var Util = {
	isEmpty: function (obj) {
		return (obj == null)
		|| ((typeof obj === 'string' || obj instanceof Array) && obj.length === 0);

	},
	isNotEmpty: function (obj) {
		return !Util.isEmpty(obj);
	},

	exception: function (message) {
		var msg = getRes("error");
		if (message) {
			msg += "\n[" + getRes(message) + "]";
		}
		showMessage(msg);
//			location.reload();
	},

	// The one accepted "typed umlaut substitution" spelling rule, shared verbatim by every place
	// that checks a typed answer against a German term: ä→ae, ö→oe, ü→ue, ß→ss (Ü→Ue, never UE).
	// Used whole-string by training_session.js (Practice) and char-by-char by learning_session.js
	// (Learn's R6 full-word typing) — same rule, one definition, so a spelling accepted in one is
	// accepted in the other.
	umlautSubst: function (str) {
		return str
			.replace(/Ä/g, "Ae").replace(/Ö/g, "Oe").replace(/Ü/g, "Ue")
			.replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/ß/g, "ss");
	},

	// The subject-pronoun label each person of a German paradigm is drilled under — the ONE JS
	// definition. A conjugated card is the label plus the bare form ("er, sie, es arbeitet ab"):
	// the dictionary panel renders it as the row header AND builds the combo from it
	// (CONJ_PERSONS / renderConjugationTable), and the drill lifts it back off as the static
	// prefix so only the verb is typed (training_session.js applyAnswerPrefix).
	//
	// ⚠️ TWINNED with VerbFormService.PERSON_LABELS (Java), which builds the very same strings
	// server-side when a verb is expanded into the Practice tray. The two must agree CHARACTER
	// FOR CHARACTER — if they drift, the panel warms and pays for a form the drill never asks
	// for, and every expansion misses the cache it just filled.
	conjPronounLabel: {
		firstSg:  "ich",
		secondSg: "du",
		thirdSg:  "er, sie, es",
		firstPl:  "wir",
		secondPl: "ihr",
		thirdPl:  "sie, Sie"
	},

	// The pronoun label `term` opens with, or "" when it opens with none. Longest label first, so
	// "er, sie, es geht" yields the whole enumeration and never just "er" — the reason this cannot
	// be a split on the first space, which would hand back "er,". "es" is included on top of the six
	// row labels because an impersonal third-person-singular cell is drilled as just "es regnet"
	// (see conjDrill / VerbFormService.labelFor); longest-first ordering still matches the full
	// "er, sie, es " before ever reaching the bare "es".
	conjPronounPrefix: function (term) {
		if (!term) {
			return "";
		}
		var labels = Object.keys(Util.conjPronounLabel)
			.map(function (k) { return Util.conjPronounLabel[k]; })
			.concat(["es"])
			.sort(function (a, b) { return b.length - a.length; });
		for (var i = 0; i < labels.length; i++) {
			if (term.indexOf(labels[i] + " ") === 0) {
				return labels[i];
			}
		}
		return "";
	},

	// The grammatical PERSON each pronoun label stands for, as a resource key. The inverse lookup of
	// conjPronounLabel above, plus the impersonal bare "es" (which is a third-person singular cell —
	// "es regnet" — drilled without the "er, sie," it has no reading for).
	//
	// Why the app needs to name a person at all, since 2026-08-27: a conjugated card used to carry a
	// per-cell translation whose pronoun said who ("я говорил"), and that translation was invented
	// per cell and is no longer shown anywhere (docs/project/conj-card-and-answer-matching.md §3).
	// The person is now named outright — and it is named in the LEARNER's language, as a grammar
	// label, on every screen where the German pronoun would give the answer away (it is the first
	// word of the string being typed or picked). The one exception is Learn's comprehension rung,
	// which shows the form with the pronoun stripped and asks WHICH pronoun it was: there the
	// pronoun itself is the honest option, and this map is not used.
	conjPersonRes: {
		"ich":         "conj_person_firstSg",
		"du":          "conj_person_secondSg",
		"er, sie, es": "conj_person_thirdSg",
		"es":          "conj_person_thirdSg",
		"wir":         "conj_person_firstPl",
		"ihr":         "conj_person_secondPl",
		"sie, Sie":    "conj_person_thirdPl"
	},

	// How a drilled form NAMES ITS PERSON — "1st pers. sg." / «1 л. ед. ч.» — read off the pronoun
	// label the form opens with. "" for a form that opens with no recognized pronoun (an imperative,
	// a malformed cell), which every caller treats as "no person chip" rather than as an error.
	// ⛔ Reads the person off the STRING, so it answers "" for a pro-drop language whose cards carry
	// no pronoun — a Spanish conjugation card gets no person chip. Recorded, not worked around
	// (register §2.7c): the person is known wherever a CELL is walked (it is the column), and lost
	// only once the cell has become a bare card face. It costs nothing until Spanish conjugation
	// cards can exist at all, which needs translated combos — 0 of them today — and is F2b's.
	conjPersonLine: function (term) {
		var key = Util.conjPersonRes[Util.conjPronounPrefix(term)];
		if (!key) {
			return "";
		}
		var text = getRes(key);
		// getRes hands back the key itself when a locale is missing it; a raw key on a card face is
		// worse than no chip at all.
		return (!text || text === key) ? "" : text;
	},

	// Each stored paradigm tense under its German name, plus the resource key holding the
	// learner-language name used as its tooltip. The ONE definition, next to the pronoun labels it
	// belongs with: the dictionary panel heads its conjugation columns with it
	// (renderConjugationTable) and Learn's meet card names a conjugated form's tense with it. Lived
	// as a private CONJ_TENSE inside main.js's closure until the meet card needed it too — a second
	// copy in learning_session.js is exactly how "Präteritum" starts reading "past" on one screen.
	// A tense with no entry here falls back to its raw key and no tooltip.
	conjTense: {
		present:      { de: "Präsens",         res: "conj_tense_present" },
		past:         { de: "Präteritum",      res: "conj_tense_past" },
		perfect:      { de: "Perfekt",         res: "conj_tense_perfect" },
		past_perfect: { de: "Plusquamperfekt", res: "conj_tense_past_perfect" },
		future:       { de: "Futur",           res: "conj_tense_future" },
		conditional:  { de: "Konjunktiv II",   res: "conj_tense_conditional" }
	},

	// How a tense NAMES ITSELF on a card: the learner-language term ALONE — «перфект», "Perfect",
	// "parfait" — because each locale's bundle now carries the name its own textbook tradition uses
	// (owner, 2026-08-28; for Russian that IS the German term, transliterated). The German original
	// and the descriptive name («Perfekt / сложное прошедшее время») live in conjTenseTip below.
	//
	// History of this line, because it has flipped twice and each flip had a reason:
	// - Until 2026-08-05 the learner-language name was a TOOLTIP on the German term — invisible on
	//   exactly the screen that needs it (in DE→RU both "ich sprach" and "ich habe gesprochen"
	//   gloss as «я говорил», so the face MUST carry the tense).
	// - Until 2026-08-28 the face carried BOTH ("Präteritum · простое прошедшее"). With the bundles
	//   moved to textbook terms the pair collapsed into near-duplication ("Perfekt · перфект"), so
	//   the face keeps only what disambiguates — which tense — and the enrichment moved to the tip.
	//   The 08-05 lesson is not violated: what the tooltip hides now is never load-bearing.
	//
	// getRes falls back to English when a locale is missing the key, so an untranslated locale
	// degrades to the English name; a tense with no conjTense entry renders under its raw key.
	// `lang` (optional) is the TERM language code; it defaults to whatever the page is learning,
	// which is what every card on screen is in. The tense KEYS are per language and disjoint
	// ("present" is German's, "pres_ind" Spanish's), so a lookup in the wrong pack yields no entry
	// and the raw key — which is why the pack, not a merged table, is what is consulted.
	conjTenseLine: function (tense, lang) {
		var pack = Util.paradigm(lang == null ? Util.termLangCode() : lang);
		var meta = pack.tenses[tense];
		if (!meta) {
			return tense || "";      // an added paradigm row still renders, under its raw key
		}
		var own = meta.res ? getRes(meta.res) : null;
		// `de` on the German pack, `name` on every other: the German entries predate the packs and
		// VerbDrillFormTest-era twins read them by that name.
		var native_ = meta.de || meta.name;
		return (!own || own === meta.res) ? native_ : own;
	},

	// The tense chip's tooltip: German textbook term + the tense described in the viewer's own
	// words — "Perfekt / сложное прошедшее время". "" (= no tip) when the locale lacks the key,
	// rather than a raw key in a tooltip bubble. Wired once, delegated on [data-tense] — the
	// conj-table headers, the Learn meet chip and Practice's cue chips all share it.
	conjTenseTip: function (tense, lang) {
		var meta = Util.paradigm(lang == null ? Util.termLangCode() : lang).tenses[tense];
		if (!meta || !meta.res) {
			return "";
		}
		var tip = getRes(meta.res + "_tip");
		return (!tip || tip === meta.res + "_tip") ? "" : tip;
	},

	// ── Principal-parts cards ("go, went, gone") ──────────────────────────────────────────────────
	//
	// The English half of the Verbs list. A whole verb's forms are ONE card, because that is how
	// they are learned and recited; the pos below is what every surface branches on, written by
	// RichTranslationService.verbFormsEntry.

	// The `sense.pos` a principal-parts card carries. ⚠️ TWINNED with the string in
	// RichTranslationService.verbFormsEntry (Java) — one place decides what these cards are called.
	VERB_FORMS_POS: "verb_forms",

	// The OTHER verb card type: one paradigm cell drilled inside a sentence ("ich brenne ab"),
	// persisted by RichTranslationService.conjugationPhrases. ⚠️ TWINNED with LearningService's
	// VERB_FORM_POS (Java). Note how close it reads to VERB_FORMS_POS above — one letter apart, and
	// they mean opposite halves of the design (one cell vs the whole set), which is exactly why both
	// belong here under a comment rather than being retyped at each site.
	VERB_FORM_POS: "phrase_verb_conj",

	// Is this card a single conjugated form? Reads the pos off whichever shape the caller has, the
	// same way isVerbFormsCard does. Callers that additionally need the head verb check `verbLemma`
	// themselves — the drill needs the head verb, the tense line does not.
	isVerbFormCard: function (card) {
		return !!card && card.pos === Util.VERB_FORM_POS;
	},

	// Is this drill card a principal-parts card? Reads the pos off whichever shape the caller has:
	// a deck card carries it directly, a TrainingDef wraps one. Everything that treats these cards
	// differently — no reverse direction, the forms label, the word-wise answer match — asks THIS,
	// so the pos string appears once. ("No sound" was on that list until 2026-08-05; these cards are
	// spoken like any other term now, so nothing about audio branches here any more.)
	isVerbFormsCard: function (card) {
		return !!card && card.pos === Util.VERB_FORMS_POS;
	},

	// The forms a card asks for, as bare words. The separators are presentation: the card face reads
	// "go, went, gone" because that is how a verb table prints, but the learner is being asked for
	// three FORMS, so anything that separates them is accepted — "go went gone", "go / went / gone",
	// a double space, a trailing comma. Splitting on "not a letter" also means the apostrophe and
	// hyphen inside a form are kept, since they are part of it.
	//
	// Order is preserved and significant: the three are a paradigm, not a set. Used by the drill's
	// answer check and by its wrong-answer diff, so what counts as a match and what gets marked as
	// the wrong form are the same reading of the string.
	verbFormsTokens: function (text) {
		if (!text) {
			return [];
		}
		return String(text).toLowerCase().split(/[^\p{L}\p{M}'’-]+/u).filter(function (t) {
			// A stray separator yields an empty token at either end; a bare "-" or "'" is not a form.
			return /[\p{L}]/u.test(t);
		});
	},

	// How many FORMS a card holds — 3 normally, 2 for a verb with no participle ("can, could"),
	// 4 for the handful whose 3rd person is irregular ("do, does, did, done"). Read off the STORED
	// card face, which always uses the comma, so it is unaffected by however the learner separates
	// what they type.
	//
	// ⚠️ Emphatically NOT verbFormsTokens().length. That counts WORDS, and 211 of the 358 English
	// irregular verbs are phrasal — "bear out, bore out, borne out" is three forms and six words, so
	// counting tokens told the majority of the list it had six forms. Splitting on the separator is
	// the only reading that survives a multi-word form.
	verbFormsCount: function (text) {
		if (!text) {
			return 0;
		}
		return String(text).split(",").filter(function (f) {
			return /[\p{L}]/u.test(f);
		}).length;
	},

	// A v4 uuid for the answer-history presentation ids (training/learning sessions group every
	// attempt + lockstep sense row of one card SHOWING under it). crypto.randomUUID needs a secure
	// context, so plain-http dev falls back to the getRandomValues recipe.
	uuid: function () {
		if (window.crypto && crypto.randomUUID) {
			return crypto.randomUUID();
		}
		var bytes = new Uint8Array(16);
		(window.crypto || window.msCrypto).getRandomValues(bytes);
		bytes[6] = (bytes[6] & 0x0f) | 0x40;
		bytes[8] = (bytes[8] & 0x3f) | 0x80;
		var hex = [];
		for (var i = 0; i < 16; i++) {
			hex.push((bytes[i] + 0x100).toString(16).substring(1));
		}
		return hex.slice(0, 4).join("") + "-" + hex[4] + hex[5] + "-" + hex[6] + hex[7] + "-"
			+ hex[8] + hex[9] + "-" + hex.slice(10).join("");
	}

};

// ── Paradigm packs — everything about a verb table that is a fact about the LANGUAGE ─────────────
//
// ⚠️ TWINNED with ParadigmPack.java / GermanParadigmPack.java / SpanishParadigmPack.java, and
// ParadigmPackTest reads THIS FILE and asserts the two agree character for character.
//
// Why it exists (plan §7 F2a part 3, docs/project/es-term-build-plan.md §4b rows 1–7). Everything
// above about conjugation — the six pronoun labels, the six German tense names, CONJ_PERSONS,
// CONJ_LEAD_RE, conjDrill — was a German literal with no dispatch anywhere, which was invisible
// while German was the only language with a paradigm tier. Spanish grew one on 2026-09-08 (64,136
// sense_conjugation rows) and the panel rendered Spanish cells under "ich · du · er, sie, es".
//
// The German pack is BUILT FROM the members above rather than restating them: one definition, and
// the twin tests that read `conjPronounLabel` / `conjTense` keep working unchanged.
Util.paradigmPack = {

	DE: {
		code: "DE",
		// German BAKES the pronoun into the drilled string — the row label and the answer prefix are
		// the same text. That is the assumption the whole file used to be built on.
		proDrop: false,
		// `pron` is the single subject pronoun the STORED cell begins with, stripped for display so
		// the label does not duplicate it. Filled from Util.conjPronounLabel below.
		persons: [
			{ key: "firstSg",  pron: "ich" },
			{ key: "secondSg", pron: "du"  },
			{ key: "thirdSg",  pron: "er"  },
			{ key: "firstPl",  pron: "wir" },
			{ key: "secondPl", pron: "ihr" },
			{ key: "thirdPl",  pron: "sie" }
		],
		tenses: Util.conjTense,
		// null = "render exactly the tenses the payload carries, in payload order". German stores
		// every tense it teaches, so a missing column means the verb genuinely has no such row and
		// there is nothing to say about it. Spanish is the opposite — see its `panelOrder`.
		panelOrder: null
	},

	ES: {
		code: "ES",
		// ⭐ The load-bearing difference. Spanish is pro-drop: f1_conjugation_projection.py stores
		// BARE cells ("hablo"), F1's term rows for those cells are bare too, and so the panel cell,
		// its data-combo, the sound key, the drilled answer and the term row are all one string.
		// The pronoun below is a ROW HEADER and nothing else; prepending it would invent a term that
		// does not exist (SpanishParadigmPack's class comment says the same thing server-side).
		proDrop: true,
		persons: [
			{ key: "firstSg",  label: "yo" },
			{ key: "secondSg", label: "tú" },
			// usted / ustedes ARE the third-person forms (register §2.5: "rendering labels on
			// 3sg/3pl, never slots"), so they are named on the row a learner would otherwise hunt for.
			{ key: "thirdSg",  label: "él, ella, usted" },
			{ key: "firstPl",  label: "nosotros" },
			// The Peninsular row. Rendered (rule F6) but not drilled — SpanishParadigmPack.CURATED
			// leaves column 7 out until the per-user Spain/Río-de-la-Plata switch of §4b row 7 exists.
			{ key: "secondPl", label: "vosotros" },
			{ key: "thirdPl",  label: "ellos, ellas, ustedes" }
		],
		// The reflexive clitic each person takes, in `persons` order. Used ONLY for a pronominal
		// headword (one ending in -rse) and only as a rendering: see esClitic below.
		clitics: ["me", "te", "se", "nos", "os", "se"],

		// The nine tenses `sense_conjugation` can carry, in rule F10's panel order. ⚠️ TWINNED with
		// PANEL_ORDER in corpus/es/term/py/f1_conjugation_projection.py, which is what
		// sense_conjugation.sort_order is computed from; f2a_aux_twin_check.py asserts the two lists
		// are the same sequence.
		storedTenses: ["pres_ind", "pret_ind", "imp_aff", "imperf_ind", "fut_ind", "cond",
		               "pres_subj", "imperf_subj_ra", "imperf_subj_se"],
		// What the panel actually shows, which is the nine plus ONE rendered column: the negative
		// imperative is "no" + the present subjunctive and is never stored (register §2.5). The
		// closed list is also how a WHOLLY MASKED tense becomes a *no existe* COLUMN — soler has no
		// future at all, so the payload simply has no fut_ind row and the renderer diffs to find it.
		panelOrder: ["pres_ind", "pret_ind", "imp_aff", "imp_neg", "imperf_ind", "fut_ind", "cond",
		             "pres_subj", "imperf_subj_ra", "imperf_subj_se"],
		// Column headers are in the TERM language, exactly as German's are ("Präsens"), with the
		// learner-language name as the hover tooltip from the bundle (conj_tense_es_*_tip).
		tenses: {
			pres_ind:       { name: "presente",              res: "conj_tense_es_pres_ind" },
			pret_ind:       { name: "pretérito indefinido",  res: "conj_tense_es_pret_ind" },
			imp_aff:        { name: "imperativo",            res: "conj_tense_es_imp_aff" },
			imp_neg:        { name: "imperativo negativo",   res: "conj_tense_es_imp_neg" },
			imperf_ind:     { name: "pretérito imperfecto",  res: "conj_tense_es_imperf_ind" },
			fut_ind:        { name: "futuro",                res: "conj_tense_es_fut_ind" },
			cond:           { name: "condicional",           res: "conj_tense_es_cond" },
			pres_subj:      { name: "presente de subjuntivo", res: "conj_tense_es_pres_subj" },
			imperf_subj_ra: { name: "imperfecto de subjuntivo (-ra)", res: "conj_tense_es_imperf_subj_ra" },
			imperf_subj_se: { name: "imperfecto de subjuntivo (-se)", res: "conj_tense_es_imperf_subj_se" }
		},
		// The two derived blocks (register rule F3: compound and progressive tenses are RENDERED,
		// never stored — ~70 rows per verb saved). Each is its own auxiliary's stored paradigm, so
		// the SET of columns is not hand-picked: haber simply has no imperative (it is one of the
		// five wholly masked (lemma, tense) pairs on the database), and the progressive drops it
		// because "está hablando" is not a command — a command uses estarse, a different verb.
		//
		// ⚠️ These two tables are the ONE place a Spanish form is written by hand rather than
		// projected, so they are twin-checked against haber's and estar's own rows in
		// work/f1/sense_conjugation_es.tsv by f2a_aux_twin_check.py. Order = persons order.
		aux: {
			haber: {
				pres_ind:       ["he", "has", "ha", "hemos", "habéis", "han"],
				pret_ind:       ["hube", "hubiste", "hubo", "hubimos", "hubisteis", "hubieron"],
				imperf_ind:     ["había", "habías", "había", "habíamos", "habíais", "habían"],
				fut_ind:        ["habré", "habrás", "habrá", "habremos", "habréis", "habrán"],
				cond:           ["habría", "habrías", "habría", "habríamos", "habríais", "habrían"],
				pres_subj:      ["haya", "hayas", "haya", "hayamos", "hayáis", "hayan"],
				imperf_subj_ra: ["hubiera", "hubieras", "hubiera", "hubiéramos", "hubierais", "hubieran"],
				imperf_subj_se: ["hubiese", "hubieses", "hubiese", "hubiésemos", "hubieseis", "hubiesen"]
			},
			estar: {
				pres_ind:       ["estoy", "estás", "está", "estamos", "estáis", "están"],
				pret_ind:       ["estuve", "estuviste", "estuvo", "estuvimos", "estuvisteis", "estuvieron"],
				imperf_ind:     ["estaba", "estabas", "estaba", "estábamos", "estabais", "estaban"],
				fut_ind:        ["estaré", "estarás", "estará", "estaremos", "estaréis", "estarán"],
				cond:           ["estaría", "estarías", "estaría", "estaríamos", "estaríais", "estarían"],
				pres_subj:      ["esté", "estés", "esté", "estemos", "estéis", "estén"],
				imperf_subj_ra: ["estuviera", "estuvieras", "estuviera", "estuviéramos", "estuvierais", "estuvieran"],
				imperf_subj_se: ["estuviese", "estuvieses", "estuviese", "estuviésemos", "estuvieseis", "estuviesen"]
			}
		},
		// The compound tenses carry their own textbook names — a learner looking for "pretérito
		// pluscuamperfecto" must find that phrase, not "pretérito imperfecto de haber". The
		// progressive block has no such separate names, so it reuses the simple ones under its
		// heading ("estar + gerundio").
		compoundNames: {
			pres_ind:       "pretérito perfecto",
			pret_ind:       "pretérito anterior",
			imperf_ind:     "pretérito pluscuamperfecto",
			fut_ind:        "futuro compuesto",
			cond:           "condicional compuesto",
			pres_subj:      "pretérito perfecto de subjuntivo",
			imperf_subj_ra: "pluscuamperfecto de subjuntivo (-ra)",
			imperf_subj_se: "pluscuamperfecto de subjuntivo (-se)"
		}
	}
};

// One definition of the German labels: the pack reads them off Util.conjPronounLabel rather than
// restating them, so VerbDrillFormTest's "main.js declares the same six labels" check still reads
// the only copy there is.
Util.paradigmPack.DE.persons.forEach(function (p) {
	p.label = Util.conjPronounLabel[p.key];
});

// The pack for a term language code ("DE", "ES", …). Everything that is not Spanish gets the German
// pack, which IS the behaviour every language had before the packs existed — a language with no
// sense_conjugation rows never reaches a paradigm renderer either way, so the default costs nothing
// and changes nothing. Mirrors ParadigmPack.of(Language) in Java.
Util.paradigm = function (langCode) {
	return Util.paradigmPack[String(langCode || "").toUpperCase()] || Util.paradigmPack.DE;
};

// The learning language the page is currently set to, read off the DOM so any caller can ask
// without threading it through. "" before a language is chosen.
Util.termLangCode = function () {
	return $("#langToValId").attr("data-lang-code") || "";
};

$(document).ready(function () {
	var windowActive = true;
	// Phase 2: the centre panel fills its pane's height purely in CSS (flex chain #centralPaneId →
	// .centralModeClass → .centralPanelClass → #centerBoxId, which scrolls internally). No JS height
	// bookkeeping and no draggable height any more — switching views just hides/shows chrome and the
	// flex box re-absorbs the difference. tabsRowHeight is vestigial: exerciseView still measures it
	// but hands it to a no-op (the flex box already reclaims the hidden tabs' row).
	var tabsRowHeight = 0;

	// Side-pane width bounds (px). The side panes carry all width geometry; the centre is the grid's
	// 1fr remainder and fills its height in CSS. Minima keep pane content legible; maxima keep the
	// sides as glanceable rails, not workspaces.
	// LEFT_MIN_WIDTH is bounded by the compact band strip: 📖 + six chips + a five-digit count on
	// ONE line, with the count whole at every width. Rigid, that needed 392px and the floor was
	// 380 — so a drag could always crush the strip by 12px. It briefly went to 470 to cover that,
	// which cost 90px of pane the user could no longer give back.
	// The chips FAN now (fitLevelStrip below), so the strip yields instead of overflowing and the
	// floor comes back down to 380 — where the fan is barely engaged (12px on the last gap alone)
	// and every label still reads. Measured floor-of-the-floor is 300px: the fan is at its 40% cap
	// on all five gaps there and the count pill is still whole, failing at 290. 380 is chosen for
	// legibility, not for the mechanism's limit — temp/ui-smoke/wl-chip-stack-probe.mjs has the
	// sweep and the frames if that trade is ever revisited.
	// The CSS floor in layout.css (#leftPaneId min-width) carries the same number; this one only
	// clamps DRAGS.
	var LEFT_MIN_WIDTH = 380, LEFT_MAX_WIDTH = 560;
	var RIGHT_MIN_WIDTH = 280, RIGHT_MAX_WIDTH = 420;
	// Layout geometry now persists as separate, named user attrs (leftPaneWidth / rightPaneWidth /
	// leftPaneCollapsed / rightPaneCollapsed / selectedTab) — see PaneLayout + the tab-restore below.
	// (The old single "panelSize" blob attr is retired; the enum value is kept only for legacy rows.)

	var doc = new Doc();

	var displayManager;
	var trainingSession;

	var startButton = $("#startId");
	var startButtonLabel = $("#startLabelId");
	var stopButton = $("#stopId");
	var clearTrayButton = $("#clearTrayId");
	var lastFinishButton = $("#lastFinishId");
	var trayControls = $("#trayControlsId");

	// ── the two heroes stay inside the band, whatever they end up saying ───────────────────────
	// views/exercise.css sizes each hero's label and sub-label from --hero-em / --hero-sub-em
	// against the room THAT hero actually has, the same length-aware idea the drill cue uses with
	// --cue-chars. It can only be stamped from here: the labels are runtime text (the JS swaps
	// Start → Pause → Practice Again, the sub-label carries a live word count) and the five UI
	// locales run from "Start Exercise!" to "Zurück zu den Wörtern".
	//
	// MEASURED, not counted. --cue-chars gets away with a character count and a 0.5 fudge because
	// its floor is generous; a CTA cannot, because the two ways a count is wrong are both visible:
	// too low a fudge CLIPS the button's own word (measured "Back to Words" at 0.53 em/char against
	// "Start Exercise!" at 0.46 — one number cannot serve both), too high a one shrinks type that
	// had room.
	//
	// So the span measures ITSELF: set it to a round size, read scrollWidth (which reports the full
	// content width regardless of the clip and the nowrap), put the size back. Nothing paints in
	// between — it is one synchronous task. A canvas measureText was tried first and dropped: at
	// this face it came out 2% short for the bold label and NINE percent short for the normal-weight
	// sub-label, which is a clipped line, not a rounding error. The element itself is the only
	// oracle that has the page's real font, weight and kerning.
	//
	// An observer rather than a call at each of the ~10 sites that write these spans: one of those
	// is always the one that gets forgotten later, and this cannot drift. It watches TEXT only
	// (childList + characterData) and writes style on nodes whose ATTRIBUTES it does not observe,
	// so neither the stamp nor the measurement can re-trigger it.
	// A string is NOT linear in its font-size: each glyph's advance is rounded as it is placed, so
	// the smaller the type the more that rounding is worth in proportion. "(Words for an exercise:
	// NN)" measures 11.56em at 100px and lays out at 12.62em at 17px — a 9% gap, which is a clipped
	// line, not a rounding error. So the probe size sits at the BOTTOM of the range the clamps can
	// reach (their floors are .8rem and 1.05rem — around 12–16px), where that overhead is at its
	// worst and is therefore already baked into what is read. Every size above the probe carries
	// LESS overhead than the estimate, so no size in the range can come out short; 1.02 covers the
	// integer rounding of scrollWidth on top. Measuring at some big round number and scaling down is
	// what does not work — it flatters every size the clamps actually use.
	var HERO_FIT_PROBE_PX = 14;
	var HERO_FIT_MARGIN = 1.02;
	function heroEmWidth(span) {
		var el = span[0];
		var was = el.style.fontSize;
		el.style.fontSize = HERO_FIT_PROBE_PX + "px";
		var em = el.scrollWidth / HERO_FIT_PROBE_PX * HERO_FIT_MARGIN;
		el.style.fontSize = was;
		// Never 0 (an empty sub-label): calc(100cqi / 0) is an invalid length, which would drop the
		// whole clamp and hand the span its inherited size instead.
		return Math.max(em, 0.5);
	}
	function stampHeroFit(button) {
		button[0].style.setProperty("--hero-em",
			heroEmWidth(button.find("#startLabelId, #stopLabelId")));
		button[0].style.setProperty("--hero-sub-em", heroEmWidth(button.find(".smallFont")));
	}
	$.each([startButton, stopButton], function (i, button) {
		if (!button.length) { return; }
		stampHeroFit(button);
		new MutationObserver(function () { stampHeroFit(button); })
			.observe(button[0], { childList: true, characterData: true, subtree: true });
	});
	// The first stamp can land on the fallback face if the webfont is still in flight, and a
	// fallback's metrics are not the real one's. Nothing rewrites these labels on a quiet page, so
	// without this the whole session would keep sizing off the wrong measurement.
	if (document.fonts && document.fonts.ready) {
		document.fonts.ready.then(function () {
			$.each([startButton, stopButton], function (i, button) {
				if (button.length) { stampHeroFit(button); }
			});
		});
	}

	// The last finished Practice screen, kept whole so the ⊙ button can reopen it (the section far
	// below owns the rest). Declared HERE, with the other state this block sets up before it starts
	// wiring, because loadLastFinish() is called a few lines down. (When the store was synchronous
	// sessionStorage this placement was load-bearing — a later `var lastFinish = null` initializer
	// quietly wiped what the boot read had just restored. The server fetch answers after the whole
	// top-to-bottom pass, so the trap can't bite anymore, but the placement stays: it is still the
	// state the wiring block touches first.)
	var lastFinish = null;

	var langToValField = $("#langToValId");
	var langFromValField = $("#langFromValId");

	var progressBox = $("#progressBoxId");
	var progressBar = $("#progressBarId");
	var counterBox = $("#counterId").assignTooltip("number_of_words_remaining");
	// (Phase 2 retired paneBox / centerBox / centralPanel — they only fed the old JS height calc.)

	// Phase 2 no-op: the centre panel fills its height via the CSS flex chain (.centralModeClass /
	// .centralPanelClass / #centerBoxId), and #centerBoxId's inner .defBoxScrollClass scrolls a tall
	// entry. Kept as an empty stub so the ~10 view-render call sites (and exerciseView's tabs-row
	// hand-off) stay valid without edits — hiding chrome now just lets the flex box re-absorb space.
	function sizeCenterBoxToPanel() {}

	var defBox = $("#defBoxId");
	var defBoxScrollBar = $("#defBoxScrollId");
	var defExerciseBox = $("#defExerciseBoxId");
	var learnBox = $("#learnBoxId");   // Learning mode's content box (learning_session.js renders inside)
	var learnControlBand = $("#learnControlBandId");   // Learn tray's top band (Start Learning! + Clear)

	var lookupBox = $("#lookupBoxId");
	var lookupField = $("#lookupFieldId");
	var searchTimeoutId = 0;   // pending as-you-type seek; cancelled when we navigate (see navigateTo)
	var answerBox = $("#answerBoxId");
	var answerField = $("#answerId");
	var tipBox = $("#tipId");

	var isExerciseView = false;

	stopButton.assignTooltip("stopButton_tooltip");
	langToValField.assignTooltip("langTo_tooltip");
	langFromValField.assignTooltip("langFrom_tooltip");
	clearTrayButton.assignTooltip("clearTray_tooltip");
	// Icon-only now: the word that used to sit next to the trash becomes the accessible name.
	clearTrayButton.attr("aria-label", getRes("clearTray_button"));
	lastFinishButton.assignTooltip("lastFinish_tooltip")
		.attr("aria-label", getRes("lastFinish_label"))
		.attr("aria-pressed", "false")
		// A toggle: pressed already showing the review closes it back to the word list, same as
		// its own "Back to Words" face (returnToRandomView) — pressed again opens it.
		.click(function () {
			if (lastFinishButton.attr("aria-pressed") === "true") {
				returnToRandomView();
			} else {
				showLastFinish();
			}
		});
	loadLastFinish();   // the pair may already have a finished session stored server-side (any tab, any day)
	// (The lookup placeholder is set by updateDictDirection below — it names the language the typed
	// word is expected to be in, which the DE⇄EN toggle changes.)

	// ── the native `title=` sites join the engine (PR 7/7, design §6) ───────────────────────
	// Every OS-drawn tooltip left in the app becomes a PL.tip site here or beside the markup
	// that builds it (the rich card, the word popup, the word lists, the garden, the account
	// menu). They gain what the OS box could never give them: the app's own chrome, HTML
	// content, placement that flips at a viewport edge, and the guided presentation.
	//
	// READOUTS OPT OUT OF GUIDED (`guided: false`). Design §6 leaves the per-site opt-outs to
	// this PR and names the sparkline and the clipped labels as candidates; the line drawn
	// here is the one those two share — a tip that merely READS OUT a value (a date, a
	// language's English name, the label's own clipped text, the detected time zone) is not an
	// explanation, and the guided face is a prominent panel that STICKS until it is dismissed.
	// Sites that explain a CONTROL (the flag slots, the gutter buttons, a tense header, the
	// growth bed) stay mode-aware, which is the uniform coverage the mode was asked for.
	var CLIP_TIP_CLASS = "plClipTipClass";   // "explain me only while I am cut off" (design §6, #11)
	// The two flag slots carry NO tooltip: "My Language" / "I'm learning" is exactly what the
	// row label beside each flag already says, and a tip that repeats a visible label is noise.
	// ONE delegate over BOTH language menus — the English name of a language whose own name is
	// written differently ("Deutsch" → German). A row whose native name IS the English name
	// ("English") would only read itself back, so it stays silent.
	PL.tip.delegate(document.getElementById("langPanelBodyId"), "li[data-english-name]", {
		guided: false,
		when: function (el) {
			var en = (el.getAttribute("data-english-name") || "").trim();
			return !!en && en.toLowerCase() !== (el.textContent || "").trim().toLowerCase();
		},
		content: function (el) { return escHtml(el.getAttribute("data-english-name")); }
	});
	// The 14-day sparkline: "3 · 8/9/2026" per bar, composed from the bar's own data (the
	// count and the day were baked into a title attribute before).
	PL.tip.delegate(document.getElementById("statsSparkId"), ".stats-spark-bar", {
		guided: false,
		content: function (el) {
			return escHtml(el.getAttribute("data-spark-count") + " · " + el.getAttribute("data-spark-date"));
		}
	});
	// Everything that names a tense and wears data-tense — the rich-card conjugation headers,
	// Learn's meet-card chip, Practice's cue chips and hint — tips the same pairing:
	// German textbook term / the tense in the viewer's own words (Util.conjTenseTip). Delegated
	// on the document, not per table or card: these render under several containers, and one
	// delegate for every instance is the whole point.
	PL.tip.delegate(document, "[data-tense]", {
		content: function (el) {
			return escHtml(Util.conjTenseTip(el.getAttribute("data-tense")));
		}
	});
	// Labels that explain themselves only while CLIPPED, by their own full text — the whole of
	// the retired addOverflowTitle, now a `when:` gate the engine already had. Any label that
	// wants it wears CLIP_TIP_CLASS; today that is three kinds of word-list row name.
	PL.tip.delegate(document, "." + CLIP_TIP_CLASS, {
		guided: false,
		when: function (el) { return el.scrollWidth > el.clientWidth; },
		content: function (el) { return escHtml(el.textContent); }
	});

	// EN's entry is the historical one and is now DEAD for flag purposes — plFlagHtml short-
	// circuits EN before it ever reaches this map, because English needs two answers (the combo
	// and the chosen dialect) where every other language needs one. Kept so the map still reads
	// as the complete language list.
	var LANG_COUNTRY = {
		EN: 'GB', FR: 'FR', ES: 'ES', ZH_CN: 'CN',
		PT: 'PT', RU: 'RU', HI: 'IN', DE: 'DE',
		JA: 'JP', AR: 'SA', KO: 'KR', IT: 'IT',
		TR: 'TR', PL: 'PL', RO: 'RO', ID: 'ID', BN: 'BD'
	};

	// Before Settings(), which paints the cluster for the first time from inside its own constructor.
	wireDirectionControls();
	// The dictionary's own DE⇄EN toggle (reverse lookup). Also owns the lookup placeholder from
	// here on, which is why the plain assignment above it is now the fallback rather than the value.
	wireDictDirection();

	var settings = new Settings();
	// Settings() is what fills the language pickers with their display names, so repaint the
	// dictionary toggle now that "English"/"Deutsch" can actually be read off them.
	updateDictDirection();

	// Self-hosted SVG flag (an <img>, not an emoji): regional-indicator flag emoji don't render on
	// Chrome/Windows (they degrade to the two "DE"/"GB" letters). The alt is the ISO code, so a
	// missing file still shows a sensible label.
	function flagImg(file, alt) {
		return "<img class='lang-flag-img' src='/image/flags/svg/" + file + ".svg' alt='" + alt + "'>";
	}

	function countryFlag(iso2) {
		return flagImg(String(iso2).toLowerCase(), iso2);
	}

	// ── THE flag resolver (docs/project/ai-features-plan.md §1 decision 6) ─────────────────────
	// Every flag the app paints comes from here, because English alone needs TWO faces and the
	// choice between them is not a property of the language — it is a property of what the flag
	// is being used to SAY:
	//
	//   context "language" — English AS SUCH: the language you can pick, browse a dictionary of,
	//                        or read a name off. Neither dialect is meant, so neither is shown:
	//                        the answer is the diagonal US/UK combo.
	//   context "learning" — YOUR English: the one you are practising, hearing and being judged
	//                        on. That is a settled question — the enDialect setting — so the
	//                        answer is that dialect's own flag, and it travels to every surface
	//                        that flags your learning.
	//
	// Omitting the context asks for the honest default: "learning" exactly when the code IS the
	// learned language, "language" otherwise. That is what the drill's sound-only prompt wants,
	// where the flagged language swaps with the practice direction.
	// Every other language ignores all of this and takes the LANG_COUNTRY hop.
	function plFlagHtml(langCode, context) {
		var code = langCode || '';
		if (!context) {
			context = code === (langToValField.attr('data-lang-code') || '') ? 'learning' : 'language';
		}
		if (code === 'EN') {
			if (context === 'learning') {
				var d = enDialect();
				return flagImg(d === 'UK' ? 'gb' : 'us', 'EN-' + d);
			}
			return flagImg('us-gb', 'EN');
		}
		var country = LANG_COUNTRY[code];
		return country ? countryFlag(country) : '';
	}

	// The chosen English, normalized. `en_dialect` is the server-inlined starting value
	// (main.html); the chooser writes it back here so a repaint mid-session sees the new choice
	// without waiting for the save to land.
	function enDialect() {
		return window.en_dialect === 'UK' ? 'UK' : 'US';
	}

	// The ONE transcription a practice screen shows: the chosen dialect's, and nothing else
	// (ai-features-plan.md §1 decision 3). The head chip may carry both US and UK side by side
	// because a dictionary entry is a reference; the popup is a rehearsal, and a second accent
	// on it would be an invitation to practice the wrong one.
	// A stored BrE-only entry answers with its BrE form for either setting — it is the only
	// transcription the corpus has, and an empty line would say less.
	function dialectIpa(entry) {
		if (!entry) { return ''; }
		var uk = entry.transcriptionUk;
		return enDialect() === 'UK' && uk ? uk : (entry.transcription || uk || '');
	}

	// A stored transcription reduced to the ONE line a practice popup shows. A multi-word head
	// keeps its whole string (it reads as one enclosing /…/, like the head and the lean row); a
	// single word with several stored VARIANTS shows the first, which is the one the row and the
	// card lead with too, minus its "xx:" register prefix.
	function popupIpa(termText, raw) {
		var s = String(raw || '').trim();
		if (!s) { return ''; }
		if (termText && termText.indexOf(' ') !== -1) { return s; }
		return s.split(' ')[0].replace(/^[a-z]{2}:/, '');
	}
	// training_session.js and learning_session.js are separate top-level closures and both plant a
	// microphone on a revealed word — this is the same reduction, shared rather than re-derived.
	window.plPopupIpa = popupIpa;

	// The language panel's own two row icons. BOTH are "language" context, including the one on
	// the "I'm learning" row: that icon names the language, and the chooser sitting directly
	// under it is what names the dialect. Showing the chosen dialect in both places would be the
	// same statement twice, and would leave nothing saying "English".
	function updateLangFlags() {
		$('#langFromFlagId').html(plFlagHtml(langFromValField.attr('data-lang-code'), 'language'));
		$('#langToFlagId').html(plFlagHtml(langToValField.attr('data-lang-code'), 'language'));
		// The dialect chooser belongs to the "I'm learning" row and appears/disappears with it, so
		// it repaints on exactly the events this does — including a langTo change to or from EN.
		paintEnDialectChooser();
	}

	// Exported for the drill (training_session.js, a separate closure), which names the answer
	// language inside the sound-only prompt. No context passed there on purpose — see the
	// resolver's default rule above.
	window.plLangFlagHtml = plFlagHtml;

	// Repaint EVERY flag on the page, plus the surfaces whose face is built from one. Called when
	// the dialect changes, so the choice lands everywhere at once with no reload. Each of these is
	// already the idempotent DOM-only repainter its own feature uses on a language change — this
	// is the same pass, triggered by a different event.
	function repaintAllFlags() {
		updateLangFlags();
		updateDictDirection();
		updateDirectionControls();
		if (window.plRepaintWordListTitle) { window.plRepaintWordListTitle(); }
	}

	// The lang + stats panels' individual collapse folds were removed — the whole right rail
	// collapses now (see PaneLayout). What remains is the stats panel's i18n label init.
	(function initStatsLabels() {
		$('#statsPanelTitleId').text(getRes('stats_panel_title') || 'My Progress');
		// What the panel counts, said once where the ambiguity actually is. Attached HERE and not
		// in refreshStats — that runs after every finished session, and re-attaching would stack a
		// tooltip per run. A content FUNCTION instead of a key so the language name resolves at
		// hover time: the label repaints on a language switch, and this has to follow it.
		$('#statsPairId').assignTooltip(function () {
			return strFormat(getRes('stats_scope_tooltip'), langName(langToValField));
		});
		$('#statsMasteredLblId').text(getRes('stats_label_mastered') || 'words mastered');
		$('#statsAccuracyLblId').text(getRes('stats_label_accuracy') || 'accuracy');
		$('#statsSessionsLblId').text(getRes('stats_label_sessions') || 'sessions');
		$('#statsTimeLblId').text(getRes('stats_label_studied') || 'studied');
	})();

	// The garden door on the My Progress header. Always visible — an empty garden opens to
	// the vista's own "nothing planted yet" invitation, which is the discovery moment.
	$('#gardenOpenLblId').text(getRes('garden_open_btn'));
	$('#gardenOpenBtnId')
		.assignTooltip('garden_open_tooltip')
		.click(function () { GARDEN_BED.openVista(); });

	// The four history doors, one per stat tile — each opens the same history card at its own
	// root. Unlike the garden they do NOT open on empty: the garden's empty state is an
	// invitation ("plant your first word"), and an empty history is just a box that wasted a
	// click. refreshStats arms each one (.statsCellLinkClass + tabindex) off its own count:
	//  - sessions  → the session list (off sessionsEnded);
	//  - mastered  → the word statistics, armed off seenWords rather than the mastered count —
	//                the table shows every PRACTICED word, so one drilled-but-unfinished word is
	//                already something to open;
	//  - accuracy  → how the percentage is built and what moves it (off attempts);
	//  - studied   → where the hours went (off sessionsEnded — it reads the same session list).
	function wireStatsDoor(cellId, tipKey, open) {
		var cell = $(cellId);
		cell.assignTooltip(tipKey)
			.attr('role', 'button')
			.on('click', function () {
				if (cell.hasClass('statsCellLinkClass')) { open(cell[0]); }
			})
			.on('keydown', function (e) {
				if ((e.which === PL.keys.ENTER || e.which === PL.keys.SPACE)
						&& cell.hasClass('statsCellLinkClass')) {
					open(cell[0]);
					// SPACE is the app's sound key: it must not also fire a pronunciation on
					// its way past, nor scroll the page under the popup it just opened.
					e.preventDefault();
					e.stopPropagation();
				}
			});
	}
	wireStatsDoor('#statsSessionsCellId', 'hist_tooltip', SESSION_HISTORY.open);
	wireStatsDoor('#statsMasteredCellId', 'hist_ws_tooltip', SESSION_HISTORY.openWords);
	wireStatsDoor('#statsAccuracyCellId', 'hist_acc_tooltip', SESSION_HISTORY.openAccuracy);
	wireStatsDoor('#statsTimeCellId', 'hist_time_tooltip', SESSION_HISTORY.openTime);

	// Compact study-time format shared by the "studied" tile and the today line.
	function fmtStudied(sec) {
		if (sec <= 0) { return '—'; }
		if (sec < 60) { return sec + 's'; }
		if (sec < 3600) { return Math.round(sec / 60) + 'm'; }
		return (sec / 3600).toFixed(1) + 'h';
	}

	// refreshStats is exposed outside $(document).ready so training_session.js can call it.
	// onData (optional) receives the raw stats response after the panel is updated — the exercise
	// finish summary uses it for its "N words mastered in total · streak" bridge line.
	window.refreshStats = function refreshStats(onData) {
		var lf = langFromValField.attr('data-lang-code');
		var lt = langToValField.attr('data-lang-code');
		if (!lf || !lt) {
			return;
		}
		// Browser IANA zone (e.g. "America/Los_Angeles") so the streak is bucketed
		// against the user's local calendar day, not the server's.
		var tz = '';
		try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { tz = ''; }
		$.ajax({
			url: 'api/exercise-stats',
			type: 'GET',
			data: { langFrom: lf, langTo: lt, tz: tz },
			dataType: 'json',
			success: function (data) {
				// The LEARNED language, not the pair. This label used to read "RU → DE" while every
				// number under it was pair-scoped; both moved together on 2026-08-25
				// (docs/project/progress-keyed-on-learned-language.md). Leaving the arrow behind a
				// term-scoped count would be the panel promising a narrower thing than it shows —
				// and the arrow is exactly what made a gloss-language switch read as amnesia.
				//
				// The NAME alone, no flag. The language panel sits directly above this one and
				// already carries the learned language's flag on its "I'm learning" row; a second
				// one a centimetre below is the same statement twice — the objection
				// updateLangFlags already makes about painting the dialect in both places. (It was
				// briefly built with a flag, and it also rendered full-panel-width: .lang-flag-img
				// carries no width of its own, the 22px lives on .lang-flag-slot. Anything that
				// paints a flag outside a slot has to bring its own size.)
				$('#statsPairId').text(langName(langToValField));

				// Words mastered — and the tile becomes the door into the word statistics once
				// anything at all was practiced (seenWords, not the mastered count: the table
				// shows every practiced word).
				$('#statsMasteredId').text(data.wordsMastered);
				$('#statsMasteredCellId')
					.toggleClass('statsCellLinkClass', data.seenWords > 0)
					.attr('tabindex', data.seenWords > 0 ? 0 : null);

				// Accuracy: correct / (correct + timeouts), or em-dash when no attempts — and
				// the tile is a door into the accuracy screen once there is an attempt to tell.
				var total = data.totalCorrect + data.totalTimeouts;
				$('#statsAccuracyId').text(
					total > 0
					? Math.round(data.totalCorrect / total * 100) + '%'
					: '—'
				);
				$('#statsAccuracyCellId')
					.toggleClass('statsCellLinkClass', total > 0)
					.attr('tabindex', total > 0 ? 0 : null);

				// Sessions — and the tile becomes the door into their history once there is one.
				// tabindex rides with the class so a keyboard never lands on a dead tile.
				$('#statsSessionsId').text(data.sessionsEnded || '—');
				$('#statsSessionsCellId')
					.toggleClass('statsCellLinkClass', data.sessionsEnded > 0)
					.attr('tabindex', data.sessionsEnded > 0 ? 0 : null);

				// Time studied: compact format — a door into the time screen alongside the
				// sessions door, off the same count (it reads the same session list).
				$('#statsTimeId').text(fmtStudied(data.studiedSeconds));
				$('#statsTimeCellId')
					.toggleClass('statsCellLinkClass', data.sessionsEnded > 0)
					.attr('tabindex', data.sessionsEnded > 0 ? 0 : null);

				// Streak, with the personal best alongside once the current run is beatable.
				var streak = data.currentStreakDays;
				if (streak > 0) {
					var tmpl = getRes('stats_streak') || '{0}-day streak';
					var streakTxt = '🔥 ' + strFormat(tmpl, streak);
					if (data.bestStreakDays > streak) {
						streakTxt += ' · ' + strFormat(getRes('stats_best_streak'), data.bestStreakDays);
					}
					$('#statsStreakId').text(streakTxt).show();
				} else {
					$('#statsStreakId').hide();
				}

				// Today line: only when there was activity today.
				if (data.todayMastered > 0 || data.todayStudiedSeconds > 0) {
					$('#statsTodayId').text(strFormat(getRes('stats_today'),
						data.todayMastered, fmtStudied(data.todayStudiedSeconds))).show();
				} else {
					$('#statsTodayId').hide();
				}

				// Corpus coverage against the learner ranking: "38 of the top 1,000 words" + mini bar.
				// fmtNum, not the raw value: the band is 1000/4000/12000/24000 and the wlLevel*
				// tooltips name the SAME numbers grouped, so an ungrouped one here disagreed with
				// them on the same screen (i18n-runtime-grammar.md §4.3).
				if (data.coverageBand > 0) {
					$('#statsCoverageLblId').text(strFormat(getRes('stats_coverage'),
						fmtNum(data.coverageMastered), fmtNum(data.coverageBand)));
					$('#statsCoverageFillId').css('width',
						Math.max(2, Math.round(data.coverageMastered / data.coverageBand * 100)) + '%');
					$('#statsCoverageId').css('display', 'flex');   // flex band — don't .show() to block
				} else {
					$('#statsCoverageId').hide();
				}

				// 14-day sparkline: words mastered per day, today rightmost.
				var days = data.dailyMastered || [];
				var maxDay = 0;
				for (var di = 0; di < days.length; di++) { maxDay = Math.max(maxDay, days[di]); }
				if (maxDay > 0) {
					var spark = $('#statsSparkId').empty();
					for (var si = 0; si < days.length; si++) {
						var v = days[si];
						var day = new Date();
						day.setDate(day.getDate() - (days.length - 1 - si));
						// count + day as data, not as a title=: the delegated PL.tip over the strip
						// composes the readout at hover time (one instance for all 14 bars).
						$('<div>').addClass('stats-spark-bar' + (v > 0 ? ' stats-spark-on' : ''))
							.css('height', (v > 0 ? Math.max(6, Math.round(v / maxDay * 24)) : 2) + 'px')
							.attr('data-spark-count', v)
							.attr('data-spark-date', day.toLocaleDateString(localeTag()))
							.appendTo(spark);
					}
					spark.css('display', 'flex');                   // flex band — don't .show() to block
				} else {
					$('#statsSparkId').hide();
				}

				// Words funnel: seen · in progress (mastered already has its own tile above).
				if (data.seenWords > 0) {
					var learning = data.seenWords - data.wordsMastered;
					$('#statsFunnelId').text(strFormat(getRes('stats_seen'), fmtNum(data.seenWords))
						+ (learning > 0 ? ' · ' + strFormat(getRes('stats_learning'), fmtNum(learning)) : '')).show();
				} else {
					$('#statsFunnelId').hide();
				}

				if (typeof onData === 'function') {
					onData(data);
				}
			},
			error: function () {
				// Silently ignore — stats are non-critical.
			}
		});
	};

	// Initial load after the lang pair is known.
	window.refreshStats();

	updateLangFlags();
	wireEnDialectChooser();

	// ── The English dialect chooser (ai-features-plan.md §1 decision 6) ──────────────────────────
	// Two flag buttons under the "I'm learning" value, alive only while EN is the learned
	// language. Applying is INSTANT and unconditional — the save goes out, but nothing on screen
	// waits for it: the value the page reads (window.en_dialect) is updated first, then every
	// surface that spells the choice out is repainted from it. A learner who clicks UK and
	// immediately presses the speaker must hear UK, not "UK once the POST lands".
	function wireEnDialectChooser() {
		// What an un-named sound request means, answered for the shared audio module. English only:
		// the question "which variant" exists exactly where the chooser does, and a German or Russian
		// word must never be asked for in a dialect. Read fresh on each call rather than captured —
		// the learned language changes without a reload.
		window.PlSound.setDialectProvider(function () {
			return (langToValField.attr("data-lang-code") || "") === "EN" ? enDialect() : null;
		});
		var row = $("#langDialectRowId");
		if (!row.length) { return; }
		$("#enDialectUsId").assignTooltip("enDialectUs_tooltip");
		$("#enDialectUkId").assignTooltip("enDialectUk_tooltip");
		row.on("click", ".lang-dialect-btn", function () {
			var pick = $(this).attr("data-dialect") === "UK" ? "UK" : "US";
			if (pick === enDialect()) { return; }
			window.en_dialect = pick;
			ajaxPostUserAttr("enDialect", pick);
			// Audio follows the setting the same instant. Nothing is discarded — the caches are
			// tagged by variant (sound.js keyOf, phraseSoundKey), so the American clips stay
			// downloaded for a reader who switches back, and only the in-flight window needs
			// closing. Then re-warm what is ON SCREEN in the new voice: the visible rows and the
			// open card's phrases, both bounded exactly as their passive passes are.
			window.PlSound.dialectChanged();
			rewarmVisibleSounds();
			rewarmPhraseSounds();
			paintEnDialectChooser();
			repaintAllFlags();
			applyEnDialectToIpa($(document));
		});
		paintEnDialectChooser();
	}

	// The chooser's own faces + pressed state, and whether it exists at all. Idempotent and
	// DOM-only, so it is safe from the wiring pass, from a dialect click and from a langTo change.
	// The two faces are painted through the resolver rather than hardcoded in the template: they
	// ARE the two answers "learning" can give, and a single source for that keeps the chooser and
	// the row icons honest with each other.
	function paintEnDialectChooser() {
		var row = $("#langDialectRowId");
		if (!row.length) { return; }
		var learnsEn = (langToValField.attr("data-lang-code") || "") === "EN";
		row.prop("hidden", !learnsEn);
		if (!learnsEn) { return; }
		var chosen = enDialect();
		$("#enDialectUsId").html(flagImg("us", "US")).attr("aria-pressed", chosen === "US" ? "true" : "false");
		$("#enDialectUkId").html(flagImg("gb", "UK")).attr("aria-pressed", chosen === "UK" ? "true" : "false");
	}

	// The rich card's dual IPA: the chosen dialect reads as the content (ordinary ink), the other
	// steps back to a muted gray. ORDER NEVER MOVES — US is always printed first, whichever one is
	// chosen, because a header whose two transcriptions swap places between users is a header you
	// have to re-read every time. Both stay click-to-play in their own dialect; only the weight
	// changes. Runs over any root, so it can restyle a card that is already on screen.
	function applyEnDialectToIpa(root) {
		var chosen = enDialect();
		// Per HEAD, not per page: a card with only one transcription has nothing to choose
		// between, and a lone /…/ greyed out would read as "this word has no pronunciation".
		// Only a genuine pair gets a lead and a follower. (Scoped to .rich-head so several
		// stacked cards — the drill's meet/head pair — are each judged on their own.)
		$(root).find(".rich-head").addBack(".rich-head").each(function () {
			var chips = $(this).find(".rich-ipa[data-dialect]");
			chips.each(function () {
				$(this).toggleClass("rich-ipa-off",
					chips.length > 1 && $(this).attr("data-dialect") !== chosen);
			});
		});
	}

	// ── Pane layout: side-pane widths + rail-collapse, persisted in the panelSize user attr ──────
	// The panes own all WIDTH geometry now (the centre is the grid's 1fr remainder); the centre
	// keeps only its draggable HEIGHT. This is the single source of truth for the two side widths
	// and their collapse flags — Step 3 layers the rail-collapse toggles on top of the same state
	// + persistence. Everything lives in the panelSize user attr, one semicolon-joined payload:
	//     l=<leftW>;r=<rightW>;h=<centreH>;lc=<0|1>;rc=<0|1>     (px; l/r are the EXPANDED widths)
	var PaneLayout = (function () {
		function clamp(v, min, max) { return Math.min(max, Math.max(min, v)); }

		var leftPaneEl  = document.getElementById("leftPaneId");
		var rightPaneEl = document.getElementById("rightPaneId");
		var frameEl     = document.getElementById("paneId");

		// Expanded widths (px) — the width a rail restores to. null = never customized → CSS default.
		var state = { leftW: null, rightW: null, leftCollapsed: false, rightCollapsed: false };

		// Per-side config so the two rails share one code path. chevIn points toward the centre (the
		// collapse direction, shown when expanded); chevOut points back out (expand, shown in the band).
		// Each side persists two user attrs — its width (px) and its rail-collapse flag — and restores
		// them from its own hidden input (populated by the controller from those attrs).
		var SIDE = {
			left:  { key: "left",  pane: leftPaneEl,  wKey: "leftW",  cKey: "leftCollapsed",  cls: "left-collapsed",
			         min: LEFT_MIN_WIDTH,  max: LEFT_MAX_WIDTH,  edge: "e", chevIn: "chevron-left",  chevOut: "chevron-right",
			         toggleId: "leftRailToggleId",  widthAttr: "leftPaneWidth",  collapsedAttr: "leftPaneCollapsed",
			         widthInputId: "leftPaneWidthId",  collapsedInputId: "leftPaneCollapsedId" },
			right: { key: "right", pane: rightPaneEl, wKey: "rightW", cKey: "rightCollapsed", cls: "right-collapsed",
			         min: RIGHT_MIN_WIDTH, max: RIGHT_MAX_WIDTH, edge: "w", chevIn: "chevron-right", chevOut: "chevron-left",
			         toggleId: "rightRailToggleId", widthAttr: "rightPaneWidth", collapsedAttr: "rightPaneCollapsed",
			         widthInputId: "rightPaneWidthId", collapsedInputId: "rightPaneCollapsedId" }
		};

		function clampWidth(side, v) { return clamp(Math.round(v), side.min, side.max); }

		// Each geometry value is its OWN server-side user attr, posted individually as it changes
		// (blank width = "use the CSS default").
		function persistWidth(side)     { ajaxPostUserAttr(side.widthAttr, state[side.wKey] != null ? Math.round(state[side.wKey]) : ""); }
		function persistCollapsed(side) { ajaxPostUserAttr(side.collapsedAttr, state[side.cKey] ? "true" : "false"); }

		// Push a side's expanded width to its inline style (or clear it → CSS default width).
		function applyExpandedWidth(side) {
			var w = state[side.wKey];
			side.pane.style.width = (w != null && !isNaN(w)) ? w + "px" : "";
		}

		// Reflect a side's collapsed flag into the DOM: the band class on the frame, the pane width
		// (band via CSS when collapsed / inline expanded width when not), and the chevron direction.
		function render(side) {
			var collapsed = state[side.cKey];
			frameEl.classList.toggle(side.cls, collapsed);
			if (collapsed) {
				side.pane.style.width = "";          // clear inline so the CSS band width (--pl-rail-w) wins
			} else {
				applyExpandedWidth(side);
			}
			var btn = document.getElementById(side.toggleId);
			if (btn) { btn.innerHTML = plIcon(collapsed ? side.chevOut : side.chevIn); }
		}

		// Seam T-8 (docs/project/tablet-support-plan.md §4): the touch layer's pane policy. null on a
		// desktop, where every line below runs exactly as it always has. js/touch/panes.js supplies it
		// through PL.panes (two panes at most, portrait drawers) — and it never persists: the user
		// attrs are shared with the user's desktop (plan §2.5).
		var policy = null;

		function setCollapsed(side, collapsed) {
			if (policy) { policy.setCollapsed(side, collapsed); return; }
			state[side.cKey] = collapsed;
			render(side);
			persistCollapsed(side);
		}

		return {
			el: { left: leftPaneEl, right: rightPaneEl, frame: frameEl },
			state: state,
			SIDE: SIDE,

			// Divider drop: just capture the new expanded width + persist it. The widget clamps at
			// side.min, so a drag NEVER auto-collapses — collapsing is chevron-only.
			onResized: function (side) {
				state[side.wKey] = clampWidth(side, side.pane.getBoundingClientRect().width);
				if (policy) { return; }   // T-8: a width dragged on glass is view-only too
				persistWidth(side);
			},

			// T-8: install the touch policy. It gets the state and render(), and re-derives the view
			// at once — here and again after every restore(), so the load order does not matter.
			usePolicy: function (p) {
				policy = p;
				p.attach({ state: state, SIDE: SIDE, render: render, frame: frameEl });
			},

			// Chevron: flip the collapse state (persists the collapse flag).
			toggle: function (side) { setCollapsed(side, !state[side.cKey]); },

			// Restore persisted side widths + collapse flags on load, each from its own hidden input.
			restore: function () {
				["left", "right"].forEach(function (key) {
					var side = SIDE[key];
					var w = parseInt($("#" + side.widthInputId).val(), 10);
					if (!isNaN(w)) { state[side.wKey] = clampWidth(side, w); }
					state[side.cKey] = $("#" + side.collapsedInputId).val() === "true";
					render(side);
				});
				if (policy) { policy.apply(); }   // T-8
			}
		};
	})();

	// Side-pane dividers: reuse PL.resize on the pane edges — the left pane grabs its RIGHT edge (e),
	// the right pane grabs its LEFT edge (w). The widget writes the pane's style.width and the grid's
	// `auto` side tracks follow, so the centre 1fr just absorbs the remainder (no overlap, no gap).
	// minWidth is the legible min: a drag just CLAMPS there — it never auto-collapses. Collapsing to
	// the rail band is chevron-only now.
	["left", "right"].forEach(function (key) {
		var side = PaneLayout.SIDE[key];
		PL.resize.attach(side.pane, {
			edges: [side.edge],
			minWidth: side.min, maxWidth: side.max,
			onStop: function () { PaneLayout.onResized(side); }
		});
	});

	// (Phase 2 removed the centre's draggable-height `s` grip — the panel fills its height in CSS
	//  now, so there is nothing left to drag. Width stays fully pane-driven via the dividers above.)

	// T-8: js/touch/panes.js may load before this block or after it. Either side finds the other:
	// it parks its policy on PL.panePolicy, or calls PL.panes.use(). Nothing on a desktop sets either.
	PL.panes = { use: PaneLayout.usePolicy };
	if (PL.panePolicy) { PaneLayout.usePolicy(PL.panePolicy); }

	PaneLayout.restore();

	// Rail-collapse chevrons: one per side pane. Icon + persisted state are owned by
	// PaneLayout.render (the per-panel lang/stats folds these once mirrored are now gone).
	["left", "right"].forEach(function (key) {
		var side = PaneLayout.SIDE[key];
		var btn = document.getElementById(side.toggleId);
		if (btn) { btn.addEventListener("click", function () { PaneLayout.toggle(side); }); }
	});

	function searchView() {
		sizeCenterBoxToPanel();

		if (!displayManager) {
			displayManager = new DisplayManager();
		}
		var displayPolicy = new DisplayPolicySearch();
		displayManager.setDisplayPolicy(displayPolicy)

		lookupField.unbind('keydown').unbind('input');
		lookupField.keydown(function (e) {
			if (e.which === PL.keys.ENTER) {
				clearTimeout(searchTimeoutId);
				var word = lookupField.val().trim();
				if (word) {
					// Decision 8 (docs/project/phrase-search-and-adoption.md): reject an over-limit
					// typed phrase before it ever reaches the gate. Forward direction only — reverse
					// lookup is index-only and never reaches the AI path, so it has no size limit.
					// Field text stays untouched and focus stays put (editing down is one step).
					if (!isReverseDict() && isOverPhraseLimit(word)) {
						showMessage(getRes("phraseTooLong_message"));
						e.preventDefault();
						return;
					}
					// Enter FOCUSES one word in both directions: forward opens its rich card, reverse
					// opens the single-key frame the tape can't carry (count header, see-also links,
					// lemma promotion, phrases band). Typing is the tape / the alphabetical seek.
					if (isReverseDict()) { runReverseLookup(word); }
					else {
						// Enter fires the band's fetch NOW rather than waiting out the seek debounce
						// that this keystroke just cancelled. The card about to open suppresses the
						// band's paint, but the answer is cached — so Esc puts the band straight
						// back under the restored lean list, with no second round trip.
						phraseBandUpdate(word, phraseBand.noMatch);
						// Enter → navigate to the typed word (gate applies); openMatch: R13 — a tape
						// prefix or a gate correction opens INSTEAD of minting, quietly labelled.
						navigateTo(word, false, true, { openMatch: true });
					}
					// Move focus out of the search box and onto the dictionary panel itself (already
					// focusable — tabindex="200" in main.html) so the input stops capturing Up/Down.
					// Without this, arrow keys just move the (invisible) text cursor inside the field
					// instead of reaching the document-level Up/Down handler below.
					$("#defId")[0].focus({ preventScroll: true });
				}
				e.preventDefault();
				return;
			}
		});
		// Re-seek only when the field's actual text changes (typing/paste/cut) — not on every
		// keydown. Navigation/modifier keys (arrows, Home/End, Shift, Ctrl...) fire keydown too
		// but leave the value untouched, so they shouldn't trigger a redundant re-search.
		lookupField.on('input', function (e) {
			clearTimeout(searchTimeoutId);
			searchTimeoutId = setTimeout(function () {
				// Both directions are as-you-type. Forward seeks the German dictionary; reverse seeks
				// the tape of English keys (§9). An emptied box drops back to reverse mode's own
				// intro rather than browsing the tape from "a" — the mode still needs explaining.
				if (!isReverseDict()) { displayManager.loadWords(); return; }
				var typed = lookupField.val().trim();
				if (typed) { runReverseSeek(typed); }
				else { reverseSeq++; disableDictScroll(); renderReverseIntro(); }
			}, 250);
		});
		// The unbind above takes EVERY 'input' handler with it, namespaced ones included — so the
		// typing mapping's stand-aside watcher is re-armed here, beside the listener it lost its
		// place to. (It is also armed by updateDictDirection, for the first paint, and arming it
		// twice is free: it removes its own binding before making a new one.)
		TypeSubst.watch(lookupField, $("#lookupBoxId"), $("#lookupSubstId"));

		isExerciseView = false;
	}

	// ── Dictionary direction: forward (term language) ⇄ reverse (the learner's own language) ─────
	// design/dictionary-reverse-lookup.md. FORWARD is everything the dictionary has always done.
	// REVERSE takes a word in the language the learner KNOWS and lists the terms that mean it, from
	// a derived in-memory index — no SQL, and never the AI path (D8), so a miss is simply a miss.
	// Session-scoped on purpose: a reload lands back on FORWARD, the dictionary everyone expects.
	var dictDirection = 'FORWARD';
	var reverseSeq = 0;          // a slow response must not paint over a newer query or a mode flip

	function isReverseDict() { return dictDirection === 'REVERSE'; }

	// The language's name AS THIS READER'S LANGUAGE WRITES IT — "German", «немецкий», "Spanisch".
	//
	// ⛔ This used to return the picker's visible text, which is the ENDONYM ("Deutsch", "Español")
	// — and every one of the eight call sites splices it into a localized sentence, so a Russian
	// reader got «наберите перевод (Deutsch)» and an English one "studied in Deutsch"
	// (docs/project/i18n-runtime-grammar.md §4.1). The picker is right to show endonyms: it is a
	// PICKER, and you find your language by its own name. A sentence is not a picker.
	//
	// Keyed off data-lang-code, so it no longer depends on Settings() having painted the pickers —
	// and no longer breaks when a browser translates the page (browser-translation-must-not-touch-
	// the-app: the rewritten pill text used to propagate into the stats label and the tooltips).
	// The old DOM read stays as the fallback for the window before lang_names is inlined.
	function langName(field) {
		var text = getFirstText(field);
		var shown = (text && text !== "[not defined]") ? text.trim() : "";
		return langDisplayName(field.attr("data-lang-code") || "", shown);
	}

	// The browser tab's title names the learned language — and the learned language changes
	// WITHOUT a reload, so the server-rendered <title> would go on naming the old one (owner
	// report 2026-09-10: picked English in the dropdowns, the tab still said «Учим немецкий»).
	//
	// Same composition as main.html's metaTitle, from the same two pieces: the bundle owns the
	// word order ("Learn {0}" / "{0} lernen" / «Учим {0}»), lang_names owns the language's name
	// as this reader's language writes it. Blank langTo — the "pick a language" state — gets the
	// bare brand, exactly as the template's empty branch does: a title that named a language
	// there would be a claim the user has not made.
	//
	// ⛔ Not on the GUEST page. /<locale>/<learn>/app is indexed, and its title is the public pair
	// landing's own (entry-flow-redesign.md §3.3) — not this one.
	function updateBrowserTitle() {
		if (window.guest_mode) { return; }
		var name = langDisplayName(langToValField.attr("data-lang-code") || "", "");
		document.title = name
			? strFormat(getRes("browserTitle_main"), name, brand_name)
			: brand_name;
	}

	// plFlagHtml directly, NOT window.plLangFlagHtml: this paints from inside the ready block's
	// wiring pass, and that export is an ASSIGNMENT further down — only declarations hoist.
	// (Same trap updateDirectionControls documents for storedAudioCue.)
	//
	// "language" context, deliberately: this toggle is a PICKER — it names the two dictionaries
	// you can look a word up in, beside the bare code text ("EN"). Which English you practise is
	// not the question it asks, so English shows as English (the combo).
	function dictDirFace(code) {
		var flag = plFlagHtml(code, "language");
		return (flag ? flag + " " : "") + escHtml(code || "");
	}

	// Repaint the toggle + placeholder from the mode in force and the current pair. DOM-only and
	// idempotent, so it is safe to call on every langTo change and from the initial wiring.
	function updateDictDirection() {
		var to = langToValField.attr("data-lang-code") || "";
		var from = langFromValField.attr("data-lang-code") || "";
		var reverse = isReverseDict();
		$("#dictDirBoxId").attr("data-mode", dictDirection);
		$("#dictDirToId").html(dictDirFace(to)).attr("aria-label", to)
			.attr("aria-pressed", reverse ? "false" : "true");
		$("#dictDirFromId").html(dictDirFace(from)).attr("aria-label", from)
			.attr("aria-pressed", reverse ? "true" : "false");
		lookupField.attr("placeholder", strFormat(
			getRes(reverse ? "lookupField_placeholder_reverse" : "lookupField_placeholder_forward"),
			langName(reverse ? langFromValField : langToValField)));
		// …and how to type that language's own letters on an English keyboard (ä→ae …), inset at
		// the field's right end. The language searched IN is the same one the placeholder just
		// named, so the mapping follows a direction flip and a pair change for free.
		TypeSubst.apply($("#lookupBoxId"), $("#lookupSubstId"), lookupField,
			reverse ? from : to, TypeSubst.LOOKUP);
		// …and it stands aside as soon as what is being typed reaches it, handing the padding back
		// to the text. Bound here rather than in the wiring pass because a mapping only ever
		// appears through this function; the binding is namespaced and replaces itself.
		TypeSubst.watch(lookupField, $("#lookupBoxId"), $("#lookupSubstId"));
	}

	// Switch mode. Flipping INTO reverse re-runs whatever is already typed (so the toggle answers
	// immediately instead of leaving the old German list on screen); flipping back restores the
	// ordinary dictionary at that same text.
	function setDictDirection(mode, opts) {
		var changed = dictDirection !== mode;
		dictDirection = mode;
		updateDictDirection();
		if (!changed || (opts && opts.silent)) { return; }
		reverseSeq++;                     // abandon any reverse response still in flight
		collapseRich();
		richOpen = false;
		currentWord = null;
		// The docked band lives OUTSIDE #defId, so no re-render of the list cleans it up — a mode
		// flip must take it down by hand (forward will refetch on the next seek response anyway).
		phraseBandForget();
		var word = lookupField.val().trim();
		if (isReverseDict()) {
			// Whatever is already typed re-runs as the tape (the as-you-type path), not the Enter-only
			// single-key lookup — flipping the toggle mid-typing should land on the same view typing
			// it fresh would.
			if (word) { runReverseSeek(word); } else { disableDictScroll(); renderReverseIntro(); }
		} else if (displayManager) {
			displayManager.loadWords();   // back to the alphabetical dictionary at the typed prefix
		}
	}

	function wireDictDirection() {
		$("#dictDirToId")
			.click(function () { setDictDirection('FORWARD'); })
			.assignTooltip(function () {
				return strFormat(getRes("dictDir_forward_tooltip"), langName(langToValField));
			});
		$("#dictDirFromId")
			.click(function () { setDictDirection('REVERSE'); })
			.assignTooltip(function () {
				return strFormat(getRes("dictDir_reverse_tooltip"),
					langName(langFromValField), langName(langToValField));
			});
		updateDictDirection();
	}

	// The empty state of reverse mode: nothing typed yet, so say what this mode does rather than
	// leaving the panel blank (a blank dictionary reads as "broken", not as "waiting").
	function renderReverseIntro() {
		$("#defId").html("<div class='_noWordsClass'>"
			+ escHtml(strFormat(getRes("reverse_intro_message"),
				langName(langFromValField), langName(langToValField))) + "</div>");
	}

	// ── The startup race: an index still building is not an empty dictionary ─────────────────────
	// A seek that arrives in the ~11-19s a pair's in-memory index takes to build got an empty page
	// and painted noWords_message — a confidently wrong "we have no words for this selection" that
	// never recovered, because that render is terminal and nothing retried it. The server now marks
	// those pages notReady (DictionaryPage.notReady / ReverseLookupPage.NOT_READY); here that turns
	// into a neutral loading state plus a short retry loop, so the panel fills itself the moment the
	// index is ready instead of waiting for the reader to reload the page.
	//
	// The loop asks fast while the usual build is running and slower after that: a warm restart is
	// ready in ~11-19s, but a cold one has been measured at 54s, and a reader who waited that long
	// should still be answered by the panel rather than by a page reload.
	var DICT_RETRY_FAST_MS = 1500;
	var DICT_RETRY_SLOW_MS = 5000;
	var DICT_RETRY_FAST_FOR_MS = 30000;
	var DICT_RETRY_BUDGET_MS = 180000;   // past three minutes, stop asking and leave the message up
	var dictRetryTimer = null;
	var dictRetryStart = 0;

	// Any answer that is NOT "still building" ends the loop, whichever surface got it.
	function clearDictRetry() {
		if (dictRetryTimer) { clearTimeout(dictRetryTimer); }
		dictRetryTimer = null;
		dictRetryStart = 0;
	}

	// Paint "still loading" over the definition panel and re-run `retry` shortly. Budgeted: a pair
	// that never becomes ready settles on the message rather than polling for the rest of the session.
	function renderDictLoading(retry) {
		collapseRich();
		richOpen = false;
		$("#defId").html("<div class='_noWordsClass'>"
			+ escHtml(getRes("dict_notReady_message")) + "</div>");
		disableDictScroll();
		if (displayManager) { displayManager.clearDefList(); }
		startButton.find("#startCountId").text("");
		startButton.prop("disabled", true);
		if (dictRetryTimer) { clearTimeout(dictRetryTimer); dictRetryTimer = null; }
		if (!dictRetryStart) { dictRetryStart = Date.now(); }
		var waited = Date.now() - dictRetryStart;
		if (waited >= DICT_RETRY_BUDGET_MS) { return; }
		dictRetryTimer = setTimeout(function () { dictRetryTimer = null; retry(); },
			waited < DICT_RETRY_FAST_FOR_MS ? DICT_RETRY_FAST_MS : DICT_RETRY_SLOW_MS);
	}

	function runReverseLookup(word) {
		var myToken = ++reverseSeq;
		collapseRich();
		richOpen = false;
		disableDictScroll();
		$.ajax({
			url: "api/dictionary/reverse",
			type: "GET",
			data: {
				word: word,
				langTo: langToValField.attr("data-lang-code"),
				langFrom: langFromValField.attr("data-lang-code")
			},
			success: function (data) {
				if (myToken !== reverseSeq) { return; }   // superseded by a newer query / a mode flip
				renderReverseResults(data, word);
			},
			error: function () {
				if (myToken !== reverseSeq) { return; }
				$("#defId").html("<div class='_noWordsClass'>" + escHtml(getRes("error")) + "</div>");
			}
		});
	}

	// ── The reverse tape (design §9): as-you-type EN ──────────────────────────────────────────────
	// Typing lists, Enter navigates — exactly the German side's split. The tape POSITIONS a window on
	// one continuous run of English keys and scrolls out of it into the rest of the alphabet; it does
	// not filter, so nothing disappears as you type. Enter (runReverseLookup) keeps its own richer
	// answer: the count header, the see-also links, the lemma promotion and the phrases band.

	function reverseParams(extra) {
		var p = {
			langTo: langToValField.attr("data-lang-code"),
			langFrom: langFromValField.attr("data-lang-code")
		};
		if (extra) { for (var k in extra) { p[k] = extra[k]; } }
		return p;
	}

	function runReverseSeek(pattern) {
		var myToken = ++reverseSeq;
		ajaxPost('api/dictionary/reverse/seek',
			reverseParams({ pattern: pattern, limit: DICT_PAGE }),
			function (data) {
				if (myToken !== reverseSeq) { return; }   // superseded by a newer keystroke / a mode flip
				renderReverseTape(data, pattern);
			},
			"Server exception");
	}

	function renderReverseTape(data, pattern) {
		if (data && data.notReady) {
			renderDictLoading(function () { runReverseSeek(pattern); });
			return;
		}
		clearDictRetry();
		var list = (data && data.definitions) || [];
		var anchor = (data && data.anchorIndex >= 0 && list[data.anchorIndex])
			? list[data.anchorIndex].matchWord : null;
		// A keystroke that does not move the anchor leaves the view EXACTLY as it is (T2) — no
		// re-render, no jump, no flicker, and no losing wherever the user has scrolled to. Typing
		// "gard", "garde", "garden" all land on `garden`, so only the first of them paints — but the
		// highlight still has to catch up to what's now typed, so repaint just the match spans.
		if (anchor && dictScroll.active && dictScroll.tapeAnchor === anchor) {
			dictScroll.pattern = pattern || '';
			reHighlightTapeRows(pattern);
			return;
		}

		var defArea = $("#defId");
		collapseRich();
		richOpen = false;
		currentWord = null;   // browsing the tape is not a navigation step, same as a forward seek
		defArea.empty();

		if (!list.length) {
			// Only reachable with no tape at all (a pair with no reverse data, or one still building).
			defArea.html("<div class='_noWordsClass'>" + getRes("noWords_message") + "</div>");
			disableDictScroll();
			if (displayManager) { displayManager.clearDefList(); }
			startButton.find("#startCountId").text("");
			startButton.prop("disabled", true);
			return;
		}

		for (var i = 0; i < list.length; i++) { defArea.append(dictRow(list[i], pattern)); }
		if (displayManager) { displayManager.setDefList(list); }
		setupDictScroll(data, pattern, {
			url: REVERSE_SCROLL_URL, params: reverseParams(), anchor: anchor
		});
		defBoxScrollBar.scrollTop(0);
		startButton.find("#startCountId").text(" (" + startCountText(list) + ")");
		startButton.prop("disabled", false);
		if (!isExerciseView) { GARDEN.decorate(defArea); }
	}

	// A keystroke that left the tape's anchor (and so the DOM) untouched still needs its highlight
	// to reflect what's now typed — re-run just that pass over the rows already on screen.
	function reHighlightTapeRows(pattern) {
		$("#defId > ._entryClass[data-match]").each(function () {
			var row = $(this);
			highlightReverseMatch(row, row.attr("data-match"), pattern);
		});
	}

	// Highlight the matched key inside the row's translation cells, mirroring lang 1's own treatment
	// (highlightMatch): the part of the key that overlaps what's currently typed goes bold-blue, the
	// rest of a partial match resets to plain weight (the translations' own subdued baseline —
	// ._senseTransClass in dictionary.css — shows through it); a full match (typed text === the whole
	// key, always true for the Enter-mode single lookup) bolds the whole occurrence, marker included.
	// Done on the BUILT row rather than in the DTO so the shared renderer keeps receiving clean data.
	// Safe to call again on a later keystroke: it always repaints from the pristine translation text
	// (cached on the cell on first pass), never re-scans markup it already injected.
	function highlightReverseMatch(row, matchWord, pattern) {
		if (!matchWord) { return; }
		// "to go" also matches inside a bare "go", and vice versa — the index folds the two together,
		// so the highlight has to as well or half the verb rows would show no reason for being there.
		var words = [matchWord];
		if (matchWord.indexOf("to ") === 0) { words.push(matchWord.slice(3)); }
		else { words.push("to " + matchWord); }
		var re = new RegExp("(^|[^\\p{L}])(" + words.map(escapeRegex).join("|") + ")(?![\\p{L}])", "giu");
		var typed = (pattern || '').trim();
		row.find("._senseTransClass").each(function () {
			var cell = $(this);
			var orig = cell.data('plOrigTransHtml');
			if (orig == null) { orig = cell.html(); cell.data('plOrigTransHtml', orig); }
			cell.html(orig.replace(re, function (full, lead, occ) {
				return lead + spanifyReverseMatch(occ, typed);
			}));
		});
	}

	// occ = the exact substring matched (e.g. "reach" or "to reach"); typed = what's currently in the
	// search box. Splits at the common prefix the same way highlightMatch does for the DE headword.
	function spanifyReverseMatch(occ, typed) {
		var marker = "";
		var core = occ;
		var m = /^(to\s+)/i.exec(occ);
		if (m) { marker = m[1]; core = occ.slice(marker.length); }
		var typedUpper = typed.toUpperCase();
		var coreUpper = core.toUpperCase();
		var inx = 0;
		while (inx < core.length && inx < typedUpper.length && coreUpper.charAt(inx) === typedUpper.charAt(inx)) { inx++; }
		if (inx === 0) {
			// No overlap with what's typed (a context row above/below the anchor) — plain, not
			// greyed, mirroring highlightMatch's own "no prefix match" fallback.
			return occ;
		}
		if (inx === core.length && typedUpper.length === core.length) {
			return "<span class='revMatchClass revMatchFullClass'>" + marker + core + "</span>";
		}
		return marker + "<span class='revMatchClass'>" + core.substring(0, inx) + "</span>"
			+ core.substring(inx);
	}

	function escapeRegex(s) {
		return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	}

	// One band of hit rows, rendered through the SHARED lean-row builder (D6) — every row behaviour
	// (click-to-open the full rich card, pronounce, IPA, add-to-list, garden plant) comes for free.
	function reverseRows(clusters, matchWord) {
		var wrap = $("<div class='revRowsClass'></div>");
		clusters.forEach(function (cluster) {
			var row = buildEntryElement(cluster, dictEntryUid++, '');
			highlightReverseMatch(row, matchWord, matchWord);   // Enter-mode: always a full match
			wrap.append(row);
		});
		return wrap;
	}

	function renderReverseResults(data, word) {
		if (data && data.status === 'NOT_READY') {
			renderDictLoading(function () { runReverseLookup(word || data.query); });
			return;
		}
		clearDictRetry();

		var defArea = $("#defId");
		defArea.empty();
		if (!data) { return; }

		var matches = data.matches || [];
		var head = $("<div class='revHeadClass'></div>");
		var line = $("<div class='revHeadLineClass'></div>");
		if (data.status === 'FALLBACK') {
			// D4: a labelled guess beats a dead end — the label carries the whole honesty.
			line.append($("<span class='revHeadTextClass'></span>")
				.text(strFormat(getRes("reverse_fallback_message"), data.query)));
			line.append(reverseLemmaLink(data.fallbackLemma));
		} else if (matches.length) {
			line.append($("<span class='revHeadTextClass'></span>").html(
				dictDirFace(langFromValField.attr("data-lang-code")) + " "
				+ escHtml(strFormat(getRes(matches.length === 1
					? "reverse_head_one" : "reverse_head_many"), matches.length))));
		} else {
			line.append($("<span class='revHeadTextClass'></span>")
				.text(strFormat(getRes("reverse_empty_message"), data.query)));
		}
		// D3: cross-links stay LINKS — never merged into the list above, because a suffix rule is a
		// guess about grammar and a wrong merge would be a wrong answer, while a wrong link is one
		// the eye simply skips.
		if ((data.seeAlso || []).length) {
			var also = $("<span class='revSeeAlsoClass'></span>")
				.append($("<span class='revSeeAlsoLblClass'></span>").text(getRes("reverse_seeAlso_label")));
			data.seeAlso.forEach(function (lemma) { also.append(reverseLemmaLink(lemma)); });
			line.append(also);
		}
		head.append(line);
		defArea.append(head);

		if (matches.length) { defArea.append(reverseRows(matches, data.matchWord)); }

		var phrases = data.phrases || { count: 0, rows: [] };
		if (phrases.count) { defArea.append(reversePhraseBand(phrases, data.query)); }

		defBoxScrollBar.scrollTop(0);
		// The hit list IS a word set: Start Exercise, the garden plants and the tray counters all
		// read displayManager's list, so reverse results behave like any other rendered set.
		if (displayManager) { displayManager.setDefList(matches); }
		startButton.find("#startCountId").text(matches.length ? " (" + startCountText(matches) + ")" : "");
		startButton.prop("disabled", !matches.length);
		if (!isExerciseView) { GARDEN.decorate(defArea); }
	}

	// A clickable lemma: fills the box with it and re-runs the lookup, so a cross-link behaves
	// exactly like typing that word — same history, same everything.
	function reverseLemmaLink(lemma) {
		return $("<button type='button' class='revLemmaClass'></button>")
			.text(lemma)
			.on("click", function () {
				lookupField.val(lemma);
				runReverseLookup(lemma);
			});
	}

	// D6: multi-word meanings that merely CONTAIN the query ("the activity of running a business").
	// Collapsed by default and never opened for us — a common word lands in hundreds of them, which
	// is exactly why they are kept out of the hit list.
	function reversePhraseBand(phrases, query) {
		var band = $("<div class='revPhraseBandClass'></div>");
		var shown = (phrases.rows || []).length;
		var toggle = $("<button type='button' class='revPhraseToggleClass' aria-expanded='false'></button>")
			.html("<span class='revPhraseCaretClass'>▸</span> "
				+ escHtml(strFormat(getRes("reverse_phrases_label"), phrases.count)));
		var body = $("<div class='revPhraseBodyClass'></div>").hide();
		toggle.on("click", function () {
			var open = toggle.attr("aria-expanded") === "true";
			toggle.attr("aria-expanded", open ? "false" : "true");
			toggle.find(".revPhraseCaretClass").text(open ? "▸" : "▾");
			if (open) { body.hide(); return; }
			if (!body.data("built")) {
				body.data("built", true);
				body.append(reverseRows(phrases.rows, query));
				if (shown < phrases.count) {
					// No silent truncation: say what is on screen out of what exists.
					body.append($("<div class='revPhraseMoreClass'></div>")
						.text(strFormat(getRes("reverse_phrases_shown"), shown, phrases.count)));
				}
			}
			body.css("display", "block");
		});
		band.append(toggle).append(body);
		return band;
	}

	// ── The dictionary band (docs/project/phrase-search-and-adoption.md decisions 2–4, redesigned
	// 2026-08-16 by docs/project/dict-band-search-redesign.md) ──
	// The A–Z tape answers "which entry is this word?". The band answers the OTHER question typed
	// input can mean: "what CONTAINS this sequence?" — and since the redesign it answers it for a
	// sequence found ANYWHERE inside a word. The tape positions by prefix, so `sprech` answered
	// richly while `prech` — inside *sprechen*, the start of nothing — returned a blank screen.
	//
	// Four sections (IN WORDS · IN COLLOCATIONS · IN EXAMPLES · FROM PHRASES I TYPED), all open by
	// default, each independently collapsible, each showing a FIXED window of rows with its own
	// pager for the rest. ONE real scroll surface — the popup itself; no section scrolls inside it,
	// which is what keeps a wheel over the band from fighting two nested scrollports.
	//
	// It answers with signposts, never with destinations: a phrase row opens its HEAD word's rich
	// card, scrolled to that phrase; a word chip navigates to that word. It rides the forward
	// dictionary only (reverse mode searches the glosses — out of v1), never paints while a rich
	// card is open (the same rule that suppresses endless scroll), and never touches the A–Z rows.
	var PHRASE_BAND_MIN = 3;         // typed chars before the band asks anything (= the index's token floor)
	var PHRASE_BAND_WINDOW = 15;     // rows one section shows at once — the pager walks the rest
	var PHRASE_BAND_CHUNK = 100;     // rows one request brings back per section (decoupled from the window)
	var PHRASE_BAND_RUNWAY = 20;     // rows of cached runway left before the next chunk is prefetched
	// IN WORDS is the exception, because a chip is a WORD and words are not rows: fifteen of them can
	// be one line of short compounds or four lines of long ones. Its window is a MEASUREMENT — however
	// many chips fit on PH_CHIP_LINES lines of the panel's width (owner call 2026-08-16). The probe is
	// how deep it renders to find that out; PH_CHIP_SLACK keeps every paint after the first one near
	// the size it already knows, so a glide does not mint ninety chips a frame.
	var PH_CHIP_LINES = 3;
	var PH_CHIP_PROBE = 96;
	var PH_CHIP_SLACK = 12;
	// The pager's hold gears, deliberately the scroll pager's own numbers (scroll_pager.js): a press
	// is one window straight away, and held past PH_HOLD_MS it becomes a continuous glide ramping to
	// PH_TOP× its opening pace. Sharing the pacing is what makes the two controls read as one app.
	var PH_HOLD_MS = 420;
	var PH_START_MS = 800;
	var PH_TOP = 3;
	var PH_RAMP_MS = 2500;

	// The four sections, in the order they paint. `rows`/`total`/`offset` name this section's fields
	// on the wire — one table instead of four near-identical code paths, which is also what lets a
	// pager click ask for exactly ONE section (`section: key`) and disturb nothing else.
	var PH_SECTIONS = [
		{ key: 'words',   label: 'phraseBand_words_label',        rows: 'words',        total: 'wordTotal',     offset: 'wordOffset' },
		{ key: 'colloc',  label: 'phraseBand_collocations_label', rows: 'collocations', total: 'total',         offset: 'collocOffset' },
		{ key: 'example', label: 'phraseBand_examples_label',     rows: 'examples',     total: 'exampleTotal',  offset: 'exampleOffset' },
		{ key: 'mine',    label: 'phraseBand_myPhrases_label',    rows: 'myPhrases',    total: 'myPhraseTotal', offset: 'myOffset' }
	];

	// Which sections the reader has folded away. Deliberately OUTSIDE phraseBand: it is a choice
	// about the band, not about one answer, so it survives every keystroke and every new query.
	var phraseBandFolded = {};

	var phraseBand = {
		seq: 0,          // generation counter — a slow response must not paint over a newer query
		pattern: '',     // the pattern the cached sections answer
		noMatch: false,  // was the A–Z empty-handed for that pattern (the rescue case)?
		sec: null,       // key → section state, so a card collapse restores the band without refetching
		open: false      // the reader pinned the docked panel open — survives repaints while typing
	};

	// One section's state. `rows` is SPARSE — index → row, filled by whichever chunks have landed —
	// so the pager's coordinate is the row's rank in the whole result, not its slot in a page. That
	// is what lets `‹ ›` step 15 rows through a 6274-row answer without a page ever being a thing.
	function phraseBandFreshSections() {
		var sec = {};
		for (var i = 0; i < PH_SECTIONS.length; i++) {
			sec[PH_SECTIONS[i].key] = {
				def: PH_SECTIONS[i],
				rows: {},       // index → row
				total: 0,
				pos: 0,         // index of the row at the top of the window
				loading: {},    // chunk offset → in flight, so a glide cannot ask twice
				height: 0,      // tallest this window has been — see phraseSectionReserve
				win: 0,         // measured window size (chips only) — 0 until it has been on screen
				winFit: false   // has that measurement actually happened yet?
			};
		}
		return sec;
	}

	// Is the band's QUESTION on the table at all? The forward dictionary tab, a language chosen,
	// not inside a drill. Deliberately says nothing about an open rich card — see phraseBandShows.
	function phraseBandEligible() {
		return activeTab === 'dict' && !isReverseDict() && !isExerciseView
			&& !!langToValField.attr("data-lang-code");
	}

	// May the band be ON SCREEN right now? Everything above, plus: not while a rich card is open —
	// the same rule that suppresses endless scroll. Fetching still happens (the answer is kept
	// warm), so collapsing the card puts the band straight back with no second round trip.
	function phraseBandShows() { return phraseBandEligible() && !richOpen; }

	function phraseBandRemove() {
		$("#phraseBandId").remove();
		$("#phraseDockId").remove();
		$("#defBoxId").removeClass("phDockOnClass");
	}

	function phraseBandForget() {
		phraseBand.seq++;
		phraseBand.sec = null;
		phraseBand.pattern = '';
		phraseBand.noMatch = false;
		phraseBand.open = false;
		phrasePagerRelease();
		phraseBandRemove();
	}

	// Ask for (and then paint) the band for `pattern`. Called from the seek response — so it rides
	// the search box's existing 250ms debounce rather than adding a second timer — and immediately
	// on Enter. `noMatch` says the A–Z found nothing that starts with what was typed: the rescue
	// case, where the band is the answer and gets a plain fact line above it.
	function phraseBandUpdate(pattern, noMatch) {
		var typed = (pattern || '').trim();
		if (!phraseBandEligible() || typed.length < PHRASE_BAND_MIN) { phraseBandForget(); return; }
		phraseBand.noMatch = !!noMatch;
		if (typed === phraseBand.pattern && phraseBand.sec) {
			// Same query, already answered (a re-render emptied #defId) — repaint from cache.
			phraseBandRender();
			return;
		}
		phraseBandFetchAll(typed);
	}

	// The fetch a settled keystroke makes: every section, first chunk each, ONE request. Together
	// with the seek it rides, that is the two-requests-per-keystroke budget the redesign kept.
	function phraseBandFetchAll(typed) {
		var gen = ++phraseBand.seq;
		phrasePagerRelease();
		ajaxPost('dictionary/phrase-search',
			dictRequestParams({ pattern: typed, limit: PHRASE_BAND_CHUNK, section: 'all' }),
			function (data) {
				if (gen !== phraseBand.seq) { return; }        // superseded by a newer keystroke
				if (!phraseBandEligible()) { return; }         // the mode flipped / we left the tab
				phraseBand.pattern = typed;
				phraseBand.sec = phraseBandFreshSections();
				phraseBandAbsorb(data, 0, null);
				phraseBandRender();
			},
			null,
			function () { /* the band is an extra answer: a failed fetch simply shows no band */ });
	}

	// File a response's rows into the sparse caches at the offset they were asked for. `only` scopes
	// it to one section, because a pager's single-section request carries zeroed totals for the
	// other three and must not overwrite what they already know.
	function phraseBandAbsorb(data, offset, only) {
		for (var i = 0; i < PH_SECTIONS.length; i++) {
			var def = PH_SECTIONS[i];
			if (only && only !== def.key) { continue; }
			var s = phraseBand.sec[def.key];
			var rows = (data && data[def.rows]) || [];
			for (var r = 0; r < rows.length; r++) { s.rows[offset + r] = rows[r]; }
			var total = data ? data[def.total] : 0;
			if (typeof total === 'number') { s.total = total; }
		}
	}

	// Chunks are aligned to PHRASE_BAND_CHUNK so any row belongs to exactly one request — a glide
	// that walks past row 100 asks for [100,200) once, whatever pace it is travelling at.
	function phraseChunkStart(index) {
		return Math.floor(index / PHRASE_BAND_CHUNK) * PHRASE_BAND_CHUNK;
	}

	// Fetch one section's chunk. Cheap by construction: one section, one offset, and the answer is
	// merged into the cache rather than replacing it, so nothing already on screen moves.
	function phraseSectionChunk(s, offset) {
		if (offset < 0 || offset >= s.total || s.loading[offset]) { return; }
		s.loading[offset] = true;
		var gen = phraseBand.seq;
		var params = { pattern: phraseBand.pattern, limit: PHRASE_BAND_CHUNK, section: s.def.key };
		params[s.def.offset] = offset;
		ajaxPost('dictionary/phrase-search', dictRequestParams(params),
			function (data) {
				delete s.loading[offset];
				if (gen !== phraseBand.seq) { return; }   // the query moved on under it
				phraseBandAbsorb(data, offset, s.def.key);
				phraseSectionPaint(s);
			},
			null,
			function () { delete s.loading[offset]; });
	}

	// How many rows this section shows at once. A fixed 15 everywhere except IN WORDS, whose window
	// is whatever its last measurement said (phraseSectionPaintChips) — 15 is only its stand-in for
	// the paint that happens before the panel is on screen and can be measured at all.
	function phraseSectionWindow(s) { return s.win || PHRASE_BAND_WINDOW; }

	// How many rows the section needs IN HAND: the chip section renders past its window to find out
	// where the third line ends, so it must have the probe's worth cached, not the window's.
	function phraseSectionNeed(s) {
		return s.def.key === 'words' ? phraseChipProbe(s) : phraseSectionWindow(s);
	}

	function phraseChipProbe(s) {
		return s.winFit ? Math.min(PH_CHIP_PROBE, s.win + PH_CHIP_SLACK) : PH_CHIP_PROBE;
	}

	// Everything the visible window needs, plus a chunk's worth of runway ahead of it — so a glide
	// meets rows that are already there instead of stopping at the chunk edge to wait for them.
	function phraseSectionEnsure(s) {
		var need = phraseSectionNeed(s);
		var last = Math.min(s.total, s.pos + need);
		for (var i = s.pos; i < last; i++) {
			if (!s.rows[i]) { phraseSectionChunk(s, phraseChunkStart(i)); }
		}
		var ahead = s.pos + need + PHRASE_BAND_RUNWAY;
		if (ahead < s.total && !s.rows[ahead]) { phraseSectionChunk(s, phraseChunkStart(ahead)); }
	}

	// Paint the cached response. Two shapes since the 2026-08-10 placement redesign: in the rescue
	// case the band IS the answer, so it stays in-flow and LEADS the neighbourhood, exactly as
	// before. In the normal case it used to be APPENDED after the A–Z rows — below an endless-scroll
	// surface that inserts rows on every scroll, i.e. unreachable by construction. Now it docks as a
	// one-line strip pinned to the panel's bottom edge, and its rows expand OVER the list.
	// Idempotent — it removes any band already there, so a second response never stacks two.
	function phraseBandRender() {
		phraseBandRemove();
		if (!phraseBand.sec || !phraseBandShows()) { return; }
		if (!phraseBandAnswerCount()) { return; }
		if (phraseBand.noMatch) { phraseBandRenderRescue(); }
		else { phraseBandRenderDock(); }
	}

	// How many sections found anything — 0 means there is no band to paint at all.
	function phraseBandAnswerCount() {
		var n = 0;
		for (var i = 0; i < PH_SECTIONS.length; i++) {
			if (phraseBand.sec[PH_SECTIONS[i].key].total) { n++; }
		}
		return n;
	}

	// The band's actual content — the four sections, each with its header, its window and its pager.
	// Identical in both shapes; only WHERE it paints differs.
	//
	// The order is the reading order of the answer: the WORDS the sequence lives in first (the
	// section the tape structurally cannot give you), then collocations before example sentences (a
	// collocation is a short curated unit and reads at a glance, a sentence takes a line), then the
	// reader's own captured phrases. Owner-only by construction (decision 4): the server scopes that
	// last section to the caller's own term_capture rows, and no attribution is ever shown.
	function phraseBandContent(container) {
		for (var i = 0; i < PH_SECTIONS.length; i++) {
			var s = phraseBand.sec[PH_SECTIONS[i].key];
			if (s.total) { container.append(phraseBandSection(s)); }
		}
		wirePhraseBandRows(container);
	}

	// One section: a header that names and counts it and folds it on click, a fixed-height window of
	// rows, and — only when there is more than one window's worth — a pager under it.
	function phraseBandSection(s) {
		var el = $("<div class='phSectionClass'></div>").attr("data-section", s.def.key);
		var folded = !!phraseBandFolded[s.def.key];
		s.$pager = s.$pos = s.$input = null;   // last render's controls are detached — forget them
		var head = $("<button type='button' class='phSectionHeadClass'></button>")
			.attr("aria-expanded", folded ? "false" : "true")
			.append($("<span class='phSectionCaretClass' aria-hidden='true'></span>").text(folded ? "▸" : "▾"))
			.append($("<span class='phSectionLabelClass'></span>")
				.text(getRes(s.def.label) + " · " + s.total));
		head.on("click", function () { phraseSectionFold(s, !phraseBandFolded[s.def.key]); });

		var body = $("<div class='phSectionBodyClass'></div>");
		s.$win = $("<div class='phSectionWinClass'></div>");
		body.append(s.$win);
		if (phraseSectionPagerWanted(s)) { body.append(phraseSectionPager(s)); }
		if (folded) { body.hide(); }

		s.$body = body;
		s.$head = head;
		el.append(head).append(body);
		phraseSectionPaint(s);
		return el;
	}

	// Folding is per section and NON-exclusive — several open at once is the normal state and the
	// default, so this only ever touches the one section that was clicked.
	function phraseSectionFold(s, fold) {
		phraseBandFolded[s.def.key] = !!fold;
		if (!s.$body) { return; }
		s.$body.toggle(!fold);
		s.$head.attr("aria-expanded", fold ? "false" : "true")
			.find(".phSectionCaretClass").text(fold ? "▸" : "▾");
		if (!fold) { phraseSectionPaint(s); }   // it may have been folded when its chunk landed
		phraseStripSync();                      // folding moves every section under it
	}

	// Is there anything for a pager to do? The chip section cannot know before it has measured
	// itself, so it builds one whenever it holds more than a single chip and hides it again if they
	// all fit (phraseSectionPagerSync).
	function phraseSectionPagerWanted(s) {
		return s.def.key === 'words' ? s.total > 1 : s.total > phraseSectionWindow(s);
	}

	// Paint the window: rows [pos, pos+window) out of the sparse cache, missing ones as placeholders
	// while their chunk is in flight. Rows swap IN PLACE — the window is re-filled, never re-built
	// around, so a glide reads as the list moving rather than as the panel rebuilding itself.
	function phraseSectionPaint(s) {
		if (!s.$win || !s.$win.length) { return; }
		phraseSectionEnsure(s);
		var win = s.$win.empty();
		if (s.def.key === 'words') { phraseSectionPaintChips(s, win); }
		else { phraseSectionPaintRows(s, win); }
		// Tooltips are per element, so freshly minted gutter buttons need their own — unlike the
		// sound click handler, which is delegated once on the whole container (wirePhraseBandRows).
		win.find(".phrase-sound-btn").assignTooltip("sound_tooltip");
		win.find(".phrase-mic-btn").assignTooltip("pronMic_tooltip");
		// The add button has no tooltip and no delegated click: it raises its own list picker, and
		// that machine is per element like every other non-delegated behaviour on these buttons.
		win.find(".phrase-add-btn").each(function () { wlAddWirePhraseBtn($(this)); });
		phraseSectionReserve(s);
		phraseSectionPagerSync(s);
	}

	function phraseSectionPaintRows(s, win) {
		var last = Math.min(s.total, s.pos + phraseSectionWindow(s));
		for (var i = s.pos; i < last; i++) {
			win.append(s.rows[i] ? phraseBandRowFor(s.def.key, s.rows[i]) : phraseBandWaitRow());
		}
	}

	// IN WORDS: three lines of chips, and however many words fit on them (owner call 2026-08-16). A
	// count cannot express that — the same fifteen chips are one line of `Aura`s or four of
	// `Restaurantbesitzer`s — so the window is MEASURED: render a probe's worth, ask each chip which
	// line it landed on, and drop everything past the third. What survives IS the window, and every
	// pager coordinate under it counts in those chips.
	//
	// Removing the overflow cannot re-wrap what is left: the line breaks are decided from the chips'
	// content widths, and `flex: 1 1 auto` only shares out what is left over on a line AFTER that.
	//
	// A window that is not on screen yet (the dock shut, the section still detached) measures
	// nothing, so it paints its stand-in window — phraseBandRemeasure comes back for it the moment
	// the panel is visible. A window under a running glide is not re-measured either: its size is
	// already known, and probing (with the forced layout each probe costs) on every frame is the one
	// place this could get expensive.
	function phraseSectionPaintChips(s, win) {
		var holder = $("<div class='phChipsClass'></div>").appendTo(win);
		var measure = win[0].offsetWidth > 0 && !(phGlide && s.winFit);
		var last = Math.min(s.total, s.pos + (measure ? phraseChipProbe(s) : phraseSectionWindow(s)));
		var made = [];
		for (var i = s.pos; i < last; i++) {
			if (!s.rows[i]) { break; }   // its chunk is in flight — measure what IS here
			made.push(phraseBandWordChip(s.rows[i]).appendTo(holder));
		}
		if (!made.length) { holder.append(phraseBandWaitRow()); return; }
		if (!measure) { return; }
		var keep = phraseChipsOnLines(made, PH_CHIP_LINES);
		for (var d = made.length - 1; d >= keep; d--) { made[d].remove(); }
		s.win = keep;
		// Trustworthy only if a chip actually FELL OFF the third line. If the probe simply ran out —
		// the cache short of rows, or this being the last page — the number says where the rows ended,
		// not where the window does, and the next paint probes deep again rather than shrinking to it.
		s.winFit = keep < made.length;
	}

	// How many of these chips sit on the first `lines` lines. A chip's offsetTop IS its line: they
	// are flex items of one height, so a new top means the line above it ended.
	function phraseChipsOnLines(made, lines) {
		var seen = 0, top = null;
		for (var k = 0; k < made.length; k++) {
			var t = made[k][0].offsetTop;
			if (top === null || t > top + 1) { seen++; top = t; }
			if (seen > lines) { return Math.max(1, k); }
		}
		return made.length;
	}

	// A row whose chunk is still in flight: it holds the window's shape for the fraction of a second
	// the request takes, so a glide never collapses the box it is moving inside.
	function phraseBandWaitRow() {
		return $("<div class='phBandRowClass phBandWaitClass'></div>").html("&nbsp;");
	}

	function phraseBandRowFor(key, row) {
		if (key === 'words') { return phraseBandWordChip(row); }
		if (key === 'mine')  { return phraseBandMyRow(row); }
		return phraseBandPhraseRow(row);
	}

	// Hold the window at the tallest it has been for this query. Phrase rows wrap, so fifteen short
	// collocations and fifteen long sentences are not the same height, and a window that resized
	// under a running glide would walk the pager out from under the pointer. It only ever grows —
	// a shorter batch leaves a little air at the bottom, which is the harmless direction.
	function phraseSectionReserve(s) {
		s.$win.css("min-height", "");
		var h = s.$win[0].offsetHeight;
		if (h > s.height) { s.height = h; }
		if (s.height) { s.$win.css("min-height", s.height + "px"); }
	}

	// ── the row pager: a scrollbar with numbers on it ────────────────────────────────────────────
	//   ‹‹   ‹   [ 166 ] / 6274   ›   ››
	// ROW-based, not page-based: with a glide there are no page boundaries, so the coordinate that
	// means anything is the rank of the row at the top of the window. `/6274` is a fact, not a
	// control; `166` is an input you can type into. Both arrow pairs stay: results are ranked
	// best-first, so "back to the top" after wandering has to be one click.
	function phraseSectionPager(s) {
		var pager = $("<div class='phPagerClass'></div>");
		s.$pager = pager;
		pager.append(phrasePagerJump(s, "first", "‹‹", 0, "phraseBand_pagerFirst_tooltip"));
		pager.append(phrasePagerStep(s, "prev", "‹", -1, "phraseBand_pagerPrev_tooltip"));

		s.$pos = $("<button type='button' class='phPagerPosClass'></button>")
			.on("click", function () { phrasePagerEdit(s); });
		s.$pos.assignTooltip(function () { return phrasePagerRangeText(s); });
		s.$input = phrasePagerInput(s);
		pager.append(s.$pos).append(s.$input);
		pager.append($("<span class='phPagerTotalClass'></span>").text("/ " + s.total));

		pager.append(phrasePagerStep(s, "next", "›", 1, "phraseBand_pagerNext_tooltip"));
		pager.append(phrasePagerJump(s, "last", "››", -1, "phraseBand_pagerLast_tooltip"));
		return pager;
	}

	/** The last position that still fills the window — where `››` lands. */
	function phrasePagerMax(s) { return Math.max(0, s.total - phraseSectionWindow(s)); }

	function phrasePagerRangeText(s) {
		var last = Math.min(s.total, s.pos + phraseSectionWindow(s));
		return strFormat(getRes("phraseBand_pagerRow_tooltip"), s.pos + 1, last, s.total);
	}

	// `‹‹` / `››`. `to` is the absolute position, or -1 for "the end" (which the total decides).
	function phrasePagerJump(s, tag, glyph, to, tipKey) {
		var b = $("<button type='button' class='phPagerBtnClass'></button>")
			.attr("data-pg", tag).text(glyph);
		b.assignTooltip(tipKey);
		b.on("click", function () { phraseSectionGo(s, to < 0 ? phrasePagerMax(s) : to); });
		return b;
	}

	// `‹` / `›`. A PRESS moves one window straight away — that is what a click is, and it must land
	// as a definite move, not as the first 200ms of a glide. Held past PH_HOLD_MS it becomes the
	// continuous glide (phraseGlideRun), exactly as the scroll pager's bars do.
	function phrasePagerStep(s, tag, glyph, dir, tipKey) {
		var b = $("<button type='button' class='phPagerBtnClass'></button>")
			.attr("data-pg", tag).text(glyph);
		// The step size is IN the sentence, so the sentence reads it from the window itself rather
		// than repeating it — and the chip window's size is only known once it has been measured, so
		// this has to be asked at hover time, not at build time.
		b.assignTooltip(function () { return strFormat(getRes(tipKey), phraseSectionWindow(s)); });
		b.on("mousedown", function (e) {
			if (e.which !== 1) { return; }
			e.preventDefault();               // no text selection while the pointer is held down
			phrasePagerPress(s, dir);
		});
		// A click the POINTER did not make — the keyboard's Enter/Space on a focused button, an
		// assistive tool activating it — steps here instead. `detail` is the standard way to tell
		// them apart: a pointer click counts the clicks it is part of, a synthesized one reports 0.
		// Doing it this way rather than with a key handler avoids double-stepping, since the browser
		// raises this very click for Enter and Space anyway.
		b.on("click", function (e) {
			if (e.detail) { return; }   // the mousedown behind it has already stepped
			phraseSectionGo(s, s.pos + dir * phraseSectionWindow(s));
		});
		return b;
	}

	// The one live hold. A pointer can only hold one arrow, so this is a singleton rather than a
	// per-button field — and a new press, a new query or an unmount all release it through one door.
	var phGlide = null;

	function phrasePagerPress(s, dir) {
		phrasePagerRelease();
		phraseSectionGo(s, s.pos + dir * phraseSectionWindow(s));
		phGlide = { s: s, dir: dir, pos: s.pos, from: 0, last: 0, raf: 0, timer: 0 };
		phGlide.timer = setTimeout(function () {
			if (!phGlide) { return; }
			phGlide.pos = s.pos;
			phGlide.raf = requestAnimationFrame(phraseGlideRun);
		}, PH_HOLD_MS);
		$(document).on("mouseup.phGlide", phrasePagerRelease);
		$(window).on("blur.phGlide", phrasePagerRelease);
	}

	// The position is carried as a FLOAT and rounded to a row each frame: at the opening pace a
	// frame is a fraction of a row, so accumulating in the integer position would round most of the
	// motion away. Sub-window steps are the point — it has to read as scrolling, not card-flipping.
	function phraseGlideRun(t) {
		var g = phGlide;
		if (!g) { return; }
		if (!g.from) { g.from = g.last = t; }
		var dt = Math.min(50, t - g.last);   // a backgrounded tab must not lurch
		g.last = t;
		var ramp = Math.min(1, (t - g.from) / PH_RAMP_MS);
		var rowsPerMs = (phraseSectionWindow(g.s) / PH_START_MS) * (1 + (PH_TOP - 1) * ramp);
		var max = phrasePagerMax(g.s);
		g.pos = Math.max(0, Math.min(max, g.pos + g.dir * rowsPerMs * dt));
		phraseSectionGo(g.s, Math.round(g.pos));
		if ((g.dir < 0 && g.s.pos <= 0) || (g.dir > 0 && g.s.pos >= max)) {
			phrasePagerRelease();   // ran into the end — stop rather than spin against the clamp
			return;
		}
		g.raf = requestAnimationFrame(phraseGlideRun);
	}

	function phrasePagerRelease() {
		if (!phGlide) { return; }
		clearTimeout(phGlide.timer);
		if (phGlide.raf) { cancelAnimationFrame(phGlide.raf); }
		phGlide = null;
		$(document).off(".phGlide");
		$(window).off(".phGlide");
	}

	// Move a section's window. Clamped, and a no-op when nothing actually changes — a glide calls
	// this every frame and most frames land on the row it is already showing.
	function phraseSectionGo(s, pos) {
		var want = Math.max(0, Math.min(phrasePagerMax(s), pos));
		if (want === s.pos) { return; }
		s.pos = want;
		phraseSectionPaint(s);
	}

	function phraseSectionPagerSync(s) {
		if (s.$pos) { s.$pos.text(s.pos + 1); }
		if (s.$pager) {
			var max = phrasePagerMax(s);
			// A chip section builds its pager before it knows whether it needs one: three lines may
			// well hold every word it found. Hidden rather than removed — the next query answers with
			// more, and the pager is the same one.
			s.$pager.toggle(s.total > phraseSectionWindow(s));
			s.$pager.find("[data-pg='first'], [data-pg='prev']").prop("disabled", s.pos <= 0);
			s.$pager.find("[data-pg='next'], [data-pg='last']").prop("disabled", s.pos >= max);
		}
	}

	// The row number as an input: click it, the current value arrives selected, Enter jumps that row
	// to the top of the window and Esc backs out. Every key is stopped from bubbling — the app reads
	// bare Space as "pronounce" and Escape as "close the panel", and neither may fire while somebody
	// is typing a row number into this box.
	function phrasePagerInput(s) {
		var input = $("<input type='text' class='phPagerInputClass' inputmode='numeric'>").hide();
		input.on("keydown", function (e) {
			e.stopPropagation();
			if (e.which === PL.keys.ENTER) {
				e.preventDefault();
				var row = parseInt(input.val(), 10);
				phrasePagerEditEnd(s);
				if (!isNaN(row)) { phraseSectionGo(s, row - 1); }
			} else if (e.which === PL.keys.ESCAPE) {
				e.preventDefault();
				phrasePagerEditEnd(s);
			}
		});
		input.on("keypress keyup", function (e) { e.stopPropagation(); });
		input.on("blur", function () { phrasePagerEditEnd(s); });
		return input;
	}

	function phrasePagerEdit(s) {
		s.$pos.hide();
		s.$input.val(s.pos + 1).show().trigger("focus").trigger("select");
	}

	function phrasePagerEditEnd(s) {
		s.$input.hide();
		s.$pos.show();
	}

	// The band's rows carry the rich card's OWN gutter pair (pronounce + add-to-list), wired to the
	// very same endpoints — a band row is a signpost, but the phrase on it is a real row a reader can
	// act on without opening the card first.
	//
	// Deliberately NOT calling preloadPhraseSounds: the rich card warms its phrases because a card is
	// one word the reader chose, while the band repaints on every keystroke. Warming here would fire
	// a PAID ElevenLabs generation per row per keystroke. Band sound resolves on CLICK only.
	//
	// The handlers are DELEGATED on the container and bound once, because the rows underneath them
	// are replaced on every window step — a handler bound per row would die with the row it was
	// bound to. Their tooltips cannot be delegated and are assigned per paint (phraseSectionPaint).
	function wirePhraseBandRows($root) {
		$root.on("click", ".phrase-sound-btn", function (e) {
			e.stopPropagation();   // the row itself opens the head card — the button must not
			var row = $(this).closest("[data-phrase-id]");
			playPhraseSound(row.attr("data-phrase-kind"), row.attr("data-phrase-id"), this);
		});
		// The band's rows carry the same gutter as a card's, so they get the same microphone —
		// a phrase found by searching is as practicable as one read inside an entry.
		$root.on("click", ".phrase-mic-btn", function (e) {
			e.stopPropagation();
			var row = $(this).closest("[data-phrase-id]");
			var kind = phraseKindOf(row.attr("data-phrase-kind"));
			var id = +row.attr("data-phrase-id");
			if (!kind || !id) { return; }
			PRONOUNCE.open(this, {
				phraseKind: kind, phraseRefId: id,
				text: row.find(".phBandTextClass, .rich-colloc-term, .rich-example-term")
					.first().text().trim()
			});
		});
		// No click-to-add handler here: the button's press opens its list picker (wlAddWirePhraseBtn),
		// and the add is the picker row's, which knows the destination.
	}

	// Rescue shape: nothing in the A–Z starts with what was typed, so say that plainly before
	// showing what the band DID find — a fact and the constraint, no advice, no apology. The band
	// goes on top, where the reader is already looking, and the neighbours keep their place below.
	// This is where the redesign earns its keep: `prech` matches no headword prefix, so the tape has
	// nothing — and the band now leads with the WORDS it is inside (sprechen, versprechen…) followed
	// by those words' phrases, instead of the blank screen that used to be the whole answer.
	function phraseBandRenderRescue() {
		var band = $("<div id='phraseBandId' class='phBandClass'></div>");
		band.append($("<div class='phBandFactClass'></div>")
			.text(strFormat(getRes("phraseBand_noEntry_message"), phraseBand.pattern)));
		phraseBandContent(band);
		$("#defId").prepend(band);
		phraseBandRemeasure();   // in the document at last — the chip window can size itself now
		defBoxScrollBar.scrollTop(0);
	}

	// Docked shape: #phraseDockId hangs on #defBoxId, NOT #defId — endless scroll writes straight
	// into #defId and would push anything there out of reach (the original placement bug). The strip
	// is the always-visible one-line summary; hovering peeks at the rows, a click pins them open.
	// #defId gets bottom padding while the dock is up (phDockOnClass) so the Z-end of the dictionary
	// can still scroll clear of the strip.
	function phraseBandRenderDock() {
		// plDockedFootClass: tells the scroll pager this strip owns the surface's bottom edge, so
		// the page-down chevrons pin above it instead of on it (scroll_pager.js dockedFootInset).
		var dock = $("<div id='phraseDockId' class='phDockClass plDockedFootClass'></div>");
		var panel = $("<div id='phrasePanelId' class='phPanelClass'></div>");
		phraseBandContent(panel);
		// The strip is a position indicator as well as a row of doors: whichever section the panel is
		// looking at is the one lit on it (phraseStripSync).
		panel.on("scroll", phraseStripSync);

		// The strip is a ROW OF CONTROLS now, not one button: each section's count opens the panel
		// AT that section, so "3554 collocations" is a place you can go rather than a number you can
		// only read. That is also why the strip no longer toggles the pin — a click anywhere on it
		// used to mean "close", which is now the chevron's job and only the chevron's.
		var strip = $("<div id='phraseStripId' class='phStripClass'></div>");
		for (var i = 0; i < PH_SECTIONS.length; i++) {
			var def = PH_SECTIONS[i], s = phraseBand.sec[def.key];
			if (!s.total) { continue; }
			strip.append(phraseStripTitle(dock, def, s));
		}

		var chev = $("<button type='button' class='phStripChevClass'></button>");
		chev.assignTooltip(function () {
			return getRes(phraseBand.open ? "phraseBand_stripClose_tooltip" : "phraseBand_stripOpen_tooltip");
		});
		chev.on("click", function (e) {
			e.stopPropagation();
			phraseDockOpen(dock, !phraseBand.open, true);
		});
		strip.append(chev);

		dock.on("mouseenter", function () { phraseDockOpen(dock, true, false); });
		dock.on("mouseleave", function () {
			phrasePagerRelease();   // the pointer left mid-hold; the glide must not outlive it
			if (!phraseBand.open) { phraseDockOpen(dock, false, false); }
		});

		dock.append(panel).append(strip);
		$("#defBoxId").addClass("phDockOnClass").append(dock);
		phraseDockPublishGutter();
		phraseDockOpen(dock, phraseBand.open, false);
	}

	// One strip title: the section's name and count, and a click that pins the panel open and puts
	// THAT section at the top of it. Other sections keep whatever fold state the reader gave them —
	// this positions the one scroll surface, it does not rearrange the panel.
	function phraseStripTitle(dock, def, s) {
		var title = $("<button type='button' class='phStripTitleClass'></button>")
			.attr("data-section", def.key)
			.text(getRes(def.label) + " · " + s.total);
		title.on("click", function (e) {
			e.stopPropagation();
			phraseSectionFold(phraseBand.sec[def.key], false);
			phraseDockOpen(dock, true, true);
			phraseSectionReveal(def.key);
			// Marked from the CLICK, not only from the scroll it just caused: the last section can be
			// too short to reach the panel's top edge, and a door that lights nothing reads as a door
			// that did nothing. A later scroll re-decides it (phraseStripSync).
			phraseStripMark(def.key);
		});
		return title;
	}

	// ── which section is the panel looking at? ───────────────────────────────────────────────────
	// The strip already names all four; lighting the current one turns that summary line into a
	// position indicator, so a reader who scrolled to the examples can see WHERE they are without
	// looking away from the rows (owner call 2026-08-16). The lit title and the sticky header pinned
	// at the top of the panel name the same section by construction — both answer "whose header has
	// reached the top edge".
	function phraseStripMark(key) {
		$("#phraseStripId .phStripTitleClass").each(function () {
			$(this).toggleClass("phStripCurClass", $(this).attr("data-section") === key);
		});
	}

	function phraseStripSync() {
		var panel = document.getElementById("phrasePanelId");
		if (!panel) { return; }
		var secs = panel.querySelectorAll(".phSectionClass");
		if (!secs.length) { return; }
		// At the very bottom the last sections may never reach the top edge — nothing below them left
		// to scroll — so the end of the surface means the last section, whatever its header did.
		if (panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 1) {
			phraseStripMark(secs[secs.length - 1].getAttribute("data-section"));
			return;
		}
		var top = panel.getBoundingClientRect().top, cur = secs[0].getAttribute("data-section");
		for (var i = 0; i < secs.length; i++) {
			if (secs[i].getBoundingClientRect().top - top <= 1) { cur = secs[i].getAttribute("data-section"); }
		}
		phraseStripMark(cur);
	}

	// Scroll the panel so a section's header sits at its top edge. Measured from live rectangles
	// rather than offsetTop: the panel is not the offset parent (#defBoxId is, it carries the dock's
	// position:relative), so offsetTop would be a coordinate in the wrong box.
	function phraseSectionReveal(key) {
		var panel = document.getElementById("phrasePanelId");
		var section = panel && panel.querySelector("[data-section='" + key + "']");
		if (!section) { return; }
		panel.scrollTop += section.getBoundingClientRect().top - panel.getBoundingClientRect().top;
	}

	// How far past the dictionary box's own edges the band may reach (design §8). The dock is allowed
	// OUT of the central panel and into the gap before the movable pane dividers — but only as far as
	// that gap really is: min(~1cm, the measured gap − a safety margin). A narrow window gets less
	// overhang rather than a band colliding with a divider.
	//
	// Measured off the DOCK's own live edges, because the dock and the pane are a stack of ems,
	// percentages and margins apart and only the rendered rectangles know what that came to. The
	// current overhang is added back, so the answer is "how far could it go from a standing start"
	// whatever it is standing at now — one measurement, not a converging series. ONE value drives
	// both sides, which is what makes the protrusion symmetric by construction.
	//
	// This deliberately REPLACES the 2026-08-10 alignment, which pushed the dock's right edge in by
	// the entry cards' scrollbar so the two lined up. The band is a floating card over the list now,
	// not a slab flush with it: it is symmetric about the panel, and its shadow is what says so.
	var PH_OVERHANG_MAX = 38;    // px ≈ 1cm — as far as the band may ever protrude
	var PH_OVERHANG_SAFE = 4;    // px of the gap left untouched, so it never reaches a divider
	function phraseDockPublishGutter() {
		var box = document.getElementById("defBoxId");
		var dock = document.getElementById("phraseDockId");
		// #centralPaneId, not #centralPanelId: the DIVIDERS bound the pane, and the panel inside it
		// keeps its own margin — measuring to the panel would give away that margin for nothing.
		var pane = document.getElementById("centralPaneId");
		if (!box || !dock || !pane) { return; }
		var now = parseFloat(getComputedStyle(box).getPropertyValue("--pl-dict-overhang")) || 0;
		var d = dock.getBoundingClientRect(), p = pane.getBoundingClientRect();
		var room = Math.min((d.left - p.left) + now, (p.right - d.right) + now);
		var overhang = Math.max(0, Math.min(PH_OVERHANG_MAX, room - PH_OVERHANG_SAFE));
		box.style.setProperty("--pl-dict-overhang", Math.round(overhang) + "px");
	}

	// Fold the open panel and forget the pin — the shared body of the chevron and Escape. The band
	// itself STAYS (strip and cached answer): the reader dismissed the rows, not the question. That
	// is why this is not phraseBandForget, which drops the cache and would refetch on the next
	// keystroke.
	function phraseDockFold() {
		var dock = $("#phraseDockId");
		if (!dock.hasClass("phDockOpenClass")) { return false; }
		phraseDockOpen(dock, false, true);
		return true;
	}

	// One switch for the dock's two states; `pin` records a deliberate click so a hover-out or the
	// next keystroke's repaint keeps the reader's choice, while a mere hover stays transient.
	function phraseDockOpen(dock, open, pin) {
		if (pin) { phraseBand.open = !!open; }
		if (!open) { phrasePagerRelease(); }
		dock.toggleClass("phDockOpenClass", !!open);
		dock.find(".phStripChevClass").text(open ? "▾" : "▴");
		if (open) { phraseBandRemeasure(); phraseStripSync(); }
	}

	// The windows could not measure themselves while the panel was display:none — and both band
	// shapes build their sections before they are in the document at all. This is the pass that runs
	// the moment they ARE on screen: the chip window re-paints (its size IS a measurement), every
	// other window settles the height it reserves.
	function phraseBandRemeasure() {
		if (!phraseBand.sec) { return; }
		for (var i = 0; i < PH_SECTIONS.length; i++) {
			var s = phraseBand.sec[PH_SECTIONS[i].key];
			if (!s || !s.$win || !s.$win.length || !s.$win[0].offsetWidth) { continue; }
			if (s.def.key === 'words' && !s.winFit) { phraseSectionPaint(s); }   // reserves too
			else if (!s.height) { phraseSectionReserve(s); }
		}
	}

	// Only the rescue shape lives in #defId now, and it LEADS the neighbourhood. Re-applied after
	// every endless-scroll insertion, because dictPrepend writes straight into #defId above it.
	function phraseBandReposition() {
		var band = $("#phraseBandId");
		if (band.length) { band.prependTo("#defId"); }
	}

	// IN WORDS: a chip per headword the typed sequence lives inside — compact, headword only, because
	// this section answers "which words is it in?" and a full row per word would bury that under
	// glosses. The word inside is minted through phraseBandPhraseHtml, so it IS a `.term-word`: the
	// standard hover surface (translation, 🔊, add-to-list) comes with it rather than being rebuilt
	// here, and the typed sequence is marked inside the word in the same blue as everywhere else.
	//
	// The click is a NAVIGATION, the one thing the tape could not do for this query: it re-centres
	// the dictionary on that word and opens it, through the same trusted path a word-list row uses —
	// so the hidden-term gate applies without this code knowing anything about it.
	function phraseBandWordChip(row) {
		var chip = $("<span class='phWordChipClass' role='button' tabindex='0'></span>")
			.html(phraseBandPhraseHtml(row.term, phraseBand.pattern));
		var open = function () { navigateTo(row.term, true, true); };
		chip.on("click", open);
		chip.on("keydown", function (e) {
			if (e.which === PL.keys.ENTER || e.which === PL.keys.SPACE) { e.preventDefault(); open(); }
		});
		return chip;
	}

	// A signpost, not a destination (decision 2): the row shows the phrase and its gloss, and the
	// chip names where it LIVES — the head word whose card the click opens, scrolled to this very
	// line. Collocations and example sentences share the builder; only their section differs.
	//
	// Phrase and gloss sit on ONE line and wrap into a hanging indent (see .phBandRowBodyClass), so a
	// long example sentence stays visibly one row instead of reading as two.
	function phraseBandPhraseRow(row) {
		var el = $("<div class='phBandRowClass' role='button' tabindex='0'></div>");
		if (row.id != null) {
			// Same data-* contract the rich card's phrase rows carry — that is what the gutter's
			// sound/add handlers read (wirePhraseBandRows).
			el.attr("data-phrase-kind", row.kind).attr("data-phrase-id", row.id);
			el.append(phraseGutter(row.id));
		}
		var body = $("<div class='phBandRowBodyClass'></div>");
		body.append($("<span class='phBandTextClass'></span>")
			.html("“" + phraseBandPhraseHtml(row.text, phraseBand.pattern) + "”"));
		if (row.gloss) { body.append($("<span class='phBandGlossClass'></span>").text(" — " + row.gloss)); }
		el.append(body);
		el.append($("<span class='phBandChipClass'></span>").text("↳ " + row.headTerm));
		var open = function () { navigateTo(row.headTerm, true, true, { focusColloc: row.text }); };
		el.on("click", function (e) {
			// The gutter's buttons act on THIS phrase (pronounce it, add it to the list); the row
			// around them is a signpost to the head entry. Without this guard a click on either
			// button also ran the row's own handler — the button did its job and then navigated
			// away from it. Their own stopPropagation cannot help: this handler is bound on the row
			// itself, so it fires while the event is still bubbling up to them.
			if ($(e.target).closest(".phrase-gutter").length) { return; }
			open();
		});
		el.on("keydown", function (e) {
			if (e.which === PL.keys.ENTER || e.which === 32) { e.preventDefault(); open(); }
		});
		return el;
	}

	// A band row's phrase, as HTML: every word a live `.term-word` token, with the typed prefix
	// blue-marked inside it. Two jobs in one pass because they nest — the highlight lives INSIDE the
	// word span, and running them separately would have one wrapping the other's markup.
	//
	// **The words are the rich card's own tokens, not lookalikes.** `termWordSegments` is the very
	// splitter `tokenizeTermWords` uses, and `.term-word` is what the document-level hover handlers
	// key on — so a band word gets the card's orange border and its translation popup for free, and
	// can never drift from how the card behaves (v2 follow-up; v1–v2 rendered inert text here).
	//
	// The blue is `.revMatchClass`, the SAME blue the A–Z rows and the reverse tape wear, so "why is
	// this row here" is answered in one colour everywhere it is asked. The server matched by FOLDED
	// substring per token; this re-finds those sequences literally and case-insensitively ANYWHERE in
	// the word — which is the whole point of the redesign, and the only way the highlight can still
	// explain a row: marking only word-initial hits would leave the `prech` in *sprechen* unmarked,
	// i.e. exactly the rows the reader most needs the mark on. A fold-only hit (typing `ue` to reach
	// `über`) still shows no highlight rather than a wrong one — the row is correct either way, it
	// just says nothing it cannot prove.
	//
	// No selfTerm is passed to the tokenizer on purpose: the card greys its own headword because
	// clicking it would re-open the entry you are already in, which is never true here — the band is
	// looking at somebody else's entry, so every word stays live.
	// Returns HTML, so every caller must use .html().
	function phraseBandPhraseHtml(text, pattern) {
		var tokens = [], parts = String(pattern || "").split(/[^\p{L}\p{N}]+/u);
		for (var p = 0; p < parts.length; p++) {
			if (parts[p].length >= PHRASE_BAND_MIN) { tokens.push(parts[p].toUpperCase()); }
		}
		var segs = termWordSegments(text), out = "";
		for (var i = 0; i < segs.length; i++) {
			if (!segs[i].word) { out += escHtml(segs[i].text); continue; }
			var word = segs[i].text, upper = word.toUpperCase(), at = -1, len = 0;
			for (var t = 0; t < tokens.length; t++) {
				// Longest typed token wins, so "sum summer" marks the whole word, not three letters.
				var found = upper.indexOf(tokens[t]);
				if (found >= 0 && tokens[t].length > len) { at = found; len = tokens[t].length; }
			}
			out += '<span class="term-word">'
				+ (len ? escHtml(word.substring(0, at))
					   + "<span class='revMatchClass'>" + escHtml(word.substr(at, len)) + "</span>"
					   + escHtml(word.substring(at + len))
					   : escHtml(word))
				+ '</span>';
		}
		return out;
	}

	// A user's own captured phrase IS its own term, so its row opens its own card — no head, no chip.
	function phraseBandMyRow(row) {
		var el = $("<div class='phBandRowClass phBandMyRowClass' role='button' tabindex='0'></div>");
		el.append($("<div class='phBandRowBodyClass'></div>")
			.append($("<span class='phBandTextClass'></span>")
				.html("“" + phraseBandPhraseHtml(row.term, phraseBand.pattern) + "”")));
		var open = function () { navigateTo(row.term, true, true); };
		el.on("click", open);
		el.on("keydown", function (e) {
			if (e.which === PL.keys.ENTER || e.which === 32) { e.preventDefault(); open(); }
		});
		return el;
	}

	// Does anything in the rendered A–Z page actually START with what was typed? The seek always
	// answers with a NEIGHBOURHOOD (it positions, it does not filter), so "no results" is a
	// client-side question: reuse the very prefix test that decides the rows' own highlight, so the
	// band's rescue line and the blue highlight can never disagree about what counts as a match.
	function phraseBandNoMatch(list, pattern) {
		var typed = (pattern || '').trim();
		if (!typed) { return false; }
		var upper = typed.toUpperCase();
		for (var i = 0; i < (list || []).length; i++) {
			var t = list[i] && list[i].term;
			if (!t || !t.term) { continue; }
			if (findMatchIndex(upper, t.term.toUpperCase(),
					(t.termSearch || '').toUpperCase(), (t.termSearchFold || '').toUpperCase(),
					t.searchOffsets, t.foldOffsets) > 0) {
				return false;
			}
		}
		return true;
	}

	function escHtml(s) {
		return String(s == null ? "" : s)
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/"/g, "&quot;");
	}

	// Strip any wrapping braces/brackets a generated form might carry (e.g. "{veröffentlicht}").
	function stripBraces(s) {
		return String(s == null ? "" : s).replace(/^[{\[(]+/, "").replace(/[}\])]+$/, "").trim();
	}

	// Maps a stored grammatical gender letter to the definite article face for the TERM's language.
	//
	// The letter alone cannot answer this: 'N' is das in German and lo in Spanish, and 'F' is die
	// or la. It was a one-language function while German was the only gendered term language; the
	// Spanish sense layer (changeset 0136) adds two letters German has no use for, so the language
	// is now a parameter. An unknown language, or a letter that language does not use, renders no
	// article chip at all — exactly what the German-only version did for every non-M/F/N letter.
	//
	//   C = común    — one form, both genders: el/la estudiante, artista, joven, testigo
	//   A = ambiguo  — both articles correct for the same referent: el/la mar, azúcar, internet
	//
	// Both render "el/la" because that IS the face a learner is shown; the two letters are kept
	// apart in the data because they are different facts (one form serving two genders, versus one
	// noun accepting two articles) and the drill grader treats them differently — es-term-onboarding
	// §2.5 rule F9 gives gender 'a' an accepted-answer set with BOTH articles.
	var GENDER_ARTICLES = {
		DE: {M: 'der', F: 'die', N: 'das'},
		ES: {M: 'el', F: 'la', C: 'el/la', A: 'el/la', N: 'lo'}
	};

	// ⛔ No default language. An absent langCode renders NO article rather than falling back to
	// German — a missing article is visible and harmless, a wrongly-German one teaches a false fact.
	function genderArticle(g, langCode) {
		if (!g || !langCode) { return ''; }
		var byLetter = GENDER_ARTICLES[String(langCode).toUpperCase()];
		return byLetter ? (byLetter[String(g).toUpperCase()] || '') : '';
	}

	// Wraps each term-language word in the given text in a selectable <span class="term-word">,
	// leaving whitespace/punctuation between words as inert (escaped) text. Used for every
	// term-language string in the rich card (headword, synonyms, collocations, examples) so the
	// user can click any single word — future hooks: add-to-list, pronounce, show rich info.
	//
	// selfTerm (optional): the entry's own headword. A token matching it (e.g. the headword recurring
	// inside its own collocations/examples) is rendered as inert text, NOT a drill-in link — clicking
	// it would only re-open the entry we're already on, a no-op that pollutes the Back history.
	// One pass over a term-language string: its word tokens and the inert text between them, in order
	// — [{text, word: true|false}]. What counts as ONE word is decided here and nowhere else, because
	// three things now have to agree about it: the .term-word markup below, the multi-word-headword
	// test that decides whether a head token drills in, and the Learn recap's per-word study links
	// (learning_session.js, via window.termWordSegments).
	function termWordSegments(text) {
		var out = [];
		if (text == null) { return out; }
		var s = String(text);
		var re = /\p{L}+(?:[-'’]\p{L}+)*/gu;
		var last = 0;
		var m;
		while ((m = re.exec(s)) !== null) {
			// Detached-genitive junk guard (word-form-entries): \p{L}+ cannot start on a digit or
			// quote, so "the 1980's" / a leading "’s" restarts the match AT the s and would mint a
			// clickable bare-"s" token — which then becomes a junk term row on click. A 1-letter
			// s/S directly preceded by an apostrophe is genitive debris, never a word. (English
			// possessives on words — "boy's" — keep their apostrophe INSIDE the token by the regex
			// and are real form tokens, resolved to their base by the word-form machinery.)
			var junkS = m[0].length === 1 && (m[0] === 's' || m[0] === 'S')
				&& m.index > 0 && (s[m.index - 1] === "'" || s[m.index - 1] === '’');
			if (junkS) { continue; }
			if (m.index > last) { out.push({ text: s.slice(last, m.index), word: false }); }
			out.push({ text: m[0], word: true });
			last = m.index + m[0].length;
		}
		if (last < s.length) { out.push({ text: s.slice(last), word: false }); }
		return out;
	}
	window.termWordSegments = termWordSegments;

	function tokenizeTermWords(text, selfTerm) {
		var self = selfTerm != null ? String(selfTerm).trim().toLowerCase() : null;
		var segs = termWordSegments(text);
		var out = '';
		for (var i = 0; i < segs.length; i++) {
			if (!segs[i].word) {
				out += escHtml(segs[i].text);
			} else if (self && segs[i].text.toLowerCase() === self) {
				// self-reference — inert (not a clickable drill-in token), styled to stand out subtly
				// from the surrounding sentence. Its own class so the colour is deliberate and identical
				// in both containers, not inherited (Dictionary defaults to black, Practice to grey).
				out += '<span class="rich-self-word">' + escHtml(segs[i].text) + '</span>';
			} else {
				out += '<span class="term-word">' + escHtml(segs[i].text) + '</span>';
			}
		}
		return out;
	}

	// How many term-language words a string carries — the same tokens tokenizeTermWords wraps.
	function termWordCount(text) {
		var segs = termWordSegments(text), n = 0;
		for (var i = 0; i < segs.length; i++) { if (segs[i].word) { n++; } }
		return n;
	}

	// data-* attributes that tag a collocation/example row with its kind + persisted id, so the
	// phrase-sound handlers can resolve it. Emitted only when the row has an id (always, for stored
	// entries — every render goes through the DB), so a stray un-persisted row simply has no gutter.
	function phraseRowAttrs(kind, id) {
		return id != null ? ' data-phrase-kind="' + kind + '" data-phrase-id="' + id + '"' : '';
	}

	// The row's own short kind ("colloc" / "example") as the server's PhraseKind enum. The sound
	// endpoint takes the short form in a named parameter and never needed this; the pronunciation
	// endpoint stores the kind on the attempt row, so it takes the enum value itself.
	function phraseKindOf(rowKind) {
		if (rowKind === "colloc" || rowKind === "collocation") { return "COLLOCATION"; }
		return rowKind === "example" ? "EXAMPLE" : null;
	}

	// The left gutter of a phrase row: three buttons (add-to-drill + practice + pronounce) revealed
	// on gutter hover. No id → empty spacer so the body still aligns with its sibling rows.
	//
	// Add · Mic · Sound — the app-wide order (ai-features-plan.md §1 decision 1). The gutter used
	// to read Sound · Add; it was reordered along with the microphone rather than left as the one
	// place the three controls sit in a sequence of their own.
	function phraseGutter(id) {
		if (id == null) {
			return '<span class="phrase-gutter"></span>';
		}
		// No title= on any button: wireRichPhraseRows puts them on PL.tip (PR 7/7), which is
		// also what finally renders the <p/> their resource strings carry.
		return '<span class="phrase-gutter">'
			+ '<span class="phrase-gutter-line">'
			+ '<button type="button" class="pl-btn-icon phrase-add-btn" tabindex="-1">'
			+ '<span class="pl-ic pl-ic-list-plus"></span></button>'
			+ '<button type="button" class="pl-btn-icon pronMicClass phrase-mic-btn" tabindex="-1"'
			+ ' aria-pressed="false"><span class="pl-ic pl-ic-mic"></span></button>'
			+ '<button type="button" class="pl-btn-icon phrase-sound-btn" tabindex="-1">'
			+ '<span class="pl-ic pl-ic-volume"></span></button>'
			+ '</span>'
			// One row below the gutter buttons, right-aligned under mic/sound (Placement D) — same
			// hover-reveal lane, tray-add-buttons.md decision 6.
			+ '<span class="phrase-tray-line">'
			+ trayMarkButtonsHtml("pl-btn-icon")
			+ '</span>'
			+ '</span>';
	}

	// The six persons of a German paradigm, in display order. `label` is the row header and the
	// prefix of the drilled form (Util.conjPronounLabel — one definition, shared with the drill and
	// twinned with Java). `pron` is the single subject pronoun the STORED cell begins with, stripped
	// for display so the label does not duplicate it: the corpus stores "er arbeitet ab" / "sie
	// arbeiten ab", which the third-person rows re-label as "er, sie, es" / "sie, Sie".
	//
	// A row is ONE drill entry, not one per pronoun: the learner types the whole enumeration
	// ("er, sie, es arbeitet ab"), with the label prefilled and only the verb left to type. That
	// keeps a single Term per paradigm cell — panel, popup, sound and drill all name the same
	// string, so warming the panel fills exactly the cache the expansion reads.
	// ⭐ Since 2026-09-08 this list lives in Util.paradigmPack.DE (F2a part 3) — one definition, and
	// the German one is unchanged down to the stored-pronoun column. The name stays because half the
	// file reads it.
	var CONJ_PERSONS = Util.paradigmPack.DE.persons;
	// Tense → German column header + resource key for the learner-language tooltip: Util.conjTense,
	// shared with Learn's meet card (which names the tense of a conjugated-form card).

	// Strip whichever subject pronoun a stored cell opens with, and give back both the bare form to
	// display and the drilled combo (label + bare). TWINNED with VerbFormService.drillForm + labelFor:
	//   - the cell begins with the pronoun the corpus actually wrote, not always "er" — an impersonal
	//     third-person-singular cell is "es regnet" / "es gibt", and a few verbs use "sie gebiert";
	//   - the third-person-singular label is normally "er, sie, es", but an impersonal "es" cell keeps
	//     just "es" (there is no "er regnet"). Stripping a fixed "er" produced "er, sie, es es regnet".
	// A single-token cell, or one with no recognizable leading pronoun, passes through untouched, so a
	// malformed paradigm can never produce "er, sie, es er".
	var CONJ_LEAD_RE = /^(ich|du|er|sie|es|wir|ihr)\s+/i;
	function conjDrill(person, cell) {
		var stored = String(cell).trim();
		if (stored.indexOf(" ") < 0) {
			return { shown: stored, combo: stored };
		}
		var m = CONJ_LEAD_RE.exec(stored);
		if (!m) {
			return { shown: stored, combo: stored };
		}
		var bare = stored.slice(m[0].length);
		if (!bare) {
			return { shown: stored, combo: stored };
		}
		var label = (person.key === "thirdSg" && m[1].toLowerCase() === "es") ? "es" : person.label;
		return { shown: bare, combo: label + " " + bare };
	}

	// ⭐ The SPANISH principal-parts line — `tengo · tuve · tenido · ten` (plan §4b row 9, F2b).
	//
	// It reads the paradigm, not the four German-shaped sense columns, and every one of the four
	// cells is a different choice from German's:
	//
	//   tengo   the FIRST person present, because that is where Spanish irregularity lives (tengo,
	//           hago, conozco, quepo) while the third person of those same verbs is regular. German
	//           prints the third for the mirror-image reason (fahren → fährt).
	//   tuve    the first person preterite: the strong preterite is stem-stressed in exactly 1sg and
	//           3sg against an ending-stressed `tuviste`, so 1sg is where the pattern breaks.
	//   tenido  the participle, off the sense column — the one cell the two languages share.
	//   ten     the tú imperative, separately irregular and predicted by nothing else on the line
	//           (ten di haz ve pon sal sé ven).
	//
	// ⛔ No auxiliary, and that is data rather than an omission: `sense.auxiliary` is filled on 0 of
	// Spanish's 7,342 verb senses because the compound is `haber` for every verb. Without this arm
	// the shared code below printed a bare `hablado` on every Spanish verb sense — the participle
	// alone, with no line to belong to (register §2.7c open item 2).
	//
	// Twinned in spirit with `VerbPrincipalPartsService.Verb.spanishSlots`, which recites the same
	// four cells onto the form-set CARD. The card additionally carries the infinitive; here it is
	// the headword the line sits under, so repeating it would say the word twice.
	function esPrincipalParts(sense) {
		var rows = sense.conjugation || [];
		function cell(tense, col) {
			for (var i = 0; i < rows.length; i++) {
				if (rows[i].tense === tense && rows[i][col]) { return rows[i][col]; }
			}
			return "";
		}
		var out = [];
		[cell("pres_ind", "firstSg"), cell("pret_ind", "firstSg"),
		 sense.participle, cell("imp_aff", "secondSg")].forEach(function (form) {
			if (form) { out.push(escHtml(stripBraces(form))); }
		});
		return out;
	}

	// Build the transposed conjugation grid (persons × whichever tenses the paradigm carries). Each
	// non-empty form cell is a hover target (.rich-conj-cell) tagged with data-combo (the FULL form,
	// pronoun included) and data-person (so the hover can co-highlight that row's pronoun label).
	//
	// `langCode` / `entry` / `sense` were added at F2a: the Spanish table is a different shape (a
	// closed tense list, *no existe* columns, rendered compound and progressive blocks off the
	// sense's participle and gerund, a reflexive clitic on a pronominal headword) and all three are
	// what it needs to build it. German ignores them and is byte-identical without them.
	function renderConjugationTable(conjugation, langCode, entry, sense) {
		var pack = Util.paradigm(langCode);
		if (pack.code === "ES") {
			return renderConjugationTableEs(conjugation, pack, entry, sense);
		}
		var head = '<tr><th class="rich-conj-corner"></th>';
		for (var t = 0; t < conjugation.length; t++) {
			var tense = conjugation[t].tense;
			var meta = Util.conjTense[tense] || { de: tense, res: null };
			// data-tense, not a title=: the delegated PL.tip over these headers (see the native
			// sites block at the top of the file) resolves the tense's learner-language name at
			// hover time — one instance for every paradigm on the page.
			head += '<th class="rich-conj-thead" data-tense="' + escHtml(tense) + '">'
				+ escHtml(meta.de) + '</th>';
		}
		head += '</tr>';

		var body = "";
		for (var p = 0; p < CONJ_PERSONS.length; p++) {
			var person = CONJ_PERSONS[p];
			var row = '<tr><th class="rich-conj-pron" data-person="' + person.key + '">'
				+ escHtml(person.label) + '</th>';
			for (var c = 0; c < conjugation.length; c++) {
				var full = conjugation[c][person.key];
				if (full == null || String(full).trim() === "") {
					row += '<td class="rich-conj-cell rich-conj-empty"></td>';
					continue;
				}
				// data-combo is the cell's single identity — what the popup translates, the sound
				// speaks, add-to-drill creates and the drill asks you to type ("er, sie, es geht").
				// The cell itself shows only the bare form; the row header carries the pronoun.
				// ⚠️ combo must equal what VerbFormService.drillForm builds for the same cell —
				// verified by temp/conj-twin/twin_check.js.
				var drill = conjDrill(person, full);
				var attrs = 'data-combo="' + escHtml(drill.combo) + '" data-person="' + person.key + '"';
				row += '<td class="rich-conj-cell" ' + attrs + '>' + escHtml(drill.shown) + '</td>';
			}
			row += '</tr>';
			body += row;
		}

		return '<details class="rich-conj"><summary>Conjugation</summary>'
			+ '<div class="rich-conj-scroll">'
			+   '<table class="rich-conj-table"><thead>' + head + '</thead><tbody>' + body + '</tbody></table>'
			+ '</div>'
			+ '</details>';
	}

	// ── The Spanish paradigm panel (F2a part 4; plan §4b rows 1–7, register rules F2/F3/F6/F10) ────
	//
	// Four things it does that the German table has no need of, each with the rule behind it:
	//
	//  1. *no existe*, in TWO different code paths (rule F2, the defective verbs). A masked CELL is
	//     a NULL inside a tense that exists — `llover` has only a 3sg present, so five of its six
	//     present cells say it. A wholly masked TENSE has NO ROW AT ALL: `soler` has no future, no
	//     conditional and no imperative, and its payload simply carries six tenses instead of nine.
	//     That second one can only be detected by diffing the payload against a CLOSED list, which
	//     is why pack.storedTenses exists (§2.7b ruling 2: an all-NULL row would be storage nothing
	//     can read — RichDictionaryService.hasAnyForm drops it before it ever reaches the client).
	//
	//  2. the negative imperative — "no" + the present subjunctive, never stored (register §2.5,
	//     names imp_neg_* reserved). Pure rendering, zero new data, and it disappears on its own for
	//     a verb whose present subjunctive is masked (`abolir`).
	//
	//  3. the compound and progressive blocks (rule F3) — the auxiliary's own paradigm, which is a
	//     language constant in the pack, plus THIS verb's participle / gerund, which travel with the
	//     sense. ~70 rows per verb that never had to be stored.
	//
	//  4. the reflexive clitic. ⛔ This is the defect §2.7b measured and told F2a to handle rather
	//     than concatenate: `levantarse` stores the finite cells BARE (`levanto`, which is
	//     `levantar`), and its gerund WITH A THIRD-PERSON ENCLITIC (`levantándose`), so "estar +
	//     gerund" gives *"estoy levantándose"* — wrong Spanish, for ~340 pronominal heads. Both
	//     halves are fixed the same way: the clitic agrees with the SUBJECT, and each person's is a
	//     constant (pack.clitics). Proclitic on a finite form, and substituted for the stored `-se`
	//     on the gerund, where it never moves the written accent.
	//
	// ⚠️ What is rendered is NOT what is drilled. data-combo carries the stored bare cell, because
	// that string is the term row, the sound key and the answer — see SpanishParadigmPack. A cell a
	// clitic was rendered onto still identifies itself by the bare form, and a DERIVED cell (the
	// negative imperative, a compound, a progressive) carries no data-combo at all: nothing is
	// stored for it, so there is nothing for the popup to translate or the drill to ask for.

	// Any Spanish infinitive ending in -rse is pronominal (levantarse, reírse, irse) and nothing else
	// in the language ends that way, so the headword itself is the test. Deliberately not a lookup
	// on `reflexiveCase` — that column is German's sich + case and Spanish writes nothing into it.
	function esIsPronominal(term) {
		return /rse$/i.test(String(term || ""));
	}

	// One rendered cell: what the learner reads, and the stored string that identifies it (null for
	// a derived cell, which has neither a term row nor a translation).
	function esCell(shown, combo) {
		return { shown: shown, combo: combo || null };
	}

	// Rule F10 in full: "present, preterite, the command block first; THE REST ONE TAP AWAY;
	// -ra default, -se behind a toggle". Both halves are per-column classes — an HTML table has no
	// column element to hide, so the class goes on the <th> and on every <td> of that column and
	// CSS decides. The two toggles compose: "más tiempos" reveals the six non-core columns, and the
	// "-ra / -se" switch then chooses which imperfect subjunctive is among them.
	//
	// ⭐ Written after LOOKING at the first screenshot. Ten columns overflow the entry pane, so the
	// default view was a table clipped mid-word with the scroll affordance off-screen — the order
	// was right and the rule's second clause was not honoured at all.
	var ES_CORE_TENSES = ["pres_ind", "pret_ind", "imp_aff", "imp_neg"];

	function esToggleClass(tense) {
		var cls = ES_CORE_TENSES.indexOf(tense) < 0 ? ["rich-conj-more"] : [];
		if (/imperf_subj_ra$/.test(tense)) { cls.push("rich-conj-ra"); }
		if (/imperf_subj_se$/.test(tense)) { cls.push("rich-conj-se"); }
		return cls.join(" ");
	}

	// The gerund as THIS person would say it. `levantándose` → `levantándome` for yo: the stored
	// form already carries the written accent on the stem, and every clitic is the same length class
	// after it, so substituting the trailing pronoun never shifts stress. A non-pronominal gerund
	// (`hablando`) is returned untouched, which is the whole point of gating on the headword.
	function esGerundFor(gerund, pronominal, clitic) {
		if (!gerund) { return null; }
		if (!pronominal) { return gerund; }
		return /se$/i.test(gerund) ? gerund.slice(0, -2) + clitic : gerund;
	}

	// ── Rule F7's boot cells ─────────────────────────────────────────────────────────────────────
	//
	// WHICH present-indicative cells actually changed, derived from the paradigm that is already on
	// the wire. ⛔ Deliberately NOT read off `sense.verbClass`: the class names the KIND of change,
	// and the cells it lands in differ by class — `e_ie` moves four (yo/tú/él/ellos, the "boot"),
	// `zco` moves one (`conozco`), `ortografico` often moves one (`cojo`) and sometimes none in this
	// tense at all. A fixed boot mask would be right for the diphthong classes and wrong for the
	// other ten, and wrong is worse than absent.
	//
	// The comparison: 1pl is the cell no Spanish stem change reaches, so it carries the verb's own
	// REGULAR stem. Strip its ending to get that stem, take the conjugation group from the same
	// ending (-amos/-emos/-imos), and a cell is marked when it differs from stem + the regular
	// ending for its person.
	//
	// ⭐ Ending-based, not prefix-based, and that is the whole difference: `tengo` BEGINS with the
	// regular stem `ten`, so a "does it start with the stem" test misses exactly the -go verbs that
	// a learner most needs marked. `ten` + `o` = `teno` ≠ `tengo` catches it.
	//
	// Fails SAFE. No 1pl cell, or one that does not end in a recognised ending, marks nothing — a
	// panel with no highlight reads as "regular", which is the honest thing to say when the rule
	// cannot see.
	var ES_PRESENT_ENDINGS = {
		ar: ["o", "as", "a", "amos", "áis", "an"],
		er: ["o", "es", "e", "emos", "éis", "en"],
		ir: ["o", "es", "e", "imos", "ís", "en"]
	};

	function esStemChangedCells(byTense, persons) {
		var marks = [];
		for (var i = 0; i < persons.length; i++) { marks.push(false); }
		var row = byTense && byTense.pres_ind;
		if (!row) { return marks; }
		var firstPl = row.firstPl == null ? "" : String(row.firstPl).trim();
		// ⛔ The GROUP is read off a DE-ACCENTED copy, the stem is sliced off the ORIGINAL.
		// `reír`'s 1pl is `reímos` — the ending is -imos, written with a hiatus accent, and a
		// literal /imos$/ misses it, which would leave the whole `e_acento` class (reír, freír,
		// sonreír) showing a chip that reads `e → í` above a table marking nothing. The
		// substitution is one-for-one, so the copy has the same LENGTH and slicing four
		// characters off the original still lands on the stem.
		var plain = firstPl.replace(/[áéíóú]/g, function (v) {
			return "aeiou".charAt("áéíóú".indexOf(v));
		});
		var group = null;
		if (/amos$/.test(plain)) { group = "ar"; }
		else if (/emos$/.test(plain)) { group = "er"; }
		else if (/imos$/.test(plain)) { group = "ir"; }
		if (!group) { return marks; }
		var stem = firstPl.slice(0, -4);
		if (!stem) { return marks; }
		var endings = ES_PRESENT_ENDINGS[group];
		for (var p = 0; p < persons.length && p < endings.length; p++) {
			// ⛔ The REFERENCE cell is never marked. It is the cell the stem was read off, so it
			// cannot have "changed" — and without this guard it sometimes does: `reír`'s 1pl is
			// `reímos`, whose accent sits inside the ENDING rather than in the stem, so
			// `re` + `imos` misses it and the reference cell reports itself as irregular.
			if (persons[p].key === "firstPl") { continue; }
			var form = row[persons[p].key];
			if (form == null || String(form).trim() === "") { continue; }
			marks[p] = String(form).trim() !== stem + endings[p];
		}
		return marks;
	}

	// The one-line explanation above the panel: the alternation as a chip, then the sentence that
	// says what it does. Both come from the UI bundle, keyed by the class NAME the column carries —
	// the store holds `e_ie`, never "the stem vowel breaks into a diphthong" (changeset 0141).
	// `e_ie_i` → `EIeI`, `only_in` → `OnlyIn`, `RPL` → `RPL`. Every Spanish sense field on the wire
	// is a stored CODE whose word lives in the viewer's own bundle, and this is the one place the
	// code becomes a key. ⛔ Only the first character of each part is touched, so an upper-case
	// region code survives whole.
	function camelCode(raw) {
		return String(raw == null ? "" : raw).trim().split("_").map(function (part) {
			return part ? part.charAt(0).toUpperCase() + part.slice(1) : "";
		}).join("");
	}

	// The bundle's word for one stored code, or "" when the bundle has no such key. ⛔ `getRes`
	// answers with the KEY when it misses, so every caller must compare — otherwise an unknown
	// value ships `senseRegionXX_label` to the learner. S4.
	function codeLabel(prefix, code) {
		if (!code) { return ""; }
		var key = prefix + camelCode(code) + "_label";
		var label = getRes(key);
		return (!label || label === key) ? "" : label;
	}

	function esVerbClassLine(sense) {
		var raw = sense && sense.verbClass ? String(sense.verbClass).trim() : "";
		if (!raw) { return ""; }
		// An unknown class yields keys with no resource behind them, and `getRes` answers the key
		// itself, so the guard below drops the line rather than printing a key at the learner.
		var camel = camelCode(raw);
		var labelKey = "verbClass" + camel + "_label";
		var noteKey = "verbClass" + camel + "_note";
		var label = getRes(labelKey);
		var note = getRes(noteKey);
		if (!label || label === labelKey || !note || note === noteKey) { return ""; }
		return '<div class="rich-verb-class">'
			+ '<span class="rich-verb-class-tag">' + escHtml(label) + '</span>'
			+ '<span class="rich-verb-class-note">' + escHtml(note) + '</span>'
			+ '</div>';
	}

	// S4: the sense's variety limits, rendered FROM THE CODES. Register clause 14 forbids an
	// `Esp.:` prefix inside a gloss so the axis stays queryable and filterable; the price of that
	// ruling is that the reader is owed a real label here, in their own language.
	//
	// ⛔ Grouped by what they SAY, not one chip per row. `coger` carries six region rows that are
	// all the same statement — "obscene in Mexico, Argentina, Uruguay, Paraguay, Chile, Venezuela"
	// — and six separate chips would read as six facts. The grouping key is the pair
	// (type, register_override), which is exactly the statement.
	//
	// ⛔ And no preposition anywhere: `only in Spain` is `seulement en Espagne` but `seulement au
	// Mexique`, and Russian governs a case per country name. `label: A, B` is the one shape that
	// survives translation, so the bundle carries bare adverbs.
	function senseRegionLine(sense) {
		var rows = (sense && sense.regions) || [];
		if (!rows.length) { return ""; }
		var order = [], groups = {};
		for (var i = 0; i < rows.length; i++) {
			var row = rows[i] || {};
			var name = codeLabel("senseRegion", row.code) || row.code;
			if (!name) { continue; }
			// The override is the sense's register INSIDE that region, and it outranks the type in
			// the label: what a learner must not miss about `coger` in Mexico is `vulgar`, not
			// `only_in`. The register value is shown raw, exactly as the register chip shows it.
			var head = row.registerOverride
				? String(row.registerOverride)
				: codeLabel("senseRegionType", row.type);
			if (!head) { continue; }
			if (!groups[head]) { groups[head] = []; order.push(head); }
			groups[head].push(name);
		}
		if (!order.length) { return ""; }
		var parts = order.map(function (head) {
			return '<span class="rich-region-group">'
				+ '<span class="rich-region-label">' + escHtml(head) + '</span> '
				+ escHtml(groups[head].join(", ")) + '</span>';
		});
		return '<div class="rich-regions">' + parts.join(' ') + '</div>';
	}

	function renderConjugationTableEs(conjugation, pack, entry, sense) {
		var persons = pack.persons;
		var pronominal = esIsPronominal(entry && entry.term);
		var participle = sense && sense.participle ? String(sense.participle).trim() : null;
		var gerund = sense && sense.gerund ? String(sense.gerund).trim() : null;

		// The payload, by tense key. Anything in pack.storedTenses that is missing here is a WHOLLY
		// masked tense and becomes a *no existe* column below.
		var byTense = {};
		for (var i = 0; i < conjugation.length; i++) {
			byTense[conjugation[i].tense] = conjugation[i];
		}

		// ── the simple table, in rule F10's order, with the rendered negative imperative in it ────
		// Rule F7: only the present indicative is marked. The stem change shows in other tenses too,
		// but the panel's job here is to make ONE column legible as the place the class lives —
		// marking six columns would be a table with a highlight on it, not a highlight.
		var bootMarks = esStemChangedCells(byTense, persons);

		var simple = [];
		for (var t = 0; t < pack.panelOrder.length; t++) {
			var key = pack.panelOrder[t];
			var cells = [];
			for (var p = 0; p < persons.length; p++) {
				cells.push(esSimpleCell(key, p, byTense, persons, pronominal, pack));
			}
			simple.push({ tense: key, name: pack.tenses[key].name, cells: cells,
			              cls: esToggleClass(key),
			              mark: key === "pres_ind" ? bootMarks : null });
		}

		// ⛔ The class LINE is not rendered here. This panel is a <details> and it renders CLOSED, so
		// a line inside it is a line most learners never see — which a screenshot showed and no
		// assertion about the DOM could have. It is rendered by the sense loop instead, beside the
		// principal parts, above this summary. The BOOT MARKS stay here, because the cells they sit
		// on are here.
		var html = '<details class="rich-conj rich-conj-es"><summary>Conjugación</summary>'
			+ '<div class="rich-conj-toggles">'
			// Rule F10's two switches. Both columns of every pair are rendered and CSS decides, so
			// flipping either costs no re-render and no request. Labelled in Spanish, like the tense
			// headers and *no existe* — a term-language grammar label, not UI copy.
			+   '<span class="rich-conj-more-toggle" role="button" tabindex="0">+ más tiempos</span>'
			+   '<span class="rich-conj-se-toggle" role="button" tabindex="0">-ra / -se</span>'
			+ '</div>'
			+ esTable(simple, persons, "rich-conj-table");

		// ── haber + participio ───────────────────────────────────────────────────────────────────
		if (participle) {
			html += esDerivedBlock("haber + participio", pack, persons, function (tense, person) {
				var aux = pack.aux.haber[tense];
				if (!aux) { return null; }
				return esCell((pronominal ? pack.clitics[person] + " " : "") + aux[person] + " " + participle);
			}, pack.compoundNames);
		}

		// ── estar + gerundio ─────────────────────────────────────────────────────────────────────
		if (gerund) {
			html += esDerivedBlock("estar + gerundio", pack, persons, function (tense, person) {
				var aux = pack.aux.estar[tense];
				if (!aux) { return null; }
				var g = esGerundFor(gerund, pronominal, pack.clitics[person]);
				return esCell(aux[person] + " " + g);
			}, null);
		}

		return html + '</details>';
	}

	// One cell of the simple table. Three outcomes: a stored form, a rendered negative imperative,
	// or null — which the table paints as *no existe*.
	function esSimpleCell(tense, person, byTense, persons, pronominal, pack) {
		var key = persons[person].key;
		if (tense === "imp_neg") {
			// Rendered from the present subjunctive. No first-person-singular command exists, so
			// that cell is *no existe* the same way the affirmative's is.
			var subj = byTense.pres_subj;
			if (!subj || person === 0) { return null; }
			var base = subj[key];
			if (base == null || String(base).trim() === "") { return null; }
			return esCell("no " + (pronominal ? pack.clitics[person] + " " : "") + String(base).trim());
		}
		var row = byTense[tense];
		if (!row) { return null; }                       // a wholly masked tense
		var form = row[key];
		if (form == null || String(form).trim() === "") { return null; }   // a masked cell
		form = String(form).trim();
		// The affirmative imperative already carries its clitic ENCLITICALLY in the data
		// ("levántate", "levantaos" with the -d dropped), so it is the one tense a proclitic must
		// not be added to. Everything else finite takes it in front.
		var shown = (pronominal && tense !== "imp_aff") ? pack.clitics[person] + " " + form : form;
		return esCell(shown, form);
	}

	// A compound/progressive block: the auxiliary's own tenses in panel order, each cell built by
	// `build`. Its own <details> because it is a reference table, not the paradigm a learner drills.
	function esDerivedBlock(heading, pack, persons, build, names) {
		var cols = [];
		for (var t = 0; t < pack.storedTenses.length; t++) {
			var tense = pack.storedTenses[t];
			// imp_aff is absent from both: `haber` has no imperative at all (one of the five wholly
			// masked pairs on the database), and "está hablando" is not a command — a progressive
			// command uses `estarse`, a different verb, so building one here would invent Spanish.
			if (tense === "imp_aff") { continue; }
			var cells = [];
			var any = false;
			for (var p = 0; p < persons.length; p++) {
				var c = build(tense, p);
				cells.push(c);
				if (c) { any = true; }
			}
			if (any) {
				// ⛔ The "más tiempos" half of esToggleClass does NOT apply here: a derived block is
				// already behind its own <details>, so gating its columns a second time would hide
				// six of the eight behind a switch the learner has to find twice. Only the -ra/-se
				// switch carries over, and it is the same panel-level class.
				cols.push({ tense: tense, name: (names && names[tense]) || pack.tenses[tense].name,
				            cells: cells,
				            cls: esToggleClass(tense).replace("rich-conj-more", "").trim() });
			}
		}
		if (!cols.length) { return ""; }
		return '<details class="rich-conj-sub"><summary>' + escHtml(heading) + '</summary>'
			+ esTable(cols, persons, "rich-conj-table rich-conj-derived") + '</details>';
	}

	// persons (rows) × columns, the same transposition the German table uses. A null cell prints
	// *no existe* — the rule's own words (register F2), in the term language, exactly as the tense
	// headers are.
	function esTable(cols, persons, tableClass) {
		var head = '<tr><th class="rich-conj-corner"></th>';
		for (var c = 0; c < cols.length; c++) {
			head += '<th class="rich-conj-thead' + (cols[c].cls ? ' ' + cols[c].cls : '')
				+ '" data-tense="' + escHtml(cols[c].tense) + '">' + escHtml(cols[c].name) + '</th>';
		}
		head += '</tr>';

		var body = "";
		for (var p = 0; p < persons.length; p++) {
			var row = '<tr><th class="rich-conj-pron" data-person="' + persons[p].key + '">'
				+ escHtml(persons[p].label) + '</th>';
			for (var i = 0; i < cols.length; i++) {
				var cell = cols[i].cells[p];
				var cls = cols[i].cls ? ' ' + cols[i].cls : '';
				if (!cell) {
					row += '<td class="rich-conj-cell rich-conj-noexist' + cls + '">no existe</td>';
					continue;
				}
				var attrs = cell.combo
					? ' data-combo="' + escHtml(cell.combo) + '" data-person="' + persons[p].key + '"'
					: '';
				// Rule F7's boot mark. Only the present-indicative column ever passes a `mark`, and
				// a *no existe* cell never reaches here, so a masked defective (`llover`) cannot be
				// marked as a stem change it does not have.
				var boot = (cols[i].mark && cols[i].mark[p]) ? ' rich-conj-boot' : '';
				row += '<td class="rich-conj-cell' + cls + boot + '"' + attrs + '>'
					+ escHtml(cell.shown) + '</td>';
			}
			body += row + '</tr>';
		}
		return '<div class="rich-conj-scroll"><table class="' + tableClass + '"><thead>'
			+ head + '</thead><tbody>' + body + '</tbody></table></div>';
	}

	// Mark, inside an already-rendered rich card, the one paradigm cell a conjugated-form card was
	// built from — the cell PLUS its pronoun row header and its tense column header. All three,
	// because the coordinates are the point: a single tinted box in a 6×6 grid is easy to lose, and
	// what the learner needs to read off is "du, Präteritum", not just "there it is".
	//
	// The match is EXACT on data-combo, which renderConjugationTable fills from conjDrill — the same
	// string VerbFormService.drillForm builds the drilled term from (twinned, temp/conj-twin). So the
	// card's own term IS the key; nothing is re-derived here, and a cell that isn't found simply
	// leaves the table plain rather than guessing.
	//
	// Returns whether it hit, and opens the <details>: the table is collapsed by default, so a
	// highlight nobody can see is the same as no highlight at all.
	// The -ra / -se switch of register rule F10. Both imperfect-subjunctive columns are in the DOM;
	// this flips one class on the panel and CSS decides which is shown, so there is no re-render and
	// nothing to re-fetch. Delegated on document, like the rest of the rich card's handlers, because
	// a panel is rebuilt every time an entry is opened.
	$(document).on("click keydown", ".rich-conj-se-toggle, .rich-conj-more-toggle", function (e) {
		if (e.type === "keydown" && e.key !== "Enter" && e.key !== " ") { return; }
		e.preventDefault();
		// The click must not reach the <details> and collapse the panel the learner is reading.
		e.stopPropagation();
		var $t = $(this);
		$t.closest("details.rich-conj").toggleClass(
			$t.hasClass("rich-conj-se-toggle") ? "rich-conj-show-se" : "rich-conj-show-more");
		$t.toggleClass("rich-conj-toggle-on");
	});

	window.highlightConjCell = function ($host, combo) {
		if (!$host || !$host.length || !combo) { return false; }
		// .filter over an attribute selector: a combo carries commas and spaces ("er, sie, es geht"),
		// which have to be escaped in a selector and do not in a comparison.
		var cell = $host.find(".rich-conj-cell").filter(function () {
			return $(this).attr("data-combo") === combo;
		}).first();
		if (!cell.length) { return false; }
		cell.addClass("rich-conj-cell-hit");
		cell.closest("tr").find("th.rich-conj-pron").addClass("rich-conj-pron-hit");
		// Every body row opens with the pronoun th and the head row with the corner th, so a cell's
		// index among its siblings is also its column's index in <thead> — no separate bookkeeping.
		cell.closest("table").find("thead th").eq(cell.index()).addClass("rich-conj-thead-hit");
		cell.closest("details.rich-conj").prop("open", true);
		return true;
	};

	// The termId of the most recently rendered rich card — what Space pronounces while a card is
	// visible (dictionary mode or the exercise reveal; see the document keydown handler).
	var richCardTermId = null;

	// Renders the full rich dictionary entry (RichEntryDto) into the given container — the inline
	// expansion slot under a dictionary row (defaults to #defId for any legacy caller). onTermClick,
	// when given, overrides what a .term-word click does (word, isHeadword) => void — used by the
	// exercise reveal, which drills into words within its own box instead of the dictionary's.
	// Display policy for a collocation's word-for-word literal. Since 0040 EVERY collocation carries a
	// literal plus a `literalIsProper` flag (true = it also reads as a proper translation, so it just
	// echoes the definition — 'auf den Bus warten' -> 'to wait for the bus'; false = it doesn't, the
	// interesting case that exposes the German's word choice — 'to howl with the wolves'). Default:
	// show every literal EXCEPT the ones the model confirmed are proper/redundant. This leans toward
	// showing more (a slightly-too-transparent literal slipping through is acceptable), and the raw
	// data is all stored, so this threshold is a one-line change if we want it tighter or looser.
	// literalIsProper === null → an un-backfilled row whose literal only exists if #167's idiomatic
	// gate fired, so it is genuine — show it.
	function showCollocLiteral(col) {
		return !!col.literal && col.literalIsProper !== true;
	}

	// ── Rich-entry block builders ─────────────────────────────────────────────────────────────────
	// The false-friends, examples and collocations blocks of the rich card, extracted so each is one
	// named thing rather than three stretches of renderRichEntry. They were pulled out for a second
	// caller — the Struggling band's elaboration subset — which was removed on 2026-08-02 (the rich
	// view belongs in the central pane, not in the ~300px list column; leech-ui.md §10.3). Kept
	// extracted: renderRichEntry calls them in place, behaviour is identical, and the phrase rows'
	// per-row identity (data-phrase-kind / data-phrase-id, which the sound + add-to-drill wiring
	// reads) is easier to keep intact in one named builder than inline.

	// false friends warning (entry level — not per sense)
	//
	// ⛔ The two sides are the DEF language and the TERM language, read off the entry — never the
	// literal words "English"/"German". The row's `lookalike` is always a word of the DEFINITION
	// language that resembles the headword, and `actualMeaning` is what the HEADWORD (term
	// language) means, written in the definition language. Hardcoding the pair was correct only
	// for DE→EN, the pair this was written for: on EN→DE it labelled German "Braun" as English
	// and the English headword as German, and DE→RU labelled a Russian lookalike English
	// (found by the 2026-08-27 §7b false-friend audit). Codes, not names, because the names
	// would need a resource key per language and this line has never had one — noted as
	// follow-up i18n work, not silently invented here.
	function richFalseFriendsHtml(r) {
		if (!r.falseFriends || !r.falseFriends.length) { return ''; }
		var defCode = escHtml(r.defLanguageCode || '');
		var termCode = escHtml(r.languageCode || '');
		var h = '<div class="rich-ff">';
		for (var f = 0; f < r.falseFriends.length; f++) {
			var ff = r.falseFriends[f];
			h += '<div class="rich-ff-item"><span class="rich-ff-mark">false friend</span> '
			   + defCode + ' &ldquo;<span class="rich-ff-look">' + escHtml(ff.lookalike) + '</span>&rdquo; &ne; '
			   + termCode + ' &ldquo;<span class="rich-ff-look">' + escHtml(r.term) + '</span>&rdquo;: '
			   + escHtml(ff.actualMeaning);
			if (ff.note) h += ' <span class="rich-ff-note">' + escHtml(ff.note) + '</span>';
			h += '</div>';
		}
		return h + '</div>';
	}

	// example sentences — full sentences first: they show the word in use, which is what a learner
	// reads the sense for. The tighter collocation list follows below, separated by a hairline rule
	// (.rich-examples + .rich-collocs).
	function richExamplesHtml(s, r) {
		if (!s.examples || !s.examples.length) { return ''; }
		var h = '<div class="rich-examples">';
		for (var e = 0; e < s.examples.length; e++) {
			var ex = s.examples[e];
			h += '<div class="rich-example"' + phraseRowAttrs("example", ex.id) + '>'
			   + phraseGutter(ex.id)
			   + '<div class="rich-phrase-body">'
			   +   '<div class="rich-example-term">' + tokenizeTermWords(ex.term, r.term) + '</div>'
			   // Omitted, not blank: on a MONOLINGUAL pair the server now keeps examples that
			   // carry no paraphrase (EN→EN writes one only for an idiomatic sentence), and an
			   // empty .rich-example-def would still take its line box and its margin. Same shape
			   // as the .literal row below it.
			   +   (ex.definition ? '<div class="rich-example-def">' + escHtml(ex.definition) + '</div>' : '')
			   +   (ex.literal ? '<div class="rich-example-lit">' + escHtml(ex.literal) + '</div>' : '')
			   + '</div>'
			   + '</div>';
		}
		return h + '</div>';
	}

	// A topic's localized name, keyed the way Topic.messageKey() spells it server-side:
	// TRAVEL -> topic_travel_label. The BADGE is never localized — it is part of the topic's
	// identity and rides along with the data (TopicChipDto). Module-level rather than inside the
	// Word Lists panel, which is where it started: the rich card's chips and the panel's picker
	// must name a topic identically, and one function is the only way to guarantee that.
	function topicName(key) {
		return getRes("topic_" + String(key || "").toLowerCase() + "_label");
	}

	// Open the Word Lists panel's 🗂️ Topics row on one topic. The panel owns the whole surface, so
	// this is only the bridge to it — a no-op for a language pair whose dictionary carries no tags
	// (no Topics row exists, and the chip that called this could not have been rendered either).
	// The left pane can be rail-collapsed independently of the panel's own contents (PaneLayout,
	// the resizable-pane chevron) — a chip click is a request to SEE the topic, so a collapsed rail
	// expands first; showTopic then runs against the now-visible panel exactly as it always did.
	function openTopicWordList(key) {
		if (!key || !settings || !settings.myListPanel || !settings.myListPanel.showTopic) {
			return;
		}
		if (PaneLayout.state.leftCollapsed) {
			PaneLayout.toggle(PaneLayout.SIDE.left);
		}
		settings.myListPanel.showTopic(key);
	}

	// The topic chip's hover content: the bold name the icon-only lean chip no longer shows
	// (2026-08-06) plus a hint that it's a click-through, not just a label. Built fresh per hover
	// rather than baked into a resource key — topicName() is the one place the badge's key resolves
	// to its localized name, and this must never drift from the rich card's own chips or the Topics
	// picker's.
	function topicChipTooltipHtml(key) {
		return "<b>" + escHtml(topicName(key)) + "</b><br><br>" + escHtml(getRes("richTopicHint_tooltip"));
	}

	// Topic chips — thematic tags (docs/project/topic-word-lists.md), badge + localized name.
	// PER SENSE, not per word: das Gericht is 🍽️ on the dish sense and ⚖️ on the court one, and
	// rolling that up to the headword would lose exactly the distinction the tags are stored at
	// sense level to keep — every caller passes ONE sense's own `topics` array (rich card:
	// `s.topics`; dictionary lean row: `sg.topics`, restored to DefinitionDto.SenseGroup 2026-08-05
	// for exactly this). Each chip opens the Topics list at that topic (wired in renderRichEntry /
	// wireEntryEvents).
	//
	// `clickable` is false in the exercise reveal, where the card is rendered with the Word Lists
	// panel HIDDEN (the drill is full-focus): the topics are still worth reading there, but a chip
	// that opens a list nobody can see is a dead affordance, so it renders as a plain label.
	//
	// `lean` marks the dictionary-row/tray call (the only caller that passes it): same hue, a much
	// quieter face (rich-topic-chip-lean, styled in rich-dictionary.css) — the rich card is one tag
	// per sense on a roomy line, a lean row is one tag competing with the translation next to it.
	function topicChipsHtml(topics, clickable, lean) {
		if (!topics || !topics.length) { return ''; }
		var cls = "pl-chip-sm rich-topic-chip" + (lean ? " rich-topic-chip-lean" : "");
		var out = [];
		for (var t = 0; t < topics.length; t++) {
			var tp = topics[t];
			var body = '<span class="rich-topic-badge">' + escHtml(tp.badge) + '</span>'
			         + '<span class="rich-topic-name">' + escHtml(topicName(tp.key)) + '</span>';
			out.push(clickable
				? '<button type="button" class="' + cls + '" data-topic="'
					+ escHtml(tp.key) + '">' + body + '</button>'
				: '<span class="' + cls + ' rich-topic-chip-inert">' + body + '</span>');
		}
		// Floated as one group so the chips pin to the row's right edge regardless of how much (or
		// little) room the translations/grammar chips to its left take up.
		return '<span class="rich-sense-topics">' + out.join(' ') + '</span>';
	}

	// collocations — each row gets a left gutter (sound button) and the whole DE phrase is
	// pronounceable / highlighted on row hover (see phrase-sound section).
	function richCollocsHtml(s, r) {
		if (!s.collocations || !s.collocations.length) { return ''; }
		var h = '<div class="rich-collocs">';
		for (var c = 0; c < s.collocations.length; c++) {
			var col = s.collocations[c];
			h += '<div class="rich-colloc"' + phraseRowAttrs("colloc", col.id) + '>'
			   + phraseGutter(col.id)
			   + '<div class="rich-phrase-body">'
			   +   '<span class="rich-colloc-term">' + tokenizeTermWords(col.term, r.term) + '</span>'
			   // Same monolingual tolerance as the example row above. EN→EN paraphrases every
			   // collocation (1:1 by design), so this is a guard rather than an expected state.
			   +   (col.definition ? '<span class="rich-colloc-def">' + escHtml(col.definition) + '</span>' : '')
			   +   (showCollocLiteral(col) ? '<span class="rich-colloc-lit">' + escHtml(col.literal) + '</span>' : '')
			   + '</div>'
			   + '</div>';
		}
		return h + '</div>';
	}

	// Phrase rows behave the same wherever they are rendered: the gutter sound button pronounces the
	// whole DE phrase, the gutter add button files it in the ACTIVE WORD LIST as a drillable phrase
	// Term (same destination as the card head's add-to-list — the rich card sends everything to the
	// list, and nothing on it goes straight to a tray), and every phrase in view is warmed in the
	// background so a later click is usually instant (ElevenLabs generates on
	// first request; cached keys skip the network, so re-renders are free). Bound per render, scoped
	// to $root — the rich card in dictionary mode, the treatment panel in the Struggling band.
	function wireRichPhraseRows($root) {
		// Both gutter buttons carried a native title= until PR 7/7. ONE instance per button
		// kind for the whole card (attach takes the collection and anchors to whichever button
		// is hovered), bound per render like every other tooltip on this card.
		$root.find(".phrase-sound-btn").assignTooltip("sound_tooltip");
		$root.find(".phrase-mic-btn").assignTooltip("pronMic_tooltip");
		$root.find(".phrase-add-btn").each(function () { wlAddWirePhraseBtn($(this)); });
		$root.find(".phrase-tray-line ._trayLearnClass").assignTooltip("trayAddLearn_tooltip");
		$root.find(".phrase-tray-line ._trayPracticeClass").assignTooltip("trayAddPractice_tooltip");
		// The gutter microphone: the SAME popup, with a longer reference. A collocation or an
		// example sentence is assessable exactly like a word — the provider takes text, not a
		// recording — and being sentence-shaped it additionally earns fluency and completeness,
		// which is why the popup shows those dimensions here and not on a headword.
		$root.on("click", ".phrase-mic-btn", function (e) {
			e.stopPropagation();
			var row = $(this).closest("[data-phrase-id]");
			var kind = phraseKindOf(row.attr("data-phrase-kind"));
			var id = +row.attr("data-phrase-id");
			if (!kind || !id) { return; }
			PRONOUNCE.open(this, {
				phraseKind: kind, phraseRefId: id,
				text: row.find(".rich-colloc-term, .rich-example-term").first().text().trim()
			});
		});
		$root.on("click", ".phrase-sound-btn", function (e) {
			e.stopPropagation();
			var row = $(this).closest("[data-phrase-id]");
			var kind = row.attr("data-phrase-kind");
			var id = row.attr("data-phrase-id");
			if (kind && id) {
				playPhraseSound(kind, id, this);
			}
		});
		// One-press tray buttons (Placement D) — materialize the phrase into a drillable term
		// first (the same lazy step addPhrasesToDrill's confirm does, one phrase instead of a kept
		// list), then stage that one term. The fly fires at the click (T4), optimistically, same as
		// every other add on this card — it doesn't wait for the round trip below.
		$root.on("click", ".phrase-tray-line ._trayLearnClass, .phrase-tray-line ._trayPracticeClass",
			function (e) {
				e.stopPropagation();
				var toLearn = $(this).hasClass("_trayLearnClass");
				var row = $(this).closest("[data-phrase-id]");
				var kind = row.attr("data-phrase-kind");
				var id = row.attr("data-phrase-id");
				if (!kind || !id) { return; }
				if (settings.myListPanel && settings.myListPanel.isAddDisabled()) { return; }
				flyToTrayTab(row.find(".rich-colloc-term, .rich-example-term").first(), toLearn);
				ajaxPost("api/phrase/to-drill", {
					collocIds: kind === "colloc" ? [id] : [],
					exampleIds: kind === "example" ? [id] : [],
					defLang: langFromValField.attr("data-lang-code")
				}, function (data) {
					var ids = (data && data.termIds) || [];
					if (!ids.length) { return; }
					if (toLearn) { addWordsToLearning(ids, false, true); } else { addWordsToPractice(ids, false, true); }
				}, getRes("operationCannotComplete_message"));
			});
		// The add button opens its list picker instead of filing (wlAddWirePhraseBtn) — the phrase
		// goes wherever the picked row says, so there is no plain click-to-add path here.
		var phraseRows = [];
		$root.find("[data-phrase-id]").each(function () {
			phraseRows.push({ kind: $(this).attr("data-phrase-kind"), id: $(this).attr("data-phrase-id") });
		});
		if (phraseRows.length) {
			preloadPhraseSounds(phraseRows);
		}
	}

	// `opts.focusVerb` says the reader arrived by clicking a VERB (the Verbs list, or a Learn card
	// studied through its head verb), so the card lands on the verb's forms — the paradigm panel
	// opens and the principal parts are marked. See the block near the end of the wiring for why
	// the panel is opened AFTER the handlers rather than baked into renderConjugationTable.
	// `opts.conjHighlight` is the finer-grained version of the same thing: ONE paradigm cell to mark,
	// for a card opened on behalf of a single conjugated form. `opts.fromForm` names that form under
	// the headword. All three are set for us by fetchRichEntryToShow; Learn's session cards pass the
	// first two directly, having resolved the head verb server-side.
	function renderRichEntry(r, $container, onTermClick, opts) {
		var h = '<div class="rich-card">';

		// header: article, headword, IPA and then the growth plant, all reading left to right —
		// a word's state belongs next to the word, not across the card. The two action buttons
		// (sound, add-to-list) still float top-right. The plant is "lg", the app's one roomy
		// plant size, which is also what the row hover peek magnifies to — so a word looks the
		// same wherever you inspect it properly.
		h += '<div class="rich-head">';
		// EVERY entry carries a speaker, form-set cards included. They used to be the one exception:
		// SoundService refused to synthesize them, so the button was omitted rather than rendered
		// dead. That refusal is gone (2026-08-05) — a paradigm is learned by reciting it, so the
		// clip earns its keep — and the button came back with it, on the same branch-free path as
		// every other word.
		h += '<button class="ai-sound-btn" id="richSoundBtnId">'
		   + '<span class="pl-ic pl-ic-volume"></span></button>';
		// The microphone stands between Add and Sound — the decided order everywhere is
		// Add · Mic · Sound (ai-features-plan.md §1 decision 1). All three FLOAT RIGHT, so source
		// order is the reverse of reading order: emitted sound, mic, add ⇒ read add, mic, sound.
		h += '<button type="button" class="pl-btn-toggle pronMicClass pronMicLgClass"'
		   + ' id="richMicBtnId" aria-pressed="false">'
		   + '<span class="pl-ic pl-ic-mic"></span></button>';
		h += '<button class="ai-wl-add" id="richWlAddId">'
		   + '<span class="pl-ic pl-ic-list-plus"></span></button>';
		// One-press tray buttons (tray-add-buttons.md decision 6, Placement B), LEFT of add-to-list.
		// All five buttons float right, so source order is reversed reading order (see the add/mic/
		// sound comment above) — practice (💧) then learn (🌱) here reads 🌱 💧 add mic sound.
		// This answers the 2026-08-02 note below: a tray-staging button was pulled from here because
		// it looked like add-to-list with a different destination and nothing on the card said so.
		// These two name their destination with the tab strip's own colored icons, so the ambiguity
		// that removal fixed doesn't reopen.
		h += '<button type="button" class="ai-wl-add _trayPracticeClass" id="richTrayPracticeId">'
		   + GARDEN.markIcon("water") + '</button>';
		h += '<button type="button" class="ai-wl-add _trayLearnClass" id="richTrayLearnId">'
		   + GARDEN.markIcon("sprout") + '</button>';
		// NO "drill it in phrases" button here (removed 2026-08-02). It sat beside add-to-list and
		// read as its neighbour, but the two went to different places: add-to-list files the word in
		// the active WORD LIST, while the picker staged phrases in the Learn/Practice TRAY. Two adds
		// side by side, same verb, different destination, nothing on either saying so. The control
		// now lives only where it answers a question the user is actually asking — on a Difficult
		// words row, where meeting a hard word inside real sentences is the band's whole point.
		if (r.article) h += '<span class="rich-article">' + escHtml(r.article) + '</span> ';
		// A MULTI-word head — a phrase, an example sentence in the tray, a separable-verb combo — is
		// flagged OUTSIDE the dictionary, because there it is not one word: each token in it is a
		// different word with its own entry, and a Learn/exercise card offers no other way into them.
		// In the DICTIONARY the head is ONE collapse target whatever its word count (owner report
		// 2026-08-07): that card is a history step, so the head's job is "close this view" — the same
		// gesture a one-word head has always had, and the same one its tooltip promises. A word of the
		// phrase is still one click away in the senses, examples and collocations below.
		// Both the click handler below and the CSS read this flag, so the affordance and the behaviour
		// stay one decision.
		h += '<span class="rich-term' + (onTermClick && termWordCount(r.term) > 1 ? ' rich-term-words' : '') + '">'
		   + tokenizeTermWords(r.term) + '</span>';
		// Strip any enclosing / / or [ ] the source may carry, so we never render //double//.
		// Multi-word heads: collapse any INTERNAL per-word slashes too — a phrase always
		// reads as one enclosing pair, /a b c/ (same rule as the lean list).
		function headerIpa(raw) {
			if (!raw) return '';
			var ipa = String(raw).trim().replace(/^[\/\[]+/, '').replace(/[\/\]]+$/, '');
			if (r.term && r.term.indexOf(' ') !== -1) {
				ipa = ipa.replace(/[\/\[\]]/g, ' ').replace(/\s+/g, ' ').trim();
			}
			return ipa;
		}
		var ipaUs = headerIpa(r.transcription);
		var ipaUk = headerIpa(r.transcriptionUk);
		if (ipaUs && ipaUk && ipaUk !== ipaUs) {
			// EN head whose stored BrE form genuinely differs (tomato, schedule): a lone
			// transcription silently claims to be THE pronunciation — which the entries' own
			// usage notes contradict. Both spans keep .rich-ipa, so the pronunciation-trigger
			// binding below covers them without change. data-dialect makes each chip speak
			// with ITS dialect's voice (the click binding passes it to playAiSound).
			h += ' <span class="rich-ipa" data-dialect="US"><span class="rich-ipa-dialect">US</span>/'
			   + escHtml(ipaUs) + '/</span>'
			   + ' <span class="rich-ipa" data-dialect="UK"><span class="rich-ipa-dialect">UK</span>/'
			   + escHtml(ipaUk) + '/</span>';
		} else if (ipaUs || ipaUk) {
			// A head with ONLY a British transcription: the chip SHOWS BrE, so it speaks BrE too —
			// same data-dialect contract as the dual chips above. A US-or-identical transcription
			// stays dialect-less and keeps the language's default voice.
			h += ' <span class="rich-ipa"' + (!ipaUs && ipaUk ? ' data-dialect="UK"' : '') + '>/'
			   + escHtml(ipaUs || ipaUk) + '/</span>';
		}
		// Band chip — term-level metadata like the IPA, so it lives on the header line, not among
		// the sense-level grammar chips. Resolved server-side per language pair: a label-driven
		// language (EN) answers the term's stored CEFR slot ("A1".."C2P"), a rank-window one the
		// legacy letter ("A".."E"); absent on unranked heads (phrases) and while the band registry
		// is still building after a restart. Label + tooltip are the level lists' own resources,
		// so the band speaks with one voice app-wide. Since C2 of the CEFR chain the chip is a
		// DOOR: click opens that band's word list scrolled to this word — the objection that a
		// list "opened at its top says less than the chip" fell with the scroll-to-word.
		// The per-band class carries the CEFR shade ramp (rich-dictionary.css); legacy letters
		// have no such rule and keep the quiet outlined face.
		if (r.level) {
			h += ' <span class="pl-chip-sm rich-level rich-level-' + escHtml(r.level)
			   + '" role="button" tabindex="0">'
			   + escHtml(getRes("wlLevel" + r.level + "_label")) + '</span>';
		}
		// The head's plant, and — via the word's own text — a door into its statistics
		// (garden.js's click delegate). Same door the lean row below carries.
		h += GARDEN.slot(r.termId, "lg", r.term);
		h += '</div>';

		// base (citation) form — shown only when the looked-up word is an inflected form;
		// clickable to open the lemma's own entry (drill-in link).
		if (r.lemma && r.lemma !== r.term) {
			// data-head-term-id names THIS card's term as the container for the lemma token inside
			// (noteTermWordContext reads it). The lemma stands alone rather than inside a sentence,
			// so it has no [data-phrase-id] row to inherit — without this the click would arrive as
			// an unverifiable trusted=true and be gated like a typed word.
			h += '<div class="rich-lemma" data-head-term-id="' + (r.termId != null ? r.termId : '')
			   + '"><span class="rich-lemma-label">base form</span> '
			   + tokenizeTermWords(r.lemma) + '</div>';
		}

		// The opposite number of that line: the inflected FORM this card was opened for, when the card
		// is the head verb standing in for it (fetchRichEntryToShow). Without it the headword silently
		// answers a different word than the one that was clicked; with it the swap is stated, and the
		// marked paradigm cell below has something to be the answer TO. Plain text, not a drill-in
		// token — clicking it would only land back on this same card.
		if (opts && opts.fromForm) {
			h += '<div class="rich-lemma rich-from-form"><span class="rich-lemma-label">form</span> '
			   + escHtml(opts.fromForm) + '</div>';
		}

		// The word-form explanation block (word-form-entries PR 3): the clicked form's OWN stored
		// translation plus its per-kind template line, sitting above the head's card that follows.
		// Only when the card is a head standing in for a thin form row (opts.wordForm), and built
		// from the form's own entry — the head's card knows nothing about the form.
		if (opts && opts.wordForm && opts.formEntry) {
			var wfTr = firstSenseTranslations(opts.formEntry);
			var wfLine = wordFormLine(opts.formEntry);
			// ⛔ The FORM's own usage note, and it has to be read off opts.formEntry rather than
			// off `r`: `r` is the HEAD's card standing in for the form, so a note stored on the
			// form row would never reach the ".rich-usage" block below however it was written.
			// That gap is why `its` warned about `it's` while looking up `it's` itself showed
			// nothing — on the highest-frequency confusions in English (en-en-full-run-plan #9).
			var wfUsage = opts.formEntry.usageNote;
			if (wfTr || wfLine || wfUsage) {
				h += '<div class="rich-form-explain">'
				   + (wfTr ? '<span class="rich-form-explain-tr">' + escHtml(wfTr) + '</span>' : '')
				   + (wfLine ? '<span class="rich-form-explain-note">' + escHtml(wfLine) + '</span>' : '')
				   + (wfUsage ? '<span class="rich-form-explain-usage">' + escHtml(wfUsage) + '</span>' : '')
				   + '</div>';
			}
		}

		// Homograph twin readings (0072): the lemma card names its form twin(s) — «rose»: the
		// flower entry, plus "также прош. вр. от rise". The head is a real drill-in token.
		if (r.formTwins && r.formTwins.length) {
			for (var tw = 0; tw < r.formTwins.length; tw++) {
				var twin = r.formTwins[tw];
				h += '<div class="rich-lemma rich-twin-reading"><span class="rich-lemma-label">'
				   + twinAlsoLabel(r.defLanguageCode) + '</span> '
				   + escHtml(wordFormKindPrefix(twin.formKind, r.defLanguageCode, twin.headTerm, r.languageCode))
				   + tokenizeTermWords(twin.headTerm)
				   + (twin.translation ? ' <span class="rich-twin-tr">— ' + escHtml(twin.translation) + '</span>' : '')
				   + '</div>';
			}
		}

		// The word-level usage note and the false-friends warning. Built here, EMITTED inside the first
		// sense right after its translation and gloss (R5, docs/project/first-run-redesign.md: the entry
		// reads translation-first — header line, then the meaning as the largest line, then the note,
		// then the grammar). They used to stand between the header and the first sense, which put the
		// meaning fifth to seventh on the card — under a five-line note at 1366×768 it was below the
		// fold of the Learn meet card. An entry with no senses still gets them, under the header.
		var wordNotes = (r.usageNote ? '<div class="rich-usage">' + escHtml(r.usageNote) + '</div>' : '')
			+ richFalseFriendsHtml(r);
		if (!r.senses || !r.senses.length) { h += wordNotes; }

		// senses
		var verbParticiple = '';   // the verb's participle (from the first sense that has one); reused
		                           // to spell out the perfect on a later sense that owns no forms.
		for (var i = 0; i < r.senses.length; i++) {
			var s = r.senses[i];
			// The sense a reader who clicked a VERB came for: the one carrying the verb's forms — the
			// paradigm grid on a German entry, the principal-parts chip on an English one. Tagged here
			// rather than looked up afterwards, because this is where "owns the forms" is decided (the
			// chip a few lines down is built from exactly these fields). `auxiliary` is deliberately
			// NOT among them: a sense that carries only that renders the spelled-out perfect, which is
			// the verb's forms restated, not the forms themselves.
			var ownsVerbForms = s.pos === 'verb'
				&& !!(s.present3sg || s.preterite || s.participle || (s.conjugation && s.conjugation.length));
			h += '<div class="rich-sense' + (i === 0 ? ' rich-sense-first' : '') + (ownsVerbForms ? ' rich-verb-sense' : '') + '">';
			// R5 — a sense reads translation-first: the translations, the gloss and its region line lead
			// (`st`), the first sense then carries the word-level notes, and only then the grammar row,
			// the forms and the paradigm (`sg`, built first because the verb-participle bookkeeping below
			// runs in this order), followed by syn / ant / note / examples / collocations as before.
			var sg = '';

			// sense header line: number · pos · grammar chips · gloss. Built as an array and joined
			// with real spaces so a copy/paste reads "verb of a device…" rather than "verbof a device…"
			// (the chips are otherwise only margin-separated, which copy ignores).
			var chips = ['<span class="pl-num-badge">' + (i + 1) + '</span>'];
			// `provisional` is not a part of speech — it is the marker ProvisionalSenseService puts
			// on the placeholder sense of a word still being enriched (B4). The card shows that
			// sense's translation and says what is happening in its own strip; printing the marker
			// as a pos chip would put an internal word on screen in every language.
			if (s.pos && s.pos !== 'provisional') chips.push('<span class="rich-pos">' + escHtml(s.pos) + '</span>');
			// Heteronym sense whose pronunciation deviates from the header IPA (übersetzen:
			// ferry vs translate, 0038): a clickable per-sense /IPA/ chip. The header keeps
			// the term's primary transcription.
			if (s.ipa && r.transcription && s.ipa !== r.transcription) {
				chips.push('<span class="rich-sense-ipa" data-ipa-variant-id="' + s.ipaVariantId + '">/'
				   + escHtml(s.ipa) + '/</span>');
			}
			// Verb class (regular/irregular) belongs to the lemma's conjugation, which is filled on
			// the verb's FIRST sense only (a later sense carries it again ONLY when it genuinely
			// conjugates differently, e.g. hängen). Show the chip only on a sense that actually owns
			// principal parts — otherwise a stray `irregular=false` the model left on a later sense
			// renders a bogus "regular" tag.
			var ownsConjugation = s.present3sg || s.preterite || s.participle || s.auxiliary;
			if (s.pos === 'verb' && s.irregular != null && ownsConjugation) {
				var vc = s.irregular ? 'irregular' : 'regular';
				chips.push('<span class="pl-chip rich-verbclass-' + vc + '">' + vc + '</span>');
			}
			if (s.pos === 'verb' && s.separable) {
				chips.push('<span class="pl-chip rich-separable">separable</span>');
			}
			if (s.reflexiveCase) {
				var rc = s.reflexiveCase === 'A' ? 'reflexive · sich (Akk)'
				       : s.reflexiveCase === 'D' ? 'reflexive · sich (Dat)' : 'reflexive';
				chips.push('<span class="pl-chip rich-reflexive">' + rc + '</span>');
			}
			// The SERVER's face wins where it has one (rule F9, FormPacks.cardFaceArticle): the
			// table below cannot answer `el agua`, because that article is phonological — a
			// feminine noun opening on a stressed /a/ — and the phonology is not in this scope.
			// ⛔ Without this line the dictionary chip would read `la agua` on the same screen the
			// drill asks for `el agua`. German has no server face and keeps the table.
			var art = s.article || genderArticle(s.gender, r.languageCode);
			if (art) chips.push('<span class="pl-chip rich-gender-' + escHtml(s.gender) + '">' + art + '</span>');
			if (s.plural) chips.push('<span class="rich-plural">pl. ' + escHtml(s.plural) + '</span>');
			if (s.genitive) chips.push('<span class="rich-genitive">gen. ' + escHtml(s.genitive) + '</span>');
			if (s.governedCase) {
				var caseLabel = s.governedCase === 'two-way' ? 'two-way (acc/dat)' : '+ ' + s.governedCase;
				chips.push('<span class="pl-chip-sm rich-case">' + escHtml(caseLabel) + '</span>');
			}
			// S4: the two splits that ARE the Spanish sense. `ser aburrido` is boring and `estar
			// aburrido` is bored; `un gran hombre` is a great man and `un hombre grande` a big one —
			// one adjective, two senses, and nothing else on the card tells them apart.
			// ⛔ `ambos` and `either` are the "no distinction here" answers and are NOT rendered: they
			// would put a chip on 5,146 senses saying only that this axis is not the point, which is
			// the rule the register chip has always followed for `neutral`.
			var copulaLabel = s.copula === 'ambos' ? '' : codeLabel('senseCopula', s.copula);
			if (copulaLabel) {
				chips.push('<span class="pl-chip-sm rich-copula">' + escHtml(copulaLabel) + '</span>');
			}
			var positionLabel = s.position === 'either' ? '' : codeLabel('sensePosition', s.position);
			if (positionLabel) {
				chips.push('<span class="pl-chip-sm rich-position">' + escHtml(positionLabel) + '</span>');
			}
			if (s.government && s.government.length) {
				for (var gi = 0; gi < s.government.length; gi++) {
					var gov = s.government[gi];
					var gc = gov.grammaticalCase;
					// A caseless frame is normal outside German (English: "depend on") — render the
					// bare preposition rather than a dangling "+ null". See changeset 0062.
					var ca = gc === 'accusative' ? 'Akk' : gc === 'dative' ? 'Dat' : gc === 'genitive' ? 'Gen' : gc;
					// S4: Spanish has no case, so a frame's SHAPE is `construction` — and seven of its
					// eleven values name a complement with no preposition either (`gustar` binds a dative
					// experiencer, `poder` a bare infinitive), which is why this chip rendered EMPTY on most
					// Spanish senses. ⭐ The same two values say two different things: on a verb `que_subj`
					// is a `que`-clause (`querer que venga`); on a CONJUNCTION the conjunction is itself the
					// link, so `cuando` must read `+ subjunctive` and never `que + subjunctive`.
					var moodOnly = s.pos === 'conjunction'
					   && (gov.construction === 'que_ind' || gov.construction === 'que_subj');
					var shape = moodOnly
					   ? codeLabel('senseMood', gov.construction === 'que_ind' ? 'ind' : 'subj')
					   : codeLabel('senseConstruction', gov.construction);
					var govRegion = codeLabel('senseRegion', gov.regionCode);
					var govText = [escHtml(gov.preposition), (ca ? '+' + escHtml(ca) : ''), escHtml(shape)]
					   .filter(function (x) { return x; }).join(' ');
					if (!govText) { continue; }   // nothing to say — never ship an empty pill
					chips.push('<span class="pl-chip-sm rich-govern">' + govText
					   + (govRegion ? '<span class="rich-govern-region">' + escHtml(govRegion) + '</span>' : '')
					   + (gov.gloss ? '<span class="rich-govern-gloss">' + escHtml(gov.gloss) + '</span>' : '')
					   + '</span>');
				}
			}
			if (s.register && s.register !== 'neutral') {
				chips.push('<span class="pl-chip-sm rich-register">' + escHtml(s.register) + '</span>');
			}
			// Topic chips float to the right of the same row — the sense head has the room, and it
			// keeps them anchored to the one sense they describe (see topicChipsHtml). Emitted FIRST
			// so the float claims the row's right edge before the grammar chips fill in from the left.
			sg += '<div class="rich-sense-head">' + topicChipsHtml(s.topics, !onTermClick) + chips.join(' ') + '</div>';

			// verb principal parts (conjugation chip): present 3sg · preterite · ist/hat participle
			// …except in Spanish, which recites four different cells off the paradigm — esPrincipalParts.
			var auxFinite = s.auxiliary === 'sein' ? 'ist' : (s.auxiliary === 'haben' ? 'hat' : '');
			var forms = [];
			if (String(r.languageCode || '').toUpperCase() === 'ES') {
				forms = esPrincipalParts(s);
				if (s.participle && !verbParticiple) verbParticiple = escHtml(stripBraces(s.participle));
			} else {
				if (s.present3sg) forms.push(escHtml(stripBraces(s.present3sg)));
				if (s.preterite)  forms.push(escHtml(stripBraces(s.preterite)));
				if (s.participle) {
					var partHtml = escHtml(stripBraces(s.participle));
					if (!verbParticiple) verbParticiple = partHtml;
					forms.push((auxFinite ? '<span class="rich-aux">' + auxFinite + '</span> ' : '')
					   + partHtml);
				}
			}
			if (forms.length) {
				sg += '<div class="rich-forms">' + forms.join(' <span class="rich-form-sep"></span> ') + '</div>';
			} else if (auxFinite) {
				// No principal parts of its own — spell out the perfect (auxiliary + the verb's
				// participle), e.g. "Perfekt: ist gegangen", instead of a cryptic "(hat)"; a tooltip
				// explains it (rich_perfect_tooltip, put on PL.tip where the card is wired — it was
				// a native title= until PR 7/7). Falls back to the bare auxiliary if no participle.
				var perfForm = escHtml(auxFinite) + (verbParticiple ? ' ' + verbParticiple : '');
				sg += '<div class="rich-forms"><span class="rich-perfect">'
				   + '<span class="rich-perfect-label">Perfekt:</span> ' + perfForm + '</span></div>';
			}

			// Rule F7's class line, BETWEEN the principal parts and the conjugation summary — the
			// one place it is read without a click. It was first rendered inside the panel, which a
			// screenshot showed for what it was: the panel is a <details> and it opens CLOSED, so
			// the line explaining the highlight was itself hidden behind the same disclosure as the
			// highlight. Empty for every non-verb, every regular verb and every language but
			// Spanish, so no language gate is needed here.
			sg += esVerbClassLine(s);

			// full conjugation paradigm — a proper grid: persons (rows) × tenses (columns), collapsed
			// by default (native <details>). Tense headers are in the term language (German), with the
			// learner-language name as a hover tooltip from the resource bundle. Each cell already bakes
			// in the subject pronoun ("ich bin gegangen"); we strip it for display (the row label carries
			// it) but keep the FULL form in data-combo — that whole combination is what a hover popup
			// translates, pronounces and adds to the drill list. See conjugationCombo* handlers.
			if (s.conjugation && s.conjugation.length) {
				sg += renderConjugationTable(s.conjugation, r.languageCode, r, s);
			}

			// adjective/adverb comparison: comparative · am …sten superlative
			if (s.comparative || s.superlative) {
				var cmp = [];
				if (s.comparative) cmp.push(escHtml(s.comparative));
				if (s.superlative) cmp.push(escHtml(s.superlative));
				sg += '<div class="rich-forms rich-compare">' + cmp.join(' <span class="rich-form-sep"></span> ') + '</div>';
			}

			// translations — separated by a middot that is a CSS pseudo-element (NOT copied), flanked
			// by real spaces so a copy/paste of the line reads "to work to function to be possible"
			// (with spaces) rather than running the items together. They LEAD the sense (R5); the first
			// sense's line is the largest on the card (rich-dictionary.css .rich-sense-first).
			if (s.translations && s.translations.length) {
				h += '<div class="rich-trans">' + s.translations.map(function (t) {
					return '<span class="rich-trans-item">' + escHtml(t) + '</span>';
				}).join(' <span class="rich-trans-sep"></span> ') + '</div>';
			}

			// The sense gloss gets its own line directly under the translations it disambiguates,
			// bracketed so it reads as a parenthetical on the meaning above. It used to ride as the
			// last chip of the sense header, where it wrapped mid-phrase against the grammar chips
			// ("…colloquial to enter a room" / "or space") — which read as if its leading "to" were
			// missing. Brackets live in the text, not a ::before, so a copy/paste keeps them.
			if (s.gloss) {
				h += '<div class="rich-gloss">(' + escHtml(s.gloss) + ')</div>';
			}

			// S4: the sense's variety limits, under the gloss they qualify. Empty for the pan-Hispanic
			// majority and for every language but Spanish, so no language gate is needed here.
			h += senseRegionLine(s);

			// Under the meaning: the word's own notes (first sense only — they are about the whole word),
			// then this sense's grammar row, forms and paradigm (R5's order).
			if (i === 0) { h += wordNotes; }
			h += sg;

			// source-language synonyms — real space after the label + a pseudo-middot separator
			// flanked by real spaces, so copy/paste reads "syn funktionieren klappen".
			if (s.synonyms && s.synonyms.length) {
				h += '<div class="rich-syn"><span class="rich-label">syn</span> '
				   + s.synonyms.map(function (x) {
					return '<span class="rich-syn-item">' + tokenizeTermWords(x, r.term) + '</span>';
				}).join(' <span class="rich-syn-sep"></span> ') + '</div>';
			}

			// source-language antonyms
			if (s.antonyms && s.antonyms.length) {
				h += '<div class="rich-syn rich-ant"><span class="rich-label">ant</span> '
				   + s.antonyms.map(function (x) {
					return '<span class="rich-syn-item">' + tokenizeTermWords(x, r.term) + '</span>';
				}).join(' <span class="rich-syn-sep"></span> ') + '</div>';
			}

			// sense note
			if (s.senseNote) {
				h += '<div class="rich-sense-note">' + escHtml(s.senseNote) + '</div>';
			}

			h += richExamplesHtml(s, r);
			h += richCollocsHtml(s, r);

			h += '</div>'; // rich-sense
		}

		h += '</div>'; // rich-card

		var defArea = ($container && $container.length) ? $container : $("#defId");
		defArea.html(h);

		// Paint the garden stage plant into the header slot (a planted/Ready word only).
		GARDEN.decorate(defArea);

		// The headword toggles the current word rich⇄lean in place (no history). Every OTHER
		// term-language token is a drill-in link: it NAVIGATES to that word (re-centres + history step).
		// onTermClick lets a caller outside the dictionary (the exercise reveal) replace both branches.
		// The headword's OWN word (self-references inside collocations/examples) is rendered inert (no
		// .term-word) by tokenizeTermWords, so this only ever fires on the big headword or a real
		// drill-in token — never on a same-term self-reference that would just re-open this entry.
		//
		// "Headword" means the token acts as the whole head — every head in the dictionary, and only a
		// ONE-word head outside it. On a Learn/exercise card a multi-word head is not one word, so the
		// reason the head is special ("clicking it would only re-open the entry we're already on")
		// doesn't hold inside it: clicking "Anbieter" in "Welcher Anbieter ist bei euch am
		// günstigsten?" asks for a DIFFERENT word, and it drills in like any token in an example
		// (owner report 2026-08-06 — the Learn meet of a phrase left every German word dead). The
		// dictionary collapses on ANY head; see where .rich-term-words is set above.
		defArea.find(".rich-card").on("click", ".term-word", function (e) {
			e.stopPropagation();
			var $head = $(this).closest(".rich-term");
			var isHeadword = $head.length > 0 && !$head.hasClass("rich-term-words");
			var word = $(this).text().trim();
			noteTermWordContext(this);   // navigateTo loses the anchor; stash the sentence now
			if (onTermClick) {
				onTermClick(word, isHeadword);
				return;
			}
			if (isHeadword) {
				toggleCurrentWord();   // clicked the headword → collapse to lean in place
				return;
			}
			if (word) {
				navigateTo(word, true, true);   // a drill-in token → trusted, navigate-and-expand
			}
		});

		// A topic chip is a way INTO the topic, not just a label: it opens the Word Lists panel's
		// 🗂️ Topics row on that topic, the same list the picker opens. Cross-navigation from the
		// word you are reading to the situation it belongs to, in one click.
		defArea.find(".rich-card").on("click", ".rich-topic-chip", function (e) {
			e.stopPropagation();
			openTopicWordList($(this).attr("data-topic"));
		});
		// Per element via .each, NEVER on the collection (pos_label.js's wire() is the reference for
		// this): assignTooltip measures its anchor from the collection's FIRST element, and each chip
		// needs its OWN topic's name in the tip besides.
		defArea.find(".rich-topic-chip:not(.rich-topic-chip-inert)").each(function () {
			var key = $(this).attr("data-topic");
			$(this).assignTooltip(function () { return topicChipTooltipHtml(key); });
		});

		// Gutter sound + add-to-drill on every collocation / example row, and the background warm
		// for their audio. Shared with the Struggling band's elaboration panel.
		wireRichPhraseRows(defArea.find(".rich-card"));

		// "Perfekt: ist gegangen" — what that line IS. A native title= until PR 7/7.
		defArea.find(".rich-perfect").assignTooltip("rich_perfect_tooltip");

		// Rule F7's class line. The tooltip says what the HIGHLIGHT means — the line itself already
		// says what the class is, so restating it here would be a tooltip that teaches nothing.
		defArea.find(".rich-verb-class").assignTooltip("verb_class_tooltip");

		// The band chip answers "how common is this word?" with the level list's own tooltip
		// (the official CEFR descriptor on a label-driven language) — and, since the C2 switch,
		// it is a door: click opens that band's word list scrolled to this word. The door only
		// binds when the panel actually holds the band list (a pair mid-startup, or a stale
		// level code after a scheme flip, simply keeps an inert chip).
		if (r.level) {
			var levelChipEl = defArea.find(".rich-level");
			levelChipEl.assignTooltip("wlLevel" + r.level + "_tooltip");
			levelChipEl.on("click keydown", function (e) {
				if (e.type === "keydown" && e.which !== PL.keys.ENTER && e.which !== PL.keys.SPACE) {
					return;
				}
				e.preventDefault();
				e.stopPropagation();
				if (window.plWlPanel && plWlPanel.openLevelAtWord) {
					plWlPanel.openLevelAtWord(r.level, r.termId, r.term);
				}
			});
		}

		// When a conjugation panel is expanded, warm every combo (pronoun+form) in it in one batch
		// so hovering a form to translate / pronounce / add-to-drill is instant. `toggle` doesn't
		// bubble, so this is bound directly per render (the panel starts collapsed).
		defArea.find("details.rich-conj").on("toggle", function () {
			if (!this.open) {
				return;
			}
			// One form per cell — the cell's whole identity. This used to warm the per-pronoun
			// variants as well, which cost a translated Term for every "sie geht"/"es geht" that
			// nothing could ever drill.
			var forms = [];
			$(this).find(".rich-conj-cell[data-combo]").each(function () {
				forms.push(this.getAttribute("data-combo"));
			});
			if (forms.length) {
				preloadCombos(forms, r.term);
			}
		});

		// Arrived from the Verbs list, where the VERB is what the reader clicked for — so the card
		// answers with the verb's forms instead of asking for a second look. Two halves, because the
		// two languages keep those forms in different places:
		//   • the paradigm panel opens (German). Deliberately set AFTER the toggle handler is bound
		//     and NOT as an `open` attribute in renderConjugationTable: flipping the property queues
		//     a real toggle event, so the panel warms its combos through exactly the same path a
		//     hand-expand does, with no second warm call to keep in step. Silently a no-op for a
		//     language whose dictionary stores no paradigm — there is no details.rich-conj on those
		//     cards, which is the whole language gate that half needs.
		//   • the verb sense's principal parts are marked (both languages), which on English is the
		//     WHOLE answer — there is no grid there, the chip is the paradigm, and it can sit well
		//     below a first sense that has nothing to do with verbs ("bear" opens on the animal).
		// The scroll that brings a buried verb sense on screen belongs to the caller: only the caller
		// knows which band the card was rendered into (see verbSenseAnchor).
		if (opts && opts.focusVerb) {
			defArea.find("details.rich-conj").prop("open", true);
			defArea.find(".rich-verb-sense").first().children(".rich-forms").addClass("rich-forms-hit");
		}

		// The other half of the same intent: the ONE paradigm cell this card was opened for ("du
		// bekamst ab" → abbekommen's entry). Marked here rather than by each caller, so every surface
		// that opens a head verb for a form marks it identically, and AFTER the toggle handler above so
		// opening the panel warms its combos through the same path a hand-expand does.
		// Opening the panel is NOT conditional on finding the cell. highlightConjCell matches exactly on
		// data-combo and leaves the table plain rather than guessing when it misses — but the reader
		// asked to see this form in its paradigm, and a collapsed table answers that with nothing at
		// all. So a miss still expands the grid and lets them find the form by eye.
		// Arrived from the collocation search band: mark the ONE collocation row the signpost
		// pointed at, so the reader lands on the line they clicked rather than on a card that
		// merely contains it somewhere. Matched by TEXT (the band carries the collocation string,
		// not its id) against the row's own term span, which tokenizeTermWords leaves readable.
		// A miss simply leaves the card plain — the head entry is still the right answer.
		if (opts && opts.focusColloc) {
			var wanted = String(opts.focusColloc).trim();
			// Both phrase kinds since the band indexed examples (v2): the signpost may have been
			// an example sentence, and it lands on its own row exactly the same way.
			defArea.find(".rich-colloc-term, .rich-example-term").each(function () {
				if ($(this).text().trim() === wanted) {
					$(this).closest(".rich-colloc, .rich-example").addClass("rich-colloc-hit");
					return false;
				}
			});
		}

		if (opts && opts.conjHighlight) {
			if (!window.highlightConjCell(defArea, opts.conjHighlight)) {
				defArea.find("details.rich-conj").prop("open", true);
			}
		}

		// Headword tooltip: how to leave the rich view (click collapses; Esc/Back navigate away).
		// Dictionary mode only — in the exercise reveal (onTermClick set) the card isn't a history
		// step, so Esc / the browser's Back button would NOT just close it.
		if (!onTermClick) {
			defArea.find(".rich-term").assignTooltip("richTerm_tooltip");
		}

		var addBtn = $("#richWlAddId");
		if (addBtn.length && r.termId) {
			// Fly the transfer frame from the HEADWORD, hugging it — not from the whole head row
			// (owner call 2026-08-13). A frame the width of the row started as a band across the
			// card and read as the card moving; what is being filed is the word, so the word is
			// what flies. Falls back to the head row on an entry with no .rich-term to hug.
			var flySrc = function () {
				var head = defArea.find(".rich-head .rich-term").first();
				return head.length ? head : defArea.find(".rich-head").first();
			};
			// Hover or press raises the list picker; a row in it is what files the word. The same
			// one wiring call every other add control in the app gets (wlAddWire).
			wlAddWire(addBtn, {
				add: function (listId) { addTermToWordList(r.termId, flySrc(), listId); }
			});
			// One-press tray buttons (Placement B) — always a plain stage, never a picker, whatever
			// tab the card happens to be open on (a rich card in a Learn/Practice tray row is still
			// just a card, not the row itself — the MOVE semantics belong to the row, not this).
			$("#richTrayLearnId").assignTooltip("trayAddLearn_tooltip")
				.on("click", function (e) { e.stopPropagation(); trayStage(r.termId, true, flySrc()); });
			$("#richTrayPracticeId").assignTooltip("trayAddPractice_tooltip")
				.on("click", function (e) { e.stopPropagation(); trayStage(r.termId, false, flySrc()); });
		}
		var soundBtn = $("#richSoundBtnId");
		if (soundBtn.length && r.termId) {
			soundBtn.assignTooltip("sound_tooltip");
			soundBtn.click(function () { playAiSound(r.termId); });
		}
		// The practice microphone. Removed rather than left dead on a card with no term behind it
		// (a live translation of something not in the corpus): there is nothing to score against
		// and nothing to file the attempt on.
		var micBtn = $("#richMicBtnId");
		if (micBtn.length && r.termId) {
			micBtn.assignTooltip("pronMic_tooltip").on("click", function () {
				PRONOUNCE.open(this, {
					termId: r.termId, text: r.term, article: r.article,
					// ONLY the dialect in force — the popup is a practice screen, and showing both
					// transcriptions there would ask the learner to choose an accent mid-attempt
					// when they already chose one in the language panel (decision 3).
					ipa: dialectIpa(r),
					large: true
				});
			});
		} else {
			micBtn.remove();
		}
		// The IPA transcription doubles as a pronunciation trigger — semantically it IS the
		// pronunciation, and it's a bigger, more obvious click target than the small speaker icon.
		// Same in the lean rows (see buildEntryElement) and works in the exercise reveal too.
		// Which of the two transcriptions reads as the primary one. Here rather than in the html
		// above because every rich card in the app — dictionary, learn drill, exercise reveal —
		// comes through this one render, so the chosen dialect cannot be missed on one of them.
		applyEnDialectToIpa(defArea);
		if (r.termId) {
			defArea.find(".rich-ipa")
				.assignTooltip("sound_tooltip")
				.click(function () { playAiSound(r.termId, null, $(this).attr("data-dialect") || null); });
			// Per-sense heteronym chip: pronounce THAT variant.
			defArea.find(".rich-sense-ipa")
				.assignTooltip("sound_tooltip")
				.click(function (e) {
					e.stopPropagation();
					playAiSound(r.termId, +$(this).attr("data-ipa-variant-id") || null);
				});
		}
		richCardTermId = r.termId || null;   // Space target while this card is up
		// T-9 (docs/project/tablet-support-plan.md §4): extra header buttons. PL.richHeadExtra is
		// unset on a desktop; js/touch/entry.js sets it (R9: Park / × on a card opened from a
		// pre-exercise tray, whose row buttons touch hides). It gets the tray row this card stands
		// over: the in-place card, on a Learn/Practice tab, over the very list it was opened from
		// (a drill-in that re-seeked the dictionary under it fails the last test) — else null.
		if (PL.richHeadExtra) {
			PL.richHeadExtra(defArea, (isStagedTab() && practiceReturn && displayManager && expandedSlot
				&& defArea[0] === expandedSlot[0] && displayManager.getDefList() === practiceReturn.list)
				? expandedEntry : null);
		}
	}

	// training_session.js is a separate top-level script (not inside this closure), so it can't call
	// fetchRichEntry/renderRichEntry directly — this is its bridge in. Swaps the exercise box's plain
	// definition for the full rich card on a wrong/timed-out answer (the moment a richer look at the
	// word is most useful). Silently does nothing if there's no rich entry for the word yet (e.g. a
	// language pair without a rich dictionary) — the plain definition already there just stays put.
	var exerciseRichWord = null;         // the originally-revealed (missed) word — Esc's return target
	var exerciseDictExcursion = false;   // true while a drill-in click has swapped in the real dictionary

	function renderExerciseRichWord(word, container, onRendered) {
		fetchRichEntryToShow(word, true, function (data, xhr, mark) {
			// The next question may have started while this fetch was in flight (Enter right after
			// a miss, or a slow first lookup) — resetExerciseRichEntry nulls exerciseRichWord then,
			// and a late render here would stomp the live cue (in sound-only, with the answer).
			if (exerciseRichWord !== word) { return; }
			if (!xhr && data && data.senses && data.senses.length) {
				renderRichEntry(data, container, onExerciseTermClick, mark);
			} else {
				// No rich entry for this word (a drilled phrase, or a lookup that failed) — still reveal
				// the correct answer itself, so on a miss/timeout the central panel shows the DE term/
				// phrase, not the leftover translation prompt. Mirrors the rich card's own headword.
				container.html('<div class="rich-card"><div class="rich-head">'
					+ '<span class="rich-term">' + escHtml(word) + '</span></div></div>');
			}
			// This render REPLACES the container, so anything the caller had painted on the cue is
			// gone by now — the drill re-adds its replay speaker here, once it can see whether the
			// entry that landed already carries one of its own.
			if (onRendered) { onRendered(); }
		});
	}

	// A drill-in click jumps to the REAL dictionary (same navigateTo/richLookupCore path Practice-tab
	// browsing already uses — full loading state, AI-generate-on-demand, error handling — rather than
	// a silent, feedback-less re-render scoped to the exercise box, which just looked broken for any
	// word without a rich entry yet). #defExerciseId is swapped out for #defId for the duration; Esc
	// (or the next question starting) swaps back via exitExerciseDictExcursion(). Headword click is a
	// no-op — it's already the word being shown.
	function onExerciseTermClick(word, isHeadword) {
		if (isHeadword || !word) { return; }
		openExerciseDictExcursion(word);
	}

	// The excursion itself, without the headword guard — the reveal's own headword uses it directly
	// when it is the ONLY thing shown (the phrase branch below), where "already open" is not true.
	function openExerciseDictExcursion(word) {
		if (!word) { return; }
		exerciseDictExcursion = true;
		activeTab = 'dict';        // avoid openRichForCurrent's staged (Practice/Learn) practiceReturn capture
		practiceReturn = null;
		defExerciseBox.hide();
		defBox.show();
		sizeCenterBoxToPanel();
		navigateTo(word, true, true);
	}

	// Reverses onExerciseTermClick: drop whatever the dictionary excursion opened and restore the
	// exercise box. showOriginal re-renders the missed word's own card (Esc); omitted when a new
	// question is starting anyway (its own plain definition is already being set separately).
	function exitExerciseDictExcursion(showOriginal) {
		if (!exerciseDictExcursion) { return; }
		exerciseDictExcursion = false;
		collapseRich();
		richOpen = false;
		currentWord = null;
		practiceReturn = null;
		defBox.hide();
		defExerciseBox.show();
		sizeCenterBoxToPanel();
		if (showOriginal && exerciseRichWord) {
			renderExerciseRichWord(exerciseRichWord, $("#defExerciseId"));
		}
	}

	// `headword` (optional, phrases only) — what to show in the answer slot when it is not the whole
	// phrase. A gapped card asks for one word out of the sentence, so that word is the answer; the
	// sentence itself is revealed in place by the gap frame the caller has already rendered.
	// `hasStoredRich` (phrases only) — the drilled term carries stored senses, so its own rich entry
	// can be opened straight from the DB.
	// `onRendered` (optional) — fired once the reveal content is actually in the container. The word
	// branch is a round trip, and it REPLACES the container, so a caller that decorates the reveal
	// (the drill's replay speaker) has no other moment at which its work would survive.
	window.showExerciseRichEntry = function (word, container, isPhrase, headword, hasStoredRich, onRendered) {
		if (isPhrase) {
			// A drilled phrase/sentence is NOT a dictionary headword — never run a rich WORD lookup on
			// it OF OUR OWN ACCORD (the click below is the learner's, and gated). Doing so makes the AI
			// "analyze" the whole sentence into a bogus single-word entry (IPA, base form, verb
			// conjugation, synonyms — see the "Die Kinder haben sich…" mix-up).
			// Just reveal the answer itself as a headword above its translation, which is already in
			// the container. No dictionary word to restore on a later Esc, so clear exerciseRichWord.
			exerciseRichWord = null;
			var head = headword || word;
			container.prepend('<div class="rich-card"><div class="rich-head">'
				+ '<span class="rich-term">' + escHtml(head) + '</span></div></div>');
			// This branch shows the bare answer and nothing else — no senses, no examples, nothing to
			// read past the word itself. So the word doubles as the way in: clicking it opens the real
			// dictionary entry, the same excursion every other clicked token in a reveal takes, and Esc
			// walks back to the card. (In the rich branch below the entry is already on screen, which
			// is why the headword is inert there.)
			//
			// Offered only where the lookup is sound, on the same gate the prefetch uses. A gapped
			// card's headword is ONE word out of the sentence — an ordinary dictionary lookup, no
			// different from a drill-in click. A whole PHRASE is offered only when its senses are
			// already stored ("turn down" and ~2k other EN phrases have real entries): looking up an
			// un-stored one is exactly the bogus sentence-analysis the guard above refuses, and it
			// would buy a paid generation mid-drill.
			if (headword || hasStoredRich) {
				container.find(".rich-term").first()
					.addClass("_revealLookupClass")
					.assignTooltip("revealTerm_tooltip")
					.on("click", function () { openExerciseDictExcursion(head); });
			}
			if (onRendered) { onRendered(); }
			return;
		}
		exerciseRichWord = word;
		renderExerciseRichWord(word, container, onRendered);
	};

	window.resetExerciseRichEntry = function () {
		exitExerciseDictExcursion(false);
		exerciseRichWord = null;
	};

	// ── Rich-entry popup (garden-vista flowers) ───────────────────────────────────────────────
	// A standalone card shown OVER whatever page raised it — unlike the excursion machinery
	// above, it never swaps out defBox/defExerciseBox and never touches the Dictionary tab's
	// history. It is just another PL.layers entry, exactly like MSG's alert box, so Esc/outside-
	// click closes IT ALONE and reveals whatever was already open underneath: opened from the
	// garden vista (itself a PL.layers entry), the popup stacks on top of it, so one Esc returns
	// to the vista and a second Esc then closes the vista too — the same order the user drilled
	// in, with no separate history plumbing needed.
	//
	// The FULL garden view is the only surface left that raises it, and the reason is structural:
	// the vista is a modal covering the page, so a card rendered in the dictionary underneath it
	// would be unreachable. Everywhere the page itself is reachable — the finish screen's words
	// and its growth bed — a click now opens the real dictionary entry instead (exWordClick /
	// gardenNavigate, via the finish-screen excursion below).
	var richPopupLayer = null;

	window.openTermRichPopup = function (word) {
		if (richPopupLayer) { richPopupLayer.close("api"); }

		var $overlay = $('<div class="richPopupOverlayClass"></div>');
		var $card = $('<div class="richPopupCardClass" role="dialog" aria-modal="true"></div>');
		var $close = $('<button type="button" class="pl-btn-icon-round richPopupCloseClass" aria-label="Close">'
			+ '<span class="pl-ic pl-ic-x"></span></button>');
		var $body = $('<div class="richPopupBodyClass"></div>');
		$card.append($close).append($body);
		$overlay.append($card).appendTo(document.body);

		var focusToken = PL.focus.remember();
		var seq = 0;   // invalidates a stale fetch if a nested click drills to another word first
		var loadingTimer = null;
		var history = [];   // words drilled THROUGH to reach the current one; Esc unwinds one at a time

		function stopLoading() {
			if (loadingTimer) { clearInterval(loadingTimer); loadingTimer = null; }
		}

		// A drill-in click swaps the body for a fresh word, which can mean a live rich-translate
		// round trip. An already-generated entry usually answers within a beat, though — swapping
		// the card out to "Looking up…" and back for that split second reads as the popup
		// blinking, not loading. So the bar only paints if the fetch is STILL in flight after a
		// short grace period; a genuine live-AI round trip (seconds, not ms) still shows it.
		function renderWord(w) {
			var mySeq = ++seq;
			stopLoading();
			var showLoadingTimer = setTimeout(function () {
				if (mySeq !== seq) { return; }
				$body.html(loadingHtml());
				loadingTimer = startAsymptoticFill($body.find(".rich-loading-bar-fill"));
				$card.scrollTop(0);
			}, 150);
			fetchRichEntryToShow(w, true, function (data, xhr, mark) {
				if (mySeq !== seq) { return; }
				clearTimeout(showLoadingTimer);
				stopLoading();
				if (!xhr && data && data.senses && data.senses.length) {
					renderRichEntry(data, $body, function (term, isHeadword) {
						if (isHeadword || !term) { return; }
						history.push(w);   // remember where we drilled FROM; Esc unwinds this
						renderWord(term);   // drill in place — same popup, same Esc
					}, mark);
				} else {
					$body.html('<div class="rich-card"><div class="rich-head">'
						+ '<span class="rich-term">' + escHtml(w) + '</span></div></div>');
				}
				// A freshly rendered word always reads from its own top — never wherever the
				// previous word (or the loading bar) left the scroll position.
				$card.scrollTop(0);
			});
		}
		renderWord(word);

		richPopupLayer = PL.layers.push({
			el: $card[0],
			// Esc steps back one drilled word at a time before it closes the popup outright —
			// the same order the user drilled in, same as Esc then walking out to an underlying
			// vista once the history runs dry (see the comment above this function).
			onEsc: function () {
				if (!history.length) { return false; }
				renderWord(history.pop());
				return true;
			},
			onClose: function () {
				stopLoading();
				richPopupLayer = null;
				$overlay.remove();
				if (focusToken) { focusToken.restore({ ifWithin: $card[0] }); focusToken = null; }
			}
		});
		$close.on("click", function () { if (richPopupLayer) { richPopupLayer.close("api"); } });
		$close.trigger("focus");
	};

	// ── Rich-entry navigation (Model A) ─────────────────────────────────────────────────────────
	// Navigating to a word re-centres the dictionary on it (seek) and shows its rich card pinned to the
	// TOP of the viewport, its real neighbours below. The HEADWORD is a pure toggle: it flips the
	// CURRENT word between rich and lean in place, touching no history. Back/Forward walk the stack of
	// VISITED words/sets (each shown rich). Typing, scrolling, panels and the toggle are NOT states.
	var currentWord   = null;   // the word the dictionary is currently centred on (null = plain browsing)
	var richOpen      = false;  // is the current word's rich card showing (vs collapsed to lean)?
	// Practice-tab return point: the random/list lean set + the word you first expanded over it,
	// captured when the first card opens. Drilling into other words seeks the dictionary UNDER the
	// card (endless scroll); collapsing restores this set so you stay in Practice, centred on the
	// word you started digging from. Null while browsing the Dictionary tab.
	var practiceReturn = null;
	// The clicked word's row offset (row-top minus viewport-top, px) captured the instant its rich
	// card opens, so collapsing can return the row to that exact spot in the viewport instead of
	// re-pinning it to the top (where the open card sat) or centring it. Null when the word wasn't
	// on screen at open time (a drill-in that re-seeks first — no prior position to preserve).
	var dictReturnOffset = null;
	// The id of the practice set the user last SAW — random OR pulled from a word list — written
	// whenever a set is shown (a fresh load, or a Back/Forward that lands on a set), read when the
	// Practice tab is clicked so the set sticks across Dictionary excursions instead of regenerating
	// every return.
	// Null until the first set is ever shown (first Practice visit → generate). See practiceTabView.
	var lastPracticeSetId = null;
	var activeTab      = 'dict';
	var tabPersistReady = false;   // gate: don't persist the tab during the initial landing/restore
	var trayPersistReady = false;  // gate: don't persist a tray until the initial rehydrate has armed it
	// Practice-tray senses ×-removed this session (senseId -> termId). A removed sense stays hidden
	// through refetches of its still-staged word, and is saved soft-deleted so a refresh keeps it
	// hidden; re-adding the word restores them (see addWordsToPractice). Pair-scoped like the tray.
	var practiceDeletedSenseIds = {};
	// Senses the user banned as "I already know this" (senseId -> true). A ban is a global
	// per-user fact stored server-side (user_sense_learning.known_ts) and loaded per pair by
	// rehydrateTrays; this map is the client mirror. A known card stays visible in its tray but
	// grays out, drills/counts skip it, and the Learn ladder never offers it. The corner toggle
	// undoes it in place.
	var knownSenseIds = {};
	// One-shot filter for the next practice-set fetch (termId -> {senseId: true}): a Learn-recap
	// handoff brings over only the GRADUATED senses of a word new to Practice — its not-yet-ready
	// siblings land in practiceDeletedSenseIds at expansion time (hidden + saved soft-deleted, so
	// they stay out across refetches until re-added or handed over themselves). Consumed per term
	// by expandPracticeClusters.
	var pendingHandoffSenses = {};
	var expandedEntry = null;   // the lean row hidden behind the open card (null when opened at top)
	var expandedSlot  = null;   // the inserted ._richExpandClass container holding the rich card
	var loadingStrip  = null;   // the "Looking up…" strip injected INTO a lean row while it loads
	var richLookupSeq = 0;      // bumped whenever the open word changes; stales any in-flight fetch cb

	// ── the enrichment poll (B5, docs/project/live-mint-async-build-plan.md §3) ──────────────────
	// A typed word the server did not hold comes back in ~3s as a PROVISIONAL card: the gate's
	// translation and nothing else, stamped `enrichment: "pending"`. The real entry is minted behind
	// the learner and lands minutes later, so the open card asks the server every few seconds
	// whether it is ready and repaints itself in place when it is. No SSE — a handful of
	// primary-key reads on ONE card is cheaper than a connection per reader
	// ([[live-mint-async-plan]] §2.5).
	var ENRICH_POLL_MS     = 3000;     // §3 B5's interval
	var ENRICH_POLL_MAX_MS = 120000;   // give up after ~2 min (≤ 40 reads); a reopen starts a new poll
	var enrichPollTimer = null;        // the one pending setTimeout — only one card is ever open

	// What is on screen right now, for anything outside this file that needs to describe the view
	// rather than change it. Today that is the feedback dialog's context snapshot
	// (docs/project/user-feedback-feature.md): a report about "the word I was looking at" is only
	// actionable if it says which word, and these three values are the answer.
	//
	// A read-only accessor rather than three globals — the values stay owned here, and a caller can
	// never write a tab the app is not on. Same shape as window.PL_FINISH_MARK below: one narrow
	// window out of this scope, named for what it does.
	window.PL_VIEW_STATE = function () {
		return { tab: activeTab, exercise: isExerciseView, word: currentWord };
	};

	function pushNav(state) {
		// Any new navigation (tab switch, drill, new set) ends a pending "New set generated" Undo
		// peel — otherwise it stays attached to the hidden Random Words button and reappears when you
		// return to Practice. popstate already does this for Back/Forward; pushNav is the matching
		// choke point for our own pushes. (The Random Words flow re-creates its peel afterwards.)
		if (dismissPeel) { dismissPeel(); } else { $("#undoPeelId").remove(); }
		history.pushState(state, '');
	}
	function replaceNav(state) {
		history.replaceState(state, '');
	}

	// Every history entry carries the tab it belongs to ('dict' | 'practice') plus what to restore:
	// a lean view ({view:'lean'[, setId]}) or a drilled word ({term}). Browser Back/Forward replay
	// each step faithfully — including switching tabs — because popstate reads state.tab and re-applies
	// that tab's chrome before restoring the content. A drilled word stores only its text (tiny,
	// re-fetched by the same lookup as typing); a practice set stores a snapshot id (heavier, capped).
	// (Back within the app is Escape or the browser's own Back; there are no in-app nav buttons.)
	function pushLeanEntry(tab, setId) {
		var s = { view: 'lean', tab: tab };
		if (setId != null) { s.setId = setId; }
		pushNav(s);
	}
	function pushDrillEntry(word) {
		pushNav({ term: word, tab: activeTab });
	}

	// The rendered row for a word — the first one, except when a click has nominated its own. A term
	// legitimately appears more than once on the reverse tape (once per English key it answers, each
	// row showing the sense that answers it — design §9.3), and there "the first row with this term"
	// would expand a card several rows above the one the user actually clicked.
	var preferredListRow = null;

	function findListRow(word) {
		if (preferredListRow && preferredListRow[0] && preferredListRow[0].parentNode
				&& preferredListRow[0].getAttribute("data-term") === word) {
			return preferredListRow;
		}
		var match = null;
		$("#defId").children("._entryClass").each(function () {
			if (this.getAttribute("data-term") === word) { match = $(this); return false; }
		});
		return match;
	}

	function collapseRich() {
		stopRichLoadingBar();
		stopEnrichPoll();
		richLookupSeq++;   // invalidate any fetch still in flight for the word we're collapsing
		if (loadingStrip) { loadingStrip.remove(); loadingStrip = null; }
		if (expandedSlot) { expandedSlot.remove(); }
		$("#defId ._richExpandClass").remove();
		$("#defId ._richLoadingHost").remove();                                  // stray inline strips
		$("#defId ._entryClass._entryReplaced").removeClass("_entryReplaced");  // un-hide lean rows
		expandedEntry = null;
		expandedSlot = null;
	}

	// Endless scroll must react to USER scrolling only. Our own centring / top-pinning moves the
	// scrollbar too, and near a list edge that would trip the auto-loader (prepend + compensation),
	// which then fights the very pin we just set. We stamp the time of each programmatic scroll and
	// have onDictScroll ignore events for a short window afterwards.
	var lastProgScrollAt = 0;
	function progScroll(el, delta) {
		if (!el || !delta) { return; }
		lastProgScrollAt = Date.now();
		el.scrollTop += delta;
	}

	// Scroll so `target`'s vertical centre sits at the vertical centre of the visible dictionary band.
	function scrollToCenter(target) {
		if (!target || !target.length) { return; }
		var el = dictContainer();
		if (!el) { return; }
		var c = el.getBoundingClientRect();
		var s = target[0].getBoundingClientRect();
		progScroll(el, (s.top + s.height / 2) - (c.top + c.height / 2));
	}

	// The as-you-type seek keeps a little alphabetical context above the match (contextAbove = 3),
	// which assumed neighbours of ordinary height. A giant neighbour — "take" and its dozen
	// senses — fills the whole band and pushes the anchor, the very word that was typed, below
	// the fold ("take aback" rendered invisible under "take"). The context rule stays; this caps
	// what it may COST: after a seek renders, if the anchor row's top sits deeper than
	// ANCHOR_MAX_FRACTION of the band, the band scrolls so the anchor tops out there — tall
	// context slides off above (still one scroll-up away), while the common short context leaves
	// the view exactly as it always was (three ordinary rows never reach the cap).
	var ANCHOR_MAX_FRACTION = 0.35;
	function ensureSeekAnchorVisible(anchorIndex) {
		if (typeof anchorIndex !== "number" || anchorIndex < 1) { return; }
		var el = dictContainer();
		if (!el) { return; }
		var row = $("#defId").children("._entryClass").eq(anchorIndex);
		if (!row.length) { return; }
		progScroll(el, -el.scrollTop);   // the seek's baseline: the window from its first row
		var c = el.getBoundingClientRect();
		var s = row[0].getBoundingClientRect();
		var top = s.top - c.top;
		var cap = el.clientHeight * ANCHOR_MAX_FRACTION;
		if (top > cap) { progScroll(el, top - cap); }
	}

	// Scroll so `target`'s top sits at the top of the visible dictionary band (the opened rich card
	// fills the viewport from the top down, rather than starting halfway down where the word was).
	function scrollToTop(target) {
		if (!target || !target.length) { return; }
		var el = dictContainer();
		if (!el) { return; }
		var c = el.getBoundingClientRect();
		var s = target[0].getBoundingClientRect();
		progScroll(el, s.top - c.top);
	}

	// Where a card opened from the Verbs list should start reading. Normally that is the card itself —
	// but the reader clicked a VERB, and the verb is not always the entry's first sense: 18 of the 358
	// English irregulars lead with something else ("bear" with the animal, "light" with four senses
	// above the verb), so the card would open on a noun and the forms would be off the bottom of the
	// band. When the verb sense is buried the card reads from THERE down instead, with its principal
	// parts marked (renderRichEntry) and the headword one scroll up. An entry whose first sense is
	// already the verb — the other 340 — never moves.
	function verbSenseAnchor(slot, focusVerb) {
		if (!focusVerb) { return slot; }
		var verbSense = slot.find(".rich-verb-sense").first();
		return (verbSense.length && verbSense.prevAll(".rich-sense").length) ? verbSense : slot;
	}

	// Scroll so `target`'s top sits `offset` px below the top of the visible dictionary band — i.e.
	// restore the row to the exact viewport position it held before its card was opened (see
	// dictReturnOffset). offset === 0 is equivalent to scrollToTop.
	function scrollToOffset(target, offset) {
		if (!target || !target.length) { return; }
		var el = dictContainer();
		if (!el) { return; }
		var c = el.getBoundingClientRect();
		var s = target[0].getBoundingClientRect();
		progScroll(el, s.top - (c.top + offset));
	}

	// Return the row for `word` to its captured pre-open viewport offset, if we have one. Used by the
	// collapse paths (Esc/headword toggle via collapseToLean, Back via popstate) so backing out of a
	// rich card leaves the word right where the user clicked it. Clears the capture either way.
	function restoreDictOffset(word) {
		if (dictReturnOffset != null && word) {
			var row = findListRow(word);
			if (row && row.length) { scrollToOffset(row, dictReturnOffset); }
		}
		dictReturnOffset = null;
	}

	// Open the current word's rich card. Two phases with different scroll positions:
	//   • while loading — the word is CENTRED in the viewport; if it has a lean row that row stays put
	//     with a "Looking up…" strip inside it (left column, under the word). If it has no row yet
	//     (a word not in the corpus), a placeholder sits at its real alphabetical slot (`anchorIndex`).
	//   • once rendered — the finished card is pinned to the TOP of the viewport (scrollToTop), so it
	//     reads from the headword down instead of starting mid-screen.
	// richLookupCore owns both the loading UI and the phase transition (it holds the async callback).
	// opts.ignoreDirection — the user pushed past the wrong-toggle nudge (see wrongDirectionNudge).
	function openRichForCurrent(word, trusted, anchorIndex, opts) {
		var ignoreDirection = !!(opts && opts.ignoreDirection);
		var openMatch = !!(opts && opts.openMatch);
		var focusVerb = !!(opts && opts.focusVerb);
		// The reader arrived from a collocation signpost in the search band: the card owes them
		// THAT line, found and called out (docs/project/phrase-search-and-adoption.md, decision 2).
		var focusColloc = (opts && opts.focusColloc) || null;
		// First expansion over a staged lean set (Practice set OR the Learn tray) → remember it
		// (+ this word) as the collapse target, before any drill-in seeks the dictionary out from
		// under us. Learn reuses Practice's whole return mechanism. See collapseToLean().
		if (!richOpen && isStagedTab() && displayManager) {
			practiceReturn = { list: displayManager.getDefList(), word: word };
		}
		// Snapshot where the word's row currently sits in the viewport (before collapseRich/scrollToTop
		// move anything), so collapsing can put it back exactly there. Only a click in a LEAN view has
		// a meaningful prior position: the row must be genuinely visible — merely existing in the
		// endless-scroll DOM window isn't enough — and no card may be open, because an open card
		// inflates the layout, so an offset measured through it would restore the row off-screen
		// (a drill-in from another word's card was the classic case). When we don't capture, the
		// collapse paths fall back to centring the row.
		dictReturnOffset = null;
		if (!richOpen) {
			var priorRow = findListRow(word);
			if (priorRow && priorRow.length) {
				var priorEl = dictContainer();
				if (priorEl) {
					var contRect = priorEl.getBoundingClientRect();
					var rowRect = priorRow[0].getBoundingClientRect();
					if (rowRect.bottom > contRect.top && rowRect.top < contRect.bottom) {
						dictReturnOffset = rowRect.top - contRect.top;
					}
				}
			}
		}
		collapseRich();
		richOpen = true;
		// A card opened over a lean row does NOT re-render the list, so the band has to be taken
		// down by hand (decision 2's suppression rule). Its answer stays cached for the collapse.
		phraseBandRemove();
		var row = findListRow(word);
		if (row && row.length) {
			expandedEntry = row;
			expandedSlot = null;                          // the card slot is created on success
			richLookupCore(word, trusted, { leanRow: row, anchorIndex: anchorIndex,
				ignoreDirection: ignoreDirection, openMatch: openMatch,
				focusVerb: focusVerb, focusColloc: focusColloc });
		} else {
			// No dictionary row for this word yet. Synthesize a REAL lean entry (term only, no translation)
			// at its alphabetical slot so the loading state is a proper entry box — it highlights on hover
			// and bounds its neighbours like any other row. On success it's swapped for the generated entry.
			var placeholder = buildEntryElement({ term: { term: word }, definitionList: [], cursor: null },
				dictEntryUid++, '');
			placeholder.addClass("_loadingEntry");
			var rows = $("#defId").children("._entryClass");
			if (typeof anchorIndex === "number" && anchorIndex >= 0 && anchorIndex < rows.length) {
				placeholder.insertBefore(rows.eq(anchorIndex));   // word's alphabetical slot among neighbours
			} else if (typeof anchorIndex === "number" && anchorIndex >= 0) {
				$("#defId").append(placeholder);                 // sorts after every row currently loaded
			} else {
				$("#defId").prepend(placeholder);                // no position info (toggle-reopen) → top
			}
			expandedEntry = placeholder;
			expandedSlot = null;                          // the card slot is created on success
			richLookupCore(word, trusted, { leanRow: placeholder, synthesized: true,
				anchorIndex: anchorIndex, ignoreDirection: ignoreDirection, openMatch: openMatch,
				focusVerb: focusVerb, focusColloc: focusColloc });
		}
	}

	// Seek the dictionary to `word` (re-centre the lean list on it), then run cb(anchorIndex). We
	// deliberately do NOT touch the input box — it stays the user's own text; navigation positions by
	// `word` directly. Unlike as-you-type seek (match near the top), a navigation loads roughly half
	// the page ABOVE the word so scrollToCenter can actually put it in the middle of the viewport.
	function navigateSeek(word, cb) {
		ajaxPost('dictionary/seek',
			dictRequestParams({ pattern: word, limit: DICT_PAGE, contextAbove: Math.floor(DICT_PAGE / 2),
				navigate: true }),
			function (data) {
				// The word is one the A–Z deliberately hides — a generated verb form, a paradigm card,
				// a phrase somebody typed (step 6, docs/project/dictionary-entry-visibility.md). It has
				// no alphabetical neighbourhood to be centred in, so re-centring would just paint 25
				// dictionary rows over whatever set is on stage: the reported symptom was a Learn drill-in
				// replacing an intact 9-word tray while the band still counted 9. Leave the view alone and
				// let the card open OVER it (no anchorIndex → openRichForCurrent puts its row on top).
				if (data && data.targetHidden) {
					if (cb) { cb(undefined); }
					return;
				}
				// A drill-in lands on a TERM-language word and re-centres the alphabetical dictionary on
				// it, which is forward mode by definition. Flip the toggle rather than leave it claiming
				// we are still looking words up in the learner's own language. Silent: we are about to
				// render. Inside this branch only — a hidden target never touches the dictionary, so it
				// has no business moving the dictionary's own toggle either.
				setDictDirection('FORWARD', { silent: true });
				var list = (data && data.definitions) || [];
				displayManager.setDefList(list);
				displayManager.displayAll();          // renders lean list (collapses any open card)
				setupDictScroll(data, word);
				if (cb) { cb(data && data.anchorIndex); }
			},
			"Server exception");
	}

	// ── Finish screen → dictionary excursion ────────────────────────────────────────────────────
	// The finish screen holds the central column in #defExerciseBoxId, which means the dictionary
	// box (#defBoxId, where every rich card renders) is display:none while it is up. Any navigation
	// raised over it — a word or a flower ON the card, or a Word Lists row clicked beside it — used
	// to run to completion invisibly: the card was fetched, rendered and pinned inside a hidden box,
	// so the click read as dead. So navigateTo swaps the boxes first and remembers how to swap them
	// back. Nothing about the finish screen is torn down; it is only hidden, so Esc (or Back) puts
	// the exact same card back on stage — the ⊙ review and the live screen behave identically.
	var finishExcursion = null;   // {live, tab} while the dictionary is open OVER a finish screen

	// Is a finished-session summary card the thing currently on stage? The card is the only content
	// #defExerciseId ever holds outside a running drill, so its own class is the whole test.
	function finishScreenUp() {
		return defExerciseBox.is(":visible") && !!$("#defExerciseId .exSummaryClass").length;
	}

	function enterFinishExcursion() {
		// `live` = the screen that closed a drill (mode tabs hidden, isExerciseView still true);
		// false = the ⊙ review, which keeps its tabs. Both come back exactly as they left.
		finishExcursion = { live: isExerciseView, tab: activeTab };
		activeTab = 'dict';        // avoid openRichForCurrent's staged (Practice/Learn) practiceReturn capture
		practiceReturn = null;
		// What is on stage IS the dictionary now, so the lean rows under the card get their garden
		// stage slots and learning badges like anywhere else (both are gated on this flag, which the
		// live finish screen still carries from the drill it closed). Restored on the way back.
		isExerciseView = false;
		defExerciseBox.hide();
		defBox.show();
		sizeCenterBoxToPanel(finishExcursion.live ? tabsRowHeight : undefined);
	}

	// Drop whatever the excursion opened and put the finish screen back. Called by Esc and by the
	// popstate replay (Esc goes through history.back so the two stay one path), never by the chrome
	// functions — a tab switch or "Back to Words" leaves the finish screen for good and only has to
	// forget the excursion (clearFinishExcursion).
	function exitFinishExcursion() {
		if (!finishExcursion) { return; }
		var was = finishExcursion;
		finishExcursion = null;
		collapseRich();
		richOpen = false;
		currentWord = null;
		practiceReturn = null;
		dictReturnOffset = null;
		activeTab = was.tab;
		isExerciseView = was.live;
		defBox.hide();
		defExerciseBox.show();
		sizeCenterBoxToPanel(was.live ? tabsRowHeight : undefined);
	}

	// The finish screen is being left behind by something other than Esc (Practice Again, Back to
	// Words, a mode tab): that path owns the boxes itself, so all that is left is to forget we were
	// ever out on an excursion.
	function clearFinishExcursion() { finishExcursion = null; }

	// A word ON the finish screen (grew today, still growing, any of the difficult-words lines)
	// opens the REAL dictionary entry — the same trusted drill-in a word-list row uses — not a
	// popup over the card. The rich popup is now the garden VISTA's alone: there the page is
	// already covered by a modal, so a card rendered underneath it would be unreachable.
	function exWordClick(word) {
		if (word) { navigateTo(word, true, true); }
	}

	// Decision 8 (docs/project/phrase-search-and-adoption.md): mirrors RichTranslationService's
	// server-side check (the authority — this is only the instant client-side rejection). Word
	// count is a plain space split since the field's own typed text has no more normalization
	// applied to it client-side than that.
	var MAX_PHRASE_WORDS = 8, MAX_PHRASE_CHARS = 80;
	function isOverPhraseLimit(word) {
		return word.length > MAX_PHRASE_CHARS || word.split(/\s+/).length > MAX_PHRASE_WORDS;
	}

	// Go TO a word: re-centre + open its rich card. pushHistory=true for a user action (click / drill /
	// Enter), false for a Back/Forward replay.
	// `opts` carries what the CALLER knows about why this navigation happened and the card cannot
	// work out for itself. Today that is only {focusVerb}: a click in the Verbs list means the reader
	// came for the verb, so the card opens on its forms rather than on sense 1 (see renderRichEntry
	// for the mark, verbSenseAnchor for where the card starts reading).
	function navigateTo(word, trusted, pushHistory, opts) {
		if (!word || !langToValField.attr("data-lang-code")) { return; }
		// Raised over a finish screen → uncover the dictionary box before anything renders into it.
		// Ahead of pushDrillEntry on purpose: the entry must be stamped with the tab the card is
		// actually opening under ('dict'), which enterFinishExcursion sets.
		if (!finishExcursion && finishScreenUp()) { enterFinishExcursion(); }
		clearTimeout(searchTimeoutId);   // cancel any pending as-you-type seek so it can't clobber us
		currentWord = word;
		if (pushHistory) { pushDrillEntry(word); }   // {term, tab: activeTab} — see pushDrillEntry

		var row = findListRow(word);
		if (row && row.length) {
			// The word is already visible in the CURRENT lean view (dictionary OR random words). Open
			// the card in place — no re-seek — so collapsing restores that exact view (a random set
			// stays the random set; a dictionary page stays where it was).
			openRichForCurrent(word, trusted, undefined, opts);
		} else {
			// Not in the current view (a drill-in to a word that isn't on screen) — re-centre the
			// dictionary on it so it has a real alphabetical neighbourhood.
			navigateSeek(word, function (anchorIndex) { openRichForCurrent(word, trusted, anchorIndex, opts); });
		}
	}

	// Garden vista → dictionary (locked decision 5: a plant click opens the word's entry).
	// The overlay lives outside this closure (garden_vista.js), so the one navigation door
	// it needs is exposed here — the same trusted drill-in a word-list row's word click uses.
	window.gardenNavigate = function (word) { navigateTo(word, true, true); };

	// The tour's sign-off (onboarding_guide.js signOff): a tray word left opened into its full entry
	// on Learn or Practice is folded back to the tray, so the walk ends on the words the reader is
	// about to learn rather than on one entry (owner, 2026-10-08). The headword toggle's own in-place
	// collapse; a dictionary entry the reader looked up is theirs and stays open.
	window.plFoldStagedRich = function () {
		if (richOpen && isStagedTab()) { collapseToLean(); }
	};

	// Headword click: flip the CURRENT word rich⇄lean in place. No history.
	function toggleCurrentWord() {
		if (richOpen) {
			collapseToLean();
		} else if (currentWord) {
			openRichForCurrent(currentWord, true);
		}
	}

	// Collapse the open rich card back to the lean list — the user-facing collapse (Esc + headword
	// toggle). Two things beyond a bare collapseRich():
	//   • Practice: drilling into other words seeks the dictionary UNDER the card (endless scroll).
	//     Restore the Practice set we captured on open and turn dict-scroll back off, so we stay in
	//     Practice instead of stranding the user in a dictionary view.
	//   • Centre the revealed row (the word you started digging from in Practice, else the collapsed
	//     word) in the viewport rather than leaving it pinned at the top where the card was.
	function collapseToLean() {
		// Staged = Practice set OR Learn tray: both drill INTO the dictionary and must restore their
		// own captured set on collapse (Learn reuses Practice's mechanism verbatim).
		var inStaged = isStagedTab();
		var target = (inStaged && practiceReturn) ? practiceReturn.word : currentWord;
		var restore = inStaged && practiceReturn && displayManager
			&& displayManager.getDefList() !== practiceReturn.list;
		collapseRich();
		richOpen = false;
		if (restore) {
			displayManager.setDefList(practiceReturn.list);
			displayManager.displayAll();   // re-render the staged lean set (Practice set or Learn tray)
			disableDictScroll();           // it is not a scrollable dictionary view
		}
		// The lean list is back, so the band's question is back with it — repainted from the cache
		// the open card suppressed, never refetched. No-op outside the forward dictionary.
		phraseBandRender();
		currentWord = target;
		if (target) {
			// Dictionary: put the row back where it was before the click (dictReturnOffset). Staged
			// (Practice / Learn): the return target is the word you started digging from over a
			// (possibly restored) set — centre it in the viewport as before.
			if (!inStaged && dictReturnOffset != null) {
				restoreDictOffset(target);
			} else {
				var row = findListRow(target);
				if (row && row.length) { scrollToCenter(row); }
			}
		}
		dictReturnOffset = null;
		practiceReturn = null;
	}

	// A list-row headword click: toggle if it's the current word, otherwise navigate to it.
	function onHeadwordClick(word, row, termId) {
		preferredListRow = row || null;   // the clicked row wins over the first match (see findListRow)
		// The row IS the container: this word is that term's own headword, which is what makes the
		// trusted claim below checkable on the server (see termWordContainers).
		noteTermWordHeadword(word, termId);
		if (word === currentWord) { toggleCurrentWord(); }
		else { navigateTo(word, true, true); }
	}


	function richLookupNoHistory(word) {
		// Back/Forward replay of a visited word → known-good, skip the gate, don't push history.
		navigateTo(word, true, false);
	}

	// Asymptotic "working" bar for the AI fallback wait. We can't know the exact latency, so the
	// fill eases toward a cap (never 100%) — brisk at first, slowing as it climbs — and is simply
	// stopped when the response arrives (the entry/error replaces it). It never fills-then-resets:
	// a late response just keeps it crawling near the top. Tune CAP/GROWTH from real latencies in
	// the rich-translate log if needed. Calibrated to ~55% by 4s, ~82% by 10s.
	var richLoadingTimer = null;

	// Drives an asymptotic fill (brisk at first, easing toward a cap it never reaches) until the
	// caller stops it. Returns the interval id. Shared by the rich-view loading bar and the
	// popup's translation bar.
	function startAsymptoticFill(fillEl) {
		if (!fillEl || !fillEl.length) {
			return null;
		}
		var TICK_MS = 100, CAP = 0.92, GROWTH = 0.022;
		var p = 0.06; // small initial jump so motion is visible immediately
		fillEl.css("width", (p * 100) + "%");
		return setInterval(function () {
			p += (CAP - p) * GROWTH;
			fillEl.css("width", (p * 100).toFixed(1) + "%");
		}, TICK_MS);
	}

	function startRichLoadingBar() {
		stopRichLoadingBar();
		richLoadingTimer = startAsymptoticFill($("#defId .rich-loading-bar-fill"));
	}

	function stopRichLoadingBar() {
		if (richLoadingTimer) {
			clearInterval(richLoadingTimer);
			richLoadingTimer = null;
		}
	}

	// Shared rich-entry fetch with a result cache + in-flight de-duplication, keyed by
	// langTo|langFrom|word. The popup's hover-translate and the click-to-open both go through
	// here, so a not-yet-enriched word triggers at most one rich-translate (one AI call) — no
	// concurrent duplicate that would also race on persist server-side. cb receives (data, xhr):
	// (data, null) on success, (null, xhr) on failure. Errors are not cached.
	var richEntryCache = {};      // key -> RichEntryDto (successful results)
	var richEntryInFlight = {};   // key -> [callbacks] awaiting the one in-flight request
	// A SEPARATE in-flight map for openMatch=true requests (R13) — same key shape, own map. Two
	// simultaneous openMatch requests for the same word (an impatient double-Enter on a slow live
	// mint) still piggyback on ONE server call, same protection the comment above describes; kept
	// apart from richEntryInFlight so an openMatch request can never piggyback on a plain one (or
	// vice versa) and render with — or silently miss — a label that belongs to a different request
	// shape. richEntryCache itself stays unread/unwritten for openMatch (see fetchRichEntry).
	var richEntryOpenMatchInFlight = {};

	// "Include vulgar words" moved (docs/project/vulgar-slur-handling.md, P3). The server decides
	// everything about the setting; the one thing it cannot reach is this cache, and a cached entry
	// is precisely the wrong shape after a toggle — a double-meaning word (`ass`, `cock`, `prick`)
	// is stored with or without its vulgar sense depending on the state it was fetched in. Emptying
	// the map is the whole fix: the next hover or click re-asks and the answer arrives in the new
	// shape. In-flight requests are left alone — they were asked under the old setting and their
	// waiters are waiting on that answer; the next ask re-fetches anyway.
	$(document).on("pl:includeVulgar", function () {
		richEntryCache = {};
	});

	// The sentence a token was standing in when it was last hovered/clicked, per word — sent as
	// the `context` param on a TRUSTED rich-translate so the server's live word-form fallback can
	// classify the token in its actual sentence (the batch measured context materially better).
	// A stash rather than a parameter thread because the click path goes through navigateTo,
	// which has long lost the DOM anchor by the time the fetch fires. Advisory only: never part
	// of the cache key, harmless when stale (the server uses it to rank, not to store).
	var termWordContexts = {};

	// WHICH STORED ROW a token was standing in, per word — {kind, id}, sent as containerKind /
	// containerId beside `trusted`. Same stash shape and the same reason as termWordContexts above.
	//
	// ⛔ This is what makes `trusted` mean anything. The flag skips the phrase limit and the paid
	// gibberish gate and goes straight to an Opus generation; until 2026-09-02 the server simply
	// believed it, so any visitor could send trusted=true with any string and get a free model call
	// (docs/project/go-public-hardening.md §3 F3). The server now reads the named row's text and
	// looks for the word in it. Sending nothing is safe and is what old pages do — the lookup is
	// then gated like a typed one.
	var termWordContainers = {};

	// Record the container sentence AND the row it came from for a token element, if it stands in
	// one — an example, a collocation, or a phrase-band row. Word tokens elsewhere (synonyms, the
	// base form line) are citation forms standing alone: no sentence, nothing recorded here; the
	// headword path uses noteTermWordHeadword below.
	function noteTermWordContext(el) {
		var word = $(el).text().trim();
		if (!word) { return; }
		var box = $(el).closest(".rich-example-term, .rich-colloc-term, .phBandRowBodyClass");
		if (box.length) {
			termWordContexts[word] = box.first().text().replace(/\s+/g, " ").trim().slice(0, 300);
		}
		// The kind + id live on the ROW (phraseRowAttrs), which is at or above the text box — the
		// same [data-phrase-id] ancestor the sound and add-to-drill handlers already resolve.
		var row = $(el).closest("[data-phrase-id]");
		var kind = phraseKindOf(row.attr("data-phrase-kind"));
		if (row.length && kind && row.attr("data-phrase-id")) {
			termWordContainers[word] = { kind: kind, id: row.attr("data-phrase-id") };
			return;
		}
		// The base-form line: a lemma standing alone under the card of the form it belongs to. Its
		// container is that card's own term, whose head-term link IS this lemma.
		var head = $(el).closest("[data-head-term-id]").attr("data-head-term-id");
		if (head) {
			termWordContainers[word] = { kind: "HEADWORD", id: head };
			return;
		}
		// A tip tease (tips.js) — the whole line is the container and the tip's id names it.
		var tip = $(el).closest("[data-tip-id]").attr("data-tip-id");
		if (tip) {
			termWordContainers[word] = { kind: "TIP", id: tip };
		}
	}

	// A word rendered as a HEADWORD of a term we hold — a word-list row, a card's own headword, a
	// garden plant, a drill token. The term id is the container: the server checks the word against
	// that row's text, spelling variant and focus form.
	function noteTermWordHeadword(word, termId) {
		if (!word || termId == null) { return; }
		termWordContainers[String(word).trim()] = { kind: "HEADWORD", id: String(termId) };
	}

	function richEntryKey(word) {
		return (langToValField.attr("data-lang-code") || "") + "|"
			+ (langFromValField.attr("data-lang-code") || "") + "|" + word;
	}

	// Is this entry the finished article? `enrichment` is stamped per response by
	// RichDictionaryController.stampEnrichment and is one of "pending" / "done" / "failed", or
	// ABSENT for every term with no queue row — which is every corpus term and so the normal case.
	// Absent and "done" are both settled; "failed" is not, because the retry ladder may still turn
	// it into a real entry and the next open should ask again rather than serve a cached stub.
	function enrichmentSettled(data) {
		return !data || !data.enrichment || data.enrichment === "done";
	}

	// trusted=true: the word came from our OWN data (a clicked term token / headword, or a hover),
	// so the server skips the validity gate. Free user input (typed + Enter) leaves it falsy → gated.
	// Not part of the cache key: the resolved entry is identical either way; trusted only affects a miss.
	// ignoreDirection=true: the user saw the wrong-toggle nudge and asked for the lookup anyway, so
	// the server skips that one guard (the validity gate still runs). Like `trusted` it stays out of
	// the cache key — it only affects a miss, and a refused lookup is never cached.
	// openMatch=true (R13, "Enter opens the match"): the Enter action only. Never reads or writes
	// richEntryCache — the entry this can return for a given `word` is NOT a function of `word`
	// alone (typing "wass" can answer Wasser's entry today and, a moment later with different
	// corpus content, something else), so caching it there would let one openMatch answer leak into
	// every OTHER caller that asks for the same typed text (a plain click, a prefetch), or vice
	// versa. It DOES still de-duplicate CONCURRENT openMatch requests for the same word, through its
	// own richEntryOpenMatchInFlight map: an impatient double-Enter on a word slow enough to still
	// be generating (a live mint routinely runs 25–48s) must piggyback on the one request already in
	// flight, not fire a second live generation and spend the guest's mint budget twice over a
	// single lookup — measured live, 2026-09-11, on a guest whose only two mints both went to the
	// same word from one retried Enter.
	function fetchRichEntry(word, trusted, cb, ignoreDirection, openMatch) {
		var key = richEntryKey(word);
		var inFlight = openMatch ? richEntryOpenMatchInFlight : richEntryInFlight;
		if (!openMatch && Object.prototype.hasOwnProperty.call(richEntryCache, key)) {
			cb(richEntryCache[key], null);
			return;
		}
		if (inFlight[key]) {
			inFlight[key].push(cb);   // piggyback on the in-flight request
			return;
		}
		inFlight[key] = [cb];
		var params = {
			word: word,
			langTo: langToValField.attr("data-lang-code"),
			langFrom: langFromValField.attr("data-lang-code"),
			trusted: !!trusted,
			ignoreDirection: !!ignoreDirection,
			openMatch: !!openMatch
		};
		// Only a trusted token can carry a sentence (it came out of one), and only a miss uses it.
		if (trusted && termWordContexts[word]) {
			params.context = termWordContexts[word];
		}
		// …and only a trusted token has a container to name. Without it the server drops the claim
		// and gates the lookup like a typed one, which is the correct degradation for a word we
		// cannot show came out of our own data.
		if (trusted && termWordContainers[word]) {
			params.containerKind = termWordContainers[word].kind;
			params.containerId = termWordContainers[word].id;
		}
		$.ajax({
			url: "api/dictionary/rich-translate",
			type: "GET",
			data: params,
			success: function (data) {
				// ⛔ A PENDING or FAILED entry is never cached (B5, build plan §1c). It is a
				// provisional card — the gate's translation and nothing else — and this map short-
				// circuits every later lookup of the word for the rest of the session (5049 above).
				// Caching it would leave the word thin until a reload even though the server finished
				// it minutes ago: the poll repaints the card that is OPEN, it cannot reach a copy
				// filed here. `enrichment` is absent for every corpus term, which is nearly all of
				// them, so this changes nothing for them.
				if (!openMatch && enrichmentSettled(data)) { richEntryCache[key] = data; }
				var waiters = inFlight[key] || [];
				delete inFlight[key];
				waiters.forEach(function (fn) { fn(data, null); });
			},
			error: function (xhr) {
				var waiters = inFlight[key] || [];
				delete inFlight[key];
				waiters.forEach(function (fn) { fn(null, xhr); });
			}
		});
	}

	// ── a verb form is read through its HEAD VERB ─────────────────────────────────────────────────
	// A conjugated combo ("du bekamst ab") and a principal-parts card ("bear, bore, borne") are Terms
	// of their own, but their ENTRIES are a single translation line and nothing else — no IPA, no
	// gloss, no examples, no grammar, and in particular not the paradigm the form belongs to. That is
	// true of every one of the 21k pre-filled forms, so opening one says back exactly what the row
	// that was clicked already said (owner report 2026-08-06). What answers "what IS this form?" is
	// the HEAD VERB's entry with this form's own paradigm cell marked — which is what the Learn
	// session has done at its own card since #210 (learning_session.js meetVerbForm). This is that
	// same substitution for every OTHER surface: dictionary rows, the Learn and Practice trays, word
	// lists, the finish-screen / garden popup, the exercise miss reveal, and a form token drilled
	// inside another card.
	//
	// Decided off the FETCHED entry rather than off the click, because those surfaces share no
	// metadata — a lean row carries neither pos nor lemma, and a drilled token is a bare string —
	// while every one of them holds the entry a moment later, and the entry carries both. `lemma` is
	// the same field the card's own "base form" line is built from.
	// ── word-form templates (word-form-entries PR 3) ────────────────────────────────────────────
	// A THIN form row stores only what is word-specific (variant-compact translation, form kind,
	// optional note); the grammar explanation renders from these per-KIND templates — ~90% of any
	// per-word prose would be identical across every past-tense verb, so none is stored. RU first
	// (the EN→RU pair ships first); other def-languages fall back to plain English until their
	// language pack brings its own template text. The form KIND arrives in senses[0].pos — the
	// phrase_verb_conj precedent: a marker, not a part of speech.
	// ⚠️ TWINNED with the `pos*_tooltip` strings in resources_{en,ru}.js: the same form kinds are
	// named there for the pos gutter (PosLabel's CANON gained a row for every one of them on
	// 2026-08-27, ending the "prete"/"decli" truncation on all 56,193 form rows). The two are
	// separate on purpose — this table is dictionary PROSE in the DEFINITION language and reads with
	// the lemma after it, the bundles are a 5-char gutter abbreviation plus a tooltip in the
	// VIEWER's locale — but a learner sees both on one screen, so the terminology must agree.
	// Change them together.
	var WORD_FORM_KINDS_RU = {
		plural: "множественное число от",
		past: "прошедшее время от",
		present_3sg: "форма 3-го лица ед. ч. от",
		ing_form: "форма на -ing (причастие/герундий) от",
		past_participle: "причастие прошедшего времени от",
		comparative: "сравнительная степень от",
		superlative: "превосходная степень от",
		suppletive: "форма глагола",
		contraction: "сокращение",
		spelling_variant: "вариант написания",
		other: "форма слова",
		// the German kinds, so a def-lang-RU pair over German renders them rather than falling
		// back to "форма слова"
		genitive_sg: "родительный падеж ед. ч. от",
		preterite: "прошедшее время (претерит) от",
		present_1sg: "форма 1-го лица ед. ч. от",
		present_2sg: "форма 2-го лица ед. ч. от",
		imperative: "повелительное наклонение от",
		subjunctive_ii: "конъюнктив II от",
		declined: "склоняемая форма от",
		// ⛔ NOT "отделяемая приставка от": the ROW is the finite verb half (`stehe`), the lemma is
		// the whole verb (`aufstehen`) — the приставка is `auf`, which this row is not. See the
		// EN table below for the measurement and the shared wording decision.
		separable_particle: "форма глагола с отделяемой приставкой от",
		fusion: "слитная форма от",
		// Ячейка спряжения, сохранённая отдельным термином («ich habe getrennt» → `trennen`).
		// Что именно лежит в строке и почему ключа не было — см. таблицу EN ниже.
		// set-here по форме причастия: корень взят из resources_ru.js
		// (`posPhraseVerbConj_tooltip: 'спряжение глагола'`, с которой эта таблица согласована),
		// а сама формула — «склоняемая форма от» выше, буква в букву.
		phrase_verb_conj: "спрягаемая форма от"
	};
	var WORD_FORM_KINDS_EN = {
		plural: "plural of", past: "past tense of", present_3sg: "3rd-person singular of",
		ing_form: "-ing form of", past_participle: "past participle of",
		comparative: "comparative of", superlative: "superlative of", suppletive: "form of",
		contraction: "contraction", spelling_variant: "spelling variant of", other: "form of",
		// German's own kinds (pack item 8). Until these were here every one of them rendered as
		// the `other` fallback, "form of X" — degraded, not broken, and invisible in testing
		// because English never produces them. Each label is written to read with the lemma
		// after it: "genitive singular of Haus".
		genitive_sg: "genitive singular of", preterite: "simple past of",
		present_1sg: "1st-person singular of", present_2sg: "2nd-person singular of",
		imperative: "imperative of", subjunctive_ii: "subjunctive II of",
		declined: "declined form of",
		// ⛔ `separable prefix of` was backwards in all four packs and is fixed in all four. What the
		// row actually holds: the token is the FINITE VERB HALF and the lemma is the whole separable
		// verb — prompts/rich/de-en.form-verdict.system.txt is explicit ("Use separable_particle when
		// the token is the finite half of a separable verb and the corpus sentence shows the particle
		// detached at the end ('stehe' in 'ich stehe früh auf' -> lemma 'aufstehen')"). So `stehe` is
		// the verb stem and `auf` is the prefix — the label named the wrong half.
		// The replacement wording is not invented: corpus/py/packs/de.py:FORM_KINDS has carried
		// "separable form of" for this kind all along, so main.js was ALSO drifting from the pack it
		// is twinned with (de.py's own comment: "keeping the two in sync by hand is exactly the drift
		// the twin check exists to stop"). Aligning to the pack fixes the grammar claim and the drift
		// at once; RU/DE/FR mirror it.
		separable_particle: "separable form of",
		fusion: "fused form of",
		// ⛔ The Track B form kind that had NO key in ANY of the four tables — 21,857 stored rows
		// (`term.category = 'verb_form'`, 34.3% of the whole German form lane), every one of them
		// falling through to the `other` label. It was missed because the earlier label sweep
		// enumerated kinds under `category = 'word_form'` only, and this kind lives in a sibling
		// category. The full Track B census now behind this fix is in the commit's PR body.
		// What the row holds, measured not assumed: a conjugation CELL persisted as its own term —
		// the display pronoun plus the finite form ("ich habe getrennt", "du wischst ab",
		// "wir fallen ab") with the INFINITIVE as its head ("trennen", "abwischen", "abfallen").
		// So the token is a conjugated form of the lemma, and that is what the label says.
		// Attested, not invented: resources_en.js names this exact pos
		// `posPhraseVerbConj_tooltip: 'conjugated verb form'`, and this block's own header declares
		// the two twinned ("the terminology must agree"). The `<X> form of` shape is this table's
		// own, from `declined: "declined form of"`.
		// ⚠️ The label is deliberately GENERIC. The precise cell ("past participle of", "2nd-person
		// singular of") is not recoverable from the stored kind — it would need a term-axis kind
		// refinement, which is a data change, not a table entry.
		phrase_verb_conj: "conjugated form of"
	};
	// German (EN->DE pack). Same key set as the two tables above — a MISSING key here would render
	// blank, which is worse than the English label this table replaces. Category names and the
	// `<Kategorie> von <lemma>` shape are the ones translation-lang-de.md §4 fixes for this pair
	// ("Partizip II von to go", "Plural von child", "Präteritum von be", "Komparativ von good",
	// "3. Person Singular von go") — German category names throughout, lemma bare and unquoted.
	var WORD_FORM_KINDS_DE = {
		plural: "Plural von", past: "Präteritum von", present_3sg: "3. Person Singular von",
		ing_form: "-ing-Form (Partizip I/Gerundium) von", past_participle: "Partizip II von",
		comparative: "Komparativ von", superlative: "Superlativ von", suppletive: "Form von",
		contraction: "Kurzform", spelling_variant: "Schreibvariante von", other: "Form von",
		// German's own kinds — reached when the TERM language is German and the reader is German
		// too (not this pair, but the table must not have holes: an absent key renders blank).
		genitive_sg: "Genitiv Singular von", preterite: "Präteritum von",
		present_1sg: "1. Person Singular von", present_2sg: "2. Person Singular von",
		imperative: "Imperativ von", subjunctive_ii: "Konjunktiv II von",
		declined: "deklinierte Form von",
		// ⛔ NOT "trennbares Präfix von": `stehe` is the finite verb half, not the Präfix (`auf` is).
		// set-here, mirroring the EN table's "separable form of" (see its comment for the evidence).
		separable_particle: "trennbare Form von",
		fusion: "Verschmelzung von",
		// set-here: the exact parallel of this table's own `declined: "deklinierte Form von"`,
		// mirroring the EN table's attested "conjugated form of" (see its comment for what the row
		// actually holds). resources_de.js now carries "konjugierte Verbform" for this pos, so the
		// two agree; this table predates that and is kept because it is the ATTESTED wording.
		phrase_verb_conj: "konjugierte Form von"
	};
	// French (DE->FR pack). Terminology is NOT invented here: every category name comes from
	// translation-lang-fr.md §3.3's fixed vocabulary table and §3.5's worked gloss template, or
	// from the closed FORM_KIND list in prompts/rich/de-fr.form-verdict.system.txt. The shape is
	// §3.5's `<catégorie> de <lemme>` — German lemma bare and unquoted, French category names
	// throughout (RULE FR-F2).
	// ⛔ The `de` → `d'` elision (RULE FR-F1) is NOT in this table and must never be: it depends on
	// the lemma that follows, which a label alone cannot see. It lives in wordFormKindPrefix below,
	// and EVERY site that renders label + lemma goes through that function.
	// Labels marked `set-here` have no direct attestation and are derived as noted.
	var WORD_FORM_KINDS_FR = {
		plural: "pluriel de",                              // §3.5 «pluriel de Kind»
		past: "prétérit de",                               // §3.3 tense list (English-side kind)
		present_3sg: "3e personne du singulier de",        // §3.5
		// set-here: §3.3 attests `participe présent`; the "-ing" wrapper mirrors the EN/DE labels.
		// `gérondif` is deliberately NOT used — it was struck from this build once already.
		ing_form: "forme en -ing (participe présent) de",
		past_participle: "participe passé de",             // §3.5 «participe passé d'öffnen»
		comparative: "comparatif de",                      // §3.5 «comparatif de schön»
		superlative: "superlatif de",                      // §3.5 «superlatif de schön»
		// set-here: EN and DE both degrade `suppletive` to the plain "form of"/"Form von" label
		// rather than reaching for jargon; French follows the same precedent.
		suppletive: "forme de",
		contraction: "contraction",                        // §3.3 residue; stands alone, no lemma
		spelling_variant: "variante orthographique de",    // set-here: standard FR term, mirrors EN/DE
		other: "forme de",                                 // set-here: mirrors EN "form of" / DE "Form von"
		genitive_sg: "génitif singulier de",               // §3.5 «génitif singulier de Kind»
		preterite: "prétérit de",                          // §3.5 «prétérit de nehmen»
		// set-here on the ordinal only: §3.5 attests the `Ne personne du singulier` shape for 2nd
		// and 3rd; `1re` is the standard French ordinal abbreviation for `première`.
		present_1sg: "1re personne du singulier de",
		present_2sg: "2e personne du singulier de",        // §3.5 «2e personne du singulier de geben»
		imperative: "impératif de",                        // §3.3 tense/mood list
		// set-here on the numeral only: §3.3 attests `subjonctif`; the "II" is the German paradigm
		// label the other three tables all carry unchanged.
		subjunctive_ii: "subjonctif II de",
		declined: "forme déclinée de",                     // set-here, from §3.3 `déclinaison`
		// ⛔ NOT "particule séparable de". §3.3 does attest `particule séparable` — but as the name of
		// the PARTICLE (`auf`), and this row's token is the finite verb half (`stehe`), so the
		// attested term was applied to the wrong half. set-here, mirroring the EN table's "separable
		// form of" (see its comment). Still ends in ` de`, so RULE FR-F1 elision is unaffected.
		separable_particle: "forme séparable de",
		// set-here: the fusion kind is zum/zur/ins with the PREPOSITION as lemma, so this reads
		// "forme contractée de zu". §3.3 has no term for it; French names its own au/du the same way.
		fusion: "forme contractée de",
		// set-here on the participle only: §3.3's fixed vocabulary attests `conjugaison`, and this
		// label is derived from it exactly as `declined: "forme déclinée de"` above is derived from
		// §3.3's `déclinaison`. Mirrors the EN table's attested "conjugated form of".
		// ⚠️ Ends in ` de`, so RULE FR-F1 fires on the vowel-initial infinitives that head a third
		// of these rows: "forme conjuguée d'abfallen", "forme conjuguée de trennen".
		phrase_verb_conj: "forme conjuguée de"
	};
	// Spanish (DE->ES pack). ⚠️ AUTHORED AT STAGE F1, DELIBERATELY NOT YET WIRED: there is no `ES`
	// column in DEF_LANG_WORDS below, because no entry in the database carries `defLanguageCode:
	// 'ES'` until the DE->ES pair is loaded, and switching Spanish on is Stage G4's single job
	// (docs/project/de-es-pair-build-plan.md §5). G4 adds the column — this table plus an `twinAlso`
	// and a `contractionOf` — and nothing else about this object changes.
	// ⛔ WHY THE TABLE IS WRITTEN NOW RATHER THAN THEN: DE->FR reached G4 with only 10 of its 17
	// German form kinds ruled, and the 7 that were missing covered 28.9% of its ~64k Track B rows
	// (translation-pair-de-fr.md, F1's "TWO G4 FINDINGS"). All 21 keys are ruled here, up front.
	// Terminology is NOT invented: every category name comes from translation-lang-es.md §3.3's
	// fixed metalanguage table or §3.5's worked gloss template, which also names `forma declinada
	// de`, `forma de`, `forma contraída de` and `variante ortográfica de` verbatim. The shape is
	// §3.5's `<categoría> de <lema>` — German lemma bare and unquoted, Spanish category names
	// throughout (RULE ES-F2).
	// ⭐ NO ELISION, and its absence is a rule (RULE ES-F1): Spanish `de` never shortens before a
	// vowel, so `plural de Auge` and `pretérito de essen` are written in full and the FR branch in
	// wordFormKindPrefix must never grow a Spanish arm. A `d'` in a Spanish field is a French leak.
	// ⭐ The person is SPELLED OUT (`tercera persona del singular`), never `3.ª persona` — ES-F2,
	// because translation-lang-es.md §1.8 keeps the ordinal indicators `º ª` out of the charset.
	// Labels marked `set-here` have no direct attestation in §3.3/§3.5 and are derived as noted.
	var WORD_FORM_KINDS_ES = {
		plural: "plural de",                               // §3.5 «plural de Kind»
		past: "pretérito de",                              // §3.3 tense list (English-side kind)
		present_3sg: "tercera persona del singular de",    // §3.5 «tercera persona del singular de nehmen»
		// set-here: §3.3 attests `participio de presente`; the "-ing" wrapper mirrors the EN/DE/FR
		// labels for this English-side kind.
		ing_form: "forma en -ing (participio de presente) de",
		past_participle: "participio de",                  // §3.5 «participio de öffnen»
		comparative: "comparativo de",                     // §3.5 «comparativo de schön»
		superlative: "superlativo de",                     // §3.5 «superlativo de schön»
		// set-here: EN, DE and FR all degrade `suppletive` to the plain "form of" label rather than
		// reaching for jargon; Spanish follows the same precedent, and §3.5 names `forma de`.
		suppletive: "forma de",
		// set-here: stands ALONE, no lemma after it (see wordFormLine's contraction branch). §3.3
		// has no term for it; `contracción` is what Spanish grammar calls its own al/del.
		contraction: "contracción",
		spelling_variant: "variante ortográfica de",       // §3.5's own vocabulary list
		other: "forma de",                                 // §3.5's own vocabulary list
		genitive_sg: "genitivo singular de",               // §3.5 «genitivo singular de Kind»
		preterite: "pretérito de",                         // §3.5 «pretérito de nehmen»
		// §3.5 attests the spelled-out `<ordinal> persona del singular` shape for 2nd and 3rd;
		// `primera` is the same shape, set-here on the ordinal word only.
		present_1sg: "primera persona del singular de",
		present_2sg: "segunda persona del singular de",    // §3.5 «segunda persona del singular de geben»
		imperative: "imperativo de",                       // §3.3 tense/mood list
		// ⛔⛔ THE GERMAN LABEL IS KEPT ON PURPOSE — this is the one row where Spanish does NOT
		// translate. §3.3: Spanish `subjuntivo` names a DIFFERENT mood system, and Spanish grammars
		// of German keep the German term, so `subjuntivo II` is listed there as a defect. FR wrote
		// `subjonctif II` because French `subjonctif` genuinely is the German Konjunktiv's
		// counterpart; Spanish's is not. ⚠️ Reads as `Konjunktiv II de sein` — German label, Spanish
		// preposition, German lemma, which is exactly what a Spanish DaF grammar prints.
		subjunctive_ii: "Konjunktiv II de",
		declined: "forma declinada de",                    // §3.5's own vocabulary list
		// ⛔ NOT "partícula separable de". §3.3 does attest `partícula separable` — but as the name
		// of the PARTICLE (`auf`), and this row's token is the finite verb half (`stehe`), so the
		// attested term names the wrong half. set-here, mirroring the EN table's "separable form of".
		separable_particle: "forma separable de",
		// §3.5's own vocabulary list. The fusion kind is zum/zur/ins with the PREPOSITION as lemma,
		// so this reads "forma contraída de zu" — and Spanish contracts its own a+el/de+el the same
		// way, which is why the term is the natural one.
		fusion: "forma contraída de",
		// set-here on the participle only: §3.3's fixed vocabulary attests `conjugación`, and this
		// label is derived from it exactly as `declined: "forma declinada de"` is derived from
		// §3.3's `declinación`. Mirrors the EN table's attested "conjugated form of".
		phrase_verb_conj: "forma conjugada de"
	};

	// ── ONE COLUMN PER DEFINITION LANGUAGE ──────────────────────────────────────────────────────────
	// Every string reachable through this object is dictionary PROSE in the entry's DEFINITION
	// language. ⛔ It is NOT the viewer's UI locale, so `getRes()` (which reads
	// `document["res_" + curr_locale]`) is the wrong tool here and these words must never move into
	// the i18n bundles: a French-reading user with an English UI has to see `aussi`, not `also`.
	//
	// ⛔ WHY THIS OBJECT EXISTS AT ALL. The same four-language mapping used to be encoded at three
	// separate sites in three different shapes — this table set, plus an inline ternary chain in
	// twinAlsoLabel, plus a third independent chain (with its own `var ru = …` boolean) inside
	// wordFormLine. That is not a style problem: the twin lead-in was inlined at two call sites, and
	// when French was added during the DE→FR build one copy got the new branch and the other did not,
	// so every GERMAN reader kept seeing `also` — which in German means "so / therefore" — until it
	// was found by hand. A copy nobody remembered to update is the defect, and four hand-written
	// ternary chains are four chances to forget.
	//
	// So: adding a definition language is ONE COLUMN HERE, and nothing else. Every per-def-language
	// string lives in this object, every reader of it goes through defLangWords() below, and
	// src/test/js/word_form_line_test.js §0 FAILS the build if any column is missing a key that any
	// other column has — the exact defect above, made impossible to reach production silently.
	//
	// ⚠️ What does NOT belong here: language RULES. The French `de` → `d'` elision is a function of
	// the lemma that follows the label, so it lives in wordFormKindPrefix; the German umlaut folding
	// in word_filter.js is a rule too. Strings go in the columns, rules stay in code.
	var DEF_LANG_WORDS = {
		//    the form-kind label table │ the homograph-twin lead-in │ the contraction preposition
		RU: { kinds: WORD_FORM_KINDS_RU, twinAlso: 'также', contractionOf: 'сокращение от' },
		DE: { kinds: WORD_FORM_KINDS_DE, twinAlso: 'auch',  contractionOf: 'Kurzform von' },
		FR: { kinds: WORD_FORM_KINDS_FR, twinAlso: 'aussi', contractionOf: 'contraction de' },
		// ES — G4's whole wiring job for this table (WORD_FORM_KINDS_ES itself was authored at F1a).
		// ⛔ wordFormKindPrefix below gets NO Spanish arm: RULE ES-F1 (see WORD_FORM_KINDS_ES's own
		// comment above) says Spanish `de` never elides, so ES rides the shared `label + ' '` branch
		// unchanged — the FR elision check stays FR-only on purpose.
		// `también` mirrors RU/DE/FR/EN's own bare adverb. `contracción de` is not invented: it is
		// WORD_FORM_KINDS_ES.contraction ("contracción") plus its preposition, the same derivation
		// DE's "Kurzform von" and FR's "contraction de" already use for their own contraction row.
		ES: { kinds: WORD_FORM_KINDS_ES, twinAlso: 'también', contractionOf: 'contracción de' },
		EN: { kinds: WORD_FORM_KINDS_EN, twinAlso: 'also',  contractionOf: 'contraction of' }
	};

	// The ONE dispatch on definition language. An unknown, empty, absent or wrong-case code falls
	// back to English, byte-for-byte as every ternary chain this replaced did (the codes arrive
	// upper-case from the server; a lower-case `de` fell through to English before and still does).
	// `hasOwnProperty` rather than a bare lookup so a code like `constructor` cannot reach
	// Object.prototype and return a function.
	function defLangWords(defLangCode) {
		return Object.prototype.hasOwnProperty.call(DEF_LANG_WORDS, defLangCode)
			? DEF_LANG_WORDS[defLangCode] : DEF_LANG_WORDS.EN;
	}

	function wordFormKindLabel(kind, defLangCode) {
		var map = defLangWords(defLangCode).kinds;
		return map[kind] || map.other;
	}

	// German lemmas that trigger French elision. Both cases are spelled out rather than relying on
	// the /i flag, and the umlauts are included explicitly — `Ä Ö Ü` open real German lemmas.
	// ⚠️ `y` is deliberately ABSENT: French does not elide before it ("de yoga", like "le yaourt").
	// ⚠️ `h` is deliberately ABSENT too. French elides before a MUTE h and not before an aspirated
	// one, but that is a property of the FRENCH lexicon, which does not classify German words —
	// there is no fact of the matter for `Haus`. We therefore never elide before h-, the
	// conservative reading ("pluriel de Haus"), on the 1.8k of 42.1k stored rows whose lemma starts
	// with one.
	var FR_ELIDES_BEFORE = /^[aeiouàâäéèêîôöûüAEIOUÀÂÄÉÈÊÎÔÖÛÜ]/;

	// ── CF8: ENGLISH lemmas need the SOUND rule, not the letter rule ────────────────────────────
	//
	// ⛔ THE RULE IS THE SOUND, NOT THE LETTER. The letter rule above is correct for GERMAN lemmas
	// and wrong for English ones, and it shipped wrong: on the real DOM `uses` rendered
	// «3e personne du singulier d'use» while the corpus stores «de use» — French does not elide
	// before the yod of /juːz/. The corpus half was fixed at A1; this is the UI half.
	//
	// ⛔ DO NOT RE-DERIVE THESE LISTS. They are the measured exception set from
	// corpus/py/lexical_kit/packs/en_fr.py (`_NO_ELIDE` / `_DO_ELIDE` / `_elides()`), ruled at F1a
	// and frozen into en-fr.pair.system.txt; translation-pair-en-fr §1 Point 4 measured the letter
	// rule and the sound rule disagreeing on 41 of 13,706 Track B rows (0.30%) in four closed
	// classes. This function is a faithful port of `_elides()` and must stay one — if the pack
	// changes, this changes with it, and neither side gets a new member invented locally.
	//
	//   elide (d')    : eat, hour, heir, herb (US /ɜrb/), uzi, unearth, unarm, uninvite
	//   do NOT (de )  : use, unit, university, uniform, euro, ewe, year, house, have, herbivore,
	//                   one, once, one-off
	//
	// `h` and `y` are ABSENT from the letter class deliberately (French elides before a MUTE h
	// only, and never before the yod of `year`); the silent-h English lemmas that DO elide are the
	// closed EN_FR_DO_ELIDE list and nothing else.
	var EN_FR_NO_ELIDE = {};
	'one once euro eunuch euthanize ewe use user unit unite union unionist unionize unicorn uniform unify university urinal urinate usurp utensil utility utilize'
		.split(' ').forEach(function (w) { EN_FR_NO_ELIDE[w] = true; });
	var EN_FR_DO_ELIDE = {};
	'hour honor honorific heir heirloom herb'
		.split(' ').forEach(function (w) { EN_FR_DO_ELIDE[w] = true; });
	var EN_FR_ELIDES_BEFORE = /^[aeiouàâäéèêëîïôöùûüœ]/i;

	// `_elides()` ported: the exception lookup is on the lemma's FIRST WHITESPACE TOKEN (so
	// "use up" is decided by "use"), the `one-` prefix is a NO, and the letter class decides the
	// rest. Uses hasOwnProperty so a lemma like "constructor" cannot reach Object.prototype.
	function enFrElides(lemma) {
		var lem = String(lemma == null ? '' : lemma).trim().toLowerCase();
		if (!lem) { return false; }
		var head = lem.split(/\s+/)[0];
		if (Object.prototype.hasOwnProperty.call(EN_FR_DO_ELIDE, head)) { return true; }
		if (Object.prototype.hasOwnProperty.call(EN_FR_NO_ELIDE, head)) { return false; }
		if (head.indexOf('one-') === 0) { return false; }
		return EN_FR_ELIDES_BEFORE.test(lem);
	}

	// The label together with the separator that joins it to `lemma` — normally a space, but a bare
	// apostrophe when French `de` elides to `d'` (RULE FR-F1, translation-lang-fr §3.5): "pluriel de
	// Kind" but "pluriel d'Auge". Returning the separator attached is what lets a caller emit the
	// lemma as HTML (tokenizeTermWords) and still get the join right.
	// Non-FR def languages take the `label + ' '` branch unchanged — this must stay byte-identical
	// for DE/RU/EN, which is shared shipped UI.
	// ⭐ `termLangCode` is the TERM language (the language the lemma is IN), not the definition
	// language: elision is a fact about the word that FOLLOWS `de`, so FR definitions on German
	// terms (DE→FR, shipped) and FR definitions on English terms (FR→EN, G4) need different rules
	// and the caller is the only place that knows which. An absent/unknown code keeps the German
	// letter rule, which is exactly the behaviour every caller had before CF8.
	function wordFormKindPrefix(kind, defLangCode, lemma, termLangCode) {
		var label = wordFormKindLabel(kind, defLangCode);
		if (defLangCode === 'FR' && /(^| )de$/.test(label)) {
			var elides = termLangCode === 'EN'
				? enFrElides(lemma)
				: FR_ELIDES_BEFORE.test(String(lemma == null ? "" : lemma));
			if (elides) { return label.slice(0, -1) + "'"; }
		}
		return label + ' ';
	}

	// The homograph-twin lead-in: «rose» is the flower AND *also* the past tense of rise. Two call
	// sites render it (the lemma card's twin row and the hover popup's second line), so it lives in
	// one function — duplicating the ternary is what let German go wrong while French was fixed.
	// ⛔ German is NOT `also`: German `also` means "so / therefore", a genuine false friend, and it
	// was reaching every German reader on this line. `auch` is the word that carries "additionally",
	// as resources_de.js already uses it ("Sie können auch eigene Listen anlegen").
	// Returns the bare word; callers add their own separator.
	function twinAlsoLabel(defLangCode) {
		return defLangWords(defLangCode).twinAlso;
	}

	// One line explaining a thin form row («прошедшее время от play», «сокращение от „do not“»).
	// `data` is the form row's own entry. Null when there is nothing to explain (a headless
	// proper-noun row — its translation already says everything).
	function wordFormLine(data) {
		var s = data.senses && data.senses.length ? data.senses[0] : null;
		if (!s) { return null; }
		// ⛔ MONOLINGUAL PAIRS RENDER THIS LINE TWICE. On EN→RU the stored translation and this
		// template line are two different strings («прошедшее время от go» beside «пошёл»), so both
		// earn their place. On EN→EN they are THE SAME STRING: the corpus stores a form row's
		// defining phrase in the fixed shape "<kind> of <lemma>" (translation-lang-en §3), and this
		// line builds "<kind> of <lemma>" from WORD_FORM_KINDS_EN + the lemma. So `went` rendered
		// "past tense of go · past tense of go" — once from the data, once from the template.
		//
		// The line is the redundant half, so the line is what goes. ⛔ NOT the stored translation:
		// `definition.definition` is NOT NULL, and word lists and learn cards read it — the corpus
		// must keep storing the anchor. This suppression is a DISPLAY decision, which is where it
		// belongs ([[feedback_corpus_stores_ui_decides]]).
		//
		// Suppressed HERE rather than at the call sites because there are two of them — the lemma
		// card's explanation block and the hover popup's second line — and this file has already
		// paid once for a per-def-language rule that lived at two call sites and was updated at one.
		if (data.languageCode && data.defLanguageCode && data.languageCode === data.defLanguageCode) {
			return null;
		}
		if (s.pos === 'contraction') {
			// senseNote carries the expansion ("do not"); the head names the fused auxiliary.
			// ⚠️ TWO strings, not one duplicated: `contractionOf` ends in a preposition because an
			// expansion follows it («Kurzform von „zu dem"»), while the table's own `contraction` key
			// — which the else-branch below falls back to — stands ALONE and must not, or the line
			// ends on a dangling "von". They are the same word with and without its preposition, so
			// they sit in the same column of DEF_LANG_WORDS and word_form_line_test.js §0 asserts the
			// second still starts with the first. Deriving one from the other would only move the
			// per-language part into a preposition table — the same number of strings, one more
			// indirection, and a formulation a future language may not want.
			var of = defLangWords(data.defLanguageCode).contractionOf;
			return s.senseNote ? of + ' «' + s.senseNote + '»'
			                   : wordFormKindLabel('contraction', data.defLanguageCode);
		}
		if (!data.lemma || data.lemma === data.term) { return null; }
		var line = wordFormKindPrefix(s.pos, data.defLanguageCode, data.lemma, data.languageCode) + data.lemma;
		// For a non-contraction the note is the aspect counterpart («сыграл») or similar — short,
		// word-specific, worth its place beside the template line.
		if (s.senseNote) { line += ' · ' + s.senseNote; }
		return line;
	}

	function verbFormHead(data) {
		if (!data || !data.lemma || data.lemma === data.term) { return null; }
		var senses = data.senses || [];
		if (!senses.length) { return null; }
		// A thin word-form row (category, not pos: the pos slot carries the open set of form
		// kinds). The head's card opens with the form's explanation block above it. Headless rows
		// (transparent proper nouns) never reach here — their lemma equals their term.
		if (data.category === 'word_form') {
			return { term: data.lemma, mark: { fromForm: data.term, wordForm: true } };
		}
		// A combo names ONE cell of the paradigm, so the head verb's card marks that cell — the term
		// IS the key, exactly matching the cell's data-combo (see highlightConjCell). A principal-parts
		// card has no single cell (it is the whole set), so its card marks the verb sense's principal
		// parts instead. The two marks are alternatives, never both — same pair, same reason, as
		// learning_session.js bindTermStudy.
		//
		// ⛔ The CATEGORY is the test, not the pos, since F2a. `phrase_verb_conj` is a GERMAN pos —
		// it is what RichTranslationService.conjugationPhrases writes onto a minted combo. A Spanish
		// cell is one row in two roles (plan §7 F2a part 2): its category is `verb_form` and its pos
		// is the form KIND (`verb_pres_ind_1sg`), so a pos test matched neither branch and clicking a
		// Spanish form silently lost head-substitution. Every one of the 21,795 German cells is
		// `verb_form` too (TermRepository.loadHeadSensesByFormTerm's own note), so this narrows
		// nothing German ever had.
		if (data.category === 'verb_form' || senses[0].pos === Util.VERB_FORM_POS) {
			return { term: data.lemma, mark: { conjHighlight: data.term, fromForm: data.term } };
		}
		if (senses[0].pos === Util.VERB_FORMS_POS) {
			return { term: data.lemma, mark: { focusVerb: true, fromForm: data.term } };
		}
		return null;
	}

	// fetchRichEntry, but handing back the entry a rich view should actually SHOW: normally the one
	// asked for, and for a verb form its head verb's, with the mark that names the form on it.
	// cb(data, xhr, mark) — mark is null when nothing was swapped, and otherwise the extra opts for
	// renderRichEntry plus `formEntry`, the form's OWN entry, for the one caller that still needs it
	// (richLookupCore builds a lean row for the word that was clicked, not for the card it shows).
	function fetchRichEntryToShow(word, trusted, cb, ignoreDirection, openMatch) {
		fetchRichEntry(word, trusted, function (data, xhr) {
			var head = xhr ? null : verbFormHead(data);
			if (!head) { cb(data, xhr, null); return; }
			// Trusted, and it can never buy a generation the first hop didn't: a form only exists as a
			// Term because its verb's entry was there to build it from. Shares the same cache, so it is
			// already warm for any verb the reader has looked up before. Never openMatch — the head
			// verb IS what the first hop already resolved to, nothing left to open instead.
			fetchRichEntry(head.term, true, function (headData, headXhr) {
				if (headXhr || !headData || !headData.senses || !headData.senses.length) {
					cb(data, xhr, null);   // verb's entry unavailable — the form's own beats nothing
					return;
				}
				head.mark.formEntry = data;
				cb(headData, null, head.mark);
			});
		}, ignoreDirection, openMatch);
	}

	// Warm the cache for a word whose rich view we ALREADY KNOW we are going to show — a Learn meet
	// card (its reveal always opens the full entry) or a Practice card (a miss always reveals it).
	// Same request, same cache and same in-flight de-duplication as fetchRichEntry, only fired
	// earlier, so the view that follows renders straight from cache instead of stopping on
	// "Looking up…" for the length of a round trip. Result AND failure are dropped on purpose: the
	// real caller still runs its own fetchRichEntry, which either finds the entry warm or piggybacks
	// on this very request while it is still in flight, and an error is never cached — so a prefetch
	// that fails costs nothing beyond a retry at the moment it actually matters.
	//
	// trusted=true because only our OWN data is ever prefetched (a session card's term). Callers must
	// only prefetch words whose entry is already STORED (a Learn/Practice card carries senseIds, so
	// its rich entry exists): rich-translate is DB-first but generates on a miss, and a speculative
	// prefetch may not buy a paid generation for a word the learner might never open.
	window.prefetchRichEntry = function (word) {
		if (!word) { return; }
		fetchRichEntry(word, true, function () { /* warming only — the real render refetches from cache */ });
	};

	// Batch form for a known word list (a Learn session's tray). `cap` bounds how much of the batch is
	// warmed and `staggerMs` spreads the requests over ticks rather than firing them in one burst that
	// would compete with the very card the user is looking at — the same knobs, and the same reasons,
	// as PlSound.prefetchMany.
	window.prefetchRichEntries = function (words, opts) {
		opts = opts || {};
		var cap = opts.cap || Infinity;
		var staggerMs = opts.staggerMs || 0;
		var seen = {};
		var deduped = [];
		for (var i = 0; i < words.length && deduped.length < cap; i++) {
			var w = words[i];
			if (!w || seen[w]) { continue; }
			seen[w] = true;
			deduped.push(w);
		}
		deduped.forEach(function (w, idx) {
			if (staggerMs > 0) { setTimeout(function () { window.prefetchRichEntry(w); }, idx * staggerMs); }
			else { window.prefetchRichEntry(w); }
		});
	};

	// Build the "Looking up… + progress bar" markup. `hostClass` lets the caller tag the wrapper so a
	// stray one (fetch outlives the row) can be found and swept by collapseRich.
	function loadingHtml(hostClass) {
		return '<div class="rich-loading' + (hostClass ? '-inline ' + hostClass : '') + '">'
			+ '<div class="rich-loading-text">' + escHtml(getRes("rich_loading_message") || "Looking up…") + '</div>'
			+ '<div class="rich-loading-bar"><div class="rich-loading-bar-fill"></div></div>'
			+ '</div>';
	}

	// Project a freshly-generated rich entry into the lean cluster shape buildEntryElement expects, so a
	// drilled-in word (which had no dictionary row) can be given a real lean row behind its card. The
	// word is now in the index (write-through on generate), so we can also reconstruct its scroll cursor
	// (base64 of "display id", UTF-8) — best-effort; it only matters if the row lands on a scroll edge.
	function leanClusterFromRich(r) {
		var posGroups = [];
		var senseGroups = [];   // the sense-grained projection the redesigned lean row renders from
		(r.senses || []).forEach(function (s) {
			if (s.translations && s.translations.length) {
				// A provisional placeholder sense carries a MARKER where a pos goes (see the card's
				// own chip line) — the lean row must not print it either.
				var pos = (s.pos && s.pos !== 'provisional') ? s.pos : '';
				posGroups.push({ pos: pos, translations: s.translations.slice() });
				senseGroups.push({
					senseId: (s.senseId != null ? s.senseId : null),
					pos: pos,
					translations: s.translations.slice(),
					gloss: s.gloss || null
				});
			}
		});
		var cursor = null;
		try { cursor = btoa(unescape(encodeURIComponent(r.term + ' ' + r.termId))); } catch (ignored) {}
		return {
			term: { term: r.term, id: r.termId, transcription: r.transcription },
			definitionList: [{ posGroups: posGroups, senseGroups: senseGroups }],
			cursor: cursor
		};
	}

	// The quiet line under the head of a provisional card. `pending` says the rest is on its way;
	// `failed` says this is all there is for now. ⛔ NEITHER is an error (ruling R7): the learner
	// asked for a word and got its translation, which is the thing they came for — the red error
	// slot is for a lookup that answered nothing at all.
	function enrichStrip(state) {
		var failed = state === "failed";
		return $("<div class='enrichStripClass'></div>")
			.toggleClass("enrichStripFailedClass", failed)
			.text(failed
				? (getRes("rich_enrichFailed_message") || "Only the translation is ready for this word.")
				: (getRes("rich_enriching_message") || "The full entry is being prepared…"));
	}

	// Put (or replace) that strip directly under the card's head.
	function setEnrichStrip(slot, state) {
		slot.find(".enrichStripClass").remove();
		if (state === "pending" || state === "failed") {
			slot.find(".rich-head").first().after(enrichStrip(state));
		}
	}

	function stopEnrichPoll() {
		if (enrichPollTimer) { clearTimeout(enrichPollTimer); enrichPollTimer = null; }
	}

	// Watch a provisional card until the background job finishes it, then repaint it IN PLACE.
	//
	// `myToken` is the richLookupSeq value the card was opened with, and every callback re-checks it
	// against the live counter: collapsing the card, opening another word, or scrolling the row off
	// all bump that counter, so a superseded card can never be repainted under a reader who has
	// moved on. That is the same guard the original fetch uses (richLookupCore below).
	//
	// `cacheKey` is the richEntryCache key the card on screen was fetched under, or NULL when the
	// card is a word-form substitution (the HEAD verb's entry standing in for the form that was
	// clicked) — filing the head verb's entry under the form's key would answer the wrong word for
	// the rest of the session. The poll itself runs either way; only the cache write is skipped.
	//
	// `repaint` re-renders but deliberately does NOT scroll: the reader has been looking at this
	// card for seconds by now and may have scrolled down it, and yanking them back to the head would
	// be the change announcing itself. The card simply grows the rest of its content.
	function pollEnrichment(cacheKey, termId, slot, myToken, richOpts, ctx, openedFor) {
		var startedAt = Date.now();

		function repaint(data) {
			// renderRichEntry replaces the slot's contents wholesale (defArea.html), so the two
			// strips that live under the head are gone with it and the one still true is put back.
			renderRichEntry(data, slot, null, richOpts);
			// `openedFor` is stamped by rich-translate's openMatch answer only, so it is not on the
			// polled response — carried in from the first render so the "did you mean…" strip the
			// reader has been looking at does not vanish when the card fills in.
			if (openedFor && openedFor.how !== "exact") {
				slot.find(".rich-head").first().after(openMatchStrip(data.term, openedFor, ctx));
			}
			if (window.OB_TIPS) { OB_TIPS.evaluate(); }
		}

		function schedule() {
			// Out of time with the word still pending: leave the "being prepared" line standing —
			// it is still true, the job has its own much longer ladder — and stop asking. Reopening
			// the word starts a fresh poll, and by then it is normally done.
			if (Date.now() - startedAt >= ENRICH_POLL_MAX_MS) { return; }
			enrichPollTimer = setTimeout(tick, ENRICH_POLL_MS);
		}

		function tick() {
			enrichPollTimer = null;
			if (myToken !== richLookupSeq) { return; }
			$.ajax({
				url: "api/dictionary/rich",
				type: "GET",
				data: {
					termId: termId,
					defLang: langFromValField.attr("data-lang-code"),
					// Don't count a poll as a card opened: the reader opened this word ONCE, and
					// forty RICH_OPEN rows for one lookup would be forty in their history and forty
					// in the dashboard's "lookups" (DashboardService).
					poll: true
				},
				success: function (data, textStatus, xhr) {
					if (myToken !== richLookupSeq) { return; }
					// ⚠️ 204 while polling means "not renderable YET" — a queue row whose pair has no
					// entry to show (measured at B4 on a seeded row), or the vulgar/blocklist gate.
					// It is NOT "gone": keep waiting, and let the deadline end it.
					if (xhr.status === 204 || !data) { schedule(); return; }
					var state = data.enrichment || "done";
					if (state === "pending") { schedule(); return; }
					// Settled. Evict first, unconditionally: a copy of this word may have been filed
					// under this key BEFORE the enrichment started (a plain corpus hit that was later
					// queued), and that copy is now the stale one (build plan §1c).
					if (cacheKey) { delete richEntryCache[cacheKey]; }
					if (state === "done") {
						if (cacheKey) { richEntryCache[cacheKey] = data; }
						repaint(data);
					} else {
						setEnrichStrip(slot, "failed");
					}
				},
				error: function () {
					if (myToken !== richLookupSeq) { return; }
					// A dropped request is not a verdict about the word — keep polling. The deadline
					// is what ends this, in the one loop rather than in two places.
					schedule();
				}
			});
		}

		schedule();
	}

	// `ctx.leanRow` is always the word's lean entry: either its real dictionary row, or (when
	// `ctx.synthesized`) a term-only row we minted at the word's alphabetical slot because it isn't in
	// the index yet. The row stays visible with a "Looking up…" strip in its left column (under the
	// word). On success the card is rendered into a slot after the row and pinned to the top; the row is
	// hidden behind it. For a synthesized row we first swap it for a proper row built from the generated
	// entry (so its translation is right and closing the card reveals an ordinary lean entry).
	function richLookupCore(word, trusted, ctx) {
		resetWordPopup();
		stopEnrichPoll();   // the card being replaced may have been watching itself fill in
		var myToken = ++richLookupSeq;
		var leanRow = ctx.leanRow;

		// Inject the strip into the row's left column directly below the word (._entryTop), above the
		// right-aligned IPA, leaving the row itself intact.
		loadingStrip = $(loadingHtml("_richLoadingHost"));
		var termCol = leanRow.find("._termClass").first();
		var top = termCol.find("._entryTop").first();
		if (top.length) { loadingStrip.insertAfter(top); }
		else if (termCol.length) { termCol.append(loadingStrip); }
		else { leanRow.append(loadingStrip); }
		scrollToCenter(leanRow);
		startRichLoadingBar();

		fetchRichEntryToShow(word, trusted, function (data, xhr, mark) {
			if (myToken !== richLookupSeq) { return; }   // a newer open / collapse superseded this fetch
			stopRichLoadingBar();
			if (loadingStrip) { loadingStrip.remove(); loadingStrip = null; }

			if (xhr) {
				// Leave the lean row visible (strip gone); show the error in a slot below it.
				var errKey = "";
				try { errKey = JSON.parse(xhr.responseText).error || ""; } catch (ignored) {}
				if (errKey === "dict.error.wrongDirection") {
					// D9: the server refused to GENERATE because the word is a known key of the
					// reverse index — i.e. the learner typed their own language with the toggle on
					// the language being learned. Offer the flip; keep a way through for the rare
					// genuine term that merely coincides with an English meaning.
					var nudgeSlot = $('<div class="_richExpandClass"></div>').insertAfter(leanRow);
					expandedSlot = nudgeSlot;
					nudgeSlot.append(wrongDirectionNudge(word, ctx));
					return;
				}
				if (errKey === "dict.error.tooLong") {
					// The server-side authority for decision 8 — normally pre-empted by the client
					// check on Enter (isOverPhraseLimit), reached only if that was bypassed. Same
					// showMessage() treatment, not the inline error slot below: the lean row and the
					// field are left exactly as they were, nothing was persisted or counted.
					showMessage(getRes("phraseTooLong_message"));
					return;
				}
				var msg;
				if (errKey === "ai.error.unknownWord") {
					var tmpl = getRes("ai_unknownWord_error")
						|| '"{0}" is not a {1} word we know.';
					msg = strFormat(tmpl, word, langName(langToValField));
				} else if (errKey === "ai.error.disabled") {
					msg = getRes("ai_disabled_error") || "AI lookup is currently unavailable.";
				} else if (errKey === "ai.error.signIn") {
					// The guest pool is spent, or this guest's own daily budget is
					// (docs/project/go-public-hardening.md §8.3). Every limit behind this key
					// disappears with an account, which is why it is an invitation rather than the
					// generic "unavailable" — that one is for the limits nobody can do anything
					// about. Nothing was generated and nothing was charged.
					msg = getRes("ai_signIn_error") || "Sign in to look up new words today.";
				} else {
					msg = getRes("rich_failed_message") || "Lookup failed.";
				}
				var errSlot = $('<div class="_richExpandClass"></div>').insertAfter(leanRow);
				expandedSlot = errSlot;
				errSlot.html('<p class="ai-error-msg">' + escHtml(msg) + '</p>');
				return;
			}
			if (data && data.senses && data.senses.length) {
				if (ctx.synthesized) {
					// Replace the term-only placeholder with a real lean row built from the generated entry
					// (now it carries the translation), and register it with displayManager's list so it
					// behaves like any other row (scroll, pruning, exercise count). The row belongs to the
					// word that was CLICKED — which is the form, not the head verb standing in for it on
					// the card, hence mark.formEntry here.
					var cluster = leanClusterFromRich((mark && mark.formEntry) || data);
					var realRow = buildEntryElement(cluster, dictEntryUid++, '');
					leanRow.replaceWith(realRow);
					leanRow = realRow;
					if (displayManager) {
						var idx = realRow.prevAll("._entryClass").length;
						var l = displayManager.getDefList() || [];
						l.splice(idx, 0, cluster);
						displayManager.setDefList(l);
					}
				}
				leanRow.addClass("_entryReplaced");                       // the card takes its place
				expandedEntry = leanRow;
				var slot = $('<div class="_richExpandClass"></div>').insertAfter(leanRow);
				expandedSlot = slot;
				var richOpts = $.extend({ focusVerb: !!ctx.focusVerb,
					focusColloc: ctx.focusColloc || null }, mark);
				renderRichEntry(data, slot, null, richOpts);
				// R13 "Enter opens the match": `openedFor` travels on the entry the server actually
				// picked. A word-form substitution (verbFormHead, just above) swaps `data` for the HEAD
				// verb's own entry — which never carries the label, since that follow-up fetch never
				// asks for openMatch — so the label is read off `mark.formEntry` (the form's own entry,
				// stashed there for exactly this) when the card on screen is a substitution.
				var openedFor = (data && data.openedFor) || (mark && mark.formEntry && mark.formEntry.openedFor);
				if (openedFor && openedFor.how !== "exact") {
					slot.find(".rich-head").first().after(openMatchStrip(data.term, openedFor, ctx));
				}
				// A word minted a moment ago is PROVISIONAL: its one sense is the gate's translation
				// and the real entry is being built behind the reader (B4b). Say so under the head
				// and watch it fill itself in. `failed` gets the same treatment minus the waiting —
				// the translation on screen is still the answer to what was asked.
				// ⛔ Only the card that is OPEN polls; a word-form substitution shows the HEAD verb's
				// entry, so the id polled is the one the card was actually rendered from.
				if (data.enrichment === "pending") {
					setEnrichStrip(slot, "pending");
					// No cache key for an openMatch answer either — fetchRichEntry never files one
					// (R13: the entry a typed string resolves to is not a function of that string).
					var pollKey = (mark || ctx.openMatch) ? null : richEntryKey(word);
					pollEnrichment(pollKey, data.termId, slot, myToken, richOpts, ctx, openedFor);
				} else if (data.enrichment === "failed") {
					setEnrichStrip(slot, "failed");
				}
				// Card reads from its top down — except when it was opened for a verb's forms, where a
				// buried verb sense is what has to be on screen (the marked cell lives inside it), or
				// for ONE collocation reached from the search band, which renderRichEntry has just
				// marked: put that line in the middle of the band rather than the card's head.
				var collocHit = richOpts.focusColloc ? slot.find(".rich-colloc-hit").first() : null;
				if (collocHit && collocHit.length) { scrollToCenter(collocHit); }
				else { scrollToTop(verbSenseAnchor(slot, richOpts.focusVerb || !!richOpts.conjHighlight)); }
				// A rich entry on screen is a step of the onboarding tour (the lookup it was
				// asked for, and the entry itself) — nothing else repaints here, so this is
				// the hook that lets the walk move on the moment the card lands.
				if (window.OB_TIPS) { OB_TIPS.evaluate(); }
			} else {
				// Generated nothing usable — keep the lean row visible, show the message in a slot below it.
				var noSlot = $('<div class="_richExpandClass"></div>').insertAfter(leanRow);
				expandedSlot = noSlot;
				var noTmpl = getRes("ai_unknownWord_error") || '"{0}" is not a {1} word we know.';
				noSlot.html('<p class="ai-error-msg">'
					+ escHtml(strFormat(noTmpl, word, langName(langToValField))) + '</p>');
			}
		}, ctx.ignoreDirection, ctx.openMatch);
	}

	// The wrong-toggle nudge (D9). Two doors, in the order of likelihood: flip the dictionary to the
	// learner's own language and look the word up there, or — for the rare real term that happens to
	// coincide with an English meaning — insist, which re-runs the lookup with only this guard
	// lifted (the validity gate still applies, so it is not a door for gibberish).
	function wrongDirectionNudge(word, ctx) {
		var box = $("<div class='revNudgeClass'></div>");
		box.append($("<span class='revNudgeIconClass'></span>").text("ⓘ"));
		var body = $("<div class='revNudgeBodyClass'></div>");
		body.append($("<span></span>").text(strFormat(getRes("dict_wrongDirection_message"),
			word, langName(langFromValField))));
		body.append($("<button type='button' class='revNudgeSwitchClass'></button>")
			.text(strFormat(getRes("dict_wrongDirection_switch"),
				langFromValField.attr("data-lang-code"), langToValField.attr("data-lang-code")))
			.on("click", function () {
				collapseRich();
				richOpen = false;
				lookupField.val(word);
				// This is a deliberate "look this word up" action (the nudge named it), not a
				// resume-typing toggle click — silent + an explicit runReverseLookup keeps its own
				// framed count/see-also view, rather than the tape setDictDirection now re-runs for
				// an ordinary toggle click with existing text.
				setDictDirection('REVERSE', { silent: true });
				runReverseLookup(word);
			}));
		body.append($("<button type='button' class='revNudgeAnywayClass'></button>")
			.text(strFormat(getRes("dict_wrongDirection_anyway"), langName(langToValField)))
			.on("click", function () {
				openRichForCurrent(word, false, ctx.anchorIndex, { ignoreDirection: true });
			}));
		box.append(body);
		return box;
	}

	// R13 "Enter opens the match": the quiet strip under the card head when Enter opened a DIFFERENT
	// headword than what was typed — the tape's own prefix (`prefix`) or the input gate's typo fix
	// (`corrected`); never shown on `exact`. Modeled on wrongDirectionNudge above but deliberately
	// quieter (no icon, one line, subtler border) — nothing failed here, the card already shows a
	// real answer, this only offers the road not taken. `ctx.anchorIndex` is the TYPED text's own
	// alphabetical anchor (computed by navigateSeek before this card ever opened), still valid for
	// re-opening that same text — same reuse the "anyway" button above makes of it.
	function openMatchStrip(openedTerm, openedFor, ctx) {
		var typed = openedFor.typed;
		var msgKey = openedFor.how === "prefix"
			? "dict_openMatch_prefix_message" : "dict_openMatch_corrected_message";
		var box = $("<div class='openMatchStripClass'></div>");
		box.append($("<span></span>").text(strFormat(getRes(msgKey), openedTerm)));
		box.append($("<button type='button' class='openMatchLinkClass'></button>")
			.text(strFormat(getRes("dict_openMatch_lookup_link"), typed))
			.on("click", function () {
				openRichForCurrent(typed, false, ctx.anchorIndex, { openMatch: false });
			}));
		return box;
	}

	// variantId (optional) = term_ipa_variant id for heteronym senses (übersetzen): asks the
	// server for that pronunciation's clip. Absent → the term's default audio. dialect (optional,
	// "US"/"UK") = which dialect's voice — the rich head's per-dialect IPA chips pass theirs, so
	// the UK chip actually speaks BrE. Resolve/cache/play is the shared PlSound module
	// (static/js/sound.js) — Dictionary, rich view, and Word Lists (below) all funnel through
	// this one function into that one cache.
	function playAiSound(termId, variantId, dialect) {
		window.PlSound.play(termId, variantId, null, dialect);
	}

	// ── per-word action popup (translation + sound + add-to-list) ─────────────────────────────
	// Hovering a term-language word in the rich view reveals a small card above the word with its
	// translation and two action buttons. We resolve the word on hover via rich-translate
	// (DB-first, with the AI generate+persist fallback) to populate the translation; the same call
	// yields the termId (cached via fetchRichEntry) so the sound / add-to-list buttons act
	// instantly. Dismissal is immediate on leaving the word/popup; any in-flight sound keeps playing.
	var wordPopupEl = null;
	var wordPopupBarTimer = null;   // drives the popup's translation progress bar
	var wordPopupBarReveal = null;  // holds the bar back until the lookup is actually slow
	// How long a lookup may take before the popup admits it is working. A DB/cache hit lands well
	// inside this; only the live AI fallback (seconds) ever crosses it.
	var POPUP_BAR_GRACE_MS = 250;
	var wordPopupWord = null;   // the word string the popup currently acts on
	var currentWordEl = null;   // the DOM node the popup is anchored to
	// Resolver for the popup currently open: a function(cb) that yields {termId, trans} (or null).
	// A single word resolves via rich-translate; a conjugation combo resolves via its phrase-Term
	// cache. The popup body + the sound/add buttons all go through this, so the popup is agnostic
	// to what it is anchored on.
	var wordPopupResolver = null;
	// What the popup's add-to-list button does. A single word adds its one term; a conjugation cell
	// may add several (er/sie/es → three separate drill entries), so the add action is distinct from
	// the resolver the sound button and the translation line use.
	var wordPopupAddAction = null;

	function firstSenseTranslations(data) {
		if (data && data.senses && data.senses.length
				&& data.senses[0].translations && data.senses[0].translations.length) {
			return data.senses[0].translations.join(", ");
		}
		return "";
	}

	function resolveWord(word, cb) {
		// The popup only ever appears on a term token from our own rendered data → trusted.
		fetchRichEntry(word, true, function (data, xhr) {
			if (xhr || !data || !data.termId) {
				cb(null);
				return;
			}
			// The popup's second line: a thin form row explains itself («прошедшее время от
			// play»); a lemma row with a homograph twin names the OTHER reading of the same
			// spelling («также прош. вр. от rise: поднялся»).
			var line = null;
			if (data.category === 'word_form') {
				line = wordFormLine(data);
			} else if (data.formTwins && data.formTwins.length) {
				var twin = data.formTwins[0];
				line = twinAlsoLabel(data.defLanguageCode) + ' '
				     + wordFormKindPrefix(twin.formKind, data.defLanguageCode, twin.headTerm, data.languageCode) + twin.headTerm
				     + (twin.translation ? ': ' + twin.translation : '');
			}
			cb({ termId: data.termId, trans: firstSenseTranslations(data), formLine: line });
		});
	}

	// ── conjugation combos (pronoun + verb form, e.g. "du gingst") ─────────────────────────────────
	// Each combo is learned as a phrase Term (server-side, DB-first → cheap batch AI), giving it a
	// termId + translation so the popup, sound and add-to-drill reuse the per-word machinery. The
	// panel-open preload warms a whole paradigm in one request; a stray hover falls back to a single
	// fetch. Cache value {termId, trans}; null = the server couldn't resolve that combo.
	var comboCache = {};       // langTo|langFrom|combo -> {termId, trans} | null
	var comboInFlight = {};    // key -> [callbacks] awaiting the in-flight request

	function comboKey(combo) {
		return (langToValField.attr("data-lang-code") || "") + "|"
			+ (langFromValField.attr("data-lang-code") || "") + "|" + combo;
	}

	// POST the given combos (all already registered in comboInFlight) and notify their waiters.
	function requestCombos(forms, headTerm) {
		$.ajax({
			url: "api/dictionary/conjugation-phrases",
			type: "POST",
			contentType: "application/json",
			data: JSON.stringify({
				forms: forms,
				headTerm: headTerm,
				langTo: langToValField.attr("data-lang-code"),
				langFrom: langFromValField.attr("data-lang-code")
			}),
			success: function (list) {
				var got = {};
				(list || []).forEach(function (it) { got[it.form] = it; });
				forms.forEach(function (f) {
					var k = comboKey(f);
					var it = got[f];
					comboCache[k] = it ? { termId: it.termId, trans: it.translation } : null;
					notifyCombo(k, comboCache[k]);
				});
			},
			error: function () {
				// Not cached on error → a later hover retries.
				forms.forEach(function (f) { notifyCombo(comboKey(f), null); });
			}
		});
	}

	function notifyCombo(key, value) {
		var waiters = comboInFlight[key] || [];
		delete comboInFlight[key];
		waiters.forEach(function (fn) { fn(value); });
	}

	// Warm every combo of a freshly-opened conjugation panel in one batch (skips ones already
	// cached / in flight), so subsequent hovers are instant.
	function preloadCombos(forms, headTerm) {
		var need = [];
		forms.forEach(function (f) {
			var k = comboKey(f);
			if (Object.prototype.hasOwnProperty.call(comboCache, k) || comboInFlight[k]) {
				return;
			}
			comboInFlight[k] = [];
			need.push(f);
		});
		if (need.length) {
			requestCombos(need, headTerm);
		}
	}

	function resolveCombo(combo, cb) {
		var k = comboKey(combo);
		if (Object.prototype.hasOwnProperty.call(comboCache, k)) {
			cb(comboCache[k]);
			return;
		}
		if (comboInFlight[k]) {
			comboInFlight[k].push(cb);
			return;
		}
		comboInFlight[k] = [cb];
		requestCombos([combo]);
	}

	function isWithinCurrentWord(node) {
		return node && currentWordEl && (node === currentWordEl || $.contains(currentWordEl, node));
	}

	// True when node is the popup or inside it — i.e. the pointer is hopping from the word/cell
	// into its own popup (so we keep the highlight and don't dismiss).
	function popupContains(node) {
		return wordPopupEl && node && (node === wordPopupEl[0] || $.contains(wordPopupEl[0], node));
	}

	// Phase 4 step 3c: the 700ms dwell rides the chassis intent machine — but ONLY the
	// open side. The anchors are DELEGATED (every .term-word / .rich-conj-cell feeds this
	// one machine), so each enter stages what open() should show; isOpen is per-anchor, so
	// re-entering the popup's own word keeps it up (no pointless re-show) while a different
	// word arms a fresh dwell. Hides stay the legacy relatedTarget-gated SYNCHRONOUS
	// hideWordPopup() in the handlers below — machine.leave() is unusable here because the
	// per-anchor isOpen would no-op once a different anchor is staged and strand the popup;
	// the popup's invisible CSS bridge (not a grace timer) is what keeps word↔popup travel
	// alive. Deliberately OFF the layer stack, like PL.tip: a hover-transient surface must
	// never eat the Esc an open menu/dialog needs.
	var wordPopupNextEl = null;     // the anchor under the pointer (staged for open())
	var wordPopupNextShow = null;   // how to show it (word vs conjugation combo)
	var wordPopupMachine = PL.hover.intent({
		openDelay: 700,
		close: function () { hideWordPopup(); },   // required by the contract; never scheduled
		open: function () { if (wordPopupNextShow) { wordPopupNextShow(); } },
		isOpen: function () { return !!currentWordEl && currentWordEl === wordPopupNextEl; }
	});

	// The persistent highlight on the popup's anchor (kept while the popup is open, including when
	// the pointer is inside the popup). For a conjugation cell it also lights its row's pronoun.
	function setAnchorActive(anchorEl) {
		var $a = $(anchorEl);
		$a.addClass("rich-popup-active");
		if (anchorEl.classList && anchorEl.classList.contains("rich-conj-cell")) {
			$a.closest("tr").children(".rich-conj-pron").addClass("rich-conj-hl");
		}
	}

	function ensureWordPopup() {
		if (wordPopupEl) {
			return wordPopupEl;
		}
		wordPopupEl = $(
			'<div class="term-word-popup">'
			+ '<div class="term-word-popup-box">'
			+   '<div class="_twpTrans term-word-popup-trans"></div>'
			+   '<div class="term-word-popup-actions">'
			// One-press tray buttons (Placement C), left of add — and Add now precedes Sound
			// (was Sound·Add), matching the app-wide Add·(Mic)·Sound reading order everywhere
			// else (tray-add-buttons.md decision 6). display:flex here, so source order IS
			// reading order (unlike the float:right rich head).
			+     trayMarkButtonsHtml("pl-btn-icon")
			+     '<button type="button" class="pl-btn-icon _twpAdd">'
			+       '<span class="pl-ic pl-ic-list-plus"></span></button>'
			+     '<button type="button" class="pl-btn-icon _twpSound">'
			+       '<span class="pl-ic pl-ic-volume"></span></button>'
			+   '</div>'
			+ '</div>');

		// The two buttons on a floating card, and the one place in the app where a tooltip has to
		// sit ABOVE the word popup (design §6 #9/#10, decided 2026-08-09): z:"over-pop" lifts it
		// out of the popup's band, and guided:false keeps it the compact inert box in every mode —
		// a sticky 20em panel with a × over a hover-dismissed card would fight the card. Built
		// once with the popup itself, so this is a genuine attach, not a per-render one.
		PL.tip.attach(wordPopupEl.find("._twpSound"), {
			key: "sound_tooltip", z: "over-pop", guided: false,
			on: function (el, name, fn) { $(el).on(name, fn); }
		});
		// Same z:"over-pop"/guided:false treatment as the sound button above — the one place in the
		// app where a tooltip must sit ABOVE the word popup itself (design §6 #9/#10).
		PL.tip.attach(wordPopupEl.find("._trayLearnClass"), {
			key: "trayAddLearn_tooltip", z: "over-pop", guided: false,
			on: function (el, name, fn) { $(el).on(name, fn); }
		});
		PL.tip.attach(wordPopupEl.find("._trayPracticeClass"), {
			key: "trayAddPractice_tooltip", z: "over-pop", guided: false,
			on: function (el, name, fn) { $(el).on(name, fn); }
		});
		// The add button carries NO tooltip — it raises the list picker, which says everything the
		// tip used to (owner call 2026-08-16). Wired once with the popup, off whatever the popup is
		// currently showing (wordPopupAddAction is re-pointed on every open).
		wlAddWire(wordPopupEl.find("._twpAdd"), {
			add: function (listId) {
				var add = wordPopupAddAction;
				if (add) { add(currentWordEl, listId); }
			}
		});

		wordPopupEl.on("click", "._twpSound", function (e) {
			e.stopPropagation();
			var resolve = wordPopupResolver;
			if (resolve) {
				resolve(function (info) { if (info && info.termId) { playAiSound(info.termId); } });
			}
		});
		// (No click-to-add on ._twpAdd: pressing it opens the list picker, and the picker's row is
		// what files the word — see wlAddWire above.)

		// One-press tray buttons (Placement C) — a plain stage, same resolve-at-click-time shape as
		// the sound button above: wordPopupResolver/currentWordEl are re-pointed on every open, so
		// reading them fresh here (not captured at attach time) is what makes this show the word the
		// popup is CURRENTLY over. A conjugation-cell popup's resolver (resolveCombo) yields the same
		// {termId} shape as a plain word's (resolveWord), so one handler covers both — that termId is
		// the combo's own phrase Term, exactly what addComboCellToDrill already files.
		wordPopupEl.on("click", "._trayLearnClass, ._trayPracticeClass", function (e) {
			e.stopPropagation();
			var toLearn = $(this).hasClass("_trayLearnClass");
			var resolve = wordPopupResolver, srcEl = currentWordEl;
			if (!resolve || !srcEl) { return; }
			resolve(function (info) {
				if (info && info.termId) { trayStage(info.termId, toLearn, $(srcEl)); }
			});
		});

		// Leaving the popup hides it immediately — unless the pointer is heading back onto the
		// word it belongs to. The popup's invisible bottom padding bridges the visual gap so
		// word↔popup movement never crosses dead space and never makes it flicker.
		wordPopupEl.on("mouseleave", function (e) {
			// …or onto the add button's own picker, which lives on <body> and so reads as leaving
			// the card. Hiding here would drop wordPopupAddAction, and the picker's rows would
			// then file nothing — the destination was chosen for a word the popup had forgotten.
			if (wlPickEl && wlPickFor === wordPopupEl.find("._twpAdd")[0]) {
				return;
			}
			if (!isWithinCurrentWord(e.relatedTarget)) {
				hideWordPopup();
			}
		});

		wordPopupEl.appendTo(document.body);
		return wordPopupEl;
	}

	// Place the popup above the word. The element's bottom padding (CSS) is an invisible bridge;
	// BRIDGE is how far that hit area reaches down into the word — keep it in sync with the CSS
	// padding-bottom (padding-bottom = visual gap + BRIDGE).
	function positionWordPopup(popup, wordEl) {
		var BRIDGE = 6;
		// A DETACHED anchor has no position to hold, so the card goes rather than moves. An element
		// taken out of the document measures 0×0 at the origin, and the clamps below then park the
		// popup in the SCREEN's top-left corner — a translation floating over the page with nothing
		// to point at (owner report 2026-08-13, on the tour's "click a word" step). The way in is the
		// late resolve: the reader clicks the word they are hovering, the entry under it re-renders,
		// and the translation lands afterwards on an anchor that is no longer there.
		if (!wordEl || !wordEl.isConnected) {
			hideWordPopup();
			return;
		}
		var rect = wordEl.getBoundingClientRect();
		var pw = popup.outerWidth();
		var ph = popup.outerHeight();
		var left = Math.max(4, Math.min(rect.left, window.innerWidth - pw - 4));
		var top = Math.max(4, rect.top + BRIDGE - ph);
		popup.css({ left: left + "px", top: top + "px" });
	}

	// Open the shared popup above anchorEl, showing a progress bar until `resolver` yields the
	// translation (and warms the termId for the sound / add buttons). `token` identifies this open
	// so a late resolve from a popup the user already left is ignored. Used for both a single term
	// word and a conjugation combo.
	//
	// `staticLabel` (conjugation cells only) is text the popup shows INSTEAD of whatever the resolver
	// yields: no bar, no waiting, and the resolved translation is discarded. The resolver still runs,
	// because the termId it warms is what the sound and add-to-list buttons act on.
	function openTermPopup(anchorEl, token, resolver, addAction, staticLabel) {
		currentWordEl = anchorEl;
		wordPopupWord = token;
		wordPopupResolver = resolver;
		wordPopupAddAction = addAction;
		setAnchorActive(anchorEl);   // keep the highlight lit for as long as the popup is open

		var popup = ensureWordPopup();
		if (staticLabel) {
			popup.find("._twpTrans").empty()
				.append($('<div class="term-word-popup-form"></div>').text(staticLabel));
		} else {
			popup.find("._twpTrans").html('<div class="term-word-popup-bar"><div class="term-word-popup-bar-fill"></div></div>');
		}
		// Render (off-screen) so it can be measured, then position above the anchor.
		popup.css({ visibility: "hidden", display: "block", left: "0px", top: "0px" });
		positionWordPopup(popup, anchorEl);
		popup.css("visibility", "visible");
		clearInterval(wordPopupBarTimer);
		clearTimeout(wordPopupBarReveal);
		if (staticLabel) {
			// Nothing to wait for — the text is already up. The resolver still runs (below) to warm
			// the termId, but silently: no bar, and its result never reaches the screen.
			resolver(function () {});
			return;
		}
		// A known word resolves from the entry cache or one indexed DB read — tens of milliseconds,
		// far too short to read a progress bar, so painting one just makes the popup flicker (owner
		// report 2026-08-16). The bar keeps its SPACE from the first frame (hidden, so the popup does
		// not jump when it appears) and only becomes visible once the lookup has missed the grace
		// window, which is the AI-fallback case the bar was built for. See startAsymptoticFill.
		var bar = popup.find(".term-word-popup-bar").css("visibility", "hidden");
		wordPopupBarReveal = setTimeout(function () {
			bar.css("visibility", "visible");
			wordPopupBarTimer = startAsymptoticFill(popup.find(".term-word-popup-bar-fill"));
		}, POPUP_BAR_GRACE_MS);

		resolver(function (info) {
			clearInterval(wordPopupBarTimer);
			clearTimeout(wordPopupBarReveal);
			if (wordPopupWord !== token || currentWordEl !== anchorEl) {
				return; // the user moved on before it resolved
			}
			var transEl = popup.find("._twpTrans");
			transEl.text((info && info.trans) ? info.trans : "—");
			// Second, subtler line: a form row's template explanation or a twin's other reading.
			if (info && info.formLine) {
				transEl.append($('<div class="term-word-popup-formline"></div>').text(info.formLine));
			}
			positionWordPopup(popup, anchorEl); // height may have grown; keep it anchored above
		});
	}

	function showWordPopup(wordEl) {
		var word = $(wordEl).text().trim();
		noteTermWordContext(wordEl);   // the hover is what pays on a miss — give it the sentence
		openTermPopup(wordEl, word,
			function (cb) { resolveWord(word, cb); },
			function (srcEl, listId) {
				resolveWord(word, function (info) {
					if (info && info.termId) { addTermToWordList(info.termId, $(srcEl), listId); }
				});
			});
	}

	// Popup for a conjugation combo (e.g. hovering "gingst" → the whole "du gingst").
	//
	// It shows the CELL, not a translation, since 2026-08-27. The per-cell translation it used to
	// print was invented per cell and unsound by construction
	// (docs/project/conj-card-and-answer-matching.md §2/§3), and nothing was lost by dropping it:
	// everything a gloss could carry is already on the screen behind the popup — the form is the
	// cell, the person is the row header, the tense is the column header, and the MEANING is the
	// sense block this whole table is rendered inside. What the table cannot give is what stays:
	// sound and add-to-word-list, both keyed on the combo's termId, untouched.
	//
	// The identity line is the combo itself ("du gingst") — deliberately not a gloss and not a
	// grammar label (the row and column headers already are the grammar label). It earns its place
	// twice over: the cell shows only the bare form, so the pronoun is new information, and it is
	// exactly the string the add button is about to file into a word list.
	//
	// The combo's termId still comes from the phrase-Term cache the panel-open preload warmed, so the
	// buttons are live immediately; resolveCombo fetches on the spot if the preload hasn't landed.
	function showComboPopup(cellEl) {
		var combo = cellEl.getAttribute("data-combo");
		if (!combo) {
			return;
		}
		openTermPopup(cellEl, combo,
			function (cb) { resolveCombo(combo, cb); },
			function (srcEl, listId) { addComboCellToDrill(cellEl, srcEl, listId); },
			combo);
	}

	// Add a conjugation cell to the word list as ONE term — the whole combo including its pronoun
	// label ("er, sie, es geht"), which is exactly what the drill will ask the learner to type.
	// The combo resolves to its phrase Term DB-first, normally straight from the panel-open preload.
	// `listId` is the list the reader picked, and there is no other way in: an add always names its
	// destination (docs/project/wl-add-target-redesign.md).
	function addComboCellToDrill(cellEl, srcEl, listId) {
		var wlDbId = listId;
		var listVal = settings.myListPanel.flyTarget(wlDbId);
		if (!wlDbId) {
			showMessage(getRes("wlAddNoWordList_error_message"));
			return;
		}
		var combo = cellEl.getAttribute("data-combo");
		if (!combo) {
			return;
		}
		resolveCombo(combo, function (info) {
			if (!info || !info.termId) {
				return;
			}
			PL.fly(srcEl, listVal, 1000);
			listVal.flashClass("confirmBackground", 1000);
			ajaxPost("wordlist-add-word", { termId: info.termId, wordListId: wlDbId },
				function () {
					listVal.flashClass("confirmBackground");
					settings.myListPanel.addWordToList(wlDbId);
				}, "wlAdd_error_message");
		});
	}

	function hideWordPopup() {
		clearInterval(wordPopupBarTimer);
		clearTimeout(wordPopupBarReveal);
		if (wordPopupEl) {
			wordPopupEl.css("display", "none");
		}
		// Drop every persistent highlight (anchor + any lit pronoun) so nothing lingers once the
		// popup is gone — a sweep rather than $(currentWordEl) because a re-render can detach the
		// anchor out from under us. DOCUMENT-wide, for the same reason the hover handlers are
		// delegated on document (see the comment there): the tokens live in six places now — the
		// five rich-card hosts plus the collocation band, which hangs on #defBoxId, OUTSIDE #defId.
		// Scoped to #defId this cleanup simply missed the band, so every hovered word kept its
		// orange border and the row read as a multi-word selection (owner report 2026-08-10).
		$(".rich-popup-active").removeClass("rich-popup-active");
		$(".rich-conj-hl").removeClass("rich-conj-hl");
		currentWordEl = null;
		wordPopupWord = null;
		wordPopupResolver = null;
		wordPopupAddAction = null;
	}

	// Cancel any pending/visible popup — called whenever a new entry renders so a stale popup
	// never lingers over freshly loaded content.
	function resetWordPopup() {
		wordPopupMachine.cancel();
		hideWordPopup();
		// …and the add-target picker with it. Its anchor is a button on the content being
		// replaced: once that element is gone no mouseleave will ever fire, and the popover
		// would hang over the new page pointing at nothing.
		wlAddClosePicker();
	}

	// …and for a surface that takes its words away by DISAPPEARING rather than by re-rendering.
	// The tip popup is dismissed with Esc while the pointer still rests on one of its tease words:
	// the element goes, so no mouseleave ever fires, and the little translation card would hang
	// over the page until the next word anywhere was hovered.
	window.plResetWordPopup = resetWordPopup;

	// ── per-phrase sound (collocations & examples) ───────────────────────────────────────────────
	// A collocation / example sentence is pronounced as a whole via ElevenLabs (there is no
	// pre-recorded corpus for phrases). Audio is generated + cached server-side on first request,
	// keyed by the rich-entry row id, so it is generated at most once ever. A background preload
	// warms every phrase when the entry renders; a click on a not-yet-warm row shows a small
	// progress bar (same asymptotic driver as the per-word popup) until the audio is ready.
	var phraseSoundUrl = {};      // key "colloc_<id>" / "example_<id>" -> resolved mp3 URL (null = no sound)
	var phraseSoundAudio = {};    // key -> decoded Audio (lazy, on first play)
	var phraseSoundInFlight = {}; // key -> [callbacks] awaiting the in-flight metadata request

	// Tagged with the English in force, for the reason PlSound.keyOf() carries in full: the request
	// names no dialect, so the server answers it from the setting, and the same row id stands for two
	// different clips. Tagging keeps both — switching back to a variant already heard costs nothing.
	// Only `phraseSoundUrl` grows per variant on a preload; `phraseSoundAudio` holds a decoded clip
	// only for a phrase somebody actually pressed play on, so the memory the second variant adds is
	// what the reader listened to, not what the card contained.
	function phraseSoundKey(kind, id) {
		return kind + "_" + id + "_" + (window.en_dialect === "UK" ? "UK" : "US");
	}

	// Resolve (and cache) the phrase's audio URL via /api/phrase-sound. De-duplicates concurrent
	// requests for the same row (the preload warming it and a click can race). cb receives the URL,
	// or null when there is no sound. Errors are not cached (so a retry can succeed).
	// prefetch = the card's background warm-up is asking, not a press — the server writes it only on
	// the ledger row of a generation it causes (docs/project/sound-play-events.md).
	function fetchPhraseSoundUrl(kind, id, cb, prefetch) {
		var key = phraseSoundKey(kind, id);
		if (Object.prototype.hasOwnProperty.call(phraseSoundUrl, key)) {
			cb(phraseSoundUrl[key]);
			return;
		}
		if (phraseSoundInFlight[key]) {
			phraseSoundInFlight[key].push(cb);
			return;
		}
		phraseSoundInFlight[key] = [cb];
		// The dialect travels with the request for the reason PlSound's fetchSoundUrl carries in
		// full: a request that names it answers the same whenever it arrives, so a switch cannot be
		// overtaken by its own save. Only while English is the language being learned — a phrase in
		// any other language has no variant to ask for.
		var params = kind === "colloc" ? { collocId: id } : { exampleId: id };
		if ((langToValField.attr("data-lang-code") || "") === "EN") { params.dialect = enDialect(); }
		if (prefetch) { params.prefetch = 1; }
		$.ajax({
			url: "api/phrase-sound",
			type: "GET",
			data: params,
			success: function (sounds, status, xhr) {
				var url = (sounds && sounds.length > 0) ? sounds[0].url : null;
				// A guest's press refused on an audio limit an account lifts: the shared invitation.
				PlSound.noteSignIn(xhr);
				// "No clip" is not remembered: since the per-user audio caps it is often "not now"
				// (a pre-load past the soft cap, a clip over the pace — tts-per-user-caps-plan.md
				// R2/R4), and the next press is exactly what may get it. Costs a re-ask per press on a
				// phrase that truly has no voice, which is one small GET.
				if (url) { phraseSoundUrl[key] = url; }
				var waiters = phraseSoundInFlight[key] || [];
				delete phraseSoundInFlight[key];
				waiters.forEach(function (fn) { fn(url); });
			},
			error: function () {
				var waiters = phraseSoundInFlight[key] || [];
				delete phraseSoundInFlight[key];
				waiters.forEach(function (fn) { fn(null); });
			}
		});
	}

	// Re-warm the phrases of whatever rich card is open, in the variant now in force. Reads the rows
	// back out of the DOM rather than remembering them: the card that is on screen IS the list, and
	// it is the same `[data-phrase-id]` sweep that warmed them when the card was rendered.
	function rewarmPhraseSounds() {
		var rows = [];
		$(document).find("[data-phrase-id]").each(function () {
			rows.push({ kind: $(this).attr("data-phrase-kind"), id: $(this).attr("data-phrase-id") });
		});
		if (rows.length) { preloadPhraseSounds(rows); }
	}

	// A phrase that really started sounding goes into PlSound's play report, the same queue a word's
	// play joins (sound.js notePlay) — counted on the promise, so a refused autoplay is no play.
	function notePhrasePlay(started, kind, id) {
		var note = function () { PlSound.notePlay(kind === "colloc" ? "c" : "e", id); };
		if (started && typeof started.then === "function") { started.then(note, function () {}); }
		else { note(); }
	}

	function playPhraseSound(kind, id, btnEl) {
		var key = phraseSoundKey(kind, id);
		var decoded = phraseSoundAudio[key];
		if (decoded) {                       // already fetched once → replay instantly
			decoded.currentTime = 0;
			notePhrasePlay(decoded.play(), kind, id);
			return;
		}
		var $btn = $(btnEl);
		if ($btn.hasClass("loading")) {
			return;                          // a fetch for this button is already in flight
		}
		startPhraseBtnLoading($btn);
		// A press that joins the card's warm-up still in flight asks once more if that came back empty:
		// the server may defer a pre-load (tts-per-user-caps-plan.md R2/R4) and serve the same press.
		var joinedPreload = !!phraseSoundInFlight[key];
		fetchPhraseSoundUrl(kind, id, function onUrl(url) {
			if (!url && joinedPreload) {
				joinedPreload = false;
				fetchPhraseSoundUrl(kind, id, onUrl);
				return;
			}
			if (!url) {
				stopPhraseBtnLoading($btn);  // no sound available (e.g. TTS disabled)
				return;
			}
			fetch(url)
				.then(function (resp) { return resp.blob(); })
				.then(function (blob) {
					var audio = new Audio(URL.createObjectURL(blob));
					phraseSoundAudio[key] = audio;
					stopPhraseBtnLoading($btn);
					notePhrasePlay(audio.play(), kind, id);
				})
				.catch(function () { stopPhraseBtnLoading($btn); });
		});
	}

	// The practice popup's speaker plays whatever the popup is pointed at, and for a collocation or
	// an example that is this — cache, loading bar and all. Exported rather than re-implemented so
	// a phrase heard from the gutter and the same phrase heard inside the popup are one code path.
	window.plPlayPhraseSound = playPhraseSound;

	function startPhraseBtnLoading($btn) {
		$btn.addClass("loading");
		$btn.append('<span class="phrase-sound-bar"><span class="phrase-sound-bar-fill"></span></span>');
		$btn.data("barTimer", startAsymptoticFill($btn.find(".phrase-sound-bar-fill")));
	}

	function stopPhraseBtnLoading($btn) {
		var timer = $btn.data("barTimer");
		if (timer) {
			clearInterval(timer);
			$btn.removeData("barTimer");
		}
		$btn.removeClass("loading");
		$btn.find(".phrase-sound-bar").remove();
	}

	// The bar-in-the-button, for a sound button that lives outside a rich card. The tip of the
	// day's tease line waits on the same kind of first-ever ElevenLabs call, and a second
	// hand-rolled progress driver for it would be a second thing to keep in step with this one.
	window.plBtnLoading = { start: startPhraseBtnLoading, stop: stopPhraseBtnLoading };

	// Warm the server-side cache for every phrase in the just-rendered entry, one in flight at a
	// time so we never fan out a burst of ElevenLabs calls. Cached rows resolve synchronously and
	// just advance to the next — re-renders (history nav) cost nothing.
	function preloadPhraseSounds(rows) {
		var i = 0;
		(function next() {
			if (i >= rows.length) {
				return;
			}
			var row = rows[i++];
			fetchPhraseSoundUrl(row.kind, row.id, function () { next(); }, true);
		})();
	}

	// Add a whole collocation / example to the word list the reader picked, so it can be drilled.
	// The backend lazily turns the phrase into a (drillable) term on first add. Mirrors
	// addTermToWordList: same destination rule, fly-to-list animation, and error handling.
	function addPhraseToWordList(kind, id, sourceEl, listId) {
		var wlDbId = listId;
		var myListVal = settings.myListPanel.flyTarget(wlDbId);

		if (!wlDbId) {
			showMessage(getRes("wlAddNoWordList_error_message"));
			return;
		}

		var src = (sourceEl && sourceEl.length) ? sourceEl : $("#defId .rich-card");
		PL.fly(src, myListVal, 1000);
		myListVal.flashClass("confirmBackground", 1000);

		// defLang is REQUIRED: it decides which translation of the phrase is stored and which
		// language the phrase's own Definition is minted in. Without it the server fell back to the
		// term's lowest-id definition row, which is English for essentially every German word — so
		// a Russian reader filed an English card. Same field /api/phrase/pick reads.
		var requestParams = { wordListId: wlDbId, defLang: langFromValField.attr("data-lang-code") };
		if (kind === "colloc") {
			requestParams.collocId = id;
		} else {
			requestParams.exampleId = id;
		}
		ajaxPost("api/phrase/add-to-list", requestParams, function () {
			myListVal.flashClass("confirmBackground");
			settings.myListPanel.addWordToList(wlDbId);
		},
		"wlAdd_error_message");
	}

	// ── The add target: the picker, and nothing else ──────────────────────────────────────────────
	// Design: docs/project/wl-add-target-redesign.md. Every add control in the app — a dictionary
	// row's "A", the rich card's button, a hovered word's popup, a collocation or example row, a
	// conjugation cell — answers the SAME gesture, whatever its size:
	//
	//   • hover (or press) the control → the list picker opens straight away;
	//   • click a list in it → the word is filed THERE.
	//
	// The control itself files nothing. There is no standing destination and no tooltip naming one:
	// a word only ever lands in the list the reader named in the same gesture, which is the failure
	// the redesign existed to fix (owner call 2026-08-16, superseding the pinned-list model that
	// shipped in PR #737 — a pin is a second piece of state to learn, and the picker was already
	// the honest answer). Two moves per add rather than one, and the destination is never a guess.
	var wlPickEl = null;      // the open picker, when shown
	var wlPickLayer = null;   // its PL.layers handle
	var wlPickFor = null;     // the control it belongs to (one picker at a time, whoever opened it)

	function wlAddPanel() {
		return settings ? settings.myListPanel : null;
	}

	function wlAddClosePicker() {
		if (wlPickLayer) { wlPickLayer.close(); }   // teardown lives in the layer's onClose
	}

	/**
	 * Give one add control its picker. `spec.add(listId)` performs THIS control's add into the list
	 * the reader clicked — the only add path there is, so every caller must pass one through.
	 */
	function wlAddWire($el, spec) {
		if (!$el || !$el.length) { return; }
		var machine = PL.hover.intent({
			// The machine's own default intent (150ms) and nothing more: the picker IS the control's
			// answer to a hover now, so it must feel like the control lighting up rather than
			// something earned by waiting. The 150ms is only there to stop a pointer sweeping across
			// a column of dictionary rows from unfolding a popover per row.
			closeDelay: 600,         // the shared grace, so a diagonal path into the picker survives
			open: function () { wlAddOpenPicker($el, spec, machine); },
			close: wlAddClosePicker,
			isOpen: function () { return !!wlPickEl && wlPickFor === $el[0]; },
			// Naming a new list is resolved by Enter or Escape, never by hover-away — the same
			// protocol the add menu's count fields use.
			suspended: function () { return !!(wlPickEl && wlPickEl.find("input").length); }
		});
		// jQuery handlers rather than machine.bind(): the smoke harness drives this surface with
		// $(sel).trigger("mouseenter") — CDP mouse input is dead in this Chrome
		// (docs/feedback/smoke-cdp-mouse-input-dead.md) — and a NATIVE listener never sees that.
		$el.on("mouseenter", function () { machine.enter(); })
			.on("mouseleave", function () { machine.leave(); })
			// A press opens the same picker at once, without the intent wait — the button has no
			// other meaning, and this is the path a reader who clicks before the hover lands takes.
			.on("click", function (e) {
				e.preventDefault();
				e.stopPropagation();
				machine.cancel();
				if (!(wlPickEl && wlPickFor === $el[0])) { wlAddOpenPicker($el, spec, machine); }
			});
	}

	// The collocation / example gutter button, on both surfaces that render one: the rich card's
	// phrase rows and the dictionary's phrase band. The two name their text element differently
	// (that is the only difference), and a row carries its own kind + id, so one wiring serves both.
	function wlAddWirePhraseBtn($btn) {
		var row = $btn.closest("[data-phrase-id]");
		var kind = row.attr("data-phrase-kind");
		var id = row.attr("data-phrase-id");
		if (!kind || !id) { return; }
		wlAddWire($btn, {
			add: function (listId) {
				addPhraseToWordList(kind, id,
					row.find(".rich-colloc-term, .rich-example-term, .phBandTextClass").first(), listId);
			}
		});
	}

	function wlAddOpenPicker($anchor, spec, machine) {
		var panel = wlAddPanel();
		// A live learning session switches the add affordances off; the picker goes with them.
		if (!panel || panel.isAddDisabled()) { return; }
		// The card/row may have been re-rendered while the open intent was pending.
		if (!$anchor.length || !document.contains($anchor[0])) { return; }
		// No early return on an empty list set: the "New list…" row below is then the ONLY way
		// forward, and a control that answers a hover with nothing at all is just broken.
		var lists = panel.fileableLists();
		wlAddClosePicker();
		PL.tip.hideAll();   // a tip lingering from a neighbour must not sit over the picker
		wlPickEl = $("<div class='wlPopoverClass wlAddPickClass wlPopScrollClass'></div>");
		wlPickFor = $anchor[0];
		wlPickEl.append($("<div class='wlAddMenuHeadClass'></div>").text(getRes("wlAddPick_label")));
		// The list rows are the ONLY thing that scrolls: the head above and "New list…" below are
		// pinned outside the scroller, because a reader may legally hold 100 lists in a language
		// and the onramp must not be the row that scrolls away (see .wlPopScrollClass).
		var body = $("<div class='wlPopScrollBodyClass'></div>");
		$.each(lists, function (_, it) {
			var row = $("<div class='wlPopoverItemClass wlAddPickRowClass'></div>");
			// An empty gutter, kept so the list names line up with "＋ New list…" underneath them.
			row.append($("<span class='wlAddPickMarkClass'></span>"));
			row.append($("<span class='wlAddPickNameClass'></span>").text(it.name));
			row.click(function (e) {
				e.preventDefault();
				e.stopPropagation();
				wlAddClosePicker();
				spec.add(it.id);
			});
			body.append(row);
		});
		wlPickEl.append(body);
		wlPickEl.append(wlAddPickNewRow(panel, spec));

		$("body").append(wlPickEl);
		wlPositionPopover(wlPickEl, $anchor);
		wlPickEl.click(function (e) { e.stopPropagation(); });
		if (machine) {
			// The picker feeds the SAME machine as its opener — moving from one into the other
			// keeps it alive; the jQuery bindings die with the element on close.
			wlPickEl.on("mouseenter", function () { machine.enter(); });
			wlPickEl.on("mouseleave", function () { machine.leave(); });
		}
		wlPickLayer = PL.layers.push({
			el: wlPickEl[0],
			anchors: [$anchor[0]],   // the control itself is never an "outside" press
			onClose: function () {
				wlPickLayer = null;
				if (wlPickEl) {
					wlPickEl.remove();
					wlPickEl = null;
				}
				wlPickFor = null;
			}
		});
	}

	// The create-onramp at the moment the need is born: the reader is filing a word and discovers
	// there is no list for it yet. Names it in place, and the word goes straight into it — naming
	// the list IS choosing it, exactly like clicking one of the rows above.
	function wlAddPickNewRow(panel, spec) {
		var row = $("<div class='wlPopoverItemClass wlAddPickNewClass'></div>");
		row.append($("<span class='wlAddPickMarkClass'>" + plIcon("plus") + "</span>"));
		var label = $("<span class='wlAddPickNameClass'></span>").text(getRes("wlAddPickNew_label"));
		row.append(label);
		row.click(function (e) {
			e.preventDefault();
			e.stopPropagation();
			if (row.find("input").length) { return; }   // already naming one
			var input = $("<input type='text' class='wlInlineInputClass' maxlength='50'/>")
				.attr("placeholder", getRes("wlNewListPlaceholder"));
			label.replaceWith(input);
			input.focus();
			input.click(function (ev) { ev.stopPropagation(); });
			input.on("keydown", function (ev) {
				ev.stopPropagation();   // Esc/Enter belong to this field, not to the page
				if (ev.which === PL.keys.ENTER) {
					var name = input.val();
					wlAddClosePicker();
					panel.createList(name, function (newId) { spec.add(newId); });
					ev.preventDefault();
				} else if (ev.which === PL.keys.ESCAPE) {
					wlAddClosePicker();
				}
			});
		});
		return row;
	}

	// Below the control, clamped to the window — flipped ABOVE it when the control sits low enough
	// that the popover would hang off the bottom (a collocation row near the fold), and then CAPPED
	// in pixels to whatever room the chosen side actually has.
	//
	// The cap is what turns "rows hang off the bottom of the screen, unreachable" into "rows scroll
	// inside the popover", so it only means anything on a popover carrying .wlPopScrollClass (which
	// is also what makes it border-box, so a px cap is the OUTER height). Anything else just gets
	// the placement, exactly as before.
	//
	// Shared by the add picker and the Move/Copy popover — both are a row per word list, and the
	// list count they render is the reader's, up to learn.word-lists.max-lists-per-language = 100.
	function wlPositionPopover(popEl, $anchor) {
		var off = $anchor.offset();
		var left = Math.min(off.left, $(window).width() - popEl.outerWidth() - 12);
		var viewTop = $(window).scrollTop() + 4;
		var viewBottom = $(window).scrollTop() + $(window).height() - 8;
		var belowTop = off.top + $anchor.outerHeight() + 4;
		var roomBelow = viewBottom - belowTop;
		var roomAbove = (off.top - 4) - viewTop;
		// Flip only when below genuinely cannot hold it AND above holds more: a flip that buys no
		// extra room just moves the same overflow to the other end of the screen.
		var flip = popEl.outerHeight() > roomBelow && roomAbove > roomBelow;
		var room = flip ? roomAbove : roomBelow;
		// The 140px floor keeps a control squeezed between two edges from collapsing the popover to
		// a sliver — it may then overflow a little, which beats being unusable.
		if (popEl.outerHeight() > room) { popEl.css("max-height", Math.max(room, 140) + "px"); }
		// Re-measured: the cap above may just have shortened it, which is what the flip subtracts.
		var top = flip ? Math.max(viewTop, off.top - popEl.outerHeight() - 4) : belowTop;
		popEl.css({ top: top, left: Math.max(4, left) });
	}

	// ── Central mode tabs: Dictionary | Learn | Practice ────────────────────────────────────────
	// The contextual add destination = pipeline-next from the active tab: Dictionary and Learn both
	// feed the Learning tray, Practice feeds the Practice tray ("Look up — Learn — Drill!", the tabs
	// run left-to-right in pipeline order). Read at action time so a tab switch needs no resync —
	// openAddMenu routes at click, and setActiveTab repaints every destination-bearing control
	// (header icon, per-row buttons, and each list's Add pill) so they follow the tab immediately.
	function addDestIsLearning() { return activeTab !== 'practice'; }
	// The destination's own garden art, not an emoji: Learning = the sprout (you plant it),
	// Practice = the watering can (you water it) — the same two files the Learn/Practice tabs
	// wear, so "where does this word go" is answered by one picture everywhere it is asked.
	// Returns MARKUP, so every consumer must use .html(), never .text().
	function addDestIcon() { return GARDEN.markIcon(addDestIsLearning() ? "sprout" : "water"); }

	// A "staged" tab shows a fixed, in-memory set of lean rows in #defId that a drill-in must restore
	// on collapse: the Practice tray and the Learn tray both work this way (same rows, same rich-drill,
	// same return mechanism). Dictionary is NOT staged — it's a live, scrollable index.
	function isStagedTab() { return activeTab === 'practice' || activeTab === 'learn'; }

	function setActiveTab(which) {
		activeTab = which;
		// Persist the chosen tab (its own user attr) so a reload lands back on it. Gated so the
		// initial dict landing + the restore-to-saved-tab below don't clobber the stored value.
		if (tabPersistReady) { ajaxPostUserAttr("selectedTab", which); }
		var dict = which === 'dict';
		var learn = which === 'learn';
		var practice = which === 'practice';
		// Leaving Dictionary tears the phrase band down. It has to happen HERE and not in the two
		// chrome functions: the dock lives in #defBoxId — the box all three tabs render into, outside
		// the #defId the list re-render wipes — so nothing else on the way into Learn/Practice removes
		// it, and the band (plus the query it was asked for) rode along into the tray. Forget, not just
		// remove: the search box is cleared on the way out too, so the cached answer is stale as well.
		if (!dict) {
			phraseBandForget();
			doc.setLookupText("");   // no stale query left to highlight inside the staged tray rows
		}
		$("#tabDictId").toggleClass('tabActive', dict).attr('aria-selected', dict);
		$("#tabLearnId").toggleClass('tabActive', learn).attr('aria-selected', learn);
		$("#tabPracticeId").toggleClass('tabActive', practice).attr('aria-selected', practice);
		// Per-tab surface tint (wayfinding cue now that the three tabs render identical rows):
		// Dictionary keeps the lavender canvas, Learn goes faint green, Practice faint red. The
		// #centralModeId[data-tab] scope re-hues the surface + CTA tokens (tokens.css); nothing
		// outside the central column (Word Lists panel, side rails) is touched.
		$("#centralModeId").attr("data-tab", which);
		// Every rendered per-row add button and each list's Add pill follow the active tab —
		// repaint them now so a tab switch updates an open list's pill immediately (it used to
		// refresh only on hover).
		var icon = addDestIcon();
		$(".wlRowAddClass, .wlGardenSecAddClass").html(icon);
		if (settings && settings.myListPanel && settings.myListPanel.repaintAddDest) {
			settings.myListPanel.repaintAddDest();
		}
		// Beacon tips (spec §6): a tab switch changes which anchors are on stage.
		if (window.OB_TIPS) { OB_TIPS.evaluate(); }
	}

	// Dictionary mode chrome only (box show/hide + active tab + search policy). No history push and
	// no content load, so popstate can re-apply the Dictionary look while restoring its own content.
	function applyDictChrome() {
		richOpen = false; practiceReturn = null;   // leaving whatever was expanded; start lean
		clearFinishExcursion();   // a mode tab leaves the finish screen for good
		if (window.LRN) { LRN.leave(); }           // a live learning session dies with its tab (state persists per event)
		progressBox.hide();
		$("#exerciseResultId").empty();             // drop any lingering "Not quite correct"/"You've done it!" overlay
		defExerciseBox.hide();
		learnBox.hide();
		learnControlBand.hide().empty();   // the Learn-only top band never shows outside the Learn tray
		defBox.show();
		tipBox.hide();
		answerBox.hide();
		stopButton.hide();

		$("#exerciseControlBandId").hide();
		lookupBox.show();
		lookupField.trigger("focus");   // land ready to type, no extra click to start a lookup
		// No tooltip on the lookup field — its placeholder ("Start typing here…") already says it.

		$("#centralTabsId").show();
		setActiveTab('dict');
		sizeCenterBoxToPanel();

		searchView();            // DisplayPolicySearch + keydown binding
		isExerciseView = false;
	}

	// Load the Dictionary lean list into #defId (the content, after applyDictChrome).
	function showDictLean() {
		// No learning language chosen yet → prompt instead of seeking (a null termLang can't bind).
		if (!langToValField.attr("data-lang-code")) {
			$("#defId").html("<div class='_noWordsClass'>" + getRes("chooseLangTo_message") + "</div>");
			return;
		}
		// Reverse mode survives a trip through another tab: re-run the lookup for whatever is still
		// in the box rather than seeking the alphabetical dictionary to an English word.
		if (isReverseDict()) {
			var typed = lookupField.val().trim();
			if (typed) { runReverseLookup(typed); } else { renderReverseIntro(); }
			return;
		}
		// Show the dictionary: the current query if any, else browse from the start (A…). loadWords
		// posts /dictionary/seek — an empty pattern returns the first page + scroll cursors.
		displayManager.loadWords();
	}

	// Dictionary mode: search + reference. Practice controls (Random / Start Exercise) hidden. A user
	// tab click lands here and pushes its own lean history entry; already-at-dict-lean is a no-op so
	// repeated clicks don't stack identical entries. (popstate restores dict via applyDictChrome
	// directly, never through here, so it adds no history.)
	function dictionaryTabView() {
		if (activeTab === 'dict' && !richOpen) { return; }   // already showing the dict lean list
		applyDictChrome();
		pushLeanEntry('dict');
		showDictLean();
	}

	// Practice mode: assemble a set (Random / list) and Start Exercise. Search hidden. A user tab
	// click lands here and pushes its own practice-lean history entry; the set that gets shown is
	// stamped into that entry (commitPracticeSet) so Back/Forward restores it exactly. Already-showing-
	// a-practice-set is a no-op so returning to Practice keeps the same set (no surprise regenerate)
	// and repeated clicks don't stack entries. (popstate restores practice via randomWordsView
	// directly, never through here, so it adds no history.)
	function practiceTabView() {
		if (activeTab === 'practice' && !richOpen) { return; }   // already showing a practice set
		// Leaving Dictionary: drop the search text so a later drill-in to the dictionary doesn't
		// re-highlight the stale query. The lookup box is hidden in Practice, so the value would
		// otherwise linger invisibly and resurface (highlighted) on the next dictionary seek.
		doc.setLookupText("");
		randomWordsView();           // practice visibility + active tab
		pushLeanEntry('practice');   // new practice-lean entry; its setId is stamped in below
		var snap = (lastPracticeSetId != null) ? wordSetSnapshots[lastPracticeSetId] : null;
		if (snap && Util.isNotEmpty(snap.list)) {
			// Show the set you last saw (random or word-list) — it sticks across Dictionary trips
			// instead of regenerating. Stamp its id into this new entry so a later Back/Forward onto
			// it restores the same set. (A Dictionary visit trampled displayManager's list/policy,
			// which is why we restore from the snapshot by id rather than trusting whatever list is
			// currently loaded.)
			replaceNav(navStateForSet(lastPracticeSetId));
			restoreWordSet(lastPracticeSetId);
		} else {
			// No set yet (first visit, cleared tray, or a language change) — the tray starts EMPTY.
			// No background auto-fill: that was landing-page onboarding; words now arrive only via
			// a word list's "Add to Practice". The hint tells a novice where to look.
			showPracticeEmpty();
		}
	}

	// Learning mode chrome — the TRAY view. The tray now renders through the SAME path as Practice:
	// lean rows (buildEntryElement) in the shared #defId box, with sound / add-to-list / rich-drill,
	// plus per-row learning badges. The rung-ladder SESSION is the one thing that still lives in
	// #learnBoxId (learnSessionChrome swaps the boxes when a session starts/ends). No history push
	// here, so popstate can re-apply the Learn look directly (same contract as applyDictChrome).
	function applyLearnChrome() {
		richOpen = false; practiceReturn = null;
		clearFinishExcursion();   // a mode tab leaves the finish screen for good
		progressBox.hide();
		$("#exerciseResultId").empty();
		defExerciseBox.hide();
		learnBox.hide();          // the session box — hidden in the tray view
		defBox.show();            // the tray renders into the shared #defId box, like Practice
		tipBox.hide();
		answerBox.hide();
		stopButton.hide();
		$("#exerciseControlBandId").hide();   // the practice Start band; the Learn CTA band shows instead
		lookupBox.hide();
		$("#centralTabsId").show();
		if (settings.myListPanel.panelAttrToShow) {
			settings.myListPanel.showPanel(false);
		}
		setActiveTab('learn');
		isExerciseView = false;
		// showTray fills #defId with the tray rows AND reveals the top control band (Start Learning!
		// + Clear); size the box AFTER, so the now-visible band is counted and the Learn panel lands
		// on the same height as the Practice panel (whose band is likewise chrome above the box).
		if (window.LRN) { LRN.showTray(); }
		sizeCenterBoxToPanel();
	}

	// Render the current Learn tray as lean rows in #defId (the exact Practice rendering) — or a
	// centred empty-tray hint when it's empty — and repaint the Start Learning! / Clear band. The
	// per-row learning badges are added by displayAll → LRN.decorateTray. Exposed as
	// window.renderLearnTray so learning_session.js (its own closure) can trigger a tray repaint
	// after words are added / a session ends. The badge status round-trip lives in decorateTray.
	function showLearnTray() {
		if (!displayManager) { displayManager = new DisplayManager(); }
		disableDictScroll();                 // the tray is a fixed set, not a scrollable dictionary
		var tray = (window.LRN && LRN.getTray) ? (LRN.getTray() || []) : [];
		if (!tray.length) {
			displayManager.setDefList([]);
			renderLearnEmptyHint();
		} else {
			displayManager.setDefList(tray);
			displayManager.displayAll();     // buildEntryElement rows + decorateTray badges
		}
		if (window.LRN && LRN.renderCta) { LRN.renderCta(tray.length > 0); }
	}
	window.renderLearnTray = showLearnTray;

	// Grow the rendered Learn tray by the cards just staged, instead of repainting it. The Practice
	// tray's append rule applies here word for word (see canAppendPracticeRows): anything this can't
	// express in place falls back to showLearnTray, which is correct — just visibly so.
	function appendLearnRows(cards, replace) {
		var tray = (window.LRN && LRN.getTray) ? (LRN.getTray() || []) : [];
		if (!canAppendLearnRows(cards, tray, replace)) { showLearnTray(); return; }
		var added = appendTrayRows(cards);
		GARDEN.decorate(added);
		// Badges are keyed by sense id off the TRAY, so this is the whole tray's read either way; it
		// leaves the badge spans already on screen in place (decorateTray only adds a missing one)
		// and repaints them with the same values. The CTA band has to be re-asked — its teachable
		// count just changed.
		if (window.LRN && LRN.decorateTray) { LRN.decorateTray($("#defId")); }
		if (window.LRN && LRN.renderCta) { LRN.renderCta(tray.length > 0); }
		runPendingTrayFly($("#defId"), added);
		if (window.OB_TIPS) { OB_TIPS.evaluate(); }
	}

	// May these cards be appended to the Learn rows on screen? Only when the tray view is what is
	// actually showing, it is not empty (an empty tray shows a hint, not rows), this is not a replace,
	// and the cards sit at the very END of the tray. That last one is the Learn-specific trap:
	// LRN.addWords inserts a new sense NEXT TO its word's other cards (insertIndexFor), so a second
	// meaning of an already-staged word belongs mid-list and appending it would put it in the wrong
	// place — that add takes the full repaint.
	function canAppendLearnRows(cards, tray, replace) {
		if (replace || !cards || !cards.length) { return false; }
		if (activeTab !== 'learn' || isExerciseView) { return false; }
		if (tray.length < cards.length) { return false; }
		var tail = tray.slice(tray.length - cards.length);
		for (var i = 0; i < cards.length; i++) {
			if (tail[i] !== cards[i]) { return false; }
		}
		// …and the rows the tail follows must really be painted: the first pre-existing card's row is
		// the probe (a Practice set left in the box, or the empty-tray hint, would fail it).
		var kept = tray[tray.length - cards.length - 1];
		if (!kept) { return false; }   // the tray WAS empty — the hint is on screen, not rows
		var id = kept.term && kept.term.id;
		return id != null
			&& $("#defId").find("._entryClass[data-term-id='" + id + "']").length > 0;
	}

	// ── dictionary level bands: the plain-language name ──────────────────────────
	// Two band-naming schemes reach the UI. The FREQUENCY scheme (A..E) labels its bands with
	// words already — "Elementary", "Advanced" — so a label explains itself. The CEFR scheme
	// (A1..C2+) labels them with the bare code: international, unambiguous, and it has to stay —
	// but it says nothing at all to a learner who has never met the ladder (owner report
	// 2026-08-25, on the empty tray's A1/A2/B1 buttons). So the CEFR bands carry a SECOND string,
	// the plain-language name, and it ships WITH the code, never instead of it.
	//
	// One list of codes, read by both places that show a bare code — the empty tray's quick-pick
	// buttons here, and the Word Lists panel far below (its rows, and its folded chips' tooltips)
	// — so the two can never name a band differently. A code that is not in it (A..E) has no
	// plain name and gets none: its label already is one.
	var CEFR_BAND_CODES = { A1: 1, A2: 1, B1: 1, B2: 1, C1: 1, C2P: 1 };

	function levelPlainName(code) {
		return CEFR_BAND_CODES[code] === 1 ? getRes("wlLevel" + code + "_name") : "";
	}

	// ── the empty tray's quick-start block ───────────────────────────────────────
	// An empty tray is where a user gets stuck, and it is a screenful of unused space — so the
	// one-click jump start lives THERE, not in a pill next to a greyed-out Clear (design note
	// docs/project/learn-quick-start-tray.md). It replaced the "N new" daily-seeds chip, whose
	// count shrank silently, which hid at 0 exactly when the tray was empty, and which handed every
	// learner the function-word wall at ranks 1–5 no matter their level.
	//
	// One builder, mounted by BOTH empty hints — the two states are twins, and only two things
	// differ: the draw behind the button (`mode`) and the add path the ids are handed to.
	// The button SET comes from the server (/quick-pick/levels), so "which bands does quick-pick
	// offer" lives in one place; each entry says whether that band still has anything to give.

	// The shared, remembered count: one number for both trays and all three buttons. Clamped by the
	// SAME tray cap every other add obeys — no second limit invented.
	//
	// First-run override (owner 2026-08-08): until the user's first learn session completes,
	// EVERY first-scoop offer is 3 — this field and the Random menu's top preset read the same
	// OB_GUIDE.firstRun() signal, so no route around the walk hands a newcomer five words. An
	// explicit edit of the field wins for the rest of the visit (quickPickEdited).
	var quickPickEdited = false;
	function quickPickCount() {
		if (!quickPickEdited && window.OB_GUIDE && OB_GUIDE.firstRun()) { return 3; }
		return quickPickCountFrom(window.quick_pick_count);
	}

	// The same signal, for the SERVER: during the first run the draw passes the tour filter
	// (docs/project/tour-showcase-words-plan.md) — skipping the guided run must not hand a newcomer
	// "Mrs." Unlike the count, an edit of the field does not lift it: it is about WHICH words.
	function quickPickFirstRun() {
		return !!(window.OB_GUIDE && OB_GUIDE.firstRun());
	}

	function quickPickCountFrom(raw) {
		var n = Math.round(+raw);
		if (!(n > 0)) { n = 5; }             // blank, 0, negative or NaN — back to the default
		return Math.min(Math.max(n, 1), trayCap());
	}

	function quickStartBlock(mode, addFn) {
		var box = $("<div>").addClass("qsBlockClass");

		// strFormat returns a STRING and so cannot host the number field: split the localized
		// sentence on {0} and inject the input between the halves, letting each locale place it
		// by its own grammar.
		var parts = String(getRes("quickStart_line")).split("{0}");
		var line = $("<div>").addClass("qsLineClass").append($("<span>").html(parts[0]));
		var count = $("<input>")
			.attr({ type: "number", min: 1, max: trayCap(), id: "quickPickCountId",
				"aria-label": getRes("quickStart_count_tooltip") })
			.addClass("qsCountClass").val(quickPickCount());
		count.assignTooltip("quickStart_count_tooltip");
		count.on("change", function () {
			quickPickEdited = true;   // an explicit choice beats the first-run 3
			window.quick_pick_count = quickPickCountFrom(this.value);
			this.value = window.quick_pick_count;      // show the clamped number back
			ajaxPostUserAttr("quickPickCount", window.quick_pick_count);
		});
		line.append(count).append($("<span>").html(parts.length > 1 ? parts[1] : ""));
		box.append(line);

		var row = $("<div>").addClass("qsButtonsClass");
		box.append(row);
		var lt = langToValField.attr("data-lang-code");
		var lf = langFromValField.attr("data-lang-code");
		$.ajax("api/garden/quick-pick/levels", {
			data: { termLang: lt, defLang: lf, mode: mode, firstRun: quickPickFirstRun() },
			dataType: "json",
			success: function (data) {
				var levels = (data && data.levels) || [];
				for (var i = 0; i < levels.length; i++) {
					row.append(quickPickButton(levels[i], mode, addFn));
				}
			},
			error: function () { box.remove(); }   // a jump start, never load-bearing
		});
		return box;
	}

	// One level button. Labels and tooltips are the LEFT PANEL's own level-list strings — pressing
	// one also teaches what that panel is for, so it must be named the same there and here.
	// A band with nothing left to give goes inert with a tooltip that points somewhere.
	//
	// A CEFR band's face is TWO lines: the plain-language name, and under it the code
	// (levelPlainName). The NAME leads and the code is the caption under it — the opposite of how
	// this started (owner call 2026-08-30). The code is what a learner who has met the ladder
	// scans for, but it says nothing to one who hasn't, and this is an empty screen whose whole
	// job is to be pressable by someone new; the word does that, the code confirms it. The
	// tooltip keeps the full CEFR descriptor. A..E bands get one line — the code element alone,
	// their label already BEING the plain name.
	//
	// Inert via aria-disabled, NOT the disabled property: the whole value of that state is the
	// tooltip, and a truly disabled <button> dispatches no mouse events, so its tooltip could
	// never fire. quick-start.css gives the attribute the same inert face .pl-btn-quiet:disabled
	// wears. The in-flight disable after a press is a real `disabled` — nothing to explain there.
	function quickPickButton(entry, mode, addFn) {
		var level = entry && entry.level;
		var btn = $("<button>").attr("type", "button")
			.addClass("pl-btn-quiet qsLevelButtonClass")
			.attr("data-level", level);
		var plain = levelPlainName(level);
		if (plain) {
			btn.append($("<span>").addClass("qsLevelNameClass").text(plain));
		}
		btn.append($("<span>").addClass("qsLevelCodeClass")
			.text(getRes("wlLevel" + level + "_label")));
		if (!entry.open) {
			btn.attr("aria-disabled", "true").assignTooltip("quickStart_exhausted_tooltip");
			return btn;
		}
		btn.assignTooltip("wlLevel" + level + "_tooltip");
		btn.click(function () {
			if (btn.attr("aria-disabled") === "true") { return; }
			btn.prop("disabled", true);   // one press per draw; the tray repaint replaces the block
			$.ajax("api/garden/quick-pick", {
				data: {
					termLang: langToValField.attr("data-lang-code"),
					defLang: langFromValField.attr("data-lang-code"),
					level: level, mode: mode, count: quickPickCount(),
					firstRun: quickPickFirstRun()
				},
				dataType: "json",
				success: function (data) {
					var ids = (data && data.termIds) || [];
					// Raced empty (the band emptied since the probe): go inert and say why, rather
					// than leaving a button that does nothing.
					if (!ids.length) {
						btn.prop("disabled", false).attr("aria-disabled", "true")
							.assignTooltip("quickStart_exhausted_tooltip");
						return;
					}
					addFn(ids);
				},
				error: function () {
					btn.prop("disabled", false);
					showMessage(getRes("operationCannotComplete_message"));
				}
			});
		});
		return btn;
	}

	// The empty Learn tray: the sprout + the quick-start block in #defId (mirrors the Practice empty
	// tray), with Start Learning! disabled (renderCta handles that). A missing langTo shows the
	// choose-language prompt instead, like every other empty view — and no quick-pick, which has no
	// language to draw from.
	function renderLearnEmptyHint() {
		var lang = langToValField.attr("data-lang-code");
		var host = $("<div>").addClass("_noWordsClass lrnTrayEmptyClass")
			.append($("<div>").addClass("lrnEmptyIconClass").html(GARDEN.markIcon("sprout")))
			.append($("<div>").addClass("lrnEmptyTextClass")
				.html(lang ? getRes("learnEmpty_message") : getRes("chooseLangTo_message")));
		if (lang) {
			host.append(quickStartBlock("LEARN", function (ids) { addWordsToLearning(ids, false); }));
		}
		$("#defId").empty().append(host);
	}

	// Learn mode: the learning tray + "Start Learning!" (the rung ladder). A user tab click
	// lands here and pushes its own lean history entry; already-on-learn is a no-op so
	// repeated clicks don't stack entries. (popstate restores learn via applyLearnChrome
	// directly, never through here, so it adds no history.)
	function learnTabView() {
		if (activeTab === 'learn') { return; }
		doc.setLookupText("");
		applyLearnChrome();
		pushLeanEntry('learn');
	}

	// Hooks for learning_session.js (it lives outside this closure): land on the Learn tab
	// programmatically (nudge chip, "Add to Learning"), and hand a graduated batch to Practice.
	window.openLearnTab = function () {
		if (activeTab !== 'learn') {
			applyLearnChrome();
			pushLeanEntry('learn');
		} else if (window.LRN) {
			LRN.showTray();
		}
	};
	// The three tab buttons' own handlers, for a caller that cannot press them: the guided walk's
	// Back, which undoes a tab switch it had asked the reader to make (onboarding_guide.js TOUR_BACK)
	// — its wall would swallow a synthetic click. Same history entry as the press would push. On an
	// open dictionary entry, 'dict' is the way back to the lookup list, exactly as the tab is.
	window.plShowTab = function (which) {
		if (which === 'dict') { dictionaryTabView(); }
		else if (which === 'learn') { learnTabView(); }
		else if (which === 'practice') { practiceTabView(); }
	};
	window.learnHandoffToPractice = function (cards) {
		if (cards && cards.length) { addSensesToPractice(cards); }
	};
	// …and the two other tabs, for the guided tour's doors (onboarding_guide.js, first-run R16): a
	// door the reader has said "yes" to opens its tab the way the tab's own click would — the wall's
	// capture listener swallowed that click to ask the question first.
	window.openDictTab = function () { dictionaryTabView(); };
	window.openPracticeTab = function () { practiceTabView(); };
	// A live rung-ladder session: swap the shared tray box (#defId) for the session box (#learnBoxId).
	// The MODE TABS STAY (owner ruling R15, docs/project/first-run-redesign.md — hiding them "breaks
	// the UI and confuses"; until 2026-10-07 this hid them, the drill's full focus copied over), so a
	// tab pressed mid-session leaves it the way any tab switch does (LRN.leave: rung state is saved
	// per event). The Word Lists panel STAYS visible (the user can still browse their lists
	// mid-session) — only its "add to the tray" affordances are switched off (setAddDisabled), so
	// there's no ambiguous "where does this add go?" while a session runs. On session end the caller
	// (showTray) repaints the tray into #defId; here we restore chrome + boxes.
	window.learnSessionChrome = function (active) {
		if (active) {
			settings.myListPanel.setAddDisabled(true);   // panel visible, tray-adds off
			$("#learnControlBandId").hide();   // the tray's Start/Clear band — gone during a session
			defBox.hide();                      // the tray box gives way to…
			learnBox.show();                    // …the rung-ladder session box
			sizeCenterBoxToPanel();             // learnBox fills the space the band vacated
		} else {
			$("#centralTabsId").show();         // a no-op now (R15) — kept for a row anything else hid
			settings.myListPanel.setAddDisabled(false);   // tray-adds live again
			if (settings.myListPanel.panelAttrToShow) {
				settings.myListPanel.showPanel(false);
			}
			learnBox.hide();
			defBox.show();                      // back to the shared tray box (showTray repaints it)
			sizeCenterBoxToPanel();
		}
	};

	// ── Learn meet-card reveal: session-scoped rich drill-in ─────────────────────────────────────
	// The meet card's reveal reuses the dictionary's rich card AND its drill feel (click a word → its
	// entry, drill further, Esc / browser-Back unwind step by step) WITHOUT leaving the session: every
	// card renders INLINE in the reveal container (inside #learnBoxId), and the whole drill sits on top
	// of a "base" history entry that restores the light reveal instead of seeking the dictionary.
	// learning_session.js owns the light reveal and hands us the container + a base() restore callback.
	var learnDrillActive = false;   // true while a meet-card reveal drill is live
	var learnDrillHost = null;      // the reveal container we render cards into (in #learnBoxId)
	var learnDrillBase = null;      // base() — re-shows the light reveal (the drill's bottom of stack)
	var learnMeetVariant = null;    // {term, variantId}: the meet word's heteronym pronunciation
	// {term, combo}: a conjugated-form card opens its HEAD VERB's entry, and this is the paradigm
	// cell to mark on it. Keyed by term so it applies to the level it was opened for and nowhere
	// else — drilling on from "abbrennen" into another word must not carry the highlight along.
	var learnDrillHighlight = null;
	// Same guard, same reason, for the OTHER verb mark: the term whose card should open on the verb's
	// principal parts. Held apart from learnDrillHighlight because they are different marks for
	// different card shapes — a combo names one cell, a principal-parts card names none.
	var learnDrillFocusVerb = null;

	// Open the meet word's own rich card (first drill level). baseFn restores the light reveal on unwind.
	// w.conjHighlight, when set, names the paradigm cell to mark on the card; w.focusVerb marks the
	// verb's principal parts instead (see learnDrillRender).
	window.openLearnDrill = function (w, $container, baseFn) {
		if (!w || !$container || !$container.length) { return; }
		learnDrillActive = true;
		learnDrillHost = $container;
		learnDrillBase = baseFn || null;
		learnMeetVariant = { term: w.term, variantId: (w.ipaVariantId != null ? w.ipaVariantId : null) };
		learnDrillHighlight = w.conjHighlight ? { term: w.term, combo: w.conjHighlight } : null;
		learnDrillFocusVerb = w.focusVerb ? w.term : null;
		pushNav({ tab: 'learn', learnReveal: 'base' });   // the light-reveal return point
		pushNav({ tab: 'learn', learnReveal: w.term });   // level 1 — the meet word itself
		learnDrillRender(w.term);
	};

	// Is a reveal drill open — a word clicked inside a Learn screen's rich view, showing in place of
	// (or over) it? Read by the onboarding guide's entry chapter, which teaches exactly that
	// excursion and the way back out of it. Asked of the module that owns the state rather than
	// inferred from the markup, because the two paths look different in the DOM and identical to a
	// reader: openStudyOverlay puts the deeper word in its own .lrnRevealRichClass box, while a word
	// clicked INSIDE a meet reveal is rendered into the very container the reveal is in.
	window.learnDrillOpen = function () { return learnDrillActive; };

	// Full reset — no history touch. Called when a fresh meet card renders or the session ends, so a
	// stale drill can't linger. Leftover forward-history entries are inert: their popstate replay finds
	// learnDrillActive false and is ignored, and the next drill's pushNav clears them.
	window.endLearnDrill = function () {
		learnDrillActive = false;
		learnDrillHost = null;
		learnDrillBase = null;
		learnMeetVariant = null;
		learnDrillHighlight = null;
		learnDrillFocusVerb = null;
	};

	// Drill one level deeper (a term clicked inside the current card).
	function learnDrillTo(term) {
		pushNav({ tab: 'learn', learnReveal: term });
		learnDrillRender(term);
	}

	// Fetch + render `term`'s rich card into the reveal container. Mirrors renderExerciseRichWord, but
	// scoped to the Learn session box (onLearnDrillTermClick keeps drilling inline; it never excursions
	// into the dictionary the way onExerciseTermClick does).
	function learnDrillRender(term) {
		if (!learnDrillHost) { return; }
		// Same rule richLookupCore follows: a card about to be replaced takes any popup hanging over
		// it with it. A drill excursion is opened BY a word the pointer is resting on, so the stale
		// popup here is the common case, not the corner one.
		resetWordPopup();
		var host = learnDrillHost;
		host.html(loadingHtml());
		fetchRichEntryToShow(term, true, function (data, xhr, mark) {
			if (!learnDrillActive || learnDrillHost !== host) { return; }   // torn down / advanced away
			if (!xhr && data && data.senses && data.senses.length) {
				// Both verb marks are guarded on the term: they belong to the level that asked for them,
				// not to anything drilled on from there. focusVerb marks the head verb's principal parts
				// (the answer for a card that names no single cell — "bear, bore, borne"); conjHighlight
				// marks the one paradigm cell a card was opened FOR ("du branntest ab" → abbrennen's
				// entry). Alternatives, never both — see bindTermStudy. `mark` wins when set: this level
				// asked for a form whose head verb we are showing instead, and it says so.
				renderRichEntry(data, host, onLearnDrillTermClick, $.extend({
					focusVerb: !!learnDrillFocusVerb && term === learnDrillFocusVerb,
					conjHighlight: (learnDrillHighlight && term === learnDrillHighlight.term)
						? learnDrillHighlight.combo : null
				}, mark));
				// renderRichEntry's own sound button + IPA fire playAiSound with NO variant; the meet
				// word carries a sense-specific heteronym variant, so rebind those to keep its
				// pronunciation (deeper drilled words have no meet variant — their default is correct).
				// Never on a swapped card: that one is the head verb's, and its own default is right.
				if (!mark && data.termId && learnMeetVariant && term === learnMeetVariant.term
						&& learnMeetVariant.variantId != null) {
					var id = data.termId, v = learnMeetVariant.variantId;
					host.find("#richSoundBtnId").off("click").on("click", function () { playAiSound(id, v); });
					host.find(".rich-ipa").off("click").on("click", function () { playAiSound(id, v, $(this).attr("data-dialect") || null); });
				}
			} else {
				// No rich entry (a phrase, or a failed lookup) — still show the word itself, like the
				// exercise reveal, so the drill never dead-ends on a blank box.
				host.html('<div class="rich-card"><div class="rich-head">'
					+ '<span class="rich-term">' + escHtml(term) + '</span></div></div>');
			}
		});
	}

	// A term clicked inside a drilled card drills deeper; the card's OWN headword is inert (it's already
	// the shown word). Same (word, isHeadword) contract renderRichEntry hands onTermClick everywhere.
	function onLearnDrillTermClick(word, isHeadword) {
		if (isHeadword || !word || !learnDrillActive) { return; }
		learnDrillTo(word);
	}

	// Unwound to the base entry (Esc / Back at level 1): restore the caller's base view (the meet's
	// rich view, or a rung's miss strip).
	function learnDrillCollapseToBase() {
		var base = learnDrillBase;
		learnDrillActive = false;
		learnDrillHost = null;
		learnDrillBase = null;
		learnMeetVariant = null;
		if (base) { base(); }
	}

	// Render w.term's FULL rich view directly into $container as reveal content (not a drill level):
	// all senses, full width, same as any dictionary rich card. Used by the Learn meet reveal (#3) —
	// the rich view IS the content, so Esc here does nothing (Got it advances). A word clicked INSIDE
	// it drills deeper via openLearnDrill, which returns to this view on Esc/Back. Preserves the meet
	// word's heteronym pronunciation on the header sound button + IPA.
	// w.conjHighlight, when set, is a paradigm cell to mark on the rendered card — the meet of a
	// conjugated form renders its HEAD VERB here and wants the form's own cell called out. w.focusVerb
	// is the same intent for a card with no single cell to name: mark the verb's principal parts,
	// which on an English entry are the whole of what "the conjugation table" means.
	window.renderLearnRichView = function (w, $container) {
		if (!w || !$container || !$container.length) { return; }
		var host = $container;
		host.html(loadingHtml());
		fetchRichEntryToShow(w.term, true, function (data, xhr, mark) {
			if (!host[0] || !document.body.contains(host[0])) { return; }   // advanced away mid-fetch
			if (!xhr && data && data.senses && data.senses.length) {
				renderRichEntry(data, host, function (word, isHeadword) {
					if (isHeadword || !word) { return; }   // headword is the shown term — inert
					openLearnDrill({ term: word }, host, function () { window.renderLearnRichView(w, host); });
				}, $.extend({ focusVerb: !!w.focusVerb, conjHighlight: w.conjHighlight || null }, mark));
				// A swapped card is the head verb's; its own default pronunciation is the right one.
				if (!mark && data.termId && w.ipaVariantId != null) {
					var id = data.termId, v = w.ipaVariantId;
					host.find("#richSoundBtnId").off("click").on("click", function () { playAiSound(id, v); });
					host.find(".rich-ipa").off("click").on("click", function () { playAiSound(id, v, $(this).attr("data-dialect") || null); });
				}
			} else {
				// Nothing to render. This used to draw the headword alone in an otherwise empty card,
				// which reads as "this word means nothing" and looks IDENTICAL whether the entry is
				// genuinely bare or the request simply failed — a reveal that comes up blank with
				// nothing to read and no hint that anything went wrong (owner report 2026-07-30, a
				// conjugated form whose lookup errored). Name which of the two it was.
				host.html('<div class="rich-card"><div class="rich-head">'
					+ '<span class="rich-term">' + escHtml(w.term) + '</span></div>'
					+ '<div class="rich-empty">'
					+ escHtml(getRes(xhr ? "richEmpty_failed" : "richEmpty_none"))
					+ '</div></div>');
			}
		});
	};

	// The empty practice tray: hint instead of words, Start disabled, count reads 0. Also the
	// canonical render for an EMPTY practice snapshot (restoreWordSet, Back over a Clear).
	function renderPracticeEmptyHint() {
		var lang = langToValField.attr("data-lang-code");
		var host = $("<div>").addClass("_noWordsClass practiceEmptyHintClass")
			.append($("<div>").addClass("practiceEmptyIconClass").html(GARDEN.markIcon("water")))
			.append($("<div>").addClass("practiceEmptyTextClass")
				.html(lang ? getRes("practiceEmpty_message") : getRes("chooseLangTo_message")));
		if (lang) {
			// PRACTICE mode draws differently (already-learned-but-never-drilled first, random
			// unstudied words for the rest) — but appends the same way the Learn side does: the
			// user's own staged picks are never superseded by a suggestion.
			host.append(quickStartBlock("PRACTICE", function (ids) { addWordsToPractice(ids, false); }));
		}
		$("#defId").empty().append(host);
		startButton.find("#startCountId").text(" (" + getRes("startButton_wordsInExercise") + " 0)");
		startButton.prop("disabled", true);
	}

	function showPracticeEmpty() {
		disableDictScroll();
		if (displayManager) { displayManager.setDefList([]); }
		renderPracticeEmptyHint();
	}

	// ── the "💧 N thirsty" chip ──────────────────────────────────────────────────
	// The garden's watering call on the Practice CTA band: how many planted words of the current
	// learning language are overdue. The chip lives inside #trayControlsId, so it shows only in the
	// pre-exercise Practice view and vanishes mid-drill with the rest of the tray controls.
	//
	// It is a SHORTCUT, nothing cleverer (simplified 2026-08-07):
	//
	//   • The NUMBER is the server's thirsty count, verbatim — the same set, and therefore the same
	//     number, as My Garden's "Needs watering" band (GardenService.thirsty and
	//     TermRepository.GARDEN_PLANTED_PREDICATE are one query in two places). The two labels say
	//     the same thing, so they must never show different numbers. It USED to subtract whatever
	//     was already staged in the Practice tray, which made it a third, private number the user
	//     had no way to derive — and worse, one bad `lastPracticeSetId` (an emptied tray whose
	//     snapshot still held words) silently knocked words off a count that looked authoritative.
	//   • Clicking APPENDS the whole thirsty set to the tray, deduped. No replace-or-add question:
	//     one control, one meaning. Anything already staged is simply skipped.
	//   • The click ALWAYS runs and ALWAYS toasts, even when every thirsty word is already staged
	//     (owner report 2026-08-07). It used to return early there, which was true to "changes
	//     nothing" and read as a broken button: a press with no visible answer of any kind. The
	//     honest fix is feedback, not inaction — the toast says the tray IS ready, which is the
	//     thing the user was trying to find out.
	var thirstyTermIds = [];

	// Paint the chip from the already-fetched thirsty set. Hidden at zero: nothing to water is good
	// news, not information (the same rule the garden's own empty bands follow).
	function renderThirstyChip() {
		var chip = $("#thirstyChipId");
		if (!thirstyTermIds.length) { chip.hide(); return; }
		// The droplet is the sprite's own (#g-droplet — the same signal the plants wear);
		// garden.css re-anchors it from badge-absolute to inline for the chip.
		chip.html(GARDEN.dropletSvg()
			+ "<span>" + strFormat(getRes("garden_thirsty_chip"), thirstyTermIds.length) + "</span>");
		chip.css("display", "inline-flex");
		// Beacon tips: the chip's first appearance IS the thirsty-watering trigger,
		// and it lands async — after the tab-switch hook already ran.
		if (window.OB_TIPS) { OB_TIPS.evaluate(); }
	}

	function refreshThirstyChip() {
		var chip = $("#thirstyChipId");
		var lang = langToValField.attr("data-lang-code");
		if (!lang) { thirstyTermIds = []; chip.hide(); return; }
		$.ajax("api/garden/thirsty", {
			data: { termLang: lang }, dataType: "json",
			success: function (data) {
				thirstyTermIds = (data && data.termIds) || [];
				renderThirstyChip();
			},
			error: function () { thirstyTermIds = []; chip.hide(); }   // a nudge, never load-bearing
		});
	}

	$("#thirstyChipId")
		.assignTooltip(function () { return getRes("garden_thirsty_tooltip"); })
		.click(function () {
			// Same path whether or not anything is new — see the section comment. addWordsToPractice
			// dedupes, so an all-already-staged press lands on the same tray it started with; what it
			// must NOT land on is silence.
			if (!thirstyTermIds.length) { return; }   // no chip is drawn at zero anyway
			// stay=true (owner-profiled 2026-08-30): the chip only ever shows on the pre-exercise
			// Practice view, so this is a STAGE press exactly like the tray-add-buttons' one-press
			// controls, never a tab switch. Without it, addWordsToPractice took the false branch
			// (loadWordListSelection → randomWordsView(), a full chrome teardown/rebuild of a tab
			// already showing) — a Firefox Profiler capture of the reported panel jerk showed the
			// click driving a ~4,000-element Style recalc plus a repeating UpdateContainerQueryStyles/
			// Reflow storm for a quarter of a second, the redundant show()/hide() cycle re-touching
			// bands that never actually changed. stagePracticeSet's lean, off-tab-safe repaint is the
			// path already built for exactly this button shape.
			addWordsToPractice(thirstyTermIds, false, true);
			showToast(getRes("garden_thirstyStaged_toast"), "water");
		});

	function randomWordsView() {
		richOpen = false; practiceReturn = null;   // showing the lean Practice set; nothing expanded
		clearFinishExcursion();   // "Back to Words" out of an excursion: this path owns the boxes now
		if (window.LRN) { LRN.leave(); }           // a live learning session dies with its tab (state persists per event)

		progressBox.hide();
		$("#exerciseResultId").empty();             // drop any lingering "Not quite correct"/"You've done it!" overlay

		defExerciseBox.hide();
		learnBox.hide();
		learnControlBand.hide().empty();   // the Learn-only top band never shows outside the Learn tray
		defBox.show();

		tipBox.hide();
		answerBox.hide();
		stopButton.hide();
		// jQuery's .show() forces display:block, which would collapse this flex band —
		// force flex explicitly (see the jquery-show-breaks-flex note).
		$("#exerciseControlBandId").css("display", "flex");
		trayControls.css("display", "flex");   // Clear + gear: pre-exercise Practice view only
		lockDirectionControls(false);          // no session running — the direction is choosable again
		refreshThirstyChip();             // re-count on every Practice entry — a drill may just have watered some
		refreshLastFinishButton();        // …and a drill that just ended is a screen worth offering back
		lookupBox.hide();                 // search now lives in Dictionary mode
		tipBox.hide();

		$("#centralTabsId").show();
		setActiveTab('practice');

		if (settings.myListPanel.panelAttrToShow) {
			settings.myListPanel.showPanel(false);
		}

		sizeCenterBoxToPanel();

		// Chrome only — no policy reset here. Every load path installs its own policy (loadRandomLevelSet
		// → Frequency, loadWordListSelection → word-list, restoreWordSet → the snapshot's own), and
		// callers that DON'T load (returnToRandomView after an exercise Stop) must keep the current
		// set's policy so a re-Start still reports the right session origin (RANDOM vs WORD_LIST).
		if (!displayManager) {
			displayManager = new DisplayManager();
		}

		startButtonLabel.text(getRes("startButton_label"));
		startButton.assignTooltip("startButton_tooltip");
		startButton.prop("disabled", false);
		restoreExerciseButtonLabels();   // Back to Words arrives here with finish-mode faces
		isExerciseView = false;
	}

	// A langTo change: every loaded set/snapshot belongs to the OLD pair — drop them and stay on
	// the current tab (Dictionary refreshes to the new pair; Practice shows the empty tray).
	function bringToInitialState() {
		trainingSession = null;
		if (displayManager) { displayManager.clearDefList(); }
		lastPracticeSetId = null;
		practiceDeletedSenseIds = {};      // pair-scoped, like the tray it belongs to
		knownSenseIds = {};                // pair-scoped mirror — rehydrateTrays refills it below
		pendingHandoffSenses = {};         // any in-flight handoff belongs to the old pair too
		if (window.LRN) { LRN.reset(); }   // the learn tray belongs to the OLD pair too
		if (activeTab === 'practice') {
			showPracticeEmpty();
		} else if (activeTab === 'learn') {
			if (window.LRN) { LRN.showTray(); }
		} else {
			showDictLean();
		}
		// The tray was just wiped for the OLD pair; the NEW pair may have its own saved tray. Read the
		// current (already-updated) langFrom/langTo and refill from the server — this keeps the client
		// tray consistent with what's stored, so a later add for the new pair doesn't clobber it.
		rehydrateTrays();
		refreshThirstyChip();   // the count is per learning language — recount for the new pair
		loadLastFinish();   // the OLD pair's screen goes away; the NEW pair keeps its own server-side
	}

	function returnToRandomView() {
		displayManager.displayAll();
		if (trainingSession) {
			trainingSession.stopSession();
		}
		trainingSession = null;
		randomWordsView();
	}

	// The same exit, for a caller outside this closure: the guided walk's "Yes, stop the tour"
	// (onboarding_guide.js endTour, owner call 2026-09-01). Stopping a tour that put the reader on a
	// drill has to leave the drill — taking the wall down is not enough, because a drill hides the
	// mode tabs and the reader is still sealed into the screen the walk led them to.
	//
	// `isExerciseView` covers the FINISH SCREEN as well as a running drill: exerciseFinished never
	// clears the flag (only randomWordsView and the dictionary view do), which is correct — the
	// finish screen wears the drill's chrome and is left by the drill's own Stop button. Returns
	// whether there was anything to leave, and is a no-op everywhere else.
	window.leaveExerciseView = function () {
		if (!isExerciseView) { return false; }
		returnToRandomView();
		return true;
	};

	function exerciseView() {
		clearFinishExcursion();   // "Practice Again" straight out of an excursion — a drill owns the boxes
		tipBox.hide();
		trayControls.hide();   // mid-drill: the gear duplicate on the progress band takes over
		lockDirectionControls(true);   // direction + cue mode are fixed for the session that is running
		lookupBox.hide();
		// Measure the tabs row while it's still visible (0 on pause/resume re-entry when already
		// hidden — keep the cached value), then hide it. Its height is handed to the word box below.
		var th = $("#centralTabsId").outerHeight(true);
		if (th > 0) { tabsRowHeight = th; }
		$("#centralTabsId").hide();       // full-focus drill: hide mode tabs
		settings.myListPanel.hidePanel(false);

		progressBox.show();
		progressBar.show();

		defBox.hide();
		learnBox.hide();
		learnControlBand.hide().empty();   // the Learn-only top band never shows outside the Learn tray
		defExerciseBox.show();

		counterBox.show();
		answerBox.show();

		sizeCenterBoxToPanel(tabsRowHeight);   // reclaim the hidden tabs' row for the word box

		stopButton.show().off("click").on("click", function () {
			returnToRandomView();
		});

		// Namespaced (.plEnter): a bare off("keydown") here silently killed the drill's ENTIRE
		// keydown instrumentation (first_key_ms / keystrokes / backspaces bound as keydown.plSrs
		// in training_session.js) — the audited "latency channel dead on virtually all Practice
		// events" defect. Each binding now removes only itself.
		answerField.off("keydown.plEnter").on("keydown.plEnter", function (e) {
			if (e.which == PL.keys.ENTER) {
				doc.setTipText("");
				if (trainingSession) {
					trainingSession.processUserAnswer();
				}
				e.preventDefault();
				e.stopPropagation();
			}
		});

		isExerciseView = true;
		answerField.focus();
		// Beacon tips (spec §6): a drill screen clears idle beacons and may raise the
		// drill-scoped one (space-pronounce) on the progress band.
		if (window.OB_TIPS) { OB_TIPS.evaluate(); }
	}

	// ── Exercise finish screen ────────────────────────────────────────────────────────────────────
	// training_session.js calls exerciseFinished(summary) when the last word retires, then
	// exerciseSessionEnded(difficultWords) once the server confirms the session end (it may flag
	// tricky words — each is OFFERED for the Difficult words band, never auto-added — and it
	// reports the day's checkmarks for words already in that band). Until the
	// user moves on, the two header buttons read
	// "Practice Again!" / "Back to Words", the answer field is gone (nothing left to type), and the
	// word box shows the session summary card.

	// Flower → word hover linkage (the reverse of wireBedHover's GARDEN.hoverBedTerm above):
	// whichever plant the growth-bed canvas is hovering, bold EVERY matching word on the finish
	// screen — a word can appear more than once (a "Tricky this round" pick is also named in Grew
	// today or Still growing), and all of them light up together. Registered once — the callback
	// itself no-ops harmlessly when no finish screen is on the page. Scoped to .exSummaryClass so
	// it never touches an unrelated data-term-id slot elsewhere on the page (e.g. a word-list row).
	GARDEN.onBedHover(function (termId) {
		$(".exSummaryClass .exBedHoverClass").removeClass("exBedHoverClass");
		if (termId != null) {
			$(".exSummaryClass [data-term-id='" + termId + "']").addClass("exBedHoverClass");
		}
	});

	// ── finish-screen timing trail ────────────────────────────────────────────────────────────────
	// The other half of the server's "session-end … ms total" log line: the server can only time
	// its own request, and most of the wait the user sees is around it — the card posts the client
	// waits for before it may even ask, and the term-status read-back the bed needs afterwards.
	// One console line per finished session, prefixed [finish] so it filters cleanly.
	//
	// Marks, in the order they normally fire:
	//   screen  the summary card is on the page (headline + the four numbers) — the clock starts
	//   bed1    pass 1 of the bed is drawn: the session's words, no growth yet
	//   posts   the last card's fire-and-forget posts have settled; the end call may now go out
	//   end     api/exercise-session-end has answered — the growth is known
	//   bed2    pass 2 of the bed is drawn — the screen is complete
	var finishMarks = null;
	window.PL_FINISH_MARK = function (name) {
		if (!finishMarks) { return; }
		finishMarks[name] = Date.now() - finishMarks.t0;
		if (name !== "bed2") { return; }
		var m = finishMarks;
		finishMarks = null;
		window.console && console.log("[finish] complete in " + m.bed2 + "ms"
			+ " — bed visible " + m.bed1 + "ms"
			+ ", card posts settled " + m.posts + "ms"
			+ ", session-end answered " + m.end + "ms"
			+ " (end call took " + (m.end - m.posts) + "ms)");
	};

	function fmtSummaryDuration(ms) {
		var sec = Math.round(ms / 1000);
		if (sec < 60) { return sec + "s"; }
		return Math.floor(sec / 60) + "m " + (sec % 60) + "s";
	}

	function summaryStat(value, label) {
		return $("<div>").addClass("stats-cell")
			.append($("<span>").addClass("stats-num").text(value))
			.append($("<span>").addClass("stats-lbl").text(label));
	}

	// The session's own word set (+ per-word direction), handed over by computeSummary. The
	// server's session-end payload names only the words that GREW; the bed and the "still
	// growing" section both need the whole set, and only the client knows it.
	var exSessionWords = [];
	var exSessionMixed = false;

	// The finish-screen word the pointer is on, or null. Set by wireBedHover, which every word on
	// the card goes through, and read by the document's bare-Space handler: on this screen the
	// hovered word is what Space pronounces (owner ask 2026-08-20 — no speaker icon anywhere on the
	// card; the words are prose here, and a 🔊 on each of twenty-one of them would bury them).
	// Nulled on mouseleave, so Space claims nothing once the pointer is off the words.
	var exHoverTermId = null;

	// The card's own copy of the tabs row's "?", for the live finish screen where that row is
	// hidden (see the note at the call site). Same face as the row's, .centralHeadPillClass, so it
	// reads as the control the user already knows and not as a new button this screen invented.
	//
	// It was a 💬 + ? PAIR until 2026-08-31, when the owner made the right pane's "Send feedback"
	// panel the channel's only door (docs/project/user-feedback-feature.md). The 💬 was here for
	// the same reason the ? still is — this row is hidden behind a finished drill — but the right
	// pane is not, so the copy is no longer earning its place. The wrapper and its class stay: the
	// owner-only 🧪 audit pill lands in this same row.
	//
	// The ? re-implements nothing: it hands ONBOARDING.openHelpHub the button it should hang its
	// menu under, and that feature keeps ownership of what the door does.
	function exFinishPills() {
		var pills = $("<div>").addClass("exSummaryPillsClass");
		if (window.ONBOARDING && ONBOARDING.openHelpHub) {
			var help = $("<button>").addClass("centralHeadPillClass").attr({
				id: "helpFinishId", type: "button", "aria-haspopup": "menu",
				"aria-label": getRes("obHelpMenu_label")
			}).text("?");
			// No hover tooltip, matching the row's original (onboarding.js wireHelpHub) —
			// owner call 2026-09-01. The aria-label is the button's whole accessible name.
			help.click(function () { ONBOARDING.openHelpHub(this); });
			pills.append(help);
		}
		return pills;
	}

	// The owner-only word-decision audit pill (session-word-audit.md) — appended into the same
	// row, ONLY once the session-end response says both a) this viewer is the gated owner and
	// b) capture actually succeeded (window.exerciseSessionEnded below). Same face as the row's
	// other two pills, a 🧪 rather than 🔍 because that glyph already means "filter this list"
	// on the word-list panel — this is a different door and must not borrow its icon.
	function auditFinishPill(sessionId) {
		var btn = $("<button>").addClass("centralHeadPillClass").attr({
			id: "auditFinishId", type: "button", "aria-label": getRes("audit_finish_tooltip")
		}).text("🧪");   // test tube — an owner-only TESTING tool, literally
		btn.assignTooltip("audit_finish_tooltip");
		btn.click(function () { SESSION_HISTORY.openAudit(sessionId, this); });
		return btn;
	}

	// reviewAt = the timestamp of a session that already ended, i.e. this is the REVIEW the ⊙ tray
	// button opens (showLastFinish) rather than a drill closing. Two differences, both because
	// nothing is happening right now: no timing trail (finishMarks measures a live paint, and a
	// replay's numbers would be noise in the same [finish] log line), and the card says up front
	// WHICH session it is showing — a screen that looks identical to the live one but reports an
	// hour-old result would otherwise read as "you just did this".
	function renderExerciseSummary(summary, reviewAt) {
		finishMarks = reviewAt ? null : { t0: Date.now() };   // the clock the [finish] line above measures against
		exSessionWords = (summary && summary.words) || [];
		exSessionMixed = !!(summary && summary.mixed);
		var card = $("<div>").addClass("exSummaryClass");
		// Both tabs-row pills — 💬 send feedback and ? the help hub — in this card's own top-right
		// corner, and ONLY on the live screen (owner ask 2026-08-20).
		//
		// The card lost its 💬 on 2026-08-17 on the reasoning that "the tabs row is back by the time
		// this card is on screen". That was simply wrong, and this is the correction: exerciseView
		// hides #centralTabsId for the drill's full focus and NOTHING shows it again when the drill
		// finishes — exerciseFinished restores the word panel and the button labels, not the tabs. So
		// on the one screen that exists to say well done, both of the app's standing doors were off
		// screen. The ⊙ REVIEW of the same card is the case the old reasoning actually described:
		// lastFinishView puts the tabs row back, so a pair here would be the second copy the owner
		// objected to — hence `reviewAt` gates them out.
		if (!reviewAt) { card.append(exFinishPills()); }
		if (reviewAt) {
			card.append($("<div>").addClass("exSummaryWhenClass subduedClass")
				.text(getRes("lastFinish_label") + " · " + fmtFinishedAt(reviewAt)));
		}
		card.append($("<div>").addClass("exSummaryHeadClass")
			.append($("<span>").text(getRes("tsYouDoneIt")))
			.append($("<span>").attr("id", "exerciseFinished")));
		var grid = $("<div>").addClass("exSummaryGridClass");
		grid.append(summaryStat(summary.wordCount, getRes("stats_label_mastered")));
		grid.append(summaryStat(summary.flawless + " / " + summary.wordCount, getRes("exSummary_flawless")));
		grid.append(summaryStat(fmtSummaryDuration(summary.sessionMs), getRes("exSummary_time")));
		if (summary.medianAnswerMs != null) {
			grid.append(summaryStat((summary.medianAnswerMs / 1000).toFixed(1) + "s", getRes("exSummary_speed")));
		}
		card.append(grid);
		// The bed and the word list are ONE band, side by side (see the CSS): stacked, a full
		// 17-word session ran ~200px past the fold the moment the bed grew to hold every word.
		card.append($("<div>").addClass("exSummaryBodyClass")
			.append($("<div>").attr("id", "exSummaryGrowthId"))     // the session's bed (filled on session-end)
			.append($("<div>").attr("id", "exSummaryOutcomesId"))); // grew today / still growing
		// The one-time "how does my garden grow?" offer, right under the bed it is about. Its own
		// mount OUTSIDE the bed's element on purpose: renderGrowthBed empties #exSummaryGrowthId on
		// every repaint (and it repaints once more when the session-end answer lands), so a card
		// parked inside it would be wiped a beat after it appeared. Stays empty — and collapsed —
		// for every session but the one that plants the user's first word.
		card.append($("<div>").attr("id", "exSummaryFirstGardenId"));
		// Four lines about the Difficult words band, in this order on purpose: the screen opens on
		// what was WON, and ends on the one thing that wants a decision. Graduations first because
		// they are the biggest news; then the day's checkmarks; then what the app filed by itself,
		// which is news the user is owed rather than news they will enjoy; and only then the offers,
		// which are the ask. Each line is absent when it has nothing to say.
		card.append($("<div>").attr("id", "exSummaryGradId"));
		card.append($("<div>").attr("id", "exSummaryMarksId"));
		card.append($("<div>").attr("id", "exSummaryFiledId"));
		card.append($("<div>").attr("id", "exSummaryTrickyId"));
		card.append($("<div>").attr("id", "exSummaryBridgeId").addClass("subduedClass"));
		$("#defExerciseId").empty().append(card);

		// ── the finish screen paints in two passes; this is pass 1 ────────────────────────────
		// Everything the client already knows goes up NOW. The bed and the word list used to wait
		// on the entire session-end chain: the last card's fire-and-forget posts settling, then
		// api/exercise-session-end (label derivation + one M5 state replay per word + the garden
		// advance + the outcome mapper + the 3-day regime), and only THEN a term-status read-back
		// before a single plant was drawn — three serialized round trips with the heaviest request
		// in the middle. The result was a card that sat as a headline and four numbers for a
		// couple of seconds while the half the user actually came for was blank.
		//
		// None of that work is needed to say WHICH words were drilled or what they looked like
		// going in. Only the GROWTH needs it, and the growth arrives in pass 2
		// (exerciseSessionEnded) and repaints both surfaces in place. Passing null rather than []
		// is what tells them "not known yet" instead of "nothing grew".
		GARDEN.renderGrowthBed(null, $("#exSummaryGrowthId"), exSessionWords);
		renderWordSections(null, null);
	}

	// Both header buttons back to their mid-exercise faces (word count under Start, "Stop Exercise
	// (and return to main page)" on the right) — finish mode rewrites them.
	function restoreExerciseButtonLabels() {
		var list = displayManager ? displayManager.getDefList() : null;
		startButton.find("#startCountId").text(list && list.length
			? " (" + startCountText(list) + ")" : "");
		$("#stopLabelId").text(getRes("stopButton_label"));
		$("#stopSubId").text(getRes("stopButton_sub"));
	}

	window.exerciseFinished = function (summary) {
		// The session is over: nulling it makes the Start button start a FRESH run of the same set
		// (the plain !trainingSession path below), and keeps Back to Words from posting a STOPPED
		// outcome over the COMPLETED one via returnToRandomView's stopSession call.
		trainingSession = null;
		answerBox.hide();
		// The session is over, so the cluster unlocks even though the finish screen is still up:
		// changing direction and pressing "Practice Again" is exactly how the same set gets drilled
		// the other way round.
		lockDirectionControls(false);
		startButtonLabel.text(getRes("practiceAgainButton_label"));
		startButton.assignTooltip("practiceAgainButton_tooltip");
		startButton.prop("disabled", false);
		$("#stopLabelId").text(getRes("backToWordsButton_label"));
		$("#stopSubId").text(getRes("backToWordsButton_sub"));
		// The drill hid the Word Lists panel for full focus (exerciseView's hidePanel); the session
		// is over as of this call, so bring it back now rather than waiting on "Back to Words".
		if (settings.myListPanel.panelAttrToShow) {
			settings.myListPanel.showPanel(false);
		}
		lastFinish = {
			summary: summary,
			ended: null,   // pass 2's payload, filled by exerciseSessionEnded below
			at: Date.now(),
			langFrom: langFromValField.attr("data-lang-code") || "",
			langTo: langToValField.attr("data-lang-code") || ""
		};
		saveLastFinish();
		renderExerciseSummary(summary);
	};

	// ── The last finished screen, on demand (the ⊙ button in the tray controls) ───────────────────
	// A drill's summary card is the one screen a user reads once, leaves, and then wants back: how
	// many were flawless, which words grew, what was flagged tricky. Nothing here recomputes any of
	// that — the EXACT payload the live screen was built from is kept and re-rendered, so the review
	// and the original cannot disagree. (The growth bed is the one part that reads live state: it
	// draws each plant at the stage it is at NOW, glowing for what THIS session grew. That is the
	// honest picture — the plant is one object, not a photograph.)
	//
	// Kept SERVER-SIDE per (user, language pair) — api/last-finish, the tray persistence pattern
	// applied to one JSON blob (owner ask 2026-08-24; sessionStorage before that, which died with
	// the tab). The pair's last session is offered back regardless of when it happened — reload,
	// browser restart, another day, another machine — and the review header's date+time says which
	// session it is showing. Per USER by construction now, so a shared machine never shows one
	// person's words to the next. A snapshot from a DIFFERENT language pair is still never shown
	// (the words, and the → glyphs, belong to their pair): each pair keeps its own row server-side,
	// and a pair change swaps the in-memory copy via loadLastFinish.
	// `lastFinish` itself is declared at the top of this ready block, NOT here — see the note there.
	function saveLastFinish() {
		// Fire-and-forget like the tray save: the in-memory copy serves the button for the rest of
		// this page's life either way, so a lost save costs one review after the next reload.
		if (!lastFinish) { return; }
		$.ajax("api/last-finish/save", {
			type: "POST",
			data: { langFrom: lastFinish.langFrom, langTo: lastFinish.langTo,
				payload: JSON.stringify(lastFinish) }
		});
	}

	// Fetch the current pair's stored screen — called at boot and on every pair change. The reply
	// is dropped if the user has already flipped to ANOTHER pair while it was in flight, so a slow
	// reply can never clobber the fresher pair's own fetch.
	function loadLastFinish() {
		var langFrom = langFromValField.attr("data-lang-code") || "";
		var langTo = langToValField.attr("data-lang-code") || "";
		if (!langTo) { return; }   // no learning pair yet → nothing stored to ask for
		$.ajax("api/last-finish", {
			type: "GET",
			data: { langFrom: langFrom, langTo: langTo },
			dataType: "json",
			success: function (data) {
				if (langFrom !== (langFromValField.attr("data-lang-code") || "")
					|| langTo !== (langToValField.attr("data-lang-code") || "")) { return; }
				try {
					lastFinish = (data && data.payload) ? JSON.parse(data.payload) : null;
				} catch (e) {
					lastFinish = null;   // an unreadable blob = no review, same as no row
				}
				refreshLastFinishButton();
			}
			// a failed load just leaves the button hidden — no worse than the pre-server behaviour
		});
	}

	function lastFinishAvailable() {
		return !!(lastFinish && lastFinish.summary
			&& lastFinish.langFrom === (langFromValField.attr("data-lang-code") || "")
			&& lastFinish.langTo === (langToValField.attr("data-lang-code") || ""));
	}

	// Called wherever the tray controls come back into view (randomWordsView) and whenever the pair
	// changes — the button must never offer a screen that belongs to another pair.
	// .css over .show(): .pl-btn-quiet is inline-flex (see the jquery-show-breaks-flex note).
	function refreshLastFinishButton() {
		// Called only from contexts where the review is NOT the screen on show (randomWordsView's
		// lean Practice tray, or a fresh pair's loadLastFinish) — the toggle face always resets here.
		lastFinishButton.attr("aria-pressed", "false");
		if (lastFinishAvailable()) {
			lastFinishButton.css("display", "inline-flex");
		} else {
			lastFinishButton.hide();
		}
	}

	// "when" for the review header: a time alone for today's session, date + time for an older one
	// (a tab left open overnight). Formatted for the APP's locale, not the browser's — owner
	// ruling 2026-09-01, docs/project/i18n-runtime-grammar.md §5.3.
	function fmtFinishedAt(ts) {
		var d = new Date(ts);
		var time = d.toLocaleTimeString(localeTag(), { hour: "2-digit", minute: "2-digit" });
		return d.toDateString() === new Date().toDateString()
			? time
			: d.toLocaleDateString(localeTag()) + " " + time;
	}

	function showLastFinish() {
		if (!lastFinishAvailable()) { return; }
		renderExerciseSummary(lastFinish.summary, lastFinish.at);
		var e = lastFinish.ended;
		if (e) {
			renderSessionEndSections(e.difficultWords, e.grew, e.wordOutcomes, e.difficultMarks,
				e.difficultFiled);
		}
		lastFinishView();
	}

	// The review's own chrome. Deliberately NOT exerciseView(): no drill is running, so there is no
	// progress bar to show and no answer field to focus, and the mode tabs stay up — this is a look
	// back, not a session the user is locked into.
	//
	// It does NOT put "Back to Words" on the band (owner, 2026-08-30). The LIVE finish screen needs
	// that hero because the drill has taken the page over and the tray controls are the only other
	// way out; a review is opened FROM the word list by a toggle that closes it again, so a second
	// exit would say the same thing twice — and it would push the band into its two-hero squeeze
	// for a screen that never had to be there. Start Exercise stays, alone, as on the word list.
	function lastFinishView() {
		lastFinishButton.attr("aria-pressed", "true");   // the pill itself is the toggle's own face
		// ⊙ pressed while out on an excursion (the tray controls stay up during a review): drop the
		// open card properly — the boxes are re-seated below either way, but the dictionary keeps
		// the lean set "Back to Words" returns to, and a card left expanded in it would resurface.
		exitFinishExcursion();
		$("#exerciseResultId").empty();
		progressBox.hide();
		tipBox.hide();
		answerBox.hide();
		lookupBox.hide();
		defBox.hide();
		learnBox.hide();
		learnControlBand.hide().empty();
		defExerciseBox.show();
		$("#centralTabsId").show();
		setActiveTab('practice');
		$("#exerciseControlBandId").css("display", "flex");
		trayControls.css("display", "flex");
		stopButton.hide().off("click");
		sizeCenterBoxToPanel();
		isExerciseView = false;   // no drill is running: the drill's key handling must stay off
	}

	// §9.1: the finish screen speaks the model's language. One line per outcome class present,
	// words grouped behind their phrase — every word gets its TRUTHFUL outcome (the model may log
	// a lapse behind a live pass), but 20 words don't become 20 rows. Token order = the order the
	// classes are worth reading in: the good news first, the voids last.
	var EX_OUTCOME_ORDER = ["RECALLED_COLD", "KNOWN_SLOW", "KNOWN_ARTICLE", "WARM_UP",
		"RELEARNED", "EARLY_PRACTICE", "PRACTICED"];
	var EX_OUTCOME_RES = {
		RECALLED_COLD: "exOutcome_recalledCold",
		KNOWN_SLOW: "exOutcome_knownSlow",
		KNOWN_ARTICLE: "exOutcome_knownArticle",
		WARM_UP: "exOutcome_warmUp",
		RELEARNED: "exOutcome_relearned",
		EARLY_PRACTICE: "exOutcome_earlyPractice",
		PRACTICED: "exOutcome_practiced"
	};

	// Every category on this card is three or four words — short enough to read at a glance, and
	// too short to explain itself. The hover carries the rest: what the model actually measured on
	// the FIRST showing (§4.2's probe — a later reveal of the same word in the same session is not
	// what the line is about), and, on the two section heads, the one rule people ask about first —
	// a plant grows when the memory estimate passes the next mark (1, 3, 7, 14, 30, 60, 90 days),
	// not because the answer was right. A correct answer that does not reach the next mark still
	// pushes the next watering out; that is the number in front of the word, not the picture.
	// ⚠️ That "one rule" is the v1 / flag-off story — see EX_OUTCOME_TIP_V2 below for the one outcome
	// whose tooltip states it directly and is wrong once learn.srs.growth.mode is active. This box
	// (renderWordSections) is superseded outright by renderWordSectionsV2's exBucket_* headings
	// whenever growth-v2 actually has data for a session, so exSummary_grewToday_tooltip /
	// exSummary_stillGrowing_tooltip were checked and deliberately left unrewritten — see
	// docs/project/garden-growth-explainer.md's "v2 copy" section for the full reasoning.
	var EX_OUTCOME_TIP = {
		RECALLED_COLD: "exOutcome_recalledCold_tooltip",
		KNOWN_SLOW: "exOutcome_knownSlow_tooltip",
		KNOWN_ARTICLE: "exOutcome_knownArticle_tooltip",
		WARM_UP: "exOutcome_warmUp_tooltip",
		RELEARNED: "exOutcome_relearned_tooltip",
		EARLY_PRACTICE: "exOutcome_earlyPractice_tooltip",
		PRACTICED: "exOutcome_practiced_tooltip"
	};

	// v2 variants — only EARLY_PRACTICE's tooltip ties its wording to growth timing (it claims the
	// plant steps on "the date the badge shows", which is the watering day, not the fixed growth
	// mark under v2); the other seven describe the practice outcome only and were checked and left
	// alone. Read via exOutcomeTipKey() below, gated by GARDEN.isGrowthV2Mode() — the same signal
	// garden.js's explainer already uses, never a second mechanism.
	var EX_OUTCOME_TIP_V2 = {
		EARLY_PRACTICE: "exOutcome_earlyPractice_tooltip_v2"
	};

	function exOutcomeTipKey(token) {
		return (GARDEN.isGrowthV2Mode() && EX_OUTCOME_TIP_V2[token]) || EX_OUTCOME_TIP[token];
	}

	// Which language the user TYPED for this word — "→DE" / "→EN". Shown per word only in a Mix
	// session: in a pure one every word carries the same glyph and it is decoration, not news.
	function exWordDirGlyph(reverse) {
		if (!exSessionMixed) { return null; }
		var code = (reverse ? langFromValField : langToValField).attr("data-lang-code") || "";
		if (!code) { return null; }
		return $("<span>").addClass("exWordDirClass subduedClass").text(" →" + code);
	}

	// What the LEFT plant of a step should be drawn as. A stage number of 0 means two different
	// things depending on which engine produced it, and since 2026-08-25 they are two different
	// drawings (garden.js bodyId): under the shipped ladder 0 means there was no plant and the word
	// grew out of "Ready"; under growth v2 it is the SPROUT, a real plant with a watering date.
	//
	// stageAfter settles the one case the mode flag alone cannot: a v2 SPROUT event is 0 → 0, and
	// the thing it grew out of is Ready either way. Only a 0 → 1 climb has a sprout behind it.
	function exStageKind(stageBefore, stageAfter) {
		if (stageBefore >= 1) { return stageBefore; }
		return (stageAfter >= 1 && GARDEN.isGrowthV2Mode()) ? 0 : "germ";
	}

	// A word's stage step as the two plants themselves — the picture the bed and every word list
	// already speak in, rather than a pair of stage names nobody has learnt yet.
	// (Written through .html(): jQuery 1.9's $("<svg>") builds HTML-namespace nodes that never render.)
	function exStageStep(stageBefore, stageAfter) {
		return $("<span>").addClass("exStageStepClass").html(
			GARDEN.plantSvg(exStageKind(stageBefore, stageAfter), "pl-plant-sm", true)
			+ '<span class="exStageArrowClass">→</span>'
			+ GARDEN.plantSvg(stageAfter, "pl-plant-sm", true));
	}

	function exSectionHead(text, tipKey) {
		var head = $("<div>").addClass("exWordSectionHeadClass").text(text);
		return tipKey ? head.assignTooltip(tipKey) : head;
	}

	// Links ANY word on the finish screen to its plant in the growth bed (GARDEN.hoverBedTerm/
	// clearBedHover below) — hovering either side rings + enlarges the flower and shows its popup;
	// hovering the flower bolds the word back (GARDEN.onBedHover, wired once near the top of this
	// section). Every word shown here (grown, still growing, tricky) is part of the session, so
	// every one of them has a plant in the bed — the linkage applies uniformly, not just to the
	// words that grew today.
	function wireBedHover($el, termId) {
		return $el.attr("data-term-id", termId)
			.on("mouseenter", function () { exHoverTermId = termId; GARDEN.hoverBedTerm(termId); })
			.on("mouseleave", function () { exHoverTermId = null; GARDEN.clearBedHover(); });
	}

	// ── the watering badge that rides in front of every word on this screen ───────────────────────
	// Owner ask 2026-08-20: each word says when it wants watering next. That question already has an
	// answer everywhere else in the app — the blue/yellow day badge from the garden ([[my-garden-list]])
	// — so this is the SAME badge, not a finish-screen invention: same span, same two faces, same
	// tooltip carrying the sentence behind the number.
	//
	// The badge alone, with no plant beside it (GARDEN.decorateDays paints these): "Grew today"
	// already draws each word's stage pair and the bed beside the list draws every plant again at
	// full size, so a third picture per word would say nothing new. Emitted for every word
	// unconditionally and left EMPTY until pass 2 paints it — `.gardenDaysSlot:empty` collapses, so
	// pass 1's flat word list and any word with no plant behind it cost no gap at all.
	function exWordDays(termId) {
		return $("<span>").addClass("gardenDaysSlot exWordDaysClass").attr("data-term-id", termId);
	}

	// Pass 2's own arguments, kept so the v1 view below can be drawn LATER — once growth v2 has said
	// it will not be painting this card (exDrawV1Fallback). The session-end callback fires once and
	// is not replayable, so without this stash "hold, then fall back" would have nothing to fall
	// back to.
	var exLastGrew = null, exLastOutcomes = null;

	// §6: the word list splits in two. "Grew today" carries the news the bed's glow is showing —
	// which words moved, and from what to what. Everything else lands under "Still growing", where
	// the six §9.1 outcome groupings survive intact as its sub-lines: a word that was watered and
	// holds its stage until it is due is the COMMON case, and the old flat list left the user
	// reading it as failure. Splitting it says what it is — no growth today, growth on schedule.
	//
	// This is the FLAG-OFF view now: with learn.srs.growth.mode active, renderWordSectionsV2 owns
	// the card and this only ever paints if growth v2 says it has nothing for this session.
	function renderWordSections(grew, wordOutcomes) {
		var box = $("#exSummaryOutcomesId");
		if (!box.length) { return; }
		// Called twice per finish screen (see renderExerciseSummary): pass 2 replaces what pass 1
		// drew rather than adding to it.
		box.empty();
		if (grew != null) { exLastGrew = grew; exLastOutcomes = wordOutcomes || []; }
		var grewIds = {}, revById = {};
		var i;
		for (i = 0; i < exSessionWords.length; i++) {
			revById[exSessionWords[i].termId] = !!exSessionWords[i].reverse;
		}

		// Pass 1 — the server has not answered yet. The one heading that is TRUE at this moment is
		// the session's own word set: "grew today" and "still growing" are both claims about
		// scoring that has not happened, and guessing either would mean the list visibly rewriting
		// itself from a wrong statement to a right one.
		//
		// Pass 2 holds that same neutral heading while growth v2 may still answer. The v2 repaint
		// (renderWordSectionsV2) is a SEPARATE request that lands a moment later, and drawing the
		// §9.1 outcome lines in between would flash the user exactly the phrasings the v2 screen
		// retired — the same visible rewrite-from-a-wrong-statement this function already refuses
		// at pass 1, one step later. Once a call comes back empty or fails, exDrawV1Fallback()
		// latches growthV2ConfirmedOff and calls this again; THAT call draws the full v1 view
		// below, and it is the only time those lines are ever painted.
		if (grew == null || !growthV2ConfirmedOff) {
			if (!exSessionWords.length) { return; }
			box.append($("<div>").addClass("exWordSectionClass")
				.append(exSectionHead(strFormat(getRes("exSummary_sessionWords"),
						exSessionWords.length), "exSummary_sessionWords_tooltip"))
				.append($("<div>").addClass("exOutcomeLineClass")
					.append(exWordSpans(exSessionWords, revById))));
			return;
		}

		for (i = 0; i < grew.length; i++) { grewIds[grew[i].termId] = 1; }

		if (grew.length) {
			var grown = $("<div>").addClass("exGrewWordsClass");
			for (i = 0; i < grew.length; i++) {
				var g = grew[i];
				grown.append(wireBedHover($("<span>").addClass("exGrewWordClass"), g.termId)
					.append(exWordDays(g.termId))
					.append($("<span>").addClass("exOutcomeWordsClass exSummaryTrickyWordClass")
						.text(g.term)
						.click(function () { exWordClick($(this).text()); }))
					.append(exWordDirGlyph(revById[g.termId]))
					.append(exStageStep(g.stageBefore, g.stageAfter)));
			}
			box.append($("<div>").addClass("exWordSectionClass")
				.append(exSectionHead(strFormat(getRes("exSummary_grewToday"), grew.length),
						"exSummary_grewToday_tooltip"))
				.append(grown));
		}

		// The rest: grouped by outcome token, in the order the classes are worth reading in.
		// A word with no §9.1 line at all (an input-anomaly or content-defect void — no honest
		// claim exists, by design) still gets named, so the section's count is the truth.
		var byToken = {}, named = {}, rest = $("<div>");
		for (i = 0; i < (wordOutcomes || []).length; i++) {
			var o = wordOutcomes[i];
			if (grewIds[o.termId] || !EX_OUTCOME_RES[o.outcome]) { continue; }
			(byToken[o.outcome] = byToken[o.outcome] || []).push(o);
			named[o.termId] = 1;
		}
		for (var t = 0; t < EX_OUTCOME_ORDER.length; t++) {
			var token = EX_OUTCOME_ORDER[t];
			if (!byToken[token]) { continue; }
			rest.append($("<div>").addClass("exOutcomeLineClass")
				.append(exWordSpans(byToken[token], revById))
				.append($("<span>").addClass("exOutcomePhraseClass subduedClass")
					.text(" — " + getRes(EX_OUTCOME_RES[token]))
					.assignTooltip(exOutcomeTipKey(token))));
		}
		var quiet = [];
		for (i = 0; i < exSessionWords.length; i++) {
			var w = exSessionWords[i];
			if (!grewIds[w.termId] && !named[w.termId]) { quiet.push(w); }
		}
		if (quiet.length) {
			rest.append($("<div>").addClass("exOutcomeLineClass").append(exWordSpans(quiet, revById)));
		}

		var restCount = exSessionWords.length
			? exSessionWords.length - grew.length
			: countWords(byToken, quiet);
		if (rest.children().length) {
			box.append($("<div>").addClass("exWordSectionClass")
				.append(exSectionHead(strFormat(getRes("exSummary_stillGrowing"), restCount),
						"exSummary_stillGrowing_tooltip"))
				.append(rest));
		}
	}

	// ── v2 finish screen: ONE axis — the verdict at the user's own strictness ────────────────────
	// docs/project/finish-screen-classification.md, owner-ruled 2026-08-25. Replaces the four R13
	// buckets AS GROUP NAMES; the buckets themselves are untouched on the wire and still decide the
	// split inside "Recalled". Called from fetchGrowthV2 below, once its own (separate) request
	// lands; never called at all while learn.srs.growth.mode is off.
	//
	// Why the old shape went: its lines mixed two axes — what the app DID ("needed the answer
	// shown") and what the model CONCLUDED ("recalled cold"). An axis-1 sentence used as an axis-2
	// group name is falsifiable by the user, and rule v3 makes the two disagree on purpose. Every
	// group here sits on the verdict axis, and the bar is the user's own strictness notch, so the
	// claim is theirs rather than ours.
	//
	//   0. First watering — the word's FIRST practice ever. NO recall claim either way: there was
	//      nothing to recall, the word had never been drilled, so judging it is a category error
	//      for the passes as much as the fails. Sits ABOVE the verdict groups and is the one
	//      celebratory line on the card (owner, 2026-08-25). Pass/fail is still recorded and still
	//      schedules exactly as before — only the screen stays quiet about it. Without this group
	//      a failed first practice would sit under "Recalled" outright, because GardenGrowthV2
	//      sprouts "regardless of pass/fail" and bucketOf files any sprout as GREW.
	//   1. Recalled, split by whether the flower reached a growth mark today.
	//   2. Not recalled.
	//
	// A word with no growth row at all (a VOID: contaminated / input_anomaly / content_defect) is
	// simply absent from all three — drawn in the bed, claimed about nowhere.
	function renderWordSectionsV2(growthWords) {
		var box = $("#exSummaryOutcomesId");
		if (!box.length || !growthWords || !growthWords.length) { return; }
		box.empty();
		var revById = {};
		for (var i = 0; i < exSessionWords.length; i++) {
			revById[exSessionWords[i].termId] = !!exSessionWords[i].reverse;
		}
		var sprouted = [], grew = [], holding = [], missed = [];
		for (i = 0; i < growthWords.length; i++) {
			var w = growthWords[i];
			if (w.sprouted) { sprouted.push(w); }
			else if (!w.passed) { missed.push(w); }
			else if (w.bucket === "GREW") { grew.push(w); }
			else { holding.push(w); }
		}

		if (sprouted.length) {
			box.append($("<div>").addClass("exWordSectionClass exFirstWateringClass")
				.append(exSectionHead(strFormat(getRes("exGroup_firstWatering"), sprouted.length),
						"exGroup_firstWatering_tooltip"))
				.append($("<div>")
					.append($("<div>").addClass("exFirstWateringNoteClass")
						.text(getRes("exGroup_firstWatering_note")))
					.append($("<div>").addClass("exOutcomeLineClass")
						.append(exWordSpans(sprouted, revById)))));
		}

		if (grew.length || holding.length) {
			var recalled = $("<div>").addClass("exWordSectionClass")
				.append(exStrictnessHead("exGroup_recalled", grew.length + holding.length,
						"exGroup_recalled_tooltip"));
			if (grew.length) {
				recalled.append(exSubSection("exBucket_grew", grew.length,
						"exBucket_grew_tooltip", exGrewBody(grew, revById)));
			}
			if (holding.length) {
				recalled.append(exSubSection("exGroup_notDueYet", holding.length,
						"exGroup_notDueYet_tooltip",
						$("<div>").addClass("exOutcomeLineClass").append(exWordSpans(holding, revById))));
			}
			box.append(recalled);
		}

		if (missed.length) {
			box.append($("<div>").addClass("exWordSectionClass")
				.append(exStrictnessHead("exGroup_notRecalled", missed.length,
						"exGroup_notRecalled_tooltip"))
				.append($("<div>").addClass("exOutcomeLineClass").append(exWordSpans(missed, revById))));
		}
	}

	// "Grew today"'s body. Multi-stage growers keep their own line (R13) — a clean covering span is
	// rarer and more worth naming than an ordinary single-mark claim.
	function exGrewBody(words, revById) {
		var body = $("<div>"), multi = [], single = [], i;
		for (i = 0; i < words.length; i++) { (words[i].multiStage ? multi : single).push(words[i]); }
		if (single.length) {
			body.append($("<div>").addClass("exOutcomeLineClass")
				.append(exWordSpans(single, revById, true)));
		}
		if (multi.length) {
			body.append($("<div>").addClass("exOutcomeLineClass")
				.append(exWordSpans(multi, revById, true))
				.append($("<span>").addClass("exOutcomePhraseClass subduedClass")
					.text(" — " + getRes("exBucket_multiStage"))));
		}
		return body;
	}

	function exSubSection(headKey, count, tipKey, body) {
		return $("<div>").addClass("exWordSectionClass exWordSubSectionClass")
			.append(exSectionHead(strFormat(getRes(headKey), count), tipKey))
			.append(body);
	}

	// The two verdict group heads name the bar they are judged at and make it a LINK rather than
	// explaining it (owner: "we should put a hyperlink there on the word strictness") — the click
	// IS the explanation, so the head stays a group name instead of becoming a paragraph.
	//
	// The resource string carries {1} where the linked word belongs, and this sentinel is what
	// {1} is filled with before the head is split around it. A sentinel rather than a fixed
	// position, because the linked word is a WORD inside a sentence, not a suffix: Russian needs
	// it inflected and sitting elsewhere in the phrase. U+0001 can never occur in a resource
	// string, so the split is unambiguous.
	var EX_STRICTNESS_MARK = "\u0001";

	function exStrictnessHead(resKey, count, tipKey) {
		var head = $("<div>").addClass("exWordSectionHeadClass");
		var parts = strFormat(getRes(resKey), count, EX_STRICTNESS_MARK).split(EX_STRICTNESS_MARK);
		head.append(document.createTextNode(parts[0]));
		for (var i = 1; i < parts.length; i++) {
			head.append($("<a href='#'>").addClass("exStrictnessLinkClass")
				.text(getRes("exGroup_strictnessWord"))
				.click(function (e) {
					e.preventDefault();
					e.stopPropagation();
					openStrictnessSetting();
				}));
			head.append(document.createTextNode(parts[i]));
		}
		return tipKey ? head.assignTooltip(tipKey) : head;
	}

	// The prefs dropdown has exactly ONE opener — user_attr.js's private openPrefFrom, wired to the
	// two gear buttons — and no public entry point. Clicking whichever gear is actually on screen IS
	// that entry point, so there is no second opener to drift from the first
	// ([[reuse-existing-ui-artifacts]]) and user_attr.js needs no change at all. The strictness row
	// then flashes, because the dropdown holds six settings and this click has to land on an answer
	// rather than on a panel.
	function openStrictnessSetting() {
		var gear = $("#prefButtonExId").filter(":visible").first();
		if (!gear.length) { gear = $("#prefButtonId").filter(":visible").first(); }
		if (!gear.length) { gear = $("#prefButtonExId, #prefButtonId").first(); }
		if (!gear.length) { return; }
		gear.click();
		var row = $("#strictnessBoxId");
		if (!row.length) { return; }
		if (row[0].scrollIntoView) { row[0].scrollIntoView({ block: "nearest" }); }
		row.flashClass("infoBackground", 1600);
	}

	// ── R15: the decision moment — a quiet, dismissable line, information only ───────────────────
	// [[ui-copy-no-unsolicited-advice]]: what was detected, plus the one suggestion, then stop —
	// both directions read the same way, only the copy differs. Appended into the SAME box
	// renderWordSectionsV2 just filled (never its own mount id — main.html is outside this
	// build's file ownership, docs/project's P6 report), so it always lands after the buckets and
	// is never wiped by them (this runs strictly after, never before, that repaint).
	function renderDecisionMoment(moment) {
		var box = $("#exSummaryOutcomesId");
		if (!box.length || !moment || !moment.direction) { return; }
		var headKey = moment.direction === "PILE_UP" ? "decisionMoment_pileUp" : "decisionMoment_headroom";
		var line = $("<div>").addClass("exWordSectionClass exDecisionMomentClass")
			.append($("<span>").addClass("exDecisionMomentTextClass").text(getRes(headKey)));
		var dismiss = $("<button type='button' class='pl-btn-icon-round' aria-label='Close'>")
			.html("<span class='pl-ic pl-ic-x'></span>");
		dismiss.click(function () {
			line.remove();
			// Bookkeeping only — GardenService.decisionMoment's own suppression is keyed off the
			// DIRECTION changing, not this flag, so a failed post here costs nothing worse than a
			// possible repeat of the same line on a later session.
			ajaxPostUserAttr("decisionMoment", JSON.stringify({
				v: 1, direction: moment.direction,
				day: new Date().toISOString().slice(0, 10), dismissed: true
			}));
		});
		line.append(dismiss);
		box.append(line);
	}

	// ── the growth-v2 fetch itself ──────────────────────────────────────────────────────────────
	// A SEPARATE request from api/exercise-session-end, called once the finish screen's shipped
	// rendering has settled — not folded into that response because training_session.js's success
	// callback forwards only a fixed, positional field list to window.exerciseSessionEnded, and
	// that file sits outside this build's file ownership (GardenService#growthV2ForSession carries
	// the full reasoning). Suppressed for the rest of THIS page's lifetime once a call comes back
	// fully empty (learn.srs.growth.mode is off, the shipped default) — a page reload re-checks
	// once, which is correct: the flag can change between deploys.
	var growthV2ConfirmedOff = false;

	// v2 is not painting this card — the flag is off, this session produced no growth rows, or the
	// request failed. Draw the shipped §9.1 view that pass 2 deliberately held back
	// (renderWordSections). The latch is raised only FOR THE CALL, then put back: a one-off network
	// failure must not suppress v2 for the rest of the page's life, and a session that simply had
	// nothing to replay says nothing about the next one.
	function exDrawV1Fallback() {
		if (exLastGrew == null) { return; }
		var was = growthV2ConfirmedOff;
		growthV2ConfirmedOff = true;
		renderWordSections(exLastGrew, exLastOutcomes);
		growthV2ConfirmedOff = was;
	}

	function fetchGrowthV2(sessionId) {
		if (growthV2ConfirmedOff || !sessionId) { return; }
		$.ajax("api/garden/growth-v2", { data: { sessionId: sessionId }, dataType: "json" })
			.done(function (data) {
				var words = (data && data.growthWords) || [];
				var moment = data && data.decisionMoment;
				if (!words.length && !moment) { growthV2ConfirmedOff = true; }
				if (!words.length) {
					exDrawV1Fallback();
				} else {
					renderWordSectionsV2(words);
					GARDEN.setGrowthV2Mode(true);
					var byTermId = {};
					for (var i = 0; i < words.length; i++) {
						byTermId[words[i].termId] = words[i].nextMarkDays;
					}
					// The shipped decorateDays call already ran (renderSessionEndSections) against
					// the OLD (v1) DOM — renderWordSectionsV2 just rebuilt #exSummaryOutcomesId
					// from scratch, so its badges are brand new elements and need their own paint
					// before the soft-words addition has anything to attach to.
					GARDEN.decorateDays($("#defExerciseId .exSummaryClass"), function () {
						GARDEN.appendGrowthSoftWords($("#defExerciseId .exSummaryClass"), byTermId);
					});
				}
				if (moment) { renderDecisionMoment(moment); }
			})
			// Quiet, but not empty-handed: pass 2 is holding the card open for this answer, so a
			// failed call has to release it or the user is left with the neutral heading alone.
			.fail(function () { exDrawV1Fallback(); });
	}

	// Words behind one outcome phrase: comma-joined, each carrying its own direction glyph in Mix.
	// `withStage` adds the two-plants step after each word — passed only by the GREW bucket, where a
	// climb actually happened; everywhere else stageBefore === stageAfter and the pair would say
	// nothing. Items must then carry stageBefore/stageAfter (GrowthWord does; exSessionWords does not).
	function exWordSpans(items, revById, withStage) {
		var wrap = $("<span>").addClass("exOutcomeWordsClass");
		for (var i = 0; i < items.length; i++) {
			if (i > 0) { wrap.append($("<span>").text(", ")); }
			wrap.append(exWordDays(items[i].termId))
				.append(wireBedHover($("<span>").addClass("exSummaryTrickyWordClass"), items[i].termId)
					.text(items[i].term)
					.click(function () { exWordClick($(this).text()); }))
				.append(exWordDirGlyph(revById[items[i].termId]));
			// Only when something actually climbed. A growth-v2 SPROUT is stageBefore === stageAfter
			// === 0 (the shipped ladder floored a first pass at 1; v2 does not), so the pair would
			// draw the same plant twice either side of an arrow that means nothing. The word still
			// belongs under "Grew today", it just has no step to show. (Until 2026-08-25 there was a
			// second reason — 0 and "germ" were the same drawing — and it is gone; this one is not.)
			if (withStage && items[i].stageAfter > items[i].stageBefore) {
				wrap.append(exStageStep(items[i].stageBefore, items[i].stageAfter));
			}
		}
		return wrap;
	}

	// Fallback count for the "still growing" heading when the session handed over no word set
	// (an older/hand-built session object) — count what the section actually lists.
	function countWords(byToken, quiet) {
		var n = quiet.length;
		for (var k in byToken) { if (byToken.hasOwnProperty(k)) { n += byToken[k].length; } }
		return n;
	}

	// ── "Drill it in phrases" (difficult-words redesign D11) ──────────────────────────────────
	// One click asks the server for the few best collocations and example sentences for a word;
	// what comes back is SHOWN, each line strikeable, and only the user's confirm puts them in the
	// tray. The app advises, the user decides — an auto-add would have been one call instead of
	// two, and would have been the app deciding what a learner drills tonight.
	//
	// One implementation, two doors: the Difficult words band row (where meeting a hard word in
	// context is the point) and the rich view's head (where it is available for any word at all).
	// The popover follows the same chassis as every other menu here — appended to body, positioned
	// under its anchor, dismissed by PL.layers on Esc or an outside press.
	var phrasePickEl = null, phrasePickLayer = null;

	function closePhrasePicker() {
		if (phrasePickLayer) { phrasePickLayer.close(); }
	}

	function openPhrasePicker(anchorEl, termId, headword) {
		closePhrasePicker();
		var $anchor = $(anchorEl);
		$anchor.addClass("loading");
		$.ajax("api/phrase/pick", {
			type: "GET", dataType: "json",
			data: { termId: termId, defLang: langFromValField.attr("data-lang-code") }
		}).always(function () {
			$anchor.removeClass("loading");
		}).fail(function () {
			showMessage(getRes("operationCannotComplete_message"));
		}).done(function (data) {
			var phrases = (data && data.phrases) || [];
			if (!phrases.length) {
				// Honest, and two different honest things: the corpus may hold no phrases for this
				// word yet, or the learner may already have every one of them. Only the second is
				// worth a different sentence, and the server cannot tell them apart cheaply — so
				// the message says what is true of both.
				showMessage(strFormat(getRes("phrasePickNone_message"), headword));
				return;
			}
			renderPhrasePicker($anchor, headword, phrases);
		});
	}

	function renderPhrasePicker($anchor, headword, phrases) {
		var kept = phrases.slice();
		phrasePickEl = $("<div class='wlPopoverClass phrasePickClass'></div>");

		// The confirm rides in the HEAD, top-right of the title — the popover's one action, where
		// the eye lands first and where it stays put however long the list is. In the foot it sat
		// under four sentences of German and read as a footnote to them. The hint line that used to
		// share that foot is gone with it: the × / ✓ toggle explains itself the moment it is used,
		// and a sentence explaining a two-state button was the popover's third row of chrome.
		var okBtn = $("<button class='pl-btn-pill phrasePickOkClass' type='button'></button>")
			.text(getRes("phrasePickAdd_label"));
		okBtn.click(function (e) {
			e.preventDefault(); e.stopPropagation();
			addPhrasesToDrill(kept, $anchor);
		});
		phrasePickEl.append($("<div class='phrasePickHeadClass'></div>")
			.append($("<span class='phrasePickTitleClass'></span>")
				.text(strFormat(getRes("phrasePickTitle_label"), headword)))
			.append(okBtn));

		var list = $("<div class='phrasePickListClass'></div>");
		$.each(phrases, function (_, ph) {
			var row = $("<div class='phrasePickRowClass'></div>");
			row.append($("<span class='phrasePickTextClass'></span>").text(ph.text));
			row.append($("<span class='phrasePickTransClass subduedClass'></span>").text(ph.translation));
			// Striking a line out rather than removing it: the user has to be able to change their
			// mind without re-opening the picker and getting a different pick the second time. So the
			// control is a TOGGLE and says so — × while the line is in, ✓ while it is struck out,
			// which is the undo offered in the same place the strike-out happened.
			var drop = $("<button class='pl-btn-icon-round phrasePickDropClass' type='button'>"
				+ plIcon("x") + "</button>");
			drop.assignTooltip(function () {
				return getRes(kept.indexOf(ph) === -1
					? "phrasePickRestore_tooltip" : "phrasePickDrop_tooltip");
			});
			drop.click(function (e) {
				e.preventDefault(); e.stopPropagation();
				var idx = kept.indexOf(ph);
				if (idx === -1) { kept.push(ph); } else { kept.splice(idx, 1); }
				var dropped = kept.indexOf(ph) === -1;
				row.toggleClass("phrasePickDroppedClass", dropped);
				drop.html(plIcon(dropped ? "check" : "x"));
				okBtn.prop("disabled", !kept.length);
			});
			row.append(drop);
			list.append(row);
		});
		phrasePickEl.append(list);

		$("body").append(phrasePickEl);
		placePhrasePicker($anchor);
		phrasePickEl.click(function (e) { e.stopPropagation(); });
		phrasePickLayer = PL.layers.push({
			el: phrasePickEl[0],
			anchors: [$anchor[0]],
			onClose: function () {
				phrasePickLayer = null;
				if (phrasePickEl) { phrasePickEl.remove(); phrasePickEl = null; }
			}
		});
	}

	// Anchor the picker under the control that opened it — with two corrections the other popovers
	// on this page do not need:
	//
	//   • the WORD-LIST row actions are hover-revealed, so the button has a ZERO-SIZED rect the
	//     moment the pointer leaves the row (which it does on the way to the popover). Anchoring to
	//     that put the panel at the top-left corner of the page. So a degenerate rect walks UP to
	//     the nearest ancestor that has one — the row, which is where the user is looking anyway.
	//   • the picker is content-tall (four sentences), so it can run off the bottom where a menu of
	//     four short items would not. It flips above its anchor rather than being clipped.
	function placePhrasePicker($anchor) {
		var el = $anchor[0];
		var rect = el.getBoundingClientRect();
		while (el && (rect.height === 0 || rect.width === 0) && el.parentElement) {
			el = el.parentElement;
			rect = el.getBoundingClientRect();
		}
		var w = phrasePickEl.outerWidth(), h = phrasePickEl.outerHeight();
		var left = Math.max(4, Math.min(rect.left + window.scrollX, $(window).width() - w - 12));
		var below = rect.bottom + 4;
		var top = (below + h > $(window).height() - 8 && rect.top - h - 4 > 8)
			? rect.top - h - 4
			: below;
		phrasePickEl.css({ top: Math.max(4, top + window.scrollY), left: left });
	}

	// The confirm: materialize the kept phrases into drillable terms, then stage them in the
	// CONTEXTUAL tray — the same destination every other add on the page routes to, so "where did
	// my phrases go" has the one answer it has everywhere else.
	function addPhrasesToDrill(kept, $anchor) {
		var collocIds = [], exampleIds = [];
		$.each(kept, function (_, ph) {
			(ph.kind === "COLLOCATION" ? collocIds : exampleIds).push(ph.id);
		});
		if (!collocIds.length && !exampleIds.length) { return; }
		closePhrasePicker();
		// The SAME defLang openPhrasePicker used to choose these phrases — the confirm must
		// materialize in the language the offer was read in.
		ajaxPost("api/phrase/to-drill", { collocIds: collocIds, exampleIds: exampleIds,
				defLang: langFromValField.attr("data-lang-code") },
			function (data) {
				var ids = (data && data.termIds) || [];
				if (!ids.length) { return; }
				if (addDestIsLearning()) { addWordsToLearning(ids, false); }
				else { addWordsToPractice(ids, false); }
				// A TOAST, not a message box: the phrases are visibly in the tray behind it, so this
				// only confirms what the user can already see — and a modal for that takes the focus,
				// dims the page and asks for an OK before you may do the next thing.
				showToast(getRes("phrasePickAdded_message"));
			}, getRes("operationCannotComplete_message"));
	}

	// The control itself, so both doors get the same button and the same tooltip.
	function phrasePickButton(termId, headwordFn, extraClass) {
		var btn = $("<button class='pl-btn-icon-round' type='button'></button>")
			.addClass(extraClass || "")
			.html(plIcon("text-quote"));
		btn.assignTooltip("phrasePick_tooltip");
		btn.click(function (e) {
			e.preventDefault(); e.stopPropagation();
			openPhrasePicker(btn, termId, headwordFn());
		});
		return btn;
	}

	// ── The 3-day exit regime's visible progress (redesign D9) ────────────────────────────────
	// One pip per day of the way out of "Difficult words", filled for the days already earned. A
	// COUNT rather than a bare "in progress", because the whole point of the regime is that the
	// user can see themselves winning, and a count against a known total also says how much is
	// left — which "practiced 2 days" on its own does not. The sentence lives in the tooltip,
	// where there is room for it to be a sentence.
	//
	// Days need not be consecutive and nothing ever takes a pip back: a bad day simply earns none.
	// There is deliberately no "lost" state to draw, because there is no such state.
	//
	// THREE SLOTS, ALWAYS — and past three, ONE PILL (2026-08-13). Three days is the whole promise,
	// so the countdown is always "N of 3". A word that has earned its three and is still here was
	// singled out again by the session that would have freed it (the exit test — see
	// DifficultAdmissionService.holdIds), and it keeps earning marks while that repeats. Drawing
	// them as pips would grow the row without bound and, worse, read as a countdown to a finish line
	// that does not exist: the word leaves on the first session that does not single it out,
	// whenever that comes. So four marks or more collapse into one accent pill carrying three
	// checks — fixed width forever, the days themselves in the tooltip. The old answer was a 6-pip
	// cap, which still grew the row twice over and still looked like a scoreboard at "6 of 7".
	//
	// MARKS_STUCK_AT only changes what that pill SAYS: six days of daily drilling and still being
	// singled out is not "nearly out", it means the word is unlearned rather than difficult, and the
	// honest options are to set it aside or keep going. Resetting the count to zero at any threshold
	// was considered and rejected — it takes back days of real work in one stroke, on the word the
	// user is fighting hardest.
	//
	// Lives on the My Garden band rows only — the finish screen deliberately shows no count (see
	// renderDifficultMarks). It sits at the top level of the ready block because it was once shared.
	var MARKS_TO_EXIT = 3;      // keep in step with DifficultRegime.MARKS_TO_EXIT
	var MARKS_STUCK_AT = 6;     // keep in step with DifficultRegime.MARKS_STUCK_AT

	function difficultMarksPips(marks) {
		var held = marks > MARKS_TO_EXIT;
		var wrap = $("<span>").addClass("wlRowMarksClass");
		var i;
		if (held) {
			var pill = $("<span>").addClass("wlRowMarksPillClass");
			for (i = 0; i < MARKS_TO_EXIT; i++) {
				pill.append($("<span>").addClass("wlRowMarkIconClass").html(plIcon("check")));
			}
			wrap.append(pill);
		} else {
			for (i = 0; i < MARKS_TO_EXIT; i++) {
				wrap.append($("<span>").addClass(i < marks ? "wlRowMarkOnClass" : "wlRowMarkOffClass")
					.html(i < marks ? plIcon("check") : ""));
			}
		}
		wrap.assignTooltip(function () {
			if (marks >= MARKS_STUCK_AT) { return strFormat(getRes("wlRowDifficultStuck_tooltip"), marks); }
			if (held) { return strFormat(getRes("wlRowDifficultHeld_tooltip"), marks); }
			return strFormat(getRes("wlRowDifficultMarks_tooltip"), marks, MARKS_TO_EXIT);
		});
		return wrap;
	}

	// One clickable word on any of the four Difficult-words lines: it bolds with its plant when the
	// growth bed is hovered, and opens its dictionary entry when clicked. Identical on all four, so
	// it is written once.
	function exDifficultWordSpan(item) {
		return wireBedHover($("<span>").addClass("exSummaryTrickyWordClass"), item.termId)
			.text(item.term)
			.click(function () { exWordClick($(this).text()); });
	}

	// Fill one of the four lines, or leave it absent when it has nothing to say — a heading over an
	// empty list is noise on a screen whose job is a quick well-done. `decorate` hangs a control off
	// each word (the offers' +); `hintRes` adds a subdued trailing clause.
	function exDifficultLine(slotId, labelRes, labelClass, items, hintRes, decorate) {
		var row = $(slotId);
		if (!row.length || !items || !items.length) { return; }
		var label = $("<span>").text(getRes(labelRes) + " ");
		if (labelClass) { label.addClass(labelClass); }
		row.append(label);
		for (var i = 0; i < items.length; i++) {
			if (i > 0) { row.append($("<span>").text(", ")); }
			// The badge rides in front of the word here too — these four lines name words the
			// reader is being asked to decide about, and "when does it come back" is part of that
			// decision (exWordDays).
			row.append(exWordDays(items[i].termId));
			row.append(exDifficultWordSpan(items[i]));
			if (decorate) { decorate(row, items[i]); }
		}
		if (hintRes) {
			row.append($("<span>").addClass("subduedClass").text(" " + getRes(hintRes)));
		}
	}

	// The finish screen's half of D9: acknowledge every checkmark this session earned, the moment
	// it is earned. Conquering an abominable word over three days is the exact experience the
	// redesign exists to give back, and a system that took the win in silence would be taking it
	// away.
	//
	// TWO lines since 2026-08-05, and that is the whole point. One line reading "Difficult words:
	// Anbieter" is the grammar of a FLAG — a category, then a word — so a user who had just beaten
	// the word read it as being told off, two lines above a genuine flag with the same shape. Now
	// the verb carries the meaning: graduations say they are over, the rest say they made progress.
	//
	// No running count on either line. It used to sit beside every word and turned this into the
	// longest, busiest block on the screen; twenty words each carrying a badge crowd out the news
	// they were meant to frame. The count lives on the My Garden band row, where it is asked for.
	function renderDifficultMarks(marks) {
		if (!marks || !marks.length) { return; }
		exDifficultLine("#exSummaryGradId", "exSummary_difficultGraduated",
			"exDifficultClearedClass",
			marks.filter(function (m) { return m.graduated; }), null, null);
		exDifficultLine("#exSummaryMarksId", "exSummary_difficultProgress", null,
			marks.filter(function (m) { return !m.graduated; }), null, null);
	}

	// What the app filed into the band BY ITSELF while closing this session (2026-08-05). This used
	// to happen in total silence: the engine's own flag is written by the garden advance, the offers
	// deliberately skip anything already banded so as not to ask about a word the app has already
	// taken, and no line said so. The word first met the user days later as a row with no
	// checkmarks and no story — which is exactly the "why is this being called difficult?" the
	// two-line split above exists to kill.
	//
	// No + here: these are already in. The WHY rides on each word, in the word's own terms
	// (redesign §6.7): "the answer was shown 6 times" — a number the user watched happen this
	// session, in the vocabulary the screen already speaks. That retired the shared trailing hint
	// ("slipping across several sessions"), which told the OLD rule's story — a lapse pattern
	// accumulated out of sight — and had no answer for a word filed on its very first practice.
	//
	// Two keys because Russian declines «раз» by count (2–4 «раза», otherwise «раз», with the
	// teens all «раз»); the other locales carry identical text under both, so the picker can stay
	// locale-blind. Filed words always have at least 2 reveals (the lowest ladder bar), so the
	// singular never arises.
	function difficultShownClause(n) {
		var few = n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14);
		return strFormat(getRes(few ? "exSummary_difficultFiled_shownFew"
			: "exSummary_difficultFiled_shown"), n);
	}
	function renderDifficultFiled(filed) {
		exDifficultLine("#exSummaryFiledId", "exSummary_difficultFiled", null, filed, null,
			function (row, item) {
				row.append($("<span>").addClass("subduedClass")
					.text(" " + difficultShownClause(item.reveals)));
			});
	}

	// One tricky word's offer control (redesign D4): a small + that files the word into the
	// "Difficult words" band — the app advises, the user decides, so nothing is auto-added and
	// each word asks individually. On success the + becomes a ✓ and the garden list repaints, so
	// the band is already right the next time the user looks at it.
	//
	// ONE WORD PER CLICK, and that is a decision rather than an omission (2026-08-04, when the
	// offers widened from the two hardest cards to every word the session measured as hard). The
	// band is uncapped and every member is due DAILY under the 3-day regime, so an "add them all"
	// would let one click create twenty daily obligations that nobody had looked at — the opposite
	// of the judgment the offer exists to ask for.
	function trickyOfferBtn(termId) {
		var btn = $("<button class='pl-btn-icon-round exTrickyAddClass' type='button'></button>")
			.html(plIcon("plus"));
		btn.assignTooltip("exSummary_offerDifficult_tooltip");
		btn.click(function () {
			ajaxPost("api/garden/difficult", { termId: termId, difficult: true }, function (data) {
				// applied:false = the engine has never seen this word (no state row yet — the
				// replay may still be seconds behind the session close). Honest failure, retryable.
				if (!data || !data.applied) {
					showMessage(getRes("operationCannotComplete_message"));
					return;
				}
				btn.replaceWith($("<span class='exTrickyAddedClass'></span>").html(plIcon("check")));
				window.refreshGardenList();
			}, getRes("operationCannotComplete_message"));
		});
		return btn;
	}

	// Everything the server's session-end answer PUTS ON THE CARD, and nothing else. Split out of
	// exerciseSessionEnded so the review button can repaint the identical screen without re-firing
	// any of the one-time side effects around it: the garden repaint, the My Garden refresh, the
	// onboarding beat and the tip counters all belong to a session ENDING, not to looking at one
	// again an hour later.
	function renderSessionEndSections(difficultWords, grew, wordOutcomes, difficultMarks,
			difficultFiled) {
		// If the user already left the finish screen, these targets are gone — every line no-ops.
		// The bed holds ALL of this session's words at their current stage, with the ones that
		// grew glowing in place (hover a plant for its story; click a plant for its rich entry,
		// click empty soil to open the whole garden). The list under it splits the same set into
		// "grew today" / "still growing".
		GARDEN.renderGrowthBed(grew, $("#exSummaryGrowthId"), exSessionWords);
		renderWordSections(grew, wordOutcomes);
		renderDifficultMarks(difficultMarks);
		renderDifficultFiled(difficultFiled);
		// The ask, last. The heading now carries the QUESTION rather than naming a category — a bare
		// "Tricky this round:" left the + to explain itself and read as a verdict already passed,
		// which is the opposite of what an offer is for. That also retires the trailing hint: the
		// heading says what the + does, and repeating it under four lines was the longest sentence
		// on the screen saying the least.
		// (On a review the offer is still live and still one word per click — the ask does not
		// expire just because the screen was reopened, and the server dedupes an already-filed word.)
		exDifficultLine("#exSummaryTrickyId", "exSummary_tricky", null, difficultWords, null,
			function (row, w) { row.append(trickyOfferBtn(w.termId)); });
		// Every word on the card now has its watering badge slot, so fill them all in one call —
		// after the last line is built, never per section, or each section would cost a round trip.
		// Pass 1 deliberately does not do this: the dates it would print are the ones this session
		// is in the middle of rewriting, and a badge that flips from yellow to blue a beat later is
		// worse than a badge that simply arrives with the rest of pass 2.
		GARDEN.decorateDays($("#defExerciseId .exSummaryClass"));
		window.refreshStats(function (data) {
			var text = strFormat(getRes("exSummary_bridgeMastered"), fmtNum(data.wordsMastered));
			if (data.currentStreakDays > 0) {
				text += " · 🔥 " + strFormat(getRes("stats_streak"), data.currentStreakDays);
			}
			$("#exSummaryBridgeId").text(text);
		});
	}

	// ── the one-time growth-explainer card (docs/project/garden-growth-explainer.md) ──────────────
	// Shown on the finish screen of the session that planted the user's FIRST-EVER word, and never
	// again: `firstGarden` is the server's half (that session and no other), the `garden_guide_seen`
	// attr is the user's half (they have already been offered this, on this or any other device).
	// Existing users are excluded by the trigger itself — their first planting is long past.
	//
	// It OFFERS, it does not lecture (ui-copy-no-unsolicited-advice / app-advises-user-decides): one
	// sentence, a press that opens the panel, an × that says no. Either answer stamps the attr —
	// the offer has been made, and repeating it tomorrow would be the nagging this card exists to
	// avoid. The vista's ? chip stays open to them forever either way.
	function renderFirstGardenCard() {
		var mount = $("#exSummaryFirstGardenId");
		if (!mount.length) { return; }
		var stamped = false;
		function stamp() {
			if (stamped) { return; }
			stamped = true;
			window.garden_guide_seen = true;   // this page's own copy, so it cannot come back mid-session
			ajaxPostUserAttr("gardenGuideSeen", true);
		}
		var card = $("<div>").addClass("gardenFirstPlantCardClass")
			.attr("role", "button").attr("tabindex", 0)
			.assignTooltip("garden_guide_open_chip");
		function open() {
			stamp();
			GARDEN.openGrowthGuide();
		}
		card.append($("<span>").addClass("gardenFirstPlantTextClass")
			.text(getRes("garden_firstplant_card")));
		var dismiss = $("<button type='button' class='pl-btn-icon-round' aria-label='Close'>")
			.html("<span class='pl-ic pl-ic-x'></span>");
		dismiss.click(function (e) {
			e.stopPropagation();   // the card itself is the open button — an × press is the other answer
			stamp();
			mount.empty();
		});
		card.append(dismiss);
		card.click(open).on("keydown", function (e) {
			if (e.key === "Enter" || e.key === " ") { e.preventDefault(); open(); }
		});
		mount.empty().append(card);
	}

	window.exerciseSessionEnded = function (difficultWords, grew, wordOutcomes, difficultMarks,
			difficultFiled, firstGarden, sessionId, auditCaptured) {
		renderSessionEndSections(difficultWords, grew, wordOutcomes, difficultMarks, difficultFiled);
		// The audit pill (session-word-audit.md): auditCaptured is false for every non-gated
		// user, so this never appears for anyone but the owner. Live finish only, deliberately —
		// exFinishPills builds the row this appends into ONLY when reviewAt is unset
		// (renderExerciseSummary), and that has already run by the time this callback fires. The
		// row is checked for rather than assumed: a future caller of this same callback (or a
		// pills-row redesign) must not throw just because the row is not there.
		if (auditCaptured && sessionId) {
			var pillsRow = $(".exSummaryPillsClass");
			if (pillsRow.length && !$("#auditFinishId").length) {
				pillsRow.append(auditFinishPill(sessionId));
			}
		}
		// Deliberately NOT part of renderSessionEndSections, and so deliberately NOT replayed by the
		// ⊙ review button: this is a one-time offer tied to a moment, not a fact about the session.
		if (firstGarden && !window.garden_guide_seen) { renderFirstGardenCard(); }
		// Garden growth engine v2 (docs/project/garden-srs-redesign-spec.md Sec 2; P6) — a separate,
		// best-effort request; see fetchGrowthV2's own comment for why this cannot simply read off
		// the arguments above. Replayed on a ⊙ review the same as the audit pill above (both are
		// facts ABOUT the session, unlike the one-time card just above this).
		fetchGrowthV2(sessionId);
		// The screen is now complete — remember it whole, so the review button reopens THIS, not the
		// half-painted pass-1 card. (exerciseFinished stored the summary a moment ago; a session-end
		// that never answers simply leaves the review showing what pass 1 knew, which is the same
		// thing the user was left looking at.)
		if (lastFinish) {
			lastFinish.ended = {
				difficultWords: difficultWords, grew: grew, wordOutcomes: wordOutcomes,
				difficultMarks: difficultMarks, difficultFiled: difficultFiled
			};
			saveLastFinish();
		}
		// A drill is the ONLY thing that grows a plant, so this is the moment every other surface
		// showing these words goes stale: open word lists, the trays, any lean rows behind the
		// finish screen. Repaint them all now, in one batched call — a user must never have to
		// close and reopen a list to find out that their word grew.
		GARDEN.refreshAll();
		// …and a watered word also CHANGES SECTION in My Garden ("Needs watering" → "Growing"),
		// which no icon repaint can express. Refresh the list itself if it is open.
		window.refreshGardenList();
		// Onboarding: the guided first session's finish beat + signup nudge ride on the finish
		// screen being fully painted (bed rendered above). No-ops unless a guided run is live.
		if (window.VISIT_LOG) { VISIT_LOG.mark("drilldone"); }
		if (window.ONBOARDING) { ONBOARDING.finishScreenShown(); }
		// Beacon tips: count the finished drill (+ a first promotion) for milestone gates.
		if (window.OB_TIPS) { OB_TIPS.sessionFinished(grew, wordOutcomes); }
	};

	startButton.click(function () {
		var defList = displayManager.getDefList();
		// Known-banned senses never drill — a tray of ONLY banned cards has nothing to exercise.
		// (In reverse the deck can also empty out when no card has sense translations.)
		if (Util.isEmpty(defList) || (!trainingSession && !drillDeckFrom(defList).length)) {
			showMessage(getRes("startButton_noWords_message"));
			return;
		}

		if (!trainingSession) {
			// A restart has begun (connection.js): a drill started now would be cut off at once.
			// Only a NEW drill — pausing and resuming the one in hand is untouched.
			if (PlConn.blocksNewExercise()) {
				showMessage(getRes("connNoNewExercise"));
				return;
			}
			var originInfo = displayManager.getSessionOriginInfo();
			var sessionMeta = {
				langFrom: langFromValField.attr("data-lang-code") || '',
				langTo: langToValField.attr("data-lang-code") || '',
				origin: originInfo.origin,
				wordListId: originInfo.wordListId,
				// The MODE is decided here, once per session (the deck shape must match it —
				// drillDeckFrom collapses to one card per word for reverse and Mix). The direction
				// each card actually asks in rides on the card itself (card.reverse).
				reverse: isReverseDrill(),
				mixed: isMixedDirection()
			};
			// The drill runs on the sense cards themselves: each card asks ONE meaning of its
			// word. Sibling senses of one word drilling in the same session is deliberate
			// (repetition is reinforcement; per-sense over-credit is a scheduling footnote).
			var deck = drillDeckFrom(defList);
			var launch = function () {
				trainingSession = new TrainingSession(deck, sessionMeta);
				if (window.VISIT_LOG) { VISIT_LOG.mark("drill", { cards: deck.length, reverse: sessionMeta.reverse, mixed: sessionMeta.mixed }); }
				trainingSession.startSession();
				startButtonLabel.text(getRes("pauseButton_label"));
				startButton.assignTooltip("pauseButton_tooltip");
				restoreExerciseButtonLabels();   // Practice Again arrives here with finish-mode faces
				exerciseView();
			};
			// Both pre-flights settle the DECK before the first card is dealt, so a card never waits
			// on a round trip mid-drill: what every conjugated card names itself with (its tense and
			// its head verb's senses), then Mix's last-drilled history. Each is a no-op for a deck
			// that doesn't need it (no conjugated cards / not Mix), so an ordinary session still
			// launches with zero requests.
			stampVerbTenses(deck, sessionMeta, function () {
				if (sessionMeta.mixed) { assignMixDirections(deck, launch); } else { launch(); }
			});
			return;   // launch() switches to the exercise view itself — it may run a tick late
		}

		if (trainingSession.isSessionStopped()) {
			//resume
			trainingSession.resumeSession();
			startButtonLabel.text(getRes("pauseButton_label"));
			startButton.assignTooltip("pauseButton_tooltip");
		} else {
			//pause
			trainingSession.pauseSession();
			startButtonLabel.text(getRes("continueButton_label"));
			startButton.assignTooltip("continueButton_tooltip");
		}

		exerciseView();
	});

	// Clear the tray: an empty set replaces the current one as a real history entry, so browser
	// Back — and the Undo peel that takes over the Clear button's face — restore the old tray
	// in ONE step. No server round-trip: the tray is client state.
	clearTrayButton.click(function () {
		// Locked while the Undo peel is animating: the tray is already empty and the only live
		// affordance is the "undo" link (a near-miss must not re-clear and re-arm the peel).
		if (peelActive) { return; }
		var list = displayManager ? displayManager.getDefList() : null;
		if (activeTab !== 'practice' || !Util.isNotEmpty(list)) { return; }   // nothing to clear
		pushLeanEntry('practice');
		practiceDeletedSenseIds = {};   // an emptied tray has no partial words left to remember
		commitPracticeSet([], null);
		showPracticeEmpty();
		showUndoPeel(clearTrayButton);
	});

	// Load a fresh random set from a dictionary level as the CURRENT practice set (empty tray —
	// a non-empty tray merges instead; see addRandomFromLevel in the Word Lists panel).
	function loadRandomLevelSet(levelCode, number) {
		// A level draw never reaches loadWordListSelection (it fetches words, not ids), so the tray cap
		// applies to the COUNT asked for. Silent here on purpose: the draw is a number the user typed,
		// so a smaller set is self-evident — nothing they picked by name goes missing.
		number = Math.min(number, trayCap());
		randomWordsView();
		displayManager.setDisplayPolicy(new DisplayPolicyFrequency(levelCode, number));
		// No learning language chosen yet (blank langTo): prompt instead of loading words.
		if (!langToValField.attr("data-lang-code")) {
			renderPracticeEmptyHint();
			return;
		}
		if (!displayManager.loadWords()) {
			return;
		}
		startButton.prop("disabled", false);
	}

	// Pull a word-list selection into Practice as the current practice set. The set is exercisable —
	// Start Exercise lives in Practice — so switch to that tab's chrome first, then give the load its
	// own history entry, exactly like a Random Words click: commitPracticeSet stamps the snapshot id
	// (+ termIds) into the entry, so tab trips and Back/Forward restore this set instead of the last
	// random one.
	// termIds is the RESULTING practice tray (an append merged the staged words in already), so the
	// cap applies to the whole list — no separate room calculation.
	function loadWordListSelection(termIds) {
		termIds = capTrayList(termIds, 0);
		randomWordsView();
		pushLeanEntry('practice');
		displayManager.setDisplayPolicy(new DisplayPolicyWordListSelectedDefs(termIds));
		displayManager.loadWords();
	}

	// ── WL → tray fly frame ──────────────────────────────────────────────────────
	// A Word-List add flies the app's standard outline frame (PL.fly, the same one add-to-list uses)
	// from the source WL element to the freshly-rendered tray content. The render is async (and lands
	// on a tab switch), so we ARM the flight here at click time and CONSUME it in DisplayManager's
	// displayAll once the tray paints. A bulk add (All / Selected / Random) targets the whole tray box
	// (termId null); an individual per-row add targets its new entry (waits for that row to appear). A
	// safety timeout drops the request if no tray render follows (e.g. an empty list).
	var pendingTrayFly = null;
	function armTrayFly(src, termId) {
		if (!src || !window.PL || !PL.fly) { pendingTrayFly = null; return; }
		var req = { src: src, termId: (termId == null ? null : termId) };
		pendingTrayFly = req;
		setTimeout(function () { if (pendingTrayFly === req) { pendingTrayFly = null; } }, 5000);
	}
	// Consume the armed flight after a tray render. `newRows` (an append) is the honest destination:
	// the frame hugs exactly the rows that just arrived — one row for a single word, the whole block
	// for a verb's forms or a multi-word pick. Without it the flight ends on the whole tray box, which
	// after an append reads as landing "somewhere down the list" (owner report 2026-08-30). A full
	// re-render passes nothing and keeps the old aim: the specific row for an individual add, the box
	// for a bulk one.
	function runPendingTrayFly(defArea, newRows) {
		if (!pendingTrayFly || (activeTab !== 'practice' && activeTab !== 'learn')) { return; }
		var pf = pendingTrayFly;
		var tgt = (newRows && newRows.length) ? trayRowsRect(newRows)
			: (pf.termId != null
				? defArea.find("._entryClass[data-term-id='" + pf.termId + "']")[0]
				: defArea[0]);
		if (!tgt) { return; }   // individual add: its row hasn't rendered yet — wait for the render that has it
		pendingTrayFly = null;
		if (pf.src && document.contains(pf.src)) { PL.fly(pf.src, tgt, 700); }
	}

	// The document-space rectangle a set of tray rows occupies, CLIPPED to the visible part of the
	// tray box: a block taller than the box would otherwise send the frame to a rectangle running off
	// past the panel's edge. Null when nothing of it is on screen.
	function trayRowsRect($rows) {
		var box = defBoxScrollBar[0];
		var clip = box ? box.getBoundingClientRect() : null;
		var top = Infinity, left = Infinity, right = -Infinity, bottom = -Infinity;
		for (var i = 0; i < $rows.length; i++) {
			var r = $rows[i].getBoundingClientRect();
			if (!r.width && !r.height) { continue; }
			top = Math.min(top, r.top); left = Math.min(left, r.left);
			right = Math.max(right, r.right); bottom = Math.max(bottom, r.bottom);
		}
		if (top === Infinity) { return null; }
		if (clip) { top = Math.max(top, clip.top); bottom = Math.min(bottom, clip.bottom); }
		if (bottom <= top || right <= left) { return null; }
		return {
			top: top + window.pageYOffset, left: left + window.pageXOffset,
			width: right - left, height: bottom - top
		};
	}

	// The card list currently in the practice tray. The tray = the last practice set shown — its
	// snapshot survives Dictionary excursions, so this is correct from either tab, not just while
	// the set is on screen. Fallback when the snapshot aged out of the cache: scan the on-screen
	// set if it IS a practice set.
	function currentPracticeList() {
		var list = (lastPracticeSetId != null && wordSetSnapshots[lastPracticeSetId])
			? wordSetSnapshots[lastPracticeSetId].list : null;
		if (!list && displayManager) {
			var origin = displayManager.getSessionOriginInfo().origin;
			if (origin === 'RANDOM' || origin === 'WORD_LIST') { list = displayManager.getDefList(); }
		}
		return list || [];
	}

	// The distinct term ids currently in the practice tray (sibling sense cards share one word).
	function currentTrayIds() {
		return distinctTermIds(currentPracticeList());
	}

	// ── Tray size cap ────────────────────────────────────────────────────────────
	// A tray stages ONE study session, it is not a shelf: "Add all" on a 2,000-word list would make
	// the drill endless, the rehydrate fetch huge and every whole-list save a bulk write. learn.tray-cap
	// (→ the tray_cap global, enforced again in TrayService when a tray is saved) is the ceiling, the
	// SAME number for both trays. Counted in WORDS, so a polysemous word's sense cards all ride along
	// and no word lands half in. An oversized add keeps the words that fit — the FIRST ones — and says
	// so, like the verb-forms ceiling above; the one silent trim is a level draw (loadRandomLevelSet),
	// where the count is a number the user typed rather than words they picked by name.
	function trayCap() {
		var n = +window.tray_cap;
		return (n > 0) ? n : 100;
	}

	// Words (not sense cards) currently staged in the Learn tray — what an append has to fit around.
	function learnTrayIds() {
		if (!window.LRN || !LRN.getTray) { return []; }
		return distinctTermIds(LRN.getTray() || []);
	}
	function learnTrayWordCount() {
		return learnTrayIds().length;
	}

	// Truncate one add — a list of term ids OR of lean clusters, one entry per word — to whatever
	// room the tray has left, and say so when it bites. `staged` = the words already in the tray
	// that this add keeps: 0 for a bulk add (it supersedes the tray) and for a list that already
	// carries the tray's own words merged in (the Practice path merges before it gets here).
	function capTrayList(items, staged) {
		if (!items) { return []; }
		var room = Math.max(0, trayCap() - (staged || 0));
		if (items.length <= room) { return items; }
		showMessage(strFormat(getRes("trayCapped_message"), trayCap(), items.length, room));
		return items.slice(0, room);
	}

	// ── Replace or add: the tray-collision choice ────────────────────────────────
	// A bulk add (a word list's All / Selected / Random ▸ n, My Garden's per-section twins, the
	// 💧 thirsty chip) used to SUPERSEDE the tray unconditionally. So staging a hand-picked set and
	// then reaching for a second source — five plants to water, then a few random words for the same
	// session — silently threw the first set away, with no warning and nothing on screen that said it
	// would happen.
	//
	// Which of the two a user wants depends on the MOMENT, not on their character: "give me exactly
	// this list" and "these as well" are both normal on the same afternoon. So it is asked at the END
	// of the pick — after All / Selected / a Random count — rather than parked in a remembered mode
	// they would have to carry in their head and check before every press.
	//
	// Asked ONLY when the destination tray already holds words. On an empty tray the two mean the same
	// thing, so nothing is asked and every surface keeps exactly the shape it had before — which is
	// also why the onboarding walk (gated on an empty tray throughout) never meets this. The per-row ✚
	// is untouched: one word has always appended, which is already the non-destructive answer.
	//
	// One vocabulary everywhere, so the choice reads the same in the list menu and in a garden
	// section's menu — and it does the ARITHMETIC rather than leaving the user to:
	//
	//     Replace in the [Practice] Tray   (−9 : +6)
	//     Add to the [Practice] Tray       (9 + 6 → 15)
	//
	// The tray's name is the one in the tab strip, picked out in the accent colour, because the two
	// trays are the thing you can genuinely be wrong about: the destination follows the active tab,
	// and the words go where the row says they go.

	// Everything the choice needs to describe itself. `incoming` = how many words this pick brings,
	// or null when that cannot be known in words (a VERBS pick brings its conjugated FORMS — several
	// cards per verb, counted server-side at expansion), in which case the arithmetic is dropped
	// rather than guessed. `learning` overrides the active tab for the one caller whose destination
	// is fixed (My Garden's "Continue in Learn").
	//
	// `ids` — the pick's concrete term ids, when the client PROVABLY has all of them
	// (`renderedIdsIfComplete` in the Word Lists panel, or a hand-checked selection). Given them, the
	// append row counts the REAL overlap with the tray and its total is a fact. Without them we know
	// only how many words the pick brings, never which, so the append row says "up to" and quotes no
	// total at all.
	//
	// It used to quote one regardless, calling it an upper bound — until an owner report on
	// 2026-08-07 where the whole pick was already staged: Replace read "(−41 : +41)" (right) and Add
	// read "41 + 41 → 82" (the true answer being "nothing to add"). An upper bound that is 100% off
	// in a routine case is simply a wrong number, and a wrong number stated confidently is worse than
	// an honest "up to".
	function trayDest(incoming, learning, ids) {
		var toLearn = (learning == null) ? addDestIsLearning() : !!learning;
		var stagedIds = toLearn ? learnTrayIds() : currentTrayIds();
		var staged = stagedIds.length;
		var want = (incoming == null) ? null : Math.max(0, Math.round(+incoming) || 0);
		// Exactness is a property of BOTH: a VERBS pick carries no word count at all (`incoming` is
		// null), so knowing its ids would still not let us count words.
		var exact = !!(ids && ids.length && want != null);
		var fresh = want;
		if (exact) {
			fresh = 0;
			for (var i = 0; i < ids.length; i++) {
				if (stagedIds.indexOf(ids[i]) === -1) { fresh++; }
			}
		}
		var room = Math.max(0, trayCap() - staged);
		return {
			learning: toLearn,
			staged: staged,
			incoming: want,
			exact: exact,
			room: room,
			// What each answer would actually do, the tray cap included — a replace has the whole
			// tray to fill, an append only the room left over.
			gainOnReplace: (want == null) ? null : Math.min(want, trayCap()),
			gainOnAppend: (want == null) ? null : Math.min(fresh, room)
		};
	}

	// The tray's name for a label — read from the tab strip itself, so the choice can never call it
	// something the tabs don't (those labels are Thymeleaf messages, not JS resources). The resource
	// keys below are a fallback for a page that has no tab strip.
	function trayDestName(learning) {
		var tab = $(learning ? "#tabLearnId" : "#tabPracticeId");
		var label = tab.children("span").not(".centralTabPlantClass, .centralTabIcon").first().text();
		return $.trim(label) || getRes(learning ? "trayDest_learn" : "trayDest_practice");
	}

	// The two choice rows, as detached elements sharing the word-list popover item face.
	// `apply(replace)` performs the add; `after` is the host surface's teardown and runs BEFORE it,
	// so the menu is gone by the time the tray repaints underneath it.
	function trayChoiceRows(dest, apply, after) {
		var name = escHtml(trayDestName(dest.learning));
		function row(labelKey, mathText, tip, replace, dead) {
			var el = $("<div class='wlPopoverItemClass trayChoiceRowClass'></div>");
			var label = $("<span class='trayChoiceLabelClass'></span>")
				.html(strFormat(escHtml(getRes(labelKey)),
					"<b class='trayChoiceDestClass'>" + name + "</b>"));
			el.append(label);
			if (mathText) {
				el.append($("<span class='trayChoiceMathClass'></span>").text(mathText));
			}
			el.assignTooltip(function () { return tip; });
			if (dead) {
				// Disabled, not hidden — an option that comes and goes reads as a bug, and the
				// tooltip is the whole point of the state (the same treatment "Selected" gets).
				el.addClass("wlMenuDisabledClass").click(function (e) { e.stopPropagation(); });
				return el;
			}
			el.click(function (e) {
				e.preventDefault();
				e.stopPropagation();
				if (after) { after(); }
				apply(replace);
			});
			return el;
		}
		var noMath = dest.incoming == null;
		var total = dest.staged + (dest.gainOnAppend || 0);

		// The append row has three shapes, and which one it takes is a question about what we KNOW,
		// not about what the tray holds:
		//   exact       "9 + 6 → 15"     — the pick's ids are in hand; this is a fact
		//   not exact   "9 + up to 6"    — only the pick's SIZE is known; no total is claimed
		//   dead        (dimmed)          — the row would add nothing, for one of two reasons
		// The two dead reasons must not share a tooltip: "the tray is full" and "these are already
		// staged" send the user to opposite next actions (clear some, vs nothing to do here).
		function appendMath() {
			if (noMath) { return ""; }
			return dest.exact
				? strFormat(getRes("trayAppend_math"), dest.staged, dest.gainOnAppend, total)
				: strFormat(getRes("trayAppendUpTo_math"), dest.staged, dest.gainOnAppend);
		}
		function appendTip() {
			if (noMath) { return getRes("trayAppendVerbs_tooltip"); }
			if (!dest.room) { return strFormat(getRes("trayFull_tooltip"), trayCap()); }
			if (dest.exact && !dest.gainOnAppend) {
				return strFormat(getRes("trayNothingNew_tooltip"), dest.incoming);
			}
			return dest.exact
				? strFormat(getRes("trayAppend_tooltip"), dest.staged, dest.gainOnAppend, total)
				: strFormat(getRes("trayAppendUpTo_tooltip"), dest.staged, dest.gainOnAppend);
		}
		// Dead when there is genuinely nothing to add. Without the ids that is only knowable when the
		// tray is FULL — an unknown overlap could still be zero, but guessing it is what this whole
		// change exists to stop, and a live row that turns out to add nothing is the honest outcome.
		var appendDead = !noMath && (!dest.room || (dest.exact && !dest.gainOnAppend));

		return [
			row("trayReplace_label",
				noMath ? "" : strFormat(getRes("trayReplace_math"), dest.staged, dest.gainOnReplace),
				noMath ? getRes("trayReplaceVerbs_tooltip")
					: strFormat(getRes("trayReplace_tooltip"), dest.staged, dest.gainOnReplace),
				true, false),
			row("trayAppend_label", appendMath(), appendTip(), false, appendDead)
		];
	}

	// (A standalone-popover host for these two rows — openTrayChoice / stageBulk, anchored under a
	// plain button — lived here until 2026-08-07. Its only user was the 💧 thirsty chip, which no
	// longer asks anything: it is a plain append shortcut now. Every remaining host is a MENU and
	// hangs the rows as a side flyout through buildChoiceSub.)

	// Add words to the practice tray. replace = true (a bulk add the user answered "Replace tray" for)
	// SUPERSEDES the tray — it becomes exactly the added words. replace = false (the per-row individual
	// button, and "Add to tray") appends at the end, deduped against what's already there.
	function addWordsToPractice(termIds, replace, stay) {
		var ids = replace ? [] : currentTrayIds();
		// What this call actually CHANGES about the staged set, which is what decides whether the
		// tray can grow in place or has to be rebuilt: `fresh` = the words being added at the end,
		// `restored` = an already-staged word that got ×-removed senses back (its row gains blocks,
		// so that row has to be rebuilt — an append can't reach it).
		var fresh = [];
		var restored = false;
		for (var j = 0; j < termIds.length; j++) {
			var addId = termIds[j];
			var isNew = ids.indexOf(addId) === -1;
			if (isNew) { ids.push(addId); fresh.push(addId); }
			if (restorePracticeSenses(addId) && !isNew) { restored = true; }
		}
		// Already on the Practice tab: there is no tab to switch TO, so loadWordListSelection's
		// randomWordsView() teardown/rebuild (hide/show every band, re-enter the tab from scratch)
		// buys nothing but the reflow storm and the "brand new" nudge chip flashing out and back in —
		// the same jerk #1180 fixed for the thirsty pill, hit here from every other add-to-Practice
		// surface (word-list dialogs, per-row buttons, dictionary rows) that didn't pass stay=true.
		// stagePracticeSet's lean repaint is correct whenever we're not actually switching tabs.
		// A plain append hands over the ids it adds, so the tray can GROW instead of re-render (see
		// stagePracticeSet); a replace, or a re-add that brings senses back into an existing row,
		// hands over nothing and takes the full rebuild it needs.
		if (stay || activeTab === 'practice') {
			// Every one of these is already staged and nothing came back: the tray is exactly what it
			// was. Re-rendering it would flash the whole list to report that nothing happened — so
			// say it, the way the 💧 chip already answers a press with nothing left to bring (owner
			// report 2026-08-30). A press must never be silent, and it must never lie about changing.
			if (!replace && !restored && !fresh.length) {
				showToast(strFormat(getRes("trayAlreadyStaged_toast"), trayDestName(false)));
				return;
			}
			stagePracticeSet(ids, (replace || restored) ? null : fresh);
		} else { loadWordListSelection(ids); }
	}

	// Stage a term-id set as the CURRENT practice set WITHOUT switching tabs or touching history —
	// what the one-press tray buttons need (docs/project/tray-add-buttons.md decision 4) when they
	// stage from the dict tab, a rich card, a word popup or a phrase gutter. loadWordListSelection
	// can't be reused as-is: it always calls randomWordsView() (switches chrome), and
	// DisplayManager.loadWords' own stale-load guard (activeTab !== loadTab) throws the render away
	// when called off-tab — silently, with no snapshot and no persistence. This mirrors
	// primePracticeFromCards' rehydrate-without-navigation shape instead: the snapshot +
	// lastPracticeSetId + persistPracticeTray happen regardless of the active tab (so
	// currentTrayIds() and a later Practice-tab visit both see the word immediately); only the
	// actual repaint — and replaceNav, which would otherwise stamp a Practice history state onto
	// whatever tab is really on screen — run if Practice is the one actually showing.
	//
	// `appendIds` (optional) = the ids this call ADDS to a set already on screen. When it is given
	// and the rows really are just growing (canAppendPracticeRows), the fetch asks for those words
	// ONLY and their rows are hung off the end of #defId — every existing row, its garden plant, its
	// badges and the scroll position survive untouched. #1180/#1181 stopped the CHROME from being
	// torn down on an add; this stops the LIST from being torn down, which is the rest of the blink
	// the owner still saw (owner report 2026-08-30, thirsty pill + Word-List adds): displayAll empties
	// the box and rebuilds every row, so a tray that only gained one word still flashed away and back
	// and jumped to the top — reading exactly like a page reload. The Learn tray never showed this
	// because its adds don't repaint the box at all.
	function stagePracticeSet(termIds, appendIds) {
		termIds = capTrayList(termIds, 0);
		if (!displayManager) { displayManager = new DisplayManager(); }
		var kept = canAppendPracticeRows(termIds, appendIds) ? displayManager.getDefList() : null;
		ajaxPost("wordlist-selected-defs", {
			defLang: langFromValField.attr("data-lang-code"),
			termIds: kept ? appendIds : termIds
		}, function (data) {
			var defs = (data && data.definitions) || [];
			if (!defs.length) { showMessage(getRes("noWords_message")); return; }
			var cards = expandPracticeClusters(defs);
			var policy = new DisplayPolicyWordListSelectedDefs(termIds);
			// The whole staged set either way — the snapshot, the tray persistence and the Start count
			// are about the SET, not about how much of it was just fetched.
			var list = kept ? kept.concat(cards) : cards;
			var setId = snapshotWordSet(list, policy);
			lastPracticeSetId = setId;
			persistPracticeTray();
			if (activeTab !== 'practice') { return; }
			disableDictScroll();
			displayManager.setDisplayPolicy(policy);
			// The fetch is async: if something else re-rendered the box meanwhile, the rows on screen
			// are no longer the ones `kept` describes and appending to them would interleave two sets.
			// Fall back to the full render — correct, and rare enough that its flash doesn't matter.
			var stale = kept && displayManager.getDefList() !== kept;
			displayManager.setDefList(list);
			if (kept && !stale) { appendPracticeRows(cards, list); } else { displayManager.displayAll(); }
			replaceNav(navStateForSet(setId));
			startButton.find("#startCountId").text(" (" + startCountText(list) + ")");
			startButton.prop("disabled", false);
		}, getRes("operationCannotComplete_message"));
	}

	// May `appendIds` be appended to the Practice rows currently on screen, instead of re-rendering
	// the set? Only when the lean tray view is what is actually showing (not a drill, not an open
	// rich card), the rendered list IS a practice set, and the new set is exactly the rendered words
	// followed by the added ones — nothing reordered, nothing dropped by the tray cap. Anything that
	// fails here still takes the full re-render, which stays the correct-by-construction path.
	function canAppendPracticeRows(termIds, appendIds) {
		if (!appendIds || !appendIds.length) { return false; }
		if (activeTab !== 'practice' || isExerciseView || richOpen) { return false; }
		var list = displayManager.getDefList();
		if (!list || !list.length) { return false; }
		var origin = displayManager.getSessionOriginInfo().origin;
		if (origin !== 'RANDOM' && origin !== 'WORD_LIST') { return false; }
		var staged = distinctTermIds(list);
		if (staged.length + appendIds.length !== termIds.length) { return false; }
		// Ids reach this code as numbers from some callers and as strings from others; compare them
		// as text so a mixed pair never sends a genuine append down the rebuild path.
		for (var i = 0; i < staged.length; i++) {
			if (String(staged[i]) !== String(termIds[i])) { return false; }
		}
		for (var j = 0; j < appendIds.length; j++) {
			if (String(appendIds[j]) !== String(termIds[staged.length + j])) { return false; }
		}
		// …and the rows must actually be in the box: an empty-tray hint, a Learn tray left behind or
		// a "no words" message would all leave the def list saying one thing and #defId showing
		// another. The last staged word's row is the cheap probe for "this list is what's painted".
		return $("#defId").find("._entryClass[data-term-id='" + staged[staged.length - 1] + "']").length > 0;
	}

	// Hang cards off the end of the rendered tray — the same rows displayAll would have built
	// (buildEntryElement, combined-view grouping and all), minus the teardown of the ones already
	// there. Shared by both trays; each caller decorates what it owns. Returns the new row nodes.
	function appendTrayRows(cards) {
		var defArea = $("#defId");
		var pattern = doc.getLookupText();
		var combined = isCombinedTrayView();
		var added = $();
		for (var i = 0; i < cards.length; i++) {
			var entry = cards[i];
			var el;
			if (combined && entry && entry.senseId != null && entry.term && entry.term.id != null) {
				var group = [entry];
				while (i + 1 < cards.length && cards[i + 1]
						&& cards[i + 1].senseId != null && cards[i + 1].term
						&& cards[i + 1].term.id === entry.term.id) {
					group.push(cards[++i]);
				}
				el = buildEntryElement(entry, dictEntryUid++, pattern, group);
			} else {
				el = buildEntryElement(entry, dictEntryUid++, pattern);
			}
			defArea.append(el);
			added = added.add(el);
		}
		// A word added to the BOTTOM of a tray that is already taller than its box lands out of sight,
		// and the whole point of the press was to see it arrive. Scroll the minimum that brings the
		// new block into view (owner report 2026-08-30) — the full re-render used to hide this by
		// jumping to the top, which showed the new word only when the tray was short.
		scrollTrayRowsIntoView(added);
		return added;
	}

	// Bring the just-appended rows into the tray box, scrolling as little as possible: already fully
	// visible → don't move at all; a block taller than the box → its first row at the top.
	function scrollTrayRowsIntoView($rows) {
		var box = defBoxScrollBar[0];
		if (!box || !$rows || !$rows.length) { return; }
		var boxTop = box.getBoundingClientRect().top;
		var top = $rows[0].getBoundingClientRect().top - boxTop + box.scrollTop;
		var bottom = $rows[$rows.length - 1].getBoundingClientRect().bottom - boxTop + box.scrollTop;
		var want = box.scrollTop;
		if (bottom > want + box.clientHeight) { want = bottom - box.clientHeight; }
		if (top < want) { want = top; }
		want = Math.max(0, Math.min(want, box.scrollHeight - box.clientHeight));
		if (want !== box.scrollTop) { box.scrollTop = want; }
	}

	// `list` = the whole staged set, which the nudge chip counts.
	function appendPracticeRows(cards, list) {
		var defArea = $("#defId");
		var added = appendTrayRows(cards);
		// Plants for the NEW rows only — the ones already on screen keep the plants they have drawn,
		// which is half the point of appending (a re-decorate of the whole box re-requests every
		// word's status and repaints every slot).
		GARDEN.decorate(added);
		// The nudge chip is about the whole set, so it is re-asked with the grown list; maybeNudge
		// swaps a standing chip for the new count in one frame, so it never blinks out and back.
		if (window.LRN && LRN.maybeNudge) { LRN.maybeNudge(defArea, list); }
		runPendingTrayFly(defArea, added);
		if (window.OB_TIPS) { OB_TIPS.evaluate(); }
	}

	// Forget the ×-removals of one word, so the refetch expands it to ALL its sense cards again.
	// Returns true when something was actually un-removed — the caller reads that as "this word's
	// row is about to gain sense blocks", which no append can do.
	function restorePracticeSenses(termId) {
		var any = false;
		for (var k in practiceDeletedSenseIds) {
			if (practiceDeletedSenseIds[k] === termId) { delete practiceDeletedSenseIds[k]; any = true; }
		}
		return any;
	}

	// Add specific SENSES to the practice tray (the Learn recap's "Go to the practice now!": the
	// graduated cards move over). cards = [{senseId, termId}] in recap order. Like every batch add,
	// this SUPERSEDES the practice tray — you drill exactly the words you just learned (ids starts
	// empty). Each word arrives with ONLY its handed-over senses — the rest are filtered at expansion
	// (pendingHandoffSenses) and kept soft-deleted until they graduate (or the word is re-added whole).
	function addSensesToPractice(cards) {
		var ids = [];
		for (var i = 0; i < cards.length; i++) {
			var c = cards[i];
			if (c.senseId == null || c.termId == null) { continue; }
			delete practiceDeletedSenseIds[c.senseId];   // a graduated sense joins even if once ×-removed
			if (ids.indexOf(c.termId) === -1) {
				ids.push(c.termId);
				pendingHandoffSenses[c.termId] = {};
			}
			if (pendingHandoffSenses[c.termId]) { pendingHandoffSenses[c.termId][c.senseId] = true; }
		}
		loadWordListSelection(ids);
	}

	// Add words to the LEARN tray: fetch their lean clusters and hand them to learning_session.js, then
	// land on the Learn tab. replace = true (bulk adds: "Add to Learning" All/Selected/Random) wipes the
	// tray first so it becomes exactly the added words; replace = false (per-row) appends (deduped).
	function addWordsToLearning(termIds, replace, stay) {
		// Unlike Practice, the learn tray keeps its own list: an append (replace = false) only gets
		// the NEW ids, so the room left is the cap minus what is staged. Capped BEFORE the fetch —
		// no point pulling clusters that can't be staged.
		termIds = capTrayList(termIds, replace ? 0 : learnTrayWordCount());
		if (!termIds.length) { return; }
		ajaxPost("wordlist-selected-defs", {
			defLang: langFromValField.attr("data-lang-code"),
			termIds: termIds
		}, function (data) {
			var defs = (data && data.definitions) || [];
			if (!defs.length) { showMessage(getRes("noWords_message")); return; }
			var added = LRN.addWords(defs, false, replace) || [];
			// Nothing new — the Learn tray already holds every one of these. Same answer as Practice:
			// a toast, never a repaint that flashes the tray to announce that nothing changed. (A
			// navigating add still travels: landing on the tray IS the answer there.)
			if (!replace && !added.length && (stay || activeTab === 'learn')) {
				showToast(strFormat(getRes("trayAlreadyStaged_toast"), trayDestName(true)));
				return;
			}
			// Already ON the Learn tab: grow the rendered tray by exactly the new rows. openLearnTab
			// would re-enter the whole tab (applyLearnChrome → showTray → displayAll) and rebuild
			// every row — the same blink #1183 took out of Practice, still visible here as the row
			// icons flashing (owner report 2026-08-30, with a screenshot of the badge/×/plant strip).
			if (activeTab === 'learn') { appendLearnRows(added, replace); return; }
			// stay = true for the one-press tray buttons (decision 4: no tab navigation from these).
			// LRN.addWords already persisted; the tray itself repaints from LRN's live state on the
			// next real tab visit (applyLearnChrome → LRN.showTray), no snapshot needed here.
			if (!stay) { window.openLearnTab(); }
		}, getRes("operationCannotComplete_message"));
	}

	// ── Study unit (term vs sense) ───────────────────────────────────────────────
	// learn.study-unit (→ the study_unit JS global): `term` (default) stages ONE card per WORD in
	// both trays and both sessions — its senses ride along on a composed gloss, progress advances
	// them in lockstep, one flower per term. `sense` is the classic one-card-per-sense behaviour.
	// Term mode is a thin composition layer at card build; the sense-grained code below stays put.
	function isTermUnitMode() { return window.study_unit !== 'sense'; }   // default (unset/'term') = term
	window.isTermUnitMode = isTermUnitMode;   // learning_session.js + training_session.js read it too

	// The composed SESSION gloss for a term: senses in display order, the MAIN (first) sense
	// contributing its top 1–2 translations and every remaining sense its top 1 — one string used as
	// the drill cue and every MC-rung meaning ("abholen — to pick up, to collect, to meet with
	// someone"). No cap (very polysemous words get a long tail; accepted). Tray/dictionary rows keep
	// the full per-sense lean view — this composition is session-only. Dedupes repeats so a shared
	// translation isn't printed twice — comparing with trailing punctuation stripped ("und": the
	// conjunction's "and" + the interjection's "and?" must not compose to "and, and?"); a sense
	// whose top pick collides falls through to its next translation ("and, so what?").
	// The longest a composed term gloss may run — the SAME budget, for the same reason, as
	// LearningTextSupport.GLOSS_BUDGET on the Java side. ⛔ These two are twins
	// ([[note-reducibility-two-engines]]): `canonicalGloss` builds this one line for the Learn
	// ladder and this function builds it for the term-mode drill cue and the MC rungs, and
	// termCardsOf above says so in as many words ("the same one line the Learn rungs use").
	//
	// ⚠️ THE BUDGET WAS ADDED TO ONE TWIN ONLY, and the gap was invisible for exactly as long as
	// every pair was a translation pair. There an item is a WORD, so 2+1+1 items is a short line
	// either way. On the monolingual EN→EN pair an item is a whole defining phrase: measured on a
	// real Practice card 2026-08-28, "new" cued with a 218-character run-on — three definitions
	// joined by commas, read as one sentence, and unanswerable as a card face. Counting items
	// cannot tell a word from a sentence; length can, and it needs to know nothing about the pair.
	var GLOSS_BUDGET = 80;

	function composedGloss(cluster) {
		var senses = [];
		var defs = (cluster && cluster.definitionList) || [];
		for (var i = 0; i < defs.length; i++) {
			var groups = defs[i].senseGroups || [];
			for (var j = 0; j < groups.length; j++) { senses.push(groups[j]); }
		}
		var out = [], seen = {}, length = 0;
		for (var s = 0; s < senses.length; s++) {
			var trans = senses[s].translations || [];
			var take = (s === 0) ? Math.min(2, trans.length) : Math.min(1, trans.length);
			var took = 0;
			for (var t = 0; t < trans.length && took < take; t++) {
				var key = (trans[t] || "").toLowerCase().replace(/[\s?!.…]+$/, "");
				if (!key || seen[key]) { continue; }
				// ⛔ The FIRST item is always kept whole, however long. It is the word's primary
				// meaning; dropping it would leave the card with no cue at all, and cutting it in
				// half would teach something wrong. The budget drops whole EXTRA items only — it
				// never truncates one, which is the same rule canonicalGloss states.
				var grown = out.length === 0 ? trans[t].length : length + 2 + trans[t].length;
				if (out.length && grown > GLOSS_BUDGET) { return out.join(", "); }
				seen[key] = true; out.push(trans[t]); took++; length = grown;
			}
		}
		return out.join(", ");
	}

	// ── Tray cards (the tray/drill unit) ─────────────────────────────────────────
	// SENSE mode: one card per sense (the sense is the learnable unit, the term organizes). TERM mode:
	// one card per WORD carrying ALL its sense ids (for lockstep events + persistence) + the composed
	// gloss, its senseId set to the MAIN sense so plumbing that needs one id still works. Every card
	// keeps the whole term DTO for the left column (headword, IPA, sound, add-to-list are term-scoped)
	// and a ref back to the source cluster (the drill + rich-view read it).

	// One tray card per sense of the cluster, in display order. A cluster with no senseGroups
	// (legacy pair data without rich senses) stays ONE term-grained card (senseId null): usable
	// for this session, but server persistence skips it — it doesn't survive a refresh (accepted).
	function senseCardsOf(cluster) {
		if (isTermUnitMode()) { return termCardsOf(cluster); }
		var cards = [];
		var defs = (cluster && cluster.definitionList) || [];
		for (var i = 0; i < defs.length; i++) {
			var groups = defs[i].senseGroups || [];
			for (var j = 0; j < groups.length; j++) {
				cards.push({
					term: cluster.term,
					senseId: groups[j].senseId,
					pos: groups[j].pos,
					translations: groups[j].translations,
					// One-line sense disambiguator — shown as a secondary line for polysemous
					// terms only (buildEntryElement gates on termSenseCount); often null.
					gloss: groups[j].gloss || null,
					// Heteronym pronunciation variant (0038); null = the term default.
					// Resolution rule: sense IPA = ipa || term.transcription.
					ipa: groups[j].ipa || null,
					ipaVariantId: groups[j].ipaVariantId || null,
					cluster: cluster
				});
			}
		}
		if (!cards.length && cluster) {
			cards.push({ term: cluster.term, senseId: null, pos: null, translations: null,
				gloss: null, ipa: null, ipaVariantId: null, cluster: cluster });
		}
		return cards;
	}
	window.senseCardsOf = senseCardsOf;   // learning_session.js expands its adds through the same rule

	// One TERM card for the whole cluster (term mode): the def cell renders the cluster's full lean
	// view (buildEntryElement routes a termCard to the term-grained branch), senseId = the main
	// sense (representative — badge/known/drill-skip stay sense-keyed and lockstep make main stand
	// for the term), senseIds = every sense (persistence + per-sense lockstep events). A legacy
	// sense-less cluster becomes a term card with no senses (session-only, never persisted), exactly
	// like the sense-mode fallback above.
	function termCardsOf(cluster) {
		if (!cluster) { return []; }
		var senseIds = [], mainSenseId = null, mainPos = null;
		var defs = cluster.definitionList || [];
		for (var i = 0; i < defs.length; i++) {
			var groups = defs[i].senseGroups || [];
			for (var j = 0; j < groups.length; j++) {
				if (groups[j].senseId == null) { continue; }
				senseIds.push(groups[j].senseId);
				if (mainSenseId == null) { mainSenseId = groups[j].senseId; mainPos = groups[j].pos; }
			}
		}
		return [{
			term: cluster.term,
			termCard: true,               // render as the full lean view; ×/✓/stats act on the whole term
			senseId: mainSenseId,         // representative main sense (null only for a legacy card)
			senseIds: senseIds,           // all senses — saved together, events posted to each (lockstep)
			pos: mainPos,
			translations: null,           // rendering uses the cluster's per-sense lean view, not this
			gloss: composedGloss(cluster),// the session gloss (drill cue + MC rungs)
			ipa: null,                    // left cell keeps the term default transcription/sound
			ipaVariantId: null,
			// The full term data, so buildEntryElement's term-grained branch renders every sense block.
			definitionList: cluster.definitionList,
			cluster: cluster
		}];
	}

	// 1-to-1 combined tray view (learn.ui.combined-tray-view → the combined_tray_view global):
	// when on, the Learn/Practice trays render ONE row per word with its staged senses stacked
	// in the def cell (each block keeps its own ×/✓/badge). Display-only — the tray list stays
	// flat sense cards, so drilling, counts and persistence are untouched. Dictionary rows are
	// term-grained clusters (no senseId) and never group anyway; the tab gate just states intent.
	function isCombinedTrayView() {
		// Moot in term mode — a term card already IS one row per word (the sense-block stacking is a
		// sense-mode presentation of adjacent sense cards, which term mode never produces).
		return !isTermUnitMode() && !!window.combined_tray_view && (activeTab === 'learn' || activeTab === 'practice');
	}

	// Cards for a freshly loaded practice set, hiding this session's ×-removed senses. A word whose
	// senses are ALL removed can't be here — fully removing a word drops its term id from the set.
	// A pending Learn-handoff filter (see pendingHandoffSenses) is consumed here: the word's
	// not-handed senses are marked soft-deleted instead of shown.
	function expandPracticeClusters(clusters) {
		var cards = [];
		// Term mode: one whole-term card per cluster, no per-sense hide/handoff filtering (×/✓ act on
		// the whole term; a graduated term hands all its senses over, so nothing is filtered out here).
		if (isTermUnitMode()) {
			for (var c = 0; c < (clusters || []).length; c++) {
				var termCards = senseCardsOf(clusters[c]);
				for (var d = 0; d < termCards.length; d++) { cards.push(termCards[d]); }
			}
			return cards;
		}
		for (var i = 0; i < (clusters || []).length; i++) {
			var expanded = senseCardsOf(clusters[i]);
			var termId = clusters[i] && clusters[i].term && clusters[i].term.id;
			var wanted = termId != null ? pendingHandoffSenses[termId] : null;
			for (var j = 0; j < expanded.length; j++) {
				var card = expanded[j];
				if (card.senseId != null && wanted && !wanted[card.senseId]) {
					practiceDeletedSenseIds[card.senseId] = termId;
					continue;
				}
				if (card.senseId != null && practiceDeletedSenseIds[card.senseId]) { continue; }
				cards.push(card);
			}
			if (wanted) { delete pendingHandoffSenses[termId]; }
		}
		return cards;
	}

	// The drill's card list: a practice list already IS sense cards and passes through; a plain
	// cluster that sneaks in (defensive — practice lists are expanded on load) drills as its
	// senses, one card each. Banned-as-known senses stay visible in the tray (grayed) but are
	// never dealt — filtering here covers the drill itself AND every count derived from it.
	function drillCardsFrom(list) {
		var out = [];
		for (var i = 0; i < (list || []).length; i++) {
			var entry = list[i];
			if (!entry) { continue; }
			var cards = (entry.cluster || entry.senseId != null) ? [entry] : senseCardsOf(entry);
			for (var j = 0; j < cards.length; j++) {
				if (cards[j].senseId != null && knownSenseIds[cards[j].senseId]) { continue; }
				out.push(cards[j]);
			}
		}
		return out;
	}

	// The deck a session actually runs, with each card's direction stamped on it (card.reverse —
	// the drill reads the CARD, never a session-wide flag, so Mix works). Forward: the cards
	// as-is. Reverse and Mix: one card per WORD — sibling sense cards would show the identical cue
	// and accept the identical answers (any sense's translation is right when the cue is the bare
	// word), so the first (primary) sense stands for the word. A card whose word carries no
	// meanings at all (isReversible false — nothing could be accepted as an answer) is skipped in
	// pure reverse and kept in Mix, where it drills forward.
	//
	// Mix leaves every card FORWARD here and has its real per-word split stamped by
	// assignMixDirections before the session starts — the assignment needs the server's
	// last-direction history, and this function is also the (synchronous) count path.
	function drillDeckFrom(list) {
		var cards = drillCardsFrom(list);
		var mode = practiceDirectionMode();
		if (mode === "FORWARD") { return stampDirection(cards, false); }
		var mixed = mode === "BOTH";
		var out = [], seenTerm = {};
		for (var i = 0; i < cards.length; i++) {
			var c = cards[i];
			if (!mixed && !isReversible(c)) { continue; }
			var tid = c.term && c.term.id;
			if (tid != null && seenTerm[tid]) { continue; }
			if (tid != null) { seenTerm[tid] = true; }
			out.push(c);
		}
		return stampDirection(out, !mixed);
	}

	// Cards are shared with the tray, so the flag is (re)written on EVERY deck build — a card can
	// never carry a direction left over from a previous session's mode.
	function stampDirection(cards, reverse) {
		for (var i = 0; i < cards.length; i++) { cards[i].reverse = reverse; }
		return cards;
	}

	// Stamp each conjugated card with the tense it drills AND with its head verb's senses, so
	// Practice can name the slot and say what it means. Practice has no meet screen: a paradigm cell
	// arrives with its meaning and nothing else, and in a pair whose prompt language collapses the
	// distinction — DE→RU glosses both "ich sprach" and "ich habe gesprochen" as «я говорил» — that
	// is a question with two right answers. See docs/project/verb-card-types.md, "The tense line".
	//
	// `headSenses` joined it on 2026-08-27: the meaning a cell arrives with was invented per cell and
	// is not shown any more, in either direction, so the head verb's own senses are what the card
	// displays forward and what it accepts in reverse (conj-card-and-answer-matching.md §3). Both
	// facts live in the head verb's paradigm/entry and in nothing the drill payload carries, which is
	// why they share this one call.
	//
	// `formHeadSenses` joined them on 2026-08-27 (step 5) for the OTHER form population: the 56,193
	// thin `word_form` rows — `drew`, `Häuser`, `größer` — whose own stored line is correct but
	// incomplete, so the head word's senses JOIN their accepted answers instead of replacing them
	// (conj-card-and-answer-matching.md §6a, ruling 1). Display is untouched, which is why it is a
	// second field and not more `headSenses`.
	//
	// ⚠️ The deck's term ids now ALL go up, where this used to filter to conjugated cards first, and
	// that is a deliberate loss of "costs nothing on an ordinary deck". A card carries its form kind
	// in `pos` (`plural`, `past`, `declined`, …) and nothing that says `word_form` — the category is
	// the term's, not the sense's, and the kind vocabulary is open, so a client-side test would be a
	// guess that silently stops widening whenever the corpus emits a new kind. The server knows the
	// category for certain; both queries self-filter on it and return nothing for an ordinary word.
	// The precedent is right next door: assignMixDirections sends the whole deck unconditionally.
	//
	// Fire-and-continue like assignMixDirections — a failed lookup drops the tense line and leaves
	// the card on its fallback cue, rather than holding up the first card.
	function stampVerbTenses(deck, meta, done) {
		var termIds = [], byId = {};
		for (var i = 0; i < deck.length; i++) {
			var tid = deck[i] && deck[i].term && deck[i].term.id;
			if (tid == null) { continue; }
			if (!byId[tid]) { byId[tid] = []; termIds.push(tid); }
			byId[tid].push(deck[i]);   // sibling sense cards of one form share its tense
		}
		if (!termIds.length) { done(); return; }
		$.ajax("api/practice/verb-tenses", {
			type: "POST",
			contentType: "application/json",
			data: JSON.stringify({ termIds: termIds, termLang: meta.langTo, defLang: meta.langFrom }),
			dataType: "json"
		}).always(function (res) {
			var tenses = (res && res.tenses) || {};
			for (var id in tenses) {
				if (!tenses.hasOwnProperty(id) || !byId[id]) { continue; }
				for (var j = 0; j < byId[id].length; j++) { byId[id][j].verbTense = tenses[id]; }
			}
			var heads = (res && res.headSenses) || {};
			for (var hid in heads) {
				if (!heads.hasOwnProperty(hid) || !byId[hid]) { continue; }
				for (var k = 0; k < byId[hid].length; k++) { byId[hid][k].headSenses = heads[hid]; }
			}
			// Kept apart from headSenses all the way to the card: this one is answers only, never a
			// cue. The two maps can never collide — a term is a conjugation cell or a thin form row,
			// not both — so the separation is about intent, not about clashing keys.
			var formHeads = (res && res.formHeadSenses) || {};
			for (var fid in formHeads) {
				if (!formHeads.hasOwnProperty(fid) || !byId[fid]) { continue; }
				for (var m = 0; m < byId[fid].length; m++) { byId[fid][m].formHeadSenses = formHeads[fid]; }
			}
			done();
		});
	}

	// Mix: ask the server which way each word was drilled last, run the flip-and-balance rule
	// (direction_mix.js) and stamp the result on the deck. Fire-and-continue — if the history call
	// fails the assignment still runs, on an empty history, which splits the deck deterministically
	// by term id rather than blocking the drill.
	function assignMixDirections(deck, done) {
		var items = [], termIds = [];
		for (var i = 0; i < deck.length; i++) {
			var tid = deck[i].term && deck[i].term.id;
			items.push({ termId: tid, reversible: isReversible(deck[i]) });
			if (tid != null) { termIds.push(tid); }
		}
		var apply = function (last) {
			var dirs = window.DirectionMix ? DirectionMix.assign(items, last || {}) : [];
			for (var j = 0; j < deck.length; j++) { deck[j].reverse = dirs[j] === "REVERSE"; }
			done();
		};
		$.ajax("api/practice/last-directions", {
			type: "POST",
			contentType: "application/json",
			data: JSON.stringify({ termIds: termIds }),
			dataType: "json",
			success: function (data) { apply(data && data.directions); },
			error: function () { apply(null); }
		});
	}

	// How many CARDS a list drills — the exercise's unit, what the "(Words for an exercise: N)"
	// label counts, matching both the in-drill countdown and the Learn CTA's card count.
	// Reverse-aware via drillDeckFrom, so the label always agrees with the in-drill counter.
	function practiceCardCount(list) {
		return drillDeckFrom(list).length;
	}

	// The count shown beside Start. Normally "Words for an exercise: N" (the drill-deck size). In
	// the 1-to-1 combined view a polysemous tray reads clearer as "N words · M meanings" — N distinct
	// words, M drillable senses — shown only when there's actually more than one meaning per word,
	// and never in reverse or Mix (there the deck is one card per word, so meanings collapse to words).
	function startCountText(list) {
		if (isCombinedTrayView() && !isWordGrainedDeck()) {
			var cards = drillCardsFrom(list);
			var words = distinctTermIds(cards).length;
			var meanings = cards.length;
			if (meanings > words) {
				return strFormat(getRes("trayCount_wordsAndMeanings"), words, meanings);
			}
		}
		return getRes("startButton_wordsInExercise") + " " + practiceCardCount(list);
	}

	// Distinct term ids of a list (cards or clusters), in first-appearance order.
	function distinctTermIds(list) {
		var ids = [], seen = {};
		for (var i = 0; i < (list || []).length; i++) {
			var t = list[i] && list[i].term;
			if (t && t.id != null && !seen[t.id]) { seen[t.id] = true; ids.push(t.id); }
		}
		return ids;
	}

	// Visible sense ids of one tray list in order; legacy senseId-null cards have nothing to persist.
	// A term card carries ALL its senses (persisted together so the tray survives a study-unit flip in
	// both directions — sense mode then shows each saved sense, term mode regroups them by word).
	function senseIdsOf(list) {
		var ids = [];
		for (var i = 0; i < (list || []).length; i++) {
			var c = list[i];
			if (!c) { continue; }
			if (c.senseIds && c.senseIds.length) {
				for (var k = 0; k < c.senseIds.length; k++) { ids.push(c.senseIds[k]); }
			} else if (c.senseId != null) {
				ids.push(c.senseId);
			}
		}
		return ids;
	}

	// ── Tray persistence (server-side) ───────────────────────────────────────────
	// Both trays used to be client-side in-memory only, so a real F5 emptied them. Each tray is now
	// persisted as an ordered list of sense ids keyed by (user, type, language pair) — a whole-list
	// save on every change (the client always knows the full tray, so this is simplest + race-free).
	// A reload rehydrates through rehydrateTrays below. Pair-scoped exactly like LRN.reset() on a
	// langTo change: reads the CURRENT langFrom/langTo, so post-langTo-change saves target the new
	// pair and never clobber the old pair's stored tray. The gate blocks writes until the initial
	// rehydrate has run (so priming from the server doesn't echo straight back).

	function trayPairScoped() {
		var langTo = langToValField.attr("data-lang-code");
		if (!langTo) { return null; }   // no learning pair yet → nothing to scope a tray to
		return { langFrom: langFromValField.attr("data-lang-code") || "", langTo: langTo };
	}

	// ONE save in flight per tray and pair. Each save is the whole tray, so a save asked for while one
	// is on the wire only has to wait, and of several that waited only the newest is worth sending.
	// Fired back to back (five quick 🌱 presses), the saves used to race on the server and arrive in
	// any order: four of five answered 500 and the stored tray kept one or two of the five words
	// (measured 2026-10-06, temp/ui-smoke/tray-save-race-probe.mjs). The server now serialises a
	// user's saves too (TrayService.saveSenses), but only this queue keeps them in ORDER.
	var traySaveQueues = {};   // "TYPE|from|to" -> { busy, next }

	function saveTraySenses(trayType, senseIds, deletedSenseIds) {
		if (!trayPersistReady) { return; }
		var pair = trayPairScoped();
		if (!pair) { return; }
		var key = trayType + "|" + pair.langFrom + "|" + pair.langTo;
		var q = traySaveQueues[key] || (traySaveQueues[key] = { busy: false, next: null });
		var data = { type: trayType, langFrom: pair.langFrom, langTo: pair.langTo,
			senseIds: senseIds || [], deletedSenseIds: deletedSenseIds || [] };
		if (q.busy) { q.next = data; return; }   // supersedes any earlier waiter
		sendTraySave(q, data);
	}

	function sendTraySave(q, data) {
		q.busy = true;
		// fire-and-forget: the tray is authoritative client-side; a lost save just costs one refresh
		$.ajax("api/tray/senses/save", { type: "POST", traditional: true, data: data })
			.always(function () {
				var next = q.next;
				q.next = null;
				if (next) { sendTraySave(q, next); } else { q.busy = false; }
			});
	}

	function practiceDeletedIdList() {
		var out = [];
		for (var k in practiceDeletedSenseIds) { out.push(+k); }
		return out;
	}

	function persistPracticeTray() {
		saveTraySenses('PRACTICE', senseIdsOf(currentPracticeList()), practiceDeletedIdList());
	}

	// Called by learning_session.js (window hook) after its tray mutates — it owns the tray, main.js
	// owns the pair + the POST. Reads the cards straight off the module so callers pass nothing.
	window.persistLearnTray = function () {
		if (!window.LRN || !LRN.getTray) { return; }
		saveTraySenses('LEARN', senseIdsOf(LRN.getTray() || []),
			LRN.getDeletedSenseIds ? LRN.getDeletedSenseIds() : []);
	};

	// Both trays back to empty — the help hub's "Replay the quick start" (onboarding.js).
	// A replay restarts the tour from the blank slate a first visit sees, so leftover staged
	// words must not sit in the way of the walk it teaches. The user's WORD LISTS are NOT
	// touched: those are their library, not tour state — only the two staging trays are.
	// No history entry and no Undo peel either: this is a deliberate reset the user asked
	// for by name, not a Clear press that might have been a slip.
	window.resetTraysForReplay = function () {
		if (window.LRN && LRN.clearTray) { LRN.clearTray(); }   // wipes + saves, paints nothing
		practiceDeletedSenseIds = {};    // an emptied tray has no partial words left to remember
		pendingHandoffSenses = {};       // …and no in-flight Learn→Practice handoff to filter
		lastPracticeSetId = snapshotWordSet([], null);
		persistPracticeTray();
		// Repaint ONLY the tab we're actually on — the three tabs share #defId, so painting
		// an empty tray from off-tab would wipe the list on screen instead.
		if (activeTab === 'practice') {
			replaceNav(navStateForSet(lastPracticeSetId));
			showPracticeEmpty();
		} else if (activeTab === 'learn' && window.LRN) {
			LRN.showTray();
		}
	};

	// Rebuild one tray's card list from the server's visible cards [{senseId, termId}...]: expand the
	// fetched clusters to sense cards, then keep exactly the saved senses in saved order. Senses the
	// clusters DO carry but the server does not list were ×-removed in an earlier session — mark them
	// into deletedSink (senseId -> termId) so the next save keeps them hidden (no restore UI yet).
	function cardsFromSaved(saved, clusters, deletedSink) {
		// Term mode: one whole-term card per distinct saved term, in first-appearance order. The saved
		// per-sense subset (and any soft-deletes) are ignored — a term card always shows the whole word.
		if (isTermUnitMode()) {
			var byTerm = {};
			for (var c = 0; c < clusters.length; c++) {
				var tc = senseCardsOf(clusters[c])[0];
				if (tc && tc.term && tc.term.id != null) { byTerm[tc.term.id] = tc; }
			}
			var termCards = [], seenTerm = {};
			for (var s = 0; s < saved.length; s++) {
				var tid = saved[s] && saved[s].termId;
				if (tid != null && !seenTerm[tid] && byTerm[tid]) { seenTerm[tid] = true; termCards.push(byTerm[tid]); }
			}
			return termCards;
		}
		var byId = {}, all = [];
		for (var i = 0; i < clusters.length; i++) {
			var expanded = senseCardsOf(clusters[i]);
			for (var j = 0; j < expanded.length; j++) {
				if (expanded[j].senseId != null) { byId[expanded[j].senseId] = expanded[j]; all.push(expanded[j]); }
			}
		}
		var cards = [], visible = {};
		for (var k = 0; k < saved.length; k++) {
			var card = byId[saved[k].senseId];
			if (card) { cards.push(card); visible[saved[k].senseId] = true; }
		}
		for (var m = 0; m < all.length; m++) {
			if (!visible[all[m].senseId]) { deletedSink[all[m].senseId] = all[m].term.id; }
		}
		return cards;
	}

	function savedTermIds(saved) {
		var ids = [], seen = {};
		for (var i = 0; i < saved.length; i++) {
			var id = saved[i] && saved[i].termId;
			if (id != null && !seen[id]) { seen[id] = true; ids.push(id); }
		}
		return ids;
	}

	// Rehydrate the Learn tray from saved cards: fetch the terms' lean clusters (defLang = langFrom),
	// merge the saved senses in QUIETLY (no echo save), and repaint if the Learn tab is on screen.
	// Guarded on activeTab at callback time so a tab switch during the fetch renders the right tab.
	function primeLearnFromCards(saved) {
		if (!saved || !saved.length || !window.LRN) { return; }
		ajaxPost("wordlist-selected-defs",
			{ defLang: langFromValField.attr("data-lang-code"), termIds: savedTermIds(saved) },
			function (data) {
				var defs = (data && data.definitions) || [];
				if (!defs.length) { return; }
				var deleted = {};
				var cards = cardsFromSaved(saved, defs, deleted);
				if (!cards.length) { return; }
				LRN.absorbDeleted(deleted);
				LRN.addWords(cards, true);   // quiet: this is a load FROM the server, don't save back
				if (activeTab === 'learn') { showLearnTray(); }
			});
	}

	// Rehydrate the Practice tray from saved cards: fetch their clusters, snapshot the card list as
	// the current practice set (so a later Practice-tab visit restores it), and render now only if
	// Practice is the tab on screen. Mirrors restoreWordSet's no-loadWords render; does NOT push
	// history or persist (it's a load), and the activeTab guard is the same stale-load protection.
	function primePracticeFromCards(saved) {
		if (!saved || !saved.length) { return; }
		if (!displayManager) { displayManager = new DisplayManager(); }
		var termIds = savedTermIds(saved);
		ajaxPost("wordlist-selected-defs",
			{ defLang: langFromValField.attr("data-lang-code"), termIds: termIds },
			function (data) {
				var defs = (data && data.definitions) || [];
				if (!defs.length) { return; }
				var cards = cardsFromSaved(saved, defs, practiceDeletedSenseIds);
				if (!cards.length) { return; }
				var policy = new DisplayPolicyWordListSelectedDefs(termIds);
				var setId = snapshotWordSet(cards, policy);
				lastPracticeSetId = setId;   // the set the Practice tab restores on its next visit
				if (activeTab !== 'practice') { return; }
				disableDictScroll();
				displayManager.setDisplayPolicy(policy);
				displayManager.setDefList(cards);
				displayManager.displayAll();
				replaceNav(navStateForSet(setId));   // stamp into the current (already-practice) entry
				startButton.find("#startCountId").text(" ("
					+ startCountText(cards) + ")");
				startButton.prop("disabled", false);
			});
	}

	// Load both saved trays for the current pair. Called once at boot (AFTER the saved tab is applied,
	// so priming renders onto the right tab) and again on a langTo change (the new pair's trays). Arms
	// tray persistence for real user actions.
	function rehydrateTrays() {
		trayPersistReady = true;
		var pair = trayPairScoped();
		if (!pair) { return; }   // no pair → nothing to load (and nothing gets saved either)
		loadKnownSenses();       // the pair's ban set, fetched alongside the trays themselves
		$.ajax("api/tray/senses", {
			type: "GET",
			data: { langFrom: pair.langFrom, langTo: pair.langTo },
			dataType: "json",
			success: function (data) {
				if (!data) { return; }
				primeLearnFromCards(data.learn);
				primePracticeFromCards(data.practice);
			}
			// a failed load just leaves the trays empty — no worse than the pre-persistence behaviour
		});
	}

	// ── "I already know this" ban ────────────────────────────────────────────────
	// Per-sense, global per user (not tray membership): a banned sense grays out in both trays,
	// drills/counts skip it, the Learn ladder never offers it, and coverage counts its word as
	// known. Each tray row's corner ✓ toggle flips it (the one place a word is marked already-known —
	// the meet card no longer carries its own "already know" action; it lives one level up, on the tray).

	// Refill the client mirror for the current pair — called with every tray rehydrate.
	function loadKnownSenses() {
		var pair = trayPairScoped();
		if (!pair) { return; }
		$.ajax("api/learning/known-senses", {
			type: "GET",
			data: { langFrom: pair.langFrom, langTo: pair.langTo },
			dataType: "json",
			success: function (data) {
				knownSenseIds = {};
				var ids = (data && data.senseIds) || [];
				for (var i = 0; i < ids.length; i++) { knownSenseIds[ids[i]] = true; }
				refreshKnownRows();
				refreshCountsAfterKnownChange();
			}
			// a failed load just shows no known styling — the server still skips banned senses
		});
	}

	// Flip one sense's ban and repaint everything that depends on it. The POST is fire-and-forget
	// like the tray saves: the map is authoritative client-side, a lost write costs one refresh.
	function setSenseKnown(senseId, known) {
		if (senseId == null) { return; }
		if (known) { knownSenseIds[senseId] = true; } else { delete knownSenseIds[senseId]; }
		$.ajax("api/learning/sense-known", {
			type: "POST",
			data: { senseId: senseId, known: !!known }
		});
		refreshKnownRows();
		refreshCountsAfterKnownChange();
	}
	window.setSenseKnown = setSenseKnown;   // used by the tray row's corner ✓ toggle
	window.isKnownSense = function (senseId) { return senseId != null && !!knownSenseIds[senseId]; };

	// Ban/unban a whole term's senses together (term mode ✓): flips them all in the client mirror,
	// fires one POST each (fire-and-forget like setSenseKnown), then repaints ONCE. Lockstep — a term
	// is known iff its senses are, so coverage counts every one of its ranks the same way.
	function setSensesKnown(senseIds, known) {
		for (var i = 0; i < (senseIds || []).length; i++) {
			var sid = senseIds[i];
			if (sid == null) { continue; }
			if (known) { knownSenseIds[sid] = true; } else { delete knownSenseIds[sid]; }
			$.ajax("api/learning/sense-known", { type: "POST", data: { senseId: sid, known: !!known } });
		}
		refreshKnownRows();
		refreshCountsAfterKnownChange();
	}

	// Sync every rendered row's known styling with the map (rows are matched by data-sense-id, so
	// this is safe to call whenever — dictionary rows carry no sense id and are never touched).
	// Combined-view rows gray at BLOCK grain instead: each sense block toggles its own class.
	function refreshKnownRows() {
		$("._entryClass[data-sense-id]").each(function () {
			var row = $(this);
			row.toggleClass("_entryKnownClass", !!knownSenseIds[row.attr("data-sense-id")]);
		});
		$("._senseBlockClass[data-sense-id]").each(function () {
			var block = $(this);
			block.toggleClass("_senseBlockKnownClass", !!knownSenseIds[block.attr("data-sense-id")]);
		});
	}

	// A ban changes what the visible tray would drill — refresh whichever count is on screen.
	function refreshCountsAfterKnownChange() {
		if (activeTab === 'practice') { updateStartCount(); }
		else if (activeTab === 'learn' && window.LRN && LRN.renderCta) {
			LRN.renderCta(LRN.trayCount() > 0);
		}
	}

	// Drop a single sense card from whichever tray is showing it, via that entry's corner ×. Only
	// Practice and Learn rows carry the button (CSS-gated by #centralModeId[data-tab]), so
	// activeTab is always one of the two here. senseId is null only for a legacy term-grained card.
	function removeTrayEntry(termId, senseId) {
		if (activeTab === 'learn') {
			if (window.LRN && LRN.removeWord) { LRN.removeWord(termId, senseId); }
		} else if (activeTab === 'practice') {
			removeFromPracticeTray(termId, senseId);
		}
	}

	// Remove one sense card from the practice tray in place — the full card set is already on
	// screen, so this needs no server round trip. Mirrors restoreWordSet's render (setDisplayPolicy
	// + setDefList + displayAll, no loadWords fetch) and gives the change its own history entry —
	// same as addWordsToPractice — so Back undoes a removal exactly like it undoes an add. The
	// removed sense is remembered (soft-deleted server-side), so refetches keep it hidden until
	// its word is deliberately re-added.
	function removeFromPracticeTray(termId, senseId) {
		var list = displayManager ? displayManager.getDefList() : null;
		if (!Util.isNotEmpty(list)) { return; }
		var newList = [];
		for (var i = 0; i < list.length; i++) {
			var entry = list[i];
			var t = entry && entry.term;
			if (t && t.id === termId && (senseId == null ? entry.senseId == null : entry.senseId === senseId)) {
				// Term mode drops the whole word (no partial removal) — don't soft-delete the main sense,
				// or a later study-unit flip would hide it from an otherwise whole term.
				if (entry.senseId != null && !isTermUnitMode()) { practiceDeletedSenseIds[entry.senseId] = t.id; }
				continue;
			}
			newList.push(entry);
		}
		if (newList.length === list.length) { return; }   // the card wasn't in the tray — nothing to do
		pushLeanEntry('practice');
		if (!newList.length) {
			commitPracticeSet([], null);
			showPracticeEmpty();
			return;
		}
		var policy = new DisplayPolicyWordListSelectedDefs(distinctTermIds(newList));
		displayManager.setDisplayPolicy(policy);
		displayManager.setDefList(newList);
		displayManager.displayAll();
		commitPracticeSet(newList, policy);
		startButton.find("#startCountId").text(" ("
			+ startCountText(newList) + ")");
		startButton.prop("disabled", false);
	}

	// Park a word straight from a pre-exercise tray — the Learn tray or the Practice start list,
	// the ONLY places the park control lives (difficult-words redesign D10). On success the word's
	// cards leave the tray too: "set this aside" and "drill it right now" cannot both be true.
	// A word the engine has never seen cannot be parked — there is no schedule to exclude it from —
	// so the honest answer is a message; the card's own × already covers "not now".
	function parkFromTray(termId) {
		ajaxPost("api/garden/park", { termId: termId, parked: true }, function (data) {
			if (!data || !data.applied) {
				showMessage(getRes("trayParkNotStarted_message"));
				return;
			}
			removeTermFromTrays(termId);
			window.refreshGardenList();   // the word moves to the garden's Set aside band
		}, getRes("wlRowParkFailed_error_message"));
	}

	// Drop EVERY card of one word from the active tray — a park is term-scoped, and a word whose
	// other senses stayed staged would be half set aside.
	function removeTermFromTrays(termId) {
		if (activeTab === 'learn') {
			if (!window.LRN || !LRN.getTray) { return; }
			var senseIds = [];
			var cards = LRN.getTray();
			for (var i = 0; i < cards.length; i++) {
				if (cards[i] && cards[i].term && cards[i].term.id === termId) {
					senseIds.push(cards[i].senseId);
				}
			}
			for (var j = 0; j < senseIds.length; j++) { LRN.removeWord(termId, senseIds[j]); }
		} else if (activeTab === 'practice') {
			removeTermFromPracticeTray(termId);
		}
	}

	// removeFromPracticeTray's term-scoped twin, for a park. Deliberately NO soft-delete of the
	// senses: parking is server-side state, and when the word is woken and re-added it must come
	// back whole — remembering its senses as ×-removed would bring back a gap-toothed word.
	function removeTermFromPracticeTray(termId) {
		var list = displayManager ? displayManager.getDefList() : null;
		if (!Util.isNotEmpty(list)) { return; }
		var newList = [];
		for (var i = 0; i < list.length; i++) {
			var t = list[i] && list[i].term;
			if (t && t.id === termId) { continue; }
			newList.push(list[i]);
		}
		if (newList.length === list.length) { return; }   // the word wasn't in the tray — nothing to do
		pushLeanEntry('practice');
		if (!newList.length) {
			commitPracticeSet([], null);
			showPracticeEmpty();
			return;
		}
		var policy = new DisplayPolicyWordListSelectedDefs(distinctTermIds(newList));
		displayManager.setDisplayPolicy(policy);
		displayManager.setDefList(newList);
		displayManager.displayAll();
		commitPracticeSet(newList, policy);
		startButton.find("#startCountId").text(" ("
			+ startCountText(newList) + ")");
		startButton.prop("disabled", false);
	}

	// The sticky count behind the "Random ▸ custom…" menu item (the wordNum user attr, rendered
	// into a hidden input server-side and updated in place when the user changes it).
	function wlRandomCount() {
		var n = parseInt($("#wlRandomCountId").val(), 10);
		return (n >= 1) ? n : 8;
	}

	// Mode tabs: Dictionary is the default landing (co-equal front door); Learn + Practice on demand.
	$("#tabDictId").click(dictionaryTabView);
	$("#tabLearnId").click(learnTabView);
	$("#tabPracticeId").click(practiceTabView);
	// Initial landing: apply Dictionary chrome + content WITHOUT a history push — the base lean
	// entry ({view:'lean', tab:'dict'}) is established by the replaceState IIFE at the bottom.
	applyDictChrome();
	showDictLean();

	// (Phase 2 removed a document.fonts.ready re-fit here: the old JS height calc had to be
	//  re-run after web fonts changed the chrome height; the CSS flex box now re-flows on its own.)

	// --- Practice word-set history: Undo toast + browser Back/Forward ----------------
	// Every set shown in Practice — a "Random Words" generation OR a word-list selection pulled into
	// the main panel — becomes a navigable history entry { view:'lean', tab:'practice', setId }.
	// (Clicking "Random Words" used to pop a confirm() ("get a new set?"). Instead the set now
	// regenerates immediately.) Browser Back/Forward and the "Undo" toast all ride this one stack:
	// Back/Undo => previous view, Forward => the new set.
	// Snapshots are in-memory only (capped, lost on reload — like the legacy defList
	// cache the popstate handler already relied on). Each snapshot carries its origin
	// (+ termIds for a word-list set) so restoring also reinstates the right display
	// policy — a Start click after a restore must attribute the session to the set's
	// real origin, and an evicted word-list set can be re-fetched instead of replaced
	// by random words.
	// Cap on how many generated random sets we keep the full word data for, so endlessly clicking
	// "Random Words" can't grow memory without bound. 20 is far more than any good-faith session
	// needs (a couple of sets), and at a few tens of KB each it is well under a megabyte. Oldest set
	// by creation order is dropped first (see snapshotWordSet); Backing onto an evicted set gives a
	// fresh set rather than stale data (see restoreWordSet). Storing only term ids to make this
	// effectively unbounded was considered and rejected — a full client/server round-trip workflow
	// to solve a non-problem (see the nav design discussion).
	var MAX_WORD_SET_SNAPSHOTS = 20;
	var wordSetSnapshots = {};      // setId -> { list: defList array, origin, termIds }
	var wordSetSnapshotOrder = [];  // insertion order, for eviction
	var nextWordSetId = 0;

	// While the Undo "peel" is on screen the Clear button is locked: clicking it (anywhere —
	// including a near-miss on the "undo" link) must NOT re-clear. peelActive guards the
	// handler; dismissPeel is the live peel's teardown so popstate (Undo == history.back) can
	// clear it too.
	var peelActive = false;
	var dismissPeel = null;

	function snapshotWordSet(list, policy) {
		var setId = nextWordSetId++;
		wordSetSnapshots[setId] = {
			list: list,
			origin: (policy && policy.origin) || 'RANDOM',
			termIds: (policy && policy.termIds) || null,
			level: (policy && policy.level) || null,
			number: (policy && policy.number) || null
		};
		wordSetSnapshotOrder.push(setId);
		while (wordSetSnapshotOrder.length > MAX_WORD_SET_SNAPSHOTS) {
			delete wordSetSnapshots[wordSetSnapshotOrder.shift()];
		}
		return setId;
	}

	// The history state for a snapshotted set. A word-list set additionally carries its termIds IN
	// the entry itself, so Back/Forward onto it can re-fetch the exact same words even after the
	// snapshot was evicted or the page reloaded; a level-random set carries its level+count and
	// regenerates an equivalent set (see restoreWordSet).
	function navStateForSet(setId) {
		var s = { view: 'lean', tab: 'practice', setId: setId };
		var snap = wordSetSnapshots[setId];
		if (snap && snap.termIds) { s.termIds = snap.termIds; }
		if (snap && snap.level) { s.level = snap.level; s.number = snap.number; }
		return s;
	}

	// Re-render a snapshotted set (Practice tab return / popstate replay). navState is the history
	// entry being restored (popstate only) — its termIds / level+count are the eviction fallback.
	function restoreWordSet(setId, navState) {
		disableDictScroll();   // a restored practice set is not a scrollable dictionary view
		var snap = wordSetSnapshots[setId];
		if (!snap) {
			// This set aged out of the capped snapshot cache (or the page was reloaded, wiping the
			// in-memory snapshots). Do NOT render whatever set is currently on screen as if it were
			// this one (that silently shows the wrong words). A word-list entry carries its termIds —
			// re-fetch those exact words; a level-random entry carries level+count — regenerate an
			// equivalent set; anything else is honestly an empty tray. Either load's
			// commitPracticeSet stamps the new snapshot's id into this same history entry, so a
			// later Back/Forward onto it restores cleanly.
			if (navState && navState.termIds) {
				displayManager.setDisplayPolicy(new DisplayPolicyWordListSelectedDefs(navState.termIds));
				displayManager.loadWords();
			} else if (navState && navState.level) {
				loadRandomLevelSet(navState.level, navState.number || wlRandomCount());
			} else {
				showPracticeEmpty();
			}
			return;
		}
		lastPracticeSetId = setId;   // this is now the set the user last saw (sticks for the Practice tab)
		// Reinstate the set's OWN policy, not whatever the excursion left behind: origin feeds the
		// session meta of a Start click (RANDOM vs WORD_LIST attribution).
		displayManager.setDisplayPolicy(snap.origin === 'WORD_LIST'
			? new DisplayPolicyWordListSelectedDefs(snap.termIds)
			: new DisplayPolicyFrequency(snap.level, snap.number));
		displayManager.setDefList(snap.list);
		displayManager.displayAll();
		// Back over a × removal puts the sense card visibly back — un-remember its removal, so the
		// next save and the next refetch agree with what's on screen.
		for (var i = 0; i < snap.list.length; i++) {
			if (snap.list[i] && snap.list[i].senseId != null) {
				delete practiceDeletedSenseIds[snap.list[i].senseId];
			}
		}
		var list = displayManager.getDefList();
		if (Util.isNotEmpty(list)) {
			startButton.find("#startCountId").text(" (" + startCountText(list) + ")");
			startButton.prop("disabled", false);
		} else {
			renderPracticeEmptyHint();   // e.g. Forward onto a Clear entry
		}
	}

	// Record a freshly-loaded practice set (random or word-list).
	function commitPracticeSet(list, policy) {
		// The history entry for this set was already pushed at the call site (a Practice tab click,
		// a word list's "Add to Practice" or the Clear button). Here we only stamp the snapshotted
		// set's id INTO that current entry, so Back/Forward onto it restores this exact set.
		var setId = snapshotWordSet(list, policy);
		lastPracticeSetId = setId;   // a freshly loaded set becomes the set the user last saw
		replaceNav(navStateForSet(setId));
		// The Practice tray IS the current practice set — persist it (server-side) so a refresh
		// restores it. The single choke point for a committed set: add, remove, clear (empty list),
		// random regenerate, and word-list pulls all route through here. No-op until armed / no pair.
		persistPracticeTray();
	}

	// Take over the host button's own face with an Undo affordance: "Undo" replaces the button's
	// label (whole face clickable, like the Remove pill's peel), then peels away diagonally (the
	// peel doubles as the countdown — hovering the button pauses it) to reveal the normal label
	// underneath. undo == history.back(): it pops the new entry so popstate restores the previous
	// view, and Forward re-applies it. The host needs position:relative + overflow:hidden.
	function showUndoPeel(host) {
		if (dismissPeel) { dismissPeel(); }   // tear down any peel still on screen

		var peel = $(
			"<span id='undoPeelId' aria-live='polite'>"
		+     "<span class='undoPeel'>"
		+       "<span class='undoPeel-undo' role='button' tabindex='0'></span>"
		+     "</span>"
		+     "<span class='undoPeel-crease'></span>"
		+   "</span>"
		);
		peel.find(".undoPeel-undo").text(getRes("undo_label"));
		host.append(peel);

		peelActive = true;   // lock the host button (see its click handler)

		var killTimer;
		function dismiss() {
			clearTimeout(killTimer);
			host.off(".undopeel").removeClass("peelArmed");
			peel.remove();
			peelActive = false;
			dismissPeel = null;
		}
		dismissPeel = dismiss;

		// Freeze-on-hover is pure CSS (#clearTrayId.peelArmed:hover pauses the wipe) so it
		// rides the browser's own :hover state — reliable. The cursor is still on the
		// button right after the click, so we must NOT freeze on that initial hover (the
		// peel should start moving). We "arm" only once the pointer has genuinely left;
		// from then on any hover pauses it.
		host.on("mouseleave.undopeel", function () {
			host.addClass("peelArmed");
		});

		function doUndo(e) {
			e.preventDefault();
			e.stopPropagation();   // belt-and-braces: keep it off the host button's own click
			history.back();        // popstate -> dismissPeel() tears the peel down
		}
		var undoEl = peel.find(".undoPeel-undo");
		undoEl.on("click", doUndo);
		undoEl.on("keydown", function (e) {
			if (e.which === 13 || e.which === 32) { doUndo(e); }
		});
		// Real auto-dismiss: when the peel finishes. The leak-guard below only
		// fires if animationend never does (e.g. animations disabled in the OS).
		peel.on("animationend", dismiss);
		killTimer = setTimeout(dismiss, 60000);
	}


	lookupField.focus(function () {
		searchView();
	});

//-------------------------------------------------------------------------------------------


	function DisplayPolicyWordListDefs() {
		var that = this;
		this.url = "wordlist-defs";
		this.origin = 'WORD_LIST';

		this.wordListId = null;

		this.getRequestParams = function () {
			return {
				defLang: langFromValField.attr("data-lang-code"),
				wordListId: that.wordListId
			}
		};

		this.beforeRequest = function (defList) {
			// VIEWING, not filing — this policy fetches the rows of whatever list is open.
			return that.wordListId = settings.myListPanel.getExpandedListId();
		}
	}

	function DisplayPolicyWordListSelectedDefs(termIds) {
		var that = this;
		this.url = "wordlist-selected-defs";
		this.origin = 'WORD_LIST';
		this.termIds = termIds;   // read by commitPracticeSet — snapshots/history re-fetch the same words
		this.requestType = "POST";

		this.getRequestParams = function () {
			return {
				defLang: langFromValField.attr("data-lang-code"),
				termIds: termIds
			}
		};

		this.beforeRequest = function (defList) {
			return true;
		}
	}

	// ── Dictionary rendering + endless scroll (in-memory index: seek + bidirectional scroll) ──
	// One reusable entry builder feeds three callers: a full render (displayAll), and incremental
	// append / prepend during scroll. Entries carry a per-node `data-cursor` so pruning either end
	// can re-derive the boundary cursor. Unique ids come from a monotonic counter (not array index)
	// so appended/prepended entries never collide with the initial render.
	var DICT_PAGE = 25;          // rows fetched per seek / scroll page
	var DICT_DOM_CAP = 300;      // max live entry nodes (sliding window — prune the far end)
	var DICT_SCROLL_PX = 300;    // fetch when within this many px of an edge
	var dictEntryUid = 0;
	// `url` + `baseParams` make the scroll generic over WHICH tape is loaded: the forward dictionary
	// (alphabetical German terms) and the reverse tape (§9 — ordered English keys) return the same
	// page shape, so whichever seek filled the view also says where to ask for more of it.
	// (The forward pair lives on the root-mapped LegacyApiController; the reverse pair sits with its
	//  Enter sibling under /api/dictionary — hence the different prefixes.)
	var DICT_SCROLL_URL = 'dictionary/scroll';
	var REVERSE_SCROLL_URL = 'api/dictionary/reverse/scroll';
	var dictScroll = {
		active: false, loadingUp: false, loadingDown: false,
		cursorTop: null, cursorBottom: null, atStart: true, atEnd: true,
		generation: 0, pattern: '',
		url: DICT_SCROLL_URL, baseParams: null, tapeAnchor: null
	};

	function dictContainer() { return defBoxScrollBar[0]; }

	function dictRequestParams(extra) {
		var p = {
			termLang: langToValField.attr("data-lang-code"),
			defLang: langFromValField.attr("data-lang-code")
		};
		if (extra) { for (var k in extra) { p[k] = extra[k]; } }
		return p;
	}

	// Arm endless scroll from a fresh seek response. Bumps the generation so any scroll request
	// still in flight from a previous pattern is ignored when it returns. `source` (omitted = the
	// forward dictionary) names the tape this view came from: its scroll URL, the params that
	// identify it, and — on the reverse tape — the anchor key, which is how a repeat seek recognises
	// that the window has not moved.
	function setupDictScroll(data, pattern, source) {
		dictScroll.active = true;
		dictScroll.generation++;
		dictScroll.loadingUp = dictScroll.loadingDown = false;
		dictScroll.cursorTop = data.cursorTop;
		dictScroll.cursorBottom = data.cursorBottom;
		dictScroll.atStart = !!data.atStart;
		dictScroll.atEnd = !!data.atEnd;
		dictScroll.pattern = pattern || '';
		dictScroll.url = (source && source.url) || DICT_SCROLL_URL;
		dictScroll.baseParams = (source && source.params) || null;
		dictScroll.tapeAnchor = (source && source.anchor) || null;
	}

	// Leave dictionary mode (random / word-list views): scroll no longer fetches more.
	function disableDictScroll() {
		dictScroll.active = false;
		dictScroll.generation++;
		dictScroll.tapeAnchor = null;   // nothing is positioned any more, so nothing can be "unmoved"
	}

	function onDictScroll() {
		if (!dictScroll.active) { return; }
		if (Date.now() - lastProgScrollAt < 200) { return; }   // ignore our own centring / top-pin scrolls
		// A card's scroll position is set once (centred while loading, then pinned to the top on
		// render) — one-shot. Scroll keeps loading in both directions regardless, and the card scrolls
		// out of view like any other row as the user browses on. If it's later pruned off the far end,
		// dictPruneTop/Bottom reset the rich state back to plain browsing (see detachOffscreenRichCard).
		var el = dictContainer();
		if (!el) { return; }
		if (!dictScroll.atEnd && !dictScroll.loadingDown &&
				el.scrollTop + el.clientHeight >= el.scrollHeight - DICT_SCROLL_PX) {
			dictLoadMore('down');
		}
		if (!dictScroll.atStart && !dictScroll.loadingUp && el.scrollTop <= DICT_SCROLL_PX) {
			dictLoadMore('up');
		}
	}

	function dictLoadMore(direction) {
		var up = direction === 'up';
		var cursor = up ? dictScroll.cursorTop : dictScroll.cursorBottom;
		if (!cursor) { return; }
		if (up) { dictScroll.loadingUp = true; } else { dictScroll.loadingDown = true; }
		var gen = dictScroll.generation;
		var more = { cursor: cursor, direction: direction, limit: DICT_PAGE };
		ajaxPost(dictScroll.url,
			dictScroll.baseParams ? $.extend({}, dictScroll.baseParams, more) : dictRequestParams(more),
			function (data) {
				if (gen !== dictScroll.generation) { return; }   // a newer seek superseded this
				if (up) { dictScroll.loadingUp = false; } else { dictScroll.loadingDown = false; }
				var list = (data && data.definitions) || [];
				if (list.length > 0) {
					if (up) { dictPrepend(list); dictScroll.cursorTop = data.cursorTop; }
					else    { dictAppend(list);  dictScroll.cursorBottom = data.cursorBottom; }
				}
				if (up) { dictScroll.atStart = (data && data.atStart) || list.length === 0; }
				else    { dictScroll.atEnd   = (data && data.atEnd)   || list.length === 0; }
			},
			"Server exception");
	}

	// One row of whichever tape is loaded. A reverse-tape cluster carries the English key it answers
	// (`matchWord`); bolding it here — rather than at each call site — is what lets scroll append and
	// prepend tape rows through the same path as dictionary rows.
	function dictRow(cluster, pattern) {
		var isReverseRow = !!(cluster && cluster.matchWord);
		// A reverse row's headword is German — `pattern` is the typed ENGLISH text, so it must not
		// reach buildEntryElement's own (DE) prefix-highlight; the translation gets it instead, below.
		var row = buildEntryElement(cluster, dictEntryUid++, isReverseRow ? '' : pattern);
		if (isReverseRow) {
			row.attr("data-match", cluster.matchWord);   // which key this row answers (smoke + debugging)
			highlightReverseMatch(row, cluster.matchWord, pattern);
		}
		return row;
	}

	function dictAppend(list) {
		var defArea = $("#defId");
		for (var i = 0; i < list.length; i++) {
			defArea.append(dictRow(list[i], dictScroll.pattern));
		}
		if (displayManager) { displayManager.setDefList((displayManager.getDefList() || []).concat(list)); }
		phraseBandReposition();   // endless scroll must not thread new rows through the band
		dictPruneTop();
		updateStartCount();
	}

	function dictPrepend(list) {
		var el = dictContainer();
		var beforeH = el ? el.scrollHeight : 0;
		var defArea = $("#defId");
		for (var i = list.length - 1; i >= 0; i--) {  // reverse so final order is ascending
			defArea.prepend(dictRow(list[i], dictScroll.pattern));
		}
		if (el) { el.scrollTop += (el.scrollHeight - beforeH); }   // keep the viewport visually stable
		if (displayManager) { displayManager.setDefList(list.concat(displayManager.getDefList() || [])); }
		phraseBandReposition();   // endless scroll must not thread new rows through the band
		dictPruneBottom();
		updateStartCount();
	}

	// The rich card adds one extra DOM node (its `._richExpandClass` slot) beyond the entries in
	// displayManager's defList, and — when opened in place — hides rather than removes the lean row
	// behind it. If pruning drops either of those nodes, the card has scrolled out of the loaded
	// window: reset the rich state to plain browsing and drop whichever half is still attached, so
	// nothing is left orphaned. Returns how many extra `._entryClass` rows it removed, so callers can
	// keep their defList slice counts correct (the slot itself is never in defList).
	function detachOffscreenRichCard() {
		stopRichLoadingBar();
		stopEnrichPoll();  // …and a still-ENRICHING word scrolled off stops being asked about
		richLookupSeq++;   // a still-loading word scrolled off — stale its fetch so it can't re-attach
		loadingStrip = null;   // it lives inside expandedEntry; removed with the row just below
		var extraEntries = 0;
		if (expandedSlot && expandedSlot[0] && expandedSlot[0].parentNode) { expandedSlot.remove(); }
		if (expandedEntry && expandedEntry[0] && expandedEntry[0].parentNode) {
			extraEntries = 1;
			expandedEntry.remove();
		}
		richOpen = false;
		currentWord = null;
		expandedEntry = null;
		expandedSlot = null;
		return extraEntries;
	}

	function dictPruneTop() {
		var defArea = document.getElementById("defId");
		if (!defArea) { return; }
		var over = defArea.children.length - DICT_DOM_CAP;
		if (over <= 0) { return; }
		var el = dictContainer();
		var beforeH = el ? el.scrollHeight : 0;
		var droppedCard = false, removedEntries = 0;
		for (var i = 0; i < over; i++) {
			var child = defArea.firstElementChild;
			if (!child) { break; }
			if ((expandedSlot && child === expandedSlot[0]) || (expandedEntry && child === expandedEntry[0])) { droppedCard = true; }
			if (child.classList.contains("_entryClass")) { removedEntries++; }
			defArea.removeChild(child);
		}
		if (droppedCard) { removedEntries += detachOffscreenRichCard(); }
		if (el) { el.scrollTop -= (beforeH - el.scrollHeight); }   // compensate the removed height
		var first = defArea.firstElementChild;
		if (first) { dictScroll.cursorTop = first.getAttribute("data-cursor"); dictScroll.atStart = false; }
		if (displayManager) { var l = displayManager.getDefList() || []; displayManager.setDefList(l.slice(removedEntries)); }
	}

	function dictPruneBottom() {
		var defArea = document.getElementById("defId");
		if (!defArea) { return; }
		var over = defArea.children.length - DICT_DOM_CAP;
		if (over <= 0) { return; }
		var droppedCard = false, removedEntries = 0;
		for (var i = 0; i < over; i++) {
			var child = defArea.lastElementChild;
			if (!child) { break; }
			if ((expandedSlot && child === expandedSlot[0]) || (expandedEntry && child === expandedEntry[0])) { droppedCard = true; }
			if (child.classList.contains("_entryClass")) { removedEntries++; }
			defArea.removeChild(child);
		}
		if (droppedCard) { removedEntries += detachOffscreenRichCard(); }
		var last = defArea.lastElementChild;
		if (last) { dictScroll.cursorBottom = last.getAttribute("data-cursor"); dictScroll.atEnd = false; }
		if (displayManager) { var l = displayManager.getDefList() || []; displayManager.setDefList(l.slice(0, Math.max(0, l.length - removedEntries))); }
	}

	function updateStartCount() {
		var list = displayManager ? displayManager.getDefList() : null;
		if (Util.isNotEmpty(list)) {
			startButton.find("#startCountId").text(" (" + startCountText(list) + ")");
			startButton.prop("disabled", false);
		}
	}

	// Total senses a term carries across its definitions — the polysemy signal that gates the
	// gloss line (a sense's gloss shows only for a term with >=2 senses; monosemous rows skip it
	// as noise). Reads the source cluster's senseGroups; 0 for a legacy sense-less cluster.
	function termSenseCount(cluster) {
		var n = 0;
		var defs = (cluster && cluster.definitionList) || [];
		for (var i = 0; i < defs.length; i++) { n += (defs[i].senseGroups || []).length; }
		return n;
	}

	// One sense's def-cell content, shared by every lean-row branch (dictionary, single sense card,
	// combined-view block): the POS label (its own ._posClass; "" when the pos is blank) followed by a
	// ._senseBodyClass holding the translations and — for a polysemous term (showGloss) — the gloss.
	// Lean-view redesign: the POS now sits in a fixed left column ALIGNED with the translation (CSS grid
	// on ._defClass ._posGroupClass), so there is NO <br> between them any more. `ipaChip` is a deviating
	// per-sense pronunciation (combined-view heteronyms only); null everywhere else. `topics`
	// (dictionary rows only — see the def.senseGroups branch below) floats right BELOW the
	// translation line, on the gloss's line: the row's top-right corner is where the tray's ×
	// (._entryRemoveClass, absolutely positioned over the def cell) sits, and a chip claiming the
	// same corner landed underneath it. Emitted between the two spans rather than after both so the
	// float starts on the gloss's line and the gloss text wraps around it — costing no extra row
	// height wherever a gloss exists (see topicChipsHtml).
	function senseBodyHtml(pos, translations, gloss, showGloss, ipaChip, topics) {
		var h = PosLabel.html(pos);   // abbreviated; full word in its tooltip. "" for a blank pos.
		h += "<span class='_senseBodyClass'>";
		if (ipaChip) { h += "<span class='_senseIpaClass'>/" + ipaChip + "/</span>"; }
		h += "<span class='_senseTransClass'>" + (translations || []).join(' · ') + "</span>";
		h += topicChipsHtml(topics, true, true);
		if (showGloss && gloss) { h += "<span class='_senseGlossClass'>" + escHtml(gloss) + "</span>"; }
		h += "</span>";
		return h;
	}

	// ── conjugation-cell rows: the head verb's senses, never the cell's own ──────────────────────
	//
	// The lean-row half of the head-senses rule (docs/project/conj-card-and-answer-matching.md §3,
	// extended from the drill cards to the LIST rows by the owner 2026-08-28): a paradigm cell's
	// stored translation was invented per cell and is unsound by construction, so it reaches no
	// screen — and until this change the Learn/Practice trays were a screen, teaching «я на мели»
	// in the row ten seconds before the card refused to. The row now reads like the card cue:
	// two grammar chips name the slot (tense — with the Perfekt / сложное прошедшее время pairing
	// in its data-tense tooltip — and person), and the meaning is the HEAD verb's senses, anchored
	// on the lemma, numbered, in entry order. The «спряж» pos gutter, badge, ✕ and sound stay.

	/** How many head senses the ROW shows — twinned with training_session.js's CONJ_SENSES_SHOWN. */
	var CONJ_ROW_SENSES_SHOWN = 4;

	// The ConjMetaDto riding the card's source cluster, or null when this is not a conjugation
	// cell (or its head resolved no senses — the server omits the field, and the row then keeps
	// the ordinary rendering, same fallback contract as the drill cards).
	function conjMetaOf(pos, card) {
		if (pos !== Util.VERB_FORM_POS || !card) { return null; }
		var src = card.cluster || card;
		var conj = src.conj;
		return (conj && conj.headSenses && conj.headSenses.length) ? conj : null;
	}

	// The def-cell content for a conjugation cell, in place of senseBodyHtml. No gloss line and no
	// IPA chip: a combo row never had either, and the sense line here is the head's, which carries
	// its own anchor (the lemma) instead.
	function conjSenseBodyHtml(pos, conj, termText) {
		var h = PosLabel.html(pos);
		h += "<span class='_senseBodyClass'>";
		var chips = "";
		if (conj.tense) {
			chips += "<span class='pl-chip _conjRowChipClass' data-tense='" + escHtml(conj.tense) + "'>"
				+ escHtml(Util.conjTenseLine(conj.tense)) + "</span>";
		}
		var person = Util.conjPersonLine(termText);
		if (person) {
			chips += "<span class='pl-chip _conjRowChipClass'>" + escHtml(person) + "</span>";
		}
		if (chips) { h += "<span class='_conjRowChipsClass'>" + chips + "</span>"; }
		var s = "";
		if (conj.headLemma) {
			s += "<span class='_conjRowLemmaClass'>" + escHtml(conj.headLemma) + "</span>";
		}
		var senses = conj.headSenses || [];
		var n = Math.min(senses.length, CONJ_ROW_SENSES_SHOWN);
		for (var i = 0; i < n; i++) {
			// Numbered only when there are several: they are alternatives, exactly like the card
			// cue; a lone sense with a "1." reads as a truncated list. Every sense gets its own
			// line under the lemma, including the first (owner, 2026-08-28) — num + text share one
			// block so they wrap together instead of the number stranding on the line above.
			var num = (n > 1) ? "<span class='_conjRowNumClass'>" + (i + 1) + "</span>" : "";
			s += "<span class='_conjRowSenseLineClass'>" + num
				+ "<span class='_conjRowSenseClass'>" + escHtml((senses[i] || []).join(", ")) + "</span></span>";
		}
		h += "<span class='_senseTransClass _conjRowSensesClass'>" + s + "</span>";
		h += "</span>";
		return h;
	}

	// Passive sound prefetch for any row-list surface (Dictionary rows, tray cards, Word List rows):
	// warms a row's sound once it's been sitting in view for a while, so scrolling to a word and
	// then clicking its sound icon doesn't pay the fetch. Deliberately NOT immediate on scroll-into-
	// view — an 8000-word Word List scrolled through quickly would otherwise fire a prefetch for
	// every row that flickers past. Instead: track whatever's CURRENTLY visible (current viewport +
	// one screen of lookahead via rootMargin) in a live set, and only take a prefetch pass over that
	// set once nothing has changed for PREFETCH_SETTLE_MS — i.e. scrolling has actually stopped. A
	// click on a specific word's sound icon is unaffected by any of this: PlSound.play() always
	// resolves+fetches on its own if the passive prefetch hasn't gotten to it yet.
	var soundPrefetchObserver = null;
	var soundPrefetchMeta = new WeakMap();     // row element -> {termId, variantId}
	var soundPrefetchVisible = new Map();      // row element -> {termId, variantId}, currently in view
	var soundPrefetchTimer = null;
	var SOUND_PREFETCH_SETTLE_MS = 2000;
	var SOUND_PREFETCH_CAP = 30;
	var SOUND_PREFETCH_STAGGER_MS = 60;

	function soundPrefetchObserverInstance() {
		if (!soundPrefetchObserver) {
			soundPrefetchObserver = new IntersectionObserver(function (entries) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						var meta = soundPrefetchMeta.get(entry.target);
						if (meta) { soundPrefetchVisible.set(entry.target, meta); }
					} else {
						soundPrefetchVisible.delete(entry.target);
					}
				});
				clearTimeout(soundPrefetchTimer);
				soundPrefetchTimer = setTimeout(function () {
					window.PlSound.prefetchMany(Array.from(soundPrefetchVisible.values()),
						{ cap: SOUND_PREFETCH_CAP, staggerMs: SOUND_PREFETCH_STAGGER_MS });
				}, SOUND_PREFETCH_SETTLE_MS);
			}, { rootMargin: "100% 0px" });   // current viewport + ~1 screen lookahead, either direction
		}
		return soundPrefetchObserver;
	}

	// Take the settle-pass NOW, for the rows currently in view, instead of waiting for the next
	// scroll to disturb the observer. The dialect chooser calls this: the words on screen were warmed
	// in the English the reader has just stopped learning, and warming them again in the new one is
	// what makes the next press instant rather than a wait for a first-ever generation. Bounded by
	// the same cap and stagger as the passive pass, so a switch costs at most one screenful.
	function rewarmVisibleSounds() {
		clearTimeout(soundPrefetchTimer);
		window.PlSound.prefetchMany(Array.from(soundPrefetchVisible.values()),
			{ cap: SOUND_PREFETCH_CAP, staggerMs: SOUND_PREFETCH_STAGGER_MS });
	}

	// el = a jQuery-wrapped row (or a plain element). Safe to call for every row as it's built —
	// a row with no term (shouldn't happen) is just skipped.
	function observeSoundPrefetch(el, termId, variantId) {
		if (termId == null) { return; }
		var node = el && el.jquery ? el[0] : el;
		if (!node) { return; }
		soundPrefetchMeta.set(node, { termId: termId, variantId: variantId });
		soundPrefetchObserverInstance().observe(node);
	}

	// ── One-press tray buttons (🌱 Learn / 💧 Practice) ─────────────────────────────────────────────
	// docs/project/tray-add-buttons.md. Two always-append, never-a-picker buttons beside every
	// add-to-list control, staging a single word straight into a tray with a fly-to-tab confirm.
	// The exact tab-mark glyphs (GARDEN.markIcon) — no new iconography. Order everywhere: Learn
	// then Practice, matching the tab strip.
	//
	// Shared primitives only; each surface wires its own two buttons at its own render site (same
	// idiom wlAddWire's callers already use) because what resolves the termId differs per surface —
	// fixed for a row, r.termId for the rich card, a live popup resolve, a materialize-then-stage
	// round trip for a phrase. `stopPropagation` is always the wiring caller's job (T3: the row/card
	// underneath opens on its own click otherwise).
	// `faceClass` matches each surface's OWN neighbouring buttons (lean rows: pl-btn-icon-round,
	// borderless; the popup and phrase gutter: pl-btn-icon, outlined) — the grayscale-mark rule
	// (garden.css) is layered on top of whichever face, unconditionally.
	function trayMarkButtonsHtml(faceClass) {
		return '<button type="button" class="' + faceClass + ' _trayLearnClass">'
			+ GARDEN.markIcon("sprout") + '</button>'
			+ '<button type="button" class="' + faceClass + ' _trayPracticeClass">'
			+ GARDEN.markIcon("water") + '</button>';
	}

	// Fly the transfer frame to the destination tab + the same arrival blink the WL add uses
	// (decision 5). Optimistic — fired at the click (T4), independent of whatever async add/remove
	// is in flight; PL.fly quiet-no-ops if flySrcEl is missing/detached by the time it runs.
	function flyToTrayTab(flySrcEl, toLearn) {
		if (!flySrcEl || !flySrcEl.length || !window.PL || !PL.fly) { return; }
		var dest = $(toLearn ? "#tabLearnId" : "#tabPracticeId");
		PL.fly(flySrcEl, dest, 1000);
		dest.flashClass("confirmBackground", 1000);
	}

	// Plain stage: dict rows, the rich card, a word popup — every surface but a tray row itself.
	// Dedup/restore-on-readd (decision 8) and the full-tray toast (decision 7) both ride
	// addWordsToLearning/addWordsToPractice unchanged; this only adds the fly + the live-session
	// gate (decision 9 — the same regime settings.myListPanel.setAddDisabled/.isAddDisabled toggle
	// for every other add control, checked fresh at click time).
	function trayStage(termId, toLearn, flySrcEl) {
		if (termId == null) { return; }
		if (settings.myListPanel && settings.myListPanel.isAddDisabled()) { return; }
		flyToTrayTab(flySrcEl, toLearn);
		if (toLearn) { addWordsToLearning([termId], false, true); } else { addWordsToPractice([termId], false, true); }
	}

	// A Learn/Practice TRAY row shows only the OPPOSITE tray's button (CSS data-tab gate,
	// dictionary.css) and a press there MOVES the word instead of staging it — reusing the row's
	// own remove path (removeTrayEntry, T5) so rung progress and the dedupe/restore rules a manual
	// remove-then-add would hit all still apply. Callers decide when this applies (only the lean/tray
	// row wiring does — a rich card or popup opened from inside a tray tab is still a plain stage).
	// `entryItem` (optional) is the row: a combined-view term card's row-level action must reach
	// EVERY staged sense, not just the row's single representative senseId — the same data-sense-ids
	// lockstep the corner ✓ toggle already reads off the row for the identical reason.
	function trayMove(entryItem, termId, senseId, toLearn, flySrcEl) {
		if (termId == null) { return; }
		if (settings.myListPanel && settings.myListPanel.isAddDisabled()) { return; }
		var termSenses = entryItem && entryItem.attr("data-sense-ids");
		if (termSenses) {
			var ids = termSenses.split(",").map(Number);
			for (var i = 0; i < ids.length; i++) { removeTrayEntry(termId, ids[i]); }
		} else {
			removeTrayEntry(termId, senseId);
		}
		flyToTrayTab(flySrcEl, toLearn);
		if (toLearn) { addWordsToLearning([termId], false, true); } else { addWordsToPractice([termId], false, true); }
	}

	// NO topic badges on the lean row — built 2026-08-05, looked at, and dropped, which the design
	// note pre-authorized ("build it, eyeball it, drop it without ceremony if the row crowds").
	// It crowded: the strip is a term-level rollup of the senses' tags, and the only line with room
	// for it is the second one, which already carries the plant and the IPA. Making space meant
	// letting the transcription ellipsize (/ɡəˈʁɛçtɪçk…/ on Gerechtigkeit) — real content giving way
	// to decoration — and at the size the line affords, three emoji read as artifacts rather than as
	// meaning. The rich card's per-sense chips are where a topic can say what it means, and the
	// Topics row is where you browse by one. Neither needs this.
	//
	// Build one entry as a detached jQuery element (events + tooltips wired), ready to append or
	// prepend. `uid` makes ids unique across incremental loads; `pattern` drives the highlight.
	// Takes a term-grained cluster (dictionary rows — same-POS senses merged via posGroups) OR a
	// tray sense card (senseId != null — the right cell shows that ONE sense's pos + translations).
	// senseCards (optional) = the 1-to-1 combined view: this row stands for a WORD and stacks one
	// sense block per staged card in the def cell; each block carries its own ×/✓ (delegated in
	// wireEntryEvents) + badge slot, matched by the block's data-sense-id instead of the row's.
	function buildEntryElement(defCluster, uid, pattern, senseCards) {
		var termDto = defCluster.term;
		// A tray sense card shows ITS pronunciation in the left cell (resolved: variant ||
		// term default, 0038). Dictionary rows / combined rows keep the term default there.
		var transcriptionStr = (!senseCards && defCluster.senseId != null && defCluster.ipa)
			? defCluster.ipa : termDto.transcription;
		var termDefinitions = defCluster.definitionList || [];
		var senseBlocks = (senseCards && senseCards.length) ? senseCards : null;
		// A sense's gloss (secondary line) shows only when its TERM is polysemous (>=2 senses):
		// a disambiguator for multi-meaning words, noise on monosemous ones. The source cluster
		// (carried by every tray card) holds the whole term's senses; a dictionary cluster carries
		// them too, though its term-grained posGroups branch never renders a gloss line.
		// Reverse-mode rows carry the English key they answer (`matchWord`), and the gloss there
		// disambiguates which EN sense matched — not the DE term's own polysemy — so it always shows,
		// even for an otherwise monosemous German word. A plain forward row still gates on polysemy.
		var polysemous = (defCluster.matchWord != null) || termSenseCount(defCluster.cluster || defCluster) >= 2;
		var defStr = "";

		if (senseBlocks) {
			for (var j = 0; j < senseBlocks.length; j++) {
				var sc = senseBlocks[j];
				defStr += "<div class='_posGroupClass _senseBlockClass"
					+ (knownSenseIds[sc.senseId] ? " _senseBlockKnownClass" : "")
					+ "' data-sense-id='" + sc.senseId + "'"
					+ (sc.ipaVariantId ? " data-ipa-variant-id='" + sc.ipaVariantId + "'" : "") + ">";
				// Heteronym block whose pronunciation deviates from the term default (shown in the
				// left cell): a clickable /IPA/ chip — the left cell stays the term default.
				var scChip = (sc.ipa && sc.ipa !== termDto.transcription) ? sc.ipa : null;
				var scConj = conjMetaOf(sc.pos, sc);
				defStr += scConj
					? conjSenseBodyHtml(sc.pos, scConj, termDto.term)
					: senseBodyHtml(sc.pos, sc.translations, sc.gloss, polysemous, scChip);
				// Corner cluster (grid column 3): the learning-status badge (prepended by decorateTray)
				// then × (remove), laid out horizontally on the row's first line. As an auto-width grid
				// column it reserves exactly its own width, so any badge (new / dots / ready) fits
				// without the meaning text ever running under it.
				defStr += "<span class='_cornerClass'>"
					+ "<button type='button' class='pl-btn-icon-round _senseRemoveClass'>" + plIcon("x") + "</button>"
					+ "</span>";
				defStr += "</div>";
			}
		} else if (defCluster.senseId != null && !defCluster.termCard) {
			var cardConj = conjMetaOf(defCluster.pos, defCluster);
			defStr += "<div class='_posGroupClass'>"
				+ (cardConj
					? conjSenseBodyHtml(defCluster.pos, cardConj, termDto.term)
					: senseBodyHtml(defCluster.pos, defCluster.translations, defCluster.gloss, polysemous, null))
				+ "</div>";
		} else {
			// Term-grained: a dictionary row OR (term mode) a tray term card — the whole word's lean
			// view, one block per sense. A term card ADDS the row-corner ×/✓ + badge below (term-scoped).
			for (var j = 0; j < termDefinitions.length; j++) {
				var def = termDefinitions[j];
				if (def.senseGroups && def.senseGroups.length > 0) {
					// Lean-view redesign: dictionary rows split into ONE block per sense with the sense's
					// gloss (polysemous terms only), the same sense-grained view the Learn/Practice trays
					// show — replacing the old merged posGroups line. No ×/✓ here (a dictionary row has no
					// drop/ban concept); the blocks self-space via the ._posGroupClass margin.
					for (var k = 0; k < def.senseGroups.length; k++) {
						var sg = def.senseGroups[k];
						// Term-grained view of a conjugation cell (term mode / word-list row):
						// same head-senses rule as the sense-card branches above.
						var sgConj = conjMetaOf(sg.pos, defCluster);
						defStr += "<div class='_posGroupClass'>"
							+ (sgConj
								? conjSenseBodyHtml(sg.pos, sgConj, termDto.term)
								: senseBodyHtml(sg.pos, sg.translations, sg.gloss, polysemous, null, sg.topics))
							+ "</div>";
					}
				} else if (def.posGroups && def.posGroups.length > 0) {
					// Fallback for a shape that carries only the merged projection (no per-sense rows).
					for (var k = 0; k < def.posGroups.length; k++) {
						var group = def.posGroups[k];
						defStr += "<div class='_posGroupClass'>"
							+ senseBodyHtml(group.pos, group.translations, null, false, null)
							+ "</div>";
					}
				} else {
					// Legacy sense-less definition (EN/FR pair data): POS above the definition text, as before.
					if (defStr) { defStr += "<br>"; }
					if (def.partOfSpeech) { defStr += PosLabel.html(def.partOfSpeech) + "<br>"; }
					defStr += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + def.definition;
				}
			}
		}

		var tabIndex = 201 + uid;
		// A "long term" row — verb form-sets ("graben, gräbt, grub, hat gegraben"), long conjugated
		// combos, phrases. These lift the term band out across the full row; the plant/IPA/actions
		// and the definition keep their ordinary columns below it (views/dictionary.css,
		// ._entryWideTermClass).
		// Marked by TERM LENGTH rather than by category, so a long phrase with an ordinary pos
		// qualifies without enumerating pos values. 24 chars is the LIFT-OUT threshold (owner call
		// 2026-08-07, up from 13), not a fit promise: the term column holds ~15 chars beside the
		// action icons (--pl-dict-term-col is a fixed 20rem since 2026-08-25, measured at 95.3%
		// one-line coverage of the commonest DE headwords), so a term between the two figures stays
		// an ordinary two-column row and wraps to a second line inside the term column.
		var wideTerm = (termDto.term || "").length > 24;
		var htmlFragment = ""
			+ "<div class='_entryClass" + (wideTerm ? " _entryWideTermClass" : "") + "' id=_entryId_" + uid + " tabindex=" + tabIndex + ">"
			+ "	<div class=_termClass id=_termId_" + uid + ">"
			// _termInnerClass is a size-query container (its inline size = the 30% term column) wrapping
			// the whole cell — both _entryTop (the loading-strip target) and _entryBottom (the IPA). On a
			// wide row the actions sit top-right beside the headword; on a narrow one they drop onto the
			// IPA line below (CSS grid areas flip in views/dictionary.css).
			+ "	 <div class=_termInnerClass>"
			+ "		<div class=_entryTop>"
			+ "			<span class=_termWordClass>" + highlightMatch(pattern, termDto) + articleSuffix(termDto) + "</span>"
			+ "		</div>"
			// The word-garden plant leads the SECOND line (planted/Ready words only; empty and
			// collapsed otherwise), left-aligned under the headword with the IPA following it to
			// the right. It sits here rather than beside the headword because this line has the
			// slack: the top line is the headword's, and a plant there squeezed it. Painted by
			// GARDEN.decorate after the list renders — matched by the row's term id.
			// The word's text goes with it: that is what makes this plant a click into the
			// word's statistics on every tab this row appears on (Dictionary, Learn, Practice).
			+ "		<div class=_entryBottom>"
			+ "			" + GARDEN.slot(termDto.id, "sm", termDto.term);

		// Multi-word terms (compounds, phrases, sentences) get ONE enclosing slash pair for the
		// whole transcription — "/ˈdɛŋkŋ̍ an/", never per-word "/ˈdɛŋkŋ̍/ /an/" — matching the
		// rich card's head. Single-word terms keep the per-token split: their space-separated
		// tokens are pronunciation VARIANTS (optionally "xx:"-prefixed), each its own /…/.
		var isMultiWord = termDto.term && termDto.term.indexOf(" ") !== -1;
		if (transcriptionStr && isMultiWord) {
			var wholeIpa = transcriptionStr.replace(/[\/\[\]]/g, " ").replace(/\s+/g, " ").trim();
			if (wholeIpa) {
				htmlFragment = htmlFragment
					+ "			<div class='_ipaClass' id=_ipaId_" + uid + "_0>"
					+ "				/" + wholeIpa + "/"
					+ "			</div>";
			}
		} else if (transcriptionStr) {
			var transcriptionArr = transcriptionStr.split(' ');
			for (var k = 0; k < transcriptionArr.length; k++) {
				var ipaText = transcriptionArr[k].replace(
					/^([a-z]{2}:)?(.+)$/,
					function (_, prefix, ipa) {
						// Strip any delimiters the corpus already stored ("/ˈdɛntəl/" — the EN term
						// pipeline writes them, the DE one does not) before adding our own, or the
						// entry renders as "//ˈdɛntəl//". Same normalization the rich card does.
						ipa = ipa.replace(/^[\/\[]+/, "").replace(/[\/\]]+$/, "");
						return (prefix ? "<span class='subduedClass'>" + prefix + "</span>" : "") + "/" + ipa + "/";
					});
				htmlFragment = htmlFragment
					+ "			<div class='_ipaClass' id=_ipaId_" + uid + "_" + k + ">"
					+ "				" + ipaText
					+ "			</div>";
			}
		}

		htmlFragment = htmlFragment
			+ "		</div>"   // close _entryBottom
			// Add-to-list + pronounce: a sibling of _entryBottom (not inside it) so the term-cell grid can
			// place it either top-right by the headword (wide) or on the IPA line (narrow). Wiring/tooltips
			// find these by class, so their new home doesn't change behaviour.
			// Add · Mic · Sound, the decided order on every surface (ai-features-plan.md §1
			// decision 1). No float here — this cluster is a plain flex row, so source order IS
			// reading order, the opposite of the rich head above.
			+ "			<span class=_termActionsClass>"
			+ "				<span class='_wlAddClass'><button class='pl-btn-icon-round' id=_wlAdd_" + uid + ">" + plIcon("list-plus") + "</button></span>"
			+ "				<span class=_micClass><button type='button' class='pl-btn-toggle pronMicClass pronMicSmClass' id=_mic_" + uid + " aria-pressed='false'>" + plIcon("mic") + "</button></span>"
			+ "				<span class=_soundClass><button class='pl-btn-icon-round' id=_sound_" + uid + ">" + plIcon("volume") + "</button></span>"
			+ "			</span>"
			// Underneath the Add·Mic·Sound cluster, bottom of the entry (tray-add-buttons decision 6,
			// Placement A). Markup always emitted, same as the ×/park pair below — CSS shows/hides
			// per _trayLearnClass/_trayPracticeClass and per data-tab (Placement E).
			+ "			<span class=_trayActionsClass>" + trayMarkButtonsHtml("pl-btn-icon-round") + "</span>"
			+ "	 </div>"   // close _termInnerClass
			+ "	</div>"   // close _termClass
			// The row-corner cluster on a row that has ONE ×/park pair for the whole row (anything but
			// the combined view, whose sense blocks each carry their own ._cornerClass). Empty markup;
			// decorateTray drops the learning badge into it (it prefers ._cornerClass over the bare def
			// cell) and CSS pins it to the row's top-right, centred on the park/× line. A DIRECT child
			// of the def cell — NOT inside the first sense block, where as a grid track it narrowed
			// that block alone (its topic chips sat left of every other block's) and rode the block's
			// first text line instead of the row corner. Emitted on dictionary rows too, where the same
			// data-tab gate that hides their ×/park hides this as well.
			+ "<div class=_defClass id=_defId_" + uid + ">"
			// Row-corner × (remove) + park ("set aside"), pinned to the ROW's top-right corner
			// (position:absolute against ._entryClass, which the tray tabs make relative) but emitted
			// INSIDE the def cell — where ._cornerSoloClass below already sits, and for the same reason.
			// They used to be direct children of ._entryClass, which is a fixed-layout TABLE: Chrome
			// wraps a non-cell child in an anonymous table CELL even when it is out of flow, so every
			// tray row secretly had a THIRD column. It resolved to 0 while the cells split 30%/70%, and
			// the moment the term column froze at 21rem and ._defClass became `auto` it began splitting
			// the leftover 50/50 with the definition — half the definition width, on the two tray tabs
			// only (the tabs that show these buttons). Never make a non-cell box a child of this row.
			// Evidence: temp/ui-smoke/table-anon-cell-probe.mjs + tray-column-parity-smoke.mjs.
			//
			// The × is sense-scoped, so a combined row emits none — each of its sense blocks carries its
			// own instead (built into defStr above). (The old "known" ✓ toggle was removed from the
			// trays; the underlying known-marking code stays for now, just unexposed.) The park is
			// emitted always and shown by CSS on the two pre-exercise trays only (same data-tab gate as
			// the ×): since the difficult-words redesign (D10) the park control lives NOWHERE else.
			+ (senseBlocks ? "" : "<button type='button' class='pl-btn-icon-round _entryRemoveClass' id=_entryRemove_" + uid + ">" + plIcon("x") + "</button>")
			+ "<button type='button' class='pl-btn-icon-round _trayParkClass' id=_trayPark_" + uid + ">" + plIcon("moon") + "</button>"
			+ (senseBlocks ? "" : "<span class='_cornerClass _cornerSoloClass'></span>")
			+ defStr
			+ "</div>"
			+ "</div>";

		var entryItem = $(htmlFragment);
		entryItem.attr("data-term", termDto.term);   // for findListRow (inline rich expansion)
		if (termDto.id != null) { entryItem.attr("data-term-id", termDto.id); }   // sibling cards share it
		// A combined row spans several senses — its blocks carry data-sense-id, not the row.
		if (!senseBlocks && defCluster.senseId != null) { entryItem.attr("data-sense-id", defCluster.senseId); }   // Learn badges match by it
		// A term card's ✓ bans EVERY sense of the word (lockstep), so it carries the full list; its
		// data-sense-id (above) is the main sense — the representative the badge/known styling match by.
		if (defCluster.termCard && defCluster.senseIds && defCluster.senseIds.length) {
			entryItem.attr("data-sense-ids", defCluster.senseIds.join(","));
		}
		if (defCluster.cursor) { entryItem.attr("data-cursor", defCluster.cursor); }
		entryItem.find("._trayParkClass").assignTooltip("wlRowPark_tooltip");
		// The row's "A": no tooltip at all — it raises the list picker, and a row in that picker is
		// what files the word (wlAddWire). Wired here, per row, because the rows are replaced on
		// every window step — and `termId` is only in scope on this side of wireEntryEvents.
		wlAddWire(entryItem.find("._wlAddClass > button"), {
			add: function (listId) {
				addTermToWordList(termDto.id, entryItem.find("._termWordClass"), listId);
			}
		});
		entryItem.find("._soundClass > button").assignTooltip("sound_tooltip");
		// The row's practice microphone. Wired here rather than delegated because the reference it
		// opens on is this row's term, which only exists in this scope — the same reason the add
		// control is wired per row.
		if (termDto.id != null) {
			entryItem.find("._micClass > button")
				.assignTooltip("pronMic_tooltip")
				.on("click", function (e) {
					e.stopPropagation();
					PRONOUNCE.open(this, {
						termId: termDto.id, text: termDto.term, article: termDto.article,
						ipa: popupIpa(termDto.term, transcriptionStr),
						ipaVariantId: defCluster.ipaVariantId || null
					});
				});
		} else {
			entryItem.find("._micClass").remove();
		}
		entryItem.find("._ipaClass, ._senseIpaClass").assignTooltip("sound_tooltip");
		entryItem.find("._entryRemoveClass, ._senseRemoveClass").assignTooltip("trayRemove_tooltip");
		entryItem.find("._knownToggleClass, ._senseKnownToggleClass").assignTooltip("knownToggle_tooltip");
		PosLabel.wire(entryItem);   // each abbreviated pos label tips its full word
		if (!senseBlocks && defCluster.senseId != null && knownSenseIds[defCluster.senseId]) {
			entryItem.addClass("_entryKnownClass");
		}
		wireEntryEvents(entryItem, termDto.id, termDto.term, senseBlocks ? null : defCluster.senseId,
			senseBlocks ? null : defCluster.ipaVariantId);
		return entryItem;
	}

	function wireEntryEvents(entryItem, termId, term, senseId, ipaVariantId) {
		observeSoundPrefetch(entryItem, termId, ipaVariantId);
		// Clicking the headword opens its rich view in place (a headword from our own list → trusted).
		entryItem.on("click", "._termWordClass", function () { onHeadwordClick(term, entryItem, termId); });
		// Park from the tray (the control is CSS-hidden outside the two trays).
		entryItem.on("click", "._trayParkClass", function (e) { e.stopPropagation(); parkFromTray(termId); });
		// One-press tray buttons (tray-add-buttons.md decisions 5/6/E). Dict tab (and both tabs'
		// OWN row on the other tray's tab is CSS-hidden — Placement E): a plain stage. On the tray
		// tab whose row this is, only the opposite mark shows and the press MOVES the word instead —
		// the tooltip says which, dynamically, since one row template serves all three tabs.
		entryItem.find("._trayLearnClass").assignTooltip(function () {
			return getRes(activeTab === 'practice' ? "trayMoveLearn_tooltip" : "trayAddLearn_tooltip");
		}).on("click", function (e) {
			e.stopPropagation();
			var flySrc = entryItem.find("._termWordClass");
			if (activeTab === 'practice') { trayMove(entryItem, termId, senseId, true, flySrc); }
			else { trayStage(termId, true, flySrc); }
		});
		entryItem.find("._trayPracticeClass").assignTooltip(function () {
			return getRes(activeTab === 'learn' ? "trayMovePractice_tooltip" : "trayAddPractice_tooltip");
		}).on("click", function (e) {
			e.stopPropagation();
			var flySrc = entryItem.find("._termWordClass");
			if (activeTab === 'learn') { trayMove(entryItem, termId, senseId, false, flySrc); }
			else { trayStage(termId, false, flySrc); }
		});
		// A sense card's sound/IPA speak THAT sense's pronunciation (variant id null = default).
		entryItem.on("click", "._soundClass > button", function () { playAiSound(termId, ipaVariantId); });
		// The IPA transcription is a pronunciation trigger too (same as the rich card's .rich-ipa).
		entryItem.on("click", "._ipaClass", function (e) { e.stopPropagation(); playAiSound(termId, ipaVariantId); });
		// Combined-view heteronym chip: pronounce that block's variant.
		entryItem.on("click", "._senseIpaClass", function (e) {
			e.stopPropagation();
			playAiSound(termId, +$(this).closest("._senseBlockClass").attr("data-ipa-variant-id") || null);
		});
		// The corner × removes THIS sense card — Learn/Practice trays only (CSS-gated by
		// #centralModeId[data-tab]; a Dictionary row never shows it, so this is unreachable there).
		entryItem.on("click", "._entryRemoveClass", function (e) { e.stopPropagation(); removeTrayEntry(termId, senseId); });
		// The corner ✓ flips the already-known ban (same tab gate as the ×). A term card bans/unbans
		// EVERY sense of the word together (data-sense-ids); a sense card flips its one sense.
		entryItem.on("click", "._knownToggleClass", function (e) {
			e.stopPropagation();
			var termSenses = entryItem.attr("data-sense-ids");
			if (termSenses) {
				setSensesKnown(termSenses.split(",").map(Number), !knownSenseIds[senseId]);
			} else {
				setSenseKnown(senseId, !knownSenseIds[senseId]);
			}
		});
		// Combined-view sense blocks: the same two actions, sense id read from the block. Wired
		// unconditionally — a per-sense row simply has no ._senseBlockClass to match.
		entryItem.on("click", "._senseRemoveClass", function (e) {
			e.stopPropagation();
			removeTrayEntry(termId, +$(this).closest("._senseBlockClass").attr("data-sense-id"));
		});
		entryItem.on("click", "._senseKnownToggleClass", function (e) {
			e.stopPropagation();
			var sid = +$(this).closest("._senseBlockClass").attr("data-sense-id");
			setSenseKnown(sid, !knownSenseIds[sid]);
		});
		// A dictionary row's topic chips (senseBodyHtml's `topics` arg) — same click target and
		// tooltip as the rich card's (renderRichEntry). A row with no topics has none to match.
		entryItem.on("click", ".rich-topic-chip", function (e) {
			e.stopPropagation();
			openTopicWordList($(this).attr("data-topic"));
		});
		entryItem.find(".rich-topic-chip").each(function () {
			var key = $(this).attr("data-topic");
			$(this).assignTooltip(function () { return topicChipTooltipHtml(key); });
		});
		entryItem.focus(function () { entryItem.addClass("_entryClass_focus"); });
		entryItem.blur(function () { entryItem.removeClass("_entryClass_focus"); });
		entryItem.hover(function () { this.focus(); });  // so the entry div can receive key events
	}

	// Nouns that carry a gender article (DE: der/die/das) show it dictionary-style AFTER the
	// headword — "Kunde, der", not "der Kunde" — so the list doesn't alphabetize under d.
	// Display-only: search/typeahead matches the bare term, data-term stays bare too.
	function articleSuffix(termDto) {
		return termDto.article
			? "<span class='_articleClass'>, " + termDto.article + "</span>"
			: "";
	}

	// The "Nouns with article" exercise setting only makes sense for target languages whose nouns
	// are drilled with a TYPED article (see acceptedForms in training_session.js) — hidden for
	// other targets. Future article languages (NL, FR, ES, IT, PT) join the list; Slavic gender
	// (RU, PL) would be a displayed tag, never typed, so it does NOT belong here.
	// NB: the list lives INSIDE the function — this is called from Settings() at the TOP of the
	// ready block, long before this point in the file, so an outer `var` would still be undefined.
	function updateDrillArticleVisibility() {
		// ⛔ ES joins on the day its face ships and NOT before, and the two are one change: the
		// setting defaults ON (UserAttrName.drillArticle), so a language whose cards start showing
		// "el agua" while it is absent from this list ships a typing requirement the learner has no
		// switch to turn off. Spanish's face is computed per SENSE on the server
		// (FormPacks.cardFaceArticle, rule F9) rather than read off term.article, which is empty
		// for every Spanish row — see DefinitionDto.SenseGroup.article.
		var ARTICLE_LANGS = ["DE", "ES"];
		var langTo = $("#langToValId").attr("data-lang-code");
		$("#drillArticleBoxId").toggle(ARTICLE_LANGS.indexOf(langTo) >= 0);
	}

	// Can THIS card be asked in reverse? Only one thing decides it: does the word carry meanings
	// to accept as answers. Rich pairs have sense translations; a pair that was never enriched
	// falls back to its definition text (AnswerForms.translationsOf) — which every drillable pair
	// has, because the forward cue is made of exactly the same meanings. So there is deliberately
	// NO language list here: this used to be `REVERSE_LANGS = ["DE"]`, written when German was the
	// only enriched pair, and it hid the whole direction cluster from every other pair long after
	// they could drill it (the owner found EN→RU forward-only on the day after it went live).
	function isReversible(card) {
		// A principal-parts card ("go, went, gone") reverses like any other word: the forms are the
		// cue, any meaning of the head verb is the answer (formHeadSenses, stampVerbTenses). It was
		// one-directional until 2026-10-06, and pure reverse over the Verbformen list dealt nothing —
		// "0 words", then a false "no words were selected" (owner report from prod).
		return !!(window.AnswerForms
			&& AnswerForms.translationsOf(card && card.cluster).length);
	}

	// Which way Practice asks: FORWARD (meaning shown, word typed) | REVERSE (word shown, meaning
	// typed) | BOTH (Mix — a direction per WORD, design/practice-direction-controls.md §4). The
	// server resolves the starting value (the practiceDirection attr, falling back once to the
	// legacy reverseDrill checkbox); from here on this is the single source of truth and
	// plSetPracticeDirection the single writer, so the DOM checkbox and the stored attr can't fork.
	// Seeded LAZILY: Settings() calls the direction predicates from the TOP of the ready block,
	// long before execution reaches this line, and an initializer here would still be undefined
	// then (the same trap as ARTICLE_LANGS in updateDrillArticleVisibility).
	var practiceDirection = null;
	function storedPracticeDirection() {
		if (!practiceDirection) {
			practiceDirection = (typeof practice_direction !== "undefined" && practice_direction)
				|| "FORWARD";
		}
		return practiceDirection;
	}

	// The mode actually in force. Mix requires TERM study units — in sense mode, sibling sense
	// cards of one word drilling in opposite directions would corrupt the label layer (one label
	// row per word and session), so the gesture is refused rather than half-honoured (design §4).
	// Whether the WORDS can go in reverse is not decided here: it is per card (isReversible), so a
	// tray that mixes enriched and bare words drills the ones it can instead of losing the mode.
	function practiceDirectionMode() {
		// A MONOLINGUAL pair has no second direction to go in. Reverse means "cue = the word,
		// TYPE THE MEANING", and on EN→EN the meaning is a defining phrase — 'a girl or woman who
		// has the same parents as you' — which nobody can be asked to type. Mix inherits the same
		// problem for the half of the deck it reverses, so both collapse to FORWARD.
		//
		// ⚠️ This is NOT the REVERSE_LANGS mistake isReversible warns about below. That was an
		// allow-LIST of languages, and it hid reverse from pairs that could perfectly well drill
		// it. This is an identity test — cue language == answer language — which is a structural
		// property of the pair, not a judgement about a language. Per-card reversibility is
		// untouched and still decides everything else.
		if (isSameLangPair()) { return "FORWARD"; }
		var stored = storedPracticeDirection();
		if (stored === "BOTH") { return isTermUnitMode() ? "BOTH" : "FORWARD"; }
		return stored === "REVERSE" ? "REVERSE" : "FORWARD";
	}

	// Reader language == learned language. Read off the two selects rather than from a pair list
	// so it needs no config duplicated into the client, and so it follows a live pair switch.
	function isSameLangPair() {
		var from = $("#langFromValId").attr("data-lang-code");
		var to = $("#langToValId").attr("data-lang-code");
		return !!from && from === to;
	}

	// Pure reverse — every card asks the meaning. NOT true in Mix (there it is per card), which is
	// what keeps the gray-out of the German-typing settings off a mixed session's forward half.
	function isReverseDrill() {
		return practiceDirectionMode() === "REVERSE";
	}

	function isMixedDirection() {
		return practiceDirectionMode() === "BOTH";
	}

	// Both reverse and Mix drill ONE card per word (a bare-word cue can't say which meaning is
	// asked), so anything that counts meanings has to know.
	function isWordGrainedDeck() {
		return practiceDirectionMode() !== "FORWARD";
	}

	// The single writer of the direction preference: updates the in-memory mode, persists it, and
	// re-syncs everything that reads it (the control cluster, the grayed German-typing settings, the
	// Start-band count). The cluster's buttons call this; so does the console, which is how a Mix
	// session was reachable before the buttons existed.
	window.plSetPracticeDirection = function (mode) {
		if (mode !== "FORWARD" && mode !== "REVERSE" && mode !== "BOTH") { return practiceDirection; }
		practiceDirection = mode;
		ajaxPostUserAttr("practiceDirection", mode);
		updateDirectionControls();
		updateStartCount();
		return practiceDirection;
	};
	window.plPracticeDirection = function () { return practiceDirectionMode(); };

	// ── The direction cluster (design/practice-direction-controls.md §2) ────────────────────────
	// Two multi-select arrow toggles, the "mix" bracket they light up together, and the speaker
	// modifier — the Start band's own controls, replacing the two ⚙ checkboxes this used to hide
	// behind. main.js owns all of it: the preferences are the variables here, the DOM is only their
	// paint, and plSetPracticeDirection / plSetAudioCue are the single writers.

	// Cue by ear: the term's audio replaces the text cue. A MODIFIER, not a fourth direction — it
	// composes with each of the three and never changes what gets typed (🔊 + forward = classic
	// dictation, 🔊 + reverse = listening comprehension). Backed by the same defSoundOnly attr the
	// retired "Sound only" checkbox wrote, so an existing preference carries over untouched.
	// Seeded LAZILY from the server-rendered global for the same reason practiceDirection is: the
	// first paint runs from Settings() at the top of the ready block.
	var audioCue = null;
	function storedAudioCue() {
		// == null, not ===: the first paint runs before the initializer above has executed, when
		// the hoisted var is still undefined — a strict null check skips the seed exactly then,
		// painting the speaker OFF while the session-start read (later, correctly seeded) says ON.
		if (audioCue == null) {
			audioCue = !!(typeof def_sound_only !== "undefined" && def_sound_only);
		}
		return audioCue;
	}
	window.isAudioCue = function () { return storedAudioCue(); };
	window.plSetAudioCue = function (on) {
		audioCue = !!on;
		ajaxPostUserAttr("defSoundOnly", audioCue);
		updateDirectionControls();
		return audioCue;
	};

	// A direction button's face: the pair's FLAGS with the arrow pointing at what gets
	// TYPED — forward shows the meaning (langFrom) and asks for the word (langTo). Codes come from
	// the markup's data-lang-code, so this needs nothing loaded and no translation; the task
	// phrasing ("type German") lives in the tooltips, and the code text ("EN → DE") stays on the
	// button as its aria-label. A language without a flag mapping falls back to its code.
	function directionCodes(reverse) {
		var lf = langFromValField.attr("data-lang-code") || "";
		var lt = langToValField.attr("data-lang-code") || "";
		return reverse ? [lt, lf] : [lf, lt];
	}
	// The learned half of the pair is YOUR learning and wears the chosen dialect; the other half
	// is your own language, named as such. Which side that is flips with the button, so the
	// resolver's own default rule (compare against langTo) decides per code rather than per
	// position — pass no context and it comes out right on both buttons.
	function directionFace(reverse) {
		var codes = directionCodes(reverse);
		function face(code) {
			return plFlagHtml(code) || escHtml(code);
		}
		return face(codes[0]) + " → " + face(codes[1]);
	}

	// Repaint the cluster from the preference in force + the current pair. DOM-only and idempotent,
	// so it is safe to call from Settings() before the click wiring exists, from either writer, and
	// on every langTo change. The attribute it sets is what the CSS reads: data-mode lights the
	// mix bracket. (data-reverse is gone with the language gate — every pair has the pair.)
	function updateDirectionControls() {
		var mode = practiceDirectionMode();
		// On a monolingual pair the mode is forced FORWARD, so the reverse toggle and the mix
		// bracket it belongs to are controls that cannot change anything. Stated as an attribute
		// and hidden in CSS — the same shape as [data-locked="1"], which already turns this
		// cluster from a control into a readout.
		$("#practiceDirBoxId").attr("data-mode", mode)
			.attr("data-samelang", isSameLangPair() ? "1" : null);
		$("#dirForwardId").html(directionFace(false))
			.attr("aria-label", directionCodes(false).join(" → "))
			.attr("aria-pressed", mode !== "REVERSE" ? "true" : "false");
		$("#dirReverseId").html(directionFace(true))
			.attr("aria-label", directionCodes(true).join(" → "))
			.attr("aria-pressed", mode !== "FORWARD" ? "true" : "false");
		paintDirCaption();
		// storedAudioCue, NOT window.isAudioCue: this runs from Settings() at the top of the ready
		// block, and the window.* assignment below has not executed yet. (Same trap as the lazily
		// seeded direction, one level up — the export is an assignment, only declarations hoist.)
		$("#practiceAudioCueId").attr("aria-pressed", storedAudioCue() ? "true" : "false");
		updateReverseDependents();
	}

	// The caption above the pair, in both of its lives. Unlocked it is the mix bracket's teaching
	// label ("mix"). LOCKED it becomes the running session's mode SPELLED OUT — "EN → DE" /
	// "DE → EN" / "MIX" behind a padlock: mid-drill the flags are 1.25em wide and the cluster is
	// inert, and the owner could not tell a reverse session from a mixed one at a glance
	// (2026-08-01). The direction codes come from the pair, so only the mix word is translated.
	function paintDirCaption() {
		var label = $("#practiceDirMixLabelId");
		var mixWord = getRes("practiceDir_mix_label");
		if (!isDirectionLocked()) {
			label.text(mixWord);
			return;
		}
		var mode = practiceDirectionMode();
		var name = mode === "BOTH" ? mixWord : directionCodes(mode === "REVERSE").join(" → ");
		label.html("<span class=\"pl-ic pl-ic-lock\"></span>" + escHtml(name));
	}

	function isDirectionLocked() {
		return $("#practiceDirBoxId").attr("data-locked") === "1";
	}

	// Toggle one direction. Multi-select with a floor: the last pressed button cannot be turned off
	// (a deck has to ask something), and pressing the second one IS the Mix gesture. Swapping a
	// single direction therefore costs two clicks — the accepted trade for reaching Mix without a
	// third control.
	function toggleDirection(wantReverse) {
		var mode = practiceDirectionMode();
		var fwdOn = mode !== "REVERSE";
		var revOn = mode !== "FORWARD";
		var btn = $(wantReverse ? "#dirReverseId" : "#dirForwardId");
		if (wantReverse ? revOn : fwdOn) {
			// Turning this one off is fine only while the other is also on — otherwise nothing
			// would be left to drill, so the click is refused rather than obeyed.
			if (fwdOn && revOn) {
				window.plSetPracticeDirection(wantReverse ? "FORWARD" : "REVERSE");
			} else {
				denyDirectionClick(btn);
			}
			return;
		}
		if (!isTermUnitMode()) {
			// Mix needs TERM study units: sibling sense cards of one word pulling in opposite
			// directions would corrupt the label layer (design §4). With the third mode out of
			// reach the pair behaves as a plain radio choice, so one click swaps — dead-ending
			// here would make pure reverse unreachable in sense mode.
			window.plSetPracticeDirection(wantReverse ? "REVERSE" : "FORWARD");
			return;
		}
		window.plSetPracticeDirection("BOTH");
	}

	// A refused click (the last direction, or Mix where it can't apply) must not read as a dead
	// button: the face twitches instead of changing state. Re-added after a reflow so a second
	// click replays the animation rather than doing nothing visible.
	function denyDirectionClick(btn) {
		btn.removeClass("practiceDirDenyClass");
		void btn[0].offsetWidth;
		btn.addClass("practiceDirDenyClass");
		setTimeout(function () { btn.removeClass("practiceDirDenyClass"); }, 400);
	}

	// Direction and cue mode are captured ONCE, when the session starts (training_session.js), so
	// the cluster goes inert while one runs instead of lying about what is being drilled. It stays
	// visible and READABLE — mid-drill it is the only place that still says which way this session
	// is going, so the lock repaints the caption (padlock + mode name) rather than dimming the
	// whole thing into illegibility, which is what it used to do.
	function lockDirectionControls(locked) {
		$("#practiceDirBoxId").attr("data-locked", locked ? "1" : null)
			.find("button").prop("disabled", !!locked);
		paintDirCaption();   // after the attribute: the caption reads the lock off the DOM
	}

	// Called once, before Settings() paints the cluster for the first time. Tooltips are assigned
	// as FUNCTIONS so their text follows the language pair and the study unit without rebinding.
	function wireDirectionControls() {
		$("#dirForwardId")
			.click(function () { toggleDirection(false); })
			.assignTooltip(function () {
				return strFormat(getRes("practiceDir_forward_tooltip"), getFirstText(langToValField));
			});
		$("#dirReverseId")
			.click(function () { toggleDirection(true); })
			.assignTooltip(function () {
				return strFormat(getRes("practiceDir_reverse_tooltip"), getFirstText(langFromValField));
			});
		// The caption carries the locked explanation too, and it is the ONLY part of the cluster
		// that can: a :disabled button emits no mouse events, so mid-session every other tooltip
		// here is unreachable by definition.
		$("#practiceDirMixId").assignTooltip(function () {
			if (isDirectionLocked()) { return getRes("practiceDir_locked_tooltip"); }
			return getRes(isTermUnitMode() ? "practiceDir_mix_tooltip" : "practiceDir_mixOff_tooltip");
		});
		$("#practiceAudioCueId")
			.click(function () { window.plSetAudioCue(!storedAudioCue()); })
			.assignTooltip("practiceDir_audio_tooltip");
	}

	// The Verbs settings apply only where a conjugation GRID exists — all three describe the grid,
	// so they belong to the "Conjugation" list and mean nothing to the form-set one (English has a
	// verb list and none of these settings). The gate is the SERVER's own list
	// (learn.verb-forms.form-in-use-languages, inlined as form_in_use_langs), not a literal like
	// ARTICLE_LANGS above, so enabling a second language stays a config edit and cannot drift from
	// WordListService's copy of the same decision.
	function verbFormsAvailable() {
		var langs = (typeof form_in_use_langs !== "undefined" && form_in_use_langs) || [];
		return langs.indexOf($("#langToValId").attr("data-lang-code")) >= 0;
	}

	function updateVerbSettingsVisibility() {
		$(".verbSettingClass").toggle(verbFormsAvailable());
	}

	// Whether a conjugated-form card shows its pronoun as a static prefix. Same shape as
	// isDrillArticle/isReverseDrill: the stored preference only acts on a pair that has verb forms,
	// so it survives switching to a language where it means nothing.
	window.isVerbPronounPrefill = function () {
		return verbFormsAvailable() && $("#verbPronounPrefillId").is(":checked");
	};

	// user_attr.js owns persisting the checkbox; it calls back here because "only irregular verbs"
	// is read server-side, so both the Verbs badge count and its rows change under us. Reloading
	// the panel is the honest refresh — a local filter would desync from the server's predicate.
	window.onVerbListFilterToggled = function () {
		if (settings && settings.myListPanel && settings.myListPanel.refreshVerbList) {
			settings.myListPanel.refreshVerbList();
		}
	};

	// While PURE reverse is active the German-typing settings can't apply (the user types English):
	// gray them out rather than hide, so the connection stays discoverable. Deliberately keyed on
	// isReverseDrill and not "reverse is involved" — in Mix the forward half of the deck still
	// honours strict caps and the typed article, so graying them there would be a lie.
	//
	// "Self-check instead of typing" is the mirror image: it acts only on reverse cards, so it grays
	// out when the session has no reverse half at all — pure FORWARD, or a pair with no rich senses
	// to answer from. Note the asymmetry is only in WHICH predicate, not in the rule: each row is
	// live whenever the direction it belongs to is somewhere in the deck, so in Mix all four are.
	function updateReverseDependents() {
		var reverseOnly = isReverseDrill();
		$("#strictCapsBoxId, #drillArticleBoxId, #gapPhrasesBoxId")
			.toggleClass("subduedClass", reverseOnly)
			.find("input").prop("disabled", reverseOnly);
		var noReverse = practiceDirectionMode() === "FORWARD";
		$("#selfCheckPrefBoxId").toggleClass("subduedClass", noReverse)
			.find("input").prop("disabled", noReverse);
	}

	// user_attr.js owns persisting the checkbox (like its sibling settings); it calls back here
	// so the dependent-settings gray-out and the card-count label follow the toggle live.
	// A session just ended, so words may have crossed between My Garden's sections (a watered word
	// leaves "Needs watering" for "Growing"; a graduated one leaves "In progress" for "Ready") and
	// every count around them moved. Called from both session-end paths — Practice's finish screen
	// and Learn's recap — right beside GARDEN.refreshAll(), which repaints the icons but knows
	// nothing about which list a word now belongs to.
	window.refreshGardenList = function () {
		if (settings && settings.myListPanel && settings.myListPanel.refreshGardenList) {
			settings.myListPanel.refreshGardenList();
		}
	};


	function highlightMatch(pattern, termDto) {
		var termStr = termDto.term;
		if (!pattern || !termStr) { return termStr; }
		var termSearch     = termDto.termSearch;      // translit key: aerger
		var termSearchFold = termDto.termSearchFold;  // fold key:     arger
		pattern = pattern.toUpperCase();
		var termStrUpper        = termStr.toUpperCase();
		var termSearchUpper     = termSearch ? termSearch.toUpperCase() : '';
		var termSearchFoldUpper = termSearchFold ? termSearchFold.toUpperCase() : '';

		// findMatchIndex maps the matched prefix back to displayed-term characters (handles ä→ae /
		// ß→ss length shifts), so we compare against its length, not the raw key length.
		var inx = findMatchIndex(pattern, termStrUpper, termSearchUpper, termSearchFoldUpper, termDto.searchOffsets, termDto.foldOffsets);
		if (inx <= 0) {
			// No prefix match (e.g. a row scrolled past the typed block) → render plain, not greyed.
			return termStr;
		}
		if (inx >= termStr.length) {
			return "<span style='font-weight:bold; color:blue'>" + termStr + "</span>";
		}
		return "<span style='color:blue'>" + termStr.substring(0, inx) + "</span>"
			+ "<span style='color:#5d5d5d'>" + termStr.substring(inx, termStr.length) + "</span>";
	}

	/**
	 * Leading characters of the displayed term to highlight. Tries: raw term prefix, then the translit
	 * key (ae→Ärger), then the fold key (ar→Ärger; ss→ß) — the latter two offset-mapped back to term chars.
	 */
	function findMatchIndex(patternUpper, termStrUpper, termSearchUpper, termSearchFoldUpper, searchOffsets, foldOffsets) {
		if (termStrUpper.startsWith(patternUpper)) {
			return patternUpper.length;
		} else if (termSearchUpper && termSearchUpper.startsWith(patternUpper)) {
			return searchPrefixToTermIndex(patternUpper.length, searchOffsets, termStrUpper.length);
		} else if (termSearchFoldUpper && termSearchFoldUpper.startsWith(patternUpper)) {
			return searchPrefixToTermIndex(patternUpper.length, foldOffsets, termStrUpper.length);
		} else {
			return 0;
		}
	}

	// Maps a prefix length in searchable chars back to original term chars via the per-term offsets.
	function searchPrefixToTermIndex(searchLen, searchOffsets, termLen) {
		if (!searchOffsets || !searchOffsets.length) { return searchLen; }
		for (var k = 0; k < searchOffsets.length; k++) {
			if (searchOffsets[k] >= searchLen) { return k; }
		}
		return termLen;
	}

	// Endless scroll is driven by the one scroll container; the handler no-ops unless in dict mode.
	defBoxScrollBar.on('scroll', onDictScroll);

	function DisplayPolicySearch() {
		this.url = "dictionary/seek";
		this.origin = 'SEARCH';

		this.getRequestParams = function () {
			return {
				termLang: langToValField.attr("data-lang-code"),
				defLang: langFromValField.attr("data-lang-code"),
				pattern: doc.getLookupText()
			}
		};

		this.beforeRequest = function (defList) {
			// Seek whenever a learning language is set — an empty pattern browses from the start (A…),
			// so the Dictionary tab and a cleared search box both show words. No language → no seek
			// (a null termLang can't bind server-side). Reverse mode refuses outright: the box holds
			// a word in the learner's OWN language, which would seek the term dictionary to nonsense
			// and paint over the hit list. Belt-and-braces — the callers already branch.
			return !!langToValField.attr("data-lang-code") && !isReverseDict();
		}
	}

	// A random draw from one dictionary level. level/number arrive from the level list's
	// "Add to Practice" menu (the Random Words band is gone) and are kept on the policy so the
	// history entry can regenerate an equivalent set after snapshot eviction (see navStateForSet).
	function DisplayPolicyFrequency(levelCode, number) {
		this.beforeRequest = function (defList) {
			doc.setLookupText("");//clear lookup box
			return true;
		};

		this.url = "loadRandom";
		this.origin = 'RANDOM';
		this.level = levelCode;
		this.number = number;

		this.getRequestParams = function () {
			return {
				number: number,
				termLang: langToValField.attr("data-lang-code"),
				defLang: langFromValField.attr("data-lang-code"),
				level: levelCode,
				termSource: "BNC",
				defSource: "GT"
			};
		};
	}

	function DisplayManager() {
		var defList;//List of original DefClusterDto objects
		var _displayPolicy;
		this.setDisplayPolicy = function (displayPolicy) {
			_displayPolicy = displayPolicy;
		};

		this.getDefList = function () {
			return defList;
		};

		this.setDefList = function (list) {
			defList = list;
		};

		this.clearDefList = function () {
			defList = null;
		};

		this.getSessionOriginInfo = function () {
			return {
				origin: (_displayPolicy && _displayPolicy.origin) || 'RANDOM',
				wordListId: (_displayPolicy && _displayPolicy.wordListId) || null
			};
		};

		this.loadWords = function () {
			if (!_displayPolicy.beforeRequest(defList)) {
				return false;
			}

			var url = _displayPolicy.url;
			var requestParams = _displayPolicy.getRequestParams();

			var displayAll = this.displayAll;
			var policy = _displayPolicy;
			var manager = this;
			ajaxPost(url, requestParams,
			function (data) {
				// Stale-load guard: the initial dict-lean seek is async, so restoreSelectedTab can
				// switch to Learn/Practice before it returns. A finished load must not clobber a tab
				// the user is no longer on (the phantom "words on the Learn tab after refresh" bug).
				// SEARCH → the Dictionary tab; RANDOM/WORD_LIST → Practice.
				var loadTab = (policy && (policy.origin === 'RANDOM' || policy.origin === 'WORD_LIST')) ? 'practice' : 'dict';
				if (activeTab !== loadTab) { return; }
				// The pair's dictionary index is still building (only dictionary/seek can say this —
				// the RANDOM / WORD_LIST policies are DB-backed and always ready). Say "loading" and
				// ask again, rather than painting the wrong "no words" and stopping there forever.
				if (data && data.notReady) {
					renderDictLoading(function () { manager.loadWords(); });
					return;
				}
				clearDictRetry();
				if (data) {
					// A practice set stages sense CARDS (one per meaning); dictionary views stay
					// term-grained clusters.
					defList = (loadTab === 'practice')
						? expandPracticeClusters(data.definitions) : data.definitions;
					if (defList && defList.length > 0) {
						// As-you-type shows the plain list. The rich entry is shown only on Enter
						// (see richLookup()), so dictionary scanning stays fast and cheap.
						displayAll();
						//enable Start Excersise button
						startButton.find("#startCountId").text(" ("
						+ startCountText(defList) + ")");
						startButton.prop("disabled", false);
						// Practice sets (random or word-list) become navigable history entries.
						if (policy && (policy.origin === 'RANDOM' || policy.origin === 'WORD_LIST')) {
							commitPracticeSet(defList, policy);
							disableDictScroll();
						} else if (policy && policy.origin === 'SEARCH') {
							// Live typing/seek is plain browsing — not a navigation step, no current word.
							currentWord = null;
							richOpen = false;
							setupDictScroll(data, requestParams.pattern);
							// The typed word must be ON SCREEN, however tall its context rows are.
							if (requestParams.pattern) {
								ensureSeekAnchorVisible(data.anchorIndex);
							}
							// …and the OTHER answer to the same typed text: which entries contain it.
							phraseBandUpdate(requestParams.pattern,
								phraseBandNoMatch(defList, requestParams.pattern));
						} else {
							disableDictScroll();
						}
					} else {
						$("#defId").html("<div class='_noWordsClass'>"
						+ getRes("noWords_message") + "</div>");
							disableDictScroll();
						if (policy && policy.origin === 'SEARCH') {
							// The seek positioned nowhere at all — nothing to browse, so the band is
							// literally the whole result (the rescue case in its purest form).
							currentWord = null;
							richOpen = false;
							phraseBandUpdate(requestParams.pattern, true);
						}
					}
				} else {
					throw Util.exception("noData_message");
				}
			},
			"Server exception"
			);

			return true;
		};

		this.displayAll = function () {
			var pattern = doc.getLookupText();

			var defArea = $("#defId");
			collapseRich();   // a full re-render replaces the list; drop any open expansion + its state
			defArea.empty();

			if (!defList) {
				return;
			}

			// Combined view: adjacent sibling sense cards (trays keep a word's senses adjacent —
			// insertIndexFor / expandPracticeClusters) merge into one row; legacy senseId-null
			// cards stay singleton rows. Off (default): one row per card, as before.
			var combined = isCombinedTrayView();
			for (var i = 0; i < defList.length; i++) {
				var entry = defList[i];
				if (combined && entry && entry.senseId != null && entry.term && entry.term.id != null) {
					var group = [entry];
					while (i + 1 < defList.length && defList[i + 1]
							&& defList[i + 1].senseId != null && defList[i + 1].term
							&& defList[i + 1].term.id === entry.term.id) {
						group.push(defList[++i]);
					}
					defArea.append(buildEntryElement(entry, dictEntryUid++, pattern, group));
				} else {
					defArea.append(buildEntryElement(entry, dictEntryUid++, pattern));
				}
			}

			// Soft gate: a rendered PRACTICE set gets the learning nudge chip when it contains
			// brand-new words (never learned, never drilled). Dictionary renders never do —
			// guarded by tab + set origin, and the chip itself is optional decoration.
			if (window.LRN && activeTab === 'practice' && !isExerciseView
					&& _displayPolicy
					&& (_displayPolicy.origin === 'RANDOM' || _displayPolicy.origin === 'WORD_LIST')) {
				LRN.maybeNudge(defArea, defList);
			}

			// Learn tray: the SAME lean rows (buildEntryElement) as Practice, plus each tray word's
			// learning-status badge (New / R0–R5 progress / Ready) painted onto its row by term id.
			// Keyed on the active tab so a dictionary seek made mid-drill (from a Learn-tab card) still
			// only badges tray members — decorateTray matches against the tray, not the rendered list.
			if (window.LRN && activeTab === 'learn' && !isExerciseView && LRN.decorateTray) {
				LRN.decorateTray(defArea);
			}

			// Word-garden stage plants on the just-rendered lean rows (dictionary + Learn/Practice
			// trays), matched by term id. Returns only planted/Ready words, so untouched rows stay
			// bare. Skipped in the drill view — it shows the exercise, not lean rows.
			if (!isExerciseView) { GARDEN.decorate(defArea); }

			// (No thirsty-chip repaint here any more. The chip's count is the server's thirsty set
			// verbatim — tray membership no longer changes it — and every Practice entry re-fetches
			// it through randomWordsView → refreshThirstyChip, which is also the path a finished
			// drill returns on. See the chip's own section.)

			defBoxScrollBar.scrollTop(0);

			// A pending WL→tray fly frame (armed at the Add click) launches now that the tray has
			// painted — to the whole box for a bulk add, or the new row for an individual add.
			runPendingTrayFly(defArea);

			// Beacon tips (spec §6): a full re-render is one of the engine's stable hooks.
			if (window.OB_TIPS) { OB_TIPS.evaluate(); }
		};

	}

	function Doc() {
		this.setDefExerciseText = function (text) {
			$("#defId").html(text);
		};

		this.getLookupText = function () {
			return  lookupField.val();
		};

		this.setLookupText = function (text) {
			lookupField.val(text);
		};

		this.getAnswerText = function () {
			return  answerField.val();
		};

		this.setAnswerText = function (text) {
			answerField.val(text);
		};

		this.setResultText = function (text) {
			$("#exerciseResultId").html(text);
		};

		this.setTipText = function (text) {
			tipBox.text(text);
		};

		this.setCounterText = function (count) {
			$("#counterId").text(count);
		};

		this.getCounterText = function () {
			return $("#counterId").text();
		}
	}

	function Settings() {
		var settings = this;

		// Cascade is langFrom → langTo, handled server-side (a langFrom change reloads the
		// page). The two menus are independent here: langFrom drives the UI locale (reload);
		// langTo just refreshes the word list. See docs/design/language-selection.md.
		new LangMenuHolder($("#langFromValId"), new Menu($("#langFrom-Menu")), "langFrom");
		new LangMenuHolder($("#langToValId"), new Menu($("#langTo-Menu")), "langTo");
		updateDrillArticleVisibility();//the article setting only shows for article targets (DE)
		updateDirectionControls();     //first paint of the direction cluster (faces + pressed state)
		updateVerbSettingsVisibility();//the Verbs settings only where a Verbs list exists
		this.myListPanel = new WordListsPanel();

		// ── Word Lists accordion panel (left pane) ──────────────────────────────────────────────
		// One framed panel: a title bar (+ new list) over a stack of list sections; a single
		// section is expanded at a time and lazy-loads its words. System lists come first from the
		// server (DEFAULT ⭐) and hide their delete action; the virtual ones are labelled from a
		// resource, never from their stored name. Bulk actions live in a contextual selection bar
		// that appears only while at least one word is checked.
		function WordListsPanel() {
			var that = this;
			var panelBox = $("#myListsPanelId");
			var accordion = $("#wlAccordionId");
			var titleEl = $("#wlPanelTitleId");
			var newListBtn = $("#wlNewListBtnId");
			var sortBtn = $("#wlSortBtnId");
			var basketBtn = $("#wlBasketBtnId");
			var filterBtn = $("#wlFilterBtnId");
			var basketCountEl = $("#wlBasketCountId");

			var lists = [];             // summaries from wordlist-load: {id, name, kind, termCount, selected}
			var expandedId = null;      // db id of the expanded section (null = all collapsed)
			var initialized = false;    // the persisted selection is applied on the first load only
			var rowTermIds = [];        // termIds of the expanded list, in rendered row order
			var lastCheckedIdx = null;  // anchor row index for shift-click range selection
			var popoverEl = null;       // the floating move/copy target picker, when open
			var popoverLayer = null;    // its PL.layers handle (Phase 4 step 3c)
			var basketPopEl = null;     // the open waste-basket popup, when shown
			var basketLayer = null;     // its PL.layers handle (Phase 4 step 3c)
			var sortPopEl = null;       // the open sort-mode menu, when shown
			var sortLayer = null;       // its PL.layers handle (Phase 4 step 3c)
			var sortMode = "NEWEST";    // persisted sort selection (wlSortMode attr), from wordlist-load
			var levelSortMode = "ALPHA"; // band lists' member sort (wlLevelSortMode attr): ALPHA | FREQ
			var dragging = false;       // a section drag is in flight: swallow the header click
			var openTopic = null;       // Topic key the 🗂️ row is showing ("TRAVEL"), null = row closed
			var topicPopEl = null;      // the open topic picker, when shown
			var topicLayer = null;      // its PL.layers handle
			var topicCounts = null;     // [{key, badge, count}] for the pair — fetched once per load

			// ── API kept for the rest of main.js ──
			this.panelShown = true;
			this.panelAttrToShow = true;   // the accordion panel is always available outside exercises

			this.showPanel = function () {
				panelBox.css("display", "flex");
				that.panelShown = true;
			};

			this.hidePanel = function () {
				panelBox.css("display", "none");
				that.panelShown = false;
				closeBasket();
				closeSortMenu();
				closeAddMenu();
				closeTopicPicker();
			};

			// A live learning session keeps the panel visible (browsing stays live) but switches OFF
			// the tray-add affordances — the header Add pill + every per-row add button read as inert
			// (CSS .wlAddDisabledClass). Closes the add menu so a half-open popover can't linger.
			this.setAddDisabled = function (disabled) {
				panelBox.toggleClass("wlAddDisabledClass", !!disabled);
				// The one-press tray buttons (tray-add-buttons.md decision 9) live all over the page —
				// lean rows, the rich card, the word popup, phrase gutters — not just inside this
				// panel, so panelBox's own class can't reach them. Same class name, same CSS shape
				// (pointer-events:none + dimmed), on <body> instead: isAddDisabled() below still
				// answers from panelBox, the one place this state actually lives.
				$("body").toggleClass("wlAddDisabledClass", !!disabled);
				if (disabled) { closeAddMenu(); }
			};

			// A word was added to a list from elsewhere (dictionary "A", rich card, phrase add) —
			// refresh the counts, and the rows too when that list is the expanded one.
			this.addWordToList = function (wlDbId) {
				loadLists();
			};

			// The central tab switched, so the Add destination changed (Learning = the sprout mark,
			// Practice = the watering-can mark).
			// Repaint every rendered list's Add pill now — it otherwise only refreshes on hover
			// (updateHeaderTight), leaving an open list's pill stale until the pointer touches it.
			this.repaintAddDest = function () {
				accordion.find(".wlHeaderClass").each(function () { paintAddPill($(this)); });
			};

			// Open the Topics row on one topic from OUTSIDE the panel — a topic chip on the rich
			// card. Unlike pickTopic (the picker's own handler) this never toggles: a chip says
			// "show me this topic", and answering a click by closing the list would be a trap. If
			// that topic is already open it just scrolls the row back into view.
			//
			// Counts are fetched first so the row's pill shows the topic's own number rather than
			// the whole tagged dictionary's — the same ensureTopicCounts the picker runs through.
			this.showTopic = function (key) {
				if (!key) { return; }
				var item = null;
				for (var i = 0; i < lists.length; i++) {
					if (isTopicKind(lists[i].kind)) { item = lists[i]; break; }
				}
				// No Topics row for this pair (no tags in its dictionary) — nothing to open.
				if (!item) { return; }
				ensureTopicCounts(function () {
					if (openTopic !== key || expandedId != item.id) {
						openTopic = key;
						expandSection(item.id);
					}
					var section = sectionEl(item.id)[0];
					if (section && section.scrollIntoView) {
						section.scrollIntoView({ block: "nearest" });
					}
				});
			};

			this.reload = function () {
				initialized = false;   // re-apply the persisted selection for the new language
				expandedId = null;
				openTopic = null;
				topicCounts = null;    // the taxonomy's coverage is per language pair
				closeTopicPicker();
				closeBasket();         // the basket is per-language
				closeSortMenu();
				// The global filter is per language pair too — its matches, its badges and the
				// row itself all describe the OLD pair. preFilterExpanded is stale with them.
				globalFilter = "";
				preFilterExpanded = null;
				closeGlobalFilterRow();
				panelBox.removeClass("wlxFilterModeClass");
				loadLists();
			};

			// The "only irregular verbs" setting changed. Unlike reload() this KEEPS the expanded
			// section and the sort/basket state: the user toggles the filter while looking at the
			// Conjugation list, and collapsing it under them would be the wrong answer.
			//
			// The forced loadWords is the point. softRefresh() never reloads a virtual list's rows
			// because dictionary content is static and a reload resets the endless scroll — true
			// for the level lists, but this toggle is precisely the case where the rows did change,
			// and the count often moves too little to trip the count check (a filter that removed
			// nothing still needs the rows redrawn on the way back). Both verb kinds are re-read
			// even though only Conjugation narrows: the open one is whichever the user is looking
			// at, and testing the kind here would be a second copy of that rule.
			this.refreshVerbList = function () {
				loadLists(function () {
					var current = expandedId ? listById(expandedId) : null;
					if (current && isVerbKind(current.kind)) {
						loadWords(expandedId);
					}
				});
			};

			// A finished Learn or Practice session changes not just the icons but WHICH SECTION a
			// word is in and every count around it — that is what My Garden is made of. Same
			// forced-reload shape as refreshVerbList and for the same reason: softRefresh never
			// reloads a virtual list's rows (dictionary content is static and a reload resets the
			// endless scroll), and this list is the exception where the rows genuinely moved.
			// loadLists refreshes the panel badge; loadWords refetches the section counts and rows.
			this.refreshGardenList = function () {
				loadLists(function () {
					var current = expandedId ? listById(expandedId) : null;
					if (current && current.kind === 'GARDEN') {
						loadWords(expandedId);
					}
				});
			};

			// Which list the user is VIEWING: the expanded one — unless it's a read-only virtual
			// list (browsable but never a target) — else the DEFAULT system list. This answers ONE
			// question, the word-list view's fetch key (DisplayPolicyWordListDefs). It used to
			// answer two, and the second one is why the split exists: "what is open" also decided
			// where an add LANDED, so expanding a list to LOOK at it silently re-aimed every add
			// button in the app (docs/project/wl-add-target-redesign.md). Nothing decides that any
			// more — the reader names the list in the add picker, every time.
			this.getExpandedListId = function () {
				var current = expandedId ? listById(expandedId) : null;
				if (current && !isVirtualKind(current.kind)) { return expandedId; }
				return defaultListId();
			};

			// The add picker's rows: every list a word can actually be filed in, in panel order.
			this.fileableLists = function () {
				var out = [];
				for (var i = 0; i < lists.length; i++) {
					if (!isVirtualKind(lists[i].kind)) {
						out.push({ id: lists[i].id, name: displayName(lists[i]), kind: lists[i].kind });
					}
				}
				return out;
			};

			// A live learning session switches the panel's add affordances off; the add picker on
			// every OTHER add control goes inert with them.
			this.isAddDisabled = function () {
				return panelBox.hasClass("wlAddDisabledClass");
			};

			// Create a list and file into it in one flow (the picker's "New list…" row). Answers
			// with the new id so the caller can put the word it was opened for straight into it.
			this.createList = function (name, onDone) {
				if (!name) { return; }
				ajaxPost("wordlist-create",
					{ termLang: langToValField.attr("data-lang-code"), wordListName: name },
					function (data) {
						var newId = data && data.wordListId;
						loadLists(function () { if (onDone && newId) { onDone(newId); } });
					},
					getRes("operationCannotComplete_message"));
			};

			// Where the fly-to-list animation lands: the header ROW of the list this add is going
			// to, else the panel title. The row, not the name span inside it (owner report
			// 2026-08-12): a frame that shrinks to the width of the words "My List" reads as
			// landing beside the list rather than on it, and the same element carries the arrival
			// blink — which now hugs the row.
			this.flyTarget = function (listId) {
				var header = sectionEl(listId).find(".wlHeaderClass").first();
				return header.length ? header : titleEl;
			};

			// ── The guided walk drives the panel (chapter 3, js/onboarding_guide.js) ──────────
			//
			// The Word Lists chapter opens a list, teaches it and PUTS IT AWAY before pointing at
			// the next row (owner spec 2026-08-13: close Conjugation first, "otherwise the next one
			// is outside of the view"), and it raises the Topics picker and the reader's brand-new
			// list by itself. None of that can go through the panel's own controls: the walk's wall
			// swallows every press but the step's own, and a synthetic press would be a lie about
			// what the reader did. So the moves it needs are named here — each one is a call the
			// panel already makes for itself somewhere.
			//
			// The walk was the only caller until 2026-08-18; the account menu's Word list settings
			// box now asks `foldable` too, because only the panel knows how many rows a group has in
			// the pair on screen.
			window.plWlPanel = {
				// ⭐ RE-LOAD THE PANEL FROM THE SERVER. Added 2026-09-09 for the one caller that
				// needs it: the guest app page's tour card, which mints a user WITHOUT reloading
				// the page. Every load-time request on that page had already come back with its
				// guest shape — for this panel, `wordListList: []`, because the system lists are
				// per-user rows and there was nobody to create them for — and nothing re-asked, so
				// the visitor met an empty Word Lists pane on the other side of the card (owner
				// report: "why no word lists here"). One call fills it, WLFX index included.
				reload: function (onDone) { loadLists(onDone); },

				// The band chip's click-through (docs/project/en-reband-plan.md C2, spec point 5):
				// open the band's own word list scrolled to the word the reader was just looking
				// at. `levelName` is the slot code the entry carried ("A1".."C2P" or "A".."E");
				// no matching list row (pair mid-startup, stale code after a scheme flip) is a
				// quiet no-op — the chip then said everything it had to.
				openLevelAtWord: function (levelName, termId, term) {
					var kind = "LEVEL_" + levelName;
					var it = null;
					for (var i = 0; i < lists.length; i++) {
						if (lists[i].kind === kind) { it = lists[i]; break; }
					}
					if (!it) { return false; }
					this.reveal();
					levelJump = { termId: termId, term: term };
					// Re-open even if it is already the expanded section — the jump cursor only
					// takes effect on a fresh stream.
					expandSection(it.id);
					return true;
				},

				// The panel ON SCREEN AT ALL. The left pane is rail-collapsible independently of
				// anything in it (PaneLayout), and a chapter that walks the panel top to bottom
				// cannot start against a 40px band — every anchor would be invisible and every step
				// would skip itself. Only ever needed by the Help hub's entry into chapter 3: the
				// offered path runs at the end of a walk the reader has had the panel open for.
				// Same move openTopicWordList makes for a topic chip.
				reveal: function () {
					if (PaneLayout.state.leftCollapsed) {
						PaneLayout.toggle(PaneLayout.SIDE.left);
					}
				},

				// Is ANY built-in group folded into a chip strip right now (the compactLevelLists /
				// compactVerbLists settings)? The walk asks so it can put them back the way it
				// found them.
				compact: function () {
					for (var i = 0; i < COMPACT_GROUPS.length; i++) {
						if (compactOn(COMPACT_GROUPS[i])) { return true; }
					}
					return false;
				},

				// …and flip that, for the walk's duration only. RENDER ONLY — neither user attr is
				// written, which is the whole safety of this: whatever the walk leaves behind, the
				// next page load reads the settings the reader actually chose.
				//
				// The walk needs it because a folded group is not a hidden row, it is five rows that
				// are not on screen at all (.wlCompactHiddenClass) behind one strip of letter chips.
				// Chapter 3's Conjugation, filter-box, verb-add and Verb-forms steps then find no
				// anchor and skip themselves one after another — the tour "breaks" at the frequency
				// bands and never recovers (owner report 2026-08-13). The two steps that DO survive
				// survive by falling back to a chip, which is worse than it sounds: the copy is about
				// five named lists and the ring is on a single letter.
				//
				// `walkFold` remembers the PER-GROUP state, not one boolean, so putting the panel
				// back cannot fold a group the reader had left open — the walk's caller still speaks
				// in one flag (it only ever asks "was anything folded?"), and this is where that flag
				// widens back out. Non-null exactly while an unfold is owed.
				//
				// Same two calls the `pl:compactLists` handler makes, in the same order: the model is
				// regrouped first so the panel and `lists` still agree (softRefresh checks that they
				// do).
				setCompact: function (on) {
					if (!on) {
						if (walkFold) { return; }   // already held unfolded
						walkFold = $.map(COMPACT_GROUPS, function (g) { return compactOn(g) ? 1 : 0; });
						$.each(COMPACT_GROUPS, function (_, g) { window[g.global] = false; });
					} else {
						if (!walkFold) { return; }  // nothing owed
						$.each(COMPACT_GROUPS, function (i, g) { window[g.global] = !!walkFold[i]; });
						walkFold = null;
					}
					groupCompactLists();
					applyCompactLists();
				},

				// Would this group's fold switch actually do anything for the pair on screen? Named
				// by USER ATTRIBUTE, so the account menu asks in the same vocabulary its checkboxes
				// are written in. English has only the form-set verb list, and folding one row into
				// one strip row saves nothing and costs the name — so that switch is not offered.
				foldable: function (attr) {
					for (var i = 0; i < COMPACT_GROUPS.length; i++) {
						if (COMPACT_GROUPS[i].attr === attr) { return groupFolds(COMPACT_GROUPS[i]); }
					}
					return false;
				},

				// Nothing open — the Topics picker included. Every lesson of that chapter starts
				// from this.
				collapse: function () {
					closeTopicPicker();
					if (expandedId != null) { collapseSection(); }
				},

				// Open the first list of a KIND ("GARDEN", "VERBS", "DEFAULT"). A pair that has no
				// such list is a no-op: the step then finds no anchor and is skipped, which is the
				// chapter's own rule for a list this language has not got.
				open: function (kind) {
					for (var i = 0; i < lists.length; i++) {
						if (lists[i].kind !== kind) { continue; }
						if (expandedId != lists[i].id) { expandSection(lists[i].id); }
						return;
					}
				},

				// The Topics row is a launcher, so what the walk opens is the PICKER — that is the
				// thing its step points at ("open the Topics automatically and suggest to pick a
				// topic"). Already open = nothing to do.
				openTopics: function () {
					if (topicPopEl) { return; }
					for (var i = 0; i < lists.length; i++) {
						if (!isTopicKind(lists[i].kind)) { continue; }
						var header = sectionEl(lists[i].id).children(".wlHeaderClass");
						if (header.length) { toggleTopicPicker(lists[i], header); }
						return;
					}
				},

				// The open list's own filter box, cleared exactly the way its × clears it (same
				// handler, so the box's debounce bookkeeping stays honest): the walk has just had
				// the reader type a few letters in, and the next step is about the whole list.
				clearListFilter: function () {
					accordion.children(".wlSectionClass.wlExpanded")
						.find(".wlToolbarClass .wlFilterClearClass").click();
				},

				// The search across all lists, folded away again — and with it the filter mode,
				// which is closeGlobalFilterRow's own job.
				closeSearch: function () { closeGlobalFilterRow(); },

				// The list the reader has just named. `wordlist-create` answers with an OK and
				// nothing else, so there is no id to carry back: the newest own list IS the one
				// just made, and the reload is what makes sure this tab knows about it at all.
				openNewest: function () {
					loadLists(function () {
						var best = null;
						for (var i = 0; i < lists.length; i++) {
							if (lists[i].kind !== 'USER') { continue; }
							if (!best || Number(lists[i].id) > Number(best.id)) { best = lists[i]; }
						}
						if (best) { expandSection(best.id); }
					});
				}
			};

			// ── data ──
			function loadLists(onDone) {
				// No learning language chosen yet (blank langTo): nothing to load.
				if (!langToValField.attr("data-lang-code")) {
					lists = [];
					accordion.empty();
					updateBasketBadge(0);
					if (onDone) { onDone(); }
					return;
				}
				ajaxPost("wordlist-load", {
						termLang: langToValField.attr("data-lang-code"),
						// Scopes the level lists' badge counts (terms with a definition in this language).
						defLang: langFromValField.attr("data-lang-code")
					},
					function (data) {
						// Feed the global filter's client index: idempotent per language pair, and
						// each call also freshens the per-user sets — so the panel's own reload IS
						// the maintenance hook for list mutations that go through it.
						WLFX.load(langToValField.attr("data-lang-code"),
							langFromValField.attr("data-lang-code"));
						var prevLists = lists;
						lists = (data && data.wordListList) || [];
						// Before ANY comparison against the DOM: the panel on screen is already
						// grouped, so a fresh model that isn't would fail softRefresh's order check
						// on every single load and force a full rebuild each time.
						groupCompactLists();
						sortMode = (data && data.sortMode) || "NEWEST";
						levelSortMode = (data && data.levelSortMode) || "ALPHA";
						if (!initialized) {
							initialized = true;
							for (var i = 0; i < lists.length; i++) {
								if (lists[i].selected) { expandedId = lists[i].id; break; }
							}
							// The Topics row persists WHICH of its eighteen lists was open; the
							// server resolved TOPIC:<KEY> back to the row's id above and hands the
							// key over here. Restored once, with the selection it belongs to.
							openTopic = (data && data.openTopic) || null;
						}
						// Sanity: the persisted selection must still exist (level lists are
						// expandable since phase 2, so any live id qualifies).
						if (expandedId && !listById(expandedId)) { expandedId = null; }
						if (!expandedId) { openTopic = null; }
						setTitle();
						updateBasketBadge(data ? data.basketCount : 0);
						// Same sections in the same order → refresh IN PLACE (no accordion rebuild):
						// tearing everything down and back up on every add/move/remove made the
						// panel visibly blink and jump. Full render only on structural change.
						if (softRefresh(prevLists)) {
							if (globalFilter) { refreshFilterMode(); }
							if (onDone) { onDone(); }
							return;
						}
						render();
						// A full rebuild minted fresh section headers — the filter mode's badges,
						// dimming and open matches live on those headers, so repaint them.
						if (globalFilter) { refreshFilterMode(); }
						if (onDone) { onDone(); }
					},
					getRes("wlLoad_error_message") + " [1]");
			}

			// In-place panel refresh when the section set/order is unchanged: update names +
			// count badges, and reload the expanded list's rows ONLY if its content actually
			// changed (its count moved) — never a level list (its dictionary content is static
			// and a reload would reset the endless scroll). Returns false when the sections on
			// screen don't match the fresh model (added/deleted/reordered list) — caller re-renders.
			function softRefresh(prevLists) {
				var domIds = $.map(accordion.children(".wlSectionClass"), function (el) {
					return +el.getAttribute("data-wl-id");
				});
				if (domIds.length !== lists.length) { return false; }
				for (var i = 0; i < lists.length; i++) {
					if (lists[i].id !== domIds[i]) { return false; }
				}
				for (var j = 0; j < lists.length; j++) {
					var it = lists[j];
					var header = sectionEl(it.id).children(".wlHeaderClass");
					header.find(".pl-count-pill").text(it.termCount);
					applyAddPillState(header, it);
					// A no-op on every row but My Garden's. Repainted here rather than only on a full
					// render because watering is exactly what moves without the panel being rebuilt:
					// a drill waters words, and this is the badge that has to notice.
					paintGardenWaterBadge(header, it.wateringCount);
					var nameEl = header.find(".wlNameClass");
					if (!nameEl.find("input").length) {   // don't stomp an in-progress rename
						paintListName(nameEl, it);   // keeps a CEFR row's name + code stack
					}
				}
				if (expandedId) {
					var now = listById(expandedId);
					var was = null;
					for (var k = 0; k < prevLists.length; k++) {
						if (prevLists[k].id === expandedId) { was = prevLists[k]; break; }
					}
					if (now && !isVirtualKind(now.kind) && (!was || was.termCount !== now.termCount)) {
						loadWords(expandedId);
					}
				}
				// The counts above were patched in place; the strip carries their sum, so it gets
				// the same treatment. Repainted, NOT rebuilt — a soft refresh runs on every add,
				// move and remove, and each rebuild would mint six fresh tooltip machines.
				paintTopicRows();   // …and the Topics row's name + count, which are not its own model's
				repaintStripTotal();
				return true;
			}

			function listById(id) {
				for (var i = 0; i < lists.length; i++) {
					if (lists[i].id == id) { return lists[i]; }
				}
				return null;
			}

			// The fallback destination behind both resolvers: "My List", else whatever this
			// language has (a pair with no lists at all answers null, which the add controls
			// already report as "no word list").
			function defaultListId() {
				for (var i = 0; i < lists.length; i++) {
					if (lists[i].kind === 'DEFAULT') { return lists[i].id; }
				}
				return lists.length ? lists[0].id : null;
			}

			// A dictionary-level list (kind LEVEL_A..LEVEL_E) — read-only, virtual content.
			// Use this ONLY where a level CODE is needed (levelCode below); for read-only /
			// not-a-target behaviour use isVirtualKind, which also covers VERBS.
			function isLevelKind(kind) {
				return kind && kind.indexOf('LEVEL_') === 0;
			}

			// Any list whose words come from a query rather than from its own membership: the five
			// levels, the two verb lists and GARDEN. These are read-only — never an add/move/copy
			// target and never a Remove source — which is what almost every caller actually means.
			// (GARDEN's query is over the user's OWN state rather than the dictionary; every
			// consequence for the panel is identical.)
			function isVirtualKind(kind) {
				return isLevelKind(kind) || isVerbKind(kind) || isTopicKind(kind) || kind === 'GARDEN';
			}

			// The 🗂️ Topics row — ONE row standing for eighteen by-situation lists. Which of them is
			// showing is `openTopic`, not the kind, so everything that asks "is this list read-only /
			// a copy source / paged off the dictionary" gets the same answer as for a level list, and
			// only the three places that need to know WHICH topic look at openTopic.
			function isTopicKind(kind) {
				return kind === 'TOPIC';
			}

			// topicName() lives at module level now (see the rich-entry block builders): the card's
			// topic chips name a topic too, and the picker and the chips must never disagree.


			// One of the two VERB card types' lists — CONJUGATION drills one form in use
			// ("du fuhrst"), VERBS the whole form set as one card ("fahren, fährt, fuhr, ist
			// gefahren"). They behave identically all over this panel: same endpoint, same rows,
			// and an add EXPANDS each verb into cards, so a count of n means n verbs and not n
			// words. The one thing that differs is which cards a verb becomes, and the server
			// decides that from the kind the request names. See docs/project/verb-card-types.md.
			function isVerbKind(kind) {
				return kind === 'VERBS' || kind === 'CONJUGATION';
			}

			// "LEVEL_C" -> "C", "LEVEL_C2P" -> "C2P": the code /loadRandom expects in its level
			// param and the wlLevel<code>_* resource-key stem. LEVEL_* ONLY — on any other kind
			// the remainder is meaningless. (Was charAt(last), which shredded the multi-char CEFR
			// slots into "1"/"2"/"P" — caught by the C2 smoke.)
			function levelCode(kind) {
				return kind.substring('LEVEL_'.length);
			}

			// System lists are labelled from resources, never from their stored names (a rename
			// would not show; level lists may even carry a de-duplication suffix).
			function displayName(item) {
				if (item.kind === 'VERBS') { return getRes("wlVerbs_label"); }
				if (item.kind === 'CONJUGATION') { return getRes("wlConjugation_label"); }
				if (item.kind === 'GARDEN') { return getRes("wlGarden_label"); }
				// Open, the Topics row IS the topic it is showing — "Travel & Transport", not
				// "Topics". The 🗂️ in the pill is the row's constant identity, which frees the NAME
				// to carry the one thing that varies. It was drawn as a breadcrumb beside the name
				// first ("🗂️ Topics ▸ ✈️ Travel & Transport") and that lost: the panel is ~370px and
				// the open row also holds the Add pill and the count, so the crumb was squeezed to
				// zero width and silently vanished — passing every test that asked whether it
				// existed. One name, in the slot every other row already keeps for one.
				if (isTopicKind(item.kind)) {
					return openTopic ? topicName(openTopic) : getRes("wlTopics_label");
				}
				if (isLevelKind(item.kind)) { return getRes("wlLevel" + levelCode(item.kind) + "_label"); }
				// DEFAULT is the one system list a reader may rename, so it is localized only while
				// it still carries the name the server seeded it with (WordListService.
				// DEFAULT_LIST_NAME, the same English string for every reader language). Once the
				// reader has typed a name of their own, that name shows as typed.
				if (item.kind === 'DEFAULT' && item.name === 'My List') { return getRes("wlDefault_label"); }
				return item.name;
			}

			// A level row's name in full: the band's label and, where that label is a bare CEFR
			// code, its plain-language name. One string, for the places that can only hold one —
			// the row's clipped-name tooltip. The ROW itself stacks the two (buildSection).
			function levelFullName(item) {
				var plain = levelPlainName(levelCode(item.kind));
				return plain ? displayName(item) + " · " + plain : displayName(item);
			}

			// A row's name span as the panel shows it — THE one painter, for the full render
			// (buildSection) and the in-place refresh (softRefresh) alike.
			//
			// A CEFR band's row reads as ONE line: its plain-language name, then its code at the far
			// end of the pill. The code alone says nothing to a learner who has not met the ladder
			// (owner report 2026-08-25), so the name leads and the code trails it (owner call
			// 2026-08-30). It was briefly a two-line stack — that bought room the fixed 8.2em pill
			// didn't have, at the cost of a name too small to read; the pill was widened instead
			// (word-lists.css). A..E bands are untouched — one line, their label already being a word.
			//
			// ONE painter because there used to be two: buildSection built the stack and softRefresh
			// reset every row with .text(displayName), which wiped it — so the names lasted exactly
			// until the first in-place refresh (any add, move, count change, or a drill's watering) and
			// the ladder read "A1, A2, B1…" from then on, names back only after a full page render
			// (owner report 2026-10-07, mid-tour: "I thought we are showing the names of the bands
			// rather than A1 etc."). data-name mirrors the visible label for the Garden row's
			// bold-reservation ghost (word-lists.css, attr(data-name)) — harmless on every other row.
			function paintListName(nameSpan, item) {
				var label = displayName(item);
				var levelPlain = isLevelKind(item.kind) ? levelPlainName(levelCode(item.kind)) : "";
				nameSpan.attr("data-name", label);
				if (levelPlain) {
					nameSpan.addClass("wlLevelStackClass").empty()
						.append($("<span class='wlLevelPlainClass'></span>").text(levelPlain))
						.append($("<span class='wlLevelCodeClass'></span>").text(label));
				} else {
					nameSpan.removeClass("wlLevelStackClass").text(label);
				}
			}

			// The glyph a VIRTUAL list is marked by, in its header pill and (folded) on its strip
			// chip — one definition, so a row and its chip can never drift apart.
			// 📖 dictionary level, 🏃 a form in use, 📋 a form set recited as a list, 🗂️ the topics
			// (index dividers: the dictionary filed by situation, not by how common a word is). The
			// &#65039; variation selector matters — bare U+1F5C2 renders monochrome on some platforms.
			//
			// GARDEN is the one that is not a glyph: it wears tab-flower.svg, the SAME stage-7
			// crown as My Progress's Garden button (main.html #gardenOpenBtnId). The two are doors
			// into one garden and now say so with one picture. It used to be 🌱 U+1F331, which
			// stopped working the moment the seedling became LEARNING's mark everywhere — the
			// Learn tab, the Add-to pill, the recap heading — leaving two different ideas wearing
			// one glyph. tab-sprout.svg and watering-can-smooth.svg stay on disk, unused.
			// Only the header pill renders this: GARDEN belongs to neither folding strip.
			function kindGlyph(kind) {
				if (kind === 'GARDEN') { return '<img alt="" src="/image/garden/tab-flower.svg">'; }
				if (kind === 'CONJUGATION') { return "&#127939;"; }
				if (kind === 'VERBS') { return "&#128203;"; }
				if (isTopicKind(kind)) { return "&#128450;&#65039;"; }
				return "&#128214;";
			}

			function setTitle() {
				// Flag FIRST ("which language's lists"), title after — the swap that freed the
				// header's right side for the 🔍 (wl-global-filter.md, decision 1). The label is
				// wrapped in a span so the title can be a flex row: flag and text CENTER against
				// each other geometrically, instead of the flag hanging off the text baseline by
				// a hand-tuned vertical-align that drifts with the font.
				// "learning" context: these are the lists of the language you are LEARNING, so
				// on English the flag is the dialect you chose, not the combo.
				var flag = plFlagHtml(langToValField.attr("data-lang-code"), "learning");
				titleEl.empty();
				if (flag) { titleEl.append(flag); }
				titleEl.append($("<span class='wlTitleTextClass'></span>").text(getRes("wlLabel")));
			}
			// Exported so the dialect chooser can repaint this title without a reload; the
			// word-list panel lives in its own closure and has no other way in.
			window.plRepaintWordListTitle = setTitle;

			function sectionEl(wlDbId) {
				return accordion.children(".wlSectionClass[data-wl-id='" + wlDbId + "']");
			}

			function stopEvent(e) {
				e.preventDefault();
				e.stopPropagation();
			}

			// ── rendering ──
			function render() {
				hidePopover();
				closeAddMenu();
				groupCompactLists();
				accordion.empty();
				for (var i = 0; i < lists.length; i++) {
					accordion.append(buildSection(lists[i]));
				}
				applyCompactLists();
				if (expandedId) {
					var section = sectionEl(expandedId);
					if (section.length) {
						section.addClass("wlExpanded");
						updateHeaderTight(section.children(".wlHeaderClass"));   // D11: pill is now always visible
						// The crumb is only paintable once the section is marked open, and it needs
						// the badge off the counts — which on a boot-restored topic have not been
						// fetched yet, so it paints twice: name now, badge when they land.
						paintTopicRows();
						if (openTopic) { ensureTopicCounts(paintTopicRows); }
						loadWords(expandedId);
						// Beacon tips (spec §6): a boot-restored expansion is the same add-pill
						// moment as a click expand — without this the boot pass races the panel.
						if (window.OB_TIPS) { OB_TIPS.evaluate(); }
					}
				}
			}

			// Paint the Add pill's contextual face (destination icon + matching label). Called at
			// build time and on every reveal (updateHeaderTight) so the pill tracks the active tab
			// with no tab-switch sync. .html() replaces only the pill's inner content — the button
			// element and its bound click/hover machine survive.
			function paintAddPill(header) {
				var pill = header.find(".wlAddPracticeClass");
				if (!pill.length) { return; }
				var learning = addDestIsLearning();
				var face = "<span class='wlDestIconClass'>" + addDestIcon() + "</span>"
					+ "<span class='wlAddLabelClass'>"
					+ escHtml(getRes(learning ? "wlAddLearn_button" : "wlAddPractice_button")) + "</span>";
				// Written only when the face CHANGES (a tab switch moved the destination). Rewriting
				// it on every reveal replaced the spans under a resting pointer, and with the
				// measure below that kept an open band's pill re-rendering in a loop — 62 writes a
				// second, the menu never opening (tour-exhaustive-test.md D4).
				if (pill.data("face") === face && pill.children(".wlDestIconClass").length) { return; }
				// A beacon bloom may live inside the pill (the explore trail's Add crumb).
				// Carry the NODE across the repaint — rebuilding it on every hover would
				// drop keyboard focus and yank the very button the pointer is heading for
				// (its native click listener survives detachment; jQuery only cleans its
				// own handlers).
				var bloom = pill[0].querySelector(".obBeaconClass");
				pill.html(face);
				pill.data("face", face);
				if (bloom) { pill[0].appendChild(bloom); }
			}

			// D11: the Add pill adapts to the space on the name row — full label when it fits,
			// icon-only (the destination icon) when tight. The name yields LAST: CSS keeps it ≥3em
			// with ellipsis and the header clips any final overflow. Measured (and the pill repainted
			// for the current destination) whenever it becomes visible (header hover, section expand).
			function updateHeaderTight(header) {
				paintAddPill(header);
				measureHeaderTight(header);
				// Inter is a WEBFONT. A verdict taken before it paints is taken against the
				// fallback's metrics, and a fallback that measures narrower says "it fits" about a
				// row that will not — after which nothing ever asks again (the ResizeObserver below
				// only fires on a WIDTH change), so the wrong answer survives for the life of the
				// panel. That is the second half of the clipped-name bug: the row was measured, in
				// good faith, against text nobody would ever see. Re-measure once the real font is
				// in. Cheap and idempotent — .ready has already resolved on every later call.
				if (document.fonts && document.fonts.status !== "loaded") {
					document.fonts.ready.then(function () { measureHeaderTight(header); });
				}
				// paintAddPill above re-html()'d the pill's content — if a beacon dot lived
				// inside it (the explore trail's Add crumb, the add-pill tip), it was wiped
				// with that content. Re-evaluate NOW so a hover reveal doesn't eat the dot
				// the pointer is travelling towards (btn.isConnected sync restores it).
				if (window.OB_TIPS) { OB_TIPS.evaluate(); }
			}

			// The measurement itself, re-runnable: the verdict is always re-derived from scratch
			// (drop the class, measure the untight row, re-apply) so a row that went tight under
			// stale metrics can come back out of it.
			//
			// Drop, measure and re-apply in ONE task, so the untight row is laid out for the reading
			// and never painted. Until 2026-10-08 the class came off at once and went back on in the
			// next frame: for that frame the pill grew its label, and a pointer resting on it from the
			// right was suddenly over something else — leave, enter, measure again, ~20 times a
			// second, and the menu under the pointer never opened (tour-exhaustive-test.md D4). A
			// header not in the document yet (build time) has nothing to measure until it is: that
			// one waits a frame, as they all used to.
			function measureHeaderTight(header) {
				if (!header.length) { return; }
				if (header[0].isConnected) { tightVerdict(header); return; }
				requestAnimationFrame(function () {
					if (header[0].isConnected) { tightVerdict(header); }
				});
			}

			function tightVerdict(header) {
				header.removeClass("wlTightClass");
				// The header itself only overflows once every flex item is at min-width — by
				// then the name is already crushed to 3em. The name must yield AFTER the pill's
				// label, so a truncated name (its full text wider than the box flex left it)
				// is itself the "tight" signal.
				var name = header.find(".wlNameClass")[0];
				if (header[0].scrollWidth > header[0].clientWidth + 1
						|| (name && name.scrollWidth > name.clientWidth + 1)) {
					header.addClass("wlTightClass");
				}
			}

			// ── The chip fan: how far does each chip tuck under its neighbour? ─────────────────
			// A compact strip carries a fixed set of chips plus a count pill that must stay whole
			// at every width (owner rule) — so when the pane narrows, the CHIPS are what give.
			// They close up like cards fanned in a hand, and open flat again as the pane widens.
			// word-lists.css draws it; this decides how far.
			//
			// The fan closes FROM THE RIGHT (owner call): the rightmost chip slides under its left
			// neighbour until CHIP_LAP_MAX of it is covered, then those two travel together and the
			// next gap starts, and so on. Not an even squeeze — that would blur all six chips at
			// once, where this leaves every chip the fan has not reached yet perfectly readable.
			// 40% is where a covered chip still reads as its own card; past that it is a sliver,
			// and the pane is better off hitting its floor than pretending the strip still fits.
			var CHIP_LAP_MAX = .40;   // fraction of a chip's own width, per gap

			// Right-hand chips tuck UNDER left-hand ones, so the labels that survive longest are
			// the ones at the start of the band order. Paint order does the opposite by default
			// (flex items paint in DOM order), hence an explicit descending z per chip.
			function fitLevelStrip(strip) {
				var chips = strip.querySelector(".wlLevelChipsClass");
				if (!chips) { return; }
				var kids = chips.children, n = kids.length;
				if (n < 2) { return; }
				// Clear first: the answer must not be measured against the last answer, or a
				// narrowing pane would ratchet the fan ever tighter and never open again.
				for (var i = 0; i < n; i++) {
					kids[i].style.setProperty("--wl-chip-lap", "0px");
					kids[i].style.setProperty("--wl-chip-z", String(n - i));
				}
				// The cap has to swallow the flex gap first. A margin-left of -L closes the .25em
				// gap BEFORE it starts covering anything, so L = gap + 40% of a chip is what
				// actually puts 40% of the disc under its neighbour. Getting this wrong silently
				// halves the fan's travel.
				var gap = parseFloat(getComputedStyle(chips).columnGap) || 0;
				var cap = gap + kids[0].getBoundingClientRect().width * CHIP_LAP_MAX;
				// Two passes: scrollWidth omits the padding on the overflow side, so the first
				// reading can undershoot. The second pass measures what is actually left.
				var laps = new Array(n).fill(0), stacked = false;
				for (var pass = 0; pass < 2; pass++) {
					var over = strip.scrollWidth - strip.clientWidth;
					if (over <= 0) { break; }
					// Fill the gaps right to left, each to the cap, until the debt is paid.
					for (var g = n - 1; g > 0 && over > 0; g--) {
						var take = Math.min(cap - laps[g], over);
						if (take <= 0) { continue; }
						laps[g] += take;
						over -= take;
						stacked = true;
						kids[g].style.setProperty("--wl-chip-lap",
							(Math.ceil(laps[g] * 10) / 10) + "px");
					}
					if (over > 0) { break; }   // every gap is at the cap; nothing more to give
				}
				strip.classList.toggle("wlChipStackClass", stacked);
			}

			function fitLevelStrips() {
				var strips = accordion[0] ? accordion[0].querySelectorAll(".wlLevelStripClass") : [];
				for (var i = 0; i < strips.length; i++) { fitLevelStrip(strips[i]); }
			}

			// The measurement above is taken at reveal time, so a panel the user RESIZES afterwards
			// leaves the open section's verdict stale — the pill would keep a label that no longer
			// fits, or stay icon-only in a header that has since grown. Re-measure on width change.
			// Only the expanded header needs it: a collapsed one hides its pill and is measured
			// again the moment the pointer reveals it. The chip fans re-fit on the same signal —
			// they answer the same question about the same width.
			(function watchPanelWidth() {
				if (typeof ResizeObserver !== "function" || !accordion.length) { return; }
				var lastWidth = 0;
				new ResizeObserver(function (entries) {
					var w = Math.round(entries[0].contentRect.width);
					if (w === lastWidth) { return; }   // a height-only change is not our business
					lastWidth = w;
					var header = accordion.children(".wlExpanded").children(".wlHeaderClass");
					if (header.length) { updateHeaderTight(header); }
					fitLevelStrips();
				}).observe(accordion[0]);
			})();

			// (addOverflowTitle lived here until PR 7/7 of the tooltip engine: a native title=,
			// added and removed on every mouseenter, carrying the label's full text only while it
			// was actually clipped. It is one CLIP_TIP_CLASS on the label now — the engine's
			// `when:` gate asks the same question, on one delegated instance for the whole page.)

			function kindIcon(item) {
				if (item.kind === 'DEFAULT') { return "⭐"; }
				return "";
			}

			// When the header's Add pill is inert. Normally "the list is empty" — plus the one row
			// whose count is large and which still has nothing to add: the Topics row before a topic
			// has been picked. Its 8,784 words are eighteen lists' worth, and "Random 20 from
			// Topics" has no meaning until the user says WHICH topic. Disabled rather than hidden,
			// like every other empty list, so the row never reshuffles.
			//
			// …and every list while the GLOBAL filter is on. The menu's three actions all name the
			// whole list ("All 8000", "Random 20 of them"), so firing one under a filter showing a
			// single match would stage 20 words the user never searched for — the opposite of what
			// the surface in front of them says. Making it filter-aware instead was rejected: over
			// a handful of matches "Random 30" is meaningless and "All" is just the per-row add
			// repeated, and filter mode already switches selection and bulk actions off wholesale
			// (it is a finding surface, not a filing one — see .wlxFilterModeClass in
			// word-lists.css). Staging a found word stays exactly where it belongs: its own row's
			// add button, which keeps working. Owner call 2026-08-10.
			function addDisabledFor(item) {
				return !item.termCount || !!globalFilter || (isTopicKind(item.kind) && !openTopic);
			}

			// The Add pill's whole enabled/visible state, in ONE place — every path that can change
			// it (build, softRefresh, paintTopicRows) calls this, because it took three call sites to
			// notice that only two of them were being kept in step.
			//
			// Disabled ≠ hidden, and the difference is deliberate:
			//   • an EMPTY list is disabled but stays put — the affordance keeps its place so the row
			//     doesn't reshuffle the moment its first word lands;
			//   • the TOPICS row with no topic chosen is HIDDEN (owner call 2026-08-07). It is one row
			//     standing for eighteen lists, so with none picked "Add to the Practice tray" names no
			//     words at all — there is nothing for the affordance to hold a place for.
			// `visibility` rather than display, so the header's right-hand cluster keeps its geometry.
			function applyAddPillState(header, item) {
				var hide = isTopicKind(item.kind) && !openTopic;
				header.find(".wlAddPracticeClass")
					.prop("disabled", addDisabledFor(item))
					.css("visibility", hide ? "hidden" : "");
			}

			// Re-run the pill state across every rendered row — for the edges that change the ANSWER
			// without touching a single list (entering and leaving global filter mode), where there
			// is no per-list repaint to hang it off.
			function applyAddPillStateAll() {
				for (var i = 0; i < lists.length; i++) {
					var section = sectionEl(lists[i].id);
					if (section.length) { applyAddPillState(section.children(".wlHeaderClass"), lists[i]); }
				}
			}

			// ── My Garden's watering badge ──────────────────────────────────────────────────────
			// The one list row that answers TWO questions, so the answers are told apart by POSITION
			// rather than by colour alone: the count pill in the right-hand cluster says how many
			// words are in the list (as on every other list), and this one — beside the NAME — says
			// how many of them want something right now. It reads the server's own "Needs watering"
			// number (WordListSummary.wateringCount), the same figure the band header inside the open
			// list carries, so the two can never disagree.
			//
			// Two faces, never both. Overdue words: the day badge's own late-yellow (garden.css)
			// wearing the sprite droplet on its top-left shoulder — the corner the droplet already
			// takes on a plant — so this badge and the per-word "3 days late" badges on the rows
			// below it read as one signal at two scales. Nothing overdue: a small green dot instead.
			// Not a yellow zero, which still reads as a task, and not nothing at all — a garden with
			// nothing to water is worth saying quietly.
			//
			// The tooltip is wired ONCE here, off a live read of the badge's own data, because
			// assignTooltip binds fresh handlers per call and softRefresh repaints this on every
			// panel load.
			function buildGardenWaterBadge() {
				var slot = $("<span class='wlGardenWaterClass'></span>");
				slot.assignTooltip(function () {
					var n = slot.data("waterCount") || 0;
					return n ? strFormat(getRes("wlGardenNeedsWater_tooltip"), n)
						: getRes("wlGardenWatered_tooltip");
				});
				return slot;
			}

			function paintGardenWaterBadge(header, count) {
				var slot = header.children(".wlGardenWaterClass");
				if (!slot.length) { return; }   // not the garden row
				var n = count || 0;
				slot.data("waterCount", n).empty().toggleClass("wlGardenWaterCalmClass", !n);
				if (!n) {
					slot.append($("<span class='wlGardenWaterDotClass'></span>"));
					return;
				}
				// Three digits is the badge shape's designed ceiling. Past it the number has stopped
				// being actionable anyway, so it says "999+" rather than growing the row.
				slot.append(GARDEN.dropletSvg())
					.append($("<span class='gardenDaysBadge'></span>").text(n > 999 ? "999+" : n));
			}

			// ── Band lists' member sort (Alphabetical ⇄ By usage frequency) ────────────────────
			// docs/project/en-reband-plan.md point 2. ONE persisted selection across all band lists
			// (wlLevelSortMode); flipping it restreams the open list under the other order.
			//
			// An ICON on the list's own header, left of the Add pill — the shape the panel's own
			// sort control already uses (#wlSortBtnId). It was a text pill inside the open list's
			// toolbar until 2026-08-19, and that was wrong twice over (owner call): the label ate
			// most of a narrow panel's row, and sitting on the selection bar's line it read as part
			// of "0 selected", which it never was — the order is a property of the LIST, not of a
			// selection inside it.
			//
			// The icon states the order that is IN FORCE (a→z vs wide→narrow), not the one a click
			// would switch to: the control's first job is to answer "why is this list in this
			// order?", which is exactly what the vanished label used to say out loud.
			function levelSortIcon() {
				return plIcon(levelSortMode === "FREQ" ? "arrow-down-wide-narrow" : "arrow-down-a-z");
			}

			// The setting is global, so every band list's button is repainted, not just the one
			// clicked — the others are hidden (closed sections) but would otherwise come back
			// showing the previous order.
			function paintLevelSortBtns() {
				accordion.find(".wlLevelSortClass").html(levelSortIcon());
			}

			function buildLevelSortBtn(item, section) {
				var btn = $("<button class='pl-btn-icon-round wlLevelSortClass' type='button'></button>")
					.html(levelSortIcon());
				// With the label gone the tooltip carries it: the order in force FIRST, then what a
				// click does. Read live — one shared setting, flipped from whichever list is open.
				btn.assignTooltip(function () {
					return "<p>" + escHtml(getRes(levelSortMode === "FREQ"
						? "wlLevelSortFreq_label" : "wlLevelSortAlpha_label")) + "</p>"
						+ getRes("wlLevelSort_tooltip");
				});
				btn.click(function (e) {
					stopEvent(e);   // the header's own click toggles the section — this must not
					levelSortMode = levelSortMode === "FREQ" ? "ALPHA" : "FREQ";
					paintLevelSortBtns();
					ajaxPost("wordlist-level-sort", { sort: levelSortMode }, function () {});
					// `smooth`: the rows already on screen STAY until the re-sorted first page
					// lands, then swap in one frame (pendingReset, consumed in loadLevelPage).
					// Without it the words box emptied on the click and refilled a round trip
					// later — the open section collapsed to its header and sprang back, which
					// reads as the list closing and reopening rather than as a re-sort
					// (owner report 2026-08-19). Same treatment a filter keystroke already got.
					if (section.hasClass("wlExpanded")) { loadLevelWords(item, true); }
				});
				return btn;
			}

			function buildSection(item) {
				var isVirtual = isVirtualKind(item.kind);
				// data-wl-kind so header-level painters (paintAddPill) can branch on the kind
				// without threading the item through — they are handed a header, not an item.
				var section = $("<div class='wlSectionClass wlDraggableClass'></div>")
					.attr("data-wl-id", item.id).attr("data-wl-kind", item.kind);
				// wlLevelClass is the VIRTUAL-list styling hook, not a LEVEL_*-only one — the
				// downstream reads of it (empty-state suppression, copy-only rows) want every
				// dictionary-backed list. Kept under its original name so the CSS is untouched.
				if (isVirtual) { section.addClass("wlLevelClass"); }   // tinted, read-only, pages from the dictionary

				var header = $("<div class='wlHeaderClass' tabindex='86'></div>");
				// data-name mirrors the visible text for the Garden row's bold-reservation ghost
				// (word-lists.css, attr(data-name)) — harmless on every other row, which doesn't
				// read it.
				var nameSpan = $("<span class='wlNameClass'></span>");
				paintListName(nameSpan, item);   // the CEFR name + code stack, or the plain label
				// A dictionary level explains itself ON ITS NAME (below), and that tooltip already
				// carries the full text when the name is clipped — a second, clipped-text tooltip
				// on the same element would stack two explanations on one hover.
				// …and the Topics row does the same, for the same reason — its name is whichever
				// topic is open, which is the longest text any list row carries.
				if (!isLevelKind(item.kind) && !isTopicKind(item.kind)) {
					nameSpan.addClass(CLIP_TIP_CLASS);
				}
				if (isVirtual) {
					// Virtual lists: an icon + the name ride inside a uniform-width rounded pill
					// (these lists ARE the dictionary; the pill sets them apart as a group without
					// tinting the whole row). What "Verbs" or "My Garden" contains lives in the
					// icon's tooltip, not on the row.
					var isGarden = item.kind === 'GARDEN';
					var isLevel  = isLevelKind(item.kind);
					var isTopics = isTopicKind(item.kind);
					// The garden's mark is an <img>, not a glyph, so its slot carries an extra class:
					// an image has no font box to ride and the slot has to state its own figures.
					var levelIcon = $("<span class='wlKindIconClass wlLevelIconClass"
						+ (isGarden ? " wlKindImgIconClass" : "") + "'>"
						+ kindGlyph(item.kind) + "</span>");
					if (isTopics) {
						// The row's name is the OPEN topic, so the tooltip has two jobs: say what this row
						// is (the name alone no longer does, once it reads "Travel & Transport"), and
						// resolve the name when the panel has clipped it. Read live — the name changes
						// under this element every time a topic is picked.
						levelIcon.assignTooltip("wlTopics_tooltip");
						nameSpan.assignTooltip(function () {
							var tip = getRes("wlTopics_tooltip");
							var el = nameSpan[0];
							return el.scrollWidth > el.clientWidth ? nameSpan.text() + " · " + tip : tip;
						});
					} else if (isLevel) {
						// The name + code stack itself is painted above (paintListName — one painter
						// for this build and for softRefresh, which used to wipe it).
						// A level's ~CEFR description moved from the 📖 onto the NAME, which frees
						// the icon to carry the one thing the row cannot show: that these five fold
						// into a single strip, and where the switch for that is. The name is clipped
						// to the pill's fixed width, so when it IS clipped the tooltip leads with the
						// full name — otherwise "Элемента…" never resolves anywhere.
						nameSpan.assignTooltip(function () {
							var tip = getRes("wlLevel" + levelCode(item.kind) + "_tooltip");
							var el = nameSpan[0];
							return el.scrollWidth > el.clientWidth ? levelFullName(item) + " · " + tip : tip;
						});
						// …and the 📖 is also the switch: double-click it to fold the five rows into
						// one strip of chips, double-click the strip's 📖 to bring them back.
						var levelGroup = compactGroupOf(item.kind);
						bindRowFold(levelIcon, levelGroup, item);
						levelIcon.assignTooltip(levelGroup.rowTip);
					} else if (isGarden) {
						// The flower is a DOOR, not decoration: it opens the same whole-garden vista
						// My Progress's Garden button opens. The row header still toggles the list —
						// the two answer different questions ("what is in it" vs "what does it look
						// like"), so the icon swallows its own click rather than doing both.
						levelIcon.addClass("wlGardenDoorClass").attr("role", "button")
							.assignTooltip("wlGarden_tooltip");
						levelIcon.click(function (e) { stopEvent(e); GARDEN_BED.openVista(); });
					} else {
						// A verb list's icon says which of the two card types it drills — the one
						// thing its name alone cannot, since both names are about "forms" — and,
						// where the language has BOTH lists, doubles as their fold switch. On a
						// language with only one of them (English) neither the gesture nor the
						// sentence about it appears: a group of one never folds.
						var verbGroup = compactGroupOf(item.kind);
						bindRowFold(levelIcon, verbGroup, item);
						levelIcon.assignTooltip(function () {
							var base = "<p>" + getRes(item.kind === 'CONJUGATION'
								? "wlConjugation_tooltip" : "wlVerbs_tooltip") + "</p>";
							return groupFolds(verbGroup)
								? base + getRes(verbGroup.rowTip) : base;
						});
					}
					header.append($("<span class='wlLevelPillClass'></span>").append(levelIcon).append(nameSpan));
					if (isGarden) {
						header.append(buildGardenWaterBadge());
						paintGardenWaterBadge(header, item.wateringCount);
					}
				} else {
					header.append($("<span class='wlChevronClass'>" + plIcon("chevron-right") + "</span>"));
					var icon = kindIcon(item);
					if (icon) { header.append($("<span class='wlKindIconClass'></span>").text(icon)); }
					header.append(nameSpan);
				}

				var actions = $("<span class='wlHeaderActionsClass'></span>");
				if (item.kind === 'USER' || item.kind === 'DEFAULT') {
					var renameBtn = $("<button class='pl-btn-icon-round' type='button'>" + plIcon("pencil") + "</button>");
					renameBtn.assignTooltip("wlRename_tooltip");
					renameBtn.click(function (e) { stopEvent(e); startRename(section, item); });
					actions.append(renameBtn);
				}
				if (item.kind === 'USER') {
					var deleteBtn = $("<button class='pl-btn-icon-round' type='button'>" + plIcon("x") + "</button>");
					deleteBtn.assignTooltip("wlDelete_tooltip");
					deleteBtn.click(function (e) { stopEvent(e); deleteList(item); });
					actions.append(deleteBtn);
				}
				header.append(actions);

				// The member-sort switch rides the header of a band list, immediately left of the
				// Add pill. Shown only while the section is OPEN (CSS): an order is a claim about
				// words on screen, and a closed row has none.
				if (isLevelKind(item.kind)) { header.append(buildLevelSortBtn(item, section)); }

				// The list's raison d'être, revealed on the name row: an "Add ▸" pill that opens the
				// All / Selected / Random menu on hover or click. Its face is contextual — the
				// destination plant mark (sprout = Learning, watering can = Practice) + matching label — painted here and
				// repainted on every reveal (updateHeaderTight), so a tab switch needs no resync.
				// No tooltip: hover opens the menu right where a tooltip would sit, and the label says it.
				//
				// My Garden skips it: with no All or Random (see the isGarden branch inside
				// openAddMenu), the row-level menu was just an almost-always-disabled "Selected"
				// plus a note redirecting to each section's own header (owner report 2026-08-07,
				// "it's useless anyway") — every other list still gets the pill.
				if (!isGarden) {
					var addBtn = $("<button class='pl-btn-pill wlAddPracticeClass' type='button'></button>");
					// A list holding no words has nothing to add. DISABLED (greyed, inert — the shared
					// .pl-btn-pill:disabled face), not hidden: the affordance keeps its place so the row
					// doesn't reshuffle the moment the first word lands. A disabled button receives no
					// pointer events at all, so the hover-intent machine below never fires either — which
					// is the point: the menu used to open on an empty list and answer every choice with
					// "No words here yet". softRefresh re-applies this as counts move.
					addBtn.click(function (e) {
						stopEvent(e);
						addBtn.data("addMenuMachine").toggle();
					});
					wireAddMenuHover(addBtn, section, item);
					header.append(addBtn);
					applyAddPillState(header, item);   // must follow the append — it queries the header
				}
				var countPill = $("<span class='pl-count-pill'></span>").text(item.termCount);
				countPill.assignTooltip("wlWordCount_tooltip");
				header.append(countPill);

				// Phase 2: level lists expand like any other — the browsable answer to "what do
				// Advanced words actually look like?". Their words lazy-load in pages (endless
				// scroll straight off the dictionary); the menu opens only via its button now.
				// D11: size the pill's label to the space the hover reveal leaves. Keep the
				// tight state while the pill remains visible without the pointer: expanded
				// section OR its menu open (pointer wandering into the menu fires mouseleave,
				// but wlAddOpenClass pins the pill shown — dropping tight would re-crowd).
				header.on("mouseenter", function () { updateHeaderTight(header); });
				header.on("mouseleave", function () {
					if (!header.closest(".wlExpanded").length && !header.find(".wlAddOpenClass").length) {
						header.removeClass("wlTightClass");
					}
				});

				// The Topics row is a LAUNCHER, not a section that opens onto its own content: with
				// eighteen lists behind it, "open" is meaningless until one of them is named. So a
				// CLOSED row's header opens the picker instead of toggling, exactly as a level CHIP
				// does on the compact strip.
				//
				// Once a topic IS open the row is an ordinary open list, and its header does what
				// every other open header does: collapse it, back to the single "🗂️ Topics" band.
				// That replaced a dedicated × in the hover actions — the header is the target the
				// hand is already on, and a row that opens one way and closes another was the odd
				// one out in the panel. Re-picking the open topic in the picker still closes it too.
				function activateHeader() {
					// In global-filter mode every header is a plain open/close of its matches —
					// including Topics, whose matches span all eighteen lists at once, so the
					// picker has nothing to decide.
					if (globalFilter) { toggleSection(item.id); return; }
					if (!isTopicKind(item.kind)) { toggleSection(item.id); }
					else if (openTopic && section.hasClass("wlExpanded")) { collapseSection(); }
					else { toggleTopicPicker(item, header); }
				}
				header.click(function () {
					if (dragging) { return; }   // the click that ends a drag must not toggle
					activateHeader();
				});
				header.keydown(function (e) {
					// A key pressed on one of the header's own BUTTONS belongs to that button: the
					// native click it fires is already stopped by their handlers, but the keydown
					// itself still bubbles here — so Enter on ✎ / Add / the sort switch used to do
					// the button's job AND collapse the row out from under it.
					if ($(e.target).closest("button").length) { return; }
					if (e.which == PL.keys.ENTER || e.which == PL.keys.SPACE) {
						activateHeader();
						e.preventDefault();
					}
				});

				var body = $("<div class='wlBodyClass'></div>");

				var toolbar = $("<div class='wlToolbarClass'></div>");
				var checkAll = $("<input type='checkbox' class='wlCheckAllClass'/>");
				checkAll.assignTooltip("wlCheckAll_tooltip");
				checkAll.change(function () {
					var boolState = $(this).is(":checked");
					body.find(".wlRowCheckClass").prop("checked", boolState)
						.closest(".wlWordRowClass").toggleClass("wlRowCheckedClass", boolState);
					lastCheckedIdx = null;
					updateSelBar(section);
				});
				toolbar.append(checkAll);
				// The contextual selection bar lives on the SAME row, to the right of the select-all
				// checkbox (only visible while something is checked); the checkbox stays left-aligned
				// with the row checkboxes below.
				toolbar.append(buildSelBar(section, item));

				body.append(toolbar);
				var words = $("<div class='wlWordsClass'></div>");
				body.append(words);
				// The open list's words are their own scrolling surface (max-height + endless
				// scroll), so they get the page up/down bars too. Attached HERE because this is
				// the one place the element is minted: its contents are emptied and re-rendered
				// on every sort/filter/page, but the element itself — and so its pager — lives
				// as long as the section does.
				SCROLL_PAGER.attach(words[0]);

				section.append(header).append(body);
				// AFTER the header joins the section, never before: paintAddPill reads the kind
				// off the section via closest(), and a detached header finds nothing — which
				// silently left the Verbs pill live on the landing tab until some later repaint
				// (hover, tab switch) happened to fix it.
				paintAddPill(header);
				return section;
			}

			// ── Compact built-in lists ───────────────────────────────────────────────────────────
			// A GROUP of system rows drawn as ONE row of chips. Two groups fold: the five LEVEL_*
			// rows into 📖 A B C D E, and the two verb rows into their own strip. Default OFF, and
			// deliberately: a new user's Garden, My List and own lists are all empty, so the
			// built-in lists are the only ready source of words there is and they earn the space.
			// Once the user has words of their own those rows are mostly in the way — this hands
			// five rows of a nine-row panel back. Which is why it is a switch the user throws and
			// not something the app decides for them.
			//
			// ONE SWITCH PER GROUP since 2026-08-18 (user attrs compactLevelLists and
			// compactVerbLists). It was a single switch for both, and the two groups turned out to
			// be different kinds of useful: five frequency bands are a lot of panel and are picked
			// from rarely, while a DE learner's two verb lists are worked in daily. The first
			// attribute's stored name still says "level" because renaming it would migrate user_attr
			// rows, the JS global and the Thymeleaf model attribute for no behaviour change.
			//
			// TWO WAYS TO THROW EITHER: the checkbox in account menu ▸ Settings ▸ Word list
			// settings, and a DOUBLE-CLICK on the group's kind icon — on a row to fold, on the strip
			// to unfold. The icon is where the reader is already looking when the rows are in the
			// way, and it works in both directions from the same place; the menu stays because a
			// gesture nobody has been told about is not a control. Both routes go through
			// throwCompactSwitch, so both persist and both keep the checkbox honest.
			//
			// The verb strip is its OWN line, not merged into the level one: the level chips are
			// single letters and the verb chips are icons, and one strip carrying two chip
			// vocabularies would break a row that is deliberately uniform.
			//
			// Purely a RENDER choice: every section is still built and still sits in the accordion,
			// the ones that are not open are merely hidden. That matters — a drag persists the DOM
			// order of every .wlSectionClass, and leaving the hidden ones out would post an order
			// missing those ids, which the server reads as "unknown, put them last" and would fling
			// the whole group to the bottom of the panel.

			// The two groups, each described once: how to recognise its rows, which global and user
			// attribute carry its switch, the leading icon on its strip, what a chip shows, and the
			// tooltips. Everything else is shared.
			var COMPACT_GROUPS = [
				{ cls: "wlLevelStripClass",
				  member: isLevelKind,
				  global: "compact_level_lists",
				  attr: "compactLevelLists",
				  icon: "&#128214;",
				  iconTip: "wlLevelExpandHint_tooltip",
				  rowTip: "wlLevelCompactHint_tooltip",
				  countTip: "wlLevelStripCount_tooltip",
				  // The chip face is the band's short code. "C2P" is the enum-safe spelling of
				  // the C2+ bucket (a "+" cannot live in an enum name or a resource key), so the
				  // display restores the plus; every other code IS its own face (A..E, A1..C1).
				  chipHtml: function (item) { return escHtml(levelCode(item.kind).replace("C2P", "C2+")); },
				  // …and the chip's tooltip LEADS with the plain-language name, because the code is
				  // already under the cursor on the chip itself — repeating it there would spend the
				  // first word of the hover on the one thing the reader can see. Falls back to the
				  // row name for the A..E scheme, whose label is a word to begin with.
				  chipName: function (item) {
					  return levelPlainName(levelCode(item.kind)) || displayName(item);
				  } },
				{ cls: "wlVerbStripClass",
				  member: isVerbKind,
				  global: "compact_verb_lists",
				  attr: "compactVerbLists",
				  icon: "&#128221;",
				  iconTip: "wlVerbExpandHint_tooltip",
				  rowTip: "wlVerbCompactHint_tooltip",
				  countTip: "wlVerbStripCount_tooltip",
				  chipHtml: function (item) { return kindGlyph(item.kind); } }
			];

			// The guided walk's latch — see plWlPanel.setCompact. Non-null exactly while the walk
			// holds the panel unfolded and owes it a refold; it holds one flag per COMPACT_GROUPS
			// entry, in that order.
			var walkFold = null;

			function compactGroupOf(kind) {
				for (var i = 0; i < COMPACT_GROUPS.length; i++) {
					if (COMPACT_GROUPS[i].member(kind)) { return COMPACT_GROUPS[i]; }
				}
				return null;
			}

			function compactOn(group) {
				return !!window[group.global];
			}

			// The MODEL's count, not the DOM's: this is asked while building a row, before the
			// sections exist. A group of ONE never folds (see applyCompactLists), so neither the
			// double-click nor the Settings switch is offered for it — English has just the one
			// form-set list, and replacing one row with one chip-strip row saves nothing and costs
			// the name.
			function groupFolds(group) {
				var n = 0;
				$.each(lists, function (_, item) { if (group.member(item.kind)) { n++; } });
				return n >= 2;
			}

			// How long the icon holds a single click before letting it through — see bindRowFold.
			// Long enough for a second press to arrive, short enough that opening a list by its icon
			// still reads as a press rather than a wait.
			var COMPACT_DBL_MS = 250;

			// A built-in row's kind icon does BOTH jobs: a single click still opens the row, exactly
			// as it always did (the icon sits inside the header, and the header toggles), and a
			// double click folds the whole group behind its strip.
			//
			// They cannot both ride the header's own handler: a double click would open the row and
			// close it again on the way to folding it — a flicker plus a wasted words fetch. So the
			// icon swallows the header click and re-issues the toggle after COMPACT_DBL_MS, which a
			// second press cancels. ONLY the icon pays that delay; the name and the rest of the row
			// are untouched, so the ordinary way of opening a list is exactly as immediate as before.
			//
			// A group of ONE is not offered the gesture at all (applyCompactLists would refuse to
			// fold it), which is why this returns without binding anything — an English verb row's
			// icon keeps its plain single-click behaviour and says nothing about folding.
			function bindRowFold(icon, group, item) {
				if (!group || !groupFolds(group)) { return; }
				var pending = null;
				icon.addClass("wlCompactTogglerClass");
				icon.click(function (e) {
					stopEvent(e);
					if (dragging) { return; }   // the click that ends a drag must not toggle
					clearTimeout(pending);
					pending = setTimeout(function () {
						pending = null;
						toggleSection(item.id);
					}, COMPACT_DBL_MS);
				});
				icon.on("dblclick", function (e) {
					stopEvent(e);
					clearTimeout(pending);
					pending = null;
					throwCompactSwitch(group, true);
				});
			}

			// The icon's half of "the user threw the switch": write the global, persist it, and fire
			// the one event both ends listen to — the panel below redraws, and the account menu's
			// checkbox re-reads the global so it can never disagree with what is on screen. The
			// Settings checkbox does exactly this from login_main.js, which is why there is one
			// event and not two.
			function throwCompactSwitch(group, on) {
				if (compactOn(group) === !!on) { return; }
				window[group.global] = !!on;
				ajaxPostUserAttr(group.attr, !!on);
				$(document).trigger("pl:compactLists");
			}

			// A folded group is ONE row on screen, so it has to be one BLOCK in the panel: the strip
			// stands where the group's first list stands and the rest follow immediately, whatever
			// order the persisted positions happen to be in. Without this, a group whose lists sit
			// apart — a list added after the user last dragged takes its kind's default slot, not its
			// sibling's — drew the strip at one member while the OPEN member's words appeared several
			// rows further down, with nothing on screen saying the two belonged together. It is also
			// what makes dragging a strip mean anything: the thing being moved is the group, and a
			// group has to be contiguous to move as one.
			//
			// Applied to the MODEL, before render builds from it — softRefresh compares the DOM against
			// `lists`, so reordering the DOM behind its back would force a full re-render on every
			// refresh. Not persisted: a drag is what writes an order down, and this runs on every render.
			function groupCompactLists() {
				$.each(COMPACT_GROUPS, function (_, group) {
					if (!compactOn(group)) { return; }
					var members = [];
					var others = [];
					var at = -1;
					$.each(lists, function (_i, item) {
						if (!group.member(item.kind)) { others.push(item); return; }
						if (at < 0) { at = others.length; }   // the group takes its FIRST member's slot
						members.push(item);
					});
					if (members.length < 2) { return; }   // a group of one never folds — see applyCompactLists
					others.splice.apply(others, [at, 0].concat(members));
					lists = others;
				});
			}

			function groupSections(group) {
				return accordion.children(".wlSectionClass").filter(function () {
					return group.member(this.getAttribute("data-wl-kind"));
				});
			}

			// One chip per row of the group. Its box is at its FINAL size at rest — fixed width (A…E
			// are not the same glyph width, and neither are two emoji), a transparent border already
			// reserved, a weight that never changes — so hover and open-state can only repaint
			// background and colour. Nothing in a strip may move under the pointer: at chip size, a
			// pixel of shift reads as a misclick waiting to happen.
			function buildStrip(group) {
				var strip = $("<div class='wlLevelStripClass'></div>").addClass(group.cls);
				var icon = $("<span class='wlKindIconClass wlLevelIconClass'>" + group.icon + "</span>");
				// The way back out, from the same glyph that folded them: double-click unfolds the
				// group. Single clicks do nothing here (the strip has no row to open), so unlike the
				// row icons this needs no click arbitration at all.
				icon.addClass("wlCompactTogglerClass").attr("role", "button");
				icon.assignTooltip(group.iconTip);
				icon.on("dblclick", function (e) {
					stopEvent(e);
					throwCompactSwitch(group, false);
				});
				strip.append(icon);

				var chips = $("<span class='wlLevelChipsClass'></span>");
				$.each(lists, function (_, item) {
					if (!group.member(item.kind)) { return; }
					var chip = $("<button class='wlLevelChipClass' type='button'></button>")
						.attr("data-wl-id", item.id)
						.html(group.chipHtml(item));
					// The names are what a strip trades away, so hovering a chip gives one back —
					// with its size, which is the other thing the folded rows used to show.
					// Resolved by id at hover time, not closed over: a soft refresh swaps `lists`
					// for a fresh array without rebuilding the strip.
					chip.assignTooltip(function () {
						var live = listById(item.id) || item;
						var name = group.chipName ? group.chipName(live) : displayName(live);
						return name + " · " + (live.termCount || 0);
					});
					chip.click(function (e) {
						stopEvent(e);
						if (dragging) { return; }   // the click that ends a strip drag must not toggle
						toggleSection(item.id);
					});
					chips.append(chip);
				});
				strip.append(chips);

				// The group's counts summed, in the same right-rail slot every other row's count
				// pill takes — so the column still lines up, and on the levels the number happens to
				// answer "how big is the dictionary for this pair".
				var countPill = $("<span class='pl-count-pill'></span>").text(groupTotal(group));
				countPill.assignTooltip(group.countTip);
				strip.append(countPill);
				return strip;
			}

			function groupTotal(group) {
				var total = 0;
				$.each(lists, function (_, item) {
					if (group.member(item.kind)) { total += item.termCount || 0; }
				});
				return total;
			}

			// A strip's one mutable part, for callers that must not pay for a rebuild. The count is
			// also the widest thing on the strip that can CHANGE width (999 → 35732 is ~30px), and
			// the chips' room is whatever it leaves — so re-fit the fan after writing it.
			function repaintStripTotal() {
				$.each(COMPACT_GROUPS, function (_, group) {
					accordion.children("." + group.cls).children(".pl-count-pill")
						.text(groupTotal(group));
				});
				fitLevelStrips();
			}

			// Rebuild the strips and re-hide/reveal the sections behind them. Idempotent and cheap
			// (a handful of rows), so every caller just runs it rather than reasoning about what
			// changed. The open row keeps its whole section — header, toolbar, words, endless scroll
			// — exactly as it looks with the setting off; only its collapsed siblings go away.
			//
			// A group of ONE never folds: English has just the form-set list, and replacing one row
			// with one chip-strip row saves nothing and costs the name.
			function applyCompactLists() {
				$.each(COMPACT_GROUPS, function (_, group) {
					accordion.children("." + group.cls).remove();
					var sections = groupSections(group);
					sections.removeClass("wlCompactHiddenClass");
					if (!compactOn(group) || sections.length < 2) { return; }
					var strip = buildStrip(group);
					sections.first().before(strip);   // the strip stands where the first row stood…
					strip.after(sections);            // …and the group closes up behind it (moved, not
					                                  // rebuilt, so an open list keeps its loaded words)
					sections.each(function () {
						var open = expandedId != null
							&& String(this.getAttribute("data-wl-id")) === String(expandedId);
						$(this).toggleClass("wlCompactHiddenClass", !open);
						if (open) {
							strip.find(".wlLevelChipClass[data-wl-id='" + expandedId + "']")
								.addClass("wlLevelChipOpenClass");
						}
					});
				});
				// A strip that has just been built has never been fitted, and the panel's
				// ResizeObserver only speaks on a WIDTH change — which a rebuild is not. Without
				// this the fan opens flat every time the setting is toggled or the pair reloads.
				fitLevelStrips();
			}

			// Either switch moved — the Settings checkbox or a double-click on a group's kind icon;
			// both write the global first and then fire this. Only the strips are rebuilt — no
			// re-render, so an open list keeps its loaded words and its scroll position and simply
			// changes which shape it is sitting in. The model is regrouped first so the panel and
			// `lists` still agree on the order (softRefresh checks that they do).
			$(document).on("pl:compactLists", function () {
				groupCompactLists();
				applyCompactLists();
			});

			// ── 🗂️ Topics: eighteen lists behind one row ─────────────────────────────────────────
			// The dictionary sliced by SITUATION rather than by frequency (docs/project/topic-word-
			// lists.md). Eighteen long names do not compact to a chip strip the way A–E do, and
			// eighteen panel rows would swallow the panel — so the row is a launcher and the picker
			// is where the choice happens. Everything BELOW the choice is the existing list-section
			// machinery unchanged: the section, its toolbar, the filter box, endless scroll, the
			// selection bar and the ⇄ copy-out that makes "select all → my own Travel list" work.

			// The pair's topics + counts, fetched once and reused: the taxonomy does not move while
			// the user is looking at it, and both the picker and the row's crumb read the same array
			// (so the badge on the row can never be a different topic's than the picker showed).
			// Dropped by reload(), which is what a language change runs through.
			function ensureTopicCounts(onReady) {
				if (topicCounts) { onReady(); return; }
				ajaxPost("wordlist-topic-counts", {
						termLang: langToValField.attr("data-lang-code"),
						defLang: langFromValField.attr("data-lang-code")
					},
					function (data) {
						topicCounts = (data && data.topics) || [];
						onReady();
					},
					getRes("wlLoad_error_message") + " [topics]");
			}

			// The Topics row's three mutable parts: the name (the open topic, or "Topics" when closed —
			// see displayName), the count pill, and the Add pill, which is inert until a topic IS open.
			// Repainted on every edge that moves any of them. Cheap and idempotent, so callers just run
			// it; a no-op on every row but this one.
			//
			// The count follows the NAME: closed, the row stands for the whole tagged dictionary and
			// says so (8,784); open, it IS one list and must say how big THAT list is (849 for Travel),
			// like every other expanded row's pill. The per-topic number comes from the picker's counts,
			// so the two can never disagree — and until they have been fetched (a boot-restored topic)
			// the row keeps its total rather than flashing a zero.
			function paintTopicRows() {
				accordion.children(".wlSectionClass[data-wl-kind='TOPIC']").each(function () {
					var section = $(this);
					var header = section.children(".wlHeaderClass");
					var item = listById(section.attr("data-wl-id"));
					var isOpen = !!openTopic && section.hasClass("wlExpanded");
					header.find(".wlNameClass").text(isOpen ? topicName(openTopic) : getRes("wlTopics_label"));
					if (item) { applyAddPillState(header, item); }   // hidden until a topic is chosen
					var count = item ? item.termCount : 0;
					if (isOpen) {
						for (var i = 0; topicCounts && i < topicCounts.length; i++) {
							if (topicCounts[i].key === openTopic) { count = topicCounts[i].count; break; }
						}
					}
					header.find(".pl-count-pill").text(count);
				});
			}

			function closeTopicPicker() {
				if (topicLayer) { topicLayer.close(); }   // teardown lives in the layer's onClose
			}

			function toggleTopicPicker(item, anchor) {
				if (topicPopEl) { closeTopicPicker(); return; }
				hidePopover();
				closeAddMenu();
				closeSortMenu();
				closeBasket();
				ensureTopicCounts(function () {
					// The row only exists for a pair that HAS tags, so an empty answer means the
					// pair changed under an open panel. Say so rather than opening an empty grid.
					if (!topicCounts.length) { showMessage(getRes("wlTopicsEmpty_message")); return; }
					openTopicPicker(item, anchor);
				});
			}

			function openTopicPicker(item, anchor) {
				// The counts fetch is async, so two fast clicks can both reach here before either
				// popover exists. Close whatever is standing rather than orphaning it.
				closeTopicPicker();
				topicPopEl = $("<div class='wlPopoverClass wlTopicPickClass'></div>");
				topicPopEl.append($("<div class='wlAddMenuHeadClass'></div>").text(getRes("wlTopicsPick_label")));
				// Two columns filled TOP-DOWN, not left-right: the list is alphabetical by the
				// localized name, and an alphabet that snakes across two columns cannot be scanned.
				// The row count is computed rather than fixed because a language's coverage decides
				// how many topics there are to show (a topic with no words is not offered at all).
				var sorted = topicCounts.slice().sort(function (a, b) {
					return topicName(a.key).localeCompare(topicName(b.key));
				});
				var grid = $("<div class='wlTopicGridClass'></div>")
					.css("grid-template-rows", "repeat(" + Math.ceil(sorted.length / 2) + ", auto)");
				$.each(sorted, function (_, t) {
					var cell = $("<button class='wlTopicCellClass' type='button'></button>")
						.toggleClass("wlTopicCellOpenClass", t.key === openTopic);
					cell.append($("<span class='wlTopicBadgeClass'></span>").text(t.badge));
					cell.append($("<span class='wlTopicNameClass " + CLIP_TIP_CLASS + "'></span>")
						.text(topicName(t.key)));
					cell.append($("<span class='pl-count-pill'></span>").text(t.count));
					cell.click(function (e) {
						stopEvent(e);
						closeTopicPicker();
						pickTopic(item, t.key);
					});
					grid.append(cell);
				});
				topicPopEl.append(grid);

				$("body").append(topicPopEl);
				positionPopup(topicPopEl, anchor);
				topicPopEl.click(function (e) { e.stopPropagation(); });
				topicLayer = PL.layers.push({
					el: topicPopEl[0],
					anchors: [anchor[0]],
					onClose: function () {
						topicLayer = null;
						if (topicPopEl) {
							topicPopEl.remove();
							topicPopEl = null;
						}
					}
				});
			}

			// Picking the OPEN topic closes it — the picker's cells toggle, exactly like the level
			// chips they stand in for, so the row has a way back to "nothing open" without needing a
			// second gesture on a header that opens the picker.
			function pickTopic(item, key) {
				if (openTopic === key && expandedId == item.id) {
					collapseSection();
					return;
				}
				openTopic = key;
				expandSection(item.id);
			}

			// One page of a topic, keyed by rank rather than alphabetically — so the cursor carries a
			// third component (see the endpoint's javadoc). Shares levelScroll: only one section is
			// ever open, and every other virtual list already streams through it.
			function loadTopicWords(item, smooth) {
				if (!openTopic) {
					// The row is expanded with no topic chosen — only reachable from a stale
					// persisted value. Show the picker rather than an empty section.
					renderWords(sectionEl(item.id), []);
					return;
				}
				// Per-list filter, client-side — same arrangement as loadLevelWords.
				var tpTyped = sectionFilter(sectionEl(item.id));
				var tpSrc = tpTyped ? filterSourceRows(item) : null;
				if (tpSrc) {
					startLocalWordStream(item, wlxMatch(tpSrc, tpTyped));
					return;
				}
				levelScroll = {
					listId: item.id,
					url: "wordlist-topic-words",
					params: { topic: openTopic },
					filter: sectionFilter(sectionEl(item.id)),
					pendingReset: !!smooth,
					lastRank: 0, lastTerm: "", lastId: 0, atEnd: false, loading: false };
				gardenScroll = null;
				var section = sectionEl(item.id);
				if (!smooth) { renderWords(section, []); }
				var wordsEl = section.find(".wlWordsClass");
				wordsEl.off("scroll.wlLevel scroll.wlGarden").on("scroll.wlLevel", function () {
					if (this.scrollTop + this.clientHeight >= this.scrollHeight - 150) {
						loadLevelPage(item);
					}
				});
				loadLevelPage(item);
			}

			// ── The "Phrases I typed" band: MY LIST's tail (phrase-search redesign 2026-08-10) ──
			// The record of the user's own typed, gate-accepted phrases (term_capture). NOT a list:
			// things arrive only by typing, leave only by the row's × (which erases the RECORD —
			// memberships and drill state live in their own tables and are untouched). Folded by
			// default to a single header row; hidden entirely at zero. One fetch, no paging — a
			// user's typed phrases number in the tens; if the 200 cap ever bites, the pill still
			// tells the truth because it carries the server's total, not the row count.
			function renderTypedBand(item, section) {
				ajaxPost("wordlist-myphrases-words",
					{ termLang: langToValField.attr("data-lang-code"), filter: "",
					  lastCapturedTs: 0, lastId: 0, limit: 200 }, function (data) {
					if (expandedId != item.id) { return; }   // the user has moved on — stale
					var words = (data && data.words) || [];
					section.find(".wlTypedBandClass").remove();   // re-render safety
					if (!words.length) { return; }                // hidden when empty
					var box = $("<div class='wlGardenSecClass wlTypedBandClass wlGardenSecFoldedClass'></div>")
						.attr("data-gsec", "typed");
					var head = $("<div class='wlGardenSecHeadClass'></div>");
					head.append($("<span class='wlGardenSecTitleClass'></span>")
						.text(getRes("wlTypedPhrases_label")));
					head.append($("<span class='pl-count-pill'></span>").text(data.total || words.length));
					head.assignTooltip("wlTypedPhrases_tooltip");
					head.click(function () { box.toggleClass("wlGardenSecFoldedClass"); });
					box.append($("<div class='wlGardenSecStickyClass plStickyHeadClass'></div>").append(head));
					var rows = $("<div class='wlGardenSecRowsClass'></div>");
					box.append(rows);
					section.find(".wlWordsClass").append(box);
					appendWords(section, words, rows);
				}, getRes("wlCannotLoadWords_error_message"));
			}

			// ── "Add to Practice ▸" menu ─────────────────────────────────────────────────────────
			// One floating menu at a time, on the Phase 4 chassis (step 3b): a PL.hover
			// intent machine per button owns the legacy timings (150ms open intent, 600ms
			// close grace; the open menu feeds the SAME machine so button→menu pointer
			// travel survives), and PL.layers owns dismissal (outside pointerdown +
			// consumed Esc — suspended while a count edit is in flight).
			var RANDOM_COUNTS = [5, 10, 15, 20, 30];
			var addMenuEl = null;        // the open menu, when shown
			var addMenuFor = null;       // the button it belongs to (toggle/no-reopen bookkeeping)
			var addMenuLayer = null;     // PL.layers handle while open
			var addMenuEditing = false;  // a count field has focus: suspend auto-close (see buildCountItems)

			function closeAddMenu() {
				addMenuEditing = false;
				if (addMenuLayer) {
					addMenuLayer.close();//teardown lives in the layer's onClose
				}
			}

			// The onboarding glow guide's cue may be OPEN over one of this menu's items
			// (the Random row, the count arrow). While it shows, hover-away close is
			// suspended on both machines below: the pointer legitimately leaves the menu
			// to read/press the cue, and the menu collapsing under it mid-walk would
			// strand the guide. Outside-press dismissal is separately covered — the cue
			// box rides the layer's anchors (finishAddMenu).
			function guideCueHolds() {
				return !!(window.OB_GUIDE && OB_GUIDE.cueInMenuLive());
			}

			function wireAddMenuHover(btn, section, item) {
				// Click-toggle goes through the machine too: toggle() cancels a pending
				// hover-open timer — the 3d-tour click-vs-hover race, fixed in the chassis.
				var machine = PL.hover.intent({
					openDelay: 150,
					closeDelay: 600,
					open: function () { openAddMenu(btn, section, item); },
					close: closeAddMenu,
					isOpen: function () { return !!addMenuEl && addMenuFor === btn[0]; },
					suspended: function () { return addMenuEditing || guideCueHolds(); }
				});
				machine.bind(btn[0]);
				btn.data("addMenuMachine", machine);
			}

			function addMenuItem(label) {
				return $("<div class='wlPopoverItemClass'></div>").text(label);
			}

			// The ids of a pick the client can PROVE it holds whole — or null, meaning "we do not
			// know which words these are". Feeds trayDest, which counts the real overlap with the
			// tray from them (see its comment for why a guess is worse than an honest "up to").
			//
			// The proof is deliberately crude and cheap: as many rows rendered as the source's own
			// badge says it has, with nothing narrowing what got rendered. Every way of holding LESS
			// than the whole pick fails it — a collapsed section (no rows at all), an endless list
			// half-scrolled (pages of 50), a typed filter (the server returns the matches, so the
			// rows are a subset while "All" still means the whole list). No fetch, no endpoint, and
			// no way to be confidently wrong: the count either matches or we say "up to".
			//
			// `total` is the badge the pick is named after — item.termCount for a whole list, a
			// garden band's own sec.count for a band. `filtered` is that surface's filter box.
			function renderedIdsIfComplete(scopeEl, total, filtered) {
				if (filtered || !total || !scopeEl || !scopeEl.length) { return null; }
				var ids = $.map(scopeEl.find(".wlWordRowClass"), function (el) {
					return +$(el).attr("data-term-id");
				});
				return (ids.length === total) ? ids : null;
			}

			// The whole-list item's FACE. A tray holds at most tray_cap words (see trayCap), so on a
			// list bigger than that "All" is a promise the click cannot keep — it stages the first
			// N and says so afterwards. Naming the trim in the label moves that fact BEFORE the
			// click, where it can still change the decision (pick Random, or select by hand instead).
			function allMenuLabel(count) {
				return (count > trayCap())
					? strFormat(getRes("wlMenuMax_label"), trayCap())
					: getRes("wlMenuAll_label");
			}

			// Wire a menu item that stages words in bulk (All / Selected / Continue in Learn).
			// `apply(replace)` does the add.
			//
			// Over an EMPTY destination tray there is one honest meaning, so the item fires on click
			// and the menu keeps exactly today's shape. Over a tray that already holds words the item
			// becomes a parent and the last step of the pick is the choice itself — the same two rows,
			// in the same order, as every other surface (see trayChoiceRows). Its flyout rides the
			// SAME hover machine as "Random ▸", so one grace timeout and one dismissal chassis cover
			// both and a diagonal pointer path across the corner doesn't collapse it.
			// `incoming` = how many words this action would bring (null when only the server knows —
			// a VERBS pick expands into conjugated forms). `learning` overrides the active tab for
			// the one caller whose destination is fixed (My Garden's "Continue in Learn"). `ids` =
			// this pick's term ids when the client provably has them all (renderedIdsIfComplete, or a
			// hand-made selection), which is what lets the append row count the real overlap.
			function wireAddAction(item, apply, incoming, learning, ids) {
				var dest = trayDest(incoming, learning, ids);
				if (!dest.staged) {
					item.click(function (e) { stopEvent(e); closeAddMenu(); apply(true); });
					return item;
				}
				item.addClass("wlMenuParentClass");
				item.append($("<span class='wlMenuArrowClass'>" + plIcon("chevron-right") + "</span>"));
				item.append(buildChoiceSub(dest, apply));
				wireSubMenu(item);
				return item;
			}

			// The choice flyout itself, shared by the menu rows and the Random count rows.
			function buildChoiceSub(dest, apply) {
				var sub = $("<div class='wlAddSubMenuClass wlPopoverClass trayChoiceSubClass'></div>");
				var rows = trayChoiceRows(dest, apply, closeAddMenu);
				sub.append(rows[0]).append(rows[1]);
				// The rows stop their own clicks, but the flyout's padding is part of the parent row
				// too — without this a press on the gap between them would toggle the flyout shut.
				sub.click(function (e) { e.stopPropagation(); });
				return sub;
			}

			// The Random counts: the presets plus the list's remembered count (merged in sorted,
			// highlighted). Each row is a highlighted number PILL (editable in place) plus a
			// triangle "add" button on its right. The two actions are decoupled:
			//   • Editing a number and committing it (Enter, or clicking outside the field but still
			//     inside the menu) SAVES it as this list's remembered count (word_list.random_count,
			//     per user) and re-highlights the sticky row — but the menu STAYS OPEN and nothing is
			//     added yet. Moving into a sibling number just switches editing (no commit).
			//   • The triangle button ADDS that row's count of random words to the Practice tray and
			//     CLOSES the menu (it does not persist the count — history keeps the exact size).
			// Escape cancels the whole menu. While a field has focus the menu's hover-away auto-close
			// is suspended (addMenuEditing), so only a deliberate commit or Escape resolves an edit.
			//
			// `act(n, replace)` receives the answered replace-or-add choice. Over a non-empty
			// destination tray the triangle no longer adds straight away: it opens THIS row's choice
			// flyout, because the count is the end of the pick and the choice belongs after it.
			// Opened on CLICK, not hover — the row hosts a live number field, and a flyout that
			// sprang out while the user was reaching for it to type would be hostile.
			// A choice flyout is the DEEPEST thing the add menu opens (menu → counts → choice), and its
			// rows are sentences, so on a narrow window the third column can run past the right edge.
			// Measure once on reveal and mirror it to the left of its parent when it would. Cheap
			// because it only ever runs on a flyout that is already on screen.
			function flipSubMenuIfClipped(sub) {
				var r = sub[0].getBoundingClientRect();
				if (r.right > $(window).width() - 8) { sub.addClass("trayChoiceLeftClass"); }
			}

			// Fold ONE count row's choice flyout away.
			function closeCountChoice(itemEl) {
				itemEl.removeClass("wlMenuParentClass wlSubOpenClass")
					.children(".trayChoiceSubClass").remove();
			}
			// …and every one inside a submenu — only ever one open at a time, like the menus themselves.
			function closeCountChoices(scope) {
				scope.find(".wlMenuCountClass").each(function () { closeCountChoice($(this)); });
			}

			// The count row's own replace-or-add flyout, on the SAME hover machine as every other
			// submenu here: the pointer onto the ▶ reveals it, leaving both it and the flyout folds it
			// away after the shared 600ms grace. Hover rather than the row itself, because the row
			// hosts a live number field — a flyout that sprang out as you reached in to type would be
			// in the way. Click still toggles, for touch and for anyone who presses rather than rests.
			//
			// Built on each reveal, never kept around: its arithmetic quotes the number the field says
			// NOW, and that number is editable in place.
			// `countsWords` is false on either verb list, where n means n VERBS and each becomes one
			// or more cards — the arithmetic is dropped rather than quoting verbs as if they were words.
			function wireCountChoice(itemEl, addBtn, readVal, act, countsWords) {
				var machine = PL.hover.intent({
					openDelay: 0,
					closeDelay: 600,
					open: function () {
						// No ids, ever: the server draws the sample and it does not exist yet, so the
						// overlap with the tray is genuinely unknowable here. The append row says
						// "up to" — see trayDest.
						var dest = trayDest(countsWords ? readVal() : null);
						if (!dest.staged) { return; }   // empty tray: the ▶ is a plain press
						closeCountChoices(itemEl.parent());   // one open flyout at a time
						var sub = buildChoiceSub(dest, function (replace) { act(readVal(), replace); });
						// The pointer travels ▶ → flyout across a gap; both must feed one machine.
						sub.on("mouseenter", function () { machine.cancelClose(); })
							.on("mouseleave", function () { machine.leave(); });
						itemEl.addClass("wlMenuParentClass wlSubOpenClass").append(sub);
						flipSubMenuIfClipped(sub);
					},
					close: function () { closeCountChoice(itemEl); },
					isOpen: function () { return itemEl.hasClass("wlSubOpenClass"); },
					suspended: function () { return addMenuEditing || guideCueHolds(); }
				});
				addBtn.on("mouseenter", function () { machine.enter(); })
					.on("mouseleave", function () { machine.leave(); });
				return machine;
			}

			function buildCountItems(container, act, item) {
				var counts = RANDOM_COUNTS.slice();
				var sticky = item.randomCount;
				// The remembered count is an EDITED preset, not an extra choice: when it isn't one of
				// the presets, replace the nearest preset in place (keeps the row count at 5). Appending
				// it instead grew the menu by a row on every reopen (5 → 6 fields).
				if (sticky >= 1 && $.inArray(sticky, counts) === -1) {
					var nearest = 0;
					for (var ci = 1; ci < counts.length; ci++) {
						if (Math.abs(counts[ci] - sticky) < Math.abs(counts[nearest] - sticky)) { nearest = ci; }
					}
					counts[nearest] = sticky;
					counts.sort(function (a, b) { return a - b; });
				}
				// While the onboarding walk is live (the user's first Learn exercise), the top
				// preset offers a gentler 3 instead of 5 — five words felt like a lot for a first
				// meeting with the app (owner call 2026-08-08). The guide's cue points at this row
				// and its copy says 3 (obGuideFive). AFTER the sticky fold-in on purpose: the
				// remembered count is 5 by default, and folding it back in would undo the override.
				if (window.OB_GUIDE && OB_GUIDE.firstRun()) {
					counts = [3].concat(RANDOM_COUNTS.slice(1));
				}

				// Re-paint the sticky highlight after an edit: exactly one row (whose value now equals
				// the remembered count) reads as sticky.
				function refreshSticky() {
					container.find(".wlMenuCountClass input").each(function () {
						$(this).toggleClass("wlCountStickyClass",
							parseInt(this.value, 10) === item.randomCount);
					});
				}

				$.each(counts, function (_, n) {
					var itemEl = $("<div class='wlPopoverItemClass wlMenuCountClass'></div>");
					// attr (not val): the value should also live on the attribute — the preset a
					// field started from stays inspectable even after an in-place edit.
					var input = $("<input type='text' inputmode='numeric' maxlength='3'/>").attr("value", n);
					if (n === sticky) { input.addClass("wlCountStickyClass"); }   // the list's remembered count
					input.assignTooltip("wlMenuCountEdit_tooltip");
					itemEl.append(input);

					// Triangle add-to-tray button (same face/icon as the per-word add row action):
					// adds THIS row's count and closes the menu.
					//
					// NO TOOLTIP — the same reasoning the Add pill itself carries. It said "Add words
					// to the Learning tray", which is verbatim the menu HEADER two rows above it, and
					// hovering the ▶ is exactly what opens the replace-or-add flyout: the tooltip
					// landed ON TOP of the two rows it was duplicating (owner report 2026-08-07). It
					// was redundant over an empty tray too, where the header still says it.
					var addBtn = $("<button class='pl-btn-icon-round wlMenuCountAddClass' type='button'>" + plIcon("play") + "</button>");
					function readVal() {
						var v = parseInt(input.val(), 10);
						return (v >= 1 && v <= 200) ? v : item.randomCount;   // else the remembered count
					}
					var choiceMachine = wireCountChoice(itemEl, addBtn, readVal, act,
						!isVerbKind(item.kind));
					addBtn.click(function (e) {
						e.stopPropagation();
						if (!trayDest(null).staged) {        // empty tray: one meaning, add straight away
							closeAddMenu();
							act(readVal(), true);
							return;
						}
						choiceMachine.toggle();
					});
					itemEl.append(addBtn);

					// Clicks inside the row (but not on the button, and not inside an open choice
					// flyout — both stop their own) land on / focus the number field. Reaching for the
					// number folds any choice away: it was asked about the OLD number.
					itemEl.click(function (e) {
						e.stopPropagation();
						closeCountChoices(itemEl.parent());
						input.focus();
					});
					input.on("click", function (e) { e.stopPropagation(); });

					var resolved = false;   // this field's edit ended (committed or reverted)

					// Commit an edit: persist the new count and re-highlight — but keep the menu open.
					function commit() {
						if (resolved) { return; }
						resolved = true;
						addMenuEditing = false;
						var val = parseInt(input.val(), 10);
						if (!(val >= 1 && val <= 200)) {
							input.val(item.randomCount);   // bad input = revert, menu stays open
							return;
						}
						// Sticks for this list (DB, per user) + updates the local model right away.
						ajaxPost("wordlist-random-count", { wordListId: item.id, count: val },
							function () {}, getRes("operationCannotComplete_message"));
						item.randomCount = val;
						$("#wlRandomCountId").val(val);   // history-regenerate fallback (see restoreWordSet)
						refreshSticky();
					}

					input.on("focus", function () {
						resolved = false;
						addMenuEditing = true;//suspends hover grace AND outside-pointerdown dismissal
						input.select();
					});
					// Escape needs no handler here anymore: PL.layers consumes it at document
					// capture (before this input could see it) and closes the layer; onClose
					// tears the menu down mid-edit = cancel (the removed field never commits).
					input.on("keydown", function (e) {
						if (e.which === PL.keys.ENTER) { e.preventDefault(); commit(); input.blur(); }
					});
					input.on("blur", function () {
						// Focus may be moving to a SIBLING count field (switching numbers, not
						// committing) — that lands after the blur, hence the deferred check.
						setTimeout(function () {
							if (resolved || !addMenuEl) { return; }
							var active = document.activeElement;
							if (active && $(active).is(".wlMenuCountClass input")) {
								addMenuEditing = true;   // still editing, just another field
								return;
							}
							commit();
						}, 0);
					});
					container.append(itemEl);
				});
			}

			function openAddMenu(btn, section, item) {
				if (!document.contains(btn[0])) {
					return;//panel re-rendered while a hover-open intent was pending
				}
				closeAddMenu();
				hidePopover();
				closeSortMenu();
				var isLevel = isVirtualKind(item.kind);
				var isGarden = item.kind === 'GARDEN';
				// The WL element the fly frame launches from: the list's header row (the Add pill lives
				// inside it), so a bulk add reads as "these words flew from this list into the tray".
				var addSrc = btn.closest(".wlHeaderClass")[0] || (section && section[0]) || btn[0];
				addMenuEl = $("<div class='wlPopoverClass wlAddMenuClass'></div>");
				addMenuFor = btn[0];
				// While the menu is open the button reads as active AND stays visible even when the
				// pointer moves off the header into the menu (the hover-reveal would hide it).
				btn.addClass("wlAddOpenClass");

				// The menu shape (All / Selected / Random ▸ counts) is identical for both destinations;
				// only the copy (header) and the click routing differ by the active tab (addDestIsLearning).
				addMenuEl.append($("<div class='wlAddMenuHeadClass'></div>").text(
					getRes(addDestIsLearning() ? "wlAddMenuHeaderLearn_label" : "wlAddMenuHeader_label")));

				// No All for virtual lists (thousands of words); everything else is shared:
				// Selected (checked words of the expanded section) + Random ▸ counts.
				if (!isLevel) {
					// An own list arrives WHOLE (loadWords → renderWords), so an expanded, unfiltered
					// section already holds every id "All" would stage — no fetch to know the overlap.
					// Collapsed or filtered, it does not, and the row says "up to" instead.
					var allIds = renderedIdsIfComplete(
						expandedId === item.id ? section : null,
						item.termCount, sectionFilter(section));
					var allItem = wireAddAction(addMenuItem(allMenuLabel(item.termCount)), function (replace) {
						armTrayFly(addSrc, null);   // bulk → frame embraces the whole tray
						if (addDestIsLearning()) { addAllToLearning(item, replace); }
						else { addAllToPractice(item, replace); }
					}, item.termCount, null, allIds);
					addMenuEl.append(allItem);
				}

				var selIds = getCheckedIds(section);
				var selItem = addMenuItem(getRes("wlMenuSelected_label")
					+ (selIds.length ? " (" + selIds.length + ")" : ""));
				if (selIds.length) {
					// A verb pick brings CARDS, one or several per verb — the word count is only
					// known once the server expands them, so the choice drops its arithmetic rather
					// than quoting the verb count as if it were words.
					wireAddAction(selItem, function (replace) {
						armTrayFly(addSrc, null);   // bulk → frame embraces the whole tray
						if (isVerbKind(item.kind)) { addVerbForms(item, { termIds: selIds }, replace); }
						else if (addDestIsLearning()) { addWordsToLearning(selIds, replace); }
						else { addWordsToPractice(selIds, replace); }
						// A hand-made selection is ALWAYS exact — the ids are the checkboxes. (Except
						// on a verb list, where each one becomes several cards and no word count
						// exists to be exact about.)
					}, isVerbKind(item.kind) ? null : selIds.length, null, selIds);
				} else {
					// Disabled, not hidden: an item that comes and goes reads as a bug. No tooltip on
					// it (owner, 2026-10-08): the pointer crosses it on the way to "Random" below,
					// and the box only got in the way of the item being reached for.
					selItem.addClass("wlMenuDisabledClass");
					selItem.click(function (e) { stopEvent(e); });
				}
				addMenuEl.append(selItem);

				// My Garden has no list-wide bulk add at all: "All" is already suppressed for every
				// virtual kind above, and "Random" is dropped here. Its four sections mean four
				// genuinely different things to do next, so a draw across all of them would hand
				// back a mix of overdue words, unfinished words and words with nothing wrong with
				// them — there is no sensible meaning to give it. The per-SECTION menus carry both,
				// where the draw does mean something. "Selected (N)" stays: a hand-picked set spans
				// sections perfectly well, and its destination is the active tab like everywhere else.
				if (isGarden) {
					addMenuEl.append($("<div class='wlPopoverNoteClass'></div>")
						.text(getRes("wlGardenUseSections_note")));
					finishAddMenu(btn, addMenuEl);
					return;
				}

				// "Random ▸" with a nested count submenu (wireSubMenu owns its hover behaviour).
				var randomItem = $("<div class='wlPopoverItemClass wlMenuParentClass wlMenuRandomClass'></div>");
				randomItem.append($("<span></span>").text(getRes("wlMenuRandom_label")));
				randomItem.append($("<span class='wlMenuArrowClass'>" + plIcon("chevron-right") + "</span>"));
				var sub = $("<div class='wlAddSubMenuClass wlPopoverClass'></div>");
				// Routed at click time by the active tab. The Random-from-level-into-an-EMPTY-tray
				// RANDOM-origin special case stays Practice-only (learning has no session-origin);
				// its learning twin always fetches a fresh draw straight into the learn tray.
				buildCountItems(sub, function (n, replace) {
					armTrayFly(addSrc, null);   // bulk → frame embraces the whole tray
					// The verb kinds first: isLevel is isVirtualKind(), which is true here, and the
					// level path is keyed by a level CODE these kinds have none of
					// (levelCode("VERBS") is the meaningless "S"). The draw happens server-side in
					// the same request that expands it — n means n VERBS, each becoming its cards.
					if (isVerbKind(item.kind)) { addVerbForms(item, { randomCount: n }, replace); }
					// Topics before the level branch for the same reason the verbs are: `isLevel` is
					// isVirtualKind(), true here, and the level path is keyed by a level CODE this
					// kind has none of (levelCode("TOPIC") would be the meaningless "C").
					else if (isTopicKind(item.kind)) { addRandomFromTopic(n, replace); }
					else if (addDestIsLearning()) {
						if (isLevel) { addRandomFromLevelToLearning(item, n, replace); }
						else { addRandomFromListToLearning(item, n, replace); }
					} else {
						if (isLevel) { addRandomFromLevel(item, n, replace); }
						else { addRandomFromList(item, n, replace); }
					}
				}, item);
				randomItem.append(sub);
				wireSubMenu(randomItem);
				addMenuEl.append(randomItem);

				finishAddMenu(btn, addMenuEl);
			}

			// The "Random ▸" parent's own intent machine (instant open, the same 600ms grace;
			// a pure CSS :hover reveal collapsed the instant a diagonal mouse path clipped
			// outside the boxes). The submenu is a CHILD of the item, so one enter/leave pair
			// covers both — and it reveals INSIDE the menu layer, deliberately NOT a separate
			// PL.layers entry: outside pointerdown and Esc take the whole family down at once.
			function wireSubMenu(parentItem) {
				var subMachine = PL.hover.intent({
					openDelay: 0,
					closeDelay: 600,
					// The onboarding glow guide steps INTO the count submenu (the 5-row's
					// arrow) — re-evaluate on both edges so its glow follows the reveal.
					open: function () {
						parentItem.addClass("wlSubOpenClass");
						// Only the replace-or-add flyout is measured: it carries sentences rather
						// than the count submenu's five short numbers, so it is the one that can
						// reach the window edge. Measured after the reveal — it has no box before.
						parentItem.children(".trayChoiceSubClass").each(function () {
							flipSubMenuIfClipped($(this));
						});
						if (window.OB_TIPS) { OB_TIPS.evaluate(); }
					},
					close: function () {
						parentItem.removeClass("wlSubOpenClass");
						// Re-measured on the next open: the window may have been resized meanwhile.
						parentItem.children(".trayChoiceSubClass").removeClass("trayChoiceLeftClass");
						if (window.OB_TIPS) { OB_TIPS.evaluate(); }
					},
					isOpen: function () { return parentItem.hasClass("wlSubOpenClass"); },
					suspended: function () { return addMenuEditing || guideCueHolds(); }
				});
				parentItem.on("mouseenter", function () { subMachine.enter(); });
				parentItem.on("mouseleave", function () { subMachine.leave(); });
				parentItem.click(function (e) { e.stopPropagation(); subMachine.toggle(); });
			}

			// Mount + arm a built add menu. Shared by the list header's menu and My Garden's
			// per-section ones, so both live on the same hover machine and the same dismissal
			// chassis — one floating menu at a time, whichever button opened it.
			function finishAddMenu(btn, menuEl) {
				// The open menu feeds the BUTTON's machine — leaving one into the other
				// keeps the menu alive; the jQuery binding dies with the element on close.
				var machine = btn.data("addMenuMachine");
				if (machine) {
					menuEl.on("mouseenter", function () { machine.enter(); });
					menuEl.on("mouseleave", function () { machine.leave(); });
				}
				menuEl.click(function (e) { e.stopPropagation(); });

				$("body").append(menuEl);
				positionPopup(menuEl, btn);
				// Dismissal lives on the chassis: outside pointerdown cascades in (suspended
				// mid-edit — the field's blur → deferred commit owns closing then), Esc is
				// consumed and closes the whole family (a live count edit cancels: the menu
				// is torn down before the field could commit). anchors = the button, so the
				// opening/toggling click never dismiss-then-reopens.
				addMenuLayer = PL.layers.push({
					el: menuEl[0],
					// The glow guide's cue box counts as "inside": its Got-it button must
					// not read as an outside press that takes the menu down mid-walk (the
					// guide's Random/5-arrow steps live in this very menu).
					anchors: window.OB_GUIDE
						? [btn[0]].concat(OB_GUIDE.cueAnchors()) : [btn[0]],
					// The guide's hold covers outside presses too: the one that reaches this layer
					// while a walk's menu step is live is a press on the quit card's backdrop,
					// whose answer is "stay" — on this menu, not on a menu it just took down.
					suspended: function () { return addMenuEditing || guideCueHolds(); },
					onClose: function () {
						addMenuLayer = null;
						addMenuEditing = false;
						if (addMenuEl) {
							addMenuEl.remove();
							addMenuEl = null;
							// Drop the open-state highlight (which also kept the hover-revealed pill visible).
							$(addMenuFor).removeClass("wlAddOpenClass");
							addMenuFor = null;
						}
						// Menu gone: the guide's in-menu glow must fall back to the pill.
						if (window.OB_TIPS) { OB_TIPS.evaluate(); }
					}
				});
				// Menu up: the guide advances from the Add pill to the Random row.
				if (window.OB_TIPS) { OB_TIPS.evaluate(); }
			}

			// ── the menu's actions ──
			// Each action has a Practice and a Learning twin (routed by the active tab in openAddMenu).
			// The Practice ones merge into the tray via addWordsToPractice (dedupe, snapshot, history);
			// the exception is Random-from-level into an EMPTY practice tray, which loads a fresh RANDOM
			// set directly (correct session-origin attribution). The Learning twins funnel through
			// addWordsToLearning / LRN.addWords instead (no session-origin).
			function loadListTermIds(item, onIds) {
				ajaxPost("wordlist-load-words", { wordListId: item.id }, function (data) {
					var terms = (data && data.wordList && data.wordList.terms) || [];
					onIds($.map(terms, function (t) { return t.id; }));
				}, getRes("wlCannotLoadWords_error_message"));
			}

			function addAllToPractice(item, replace) {
				loadListTermIds(item, function (ids) {
					if (ids.length) { addWordsToPractice(ids, replace); }
					else { showMessage(getRes("wlEmptyList_message")); }
				});
			}

			function addAllToLearning(item, replace) {
				loadListTermIds(item, function (ids) {
					if (ids.length) { addWordsToLearning(ids, replace); }
					else { showMessage(getRes("wlEmptyList_message")); }
				});
			}

			// Adding a VERB means drilling its conjugated forms, not the infinitive: the server
			// walks the stored paradigm, keeps the curated cells and hands back one phrase term per
			// form. DB-first, so a verb anybody drilled before costs nothing and the rest are one
			// cheap batch call.
			//
			// Goes to EITHER tray, like every other add — the expansion is the same, only the
			// destination differs. Learn teaches the forms through its rung ladder (its distractors
			// are sibling forms, built server-side in LearningService.verbFormCell); Practice
			// drills them. The infinitive itself never enters either tray: you study "ich fahre",
			// not "fahren".
			//
			// source = {termIds: [...]} for a picked selection, {randomCount: n} for Add ▸ Random.
			// `item` is the LIST the verbs were picked from, and its kind rides along: the server
			// routes the expansion by it, because a German verb can be on both lists and only the
			// click knows which one the user was looking at.
			function addVerbForms(item, source, replace) {
				var params = {
					termLang: langToValField.attr("data-lang-code"),
					defLang: langFromValField.attr("data-lang-code"),
					kind: item.kind
				};
				if (source.randomCount) { params.randomCount = source.randomCount; }
				else { params.termIds = source.termIds; }
				var toLearning = addDestIsLearning();
				ajaxPost("wordlist-verb-forms", params, function (data) {
					var ids = (data && data.termIds) || [];
					if (!ids.length) {
						showMessage(getRes("wlVerbsNoForms_message"));
						return;
					}
					if (toLearning) { addWordsToLearning(ids, replace); }
					else { addWordsToPractice(ids, replace); }
					// Never truncate silently — the ceiling is there because every verb whose forms
					// are not stored yet costs an API call, and the user asked for more than that.
					if (data.verbsTruncated) {
						showMessage(getRes("wlVerbsTruncated_message")
							.replace("{0}", data.verbsRequested - data.verbsTruncated)
							.replace("{1}", data.verbsRequested));
					}
				}, getRes("wlVerbsExpand_error_message"));
			}

			// Level lists have no membership rows — draw n random words straight from the dictionary
			// band into the learn tray (learning has no session-origin, so no empty-tray special case).
			function addRandomFromLevelToLearning(item, n, replace) {
				ajaxPost("loadRandom", {
					termLang: langToValField.attr("data-lang-code"),
					defLang: langFromValField.attr("data-lang-code"),
					level: levelCode(item.kind),
					number: n
				}, function (data) {
					var defs = (data && data.definitions) || [];
					if (!defs.length) { showMessage(getRes("noWords_message")); return; }
					// Clusters, one per word. A replace has the whole tray to fill; an append only the
					// room left over — the same offset every other learn-tray append works against.
					defs = capTrayList(defs, replace ? 0 : learnTrayWordCount());
					if (!defs.length) { return; }   // capped to nothing: capTrayList already said so
					LRN.addWords(defs, false, replace);
					window.openLearnTab();
				}, getRes("operationCannotComplete_message"));
			}

			// Random ▸ n from the open topic. The draw is server-side, over the WHOLE topic rather
			// than the page in hand, and comes back as bare term ids — which is all either
			// destination needs, so one branch covers Learning and Practice instead of the two
			// separate paths the level lists carry (their Practice route has a session-origin fast
			// path a topic has no equivalent of).
			function addRandomFromTopic(n, replace) {
				if (!openTopic) { return; }
				ajaxPost("wordlist-topic-term-ids", {
					termLang: langToValField.attr("data-lang-code"),
					defLang: langFromValField.attr("data-lang-code"),
					topic: openTopic,
					randomCount: n
				}, function (data) {
					var ids = (data && data.termIds) || [];
					if (!ids.length) { showMessage(getRes("noWords_message")); return; }
					if (addDestIsLearning()) { addWordsToLearning(ids, replace); }
					else { addWordsToPractice(ids, replace); }
				}, getRes("operationCannotComplete_message"));
			}

			function addRandomFromList(item, n, replace) {
				loadListTermIds(item, function (ids) {
					if (!ids.length) { showMessage(getRes("wlEmptyList_message")); return; }
					// Fisher–Yates down to n: an unbiased sample of the list.
					for (var i = ids.length - 1; i > 0; i--) {
						var j = Math.floor(Math.random() * (i + 1));
						var tmp = ids[i]; ids[i] = ids[j]; ids[j] = tmp;
					}
					addWordsToPractice(ids.slice(0, n), replace);
				});
			}

			// Learning counterpart of addRandomFromList: same unbiased n-sample, dropped into the
			// learn tray instead of the practice tray.
			function addRandomFromListToLearning(item, n, replace) {
				loadListTermIds(item, function (ids) {
					if (!ids.length) { showMessage(getRes("wlEmptyList_message")); return; }
					for (var i = ids.length - 1; i > 0; i--) {
						var j = Math.floor(Math.random() * (i + 1));
						var tmp = ids[i]; ids[i] = ids[j]; ids[j] = tmp;
					}
					addWordsToLearning(ids.slice(0, n), replace);
				});
			}

			function addRandomFromLevel(item, n, replace) {
				var code = levelCode(item.kind);
				// An empty tray is never asked the question, so `replace` is true here by
				// construction and the RANDOM-origin fast path is reached exactly as before.
				if (!currentTrayIds().length) {
					pushLeanEntry('practice');       // its own history entry, like any fresh set
					loadRandomLevelSet(code, n);
					return;
				}
				// Non-empty tray: fetch a draw, then either supersede with it or merge its ids
				// (dedupe may land fewer than n — the tray already holds some of the drawn words;
				// a fair trade for no oversampling).
				ajaxPost("loadRandom", {
					number: n,
					termLang: langToValField.attr("data-lang-code"),
					defLang: langFromValField.attr("data-lang-code"),
					level: code,
					termSource: "BNC",
					defSource: "GT"
				}, function (data) {
					var defs = (data && data.definitions) || [];
					var ids = [];
					for (var i = 0; i < defs.length; i++) {
						var t = defs[i] && defs[i].term;
						if (t && t.id != null) { ids.push(t.id); }
					}
					if (ids.length) { addWordsToPractice(ids, replace); }
					else { showMessage(getRes("noWords_message")); }
				}, "Server exception");
			}

			// ── The word filter ──────────────────────────────────────────────────────────────────
			// A list long enough to scroll is a list you can no longer scan, so past 50 words every
			// list — and every My Garden band, which is a list in its own right — grows a filter box.
			//
			// The match is a plain SUBSTRING, not a prefix. These are the user's OWN words and they
			// are remembered by any part of them ("…schaft", "-ieren", the middle of a compound); a
			// prefix box would answer half of those with nothing. The matched run is painted in the
			// dictionary's own match blue, so the reason a row survived the filter is visible ON the
			// row rather than left to be inferred.
			//
			// Below the threshold there is no box at all rather than a disabled one: fifty words are
			// two screenfuls, and a search field over two screenfuls is furniture.
			//
			// Filtering happens where the LIST lives, which is usually NOT the browser: a level list
			// holds 50 of its several thousand rows at a time, so a filter applied to what has
			// already arrived would search 1.5% of the list and confidently report nothing. The
			// filter therefore rides the page request (TermRepository.loadLevelWordsPage), and a
			// change to it restarts the stream. Own lists arrive whole and are re-fetched exactly the
			// same way — one path, not a client-side twin that would have to keep a cache, a
			// selection and a scroll cursor honest against a server that already knows the answer.
			var FILTER_MIN_WORDS = 50;
			var FILTER_DEBOUNCE_MS = 220;

			// The server decides which rows come back; this only decides where to paint inside one.
			// The typed text as the same substring regex the server matched the rows with — the twin
			// of LanguageSearchSupport.substringPattern / GermanSearchSupport, and it has to stay
			// its twin: typing "ue" brings BACK a row spelled "ü", and a plain indexOf would then
			// find nothing to paint on the very rows the substitution earned.
			//
			// German only, because German is the only language whose search support substitutes.
			// The matched run is not the typed run — "ue" paints one character — so the regex has
			// to report the length as well as the position.
			//
			// Both rules now live in js/word_filter.js: the Session history popup's word list
			// filters with the SAME regex and paints with the SAME classes, and two copies would
			// have drifted the first time a language grew a substitution. These two lines are all
			// that is left here — the panel just supplies the pair's learned language.
			function filterRegex(filter) {
				return WORDFILTER.regex(filter, langToValField.attr("data-lang-code"));
			}

			function paintFilterMatch(span, word, filter) {
				WORDFILTER.paint(span, word, filter, langToValField.attr("data-lang-code"));
			}

			// ── ENTER opens the word the filter named ────────────────────────────────────────
			// The box is a way IN, not only a way to narrow: when what was typed names one of the
			// words on the nose, ENTER opens that word's rich entry, exactly as clicking it would.
			//
			// "On the nose" is read off the PAINT — the revMatchFullClass span the highlighter
			// already puts on a word it matched from end to end — rather than re-derived here. The
			// rule the user sees ("the word that went entirely blue") is then the rule the code
			// follows, they cannot drift apart, and the language's substitutions come along for
			// free: typed `abklaeren` opens *abklären*, because that is the row the server matched
			// and the painter marked full.
			var FILTER_OPEN_MS = 4000;
			var filterOpenWanted = null;   // { input, typed, until } — armed by ENTER, consumed by the rows

			// The rows a box governs: a My Garden band filters its own band, every other box filters
			// its whole list.
			function filterRowsFor(input) {
				// The GLOBAL box governs every rendered row across every open section.
				if (input.hasClass("wlxGlobalFilterClass")) {
					return accordion.find(".wlWordRowClass");
				}
				var band = input.closest(".wlGardenSecClass");
				return (band.length ? band : input.closest(".wlSectionClass")).find(".wlWordRowClass");
			}

			// The one row whose word matched IN FULL. Two can qualify at once — the match is
			// case-insensitive and German case twins are different words (sie / Sie) — so a
			// character-for-character hit wins, and a tie without one opens nothing rather than
			// guessing which of the two was meant.
			function fullMatchRow(rows, typed) {
				var full = rows.filter(function () {
					return $(this).find(".wlWordTextClass .revMatchFullClass").length > 0;
				});
				if (full.length < 2) { return full.length ? full.eq(0) : null; }
				var same = full.filter(function () {
					return $.trim($(this).find(".wlWordTextClass").text()) === typed;
				});
				if (same.length === 1) { return same.eq(0); }
				// The global filter shows the SAME word once per list it lives in — several rows,
				// one word, one entry to open. Only genuinely different spellings (the case-twin
				// tie this guard exists for: sie / Sie) still open nothing rather than guess.
				var pool = same.length ? same : full;
				var text = null, uniform = true;
				pool.each(function () {
					var t = $.trim($(this).find(".wlWordTextClass").text());
					if (text === null) { text = t; }
					else if (t !== text) { uniform = false; }
				});
				return uniform ? pool.eq(0) : null;
			}

			function armFilterOpen(input) {
				filterOpenWanted = { input: input, typed: $.trim(input.val()),
					until: Date.now() + FILTER_OPEN_MS };
				tryFilterOpen();
			}

			// Runs on the ENTER itself — usually enough, the debounce lands while the word is still
			// being finished — and again from appendWords, because an ENTER on the LAST keystroke
			// arrives while the rows it is asking about are still on the wire.
			function tryFilterOpen() {
				var want = filterOpenWanted;
				if (!want) { return; }
				// Typing on, or a stream that took too long: a page landing later must never open a
				// word by surprise.
				if (Date.now() > want.until || $.trim(want.input.val()) !== want.typed) {
					filterOpenWanted = null;
					return;
				}
				var hit = fullMatchRow(filterRowsFor(want.input), want.typed);
				if (!hit) { return; }
				filterOpenWanted = null;
				hit.find(".wlWordTextClass").click();   // the row's own handler: one door, one behaviour
			}

			// The box itself. `apply` restarts whatever surface owns it, and is DEBOUNCED because
			// every keystroke is a round trip; ENTER and ESCAPE skip the wait (ESCAPE by clearing).
			function buildFilterInput(cssClass, apply) {
				var input = $("<input type='text' size='1' maxlength='40'/>")
					.addClass("wlFilterInputClass " + cssClass)
					.attr("placeholder", getRes("wlFilterPlaceholder"));
				var timer = null;
				var applied = "";
				function fire() {
					var typed = $.trim(input.val());
					if (typed === applied) { return; }   // debounce landing on an unchanged value
					applied = typed;
					apply(typed);
				}
				input.on("input", function () {
					clearTimeout(timer);
					filterOpenWanted = null;   // the word being asked for has changed
					timer = setTimeout(fire, FILTER_DEBOUNCE_MS);
				});
				input.keydown(function (e) {
					if (e.which === PL.keys.ESCAPE) { input.val(""); filterOpenWanted = null; }
					if (e.which === PL.keys.ENTER || e.which === PL.keys.ESCAPE) {
						clearTimeout(timer);
						fire();
						// …and if what is typed names a word exactly, ENTER opens it. After fire(),
						// so a filter typed and confirmed in one go still gets its rows asked for.
						if (e.which !== PL.keys.ESCAPE) { armFilterOpen(input); }
						e.preventDefault();
					}
					// The panel's own keys must not reach past a field being typed into: ENTER and
					// SPACE both toggle the section from its header, and SPACE is the app's sound key.
					e.stopPropagation();
				});
				// A click in the box must not fold the band it sits under, nor toggle the list.
				input.click(function (e) { e.stopPropagation(); });
				// The clear ×: same immediate path as ESC (no debounce wait), and the box keeps
				// focus so the next search starts with a keystroke, not a click. Shown only while
				// there is text — CSS does that off :placeholder-shown, so programmatic clears
				// (entering global-filter mode blanks every per-list box) need no bookkeeping.
				var clear = $("<button type='button' class='pl-btn-icon-round wlFilterClearClass' tabindex='-1'></button>")
					.html(plIcon("x"));
				clear.mousedown(function (e) { e.preventDefault(); });   // don't steal the box's focus
				clear.click(function (e) {
					e.stopPropagation();
					input.val("");
					filterOpenWanted = null;
					clearTimeout(timer);
					fire();
					input.focus();
				});
				return $("<span class='wlFilterWrapClass'></span>").append(input).append(clear);
			}

			// What the LIST's own box currently holds ("" when it has none). Scoped to the toolbar so
			// it can never pick up a My Garden band's box, which lives down among the rows.
			function sectionFilter(section) {
				return $.trim(section.find(".wlToolbarClass .wlFilterInputClass").val() || "");
			}

			// ── The GLOBAL filter: one box over ALL lists (docs/project/wl-global-filter.md) ──
			// Fully client-side: WLFX holds every list's members (static payload + per-user sets),
			// so a keystroke costs zero round trips — badges, dimming and rows all paint from
			// memory, from the FIRST letter (the 3-char minimum was dropped 2026-08-10: it guarded
			// a server fan-out that no longer exists, and the mess-guard is auto-expand's
			// full-word rule, not a length gate). Selection and bulk actions are OFF in filter
			// mode (CSS .wlxFilterModeClass): the panel's selection model is single-open, and
			// this is a finding surface, not a filing one.
			var globalFilter = "";        // the typed value while the mode is on; "" = mode off
			var globalFilterRow = null;   // the inserted row, or null while hidden
			var preFilterExpanded = null; // what was open before the mode took over
			var wlxAutoOpen = {};         // sections opened by a full-word match (decision 6)
			var wlxManualOpen = {};       // sections the user opened while filtering

			// The rows a list would show, from the client index — null when the data (or the
			// pair's payload) is not in hand, which every caller reads as "fall back to the
			// server / show no badge". The CONJUGATION source honours the onlyIrregular display
			// toggle by picking the OTHER precomputed membership, never by re-deriving it.
			function filterSourceRows(item) {
				var k = item.kind;
				if (k === 'USER') { return WLFX.ownRows(item.id); }
				if (k === 'DEFAULT') {
					// MY LIST's filter source is its own rows PLUS the "Phrases I typed" band that
					// lives at its tail — one surface, one search. Deduped by id (a promoted phrase
					// is legitimately in both); either half missing → null, so the caller falls
					// back to the server rather than silently searching half the surface.
					var own = WLFX.ownRows(item.id);
					var ph = WLFX.phraseRows();
					if (!own || !ph) { return own && !ph ? own : null; }
					var seen = {}, merged = [];
					for (var mi = 0; mi < own.length; mi++) { seen[own[mi].id] = 1; merged.push(own[mi]); }
					for (var pi = 0; pi < ph.length; pi++) {
						if (!seen[ph[pi].id]) { merged.push(ph[pi]); }
					}
					return merged;
				}
				if (isLevelKind(k)) { return WLFX.virtualRows(k); }
				if (k === 'CONJUGATION') {
					return WLFX.virtualRows($("#verbOnlyIrregularId").is(":checked")
						? "CONJUGATION_IRR" : "CONJUGATION");
				}
				if (k === 'VERBS') { return WLFX.virtualRows('VERBS'); }
				if (isTopicKind(k)) {
					return openTopic ? WLFX.topicRows(openTopic) : WLFX.topicAllRows();
				}
				if (k === 'GARDEN') { return WLFX.gardenAllRows(); }
				return null;
			}

			function wlxMatch(rows, typed) {
				var re = filterRegex(typed);
				var out = [];
				if (!rows || !re) { return out; }
				for (var i = 0; i < rows.length; i++) {
					if (re.test(String(rows[i].term || ""))) { out.push(rows[i]); }
				}
				return out;
			}

			// Same definition the painter uses for revMatchFullClass: the match covers the
			// headword end to end — so the badge's auto-expand and the blue-bold paint can
			// never disagree about what "a full match" is.
			function wlxHasFullMatch(rows, typed) {
				var re = filterRegex(typed);
				if (!re) { return false; }
				for (var i = 0; i < rows.length; i++) {
					var term = String(rows[i].term || "");
					var m = re.exec(term);
					if (m && m.index === 0 && m[0].length === term.length) { return true; }
				}
				return false;
			}

			// Local endless scroll for a CLIENT-provided row set — the same 50-row pages the
			// server streams arrive in, so the DOM cost of a broad filter stays bounded. Bound
			// under scroll.wlLevel on purpose: the server streams' own .off() calls then clear
			// it when a section returns to normal paging, with no extra bookkeeping.
			function startLocalWordStream(item, matched) {
				var section = sectionEl(item.id);
				var wordsEl = section.find(".wlWordsClass");
				wordsEl.off("scroll.wlLevel scroll.wlGarden");
				resetRows(section, true);
				section.find(".wlCheckAllClass").toggle(!!matched.length && !globalFilter);
				if (!matched.length) {
					wordsEl.append($("<div class='wlEmptyClass'></div>").text(getRes("wlNoMatch_message")));
					updateSelBar(section);
					return;
				}
				var st = { idx: 0 };
				function page() {
					var slice = matched.slice(st.idx, st.idx + LEVEL_PAGE);
					st.idx += slice.length;
					appendWords(section, slice);
				}
				page();
				var el = wordsEl[0];
				function fill() {
					while (st.idx < matched.length && wlShort(el, fill)) { page(); }
				}
				fill();
				wordsEl.on("scroll.wlLevel", function () {
					if (this.scrollTop + this.clientHeight >= this.scrollHeight - 150
							&& st.idx < matched.length) {
						page();
					}
				});
			}

			// My Garden in filter mode: lightweight read-only band blocks — title + match count +
			// the matching rows, built from the per-user sets. No fold, no select-all, no Add
			// menu: those belong to the live garden (loadGardenWords), and a found word's
			// affordances ride on its ROW (buildRow reads data-gsec for the band specials).
			function renderGardenFilterRows(item, section) {
				var wordsEl = section.find(".wlWordsClass");
				wordsEl.off("scroll.wlLevel scroll.wlGarden");
				resetRows(section, true);
				var any = false;
				$.each(GARDEN_SEC_RES, function (key) {
					var matched = wlxMatch(WLFX.gardenRows(key), globalFilter);
					if (!matched.length) { return; }
					any = true;
					var box = $("<div class='wlGardenSecClass'></div>").attr("data-gsec", key);
					var head = $("<div class='wlGardenSecHeadClass'></div>");
					head.append($("<span class='wlGardenSecSelClass wlSecSelEmptyClass'></span>"));
					head.append($("<span class='wlGardenSecTitleClass'></span>")
						.text(getRes(GARDEN_SEC_RES[key] || "")));
					head.append($("<span class='pl-count-pill'></span>").text(matched.length));
					box.append($("<div class='wlGardenSecStickyClass'></div>").append(head));
					var rowsBox = $("<div class='wlGardenSecRowsClass'></div>");
					box.append(rowsBox);
					wordsEl.append(box);
					appendWords(section, matched, rowsBox);
				});
				if (!any) {
					wordsEl.append($("<div class='wlEmptyClass'></div>").text(getRes("wlNoMatch_message")));
				}
			}

			function openFilterSection(item) {
				var section = sectionEl(item.id);
				section.addClass("wlExpanded");
				updateHeaderTight(section.children(".wlHeaderClass"));
				if (item.kind === 'GARDEN') { renderGardenFilterRows(item, section); }
				else { startLocalWordStream(item, wlxMatch(filterSourceRows(item), globalFilter)); }
			}

			function closeFilterSection(section) {
				section.removeClass("wlExpanded");
				section.find(".wlWordsClass").off("scroll.wlLevel scroll.wlGarden").empty();
			}

			// The badge is an ADDITION next to the size pill, never a replacement — "counts are
			// not filtered" still holds for the pill (decision 5). null matched = data not in
			// hand: no badge at all, rather than a 0 that would read as "not here".
			function paintMatchBadge(section, matched) {
				var header = section.children(".wlHeaderClass");
				var badge = header.find(".wlxMatchBadgeClass");
				if (matched === null) { badge.remove(); return; }
				if (!badge.length) {
					badge = $("<span class='wlxMatchBadgeClass'></span>");
					var pill = header.find(".pl-count-pill").first();
					if (pill.length) { pill.before(badge); } else { header.append(badge); }
				}
				badge.text(matched.length);
			}

			// Recompute every list's matches and repaint the whole mode: badges, dimming,
			// full-match auto-expand (and auto-collapse when typing on moved past a match),
			// and a re-render of every open section under the new letters.
			function refreshFilterMode() {
				if (!globalFilter) { return; }
				for (var i = 0; i < lists.length; i++) {
					var item = lists[i];
					var section = sectionEl(item.id);
					if (!section.length) { continue; }
					var src = filterSourceRows(item);
					var matched = src ? wlxMatch(src, globalFilter) : null;
					paintMatchBadge(section, matched);
					section.toggleClass("wlxDimClass", matched !== null && !matched.length);
					var full = !!(src && matched && matched.length
						&& wlxHasFullMatch(matched, globalFilter));
					var open = section.hasClass("wlExpanded");
					if (full && !open && !wlxManualOpen[item.id]) {
						wlxAutoOpen[item.id] = true;
						openFilterSection(item);
					} else if (!full && open && wlxAutoOpen[item.id] && !wlxManualOpen[item.id]) {
						// The word this section auto-opened for is no longer what is typed.
						delete wlxAutoOpen[item.id];
						closeFilterSection(section);
					} else if (open) {
						if (item.kind === 'GARDEN') { renderGardenFilterRows(item, section); }
						else { startLocalWordStream(item, matched || []); }
					}
				}
			}

			function enterFilterMode() {
				preFilterExpanded = expandedId;
				wlxAutoOpen = {};
				wlxManualOpen = {};
				// A light collapse, NOT collapseSection(): the filter is a transient view, so the
				// persisted selection must survive it untouched for exitFilterMode to restore.
				expandedId = null;
				levelScroll = null;
				gardenScroll = null;
				hidePopover();
				closeAddMenu();
				// A per-list (or band) box still holding text would win the paint derivation in
				// appendWords over the global value — the mode owns the letters now, so clear them.
				accordion.find(".wlFilterInputClass").val("");
				accordion.children(".wlSectionClass").removeClass("wlExpanded")
					.find(".wlWordsClass").off("scroll.wlLevel scroll.wlGarden");
				panelBox.addClass("wlxFilterModeClass");
				applyAddPillStateAll();   // the header Add pills go inert for the mode's duration
			}

			function exitFilterMode() {
				globalFilter = "";
				panelBox.removeClass("wlxFilterModeClass");
				applyAddPillStateAll();   // …and come back exactly as they were (empty lists stay off)
				accordion.find(".wlxMatchBadgeClass").remove();
				accordion.children(".wlSectionClass").removeClass("wlxDimClass wlExpanded")
					.find(".wlWordsClass").off("scroll.wlLevel scroll.wlGarden").empty();
				wlxAutoOpen = {};
				wlxManualOpen = {};
				expandedId = null;
				// Back to the world as it was: the pre-filter list re-opens through the normal
				// path (server rows, one-open rule, same persisted value it had).
				if (preFilterExpanded && listById(preFilterExpanded)) {
					expandSection(preFilterExpanded);
				}
				preFilterExpanded = null;
			}

			function applyGlobalFilter(typed) {
				// The index is still on the wire (or this pair has none): stay inert rather than
				// flash a mode that cannot answer. The per-list boxes keep working regardless.
				if (typed && !WLFX.ready()) { return; }
				var was = globalFilter;
				globalFilter = typed;
				if (!typed) {
					if (was) { exitFilterMode(); }
					return;
				}
				if (!was) { enterFilterMode(); }
				refreshFilterMode();
			}

			function toggleGlobalFilterRow() {
				if (globalFilterRow) { closeGlobalFilterRow(); return; }
				var wrap = buildFilterInput("wlxGlobalFilterClass", applyGlobalFilter);
				var input = wrap.find(".wlFilterInputClass")
					.attr("placeholder", getRes("wlxGlobalFilter_placeholder"));
				// First ESC clears (buildFilterInput's own handler); ESC in an ALREADY-empty box
				// folds the row away. Captured natively so the emptiness is read BEFORE the
				// factory's handler clears the value.
				input[0].addEventListener("keydown", function (e) {
					if (e.key === "Escape" && !$.trim(input.val())) { closeGlobalFilterRow(); }
				}, true);
				globalFilterRow = $("<div id='wlGlobalFilterRowId'></div>").append(wrap);
				$("#wlPanelHeaderId").after(globalFilterRow);
				// Silent self-heal for per-user drift (garden words planted by a practice session
				// this tab ran): the sets refetch in the background while typing starts.
				WLFX.freshenUserSets(30000);
				input.focus();
			}

			function closeGlobalFilterRow() {
				if (!globalFilterRow) { return; }
				globalFilterRow.remove();
				globalFilterRow = null;
				if (globalFilter) { exitFilterMode(); }
			}

			function buildSelBar(section, item) {
				var bar = $("<div class='wlSelBarClass'></div>");
				bar.append($("<span class='wlSelCountClass'></span>"));

				// The filter box takes the empty middle of this row — the gap between "N selected"
				// and the bulk actions, which never held anything. My Garden is the one exception:
				// its bands are five lists in a trench coat, and a single box above all of them would
				// filter four lists nobody is looking at, so its boxes sit under each band head.
				if (item.kind !== 'GARDEN' && item.termCount > FILTER_MIN_WORDS) {
					bar.append(buildFilterInput("wlListFilterClass", function () {
						// Every source re-reads the box for itself, so this is just "load again" —
						// smoothly, i.e. without blanking the rows while the answer is in flight.
						loadWords(item.id, true);
					}));
				}

				// Virtual lists are read-only dictionary views: the only bulk action on checked words
				// is copying them OUT into an own list (adding to Practice lives in the header menu).
				if (isVirtualKind(item.kind)) {
					// Icon only, with the label demoted to the tooltip — the same round icon button the
					// own-list bar's ✕ and ⇄ already are. It used to be a labelled pill, which was the
					// widest thing on the row and left the filter box beside it too narrow to read what
					// was typed in it. One bulk action does not need more of the row than two do.
					var copyBtn = $("<button class='pl-btn-icon-round wlSelBarRightClass' type='button'></button>")
						.html(plIcon("copy"));
					copyBtn.assignTooltip("wlCopyWords_tooltip");
					copyBtn.click(function (e) { stopEvent(e); showPopover(copyBtn, getCheckedIds(section), true); });
					bar.append(copyBtn);
					return bar;
				}

				// Practice moved to the list's name row. This bar carries only the bulk actions on the
				// checked words: Remove + Move/Copy, pushed to the right end of the toolbar row
				// (wlSelBarRightClass = margin-left:auto on the first of the pair). Icon-only, same
				// size as the per-row action buttons. Always in the DOM (not hidden at 0 selected) so
				// the toolbar row never shifts; updateSelBar disables them instead.
				var removeBtn = $("<button class='pl-btn-icon-round wlRemoveBtnClass wlSelBarRightClass' type='button'></button>")
					.html(plIcon("x"));
				removeBtn.assignTooltip("wlDeleteWords_tooltip");
				removeBtn.click(function () { removeChecked(section, item, removeBtn); });
				bar.append(removeBtn);

				var moveBtn = $("<button class='pl-btn-icon-round wlMoveCopyBtnClass' type='button'></button>")
					.html(plIcon("arrow-right-left"));
				moveBtn.assignTooltip("wlCopyWords_tooltip");
				moveBtn.click(function (e) { stopEvent(e); showPopover(moveBtn, getCheckedIds(section)); });
				bar.append(moveBtn);

				return bar;
			}

			function toggleSection(wlDbId) {
				hidePopover();
				// Global-filter mode: sections open and close FREELY (several at once) onto
				// their client-side matches — never through expandSection, which enforces the
				// one-open rule, persists the selection and asks the server for rows.
				if (globalFilter) {
					var fItem = listById(wlDbId);
					var fSection = sectionEl(wlDbId);
					if (!fItem || !fSection.length) { return; }
					if (fSection.hasClass("wlExpanded")) {
						closeFilterSection(fSection);
						delete wlxManualOpen[wlDbId];
						delete wlxAutoOpen[wlDbId];
					} else {
						wlxManualOpen[wlDbId] = true;
						openFilterSection(fItem);
					}
					return;
				}
				if (expandedId == wlDbId) { collapseSection(); }
				else { expandSection(wlDbId); }
			}

			function collapseSection() {
				expandedId = null;
				openTopic = null;        // a closed Topics row shows no topic
				accordion.children(".wlSectionClass").removeClass("wlExpanded");
				paintTopicRows();
				// Persist "nothing open" so a reload restores the all-collapsed state too.
				ajaxPostUserAttr("myListValId", "", function () {});
				applyCompactLists();    // a closed row folds back into its chip
				// Beacon tips (spec §6): collapse matters too — the explore trail's Add
				// crumb must fall back to the open-a-list crumb when its list closes.
				if (window.OB_TIPS) { OB_TIPS.evaluate(); }
			}

			// Split out of toggleSection so the topic picker can open a section without re-deriving
			// any of this: picking a topic is an expand whose "which list" is already decided.
			function expandSection(wlDbId) {
				var it = listById(wlDbId);
				// Opening anything else puts the Topics row away, crumb and all.
				if (!it || !isTopicKind(it.kind)) { openTopic = null; }
				expandedId = wlDbId;
				lastCheckedIdx = null;
				rowTermIds = [];
				accordion.children(".wlSectionClass").removeClass("wlExpanded");
				sectionEl(wlDbId).addClass("wlExpanded");
				applyCompactLists();    // reveal the opened row, re-fold whichever one closed
				updateHeaderTight(sectionEl(wlDbId).children(".wlHeaderClass"));   // D11
				paintTopicRows();
				loadWords(wlDbId);
				// Same user attr the old selector persisted → survives reloads and language trips.
				// The Topics row persists WHICH topic with it (TOPIC:TRAVEL): one row stands for
				// eighteen lists, so its id alone would restore the row and not the list.
				ajaxPostUserAttr("myListValId",
					(it && isTopicKind(it.kind) && openTopic) ? ("TOPIC:" + openTopic) : wlDbId,
					function () {});
				// Beacon tips (spec §6): expanding a level list is the add-pill tip's moment.
				if (window.OB_TIPS) { OB_TIPS.evaluate(); }
			}

			// Which load of an own list's words is the current one. The filter box makes this list
			// reloadable on a keystroke, so two requests can now be in flight at once — and the
			// slower one is not always the older one. Without the stamp a late "ab" response would
			// paint itself over the "abs" the user has already finished typing.
			var wordsLoadSeq = 0;

			// `smooth` marks a reload driven by a filter keystroke: the rows already on screen stay put
			// until the replacements arrive, so typing narrows the list instead of blinking it.
			function loadWords(wlDbId, smooth) {
				var item = listById(wlDbId);
				if (item && item.kind === 'GARDEN') {
					loadGardenWords(item);   // sectioned, and its cursor differs per section
					return;
				}
				if (item && isTopicKind(item.kind)) {
					loadTopicWords(item, smooth);   // same endless scroll, one extra cursor component
					return;
				}
				if (item && isVirtualKind(item.kind)) {
					loadLevelWords(item, smooth);   // serves every other virtual list, not just LEVEL_*
					return;
				}
				// Per-list filter, client-side (wl-global-filter.md): the whole list is in the
				// WLFX sets, so a typed filter narrows it with no round trip. Sets not in hand
				// (fetch failed, brand-new list) → the server path below, exactly as before.
				var ownTyped = sectionFilter(sectionEl(wlDbId));
				if (ownTyped && item && WLFX.ownRows(item.id)) {
					startLocalWordStream(item, wlxMatch(WLFX.ownRows(item.id), ownTyped));
					return;
				}
				var seq = ++wordsLoadSeq;
				ajaxPost("wordlist-load-words",
						{ wordListId: wlDbId, filter: ownTyped,
						  termLang: langToValField.attr("data-lang-code") }, function (data) {
					if (expandedId != wlDbId || seq !== wordsLoadSeq) { return; }   // stale
					if (!data || !data.wordList || data.wordList.id != wlDbId) {
						throw Util.exception(getRes("wlCannotLoadWords_error_message"));
					}
					var section = sectionEl(wlDbId);
					// A whole-list (unfiltered) response is the freshest truth about this list —
					// hand it to WLFX so the client-side filter answers from the same rows.
					if (!ownTyped) { WLFX.setOwnRows(wlDbId, data.wordList.terms || []); }
					// An own list arrives whole, so its swap is already atomic — clear and refill
					// happen in this one tick and the eye never sees the gap. All a filter change adds
					// is the jump to the top: it is a new list, not the same list refreshed.
					renderWords(section, data.wordList.terms || []);
					// MY LIST carries the "Phrases I typed" band at its tail — only on the plain
					// (unfiltered) render; a typed filter answers from the merged WLFX source
					// instead, flat, exactly like a filtered garden loses its sections.
					if (item && item.kind === 'DEFAULT' && !ownTyped && !globalFilter) {
						renderTypedBand(item, section);
					}
					if (smooth) {
						var el = section.find(".wlWordsClass")[0];
						if (el) { el.scrollTop = 0; }
					}
				}, getRes("wlCannotLoadWords_error_message"));
			}

			// ── Virtual lists' content: paged straight off the dictionary (endless scroll) ─────
			// Only one section is ever expanded, so one keyset cursor state is enough. Pages of 50
			// append into .wlWordsClass; nearing its bottom fetches the next page; short lists
			// keep fetching until the box is filled or the list runs dry.
			//
			// Both virtual sources share this machinery — they differ only in which endpoint they
			// page and whether a `level` param rides along, so `st` carries the url and the extra
			// params rather than the code branching per source.
			var LEVEL_PAGE = 50;

			// "Not scrollable yet, pull another page" — but only for a box someone can SEE. A hidden
			// box (the word-lists pane folded to its rail, which every portrait tablet loads with)
			// measures 0 ≤ 0, and that used to pull every page of the open list into a pane nobody
			// could see: all 1,405 rows of a level list, each page re-asking the garden about every
			// row so far, until the asks outgrew the server's parameter cap (tablet-support-plan
			// §7e). A hidden box answers "not short" and waits instead: `refill` runs once, when the
			// box is shown again (or never, if it is thrown away first).
			var refillWaits = typeof WeakSet === "function" ? new WeakSet() : null;
			function wlShort(el, refill) {
				if (!el) { return false; }
				if (el.clientHeight > 0) { return el.scrollHeight <= el.clientHeight; }
				if (refill && refillWaits && !refillWaits.has(el) && typeof ResizeObserver === "function") {
					refillWaits.add(el);
					var ro = new ResizeObserver(function () {
						if (!el.isConnected) { ro.disconnect(); refillWaits.delete(el); return; }
						if (el.clientHeight > 0) { ro.disconnect(); refillWaits.delete(el); refill(); }
					});
					ro.observe(el);
				}
				return false;
			}
			var levelScroll = null;   // { listId, url, params, lastTerm, lastId, atEnd, loading }
			// One-shot jump target for the band chip's click-through (openLevelAtWord): the next
			// level stream starts AT this word (server resolves the keyset cursor under the active
			// sort from startTermId) and highlights its row when it lands.
			var levelJump = null;     // { termId, term }

			// `smooth` = this reload is a filter keystroke, not an open or a refresh. The rows are then
			// left ON SCREEN until the new page actually lands (pendingReset, consumed in
			// loadLevelPage) instead of being cleared here. Clearing here is what made the list blink
			// on every letter: the box emptied on the keystroke and refilled a round trip later, so
			// the eye saw a flash of nothing between each pair of results.
			function loadLevelWords(item, smooth) {
				var isVerbs = isVerbKind(item.kind);
				// Per-list filter, client-side: the list's members are in the WLFX payload, so a
				// typed filter narrows them locally — same pages, same paint, no round trips.
				// No payload (fetch failed / unconfigured pair) → the server stream unchanged.
				var lvTyped = sectionFilter(sectionEl(item.id));
				var lvSrc = lvTyped ? filterSourceRows(item) : null;
				if (lvSrc) {
					startLocalWordStream(item, wlxMatch(lvSrc, lvTyped));
					return;
				}
				// The filter is read ONCE, into the cursor state: every page of this stream has to be
				// drawn from the same list, and re-reading the box mid-stream would splice two
				// different lists together on a keystroke that landed between two pages.
				levelScroll = {
					listId: item.id,
					url: isVerbs ? "wordlist-verb-words" : "wordlist-level-words",
					// The verb endpoint is keyed by KIND the way the level one is by level code:
					// the two verb lists are different verbs of the same language.
					params: isVerbs ? { kind: item.kind } : { level: levelCode(item.kind) },
					filter: sectionFilter(sectionEl(item.id)),
					pendingReset: !!smooth,
					lastTerm: "", lastId: 0, atEnd: false, loading: false };
				// The band lists' frequency sort rides the SAME stream with the rank-led keyset
				// the topic lists already use — the endpoint returns each row's rank so the
				// cursor feeds itself. (A typed per-list filter answers locally from the WLFX
				// payload above, which is alphabetical — a filter is a search, so that stays.)
				if (!isVerbs && isLevelKind(item.kind) && levelSortMode === "FREQ") {
					levelScroll.params.sort = "FREQ";
					levelScroll.lastRank = 0;
				}
				// The chip's click-through: the first page starts at the clicked word (the server
				// derives the just-before cursor under the active sort) and its row pulses once.
				if (levelJump && !isVerbs && isLevelKind(item.kind)) {
					levelScroll.startTermId = levelJump.termId;
					levelScroll.highlightId = levelJump.termId;
					levelJump = null;
				}
				gardenScroll = null;
				var section = sectionEl(item.id);
				if (!smooth) { renderWords(section, []); }   // reset rows/selection; select-all shows once rows land
				var wordsEl = section.find(".wlWordsClass");
				wordsEl.off("scroll.wlLevel scroll.wlGarden").on("scroll.wlLevel", function () {
					if (this.scrollTop + this.clientHeight >= this.scrollHeight - 150) {
						loadLevelPage(item);
					}
				});
				loadLevelPage(item);
			}

			function loadLevelPage(item) {
				var st = levelScroll;
				if (!st || st.listId !== item.id || st.loading || st.atEnd) { return; }
				st.loading = true;
				var params = {
					termLang: langToValField.attr("data-lang-code"),
					defLang: langFromValField.attr("data-lang-code"),
					filter: st.filter || "",
					lastTerm: st.lastTerm,
					lastId: st.lastId,
					limit: LEVEL_PAGE
				};
				// A topic list is ordered by learner rank, so its keyset leads with the rank and the
				// (term, id) pair only breaks ties. Present on that stream alone — the alphabetic
				// sources never set it and their endpoints would ignore it anyway.
				if (st.lastRank != null) { params.lastRank = st.lastRank; }
				// My phrases' extra cursor component — same arrangement as lastRank above, present
				// only on that one stream (the alphabetic sources never set it).
				if (st.lastCapturedTs != null) { params.lastCapturedTs = st.lastCapturedTs; }
				// The chip click-through's start-at-word marker — FIRST page only; later pages
				// walk the ordinary cursor the first page handed back.
				if (st.startTermId) { params.startTermId = st.startTermId; st.startTermId = 0; }
				for (var k in st.params) {
					if (st.params.hasOwnProperty(k)) { params[k] = st.params[k]; }
				}
				ajaxPost(st.url, params, function (data) {
					st.loading = false;
					// Stale: the user opened another section (or re-opened, replacing the state).
					if (expandedId != item.id || levelScroll !== st) { return; }
					var words = (data && data.words) || [];
					st.atEnd = !data || !!data.atEnd;
					if (words.length) {
						var last = words[words.length - 1];
						st.lastTerm = last.term;
						st.lastId = last.id;
						if (st.lastRank != null && last.rank != null) { st.lastRank = last.rank; }
						if (st.lastCapturedTs != null && last.capturedTs != null) {
							st.lastCapturedTs = last.capturedTs;
						}
					}
					var section = sectionEl(item.id);
					// The old filter's rows come off HERE, one tick before the new ones go on, so the
					// swap happens inside a single frame and the list never shows empty. Only the
					// first page of a stream carries the flag.
					if (st.pendingReset) {
						st.pendingReset = false;
						resetRows(section, true);
					}
					appendWords(section, words);
					// The chip click-through's landing: the word leads the page it asked for —
					// pulse its row once so the eye finds what the click meant.
					if (st.highlightId) {
						var jumpRow = section.find(
							".wlWordRowClass[data-term-id='" + st.highlightId + "']");
						if (jumpRow.length) {
							jumpRow.addClass("wlRowJumpClass");
							st.highlightId = 0;
						}
					}
					// A short level (or a tall panel): keep filling until scrollable or dry.
					var el = section.find(".wlWordsClass")[0];
					if (!st.atEnd && wlShort(el, function () { loadLevelPage(item); })) {
						loadLevelPage(item);
					} else if (st.atEnd && !section.find(".wlWordRowClass").length) {
						// A virtual list normally suppresses the empty state (its rows arrive late,
						// and "nothing here" flashing before them reads as a broken list). Once the
						// stream is genuinely dry with nothing in it, though, there IS something to
						// say — and under a filter it is the only answer the user gets.
						section.find(".wlWordsClass").append($("<div class='wlEmptyClass'></div>")
							.text(getRes(st.filter ? "wlNoMatch_message" : "wlEmptyList_message")));
					}
				}, getRes("wlCannotLoadWords_error_message"));
			}

			// ── "My Garden": the sections in one endless scroll ───────────────────────────────
			// One population — every word the user has actually touched — partitioned by what to do
			// about it next, in a fixed order (most actionable first, but finish what you started
			// before starting more). Words cross between sections as a DEADLINE passes, with nobody
			// doing anything, which is exactly why this is one list with headers rather than several
			// lists: the motion stays continuous and legible instead of words teleporting between
			// panel rows while the user watches. Two of the bands are OVERLAYS rather than lifecycle
			// states: "Difficult words" (top — its words also sit in their lifecycle band) and
			// "Set aside" (bottom — the parked words, which leave the lifecycle bands entirely).
			//
			// The section counts arrive FIRST, in their own request, so the headers render carrying
			// the right numbers before a single row lands. Rows then stream in beneath them, one
			// section at a time, rolling into the next when one runs dry.
			var GARDEN_SEC_RES = {
				STRUGGLING: "wlGardenDifficult_label",
				WATERING: "wlGardenWatering_label",
				PROGRESS: "wlGardenProgress_label",
				READY:    "wlGardenReady_label",
				GROWING:  "wlGardenGrowing_label",
				SET_ASIDE: "wlGardenSetAside_label"
			};
			// The band names are the shortest honest phrasing of the different states, and some of
			// them ("Ready for practice", "Needs watering") are longer than a narrow panel can show —
			// CSS clips them to "READY FOR P…". The tooltip therefore carries BOTH: the full name and
			// one sentence on what the band means, since the name alone ("Growing") never says what
			// you are supposed to do about it.
			var GARDEN_SEC_TIP = {
				STRUGGLING: "wlGardenDifficult_tooltip",
				WATERING: "wlGardenWatering_tooltip",
				PROGRESS: "wlGardenProgress_tooltip",
				READY:    "wlGardenReady_tooltip",
				GROWING:  "wlGardenGrowing_tooltip",
				SET_ASIDE: "wlGardenSetAside_tooltip"
			};
			// The two overlay bands are hidden rather than shown at zero. The lifecycle four describe
			// states every word passes through, so "Growing 0" is information. These two describe an
			// exception — "Difficult words 0" is good news and "Set aside 0" means the user never
			// parked anything — and a header that is always there reads as a standing reproach for a
			// garden that is doing perfectly well.
			function gardenSecHiddenWhenEmpty(key) {
				return key === "STRUGGLING" || key === "SET_ASIDE";
			}

			// { listId, secs: [{key, count, lastTerm, lastId, lastBucket, atEnd}], idx, loading, maxAddAll }
			var gardenScroll = null;

			// Which bands the user has folded away, by section key. Deliberately NOT persisted: a
			// fold is a "get this out of my way while I work through the rest" gesture, and a garden
			// that came back next morning with three bands hidden would be hiding the very words it
			// exists to surface. It DOES survive a list reload within the session (a park, a drill
			// coming back, softRefresh), because those redraw the bands under the user's hands.
			var gardenSecFolded = {};

			function gardenSecIsFolded(key) {
				return !!gardenSecFolded[key];
			}

			function langParams() {
				return {
					termLang: langToValField.attr("data-lang-code"),
					defLang: langFromValField.attr("data-lang-code")
				};
			}

			// Wake a resting word (§6.6) — or park one, though since the difficult-words redesign the
			// park control lives in the pre-exercise trays (parkFromTray), so from the garden this
			// runs wake-only. The whole list is reloaded rather than the single row patched in place:
			// the word changes SECTION (it leaves Set aside for its lifecycle band, or the other way
			// round) and the band counts move with it, so a row-local update would leave the headers
			// lying about what is below them.
			// No confirmation and no toast: the row moves to the resting group and dims, which IS the
			// feedback, and a modal for a one-click action that one click undoes would be noise.
			function setWordParked(termId, parked) {
				ajaxPost("api/garden/park", { termId: termId, parked: parked }, function () {
					if (expandedId) { loadWords(expandedId); }
				}, getRes("wlRowParkFailed_error_message"));
			}

			function loadGardenWords(item) {
				levelScroll = null;
				gardenScroll = null;
				var section = sectionEl(item.id);
				renderWords(section, []);   // reset rows/selection before the counts land
				ajaxPost("wordlist-garden-sections", langParams(), function (data) {
					if (expandedId != item.id) { return; }   // stale: another section was opened
					var st = {
						listId: item.id,
						maxAddAll: (data && data.maxAddAll) || 200,
						idx: 0,
						loading: false,
						secs: $.map((data && data.sections) || [], function (s) {
							// A zero-count section is already exhausted — never ask for its page.
							return { key: s.key, count: s.count, lastTerm: "", lastId: 0,
								lastBucket: 0, atEnd: !s.count };
						})
					};
					gardenScroll = st;
					renderGardenSections(item, st);
					var wordsEl = section.find(".wlWordsClass");
					wordsEl.off("scroll.wlLevel scroll.wlGarden").on("scroll.wlGarden", function () {
						if (this.scrollTop + this.clientHeight >= this.scrollHeight - 150) {
							loadGardenPage(item);
						}
					});
					loadGardenPage(item);
				}, getRes("wlCannotLoadWords_error_message"));
			}

			function renderGardenSections(item, st) {
				var section = sectionEl(item.id);
				var wordsEl = section.find(".wlWordsClass").empty();
				rowTermIds = [];
				lastCheckedIdx = null;
				var total = 0;
				for (var i = 0; i < st.secs.length; i++) { total += st.secs[i].count; }
				section.find(".wlCheckAllClass").prop("checked", false).toggle(total > 0);
				if (!total) {
					// The list is shown even when empty (a new garden fills over days, and a list
					// that appears from nowhere reads worse) — so it needs a hint of its own rather
					// than the generic "add words from the Dictionary": nothing is ADDED here.
					wordsEl.append($("<div class='wlEmptyClass'></div>").text(getRes("wlGardenEmpty_message")));
					updateSelBar(section);
					return;
				}
				for (var j = 0; j < st.secs.length; j++) {
					if (!st.secs[j].count && gardenSecHiddenWhenEmpty(st.secs[j].key)) { continue; }
					wordsEl.append(buildGardenSection(item, st, st.secs[j]));
				}
				updateSelBar(section);
			}

			function buildGardenSection(item, st, sec) {
				var box = $("<div class='wlGardenSecClass'></div>").attr("data-gsec", sec.key)
					.toggleClass("wlGardenSecFoldedClass", gardenSecIsFolded(sec.key));
				var head = $("<div class='wlGardenSecHeadClass'></div>");
				// The band head folds its own rows away on a click — the bands are five, several run
				// to hundreds of words, and reaching Growing used to mean scrolling the whole garden.
				// The head itself is the target, not a hit-area-sized control: everything on the row
				// that means something else — the select-all box, the Add button — already stops its
				// own clicks, so the rest of the row is free to be one large, obvious control.
				// The band's COUNT stays visible while folded, so a folded band still reports itself.
				head.click(function () { toggleGardenSection(item, sec.key); });

				// A band is a list in its own right — its four adds mean four different things — so it
				// gets the same select-all affordance the list header carries, on the LEFT of the name
				// where the row checkboxes below already line up. Its count is the bare number, not
				// "N selected": the band name owns the middle of this row and there is no width for a
				// word neither cluster needs. The pair only exists once the band HAS rows (updateSelBar
				// → updateGardenSecBars toggles it as they stream in): a checkbox over nothing to check
				// is a dead control, and "Needs watering 0" is good news, not a thing to act on.
				// "Set aside" carries NO selection pair: with no bulk menu on the band (below) a
				// select-all could only feed nothing. The bare cluster span still reserves the
				// column so its title lines up with its neighbours'.
				var selCluster = $("<span class='wlGardenSecSelClass wlSecSelEmptyClass'></span>");
				if (sec.key !== "SET_ASIDE") {
					var secCheck = $("<input type='checkbox' class='wlGardenSecCheckClass'/>");
					secCheck.assignTooltip("wlGardenSecCheckAll_tooltip");
					var secCount = $("<span class='wlGardenSecCountClass'></span>").text(0);
					secCheck.change(function () {
						var boolState = secCheck.is(":checked");
						box.find(".wlRowCheckClass").prop("checked", boolState)
							.closest(".wlWordRowClass").toggleClass("wlRowCheckedClass", boolState);
						lastCheckedIdx = null;   // a band-wide toggle is no anchor for a shift range
						updateSelBar(sectionEl(item.id));
					});
					secCheck.click(function (e) { e.stopPropagation(); });
					// Hidden as ONE cluster (not two hidden children), and hidden by VISIBILITY, not
					// by display: the empty band must still reserve the column, or its name centres
					// in a wider gap than its neighbours' and the titles stop lining up with each
					// other — the same "hold the column whether or not it is filled" rule the row
					// plant and day badge already follow (garden.css).
					selCluster.append(secCheck).append(secCount);
				}
				head.append(selCluster);

				head.append($("<span class='wlGardenSecTitleClass'></span>")
					.text(getRes(GARDEN_SEC_RES[sec.key] || ""))
					.assignTooltip(function () {
						// Full name (the band itself may be clipped) over the one-line explanation.
						return "<b>" + escHtml(getRes(GARDEN_SEC_RES[sec.key] || "")) + "</b><p/>"
							+ escHtml(getRes(GARDEN_SEC_TIP[sec.key] || ""));
					}));
				var pill = $("<span class='pl-count-pill'></span>").text(sec.count);
				pill.assignTooltip("wlWordCount_tooltip");
				head.append(pill);
				// Each section carries its own Add menu — the adds mean different things per
				// section, which is the whole reason the list-wide one is gone. Its face follows
				// the active tab like every other add affordance (setActiveTab repaints it).
				// An EMPTY band disables it outright (same rule as an empty list's header pill):
				// its menu could only answer every choice with "nothing here".
				// "Set aside" has no bulk add at all — a sweep that staged parked words would undo
				// the setting-aside unasked; the per-ROW add stays, because a word the user picks
				// by name is a decision, not a sweep. The button is kept invisible (not dropped) so
				// the Add-button column lines up across bands.
				var menuBtn = $("<button class='pl-btn-icon-round wlGardenSecAddClass' type='button'></button>")
					.html(addDestIcon());
				if (sec.key === "SET_ASIDE") {
					menuBtn.prop("disabled", true).css("visibility", "hidden");
				} else {
					menuBtn.prop("disabled", !sec.count);
					menuBtn.assignTooltip(function () {
						return getRes(addDestIsLearning() ? "wlAddMenuHeaderLearn_label" : "wlAddMenuHeader_label");
					});
					menuBtn.click(function (e) { stopEvent(e); openGardenSectionMenu(menuBtn, item, st, sec, box); });
				}
				head.append(menuBtn);
				// The head and its filter box stick to the top of the scroll together, as ONE block.
				// A sticky head plus a separately-sticky filter row would need the filter's offset to
				// equal the head's rendered height — a number that changes with the font, the locale's
				// longer band names and the panel's width, and that is wrong in exactly the case the
				// filter exists for (a band long enough to scroll).
				// plStickyHeadClass is the scroll pager's marker: the up bar pins to this
				// surface's top edge, which is the very strip this block parks on, and its
				// chevrons DO take the pointer — so without the marker a click on the middle of
				// a band head pages the list up instead of folding the band.
				var sticky = $("<div class='wlGardenSecStickyClass plStickyHeadClass'></div>").append(head);
				// A band past the threshold gets its OWN filter box, on its own row BELOW the head.
				// Not on the head itself: that row is already carrying a select-all, a name, a count
				// and an Add menu inside a panel narrow enough to clip the name, and it is
				// also the fold control — a text field inside a click-to-fold row is a trap. Below it
				// the box spans the band's full width and reads as belonging to the rows it governs.
				if (sec.count > FILTER_MIN_WORDS) {
					sticky.append($("<div class='wlGardenSecFilterClass'></div>")
						.append(buildFilterInput("wlBandFilterClass", function (typed) {
							sec.filter = typed;
							refilterGardenSection(item, sec);
						})));
				}
				box.append(sticky);
				box.append($("<div class='wlGardenSecRowsClass'></div>"));
				return box;
			}

			// A band's filter changed: throw away that band's rows and page it again from the top,
			// leaving every other band exactly as it stands. Per band and not per list because the
			// bands ARE separate lists — re-streaming the whole garden to narrow one of them would
			// scroll the user's place out from under them in the four they did not touch.
			function refilterGardenSection(item, sec) {
				// The band's CURRENT rows stay on screen until the new page lands (pendingReset,
				// consumed in loadGardenPage) — emptying here is what made the band blink on every
				// letter typed.
				sec.pendingReset = true;
				// Any page of THIS band still on the wire was fetched under the old filter and must
				// not land in the band we are about to refill — the generation stamp is what tells
				// its callback that its rows are no longer wanted.
				sec.gen = (sec.gen || 0) + 1;
				sec.lastTerm = "";
				sec.lastId = 0;
				sec.lastBucket = 0;
				sec.atEnd = !sec.count;
				loadGardenPage(item, sec.key);
			}

			// Fold or unfold one band, in place. The rows are HIDDEN, not dropped: they were paid for
			// already, and unfolding has to be instant or the fold reads as a reload.
			//
			// Then re-fill: folding frees a screenful of height, so the bands still open below may no
			// longer reach the bottom of the box — and the endless scroll only ever fires on a scroll
			// event, which a fold does not produce. (loadGardenPage skips folded bands on its own, so
			// unfolding one likewise has to hand the filler back to it.)
			function toggleGardenSection(item, key) {
				var box = sectionEl(item.id).find(".wlGardenSecClass[data-gsec='" + key + "']");
				// A BAND THAT SHOWS NOTHING CANNOT BE FOLDED — there is nothing to fold away, and the
				// click would change not one pixel. It is not a rare state: an empty rows box is
				// display:none, so a band whose rows have not arrived looks exactly like a folded one,
				// and straight after a page load THE WHOLE GARDEN is in that state while it streams
				// in. Fold it and the pages already on the wire land into a box nobody can see — so
				// the click that finally shows the words is the SECOND one. Reported as "after a
				// refresh it takes two clicks to open a band", and that is precisely what it was: the
				// first click was spent folding something that was already invisible.
				var rowless = !box.find(".wlGardenSecRowsClass").children().length;
				var folded = rowless ? false : !gardenSecIsFolded(key);
				gardenSecFolded[key] = folded;
				box.toggleClass("wlGardenSecFoldedClass", folded);
				// …and a click on such a band means OPEN, so go and get its rows. fillGardenIfShort
				// alone cannot: it fires only while the box does not scroll, and a garden with any
				// other band open always scrolls. Besides the streaming case above, a band arrives
				// rowless when the endless scroll never reached it, or when it was folded across a
				// rebuild (renderGardenSections drops every row, and loadGardenPage then skips it for
				// as long as it stays folded). loadGardenPage minds itself here: an exhausted band
				// returns at once, and a band with a page already on the wire is parked as the refill
				// rather than fetched twice.
				if (rowless) { loadGardenPage(item, key); }
				fillGardenIfShort(item);
			}

			// Keep pulling pages — across band boundaries — until the box actually scrolls or the
			// whole garden is on screen.
			function fillGardenIfShort(item) {
				var el = sectionEl(item.id).find(".wlWordsClass")[0];
				if (wlShort(el, function () { fillGardenIfShort(item); })) { loadGardenPage(item); }
			}

			// One page of the section currently being filled; when it runs dry the next section
			// takes over, so the user scrolls through the whole garden without ever asking for it.
			// `forceKey` pins the page to ONE band regardless of whose turn it is — the band whose
			// filter box just changed, which has to refill immediately even though bands above it may
			// still be mid-stream and would otherwise take every page for themselves.
			function loadGardenPage(item, forceKey) {
				var st = gardenScroll;
				if (!st || st.listId !== item.id) { return; }
				if (st.loading) {
					// A page for some band is already on the wire. An ordinary walk simply waits for
					// the next scroll event, but a REFILL cannot be dropped — its band has just been
					// emptied and nothing else would ever come back for it. Park the key; the landing
					// response picks it up.
					if (forceKey) { st.refill = forceKey; }
					return;
				}
				var sec = null;
				if (forceKey) {
					for (var i = 0; i < st.secs.length; i++) {
						if (st.secs[i].key === forceKey) { sec = st.secs[i]; break; }
					}
					if (!sec || sec.atEnd) { return; }
				} else {
					// Recomputed from the top on every call rather than advanced monotonically, because
					// FOLDED bands are skipped and a fold is reversible: pouring page after page into a
					// box nobody can see would spend the entire scroll budget on hidden rows, and once
					// the cursor had walked past a band it could never be sent back when it reopened.
					st.idx = 0;
					while (st.idx < st.secs.length
							&& (st.secs[st.idx].atEnd || gardenSecIsFolded(st.secs[st.idx].key))) {
						st.idx++;
					}
					if (st.idx >= st.secs.length) { return; }
					sec = st.secs[st.idx];
				}
				st.loading = true;
				var gen = sec.gen || 0;
				var params = langParams();
				params.section  = sec.key;
				params.filter   = sec.filter || "";
				params.lastBucket = sec.lastBucket;   // ignored by the two alphabetic sections
				params.lastTerm = sec.lastTerm;
				params.lastId   = sec.lastId;
				params.limit    = LEVEL_PAGE;
				ajaxPost("wordlist-garden-words", params, function (data) {
					st.loading = false;
					// A refill that arrived while this page was in flight goes first: its band is
					// sitting empty, and nothing else will come back for it.
					var pending = st.refill;
					st.refill = null;
					if (pending) { loadGardenPage(item, pending); }
					// Stale: the user opened another section (or re-opened, replacing the state), or
					// this band's filter moved on while the page was on the wire.
					if (expandedId != item.id || gardenScroll !== st || (sec.gen || 0) !== gen) { return; }
					var words = (data && data.words) || [];
					sec.atEnd = !data || !!data.atEnd;
					if (words.length) {
						var last = words[words.length - 1];
						sec.lastTerm = last.term;
						sec.lastId = last.id;
						// The two PLANTED sections lead with urgency, so their cursor carries the
						// day bucket as well — the one place the alphabetic (term, id) contract is
						// not enough. The other two never send one back and leave this at 0.
						if (last.dueBucket != null) { sec.lastBucket = last.dueBucket; }
					}
					var section = sectionEl(item.id);
					var rows = section
						.find(".wlGardenSecClass[data-gsec='" + sec.key + "'] .wlGardenSecRowsClass");
					// The old filter's rows come off one tick before the new ones go on, so the swap
					// happens inside a single frame and the band never shows empty. Only this ONE band
					// is touched; the flat row index that shift-range selection walks is then rebuilt
					// from the DOM, and a selection made against rows that just vanished is no anchor.
					if (sec.pendingReset) {
						sec.pendingReset = false;
						rows.empty();
						rowTermIds = $.map(section.find(".wlWordRowClass"),
							function (el) { return +$(el).attr("data-term-id"); });
						lastCheckedIdx = null;
					}
					appendWords(section, words, rows);
					if (!forceKey) {
						fillGardenIfShort(item);   // a short band, or a tall panel: keep going
						return;
					}
					// Refilling one band after its filter changed: keep pulling THAT band until it
					// fills the box or runs dry, then hand the scroll back to the ordinary walk so the
					// bands below it still fill (a short box fires no scroll event to restart them).
					var el = section.find(".wlWordsClass")[0];
					if (!sec.atEnd && wlShort(el, function () { loadGardenPage(item, forceKey); })) {
						loadGardenPage(item, forceKey);
						return;
					}
					if (!rows.children().length) {
						rows.append($("<div class='wlEmptyClass'></div>")
							.text(getRes(sec.filter ? "wlNoMatch_message" : "wlEmptyList_message")));
					}
					fillGardenIfShort(item);
				}, getRes("wlCannotLoadWords_error_message"));
			}

			// The per-section Add menu: All (only under the cap) / Selected (N) within this section /
			// Random ▸, plus "Continue in Learn" on the In-progress section. Rides the same single
			// floating-menu chassis as the list header's menu.
			function openGardenSectionMenu(btn, item, st, sec, box) {
				if (!document.contains(btn[0])) { return; }
				closeAddMenu();
				hidePopover();
				closeSortMenu();
				addMenuEl = $("<div class='wlPopoverClass wlAddMenuClass'></div>");
				addMenuFor = btn[0];
				btn.addClass("wlAddOpenClass");
				var addSrc = box[0] || btn[0];

				addMenuEl.append($("<div class='wlAddMenuHeadClass'></div>")
					.text(getRes(GARDEN_SEC_RES[sec.key] || "")));

				function stage(ids, replace) {
					armTrayFly(addSrc, null);   // bulk → frame embraces the whole tray
					if (addDestIsLearning()) { addWordsToLearning(ids, replace !== false); }
					else { addWordsToPractice(ids, replace !== false); }
				}
				// A garden band pages 50 at a time, so it holds the whole band only once the scroll
				// has run it dry — which for a band under a page (the usual case) is immediately.
				// `sec.filter` is the band's OWN filter box, not the list's.
				var bandIds = renderedIdsIfComplete(box, sec.count, sec.filter);

				// The section's twin of the list menu's wiring: the choice is asked at the end of the
				// pick, and only over a tray that has something to lose. The ids are still fetched
				// AFTER the answer, so a "Replace tray" the user backs out of (Esc) costs no request —
				// `ids` here only informs the ARITHMETIC, and is null whenever it would be a guess.
				function stageAsked(itemEl, incoming, fetchIds, ids) {
					wireAddAction(itemEl, function (replace) {
						fetchIds(function (fetched) { stage(fetched, replace); });
					}, incoming, null, ids);
				}
				// The server draws Random itself, so a sample is of the WHOLE section rather than
				// of whatever the first page happened to hold.
				function withSectionIds(randomCount, onIds) {
					var params = langParams();
					params.section = sec.key;
					params.randomCount = randomCount || 0;
					ajaxPost("wordlist-garden-term-ids", params, function (data) {
						var ids = (data && data.termIds) || [];
						if (!ids.length) { showMessage(getRes("wlEmptyList_message")); return; }
						onIds(ids);
					}, getRes("wlCannotLoadWords_error_message"));
				}

				// A whole-section add is offered only while the section is small enough to stage in
				// one go. Past the cap the item is DISABLED with a tooltip pointing at Random —
				// never hidden (an item that comes and goes reads as a bug) and never a silent
				// truncation. An EMPTY section disables it too, but says so honestly: "too many
				// words" on a section holding none would be nonsense.
				function disableOverCap(menuItem) {
					menuItem.addClass("wlMenuDisabledClass");
					menuItem.assignTooltip(function () {
						return sec.count
							? strFormat(getRes("wlGardenAll_disabled_tooltip"), st.maxAddAll)
							: getRes("wlGardenSecEmpty_tooltip");
					});
					menuItem.click(function (e) { stopEvent(e); });
				}
				function withinCap() { return sec.count > 0 && sec.count <= st.maxAddAll; }

				var allItem = addMenuItem(allMenuLabel(sec.count));
				if (withinCap()) {
					stageAsked(allItem, sec.count,
						function (onIds) { withSectionIds(0, onIds); }, bandIds);
				} else {
					disableOverCap(allItem);
				}
				addMenuEl.append(allItem);

				var selIds = getCheckedIds(box);
				var selItem = addMenuItem(getRes("wlMenuSelected_label")
					+ (selIds.length ? " (" + selIds.length + ")" : ""));
				if (selIds.length) {
					stageAsked(selItem, selIds.length, function (onIds) { onIds(selIds); }, selIds);
				} else {
					selItem.addClass("wlMenuDisabledClass");
					// No tooltip — see the band menu's "Selected" (owner, 2026-10-08).
					selItem.click(function (e) { stopEvent(e); });
				}
				addMenuEl.append(selItem);

				var randomItem = $("<div class='wlPopoverItemClass wlMenuParentClass wlMenuRandomClass'></div>");
				randomItem.append($("<span></span>").text(getRes("wlMenuRandom_label")));
				randomItem.append($("<span class='wlMenuArrowClass'>" + plIcon("chevron-right") + "</span>"));
				var sub = $("<div class='wlAddSubMenuClass wlPopoverClass'></div>");
				buildCountItems(sub, function (n, replace) {
					withSectionIds(n, function (ids) { stage(ids, replace); });
				}, item);
				randomItem.append(sub);
				wireSubMenu(randomItem);
				addMenuEl.append(randomItem);

				// The "finish what you started" nudge, as a discoverable affordance rather than a
				// hidden routing rule: on the In-progress section only, one click switches to the
				// Learn tab AND stages the words. Everything else here obeys the app-wide rule that
				// the destination is whichever tab you are on.
				if (sec.key === 'PROGRESS') {
					var contItem = addMenuItem(getRes("wlGardenContinueLearn_label"));
					if (withinCap()) {
						// This one always targets the LEARN tray whatever tab you are on, so its
						// question is about the learn tray too — wireAddAction otherwise reads the
						// destination from the active tab, hence the explicit `learning` here.
						wireAddAction(contItem, function (replace) {
							withSectionIds(0, function (ids) {
								armTrayFly(addSrc, null);
								addWordsToLearning(ids, replace);
								if (window.openLearnTab) { window.openLearnTab(); }
							});
						}, sec.count, true, bandIds);
					} else {
						disableOverCap(contItem);
					}
					addMenuEl.append(contItem);
				}

				finishAddMenu(btn, addMenuEl);
			}

			// Drop the rows and the selection that went with them, WITHOUT painting an empty state —
			// the caller is about to refill. Split out of renderWords for the filter, which must not
			// blank the list between the keystroke and the page landing (see loadLevelWords).
			function resetRows(section, toTop) {
				// If an undo peel is mid-flight when the words get re-rendered from the server,
				// hard-cancel it (its detached rows are about to be replaced) — the removal stays
				// committed; the fresh render already reflects it.
				var pendingPeel = section.data("wlPeel");
				if (pendingPeel) { pendingPeel.cancel(); }
				var wordsEl = section.find(".wlWordsClass");
				wordsEl.empty();
				rowTermIds = [];
				lastCheckedIdx = null;
				section.find(".wlCheckAllClass").prop("checked", false);
				// A filter change is a NEW list, so it starts at the top; an ordinary refresh keeps
				// the reader where they were.
				if (toTop && wordsEl.length) { wordsEl[0].scrollTop = 0; }
			}

			function renderWords(section, termArr) {
				var wordsEl = section.find(".wlWordsClass");
				var keepScroll = wordsEl.length ? wordsEl[0].scrollTop : 0;   // a refresh must not jump to the top
				resetRows(section);
				section.find(".wlCheckAllClass").toggle(termArr.length > 0);
				if (!termArr.length && !section.hasClass("wlLevelClass")) {
					// "This list is empty" is the wrong sentence when the list is full and the filter
					// is what emptied the view — the user would go looking for words they already have.
					wordsEl.append($("<div class='wlEmptyClass'></div>")
						.text(getRes((sectionFilter(section) || globalFilter)
							? "wlNoMatch_message" : "wlEmptyList_message")));
					updateSelBar(section);
					return;
				}
				appendWords(section, termArr);
				if (keepScroll && wordsEl.length) { wordsEl[0].scrollTop = keepScroll; }
			}

			// Append rows (initial render and every scroll page go through here) — indexes continue
			// from what's already there, so shift-range selection spans pages seamlessly.
			//
			// `target` sends the rows somewhere OTHER than the words box itself — My Garden's
			// per-section row containers. Rows still land in reading order across sections (each
			// section is filled before the next starts), so rowTermIds keeps matching the DOM order
			// that shift-range selection walks.
			function appendWords(section, termArr, target) {
				// A rebuild (filter keystroke, band re-stream, a × that reloaded the list) throws
				// away the rows — including whichever one owns the floating cluster. Put it back
				// before its row stops existing.
				closeRowActions();
				var wordsEl = section.find(".wlWordsClass");
				var into = target && target.length ? target : wordsEl;
				// My Garden's In-progress section shows how far up the learning ladder each word
				// got — the same dots the Learn tray uses, keyed by term instead of by sense. Only
				// that section: elsewhere the word is planted or graduated and the plant says it,
				// which is also why those rows lead with the dots INSTEAD of the plant column.
				var isProgress = !!into.closest(".wlGardenSecClass[data-gsec='PROGRESS']").length;
				// Difficult-words rows carry the band's own affordance — the treatment panel; the
				// park control moved OFF these rows (difficult-words redesign D10: setting a word
				// aside must never read as the app's suggested answer to difficulty). Set-aside rows
				// carry the wake control instead — the one gesture that band exists for.
				var isStruggling = !!into.closest(".wlGardenSecClass[data-gsec='STRUGGLING']").length;
				var isSetAside = !!into.closest(".wlGardenSecClass[data-gsec='SET_ASIDE']").length;
				// Which filter box governs these rows — the band's own inside My Garden, the list's
				// everywhere else — so each word can be built with its matched letters already blue
				// instead of being repainted afterwards.
				// The GLOBAL filter is the fallback in both branches: in filter mode the rows are
				// its matches (a filter-mode garden band has no box of its own), and the paint has
				// to say which letters earned each row its place.
				var band = into.closest(".wlGardenSecClass");
				var filter = band.length
					? ($.trim(band.find(".wlBandFilterClass").val() || "") || globalFilter)
					: (sectionFilter(section) || globalFilter);
				var before = into.children().length;
				for (var i = 0; i < termArr.length; i++) {
					into.append(buildRow(section, termArr[i], isProgress, isStruggling, isSetAside, filter));
					rowTermIds.push(termArr[i].id);
				}
				if (rowTermIds.length) { section.find(".wlCheckAllClass").show(); }
				updateSelBar(section);
				// Paint planted words' stage plants + day badges by term id — THIS page's rows only.
				// Decorating all of `into` re-asked the server about every earlier page on each new
				// one, so an endless scroll's asks grew with the list (50, 100, … 1,405 ids).
				GARDEN.decorate(into.children().slice(before));
				if (isProgress && window.LRN) { LRN.decorateTermRows(into); }
				// An ENTER pressed while these very rows were on the wire is waiting for them.
				if (filterOpenWanted) { tryFilterOpen(); }
			}

			// ── The row's hover surface: the action cluster, and the word it would have eaten ──
			// The buttons take their ~5em slot only while a row is pointed at (see
			// .wlRowActionsClass) — which in a narrow panel means POINTING at a row is what
			// shortens its word, sometimes to nothing. So the reveal is measured instead of
			// automatic: the cluster goes inline only where there is already free space to the
			// right of the word for it, and otherwise into a box on the row's top edge,
			// right-aligned, leaving the word its full width.
			//
			// The box holds the ROW'S OWN cluster, moved — not a copy. Cloning would mean two
			// sets of buttons and two sets of handlers to keep in step; moving means the sound,
			// add, move, ×, wake and phrase buttons behave in the box exactly as they do in the
			// row, because they ARE those buttons. `closeRowActions` puts them back.
			//
			// And when the word does not fit the panel even with the cluster gone, the box leads
			// with the FULL word, clickable, opening the same rich entry the row's word opens.
			// That used to be a second popup of its own (a PL.tip below the row) and the two
			// collided on exactly the rows that needed both — a 210px panel put the tip and the
			// cluster in the same place. One surface per row instead: the word can never be
			// clipped without the cluster floating (the fit test says so below), so there is no
			// case left for a separate tip.
			var actionPop = null;        // the floating box, or null
			var actionPopRow = null;     // what the box currently belongs to
			var actionMachine = null;

			// How the row's hover should be drawn, measured with the cluster still OUT of flow so
			// the answer never depends on the state it is deciding.
			//   clipped — the word is already at its maximum and the panel still cuts it;
			//   fits    — the cluster has room to the right of the word without shortening it.
			// A clipped word can never leave room, so `clipped` implies `!fits`: every clipped
			// word floats, which is what makes the box the only place the full word has to live.
			function measureRowFit(rowEl, actionsEl, textEl) {
				var cs = getComputedStyle(rowEl);
				var rowRight = rowEl.getBoundingClientRect().right - (parseFloat(cs.paddingRight) || 0);
				var lastEl = actionsEl.previousElementSibling || textEl;
				var free = rowRight - lastEl.getBoundingClientRect().right;
				var clipped = textEl.scrollWidth - textEl.clientWidth > 1;
				return {
					clipped: clipped,
					fits: !clipped
						&& measureHiddenWidth(actionsEl) + (parseFloat(cs.columnGap) || 0) <= free + 0.5
				};
			}

			// Width of a display:none element without letting it disturb the row: shown absolutely
			// positioned and invisible, so it is laid out but takes no space from the flex line.
			function measureHiddenWidth(el) {
				var prev = el.getAttribute("style") || "";
				el.style.cssText = prev + ";display:inline-flex;position:absolute;visibility:hidden;left:-9999px";
				var w = el.offsetWidth;
				if (prev) { el.setAttribute("style", prev); } else { el.removeAttribute("style"); }
				return w;
			}

			function rowActionsInit() {
				if (actionMachine) { return; }
				// openDelay 0 — the cluster has always appeared the instant a row is pointed at
				// and that does not change; the machine is here for the CLOSE grace, which is what
				// lets the pointer travel from the row up into the box without it vanishing.
				actionMachine = PL.hover.intent({
					openDelay: 0,
					closeDelay: 300,
					open: openRowActions,
					close: closeRowActions,
					isOpen: function () { return !!actionPop; }
				});
				// Any scroll under an open box would leave it pointing at a row that has moved —
				// capture, so it catches the words box and the accordion alike.
				document.addEventListener("scroll", closeRowActions, true);
			}

			function openRowActions() {
				var s = actionPopRow;
				if (actionPop) { return; }
				if (!s || !document.contains(s.row[0])) { actionPopRow = null; return; }
				actionPop = $("<div class='wlRowActionsPopClass'></div>");
				if (s.clipped) {
					// The word first, reading order, then the controls — the same order as the row.
					// .text() and not an interpolated string: a headword is data and goes in as text.
					actionPop.append($("<button type='button' class='wlWordTipClass'></button>")
						.text(s.term)
						.click(function (e) {
							stopEvent(e);
							var term = s.term, focusVerb = s.focusVerb;
							actionMachine.cancel();
							closeRowActions();
							navigateTo(term, true, true, { focusVerb: focusVerb });
						}));
				}
				actionPop.append(s.actions);
				$("body").append(actionPop);
				s.row.addClass("wlRowActionsPopHostClass");
				placeRowActions(s);
				// The box and the row feed ONE machine — leaving either into the other keeps it
				// open (PL.hover's whole reason for existing). enter() would try to re-open, so the
				// box only ever calls off a pending close.
				actionPop.on("mouseenter", function () { actionMachine.cancelClose(); });
				actionPop.on("mouseleave", function () { actionMachine.leave(); });
			}

			function placeRowActions(s) {
				var r = s.row[0].getBoundingClientRect();
				var cs = getComputedStyle(s.row[0]);
				var right = r.right - (parseFloat(cs.paddingRight) || 0);
				var w = actionPop[0].offsetWidth, h = actionPop[0].offsetHeight;
				// Sitting ON the row's top edge (1px of overlap, no gap to cross) and aligned to
				// the row's right — where the cluster would have been, one line up.
				var top = r.top - h + 1;
				var wordsBox = s.row.closest(".wlWordsClass")[0];
				if (wordsBox && top < wordsBox.getBoundingClientRect().top) {
					top = r.bottom - 1;   // the first rows have nothing above them inside the box
				}
				// Carrying a long word, the box can be wider than the panel it belongs to — it
				// grows leftwards from its right anchor, so keep it on screen.
				var left = Math.max(4, Math.min(right - w, window.innerWidth - w - 4));
				actionPop.css({ left: Math.round(left) + "px", top: Math.round(top) + "px" });
			}

			function closeRowActions() {
				var s = actionPopRow;
				actionPopRow = null;
				if (s) {
					s.row.removeClass("wlRowActionsPopHostClass");
					// Back to being the row's LAST child, which is where buildRow appended it.
					if (document.contains(s.row[0])) { s.row[0].appendChild(s.actions[0]); }
				}
				if (actionPop) { actionPop.remove(); actionPop = null; }
			}

			// Every row's mouseenter — this is the decision point. Armed on the ROW and not on the
			// word or the cluster: at this width either of those can be zero-sized, which is
			// precisely the case this exists for.
			function armRowHover(row, t, isVerbs, actions, text) {
				row.on("mouseenter", function () {
					rowActionsInit();
					if (actionPopRow && actionPopRow.row[0] !== row[0]) {
						actionMachine.cancel();
						closeRowActions();   // the box belongs to the row we just left
					}
					// Already floating for THIS row — coming back down from the box onto its own
					// row must CALL OFF the pending close, which is what enter() does when open.
					if (actionPop) { actionMachine.enter(); return; }
					var fit = measureRowFit(row[0], actions[0], text[0]);
					if (fit.fits) {
						row.addClass("wlRowActionsInlineClass");
						return;
					}
					actionPopRow = { row: row, actions: actions, clipped: fit.clipped,
						term: t.term, focusVerb: isVerbs };
					actionMachine.enter();
				});
				row.on("mouseleave", function () {
					row.removeClass("wlRowActionsInlineClass");
					// NOT closed here: the pointer may be on its way UP into the floating box.
					// The machine's close grace is what tells the two apart.
					if (actionMachine) { actionMachine.leave(); }
				});
			}


			function buildRow(section, t, isProgress, isStruggling, isSetAside, filter) {
				var isLevel = section.hasClass("wlLevelClass");
				var sectionKind = section.attr("data-wl-kind");
				var isVerbs = isVerbKind(sectionKind);
				// A "Phrases I typed" band row (capturedTs is the marker — only that endpoint sends
				// it). Same row, three deviations: its × erases the CAPTURE RECORD (never a list
				// membership), its move/copy is copy-only (a record is not a source to move FROM),
				// and it stays out of the host list's selection model — the bulk bar acts on MY
				// LIST memberships (delete/move by wordListId), which a record row does not have.
				var isTypedRec = !!t.capturedTs;
				var row = $("<div class='wlWordRowClass'></div>").attr("data-term-id", t.id);
				var checkbox = $("<input type='checkbox' class='wlRowCheckClass' tabindex='300'/>").val(t.id);
				// The row's STATUS COLUMN. It leads the row, LEFT of the word, and holds its width
				// even while empty (see the :empty override in garden.css) so the words stay on one
				// vertical line instead of shifting sideways as it fills in. Two forms, one width:
				//   • normally the word-garden stage plant + its day badge, painted by
				//     GARDEN.decorate after the section renders;
				//   • on My Garden's In-progress rows the ladder dots, painted by
				//     LRN.decorateTermRows. Those words have no plant and no due date by definition
				//     — that IS the section — so the plant column would stand empty on every row of
				//     the band, and the dots would otherwise have to float over the action buttons
				//     on the right. See .lrnRowDotsHostClass in word-lists.css.
				//   • on a VERB list row the same plant, but read off what the row EXPANDS into —
				//     the form-set card, or the conjugation cells, each a first-class term with its
				//     own plant and schedule. The row's id is the lemma's; the lemma is not what
				//     this row adds, drills or grows, so the kind rides along and GARDEN routes the
				//     read to verb-term-status.
				var statusCol = isProgress
					? $("<span class='lrnRowDotsHostClass'></span>")
					: $(GARDEN.slot(t.id, "sm", null, isVerbs ? sectionKind : null));
				var text = $("<span class='wlWordTextClass'></span>");
				paintFilterMatch(text, t.term, filter);   // plain .text() when nothing is filtering
				var actions = $("<span class='wlRowActionsClass'></span>");

				observeSoundPrefetch(row, t.id, null);

				var soundBtn = $("<button class='pl-btn-icon-round wlRowSoundClass' type='button'>" + plIcon("volume") + "</button>");
				soundBtn.assignTooltip("sound_tooltip");
				soundBtn.click(function (e) { stopEvent(e); playAiSound(t.id); });

				// Per-row add: the destination's plant mark alone (sprout = Learning, watering can = Practice).
				// setActiveTab repaints the glyph on tab switch; the tooltip resolves on hover, both
				// following the contextual destination. Routed at click time.
				var addRowBtn = $("<button class='pl-btn-icon-round wlRowAddClass' type='button'></button>").html(addDestIcon());
				addRowBtn.assignTooltip(function () {
					return getRes(addDestIsLearning() ? "wlRowLearn_tooltip" : "wlRowPractice_tooltip");
				});
				addRowBtn.click(function (e) {
					stopEvent(e);
					armTrayFly(row[0], t.id);   // individual → frame ends on this new entry in the tray
					// A single verb expands exactly like a selection of one — same rule everywhere
					// a verb enters the tray. MERGES (replace=false), unlike the bulk paths.
					if (isVerbs) { addVerbForms({ kind: sectionKind }, { termIds: [t.id] }, false); }
					else if (addDestIsLearning()) { addWordsToLearning([t.id], false); }
					else { addWordsToPractice([t.id], false); }
				});

				// Level rows: the dictionary is read-only — copy words OUT (harvest into an own
				// list), never move or remove.
				var moveBtn = $("<button class='pl-btn-icon-round' type='button'>" + plIcon("arrow-right-left") + "</button>");
				moveBtn.assignTooltip(isLevel || isTypedRec ? "wlCopyWords_tooltip" : "wlRowMoveCopy_tooltip");
				moveBtn.click(function (e) { stopEvent(e); showPopover(moveBtn, [t.id], isLevel || isTypedRec); });

				actions.append(soundBtn).append(addRowBtn).append(moveBtn);
				if (isStruggling) {
					// No treatment panel and no chevron to open one (removed 2026-08-02, leech-ui.md
					// §10.5). It ended up holding a single "Learn it again" button that ran exactly the
					// call the row's own add button already runs — a disclosure control in front of a
					// duplicate. No park control here either (redesign D10): setting a word aside is a
					// general-purpose user tool, never the app's suggested answer to difficulty — it
					// lives in the pre-exercise panels instead.
					//
					// "Drill it in phrases" (D11), prominent on this band because meeting a hard
					// word inside real sentences is the band's whole answer to it. The same control
					// lives in the rich view for every other word — one mechanism, two doors.
					actions.prepend(phrasePickButton(t.id, function () { return t.term; },
						"wlRowPhrasesClass"));
					// EVERY difficult row carries the × now (D8: removal is always the user's to
					// make, engine-flagged rows included). The server writes the regime's EXIT
					// rather than clearing a flag — a difficult_auto flag is derived and the next
					// replay would only put it back, whereas an exit is a decision and the band
					// keeps it until a fresh fail.
					if (t.removable) {
						var unmarkBtn = $("<button class='pl-btn-icon-round' type='button'>" + plIcon("x") + "</button>");
						unmarkBtn.assignTooltip("wlRowUnmarkDifficult_tooltip");
						unmarkBtn.click(function (e) {
							stopEvent(e);
							ajaxPost("api/garden/difficult", { termId: t.id, difficult: false },
								function () { if (expandedId) { loadWords(expandedId); } },
								getRes("operationCannotComplete_message"));
						});
						actions.append(unmarkBtn);
					}
				}
				// A "Set aside" row is a resting word: dimmed as status (never a disablement — every
				// control still works), and carrying the wake control, which must stay permanently
				// visible and one gesture away — parking that could not be undone in one gesture
				// would be a deletion wearing another name.
				if (isSetAside) {
					row.addClass("wlRowParkedClass");
					var wakeBtn = $("<button class='pl-btn-icon-round wlRowParkClass' type='button'></button>")
						.html(plIcon("sun"));
					wakeBtn.assignTooltip("wlRowWake_tooltip");
					wakeBtn.click(function (e) {
						stopEvent(e);
						setWordParked(t.id, false);
					});
					actions.append(wakeBtn);
				}
				if (isTypedRec) {
					// "Remove from here" (user decision 2026-08-10): erases the caller's OWN
					// term_capture row and nothing else — copies promoted into real lists and any
					// drill state live in their own tables and keep going. The DOM is trimmed in
					// place (no loadLists round trip: no badge depends on the record), and typing
					// the phrase again re-captures it, so this × is never destructive.
					var forgetBtn = $("<button class='pl-btn-icon-round' type='button'>" + plIcon("x") + "</button>");
					forgetBtn.assignTooltip("wlTypedRemove_tooltip");
					forgetBtn.click(function (e) {
						stopEvent(e);
						ajaxPost("wordlist-myphrases-remove", { termId: t.id }, function () {
							var band = row.closest(".wlTypedBandClass");
							row.remove();
							var left = band.find(".wlWordRowClass").length;
							if (!left) { band.remove(); }
							else { band.find(".pl-count-pill").text(left); }
						}, getRes("operationCannotComplete_message"));
					});
					actions.append(forgetBtn);
				} else if (!isLevel) {
					var removeBtn = $("<button class='pl-btn-icon-round' type='button'>" + plIcon("x") + "</button>");
					removeBtn.assignTooltip("wlRowRemove_tooltip");
					removeBtn.click(function (e) {
						stopEvent(e);
						var fromId = expandedId;
						ajaxPost("wordlist-delete-word", { wordListId: fromId, termId: t.id },
							function () {
								WLFX.dropOwnRows(fromId, [t.id]);   // same reason as the move popover
								loadLists();
							},
							getRes("wlCannotDeleteWord_error_message") + ": " + t.term);
					});
					actions.append(removeBtn);
				}
				// Status BEFORE the word: a status column that trails the text moves with every word
				// length. Its slot holds its width even when empty (garden.css), so the words stay
				// on one vertical line. A typed-record row carries no checkbox at all (see
				// isTypedRec above) — absent, not hidden, so shift-ranges never sweep it either.
				// The checkbox rides in a cell that spans the row's full height and its left padding: that
				// whole column is the select target, since a plain click anywhere else opens the word.
				if (isTypedRec) { row.append(statusCol).append(text); }
				else { row.append($("<span class='wlRowCheckCellClass'></span>").append(checkbox)).append(statusCol).append(text); }
				// The 3-day regime's visible progress (D9), right after the word where it is read:
				// how many of the three days this one has already been conquered on. Absent at
				// zero — a scoreboard of nothing is not encouragement — and absent on every row
				// outside the Difficult words band, which is the only place it means anything.
				if (isStruggling && t.marks) {
					row.append(difficultMarksPips(t.marks));
				}
				row.append(actions);

				// Selection model: the checkbox column toggles; SHIFT extends from the last-clicked row;
				// Ctrl/Cmd-click anywhere on the row toggles too (macOS: metaKey). A plain click anywhere
				// else on the row opens the word's dictionary entry. Until 2026-10-12 a click on the row
				// background toggled and only the word's own text opened — and a prod visitor clicked
				// 3 px past the end of "air-conditioned" twice, ticked and unticked it, and left
				// (ad-funnel-diagnosis §10).
				// The row's index is read from the DOM at click time rather than baked in at build
				// time. It used to be baked, and that only held while rows were append-only: a
				// removal — and now a My Garden band re-streaming under a new filter — renumbers
				// every row after it, and a shift-range then ran between two positions that no longer
				// existed. Walking the rows on a click costs nothing at these lengths.
				function rowIdx() {
					return section.find(".wlWordRowClass").index(row);
				}
				checkbox.on("click", function (e) {
					if (e.shiftKey && lastCheckedIdx !== null) {
						applyRange(section, rowIdx(), $(this).is(":checked"));
					}
					lastCheckedIdx = rowIdx();
					syncRowChecked(row);
					updateSelBar(section);
					e.stopPropagation();
				});
				function press(e) {
					var selects = e.shiftKey || e.ctrlKey || e.metaKey
						|| $(e.target).closest(".wlRowCheckCellClass").length > 0;
					if (selects && !isTypedRec) {
						toggleRow(section, row, rowIdx(), e);
						return;
					}
					// From the Verbs list the VERB is the reason for the click, so the card opens on
					// its forms — the paradigm panel expanded, the principal parts marked, and the
					// card starting at the verb sense when that sense is not the first one.
					navigateTo(t.term, true, true, { focusVerb: isVerbs });
				}
				text.click(function (e) {
					e.stopPropagation();
					press(e);
				});
				row.click(function (e) {
					if ($(e.target).is("input, button")) { return; }
					press(e);
				});
				// The row's hover behaviour: whether the action cluster goes inline or floats, and
				// whether the floating box has to carry the full word too.
				armRowHover(row, t, isVerbs, actions, text);

				return row;
			}

			function toggleRow(section, row, idx, e) {
				var checkbox = row.find(".wlRowCheckClass");
				var newState = !checkbox.is(":checked");
				if (e && e.shiftKey && lastCheckedIdx !== null) {
					applyRange(section, idx, newState);
				} else {
					checkbox.prop("checked", newState);
				}
				lastCheckedIdx = idx;
				syncRowChecked(row);
				updateSelBar(section);
			}

			function applyRange(section, idx, boolState) {
				var rows = section.find(".wlWordRowClass");
				var from = Math.min(lastCheckedIdx, idx);
				var to = Math.max(lastCheckedIdx, idx);
				rows.slice(from, to + 1).each(function () {
					$(this).find(".wlRowCheckClass").prop("checked", boolState);
					syncRowChecked($(this));
				});
			}

			function syncRowChecked(row) {
				row.toggleClass("wlRowCheckedClass", row.find(".wlRowCheckClass").is(":checked"));
			}

			function updateSelBar(section) {
				var bar = section.find(".wlSelBarClass");
				var count = getCheckedIds(section).length;
				// A fresh selection while the undo peel is running means the user has moved on:
				// finalize the pending removal (finish() re-invokes updateSelBar to set the state).
				if (count > 0 && bar.hasClass("wlSelBarPeelingClass")) {
					var peel = section.data("wlPeel");
					if (peel) { peel.finish(); return; }
				}
				// The bar (select-all row's count + bulk-action buttons) stays visible whenever there
				// are words to select at all — "0 selected" with disabled buttons, not a vanishing row,
				// so the toolbar never shifts as the selection changes. Only a genuinely empty list
				// (no rows) hides it; the peel keeps it up regardless (handled by its own CSS class).
				// …with one exception: the bar HOSTS the list's filter box, so a filter that matches
				// nothing must not take away the control that would let the user relax it. A list
				// with a box is by definition long enough to have rows.
				bar.toggleClass("wlSelBarShowClass", section.find(".wlWordRowClass").length > 0
					|| bar.find(".wlFilterInputClass").length > 0);
				// Buttons act on the checked words — disabled (not hidden) at 0 selected. Skipped while
				// the peel is running: the Remove pill's face is mid-peel (Undo must stay clickable)
				// and Move/Copy is hidden by CSS then, so neither should have its state touched.
				if (!bar.hasClass("wlSelBarPeelingClass")) {
					// .not(): the filter box's clear × also lives in this bar but acts on the box,
					// not the selection — a disabled button swallows its clicks silently.
					bar.find("button").not(".wlFilterClearClass").prop("disabled", count === 0);
				}
				section.toggleClass("wlHasSelClass", count > 0);
				bar.find(".wlSelCountClass").text(count + " " + getRes("wlSelected_label"));
				updateGardenSecBars(section);
			}

			// My Garden's bands each carry their own select-all + selected-count, so every path that
			// changes a selection has to refresh them — which is exactly the set of paths that already
			// call updateSelBar (row click, checkbox, shift range, list-wide check-all, a page of rows
			// landing). Hanging it off there rather than off each call site is what keeps a band's
			// count from silently drifting out of step with its rows.
			//
			// The pair appears with the band's FIRST row and not before: a section whose rows have not
			// streamed in yet (or that holds none at all) offers a control that could select nothing.
			// A no-op on every other list — they have no .wlGardenSecClass.
			function updateGardenSecBars(section) {
				section.find(".wlGardenSecClass").each(function () {
					var box = $(this);
					var rows = box.find(".wlRowCheckClass");
					var checked = rows.filter(":checked").length;
					box.find(".wlGardenSecSelClass").toggleClass("wlSecSelEmptyClass", rows.length === 0);
					box.find(".wlGardenSecCheckClass")
						.prop("checked", rows.length > 0 && checked === rows.length);
					box.find(".wlGardenSecCountClass").text(checked);
				});
			}

			function getCheckedIds(section) {
				return $.map(section.find(".wlRowCheckClass:checked"), function (el) {
					return +el.value;
				});
			}

			// ── list + word operations ──
			// Remove the checked words. No confirm dialog: the rows drop instantly and the Remove
			// pill offers an undo window via a diagonal peel. Everything is done LOCALLY — the rows
			// are detach()ed (not removed), so undo re-inserts them verbatim (handlers and all) and
			// neither undo nor expiry reloads the list, so nothing flashes. The delete commits
			// server-side and the peel appears only once it confirms, so undo's re-add can't race
			// ahead of the delete. undo re-adds via wordlist-copy-selected-to (idempotent: terms
			// are a Set, @OrderBy("term") restores their exact positions).
			function removeChecked(section, item, removeBtn) {
				var ids = getCheckedIds(section);
				if (!ids.length) { return; }

				var wordsEl  = section.find(".wlWordsClass");
				var checkAll = section.find(".wlCheckAllClass");
				var bar      = section.find(".wlSelBarClass");
				var countEl  = section.find(".wlHeaderClass .pl-count-pill");

				// Snapshot the full row order + state so undo can put it all back untouched.
				var originalOrder      = wordsEl.find(".wlWordRowClass").toArray();
				var originalRowTermIds = rowTermIds.slice();
				var originalCount      = parseInt(countEl.text(), 10) || originalOrder.length;
				var idSet = {};
				ids.forEach(function (id) { idSet[id] = true; });
				originalOrder.forEach(function (el) {
					if (idSet[$(el).attr("data-term-id")]) { $(el).detach(); }
				});
				var emptyNow = wordsEl.find(".wlWordRowClass").length === 0;

				rowTermIds = $.map(wordsEl.find(".wlWordRowClass"),
					function (el) { return +$(el).attr("data-term-id"); });
				lastCheckedIdx = null;
				checkAll.prop("checked", false);
				countEl.text(Math.max(0, originalCount - ids.length));

				bar.addClass("wlSelBarPeelingClass");
				if (emptyNow) {
					// Nothing left to remove: peel the Undo away to blank space (the "✕ Remove"
					// label is hidden via .wlSelBarEmptyClass, not removed, so it still sizes the
					// pill) and drop the select-all checkbox — only the peeling Undo shows.
					bar.addClass("wlSelBarEmptyClass");
					checkAll.hide();
				}

				function restore() {   // undo: put everything back exactly as it was, locally
					wordsEl.append(originalOrder);
					rowTermIds = originalRowTermIds;
					countEl.text(originalCount);
					checkAll.show();
				}
				function settle() {    // expiry: finalize the empty view (the partial view is already final)
					if (emptyNow) {
						wordsEl.append($("<div class='wlEmptyClass'></div>").text(getRes("wlEmptyList_message")));
					}
				}

				ajaxPost("wordlist-delete-selected", { wordListId: item.id, termIds: ids },
					function () { startWlRemovePeel(section, item, removeBtn, bar, ids, restore, settle); },
					getRes("wlDeleteWords_error_message") + " [1]");
			}

			// Take over the Remove pill's face with an "Undo" affordance that peels away diagonally
			// (top-left → bottom-right); the wipe doubles as the countdown and stays clickable until
			// it fully clears. The countdown is JS-driven so it keeps expiring at the SAME rate even
			// while the collapsed body is display:none (a CSS animation would freeze there); the
			// only pause is an armed hover. Resolutions (all reload-free): undo → restore(); expiry
			// → settle() + recompute the bar; a fresh selection during the window → finalize (the
			// user has moved on); a words reload (renderWords) → hard-cancel.
			function startWlRemovePeel(section, item, removeBtn, bar, ids, restore, settle) {
				removeBtn.find(".wlRemovePeel").remove();   // idempotent: clear any peel still on the pill

				var peel = $(
					"<span class='wlRemovePeel' role='button' tabindex='0'>"
				+     "<span class='wlRemovePeel-label'></span>"
				+     "<span class='wlRemovePeel-crease'></span>"
				+   "</span>"
				);
				peel.find(".wlRemovePeel-label").text(getRes("undo_label"));
				removeBtn.append(peel);

				var BASE_MS = 10300;             // matches the CSS wipe (10s) + its .3s lead-in
				var elapsed = 0;
				var lastTick = Date.now();
				var hovered = false, armed = false;
				var done = false;

				function currentRate() {
					if (armed && hovered) { return 0; }   // armed hover → paused (matches the CSS)
					return 1;                             // same speed whether the section is open or collapsed
				}

				var ticker = setInterval(function () {
					var now = Date.now();
					elapsed += (now - lastTick) * currentRate();
					lastTick = now;
					if (elapsed >= BASE_MS) { finish(); }
				}, 150);

				// Stop the ticker + strip the peel and its pinned bar state. Leaves the words/count
				// as they currently stand (removed for expiry, restored by undo's restore()).
				function cleanup() {
					if (done) { return true; }
					done = true;
					clearInterval(ticker);
					section.removeData("wlPeel");
					removeBtn.off(".wlrmpeel").removeClass("wlPeelArmed");
					bar.removeClass("wlSelBarPeelingClass wlSelBarEmptyClass");
					peel.remove();
					return false;
				}
				function finish() {           // countdown expired (or a fresh selection superseded it)
					if (cleanup()) { return; }
					settle();
					updateSelBar(section);    // 0 selected → bar hides; a new selection → bar shows it
				}
				function undo(e) {
					if (e) { e.preventDefault(); e.stopPropagation(); }
					if (cleanup()) { return; }
					restore();
					updateSelBar(section);
					ajaxPost("wordlist-copy-selected-to", { termIds: ids, wordListIdTo: item.id },
						function () {}, getRes("wlDeleteWords_error_message") + " [2]");
				}

				// finish() ends the window on a fresh selection (updateSelBar calls it); cleanup()
				// hard-cancels when the words get re-rendered out from under the peel (renderWords).
				section.data("wlPeel", { finish: finish, cancel: cleanup });

				// Freeze-on-hover: the visual wipe pauses via the .wlPeelArmed CSS rule and the
				// ticker via currentRate(). The cursor is still on the pill right after the click,
				// so we "arm" only once it has genuinely left — otherwise it'd never start.
				removeBtn.on("mouseenter.wlrmpeel", function () { hovered = true; });
				removeBtn.on("mouseleave.wlrmpeel", function () {
					hovered = false;
					armed = true;
					removeBtn.addClass("wlPeelArmed");
				});

				peel.on("click", undo);
				peel.on("keydown", function (e) { if (e.which === 13 || e.which === 32) { undo(e); } });
			}

			// Delete = send the list to the Recycle Bin (soft-delete, restorable). No confirm: the
			// list flies into the basket icon and can be restored from there until purged. An EMPTY
			// list is deleted outright server-side (nothing to recover), so skip the fly animation.
			function deleteList(item) {
				if (item.termCount > 0) {
					var header = sectionEl(item.id).find(".wlHeaderClass");
					PL.fly(header.length ? header : accordion, basketBtn, 700);
				}
				ajaxPost("wordlist-delete", { wordListId: item.id },
					function () {
						if (expandedId == item.id) { expandedId = null; }
						loadLists();
					},
					getRes("wlDelete_error_message"));
			}

			function startRename(section, item) {
				var nameEl = section.find(".wlNameClass");
				if (nameEl.find("input").length) { return; }
				var header = section.find(".wlHeaderClass");
				header.addClass("wlEditing");   // free the row width: hides actions + count (CSS)
				// Prefilled with what the row SHOWS, so a French reader edits "Ma liste", not a
				// stored English "My List" they have never seen.
				var input = $("<input type='text' class='wlInlineInputClass' maxlength='50'/>").val(displayName(item));
				nameEl.empty().append(input);
				input.focusToEnd();

				var done = false;
				function finish(commit) {
					if (done) { return; }
					done = true;
					header.removeClass("wlEditing");
					var newName = input.val();
					if (!commit || !newName || newName == displayName(item)) {
						nameEl.text(displayName(item));
						return;
					}
					ajaxPost("wordlist-rename", { wordListId: item.id, wordListName: newName },
						function () { loadLists(); },
						getRes("operationCannotComplete_message"));
				}

				input.on("click", function (e) { e.stopPropagation(); });
				input.on("keydown", function (e) {
					if (e.which == PL.keys.ENTER) { finish(true); e.preventDefault(); e.stopPropagation(); }
					else if (e.which == PL.keys.ESCAPE) { finish(false); e.stopPropagation(); }
					else if (e.which == PL.keys.SPACE) { e.stopPropagation(); }
				});
				input.on("blur", function () { finish(true); });
			}

			function startCreate() {
				var existing = accordion.find(".wlNewRowClass input");
				if (existing.length) {
					existing.focus();
					return;
				}
				var rowEl = $("<div class='wlNewRowClass'></div>");
				var input = $("<input type='text' class='wlInlineInputClass' maxlength='50'/>")
					.attr("placeholder", getRes("wlNewListPlaceholder"));
				rowEl.append(input);
				accordion.prepend(rowEl);
				input.focus();

				var done = false;
				function closeRow() {
					if (done) { return; }
					done = true;
					rowEl.remove();
				}

				input.on("keydown", function (e) {
					if (e.which == PL.keys.ENTER) {
						var name = input.val();
						closeRow();
						// Through the shared creator, so the panel's own "+ new list" earns the pin
						// exactly like the picker's "New list…" row does — one rule, one path.
						that.createList(name);
						e.preventDefault();
						e.stopPropagation();
					} else if (e.which == PL.keys.ESCAPE) {
						closeRow();
						e.stopPropagation();
					} else if (e.which == PL.keys.SPACE) {
						e.stopPropagation();
					}
				});
				input.on("blur", function () { setTimeout(closeRow, 100); });
			}

			// ── move / copy popover ──
			// copyOnly: a level list is the source — words can only be copied OUT of the dictionary,
			// never moved (its content is virtual); the popover then has no Move/Copy tabs.
			function showPopover(anchorEl, termIds, copyOnly) {
				hidePopover();
				if (!termIds || !termIds.length) {
					showMessage(getRes("wlNoWords_message"));
					return;
				}
				var targets = [];
				for (var i = 0; i < lists.length; i++) {
					// Level lists have virtual content — never a move/copy target.
					if (lists[i].id != expandedId && !isVirtualKind(lists[i].kind)) { targets.push(lists[i]); }
				}
				if (!targets.length) {
					showMessage(getRes("wlCopyNoLists_message"));
					return;
				}

				var mode = copyOnly ? 'copy' : 'move';
				popoverEl = $("<div class='wlPopoverClass wlPopScrollClass'></div>");
				if (copyOnly) {
					var title = $("<div class='wlPopoverTabsClass'></div>")
						.append($("<span class='wlPopoverTabClass wlPopTabActiveClass'></span>")
							.text(getRes("wlCopy_label")));
					popoverEl.append(title);
				} else {
					var tabs = $("<div class='wlPopoverTabsClass'></div>");
					var moveTab = $("<span class='wlPopoverTabClass wlPopTabActiveClass'></span>").text(getRes("wlMove_label"));
					var copyTab = $("<span class='wlPopoverTabClass'></span>").text(getRes("wlCopy_label"));
					moveTab.click(function (e) {
						mode = 'move';
						moveTab.addClass("wlPopTabActiveClass");
						copyTab.removeClass("wlPopTabActiveClass");
						e.stopPropagation();
					});
					copyTab.click(function (e) {
						mode = 'copy';
						copyTab.addClass("wlPopTabActiveClass");
						moveTab.removeClass("wlPopTabActiveClass");
						e.stopPropagation();
					});
					tabs.append(moveTab).append(copyTab);
					popoverEl.append(tabs);
				}

				// Targets scroll, the Move/Copy tabs above them stay pinned — the tabs are the
				// popover's mode switch and must stay reachable however many lists there are.
				var targetsBody = $("<div class='wlPopScrollBodyClass'></div>");
				$.each(targets, function (_, target) {
					var itemEl = $("<div class='wlPopoverItemClass'></div>");
					var icon = kindIcon(target);
					if (icon) { itemEl.append($("<span class='wlKindIconClass'></span>").text(icon)); }
					itemEl.append($("<span></span>").text(displayName(target)));
					itemEl.click(function (e) {
						e.stopPropagation();
						var url = mode === 'move' ? "wordlist-move-selected-to" : "wordlist-copy-selected-to";
						var params = { termIds: termIds, wordListIdTo: target.id };
						if (mode === 'move') { params.wordListIdFrom = expandedId; }
						hidePopover();
						var from = expandedId;
						var moved = (mode === 'move');
						ajaxPost(url, params,
							function () {
								// A move EMPTIES the source of these words, and the reload below
								// re-renders it. With a filter typed that render is answered from
								// WLFX's cached rows, whose own refetch is debounced — so tell it
								// the truth here or the moved word is drawn straight back.
								if (moved) { WLFX.dropOwnRows(from, termIds); }
								loadLists();
							},
							getRes("wlCopyWords_error_message"));
					});
					targetsBody.append(itemEl);
				});
				popoverEl.append(targetsBody);

				$("body").append(popoverEl);
				// Same placement + height cap as the add picker: this popover never flipped or
				// bounded itself, so a reader with many lists lost the bottom of the target list.
				wlPositionPopover(popoverEl, $(anchorEl));
				popoverEl.click(function (e) { e.stopPropagation(); });
				// Phase 4 step 3c: dismissal on the chassis — outside pointerdown + consumed
				// Esc; the anchor button can re-open without a dismiss-then-reopen bounce.
				popoverLayer = PL.layers.push({
					el: popoverEl[0],
					anchors: [$(anchorEl)[0]],
					onClose: function () {
						popoverLayer = null;
						if (popoverEl) {
							popoverEl.remove();
							popoverEl = null;
						}
					}
				});
				wireCloseOnLeave(anchorEl, popoverEl, hidePopover, function () { return !!popoverEl; });
			}

			function hidePopover() {
				if (popoverLayer) {
					popoverLayer.close();
				}
			}

			// ── Sorting ──────────────────────────────────────────────────────────────────────────
			// The ⇅ header button opens a menu of orderings (current one checked). Picking one
			// re-materializes the persisted order server-side and saves the selection (wlSortMode
			// attr); a later drag tweaks the order in place without changing the selection.
			var SORT_MODES = [
				{ mode: "NEWEST", res: "wlSortNewest_label" },
				{ mode: "OLDEST", res: "wlSortOldest_label" },
				{ mode: "ALPHA",  res: "wlSortAlpha_label" },
				{ mode: "SIZE",   res: "wlSortSize_label" }
			];

			function toggleSortMenu() {
				if (sortPopEl) { closeSortMenu(); return; }
				openSortMenu();
			}

			function openSortMenu() {
				hidePopover();
				closeBasket();
				sortPopEl = $("<div class='wlPopoverClass wlSortPopClass'></div>");
				$.each(SORT_MODES, function (_, opt) {
					var itemEl = $("<div class='wlPopoverItemClass'></div>");
					itemEl.append($("<span class='wlSortCheckClass'></span>")
						.html(opt.mode === sortMode ? plIcon("check") : ""));
					itemEl.append($("<span></span>").text(getRes(opt.res)));
					itemEl.click(function (e) {
						e.stopPropagation();
						closeSortMenu();
						ajaxPost("wordlist-sort",
							{ termLang: langToValField.attr("data-lang-code"), sortMode: opt.mode },
							function () {
								sortMode = opt.mode;
								loadLists();
							},
							getRes("operationCannotComplete_message"));
					});
					sortPopEl.append(itemEl);
				});
				$("body").append(sortPopEl);
				positionPopup(sortPopEl, sortBtn);
				sortPopEl.click(function (e) { e.stopPropagation(); });
				sortLayer = PL.layers.push({
					el: sortPopEl[0],
					anchors: [sortBtn[0]],
					onClose: function () {
						sortLayer = null;
						if (sortPopEl) {
							sortPopEl.remove();
							sortPopEl = null;
						}
					}
				});
				wireCloseOnLeave(sortBtn, sortPopEl, closeSortMenu, function () { return !!sortPopEl; });
			}

			function closeSortMenu() {
				if (sortLayer) {
					sortLayer.close();
				}
			}

			// ── Drag reordering (every list — the panel order is flat and fully the user's) ──────
			// Sections drag by their header. No pinning and no sections: system, level and user
			// lists interleave freely; the level lists' tint is a visual cue, not a fence.
			// A compact STRIP drags too, by itself — it is the row standing in for its whole group,
			// so a panel where every other row can be moved and that one cannot reads as a bug. It
			// carries no id of its own, so what actually moves is its lists: reflowStripGroups pulls
			// their sections in behind the strip before the order is read off the DOM and posted.
			// SortableJS (PL.Sortable, Phase 4 step 5 — retired jQuery UI .sortable):
			// forceFallback = a pointer-following clone like the old helper (no native HTML5
			// drag ghost); fallbackTolerance keeps plain header clicks toggling (= the old
			// distance: 8); the ghost — the REAL section left at the drop slot — wears
			// .wlDragPlaceholderClass, whose CSS hollows it into the dashed placeholder box
			// (no height fixup needed: it keeps its own footprint). The `dragging` flag still
			// swallows the click that ends a real drag.
			PL.Sortable.create(accordion[0], {
				draggable: ".wlSectionClass, .wlLevelStripClass",
				handle: ".wlHeaderClass, .wlLevelStripClass",
				direction: "vertical",
				forceFallback: true,
				fallbackTolerance: 8,
				ghostClass: "wlDragPlaceholderClass",
				onStart: function () {
					dragging = true;
					hidePopover();
					closeSortMenu();
					closeAddMenu();
				},
				onUpdate: function () { reflowStripGroups(); persistDomOrder(); },
				onEnd: function () {
					// After the drop has fully let go: normalize the DOM from the (reordered) model.
					setTimeout(function () {
						dragging = false;
						render();
					}, 0);
				}
			});

			// After a drop, put every folded group's sections back behind their strip. A strip is not
			// a .wlSectionClass and so is invisible to the order that gets posted — moving it is only
			// a move once its lists have followed it. Runs for every drop, not just a strip's: a
			// section dropped INTO the middle of a folded group (its neighbours are hidden, so the
			// gap is invisible) would otherwise split the group in the persisted order.
			function reflowStripGroups() {
				$.each(COMPACT_GROUPS, function (_, group) {
					var strip = accordion.children("." + group.cls);
					if (strip.length) { strip.after(groupSections(group)); }
				});
			}

			// Persist the dragged order (ALL sections) and mirror it into the local model.
			function persistDomOrder() {
				var ids = $.map(accordion.children(".wlSectionClass"), function (el) {
					return +el.getAttribute("data-wl-id");
				});
				lists.sort(function (a, b) {
					return $.inArray(a.id, ids) - $.inArray(b.id, ids);
				});
				ajaxPost("wordlist-reorder",
					{ termLang: langToValField.attr("data-lang-code"), wordListIds: ids },
					function () {},
					getRes("operationCannotComplete_message"));
			}

			// ── Recycle Bin ──────────────────────────────────────────────────────────────────────
			// The 🗑 in the panel header opens a popup of soft-deleted lists (a read-only mini-accordion
			// showing word labels only). Each can be Restored (flies back) or deleted forever; a
			// "delete all forever" button empties the basket. Basket count comes from wordlist-load.
			function updateBasketBadge(count) {
				count = count || 0;
				basketCountEl.text(count > 0 ? count : "");
				basketBtn.toggleClass("wlBasketEmptyClass", count === 0);
				basketBtn.prop("disabled", count === 0);
			}

			function positionPopup(popEl, anchorEl) {
				var off = $(anchorEl).offset();
				var left = Math.min(off.left, $(window).width() - popEl.outerWidth() - 12);
				popEl.css({ top: off.top + $(anchorEl).outerHeight() + 4, left: Math.max(4, left) });
			}

			// Click-opened popovers (Move/Copy, Sort, Recycle Bin) still open on click only, but once
			// open they should feel like the "Add to Practice" menu: linger while the pointer is
			// anywhere over the anchor+popup pair, close 600ms after it leaves both (same grace as
			// PL.hover.intent's default). Re-callable per open — .off() first so a persistent anchor
			// (Sort/Basket buttons, opened many times) never stacks handlers.
			function wireCloseOnLeave(anchorEl, popEl, closeFn, isOpenFn) {
				var machine = PL.hover.intent({
					openDelay: 0,
					closeDelay: 600,
					open: function () {},   // opening stays click-only — this machine only owns the close grace
					close: closeFn,
					isOpen: isOpenFn
				});
				$(anchorEl).off(".wlCloseOnLeave")
					.on("mouseenter.wlCloseOnLeave", function () { machine.cancelClose(); })
					.on("mouseleave.wlCloseOnLeave", function () { machine.leave(); });
				$(popEl)
					.on("mouseenter.wlCloseOnLeave", function () { machine.cancelClose(); })
					.on("mouseleave.wlCloseOnLeave", function () { machine.leave(); });
			}

			function toggleBasket() {
				if (basketPopEl) { closeBasket(); return; }
				openBasket();
			}

			function openBasket() {
				hidePopover();
				closeSortMenu();
				basketPopEl = $("<div class='wlBasketPopClass'></div>");
				var head = $("<div class='wlBasketHeadClass'></div>");
				head.append($("<span class='wlBasketTitleClass'></span>").text(getRes("wlBasketTitle_label")));
				var emptyBtn = $("<button class='pl-btn-pill pl-btn-danger' type='button'></button>")
					.text(getRes("wlBasketEmpty_button"));
				emptyBtn.click(function (e) { e.stopPropagation(); emptyBasket(); });
				head.append(emptyBtn);
				basketPopEl.append(head);
				basketPopEl.append($("<div class='wlBasketListClass'></div>"));

				$("body").append(basketPopEl);
				positionPopup(basketPopEl, basketBtn);
				basketPopEl.click(function (e) { e.stopPropagation(); });
				basketLayer = PL.layers.push({
					el: basketPopEl[0],
					anchors: [basketBtn[0]],
					onClose: function () {
						basketLayer = null;
						if (basketPopEl) {
							basketPopEl.remove();
							basketPopEl = null;
						}
					}
				});
				wireCloseOnLeave(basketBtn, basketPopEl, closeBasket, function () { return !!basketPopEl; });
				loadBasketInto();
			}

			function closeBasket() {
				if (basketLayer) {
					basketLayer.close();
				}
			}

			function loadBasketInto() {
				if (!basketPopEl) { return; }
				ajaxPost("wordlist-basket-load", { termLang: langToValField.attr("data-lang-code") },
					function (data) {
						if (!basketPopEl) { return; }
						var items = (data && data.basket) || [];
						updateBasketBadge(items.length);   // keep the badge in sync with the fetched truth
						var listEl = basketPopEl.find(".wlBasketListClass").empty();
						basketPopEl.find(".pl-btn-danger").prop("disabled", items.length === 0);
						if (!items.length) {
							listEl.append($("<div class='wlEmptyClass'></div>").text(getRes("wlBasketEmpty_message")));
							return;
						}
						for (var i = 0; i < items.length; i++) {
							listEl.append(buildTrashSection(items[i]));
						}
					},
					getRes("wlLoad_error_message") + " [basket]");
			}

			function buildTrashSection(item) {
				var section = $("<div class='wlTrashSectionClass'></div>").attr("data-wl-id", item.id);

				var header = $("<div class='wlTrashHeaderClass'></div>");
				header.append($("<span class='wlChevronClass'>" + plIcon("chevron-right") + "</span>"));
				var trashName = $("<span class='wlTrashNameClass " + CLIP_TIP_CLASS + "'></span>")
					.text(displayName(item));
				header.append(trashName);
				header.append($("<span class='pl-count-pill'></span>").text(item.termCount));

				var restoreBtn = $("<button class='pl-btn-pill' type='button'></button>")
					.html(plIcon("rotate-ccw") + " " + escHtml(getRes("wlRestore_button")));
				restoreBtn.assignTooltip("wlRestore_tooltip");
				restoreBtn.click(function (e) { e.stopPropagation(); restoreList(item, section); });
				header.append(restoreBtn);

				var foreverBtn = $("<button class='pl-btn-icon-round' type='button'>" + plIcon("x") + "</button>");
				foreverBtn.assignTooltip("wlDeleteForever_tooltip");
				foreverBtn.click(function (e) { e.stopPropagation(); deleteForever(item); });
				header.append(foreverBtn);

				header.click(function () { toggleTrashSection(section, item); });

				section.append(header);
				section.append($("<div class='wlTrashWordsClass'></div>"));
				return section;
			}

			// Expand one basket list at a time to show its words (labels only, no actions).
			function toggleTrashSection(section, item) {
				var wasOpen = section.hasClass("wlTrashExpanded");
				basketPopEl.find(".wlTrashSectionClass").removeClass("wlTrashExpanded");
				if (wasOpen) { return; }
				section.addClass("wlTrashExpanded");
				var wordsEl = section.find(".wlTrashWordsClass");
				if (wordsEl.attr("data-loaded")) { return; }
				ajaxPost("wordlist-load-words", { wordListId: item.id }, function (data) {
					wordsEl.attr("data-loaded", "1").empty();
					var terms = (data && data.wordList && data.wordList.terms) || [];
					if (!terms.length) {
						wordsEl.append($("<div class='wlEmptyClass'></div>").text(getRes("wlEmptyList_message")));
						return;
					}
					for (var i = 0; i < terms.length; i++) {
						wordsEl.append($("<div class='wlTrashWordClass'></div>").text(terms[i].term));
					}
				}, getRes("wlCannotLoadWords_error_message"));
			}

			function restoreList(item, section) {
				ajaxPost("wordlist-restore", { wordListId: item.id }, function () {
					// Re-render the panel FIRST so the restored section exists, then fly the frame from
					// the basket item onto that section (not the whole panel). The transfer effect reads
					// both boxes synchronously, so dropping the basket item right after is safe.
					loadLists(function () {
						var target = sectionEl(item.id);
						if (target.length && section && section.length) {
							PL.fly(section, target, 700);
						}
						loadBasketInto();  // drop it from the open basket
					});
				}, getRes("operationCannotComplete_message"));
			}

			function deleteForever(item) {
				ajaxPost("wordlist-delete-forever", { wordListId: item.id }, function () {
					loadBasketInto();  // refresh basket + badge (main accordion is unaffected)
				}, getRes("operationCannotComplete_message"));
			}

			function emptyBasket() {
				ajaxPost("wordlist-basket-empty", { termLang: langToValField.attr("data-lang-code") },
					function () {
						updateBasketBadge(0);
						closeBasket();
					},
					getRes("operationCannotComplete_message"));
			}

			this.onLangChange = function () {
				that.reload();
			};

			newListBtn.assignTooltip("myList_create_tooltip");
			newListBtn.click(function (e) { startCreate(); e.stopPropagation(); });
			filterBtn.assignTooltip("wlxGlobalFilter_tooltip");
			filterBtn.click(function (e) { e.stopPropagation(); toggleGlobalFilterRow(); });
			// The header's non-button surface (title, flag, empty space) opens the filter too —
			// the 🔍 is the visible affordance, the header is the big target (decision 1).
			$("#wlPanelHeaderId").click(function (e) {
				if ($(e.target).closest("button").length) { return; }
				toggleGlobalFilterRow();
			});
			sortBtn.assignTooltip("wlSort_tooltip");
			sortBtn.click(function (e) { e.stopPropagation(); toggleSortMenu(); });
			basketBtn.assignTooltip("wlBasket_tooltip");
			basketBtn.click(function (e) { e.stopPropagation(); toggleBasket(); });
			loadLists();
		}

		function LangMenuHolder(holder, menu, attrName) {
			var that = this;
			this.holder = holder;
			this.menuObj = menu;
			this.attrName = attrName;//"langFrom" or "langTo"
			this.selectedMenuItemId = null;

			this.processMenuItem = function (menuItem) {
				var langCode = menuItem.getId().split("-")[1];
				if (that.attrName === "langFrom") {
					// langFrom is the UI locale and (via Rule R, server-side) drives langTo.
					// A full reload re-renders labels + both menus consistently.
					ajaxPostUserAttr("langFrom", langCode, function () {
						window.location.reload();
					});
				} else {
					ajaxPostUserAttr("langTo", langCode, function (data) {
						setMenuItem($("#langTo-" + (data.langTo || langCode)));
					});
				}
			};

			this.findSelectedMenuItem = function () {
				var langCode = holder.attr("data-lang-code");//EN, RU...
				if (!langCode) {
					return null;
				}
				var menuId = menu.menu.getId();//langFrom-Menu or langTo-Menu
				var menuItemId = menuId.split("-")[0] + "-" + langCode;
				var selectedMenuItem = that.menuObj.findSelectedItem(menuItemId);
				return (selectedMenuItem && selectedMenuItem.length > 0) ? selectedMenuItem : null;
			}

			function setMenuItem(menuItem) {
				if (!menuItem || menuItem.length == 0) {
					return;
				}
				var itemText = menuItem.text();
				var firstChild = that.holder[0].firstChild;
				if (firstChild && firstChild.nodeType == 3) {
					//remove previous value
					that.holder[0].removeChild(firstChild);
				}
				that.holder.prepend(itemText);
				that.selectedMenuItemId = menuItem.getId();
				var langCode = menuItem.getId().split("-")[1];
				that.holder.attr("data-lang-code", langCode);
				updateLangFlags();

				// Only langTo affects the word list; langFrom changes reload the page.
				if (that.attrName === "langTo") {
					updateBrowserTitle();            //the tab names the learned language, and it just changed
					if (settings.myListPanel) {
						settings.myListPanel.onLangChange();
					}
					updateDrillArticleVisibility();
					updateDirectionControls();      //new pair → new arrow faces, maybe no reverse at all
					updateDictDirection();          //…and new faces on the dictionary's own DE⇄EN toggle
					updateVerbSettingsVisibility();//the Verbs settings only where a Verbs list exists
					bringToInitialState();
					window.refreshStats();
				}
			}

			init();

			function init() {
				that.menuObj.init();

				function flipMenu(e) {
					if (!that.menuObj.shown) {
						var menuObj = that.menuObj;
						that.holder.append(menuObj.menu);
						menuObj.holder = that;//add this holder for call back calls
						menuObj.show(that.selectedMenuItemId);
					} else {
						that.menuObj.hide();
					}
					e.stopPropagation();
				}

				//add event to open menu on click and keydown
				that.holder.click(function (e) {
					flipMenu(e);
				});
				that.holder.keydown(function (e) {
					switch (e.which) {
						case PL.keys.ENTER:
						case PL.keys.SPACE:
							flipMenu(e);
							e.preventDefault();
							e.stopPropagation();
					}
				});

				// Display the saved selection WITHOUT side effects — the initial content load is
				// driven by the top-level landing code (applyDictChrome + showDictLean), not the menu.
				var selectedMenuItem = that.findSelectedMenuItem();
				if (selectedMenuItem) {
					that.holder.prepend(selectedMenuItem.text());
					that.selectedMenuItemId = selectedMenuItem.getId();
				} else if (that.attrName === "langTo") {
					// Blank langTo (e.g. langFrom = EN, nothing picked yet): prompt the user.
					that.holder.text(getRes("chooseLangTo_label"));
				}
				updateLangFlags();
			}
		}

		function Menu(menu) {
			var that = this;

			this.menu = menu;
			this.holder = null;//initialized by the holder
			this.selectedItem = null;
			this.hoverClass = "menuItemSelected";
			this.shown = false;
			this.layer = null;//PL.layers handle while open (Phase 4 step 3a)
			this.opener = null;//PL.focus token while open — focus returns to the pill

			this.getMenuItems = function () {
				//by default, returns all items of this menu, but can be overridden by the holder if not all the items
				//should act as menu items (e.g. if the first item acts as a toolbar (like in My List)
				return that.menu.children();
			};

			this.getMenuSize = function () {
				return that.getMenuItems().size();
			}

			this.show = function (selectedMenuItemId) {
				/*This fixes a strange bug in Firefox (and only in Firefox) -
				 the items inside menu appear selected after append and show,
				 so do de-selection*/
				document.getSelection().removeAllRanges();
				var menuItemToSelect = that.findSelectedItem(selectedMenuItemId);
				selectItem(menuItemToSelect);
				var menu = this.menu;
				that.opener = PL.focus.remember();//the pill has focus (click or Enter)
				menu.show();
				menu.focus();//focus is very important here to enable menu to receive keyboard events
				this.shown = true;

				// Phase 4 step 3a: dismissal lives on the chassis. D20 = sticky select —
				// no hover-away close; the layer closes on outside pointerdown, consumed
				// Esc, item pick or pill re-click. Every path funnels through onClose.
				that.layer = PL.layers.push({
					el: menu[0],
					anchors: [that.holder.holder[0]],//the pill — click-toggle opener
					onClose: function () {
						that.layer = null;
						menu.hide();
						that.shown = false;
						if (that.opener) {
							that.opener.restore({ifWithin: menu[0]});
							that.opener = null;
						}
					}
				});

				if (menuItemToSelect) {
					menu.animate({
						scrollTop: menuItemToSelect.offset().top - menu.offset().top
						+ menu.scrollTop() - 20
					}, 500);
				}
			};

			this.hide = function () {
				if (that.layer) {
					that.layer.close();
				}
			};

			this.findSelectedItem = function (selectedMenuItemId) {
				var menuItemToSelect;
				var menuItems = that.getMenuItems();//it could be overridden by holder to exclude certain children from menu
				if (selectedMenuItemId) {
					for (var i = 0; i < menuItems.length; i++) {
						var menuItem = $(menuItems[i]);
						var menuItemId = menuItem.getId();
						if (selectedMenuItemId == menuItemId) {
							menuItemToSelect = menuItem;
							break;
						}
					}
				}
				return menuItemToSelect;
			};

			this.findNeighbourItem = function (currMenuItemId, increment) {
				var nextItem;
				var menuItems = that.getMenuItems();//it could be overridden by holder to exclude certain children from menu
				var length = menuItems.length;
				if (currMenuItemId) {
					for (var i = 0; i < length; i++) {
						var menuItem = $(menuItems[i]);
						var menuItemId = menuItem.getId();
						if (currMenuItemId == menuItemId) {
							var nextIndex = (i + increment) % length;
							nextIndex = nextIndex < 0 ? nextIndex + length : nextIndex;
							nextItem = $(menuItems[nextIndex]);
							break;
						}
					}
				}
				return nextItem;
			};

			this.findNextItem = function (increment) {
				if (!that.selectedItem) {
					// Nothing selected yet (blank langTo): Down enters at the first
					// item, Up at the last — legacy threw a TypeError here.
					var menuItems = that.getMenuItems();
					return $(menuItems[increment > 0 ? 0 : menuItems.length - 1]);
				}
				return that.findNeighbourItem(that.selectedItem.getId(), increment);
			};

			this.addItemEvents = function () {
				that.getMenuItems().each(function () {
					var menuItem = $(this);
					menuItem.click(function (e) {
						setMenuItem();
						e.stopPropagation();
					});
					menuItem.mouseover(function () {
						selectItem(menuItem);
					});
				});
			}

			this.init = init;

			function init() {
				addMenuEvents();
				that.addItemEvents();
			}

			function selectItem(newSelected) {
				if (!newSelected || that.selectedItem && that.selectedItem == newSelected) {
					return;
				}
				if (that.selectedItem) {
					that.selectedItem.removeClass(that.hoverClass)
				}
				newSelected.addClass(that.hoverClass);
				that.selectedItem = newSelected;
				that.selectedItem.focus();
			}

			function addMenuEvents() {
				// Esc + outside-click dismissal live on PL.layers since step 3a; the
				// legacy per-menu $(document).keyup(Esc) and the instant mouseleave
				// close are gone (D20: sticky select).
				that.menu.keydown(function (e) {
					switch (e.which) {
						case PL.keys.DOWN:
							selectItem(that.findNextItem(1));
							break;
						case PL.keys.UP:
							selectItem(that.findNextItem(-1));
							break;
						case PL.keys.ENTER:
							setMenuItem();
							//This is to prevent Opera browser (at least) to fire onclick event on Enter
							e.preventDefault();
							e.stopPropagation();
					}
				});
			}

			function setMenuItem() {
				var menuItem = that.selectedItem;
				if (!menuItem) {
					return;
				}
				that.hide();
				that.holder.processMenuItem(menuItem);//call back holder to set the value
			}

			this.toString = function () {
				return "Menu id=" + this.menu.attr("id")
				+ "; parent id=" + this.menu.parent().attr("id");
			};

			this.toAlert = function (msg) {
				showMessage(msg + ": " + this.toString());
			}
		}

	}

	// File a term in a word list — the ONE path for every term-shaped add (a dictionary row, the
	// rich card's button, a hovered word's popup, an AI translation). They all persist a Term and
	// hand its id here; the two copies of this that used to exist differed only in which element
	// the frame flew from, which is now the `sourceEl` argument.
	//
	// Destination: `listId`, the row the reader clicked in the add picker. Every add in the app now
	// starts there and nowhere else (docs/project/wl-add-target-redesign.md) — there is no standing
	// destination to fall back to, which is the whole point: a word is never filed somewhere the
	// reader did not name in the same gesture.
	function addTermToWordList(termId, sourceEl, listId) {
		var wlDbId = listId;
		var myListVal = settings.myListPanel.flyTarget(wlDbId);

		if (!wlDbId) {
			showMessage(getRes("wlAddNoWordList_error_message"));
			return;
		}

		// Fly the animated frame from the source word (when provided) to the pinned list's header;
		// fall back to the inline card term otherwise.
		var src = (sourceEl && sourceEl.length) ? sourceEl : $(".ai-card .ai-src-word");
		PL.fly(src, myListVal, 1000);
		myListVal.flashClass("confirmBackground", 1000);

		var requestParams = {
			termId: termId,
			wordListId: wlDbId
		};
		ajaxPost("wordlist-add-word", requestParams, function (data) {
			myListVal.flashClass("confirmBackground");
			settings.myListPanel.addWordToList(wlDbId);
		},
		"wlAdd_error_message");
	}

	(function () {
		/*
		 * this swallows backspace keys on any non-input element.
		 * stops backspace -> back
		 */
		var rx = /INPUT|SELECT|TEXTAREA/i;

		$(document).unbind("keydown").bind("keydown", function (e) {
			if (e.which == 8) { // 8 == backspace
				var target = $(e.target);

				if (!rx.test(e.target.tagName) && target.attr("contenteditable") != "true"
				|| target.is(':checkbox')
				|| target.is(':radio') || target.is(':submit')
				|| e.target.disabled || e.target.readOnly) {

					e.preventDefault();
				}
			} else if (e.which === PL.keys.ESCAPE && exerciseDictExcursion
					&& !$(".menuClass:visible, .dlgClass:visible").length) {
				// Esc backs out of a drill-in-triggered dictionary excursion (see onExerciseTermClick)
				// and restores the exercise's own missed-word card — takes priority over the plain
				// richOpen branch below, since navigateTo() also sets richOpen while the excursion is
				// live (arbitrarily deep drilling within the dictionary still returns here in one step).
				exitExerciseDictExcursion(true);
				e.preventDefault();
				e.stopPropagation();
			} else if (e.which === PL.keys.ESCAPE && finishExcursion
					&& !$(".menuClass:visible, .dlgClass:visible").length) {
				// Esc backs out of a dictionary excursion raised over a finish screen (its own words
				// and flowers, or a Word Lists row clicked beside it) and puts the summary card back.
				// It goes through history.back rather than calling the exit directly, so the entry
				// navigateTo pushed is popped with it and the popstate replay stays the single way
				// back — browser Back does exactly what Esc does. Arbitrarily deep drilling within
				// the dictionary still returns to the card in one step (the popstate branch exits
				// the excursion whatever entry it lands on). Ahead of the plain richOpen branch
				// below, which navigateTo also arms while the excursion is live.
				history.back();
				e.preventDefault();
				e.stopPropagation();
			} else if (e.which === PL.keys.ESCAPE && isExerciseView && trainingSession
					&& trainingSession.isAnswerRevealed()
					&& !$(".menuClass:visible, .dlgClass:visible").length) {
				// The drill's revealed answer IS a rich card, and Escape is how a rich card is
				// dismissed everywhere else in the app — so here it means what Enter means: move on to
				// the next word. Without this it was simply a dead key on the one screen whose look
				// most invites it (owner report 2026-07-31). Deliberately ordered AFTER the excursion
				// branch above: once the learner has drilled out into the dictionary, Escape first
				// walks them back to this card, and only the next press advances. It goes through
				// processUserAnswer (not setNextDefinition) so Escape inherits the same just-missed
				// debounce Enter has — a keypress still in flight from the wrong answer must not skip
				// the reveal unread.
				trainingSession.processUserAnswer();
				e.preventDefault();
				e.stopPropagation();
			} else if (e.which === PL.keys.ESCAPE && learnDrillActive
					&& !$(".menuClass:visible, .dlgClass:visible").length) {
				// Esc steps one level back through the Learn meet-card reveal drill (history.back →
				// popstate re-renders the previous card); at the base it lands on the light reveal and
				// stops. Mirrors the dictionary drill's Esc, kept ahead of the richOpen branch below
				// (a reveal drill never sets richOpen, so that branch wouldn't fire for it anyway).
				history.back();
				e.preventDefault();
				e.stopPropagation();
			} else if (e.which === PL.keys.ESCAPE
					&& !$(".menuClass:visible, .dlgClass:visible").length && phraseDockFold()) {
				// The open collocation panel is the topmost thing on the dictionary, so Escape folds
				// it and STOPS — without this the key fell through to the richOpen branch below and
				// navigated the reader BACK out of the entry they were reading, which is not what
				// dismissing a panel means. phraseDockFold answers false when no panel is open, so
				// this branch simply does not fire the rest of the time. It cannot collide with the
				// branches above: the dock only paints on the dictionary tab with no card open.
				e.preventDefault();
				e.stopPropagation();
			} else if (e.which === PL.keys.ESCAPE && richOpen
					&& !$(".menuClass:visible, .dlgClass:visible").length) {
				// Esc steps ONE level back through the drill-down, exactly like the ‹ Back button:
				// it pops the current visited word (history.back), so popstate re-opens the previous
				// word rich; at the first level it lands on the lean view and collapses there. Repeated
				// Esc therefore walks C, B, A, lean and then stops — at the lean view richOpen is false,
				// so this branch no longer fires and Esc does nothing. The scroll position of the word
				// you first drilled from is restored on that final step by popstate (restoreDictOffset).
				// (Previously Esc flattened the whole drill in one shot via collapseToLean; the headword
				// toggle still does that in-place collapse.) It yields to anything that already owns Esc:
				// an open menu/dialog closes first, and a second Esc then steps back. This lives in THE
				// document-keydown handler on purpose — the line above unbinds all others, so a
				// separately-registered handler would be wiped.
				history.back();
				e.preventDefault();
				e.stopPropagation();
			} else if ((e.which === PL.keys.UP || e.which === PL.keys.DOWN) && defBox.is(':visible')
					&& !rx.test(e.target.tagName) && !$(".menuClass:visible, .dlgClass:visible").length) {
				// Up/Down should scroll the dictionary/practice panel (#defBoxScrollId), same as when
				// you opened a rich card by clicking a term. The browser's native arrow-scroll target
				// isn't driven by document.activeElement here — it's whichever element last received
				// an actual mouse click — so relying on the native default action scrolls the whole
				// page instead as soon as focus/click history isn't pinned inside the panel (e.g. after
				// an Enter-driven lookup, or after clicking anywhere outside the panel in either tab).
				// Scroll dictContainer() ourselves so this doesn't depend on click history. Gated on
				// defBox being visible so this doesn't fire during an active Exercise (defExerciseBox
				// shown instead) or while the target is a real input/select/textarea or a menu/dialog
				// is open (those own Up/Down for their own item navigation).
				progScroll(dictContainer(), e.which === PL.keys.DOWN ? 60 : -60);
				e.preventDefault();
			}
		});
	})();

	function debug(jqueryElem) {
		var msg;
		if ($.type(jqueryElem) === "string") {
			msg = jqueryElem;
		} else if (jqueryElem && jqueryElem.length > 0) {
			var elem = jqueryElem[0];
			msg = elem.nodeName
			+ ": id=" + elem.getAttribute("id") + " (class=" + elem.getAttribute("class") + ")";
		}
		showMessage(msg);
	}

	$(window).focus(function (e) {
		windowActive = true;
	});
	$(window).blur(function (e) {
		windowActive = false;
	});

	$(window).on('popstate', function(e) {
		resetWordPopup();
		// Any pending Undo peel is moot once we navigate; tear it down fully (clears the
		// button lock) so we don't strand peelActive=true and dead-lock generation.
		if (dismissPeel) { dismissPeel(); } else { $("#undoPeelId").remove(); }
		var state = e.originalEvent.state || {};

		// Backing out of a dictionary excursion raised over a finish screen: the card is still on
		// the page under the dictionary box, so the way back is to uncover it — never to replay
		// whatever entry we landed on, which would render into a box that is about to be hidden.
		// This is Esc's path too (it calls history.back), and it fires from however deep the
		// reader drilled, because the summary card is the one place the excursion returns to.
		if (finishExcursion) { exitFinishExcursion(); return; }

		// Each entry knows its tab. If Back/Forward crossed a tab boundary, re-apply that tab's chrome
		// FIRST (no history push — this is a restore), then restore the entry's own content. This is
		// what makes replay faithful: a dictionary word backed into while sitting in Practice comes
		// back under the Dictionary tab, not stranded under Practice.
		var targetTab = state.tab || 'dict';
		var crossed = targetTab !== activeTab;

		if (state.learnReveal != null) {
			// A Learn meet-card reveal drill step (Esc / browser Back). 'base' restores the light
			// reveal; any other value re-renders that word's card. Acts only while a drill is live —
			// stale forward replays (after advancing past a drilled card) are ignored so the session
			// view stays put. targetTab is 'learn' and we're already on it, so no chrome re-apply.
			if (state.learnReveal === 'base') {
				if (learnDrillActive) { learnDrillCollapseToBase(); }
			} else if (learnDrillActive) {
				learnDrillRender(state.learnReveal);
			}
		} else if (state.term != null) {
			// A visited word — restore its tab, then re-open it rich (no new history entry). A word
			// drilled from the Learn tray comes back under the Learn tab (its tray re-renders), just
			// as a Practice-drilled word returns to Practice.
			if (crossed) {
				if (targetTab === 'practice') { randomWordsView(); }
				else if (targetTab === 'learn') { applyLearnChrome(); }
				else { applyDictChrome(); }
			}
			richLookupNoHistory(state.term);
		} else if (state.setId != null) {
			// A practice word-set entry (random or word-list) — restore Practice + that exact set
			// (evicted → re-fetch by the entry's termIds, or a fresh random set; see restoreWordSet).
			if (crossed || activeTab !== 'practice') { randomWordsView(); }
			currentWord = null;
			richOpen = false;
			collapseRich();
			restoreWordSet(state.setId, state);
		} else if (targetTab === 'learn') {
			// A Learn lean entry — re-apply the Learn chrome; the tray (client state) re-renders.
			currentWord = null;
			richOpen = false;
			collapseRich();
			applyLearnChrome();
		} else if (targetTab === 'practice') {
			// A Practice lean entry that never got a set stamped in (rare) — the empty tray.
			if (crossed) { randomWordsView(); }
			currentWord = null;
			richOpen = false;
			collapseRich();
			showPracticeEmpty();
		} else {
			// A Dictionary lean entry — back out of any open word to plain lean browsing.
			var backWord = currentWord;
			currentWord = null;
			richOpen = false;
			if (crossed) {
				// Came from Practice: rebuild the Dictionary look + its lean list.
				applyDictChrome();
				collapseRich();
				showDictLean();
			} else if (expandedSlot) {
				collapseRich();
				restoreDictOffset(backWord);   // return the collapsed word to where it was before opening
			} else if (displayManager) {
				displayManager.displayAll();
			}
			// Plain lean browsing is back, and so is the band's half of the answer — repainted from
			// the cache the open card suppressed (all three branches above either leave #defId's
			// rows alone or re-render them, and both cases need the band re-appended).
			phraseBandRender();
		}
	});

	// Mark the initial entry as the dictionary lean view so the first Back from a drilled word lands
	// here. We no longer put the word in the URL, so strip any '#word' a legacy bookmark may still
	// carry, keeping the bar clean.
	(function() {
		var url = window.location.pathname + window.location.search;
		history.replaceState({ view: 'lean', tab: 'dict' }, '', url);
	})();

	// Restore the last-selected tab (its own user attr). The dict landing above already ran (so its
	// content is set up + the base history entry is dict); if the saved tab is Learn/Practice, switch
	// to it now — synchronous, so no flash. Then arm persistence for real user tab switches.
	(function restoreSelectedTab() {
		var saved = $("#selectedTabId").val();
		if (saved === 'learn') { learnTabView(); }
		else if (saved === 'practice') { practiceTabView(); }
		tabPersistReady = true;
	})();

	// Now that we've LANDED on the saved tab, rehydrate both persisted trays. Order matters: landing
	// first means the async prime renders onto the correct tab (and the dict-lean seek's own stale-load
	// guard has already conceded the box if we jumped to Learn/Practice), so refilling never re-triggers
	// the phantom dict-lean render. This also arms tray persistence for real user actions.
	rehydrateTrays();

	// Per-word action popup: dwell ~700ms over a term-language word to reveal sound / add-to-list.
	//
	// Delegated on DOCUMENT, not on a container. A rich card is rendered into five different hosts —
	// the dictionary panel (#defId), the exercise reveal (#defExerciseId), the Learn reveal and its
	// drill levels (#learnId), the expanded lean-row slot, and the standalone rich popup that the
	// finish screen and the garden vista raise over the page. Every other affordance on the card
	// (drill-in clicks, phrase gutter buttons, topic tips, the combo warm-up) is wired per render on
	// whatever host it was given, so it already worked in all five; only these two hover popups were
	// bound to #defId and so existed in the dictionary alone — a conjugation table opened from a
	// Learn card had inert cells (owner report 2026-08-07). Document-level delegation is the shape
	// that matches "a rich card behaves the same wherever it is opened", and it costs nothing to
	// keep in step with a new host later. Safe to widen: .rich-conj-cell is minted ONLY by
	// renderConjugationTable, and .term-word only by code that MEANS a live word token —
	// renderRichEntry via tokenizeTermWords, and (since the v2 follow-up) the collocation band's
	// rows via phraseBandPhraseHtml, which mints the class precisely so a band word behaves like a
	// card word. Anything else minting .term-word is opting into this popup by doing so.
	$(document).on("mouseenter", ".term-word", function () {
		// No popup on the headword itself — the whole rich entry IS its translation, with its own
		// large sound / add-to-list buttons.
		if ($(this).closest(".rich-term").length) {
			return;
		}
		var wordEl = this;
		wordPopupNextEl = wordEl;
		wordPopupNextShow = function () { showWordPopup(wordEl); };
		wordPopupMachine.enter();
	});
	$(document).on("mouseleave", ".term-word", function (e) {
		wordPopupMachine.cancelOpen();
		// Keep the popup (and the word's highlight) when the pointer hops into the popup itself.
		// Hide is DIRECT (not machine.leave): the machine's isOpen is per-anchor, so a leave
		// fired after the pointer already staged a different word would no-op and strand the
		// old popup — the legacy synchronous hide is the correct semantic here.
		if (!popupContains(e.relatedTarget)) {
			hideWordPopup();
		}
	});

	// Conjugation combo hover: co-highlight the form cell AND its row's pronoun label (CSS handles
	// the cell's own underline on :hover), then after a dwell reveal the same popup acting on the
	// whole combination "du gingst". Empty cells (data-combo absent) are inert.
	$(document).on("mouseenter", ".rich-conj-cell", function () {
		if (!this.getAttribute("data-combo")) {
			return;
		}
		var cellEl = this;
		$(cellEl).closest("tr").children(".rich-conj-pron").addClass("rich-conj-hl");
		wordPopupNextEl = cellEl;
		wordPopupNextShow = function () { showComboPopup(cellEl); };
		wordPopupMachine.enter();
	});
	$(document).on("mouseleave", ".rich-conj-cell", function (e) {
		wordPopupMachine.cancelOpen();
		// Hopping into the popup → keep the cell + pronoun lit and leave the popup open.
		if (popupContains(e.relatedTarget)) {
			return;
		}
		$(this).closest("tr").children(".rich-conj-pron").removeClass("rich-conj-hl");
		hideWordPopup();//direct, like .term-word above — machine.leave would no-op cross-anchor
	});

	// Seam T-12 (docs/project/tablet-support-plan.md §4): the touch layer's way into the two popups
	// above. A finger has no hover, so js/touch/press.js opens them on a long-press (a word) or a tap
	// (a conjugation cell) — at once, the hold having been the dwell. Same guards as the hover
	// handlers: no popup on a headword, none on an empty cell. Nothing on a desktop calls this.
	PL.termPopup = {
		open: function (el) {
			var isCell = el.classList.contains("rich-conj-cell");
			if (isCell ? !el.getAttribute("data-combo") : $(el).closest(".rich-term").length) {
				return false;
			}
			wordPopupMachine.cancel();
			if (currentWordEl && currentWordEl !== el) {
				hideWordPopup();   // the previous anchor's highlight goes with it
			}
			if (isCell) {
				$(el).closest("tr").children(".rich-conj-pron").addClass("rich-conj-hl");
			}
			wordPopupNextEl = el;
			wordPopupNextShow = null;
			if (isCell) { showComboPopup(el); } else { showWordPopup(el); }
			return true;
		},
		hide: function () {
			wordPopupMachine.cancel();
			hideWordPopup();
		},
		anchor: function () { return currentWordEl; },
		box: function () { return currentWordEl && wordPopupEl ? wordPopupEl[0] : null; }
	};

	// Space pronounces the word on screen (the media-player convention). A visible rich card
	// (dictionary or exercise reveal) wins; otherwise a focused lean row — rows focus themselves on
	// hover — speaks its own word (same wiring as its gutter buttons). (A Ctrl+Shift+Space chord
	// used to double for Space inside a text field; dropped 2026-07-27 — one key per action, the
	// sound button is a click away while typing.)
	//
	// Ctrl+Shift+A used to sit beside it as "add this word", and it is GONE (owner call
	// 2026-08-16). It worked by pressing the add button, and pressing the add button no longer
	// files anything — it opens the list picker, because an add now always names its destination
	// (docs/project/wl-add-target-redesign.md). A shortcut that pops a menu the reader then has to
	// aim with the mouse is not a shortcut, and the alternative — one hidden standing list for the
	// keyboard alone — is precisely the invisible destination the redesign removed.
	//
	// Bare Space is ALSO the browser's page-down key, but on the word screens — the rich card and
	// the lean list — sound OWNS the key: the media-player convention beats the page scroll, so
	// both branches preventDefault whenever a word is on screen (no focused row needed — the first
	// row in view speaks). Elsewhere we claim it narrowly: only when nothing else has a claim on
	// the key (see spaceIsIdle) — otherwise we return without preventDefault and the page scrolls
	// as it always did. preventDefault() on keydown is what suppresses that scroll, and every
	// current browser honours it there (Chrome, Edge, Firefox, Safari).
	function spaceIsIdle(e) {
		var t = e.target || {};
		var tag = (t.tagName || "").toLowerCase();
		if (t.isContentEditable) { return false; }                                    // typing
		if (tag === "input" || tag === "textarea" || tag === "select") { return false; }   // typing / picking
		if (tag === "button" || tag === "summary") { return false; }                  // Space clicks it
		if (t.getAttribute && t.getAttribute("role") === "button") { return false; }  // the undo peels
		return !$(".menuClass:visible, .dlgClass:visible").length;                    // a menu/dialog owns its keys
	}

	$(document).on("keydown", function (e) {
		// Alt+1/Alt+2 flip the dictionary direction toggle (left/DE, right/EN) without touching the
		// mouse — scoped to the Dictionary tab (lookupBox is hidden on Learn/Practice).
		var altDir = e.altKey && !e.ctrlKey && !e.shiftKey && !e.metaKey
			&& (e.key === "1" || e.key === "2") && lookupBox.is(":visible");
		if (altDir) {
			e.preventDefault();
			setDictDirection(e.key === "1" ? 'FORWARD' : 'REVERSE');
			return;
		}
		var space = e.keyCode === 32 || e.key === " ";
		var bare = space && !e.ctrlKey && !e.shiftKey && !e.altKey && !e.metaKey && spaceIsIdle(e);
		if (!bare) {
			return;
		}
		// Holding Space must not machine-gun the audio — swallow the repeats, keep the scroll off.
		if (e.originalEvent && e.originalEvent.repeat) { e.preventDefault(); return; }
		// The finish screen: the word under the pointer is what Space pronounces. That screen puts
		// no speaker on its words on purpose (owner call 2026-08-20) — they are prose, wrapping
		// across a column, and a 🔊 beside each of twenty-one of them would bury the words it was
		// meant to serve. The hover already means something here (it rings the word's flower in the
		// bed), so the key simply acts on whatever the hover has already picked out.
		//
		// Ahead of the rich-card branch because the two cannot both be the screen in front of the
		// reader: a dictionary excursion from the card hides the card, and finishScreenUp() is the
		// test for that — a stale exHoverTermId from a word the excursion covered can never fire.
		if (exHoverTermId != null && finishScreenUp()) {
			playAiSound(exHoverTermId);
			e.preventDefault();
			return;
		}
		if ($(".rich-card:visible").length) {
			if (richCardTermId) { playAiSound(richCardTermId); }
			// A rich card is a word screen — bare Space never scrolls it, even with no termId.
			e.preventDefault();
			return;
		}
		var row = $(document.activeElement).closest("._entryClass");
		if (!row.length) {
			// No row hovered/focused: Space in the lean list still means sound, not page-down —
			// act on the first row in view (and focus it, so the highlight shows which one spoke).
			row = $("._entryClass:visible").filter(function () {
				var r = this.getBoundingClientRect();
				return r.bottom > 0 && r.top < window.innerHeight && r.height > 0;
			}).first();
			if (row.length) { row.focus(); }
		}
		if (row.length) {
			var btn = row.find("._soundClass > button").first();
			if (btn.length) { btn.click(); e.preventDefault(); }
		}
	});
});
